webpackJsonp([1],{

/***/ "+48i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TopBar__ = __webpack_require__("5PWk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Header__ = __webpack_require__("teIl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FooterMenu__ = __webpack_require__("gTlp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ShopNav__ = __webpack_require__("hV6H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FooterCopyright__ = __webpack_require__("3LwO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_api_api_js__ = __webpack_require__("fXcb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_js_alertConfirm_js__ = __webpack_require__("bCJ+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__static_js_emallUtils_js__ = __webpack_require__("spYF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mint_ui_lib_style_css__ = __webpack_require__("d8/S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mint_ui_lib_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_mint_ui_lib_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__static_js_map_js__ = __webpack_require__("oICd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_router__ = __webpack_require__("/ocq");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














//没用
//	import MessageBox from 'mint-ui'


__WEBPACK_IMPORTED_MODULE_13_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_13_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_mint_ui___default.a);
//没用
//	Vue.use(MessageBox)
//	Vue.component(MessageBox.name,MessageBox);

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'shopcart',
	data: function data() {
		return {
			boList: [],
			shopBoList: [],
			count: 0,
			shoppingCartNum: 0,
			firstIn: true,
			goodsNum: 0,
			saveMoney: ''
		};
	},

	components: {
		'topbar': __WEBPACK_IMPORTED_MODULE_1__components_TopBar__["a" /* default */],
		'shopnav': __WEBPACK_IMPORTED_MODULE_4__components_ShopNav__["a" /* default */],
		'emallheader': __WEBPACK_IMPORTED_MODULE_2__components_Header__["a" /* default */],
		'footermenu': __WEBPACK_IMPORTED_MODULE_3__components_FooterMenu__["a" /* default */],
		'footercopyright': __WEBPACK_IMPORTED_MODULE_5__components_FooterCopyright__["a" /* default */]
	},
	methods: {
		checkAll: function checkAll() {
			if (__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#allCheck").prop("checked") == true) {
				__WEBPACK_IMPORTED_MODULE_8_jquery___default()("input[name='goodsCheckBox']").each(function () {
					if (this.disabled == false) this.checked = true;
				});
			} else {
				__WEBPACK_IMPORTED_MODULE_8_jquery___default()("input[name='goodsCheckBox']").each(function () {
					if (this.disabled == false) this.checked = false;
				});
			}
			this.goodsNum = __WEBPACK_IMPORTED_MODULE_8_jquery___default()("input[name='goodsCheckBox']").length;
			this.sumPrice();
		},
		toDetail: function toDetail(goodsCode) {
			//this.$router.push({ path: '/goodsDetails', query:{goodsCode:goodsCode}});
			var routeData = this.$router.resolve({ path: '/goodsDetails', query: { goodsCode: goodsCode } });
			window.open(routeData.href, '_blank');
		},
		addPayNum: function addPayNum(id, goodsCode) {
			var that = this;
			var num = __WEBPACK_IMPORTED_MODULE_8_jquery___default()("#" + id + "_goods_number").val();
			num = parseInt(num) + 1;
			var price = parseFloat(__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#" + id + "_price").text().replace("￥", ""));
			__WEBPACK_IMPORTED_MODULE_6__static_api_api_js__["a" /* default */].updateGoodsCount(goodsCode, num, id, function (ret) {
				if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__static_js_emallUtils_js__["n" /* parseResult */])(ret, null, false)) {
					__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#" + id + "_goods_number").val(num);
					if (__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#" + id + "_price").text().indexOf("积分") != -1) {
						var unitPrice = num * price;
						__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#" + id + "_unitPrice").text(unitPrice + "积分");
					} else {
						var unitPrice = (num * price).toFixed(2);
						__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#" + id + "_unitPrice").text("￥" + unitPrice);
					}

					that.$refs.eh.getShoppingCartList();
					that.$refs.eh.getShoppingCartNum();
					that.getShoppingCartNum();
					that.sumPrice();
					for (var i = 0; i < that.boList.length; i++) {
						if (id == that.boList[i].id) {
							that.boList[i].goodsNumber = num;
						}
					}
				}
			});
		},
		subPayNum: function subPayNum(id, goodsCode) {
			var that = this;
			var num = __WEBPACK_IMPORTED_MODULE_8_jquery___default()("#" + id + "_goods_number").val();
			if (num > 1) {
				num = parseInt(num) - 1;
			}
			var price = parseFloat(__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#" + id + "_price").text().replace("￥", ""));
			__WEBPACK_IMPORTED_MODULE_6__static_api_api_js__["a" /* default */].updateGoodsCount(goodsCode, num, id, function (ret) {
				if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__static_js_emallUtils_js__["n" /* parseResult */])(ret, null, false)) {
					__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#" + id + "_goods_number").val(num);
					if (__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#" + id + "_price").text().indexOf("积分") != -1) {
						var unitPrice = num * price;
						__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#" + id + "_unitPrice").text(unitPrice + "积分");
					} else {
						var unitPrice = (num * price).toFixed(2);
						__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#" + id + "_unitPrice").text("￥" + unitPrice);
					}
					that.$refs.eh.getShoppingCartList();
					that.$refs.eh.getShoppingCartNum();
					that.getShoppingCartNum();
					that.sumPrice();
					for (var i = 0; i < that.boList.length; i++) {
						if (id == that.boList[i].id) {
							that.boList[i].goodsNumber = num;
						}
					}
				}
			});
		},
		chooseGoods: function chooseGoods(e) {
			if (e.target.checked) {
				this.goodsNum++;
			} else {
				__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#allCheck").prop("checked", false);
				this.goodsNum--;
			}
			if (this.goodsNum == 0) {
				__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#allCheck").prop("checked", false);
			}
			if (this.goodsNum == __WEBPACK_IMPORTED_MODULE_8_jquery___default()("input[name='goodsCheckBox']").length) {
				__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#allCheck").prop("checked", true);
			}
			this.sumPrice();
		},
		sumPrice: function sumPrice() {
			var that = this;
			var checkedGoods = "";
			var sumNum = 0;
			var specName = '';
			var goodsNumber = "";
			__WEBPACK_IMPORTED_MODULE_8_jquery___default()("input[name='goodsCheckBox']:checked").each(function () {
				checkedGoods += __WEBPACK_IMPORTED_MODULE_8_jquery___default()(this).attr("goodsCode") + ",";
				specName += __WEBPACK_IMPORTED_MODULE_8_jquery___default()(this).attr("specname") + ",";
				var num = __WEBPACK_IMPORTED_MODULE_8_jquery___default()("#" + __WEBPACK_IMPORTED_MODULE_8_jquery___default()(this).attr("goodsId") + "_goods_number").val();
				sumNum = sumNum + parseInt(num);
				goodsNumber += __WEBPACK_IMPORTED_MODULE_8_jquery___default()("#" + __WEBPACK_IMPORTED_MODULE_8_jquery___default()(this).attr("goodsId") + "_goods_number").val() + ",";
			});
			if (checkedGoods != "") {
				var priceText = "";
				__WEBPACK_IMPORTED_MODULE_6__static_api_api_js__["a" /* default */].sumGoodsPrice(checkedGoods, null, encodeURI(specName), goodsNumber, "", function (ret) {
					if (ret.data != null) {
						var goodsTotalPrice = ret.data;
						var saveMoney = goodsTotalPrice.saveMoney;
						if (saveMoney != undefined) {
							saveMoney = (saveMoney / 100).toFixed(2);
						}
						if (goodsTotalPrice.totalMoney > 0) {
							priceText += "￥" + (goodsTotalPrice.totalMoney / 100).toFixed(2);
						} else {
							priceText = "￥0";
							saveMoney = '0';
						}
						that.saveMoney = saveMoney;
						var num = 0;
						var goodsCodeList = new Array();
						goodsCodeList = checkedGoods.split(",");
						for (var i = 0; i < goodsCodeList.length; i++) {
							that.shopBoList.forEach(function (shopBoList) {
								shopBoList.boListIn.forEach(function (bo) {
									if (bo.goodsCode == goodsCodeList[i]) {
										num += bo.goodsNumber;
									}
								});
							});
						}
						__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#sumPay").html(priceText);
						__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#selectedCount").html(sumNum);
					}
				});
			} else {
				__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#sumPay").html("￥ 0.00");
				__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#selectedCount").html("0");
				that.saveMoney = '0.00';
			}
		},
		setNumVue: function setNumVue() {
			var goodNum = 0;
			this.shopBoList.forEach(function (e) {
				e.boListIn.forEach(function (good) {
					goodNum += good.goodsNumber;
				});
			});
			__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#selectedCount").html(goodNum);
		},
		getShoppingCartNum: function getShoppingCartNum() {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_6__static_api_api_js__["a" /* default */].getShoppingCartNum(function (ret) {
				if (ret.code != null && ret.code == "9999") {
					//						alertConfirm.singleConfirm("请先登陆！");
					window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/login.htm';
					return false;
				}
				that.shoppingCartNum = ret.data.shoppingCartNum;
			});
		},
		getCartList: function getCartList() {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_6__static_api_api_js__["a" /* default */].getShoppingCartList(function (ret) {
				if (ret.code == "success") {
					that.boList = ret.data.boList;
					//根据店铺进行分类，店铺名称=店铺
					var shopBoMap = {};
					var totalCount = 0;
					var goodList = new Array();
					goodList = ret.data.boList;
					var money = 0;
					if (goodList != null && goodList.length > 0) {
						for (var i = 0; i < goodList.length; i++) {
							var goodsPrice = goodList[i].goodsPrice;
							var unitPrice = goodList[i].unitPrice;
							var attrValue = JSON.parse(goodList[i].attrValue);
							var unitPriceAry = attrValue.unitPriceAry;
							var goodsSkuStrAry = attrValue.goodsSkuStrAry;
							var imgLargeAry = attrValue.imgLargeAry;
							var specName = goodList[i].specName;
							if (unitPriceAry != 'undefined' && unitPriceAry != null && unitPriceAry.length > 0 && specName != null && specName != '' && goodsSkuStrAry != 'undefined' && goodsSkuStrAry != null && goodsSkuStrAry.length > 0 && goodsSkuStrAry.indexOf(",") > -1) {
								var unitPriceArr = eval("(" + unitPriceAry + ")");
								var goodsSkuStrArr = eval("(" + goodsSkuStrAry + ")");
								var imgLargeArr = eval("(" + imgLargeAry + ")");
								for (var o = 0; o < goodsSkuStrArr.length; o++) {
									if (goodsSkuStrArr[o] == specName) {
										unitPrice = unitPriceArr[o];
										if (imgLargeArr[o] != null && imgLargeArr[o] != '') {
											goodList[i].imgSmall = imgLargeArr[o];
										}
									}
								}
							}

							//						 		goodList[i].unitPrice = (unitPrice/ 100).toFixed(2);
							if (goodList[i].seckillPrice > 0) {
								goodList[i].unitPrice = (goodList[i].seckillPrice / 100).toFixed(2);
							} else {
								goodList[i].unitPrice = (goodList[i].unitPrice / 100).toFixed(2);
							}
							var imgSmall = goodList[i].imgSmall;
							if (imgSmall.indexOf(";") != -1) {
								imgSmall = imgSmall.split(";")[0];
							}
							goodList[i].imgSmall = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + imgSmall;
							if (goodList[i].goodsPrice > 0) {
								goodList[i].ext1 = goodList[i].goodsPrice * goodList[i].goodsNumber + "积分";
							} else {
								goodList[i].ext1 = "￥" + (goodList[i].unitPrice * goodList[i].goodsNumber).toFixed(2);
							}
							//按照店铺分类
							var shopBo = shopBoMap[goodList[i].shopName];
							if (shopBo == undefined) {
								var arrayTemp = new Array();
								arrayTemp.push(goodList[i]);
								shopBo = {
									shopName: goodList[i].shopName,
									boListIn: arrayTemp
								};
								shopBoMap[goodList[i].shopName] = shopBo;
							} else {
								shopBo.boListIn.push(goodList[i]);
							}
						}
					}
					for (var j in shopBoMap) {
						that.shopBoList.push(shopBoMap[j]);
					}
				}
			});

			console.log(this.shopBoList);
		},
		deleteGoods: function deleteGoods(id, goodsCode, index) {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_7__static_js_alertConfirm_js__["a" /* default */].alertConfirm("是否确定删除？", function () {
				__WEBPACK_IMPORTED_MODULE_6__static_api_api_js__["a" /* default */].deleteGoods(id, goodsCode, function (ret) {
					if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__static_js_emallUtils_js__["n" /* parseResult */])(ret, null, false)) {
						//      				that.boList.splice(index,1)
						that.$refs.eh.getShoppingCartNum();
						that.$refs.eh.getShoppingCartList();
						var shopBo = that.shopBoList[index];
						var boListIn = shopBo.boListIn;
						for (var i = 0; i < boListIn.length; i++) {
							if (boListIn[i].id == id) {
								boListIn.splice(i, 1);
							}
						}
						if (boListIn.length == 0) {
							//如果为1删除该店铺分类
							that.shopBoList.splice(index, 1);
						}

						setTimeout(function () {
							that.sumPrice();
						}, 50);
						if (that.shopBoList.length <= 0) {
							__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#selectedCount").html("0");
							__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#allCheck").prop("checked", false);
						}
					} else {
						__WEBPACK_IMPORTED_MODULE_7__static_js_alertConfirm_js__["a" /* default */].singleConfirm("删除商品失败");
					}
				});
			});
		},
		deleteCart: function deleteCart() {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_7__static_js_alertConfirm_js__["a" /* default */].alertConfirm('是否确定清空购物车？', function () {
				that.shopBoList.forEach(function (shop) {
					shop.boListIn.forEach(function (good, index) {
						__WEBPACK_IMPORTED_MODULE_6__static_api_api_js__["a" /* default */].deleteGoods(good.id, good.goodsCode, function (ret) {
							if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__static_js_emallUtils_js__["n" /* parseResult */])(ret, null, false)) {
								that.$refs.eh.getShoppingCartNum();
								that.$refs.eh.getShoppingCartList();
							} else {
								__WEBPACK_IMPORTED_MODULE_7__static_js_alertConfirm_js__["a" /* default */].singleConfirm("清空购物车失败");
							}
						});
					});
				});
				__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#sumPay").html("￥ 0.00");
				__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#selectedCount").html("0");
				that.shopBoList = [];
			});
		},
		doSettle: function doSettle() {
			var that = this;
			//var checkedGoods = "";
			var checkedGoods = new Array();
			var goodsCodes = "";
			var specNames = "";
			var checkedName = new Array();
			var idArray = new Array();
			var selectedBos = new Array();
			var boList = new Array();
			var bos = that.boList;
			__WEBPACK_IMPORTED_MODULE_8_jquery___default()("input[name='goodsCheckBox']:checked").each(function () {
				goodsCodes += __WEBPACK_IMPORTED_MODULE_8_jquery___default()(this).attr("goodsCode") + ",";
				specNames += __WEBPACK_IMPORTED_MODULE_8_jquery___default()(this).attr("specName") + ",";
				checkedGoods.push(__WEBPACK_IMPORTED_MODULE_8_jquery___default()(this).attr("goodsCode"));
				checkedName.push(__WEBPACK_IMPORTED_MODULE_8_jquery___default()(this).attr("goodsName"));
				idArray.push(__WEBPACK_IMPORTED_MODULE_8_jquery___default()(this).attr("goodsId"));
			});
			if (checkedGoods != "" && checkedGoods != undefined) {
				for (var i = 0; i < bos.length; i++) {
					for (var k = 0; k < checkedGoods.length; k++) {
						if (checkedGoods[k] == bos[i].goodsCode && idArray[k] == bos[i].id) {
							selectedBos.push(bos[i]);
						}
					}
				}
				var tmpBos = JSON.parse(localStorage.getItem('bos'));
				if (tmpBos != undefined && tmpBos.length > 0) {
					localStorage.removeItem('bos');
				}
				localStorage.setItem('bos', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(selectedBos));
				this.$router.push({ name: 'ordercommit', query: { goodsCodes: goodsCodes,
						specNames: specNames, bos: selectedBos, orderSource: 'cart' } });
			} else {
				__WEBPACK_IMPORTED_MODULE_7__static_js_alertConfirm_js__["a" /* default */].singleConfirm("请勾选商品结算");
			}
		},
		setCheckAll: function setCheckAll() {
			if (this.firstIn) {
				__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#allCheck").prop("checked", true);
				this.checkAll();
				this.firstIn = false;
			}
		},
		editPayNum: function editPayNum(id, goodsCode, num) {
			var that = this;
			num = parseInt(num);
			var price = parseFloat(__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#" + id + "_price").text().replace("￥", ""));
			__WEBPACK_IMPORTED_MODULE_6__static_api_api_js__["a" /* default */].updateGoodsCount(goodsCode, num, id, function (ret) {
				if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__static_js_emallUtils_js__["n" /* parseResult */])(ret, null, false)) {
					__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#" + id + "_goods_number").val(num);
					if (__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#" + id + "_price").text().indexOf("积分") != -1) {
						var unitPrice = num * price;
						__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#" + id + "_unitPrice").text(unitPrice + "积分");
					} else {
						var unitPrice = (num * price).toFixed(2);
						__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#" + id + "_unitPrice").text("￥" + unitPrice);
					}
					that.$refs.eh.getShoppingCartList();
					that.$refs.eh.getShoppingCartNum();
					that.getShoppingCartNum();
					that.sumPrice();
					for (var i = 0; i < that.boList.length; i++) {
						if (id == that.boList[i].id) {
							that.boList[i].goodsNumber = num;
						}
					}
				}
			});
		},
		setPayNum: function setPayNum(id, goodsCode, goodsStock) {
			var num = __WEBPACK_IMPORTED_MODULE_8_jquery___default()("#" + id + "_goods_number").val(),
			    maxNum = goodsStock;
			/*				if(num > maxNum){
   					alertConfirm.singleConfirm("订单数量大于商品库存！")
   					this.editPayNum(id,goodsCode,maxNum);
   				}else*/
			if (num <= 0 || num === '' || num == undefined || num == null) {
				this.editPayNum(id, goodsCode, 1);
			} else {
				this.editPayNum(id, goodsCode, num);
			}
		},
		initMap: function initMap() {
			var that = this;
			var script = document.getElementById("mapScriptId");
			if (script == null) {
				that.$nextTick(function () {
					__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__static_js_map_js__["a" /* MP */])(__WEBPACK_IMPORTED_MODULE_9__static_js_emallUtils_js__["u" /* ak */]).then(function (BMap) {});
				});
			}
		}
		//      	orderCommit:function(){
		//      		var that = this;
		//      		this.$router.push({ name: 'ordercommit', params:{bos:that.boList}});
		//      	},
	},
	beforeMount: function beforeMount() {
		this.getShoppingCartNum();
		this.getCartList();
		this.initMap();
	},
	mounted: function mounted() {
		window.scrollTo(0, 0);
		//			alertConfirm.init();
		//			this.getShoppingCartNum();
		//			this.getCartList();
	},
	updated: function updated() {
		this.setCheckAll();
	}
});

/***/ }),

/***/ "+LED":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "indexbg"
  }, [_c('topbar'), _vm._v(" "), _c('sortHeader'), _vm._v(" "), _c('div', {
    staticClass: "clear mt15"
  }), _vm._v(" "), _c('div', {
    staticClass: "w1200 bc"
  }, [_c('div', {
    staticClass: "hq-shopping-cart"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tipsbox success",
    staticStyle: {
      "padding": "0",
      "height": "500px"
    }
  }, [_c('div', {
    staticClass: "order clearfix order-init order-init-oldUser-noQrcode"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "o-right",
    staticStyle: {
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "o-price"
  }, [_c('em', [_vm._v("应付金额")]), _c('strong', [_vm._v(_vm._s((_vm.total_fee / 100).toFixed(2)))]), _c('em', [_vm._v("元")])])]), _vm._v(" "), _c('div', {
    staticClass: "o-right",
    staticStyle: {
      "width": "286px",
      "float": "left",
      "padding": "32px 10px 0px 10px"
    }
  }, [_c('a', {
    staticStyle: {
      "font-size": "14px",
      "color": "#df3134"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('wait_send_goods')
      }
    }
  }, [_vm._v("查看订单 >")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "font-size": "14px",
      "margin-left": "10px",
      "color": "#df3134"
    },
    attrs: {
      "href": _vm.indexUrl
    }
  }, [_vm._v("返回首页 >")])])]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('footermenu'), _vm._v(" "), _c('footercopyright')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hq-reg-step"
  }, [_c('ul', {
    staticClass: "ico"
  }, [_c('li', [_c('p', {
    staticClass: "item"
  }, [_vm._v("购物车")]), _vm._v(" "), _c('i', {
    staticClass: "step-count"
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "line"
  })]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "item"
  }, [_vm._v("提交订单")]), _vm._v(" "), _c('i', {
    staticClass: "step-count"
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "line"
  })]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "item"
  }, [_vm._v("确认付款")]), _vm._v(" "), _c('i', {
    staticClass: "step-count"
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "line"
  })]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('p', {
    staticClass: "item"
  }, [_vm._v("下单成功")]), _vm._v(" "), _c('i', {
    staticClass: "step-count"
  })])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-left"
  }, [_c('h3', {
    staticClass: "o-title"
  }, [_vm._v("订单提交成功，请尽快付款！")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "payment"
  }, [_c('div', {
    staticClass: "pay-weixin"
  }, [_c('div', {
    staticClass: "p-w-bd",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "p-w-box"
  }, [_c('div', {
    staticClass: "pw-box-hd"
  }, [_c('canvas', {
    attrs: {
      "id": "canvas"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pw-retry j_weixiRetry",
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    staticClass: "ui-button ui-button-gray j_weixiRetryButton",
    attrs: {
      "href": "javascript:getWeixinImage2();"
    }
  }, [_vm._v("获取失败 点击重新获取二维码  ")])]), _vm._v(" "), _c('div', {
    staticClass: "pw-box-ft"
  }, [_c('p', [_vm._v("请使用微信扫一扫")]), _vm._v(" "), _c('p', [_vm._v("扫描二维码支付")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-w-sidebar"
  })])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb20 ad-4 mt20"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("dlf8"),
      "width": "1200",
      "height": "60"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+Z1y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TopBar__ = __webpack_require__("5PWk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_api_api_js__ = __webpack_require__("fXcb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__ = __webpack_require__("spYF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_js_db_main_js__ = __webpack_require__("gkCg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_js_db_main_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__static_js_db_main_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Header__ = __webpack_require__("teIl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_FooterMenu__ = __webpack_require__("gTlp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_FooterCopyright__ = __webpack_require__("3LwO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_HearderNav__ = __webpack_require__("7JIe");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//import {jQuery} from "../../../static/js/jquery.min.js"









/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'goodsList',
	components: {
		'topbar': __WEBPACK_IMPORTED_MODULE_2__components_TopBar__["a" /* default */],
		'sortHeader': __WEBPACK_IMPORTED_MODULE_6__components_Header__["a" /* default */],
		'footermenu': __WEBPACK_IMPORTED_MODULE_7__components_FooterMenu__["a" /* default */],
		'footercopyright': __WEBPACK_IMPORTED_MODULE_8__components_FooterCopyright__["a" /* default */],
		'heardernav': __WEBPACK_IMPORTED_MODULE_9__components_HearderNav__["a" /* default */]
	},
	data: function data() {
		var _ref;

		return _ref = {
			isRefresh: true,
			goodsList: [],
			recommendGoodsList: [],
			sortCondition: 'defaultSort',
			sortSaleAmount: '',
			sortPublishTime: '',
			sortPrice: '',
			choosedCondItem: [],
			catCode: 'categoryAll',
			interval: 'intervalAll',
			sortTime: 'timeAll',
			currentPage: 1,
			totalPage: 1,
			orderBy: '',
			orderAsc: '',
			shopCode: '',
			pageList: [1],
			totalItem: 0,
			sortParam: '',
			shoppingCartNum: 0,
			boList: [],
			count: 0,
			goodsImgs: [],
			sumMoney: 0,
			goodsName: '',
			firstCatCode: ''
		}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'shopCode', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'mobile', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'isLogin', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'isShow', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'account', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'userCenterUrl', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'loginUrl', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'registerUrl', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'logoutUrl', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'aboutUsUrl', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'indexUrl', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'orderUrl', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'catNameCn', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'brandId', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'brandName', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'allCount', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'payCount', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'putCount', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'receiveCount', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'sendCount', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'closeCount', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'computeFlag', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'contactUrl', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'showItem', 7), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'isInit', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'lower', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'upper', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'productType', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'orderType', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'activeLi', 'mallIndex'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'twoCategoryList', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'brandList', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'firstCatList', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'catMap', []), _ref;
	},

	watch: {
		sortParam: function sortParam(newValue, oldValue) {
			//      		alert(this.sortParam);
			//				alert(newValue+" to "+oldValue);
			this.$refs.sortHeader.changeParam(newValue); //往子组件传值
			if (oldValue != undefined) {
				this.getRecommendGoods();
				this.getGoods();
			}
		}

	},
	methods: {
		orderShow: function orderShow() {
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".orders-list").show();
		},
		orderHide: function orderHide() {
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".orders-list").hide();
		},
		shopCarShow: function shopCarShow() {
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".goods-list").show();
		},
		shopCarHide: function shopCarHide() {
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".goods-list").hide();
		},
		getOrderCount: function getOrderCount(shopCode) {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_3__static_api_api_js__["a" /* default */].getOrderCount(function (ret) {
				if (ret.code == "success") {
					that.allCount = ret.data.allCount;
					that.payCount = ret.data.payCount;
					that.putCount = ret.data.putCount;
					that.receiveCount = ret.data.receiveCount;
					that.sendCount = ret.data.sendCount;
					that.closeCount = ret.data.closeCount;
				}
			});
		},
		logout: function logout() {
			localStorage.clear();
			__WEBPACK_IMPORTED_MODULE_3__static_api_api_js__["a" /* default */].loginOut(function (ret) {});
			window.location.href = this.logoutUrl;
		},
		clearCookie: function clearCookie() {
			var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
			if (keys) {
				for (var i = keys.length; i--;) {
					document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString();
				}
			}
		},
		goOrder: function goOrder(tradeStatus) {
			var account = localStorage.getItem("account");
			if (account != undefined && account != "") {
				window.location.href = this.orderUrl + "?tradeStatus=" + tradeStatus;
			} else {
				window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/login.htm';
			}
		},
		mobileAppShow: function mobileAppShow() {
			this.isShow = true;
		},
		mobileAppHidden: function mobileAppHidden() {
			this.isShow = false;
		},
		jumpTo: function jumpTo(name) {
			this.$router.push({ name: name });
		},
		toGoodsDetail: function toGoodsDetail(goodsCode, productType) {
			//this.$router.push({ name: 'goodsdetail', query:{goodsCode:goodsCode}});
			/*if(productType!=undefined&&productType=='sample'){//样品
   	let routeData = this.$router.resolve({ path: '/sampleDetail', query: {goodsCode: goodsCode } });
   	window.open(routeData.href, '_blank');
   }else{*/
			var routeData = this.$router.resolve({ path: '/goodsDetails', query: { goodsCode: goodsCode, orderType: this.orderType, productType: this.productType } });
			window.open(routeData.href, '_blank');
			/*}*/
		},
		prePage: function prePage() {
			if (this.currentPage > 1) {
				this.currentPage = this.currentPage - 1;
				this.adjustPageArray(this.currentPage);
				this.getGoods();
			}
		},
		nextPage: function nextPage() {
			if (this.currentPage < this.totalPage) {
				this.currentPage = this.currentPage + 1;
				this.adjustPageArray(this.currentPage);
				this.getGoods();
			}
		},
		queryByPage: function queryByPage(page) {
			this.currentPage = page;
			this.adjustPageArray(this.currentPage);
			this.getGoods();
		},
		adjustPageArray: function adjustPageArray(page) {
			if (page == this.pageList[6] && page + 2 <= this.totalPage) {
				this.pageList.push(page + 1);
				this.pageList.push(page + 2);
				this.pageList.shift();
				this.pageList.shift();
			} else if (page == this.pageList[6] && page + 1 == this.totalPage) {
				this.pageList.push(page + 1);
				this.pageList.shift();
			} else if (page == this.pageList[0] && page >= 3) {
				this.pageList.unshift(page - 1);
				this.pageList.unshift(page - 2);
				this.pageList.pop();
				this.pageList.pop();
			} else if (page == this.pageList[0] && page == 2) {
				this.pageList.unshift(page - 1);
				this.pageList.pop();
			}
		},
		initPageArray: function initPageArray() {
			var pageList = new Array();
			var totalPage = this.totalPage;
			for (var i = 1; i <= totalPage; i++) {
				if (i <= this.showItem) {
					pageList.push(i);
				}
			}
			this.pageList = pageList;
		},
		clearUserDefined: function clearUserDefined() {
			this.lower = '';
			this.upper = '';
		},
		userDefinedCondition: function userDefinedCondition() {
			this.lower = this.lower.trim();
			this.upper = this.upper.trim();
			var sortParams = '';
			if (this.lower != '' && this.upper != '') {
				sortParams = this.lower + ',' + this.upper;
			} else if (this.lower == '' && this.upper != '') {
				sortParams = '0,' + this.upper;
			} else if (this.lower != '' && this.upper == '') {
				sortParams = this.lower + ',';
			}
			this.chooseCondition('', 'amount', sortParams);
		},
		//选择一级类目时
		chooseFirstCat: function chooseFirstCat(firstCatCode) {
			this.firstCatCode = firstCatCode;
			if (this.catMap != undefined && this.catMap[firstCatCode] != undefined && this.catMap[firstCatCode] != null) {
				this.twoCategoryList = JSON.parse(this.catMap[firstCatCode]);
			}
		},
		chooseCondition: function chooseCondition(event, type, sortParams) {
			if (event != '') {
				var condText = event.target.innerText;
				if (condText != "不限") {
					var condText = event.target.innerText;
					if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#choosedCond").find("span[condType='" + type + "']").length != 0) {
						__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#choosedCond").find("span[condType='" + type + "']").remove();
					}
					this.choosedCondItem.push({ condName: condText, condType: type });
				} else {
					__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#choosedCond").find("span[condType='" + type + "']").remove();
				}

				if (type == 'amount') {
					this.clearUserDefined();
				}
			} else {
				if (type == 'amount') {
					if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#choosedCond").find("span[condType='" + type + "']").length != 0) {
						__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#choosedCond").find("span[condType='" + type + "']").remove();
					}
				}
			}

			if (type == 'amount') {
				this.interval = sortParams;
			} else if (type == 'cat') {
				this.catCode = sortParams;
			} else if (type == 'time') {
				this.sortTime = sortParams;
			} else if (type == 'catNameCn') {
				this.catCode = sortParams;
			} else if (type == 'brand') {
				this.brandId = sortParams;
			} else if (type == 'firstCat') {
				//选择了一级类目
				if (this.firstCatCode != sortParams) {
					this.firstCatCode = sortParams;
					this.catCode = "categoryAll"; //换一级类目后二级类目初始化为全部
					if (this.catMap[sortParams] != undefined && this.catMap[sortParams] != null) {
						this.twoCategoryList = JSON.parse(this.catMap[sortParams]);
					} else {
						this.twoCategoryList = [];
					}

					if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#choosedCond").find("span[condType='catNameCn']").length != 0) {
						__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#choosedCond").find("span[condType='catNameCn']").remove();
					}
				}
			}
			this.currentPage = 1; //页码初始化为1
			this.getRecommendGoods();
			this.getGoods();
		},
		removeCondition: function removeCondition(index, type) {
			if (type == 'amount') {
				this.interval = "intervalAll";
			} else if (type == 'cat') {
				this.catCode = "categoryAll";
			} else if (type == 'time') {
				this.sortTime = "timeAll";
			} else if (type == 'catNameCn') {
				this.catCode = "categoryAll";
			} else if (type == 'brand') {
				this.brandId = 0;
			} else if (type == 'firstCat') {
				this.firstCatCode = '';
			}
			//		  			this.choosedCondItem.splice(index,1);
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#choosedCond").find("span[condType='" + type + "']").remove();
			this.getRecommendGoods();
			this.getGoods();
		},
		findGoods: function findGoods() {
			this.resetCond();
			this.getRecommendGoods();
			this.getGoods();
		},
		findShops: function findShops() {
			this.$router.push({ name: 'shopsList', query: { sortParam: this.sortParam } });
		},
		sortGoods: function sortGoods(sortCondition) {
			this.currentPage = 1;
			this.sortCondition = sortCondition;
			if (sortCondition == "saleAmount") {
				this.orderBy = "sale_number";
				if (this.sortSaleAmount == '') {
					this.sortSaleAmount = "desc";
				} else if (this.sortSaleAmount == 'desc') {
					this.sortSaleAmount = "asc";
				} else if (this.sortSaleAmount == 'asc') {
					this.sortSaleAmount = "desc";
				}
				this.orderAsc = this.sortSaleAmount;
			}
			if (sortCondition == "publishTime") {
				this.orderBy = "gmt_create";
				if (this.sortPublishTime == '') {
					this.sortPublishTime = "desc";
				} else if (this.sortPublishTime == 'desc') {
					this.sortPublishTime = "asc";
				} else if (this.sortPublishTime == 'asc') {
					this.sortPublishTime = "desc";
				}
				this.orderAsc = this.sortPublishTime;
			}
			if (sortCondition == "price") {
				this.orderBy = "unit_price";
				if (this.sortPrice == '') {
					this.sortPrice = "desc";
				} else if (this.sortPrice == 'desc') {
					this.sortPrice = "asc";
				} else if (this.sortPrice == 'asc') {
					this.sortPrice = "desc";
				}
				this.orderAsc = this.sortPrice;
			}
			if (sortCondition == "defaultSort") {
				this.orderBy = "";
				this.orderAsc = "";
			}
			this.getGoods();
			this.getRecommendGoods();
		},
		getRecommendGoods: function getRecommendGoods() {
			var that = this;
			var interval = that.interval;
			var catCode = that.catCode;
			var cabinetId = "";
			var pageSize = 5;
			var isQueryAll = "n";
			var currentPage = 1;
			var orderBy = "sale_number";
			var orderAsc = "desc";
			var shopCode = that.shopCode;
			var sortTime = "";
			var goodsName = encodeURI(that.sortParam);
			var firstCatCode = that.firstCatCode;
			var brandId = that.brandId;
			var productType = that.productType;
			var orderType = that.orderType;

			__WEBPACK_IMPORTED_MODULE_3__static_api_api_js__["a" /* default */].getGoodsList(cabinetId, catCode, interval, currentPage, orderBy, orderAsc, shopCode, sortTime, pageSize, isQueryAll, goodsName, firstCatCode, brandId, productType, orderType, function (ret) {
				if (ret.code == "success") {
					var goods = ret.data.goods;
					if (goods != undefined) {
						for (var i = 0; i < goods.length; i++) {
							//商品图片
							var imgMiddle = goods[i].imgMiddle;
							if (imgMiddle.indexOf(";") != -1) {
								imgMiddle = imgMiddle.split(";")[0];
							}
							imgMiddle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + imgMiddle;
							goods[i].imgMiddle = imgMiddle;
						}
					}
					that.recommendGoodsList = goods;
				}
			});
		},
		getGoods: function getGoods() {
			var that = this;
			var interval = that.interval;
			var catCode = that.catCode;
			var isQueryAll = "n";
			var shopCode = that.shopCode;
			var cabinetId = "";
			var pageSize = 9;
			var currentPage = that.currentPage;
			var orderBy = that.orderBy;
			var orderAsc = that.orderAsc;
			var sortTime = that.sortTime;
			var goodsName = encodeURI(that.sortParam);
			var firstCatCode = that.firstCatCode;
			var brandId = that.brandId;
			var productType = that.productType;
			var orderType = that.orderType;
			__WEBPACK_IMPORTED_MODULE_3__static_api_api_js__["a" /* default */].getGoodsList(cabinetId, catCode, interval, currentPage, orderBy, orderAsc, shopCode, sortTime, pageSize, isQueryAll, goodsName, firstCatCode, brandId, productType, orderType, function (ret) {
				if (ret.code == "success") {
					var goods = ret.data.goods;
					that.totalItem = ret.data.totalItem;
					var totalPage = ret.data.totalPage;
					if (totalPage != undefined && totalPage != 0 && totalPage != that.totalPage) {
						that.totalPage = ret.data.totalPage;
						that.initPageArray();
					} else if (totalPage != undefined && totalPage == 0) {
						that.totalPage = 1;
						that.initPageArray();
					}
					if (goods != undefined) {
						for (var i = 0; i < goods.length; i++) {
							//商品图片
							var imgMiddle = goods[i].imgMiddle;
							if (imgMiddle.indexOf(";") != -1) {
								imgMiddle = imgMiddle.split(";")[0];
							}
							imgMiddle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + imgMiddle;
							goods[i].imgMiddle = imgMiddle;

							if (firstCatCode == 'spike') {

								var marketPrice = JSON.parse(goods[i].attrValue).marketPrice;
								var saleTimeStr = JSON.parse(goods[i].attrValue).saleTimeShow;
								var saleEndTimeStr = JSON.parse(goods[i].attrValue).saleEndTimeShow;
								if (marketPrice != undefined && marketPrice != "") {
									goods[i].marketPrice = marketPrice;
								} else {
									goods[i].marketPrice = goods[i].unitPrice;
								}
								if (saleEndTimeStr != undefined && saleEndTimeStr != '') {
									saleEndTimeStr = saleEndTimeStr.replace(/-/g, "/");
									var saleEndDate = new Date(saleEndTimeStr);

									saleTimeStr = saleTimeStr.replace(/-/g, "/");
									var saleDate = new Date(saleTimeStr);

									//如果当期日期大于销售结束日期 xxx
									if (new Date() > saleEndDate) {
										goods[i].saleStatus = "end";
									} else if (new Date() < saleDate) {
										//如果当期时间小于上架时间，展示距离开始 时间
										goods[i].saleStatus = "wait_start";
										var begSeconds = saleDate.getTime() - new Date().getTime(); //时间差的毫秒数        
										//计算出相差天数  
										//  								var days=Math.floor(begSeconds/(24*3600*1000));  
										//计算出小时数  
										var leave1 = begSeconds % (24 * 3600 * 1000); //计算天数后剩余的毫秒数  
										var hours = Math.floor(begSeconds / (3600 * 1000));
										//计算相差分钟数  
										var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数  
										var minutes = Math.floor(leave2 / (60 * 1000));
										//计算相差秒数  
										var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数  
										var seconds = Math.round(leave3 / 1000);
										// 									goods[i].day=days;
										goods[i].hour = hours;
										goods[i].minute = minutes;
										goods[i].second = seconds;
									} else {
										goods[i].saleStatus = "on_sale";

										var begSeconds = saleEndDate.getTime() - new Date().getTime(); //时间差的毫秒数        
										//计算出相差天数  
										//  								var days=Math.floor(begSeconds/(24*3600*1000));  
										//计算出小时数  
										var leave1 = begSeconds % (24 * 3600 * 1000); //计算天数后剩余的毫秒数  
										var hours = Math.floor(begSeconds / (3600 * 1000));
										//计算相差分钟数  
										var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数  
										var minutes = Math.floor(leave2 / (60 * 1000));
										//计算相差秒数  
										var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数  
										var seconds = Math.round(leave3 / 1000);
										// 									goods[i].day=days;
										goods[i].hour = hours;
										goods[i].minute = minutes;
										goods[i].second = seconds;
									}
								}
							}
						}
					}
					that.goodsList = goods;
					if (!that.isInit) {
						that.isInit = true;
						that.initPageArray();
					}
				}
			});
		},
		getShoppingCartNum: function getShoppingCartNum(shopCode) {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_3__static_api_api_js__["a" /* default */].getShoppingCartNum(function (ret) {
				if (ret.code == "success") {
					that.shoppingCartNum = ret.data.shoppingCartNum;
				}
			});
		},
		getShoppingCartList: function getShoppingCartList() {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_3__static_api_api_js__["a" /* default */].getShoppingCartList(function (ret) {
				if (ret.code == "success") {
					that.boList = ret.data.boList;
					var totalCount = 0;
					var bos = new Array();
					bos = ret.data.boList;
					var money = 0;
					for (var i = 0; i < bos.length; i++) {
						var imgSmall = bos[i].imgSmall;
						if (imgSmall.indexOf(";") != -1) {
							imgSmall = imgSmall.split(";")[0];
						}
						bos[i].imgSmall = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + imgSmall;
						money = money + bos[i].goodsPrice * bos[i].goodsNumber;
						totalCount = totalCount + bos[i].goodsNumber;
					}
					that.sumMoney = money;
					that.count = totalCount;
				}
			});
		},
		deleteGoods: function deleteGoods(goodsCode) {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_3__static_api_api_js__["a" /* default */].deleteGoods(goodsCode, function (ret) {
				if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["n" /* parseResult */])(ret, null, false)) {
					__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#" + goodsCode + "_cart_pro").remove();
				}
			});
		},
		goIndex: function goIndex() {
			this.$router.push({ name: 'index' });
		},
		getMoreCatGoods: function getMoreCatGoods(catCode, catNameCn) {
			this.catNameCn = catNameCn;
			this.resetCond();
			this.sortParam = "";
			this.firstCatCode = catCode;
			this.sortParam = "";
			this.getRecommendGoods();
			this.getGoods();
		},
		getCatGoods: function getCatGoods(catCode, catNameCn) {
			this.catNameCn = catNameCn;
			this.resetCond();
			this.sortParam = "";
			this.catCode = catCode;
			this.firstCatCode = "";
			this.sortParam = "";
			this.getRecommendGoods();
			this.getGoods();
		},
		resetCond: function resetCond() {
			this.interval = "intervalAll";
			this.catCode = "categoryAll";
			this.sortTime = "timeAll";
			this.firstCatCode = "";
			this.orderBy = "";
			this.orderAsc = "";
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#choosedCond").html("");
		},
		computeTime: function computeTime() {
			var that = this;
			var goodsList = that.goodsList;
			for (var j = 0; j < goodsList.length; j++) {
				var saleTimeStr = JSON.parse(goodsList[j].attrValue).saleTimeShow;
				var saleEndTimeStr = JSON.parse(goodsList[j].attrValue).saleEndTimeShow;

				if (saleEndTimeStr != undefined && saleEndTimeStr != '') {
					saleEndTimeStr = saleEndTimeStr.replace(/-/g, "/");
					var saleEndDate = new Date(saleEndTimeStr);

					saleTimeStr = saleTimeStr.replace(/-/g, "/");
					var saleDate = new Date(saleTimeStr);

					//如果当期日期大于销售结束日期 xxx
					if (new Date() > saleEndDate) {
						goodsList[j].saleStatus = "end";
					} else if (new Date() < saleDate) {
						//如果当期时间小于上架时间，展示距离开始 时间
						goodsList[j].saleStatus = "wait_start";
						var begSeconds = saleDate.getTime() - new Date().getTime(); //时间差的毫秒数        
						//计算出相差天数  
						//  								var days=Math.floor(begSeconds/(24*3600*1000));  
						//计算出小时数  
						var leave1 = begSeconds % (24 * 3600 * 1000); //计算天数后剩余的毫秒数  
						var hours = Math.floor(begSeconds / (3600 * 1000));
						//计算相差分钟数  
						var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数  
						var minutes = Math.floor(leave2 / (60 * 1000));
						//计算相差秒数  
						var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数  
						var seconds = Math.round(leave3 / 1000);
						goodsList[j].hour = hours;
						goodsList[j].minute = minutes;
						goodsList[j].second = seconds;
					} else {
						goodsList[j].saleStatus = "on_sale";

						var begSeconds = saleEndDate.getTime() - new Date().getTime(); //时间差的毫秒数        
						//计算出相差天数  
						//  								var days=Math.floor(begSeconds/(24*3600*1000));  
						//计算出小时数  
						var leave1 = begSeconds % (24 * 3600 * 1000); //计算天数后剩余的毫秒数  
						var hours = Math.floor(begSeconds / (3600 * 1000));
						//计算相差分钟数  
						var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数  
						var minutes = Math.floor(leave2 / (60 * 1000));
						//计算相差秒数  
						var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数  
						var seconds = Math.round(leave3 / 1000);
						goodsList[j].hour = hours;
						goodsList[j].minute = minutes;
						goodsList[j].second = seconds;
					}
				}
			}
			that.goodsList = goodsList;
			if (!that.isInit) {
				that.isInit = true;
				that.initPageArray();
			}
		},
		getCategoryListByCode: function getCategoryListByCode(parentCode) {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_3__static_api_api_js__["a" /* default */].getCategoryListByCode(parentCode, function (ret) {
				if (ret.data.catList != null || ret.data.catList != "") {
					that.twoCategoryList = ret.data.catList;
				}
			});
		},
		getAllCategoryMap: function getAllCategoryMap() {
			var that = this;
			var productType = '';
			if (that.productType != undefined) {
				if (that.productType == 'sample') {
					productType = 'product'; //样品和现货公用一套类目，按product来查询
				} else {
					productType = that.productType;
				}
			}
			__WEBPACK_IMPORTED_MODULE_3__static_api_api_js__["a" /* default */].getAllCategoryMap(productType, function (ret) {
				if (ret.data.firstCatList != null || ret.data.firstCatList != "") {
					that.firstCatList = ret.data.firstCatList;
				}
				if (ret.data.catMap != null || ret.data.catMap != "") {
					that.catMap = ret.data.catMap;
				}
			});
		},
		getBrandList: function getBrandList() {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_3__static_api_api_js__["a" /* default */].getBrandList(function (ret) {
				if (ret.data.brandBoList != null || ret.data.brandBoList != "") {
					that.brandList = ret.data.brandBoList;
				}
			});
		},
		showMoreCategory: function showMoreCategory() {
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.td_div').toggleClass('td_h');
		},
		showMoreBrand: function showMoreBrand() {
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.td_brand_div').toggleClass('td_brand_h');
		}
	},
	ready: function ready() {},
	beforeDestroy: function beforeDestroy() {
		var that = this;
		if (that.firstCatCode == 'spike') {
			window.clearInterval(this.computeFlag);
		}
	},
	mounted: function mounted() {
		window.scrollTo(0, 0);
		//			this.$refs.navComp.getCat();//不用获取首页的类目
		var account = localStorage.getItem("account");
		if (account != undefined && account != "") {
			this.isLogin = true;
			this.account = account;
		}
		this.userCenterUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/index/default.htm';
		this.loginUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/login.htm';
		//			this.registerUrl = getUcUrl() + '/custm/user/user_reg_add.htm';
		this.registerUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/custm/user/user_reg_add.htm?formCode=MCHT_USER_FORM';
		this.logoutUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/logout.htm';
		this.aboutUsUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["l" /* getAboutUsUrl */])();
		this.indexUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["o" /* getIndexUrl */])();
		this.orderUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["b" /* getEmallUrl */])() + '/orderManage/myOrderList.htm';
		var sortParam = this.$route.query.sortParam;
		var firstCatCode = this.$route.query.firstCatCode;
		var shopCode = this.$route.query.shopCode;
		var catCode = this.$route.query.catCode;
		var catNameCn = this.$route.query.catNameCn;
		var brandId = this.$route.query.brandId;
		var brandName = this.$route.query.brandName;
		//产品类型
		if (this.$route.query.productType != undefined && this.$route.query.productType != "") {
			this.productType = this.$route.query.productType;
		}
		if (this.$route.params.productType != undefined && this.$route.params.productType != "") {
			this.productType = this.$route.params.productType;
		}
		if (this.productType == 'sample' || this.productType == 'meterial') {
			this.activeLi = this.$route.query.productType;
		}
		//下单类型
		if (this.$route.query.orderType != undefined && this.$route.query.orderType != "") {
			this.orderType = this.$route.query.orderType;
		}
		if (this.$route.params.orderType != undefined && this.$route.params.orderType != "") {
			this.orderType = this.$route.params.orderType;
		}
		if (sortParam != undefined) {
			this.sortParam = sortParam;
		}
		if (firstCatCode != undefined) {
			this.firstCatCode = firstCatCode;
		}
		if (shopCode != undefined) {
			this.shopCode = shopCode;
		}
		var that = this;
		if (firstCatCode != undefined && firstCatCode == 'spike') {
			this.computeFlag = window.setInterval(function () {
				that.computeTime(); //计算倒计时
			}, 1000);
		}
		if (catCode != undefined) {
			this.catCode = catCode;
			this.getCatGoods(this.catCode);
		} else {
			this.getRecommendGoods();
			this.getGoods();
		}
		if (catNameCn != undefined) {
			this.catNameCn = decodeURI(catNameCn);;
		}
		if (brandId != undefined) {
			this.brandId = brandId;;
		}
		if (brandName != undefined) {
			this.brandName = brandName;;
		}
		//this.getRecommendGoods();
		//this.getGoods();
		this.getShoppingCartNum();
		this.getShoppingCartList();
		this.getOrderCount();
		this.contactUrl = __WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["p" /* sysContactUrl */];
		if (firstCatCode != undefined && firstCatCode != "") {
			this.getCategoryListByCode(firstCatCode);
		} else {
			this.getAllCategoryMap();
		}
		//获取品牌信息
		this.getBrandList();
	}
});

/***/ }),

/***/ "/37r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/4jM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/C53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "topbar"
  }, [_c('div', {
    staticClass: "w1200 bc"
  }, [_c('ul', {
    staticClass: "topbar-right fr"
  }, [(_vm.isLogin == false) ? _c('li', [_c('a', {
    staticClass: "co2",
    attrs: {
      "href": _vm.loginUrl
    }
  }, [_vm._v("[登录]")])]) : _vm._e(), _vm._v(" "), (_vm.isLogin == false) ? _c('li', [_c('a', {
    staticClass: "co2",
    attrs: {
      "href": _vm.registerUrl
    }
  }, [_vm._v("[注册]")])]) : _vm._e(), _vm._v(" "), (_vm.isLogin == true) ? _c('li', [_c('span', [_vm._v("您好")])]) : _vm._e(), _vm._v(" "), (_vm.isLogin == true) ? _c('li', [_c('a', {
    staticClass: "co2",
    attrs: {
      "href": _vm.userCenterUrl
    }
  }, [_vm._v(_vm._s(_vm.account))])]) : _vm._e(), _vm._v(" "), (_vm.isLogin == true) ? _c('li', [_c('a', {
    staticClass: "co2",
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("[退出]")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.aboutUsUrl
    }
  }, [_vm._v("关于我们")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.contactUrl,
      "target": "_blank"
    }
  }, [_vm._v("联系客服")])])]), _vm._v(" "), _c('ul', {
    staticClass: "topbar-left fl"
  }, [_c('li', [_vm._v("\n\t\t\t\t\t\t\t您好！欢迎来到相伴宝！\n\t\t\t\t\t\t")]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "co1",
    attrs: {
      "href": _vm.indexUrl
    }
  }, [_vm._v("返回相伴宝")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('sortHeader'), _vm._v(" "), _c('heardernav', {
    ref: "navComp"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear mt15"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "clear mt15"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "shopWarp"
  }, [_c('div', {
    staticClass: "shopBox"
  }, [_c('ul', _vm._l((_vm.goodsList), function(goodsBo) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(goodsBo.goodsCode)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": goodsBo.imgMiddle,
        "alt": "暂无图片"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "shopBox-right"
    }, [_c('p', {
      staticClass: "rightTitle"
    }, [_vm._v(_vm._s(goodsBo.goodsName))]), _vm._v(" "), _c('p', {
      staticClass: "rightdetail"
    }), _vm._v(" "), _c('div', {
      staticClass: "priceleft ov_hid"
    }, [_c('a', {
      staticClass: "priceright right",
      attrs: {
        "href": "#"
      }
    }, [_vm._v("\n\t\t                                \t马上兑\n\t\t                            ")]), _vm._v(" "), (goodsBo.unitPrice > 0) ? _c('span', {
      staticClass: "currentPrice"
    }, [_vm._v("￥" + _vm._s((goodsBo.unitPrice / 100).toFixed(2)))]) : _vm._e()]), _vm._v(" "), (goodsBo.goodsPrice > 0) ? _c('div', {
      staticClass: "duihuan"
    }, [_vm._v("兑换积分："), _c('span', [_vm._v(_vm._s((goodsBo.goodsPrice)))])]) : _vm._e(), _vm._v(" "), (goodsBo.discountMoney > 0) ? _c('div', {
      staticClass: "duihuan"
    }, [_vm._v("可抵扣："), _c('span', [_vm._v("￥" + _vm._s((goodsBo.discountMoney / 100).toFixed(2)))])]) : _vm._e()])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "dp-pages tc"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.prePage()
      }
    }
  }, [_vm._v(" < ")]), _vm._v(" "), _vm._l((_vm.pageList), function(page) {
    return _c('a', {
      class: {
        "current_page": _vm.currentPage === page
      },
      on: {
        "click": function($event) {
          _vm.queryByPage(page)
        }
      }
    }, [_vm._v(_vm._s(page))])
  }), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.nextPage()
      }
    }
  }, [_vm._v(" > ")])], 2)]), _vm._v(" "), _c('footermenu'), _vm._v(" "), _c('footercopyright')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top"
  }, [_c('ul', [_c('p', {
    staticClass: "n1"
  }, [_vm._v("1.积分获取方式："), _c('br'), _vm._v("\n\t\t\t        ▲在云商城消费奖励积分商品"), _c('br'), _vm._v("\n\t\t\t        ▲在商城积分活动中获得积分")]), _vm._v(" "), _c('p', {
    staticClass: "n2"
  }, [_vm._v("2.积分使用方法："), _c('br'), _vm._v("\n\t\t\t        ▲积分可以代替现金购买商城内的积分商品"), _c('br'), _vm._v("\n\t\t\t        ▲积分可以换取云商城专属的礼品")]), _vm._v(" "), _c('p', {
    staticClass: "n3"
  }, [_vm._v("云商城 秋冬货品持续更新中...")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/ZyE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_api_api_js__ = __webpack_require__("fXcb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__ = __webpack_require__("spYF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_js_db_main_js__ = __webpack_require__("gkCg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_js_db_main_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__static_js_db_main_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Header__ = __webpack_require__("teIl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_FooterMenu__ = __webpack_require__("gTlp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_FooterCopyright__ = __webpack_require__("3LwO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_HearderNav__ = __webpack_require__("7JIe");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//import {jQuery} from "../../../static/js/jquery.min.js"








/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'goodsClassList',
	components: {
		'sortHeader': __WEBPACK_IMPORTED_MODULE_5__components_Header__["a" /* default */],
		'footermenu': __WEBPACK_IMPORTED_MODULE_6__components_FooterMenu__["a" /* default */],
		'footercopyright': __WEBPACK_IMPORTED_MODULE_7__components_FooterCopyright__["a" /* default */],
		'heardernav': __WEBPACK_IMPORTED_MODULE_8__components_HearderNav__["a" /* default */]
	},
	data: function data() {
		var _ref;

		return _ref = {
			isRefresh: true,
			goodsList: [],

			sortCondition: 'defaultSort',
			sortSaleAmount: '',
			sortPublishTime: '',
			sortPrice: '',
			choosedCondItem: [],
			catCode: 'categoryAll',
			interval: 'intervalAll',
			sortTime: 'timeAll',
			currentPage: 1,
			totalPage: 1,
			orderBy: '',
			orderAsc: '',
			shopCode: '',
			pageList: [1],
			totalItem: 0,
			sortParam: '',
			shoppingCartNum: 0,
			boList: [],
			count: 0,
			goodsImgs: [],
			sumMoney: 0,
			goodsName: '',
			firstCatCode: ''
		}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "shopCode", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "mobile", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "isLogin", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "isShow", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "account", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "userCenterUrl", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "loginUrl", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "registerUrl", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "logoutUrl", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "aboutUsUrl", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "indexUrl", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "orderUrl", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "catNameCn", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "brandId", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "brandName", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "allCount", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "payCount", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "putCount", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "receiveCount", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "sendCount", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "closeCount", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "computeFlag", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "contactUrl", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "showItem", 7), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "isInit", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "lower", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "upper", ''), _ref;
	},

	methods: {
		orderShow: function orderShow() {
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".orders-list").show();
		},
		orderHide: function orderHide() {
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".orders-list").hide();
		},
		shopCarShow: function shopCarShow() {
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".goods-list").show();
		},
		shopCarHide: function shopCarHide() {
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".goods-list").hide();
		},
		getOrderCount: function getOrderCount(shopCode) {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_2__static_api_api_js__["a" /* default */].getOrderCount(function (ret) {
				if (ret.code == "success") {
					that.allCount = ret.data.allCount;
					that.payCount = ret.data.payCount;
					that.putCount = ret.data.putCount;
					that.receiveCount = ret.data.receiveCount;
					that.sendCount = ret.data.sendCount;
					that.closeCount = ret.data.closeCount;
				}
			});
		},
		logout: function logout() {
			localStorage.clear();
			__WEBPACK_IMPORTED_MODULE_2__static_api_api_js__["a" /* default */].loginOut(function (ret) {});
			window.location.href = this.logoutUrl;
		},
		clearCookie: function clearCookie() {
			var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
			if (keys) {
				for (var i = keys.length; i--;) {
					document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString();
				}
			}
		},
		goOrder: function goOrder(tradeStatus) {
			var account = localStorage.getItem("account");
			if (account != undefined && account != "") {
				window.location.href = this.orderUrl + "?tradeStatus=" + tradeStatus;
			} else {
				window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/login.htm';
			}
		},
		mobileAppShow: function mobileAppShow() {
			this.isShow = true;
		},
		mobileAppHidden: function mobileAppHidden() {
			this.isShow = false;
		},
		jumpTo: function jumpTo(name) {
			this.$router.push({ name: name });
		},
		toGoodsDetail: function toGoodsDetail(goodsCode) {
			//this.$router.push({ name: 'goodsdetail', query:{goodsCode:goodsCode}});
			var routeData = this.$router.resolve({ path: '/goodsDetails', query: { goodsCode: goodsCode } });
			window.open(routeData.href, '_blank');
		},
		prePage: function prePage() {
			if (this.currentPage > 1) {
				this.currentPage = this.currentPage - 1;
				this.adjustPageArray(this.currentPage);
				this.getGoods();
			}
		},
		nextPage: function nextPage() {
			if (this.currentPage < this.totalPage) {
				this.currentPage = this.currentPage + 1;
				this.adjustPageArray(this.currentPage);
				this.getGoods();
			}
		},
		queryByPage: function queryByPage(page) {
			this.currentPage = page;
			this.adjustPageArray(this.currentPage);
			this.getGoods();
		},
		adjustPageArray: function adjustPageArray(page) {
			if (page == this.pageList[6] && page + 2 <= this.totalPage) {
				this.pageList.push(page + 1);
				this.pageList.push(page + 2);
				this.pageList.shift();
				this.pageList.shift();
			} else if (page == this.pageList[6] && page + 1 == this.totalPage) {
				this.pageList.push(page + 1);
				this.pageList.shift();
			} else if (page == this.pageList[0] && page >= 3) {
				this.pageList.unshift(page - 1);
				this.pageList.unshift(page - 2);
				this.pageList.pop();
				this.pageList.pop();
			} else if (page == this.pageList[0] && page == 2) {
				this.pageList.unshift(page - 1);
				this.pageList.pop();
			}
		},
		initPageArray: function initPageArray() {
			var pageList = new Array();
			var totalPage = this.totalPage;
			for (var i = 1; i <= totalPage; i++) {
				if (i <= this.showItem) {
					pageList.push(i);
				}
			}
			this.pageList = pageList;
		},
		clearUserDefined: function clearUserDefined() {
			this.lower = '';
			this.upper = '';
		},
		userDefinedCondition: function userDefinedCondition() {
			this.lower = this.lower.trim();
			this.upper = this.upper.trim();
			var sortParams = '';
			if (this.lower != '' && this.upper != '') {
				sortParams = this.lower + ',' + this.upper;
			} else if (this.lower == '' && this.upper != '') {
				sortParams = '0,' + this.upper;
			} else if (this.lower != '' && this.upper == '') {
				sortParams = this.lower + ',';
			}
			this.chooseCondition('', 'amount', sortParams);
		},
		chooseCondition: function chooseCondition(event, type, sortParams) {
			if (event != '') {
				var condText = event.target.innerText;
				if (condText != "不限") {
					var condText = event.target.innerText;
					if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#choosedCond").find("span[condType='" + type + "']").length != 0) {
						__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#choosedCond").find("span[condType='" + type + "']").remove();
					}
					this.choosedCondItem.push({ condName: condText, condType: type });
				} else {
					__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#choosedCond").find("span[condType='" + type + "']").remove();
				}

				if (type == 'amount') {
					this.clearUserDefined();
				}
			} else {
				if (type == 'amount') {
					if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#choosedCond").find("span[condType='" + type + "']").length != 0) {
						__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#choosedCond").find("span[condType='" + type + "']").remove();
					}
				}
			}

			if (type == 'amount') {
				this.interval = sortParams;
			} else if (type == 'cat') {
				this.catCode = sortParams;
			} else if (type == 'time') {
				this.sortTime = sortParams;
			}
			this.getGoods();
		},
		removeCondition: function removeCondition(index, type) {
			if (type == 'amount') {
				this.interval = "intervalAll";
			} else if (type == 'cat') {
				this.catCode = "categoryAll";
			} else if (type == 'time') {
				this.sortTime = "timeAll";
			}
			this.choosedCondItem.splice(index, 1);
			this.getGoods();
		},
		findGoods: function findGoods() {
			this.resetCond();
			this.getGoods();
		},
		findShops: function findShops() {
			this.$router.push({ name: 'shopsList', query: { sortParam: this.sortParam } });
		},
		sortGoods: function sortGoods(sortCondition) {
			this.currentPage = 1;
			this.sortCondition = sortCondition;
			if (sortCondition == "saleAmount") {
				this.orderBy = "sale_number";
				if (this.sortSaleAmount == '') {
					this.sortSaleAmount = "desc";
				} else if (this.sortSaleAmount == 'desc') {
					this.sortSaleAmount = "asc";
				} else if (this.sortSaleAmount == 'asc') {
					this.sortSaleAmount = "desc";
				}
				this.orderAsc = this.sortSaleAmount;
			}
			if (sortCondition == "publishTime") {
				this.orderBy = "gmt_create";
				if (this.sortPublishTime == '') {
					this.sortPublishTime = "desc";
				} else if (this.sortPublishTime == 'desc') {
					this.sortPublishTime = "asc";
				} else if (this.sortPublishTime == 'asc') {
					this.sortPublishTime = "desc";
				}
				this.orderAsc = this.sortPublishTime;
			}
			if (sortCondition == "price") {
				this.orderBy = "unit_price";
				if (this.sortPrice == '') {
					this.sortPrice = "desc";
				} else if (this.sortPrice == 'desc') {
					this.sortPrice = "asc";
				} else if (this.sortPrice == 'asc') {
					this.sortPrice = "desc";
				}
				this.orderAsc = this.sortPrice;
			}
			if (sortCondition == "defaultSort") {
				this.orderBy = "";
				this.orderAsc = "";
			}
			this.getGoods();
		},
		getGoods: function getGoods() {
			var that = this;
			var interval = that.interval;
			var catCode = that.catCode;
			var isQueryAll = "n";
			var shopCode = that.shopCode;
			var cabinetId = "";
			var pageSize = 12;
			var currentPage = that.currentPage;
			var orderBy = that.orderBy;
			var orderAsc = that.orderAsc;
			var sortTime = that.sortTime;
			var goodsName = encodeURI(that.sortParam);
			var firstCatCode = that.firstCatCode;
			var brandId = that.brandId;
			var productType = ""; //产品类型
			var orderType = ""; //订单类型
			__WEBPACK_IMPORTED_MODULE_2__static_api_api_js__["a" /* default */].getGoodsList(cabinetId, catCode, interval, currentPage, orderBy, orderAsc, shopCode, sortTime, pageSize, isQueryAll, goodsName, firstCatCode, brandId, productType, orderType, function (ret) {
				if (ret.code == "success") {
					var goods = ret.data.goods;
					that.totalItem = ret.data.totalItem;
					var totalPage = ret.data.totalPage;
					if (totalPage != undefined && totalPage != 0 && totalPage != that.totalPage) {
						that.totalPage = ret.data.totalPage;
						that.initPageArray();
					} else if (totalPage != undefined && totalPage == 0) {
						that.totalPage = 1;
						that.initPageArray();
					}
					if (goods != undefined) {
						for (var i = 0; i < goods.length; i++) {
							//商品图片
							var imgMiddle = goods[i].imgMiddle;
							if (imgMiddle.indexOf(";") != -1) {
								imgMiddle = imgMiddle.split(";")[0];
							}
							imgMiddle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + imgMiddle;
							goods[i].imgMiddle = imgMiddle;

							if (firstCatCode == 'spike') {

								var marketPrice = JSON.parse(goods[i].attrValue).marketPrice;
								var saleTimeStr = JSON.parse(goods[i].attrValue).saleTimeShow;
								var saleEndTimeStr = JSON.parse(goods[i].attrValue).saleEndTimeShow;
								if (marketPrice != undefined && marketPrice != "") {
									goods[i].marketPrice = marketPrice;
								} else {
									goods[i].marketPrice = goods[i].unitPrice;
								}
								if (saleEndTimeStr != undefined && saleEndTimeStr != '') {
									saleEndTimeStr = saleEndTimeStr.replace(/-/g, "/");
									var saleEndDate = new Date(saleEndTimeStr);

									saleTimeStr = saleTimeStr.replace(/-/g, "/");
									var saleDate = new Date(saleTimeStr);

									//如果当期日期大于销售结束日期 xxx
									if (new Date() > saleEndDate) {
										goods[i].saleStatus = "end";
									} else if (new Date() < saleDate) {
										//如果当期时间小于上架时间，展示距离开始 时间
										goods[i].saleStatus = "wait_start";
										var begSeconds = saleDate.getTime() - new Date().getTime(); //时间差的毫秒数        
										//计算出相差天数  
										//  								var days=Math.floor(begSeconds/(24*3600*1000));  
										//计算出小时数  
										var leave1 = begSeconds % (24 * 3600 * 1000); //计算天数后剩余的毫秒数  
										var hours = Math.floor(begSeconds / (3600 * 1000));
										//计算相差分钟数  
										var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数  
										var minutes = Math.floor(leave2 / (60 * 1000));
										//计算相差秒数  
										var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数  
										var seconds = Math.round(leave3 / 1000);
										// 									goods[i].day=days;
										goods[i].hour = hours;
										goods[i].minute = minutes;
										goods[i].second = seconds;
									} else {
										goods[i].saleStatus = "on_sale";

										var begSeconds = saleEndDate.getTime() - new Date().getTime(); //时间差的毫秒数        
										//计算出相差天数  
										//  								var days=Math.floor(begSeconds/(24*3600*1000));  
										//计算出小时数  
										var leave1 = begSeconds % (24 * 3600 * 1000); //计算天数后剩余的毫秒数  
										var hours = Math.floor(begSeconds / (3600 * 1000));
										//计算相差分钟数  
										var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数  
										var minutes = Math.floor(leave2 / (60 * 1000));
										//计算相差秒数  
										var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数  
										var seconds = Math.round(leave3 / 1000);
										// 									goods[i].day=days;
										goods[i].hour = hours;
										goods[i].minute = minutes;
										goods[i].second = seconds;
									}
								}
							}
						}
					}
					that.goodsList = goods;
					if (!that.isInit) {
						that.isInit = true;
						that.initPageArray();
					}
				}
			});
		},
		getShoppingCartNum: function getShoppingCartNum(shopCode) {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_2__static_api_api_js__["a" /* default */].getShoppingCartNum(function (ret) {
				if (ret.code == "success") {
					that.shoppingCartNum = ret.data.shoppingCartNum;
				}
			});
		},
		getShoppingCartList: function getShoppingCartList() {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_2__static_api_api_js__["a" /* default */].getShoppingCartList(function (ret) {
				if (ret.code == "success") {
					that.boList = ret.data.boList;
					var totalCount = 0;
					var bos = new Array();
					bos = ret.data.boList;
					var money = 0;
					for (var i = 0; i < bos.length; i++) {
						bos[i].imgSmall = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + bos[i].imgSmall;
						money = money + bos[i].goodsPrice * bos[i].goodsNumber;
						totalCount = totalCount + bos[i].goodsNumber;
					}
					that.sumMoney = money;
					that.count = totalCount;
				}
			});
		},
		deleteGoods: function deleteGoods(goodsCode) {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_2__static_api_api_js__["a" /* default */].deleteGoods(goodsCode, function (ret) {
				if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__["n" /* parseResult */])(ret, null, false)) {
					__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#" + goodsCode + "_cart_pro").remove();
				}
			});
		},
		goIndex: function goIndex() {
			this.$router.push({ name: 'index' });
		},
		getMoreCatGoods: function getMoreCatGoods(catCode, catNameCn) {
			this.catNameCn = catNameCn;
			this.resetCond();
			this.sortParam = "";
			this.firstCatCode = catCode;
			this.sortParam = "";
			this.getGoods();
		},
		getCatGoods: function getCatGoods(catCode, catNameCn) {
			this.catNameCn = catNameCn;
			this.resetCond();
			this.sortParam = "";
			this.catCode = catCode;
			this.firstCatCode = "";
			this.sortParam = "";
			this.getGoods();
		},
		resetCond: function resetCond() {
			this.interval = "intervalAll";
			this.catCode = "categoryAll";
			this.sortTime = "timeAll";
			this.firstCatCode = "";
			this.orderBy = "";
			this.orderAsc = "";
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#choosedCond").html("");
		},
		computeTime: function computeTime() {
			var that = this;
			var goodsList = that.goodsList;
			for (var j = 0; j < goodsList.length; j++) {
				var saleTimeStr = JSON.parse(goodsList[j].attrValue).saleTimeShow;
				var saleEndTimeStr = JSON.parse(goodsList[j].attrValue).saleEndTimeShow;

				if (saleEndTimeStr != undefined && saleEndTimeStr != '') {
					saleEndTimeStr = saleEndTimeStr.replace(/-/g, "/");
					var saleEndDate = new Date(saleEndTimeStr);

					saleTimeStr = saleTimeStr.replace(/-/g, "/");
					var saleDate = new Date(saleTimeStr);

					//如果当期日期大于销售结束日期 xxx
					if (new Date() > saleEndDate) {
						goodsList[j].saleStatus = "end";
					} else if (new Date() < saleDate) {
						//如果当期时间小于上架时间，展示距离开始 时间
						goodsList[j].saleStatus = "wait_start";
						var begSeconds = saleDate.getTime() - new Date().getTime(); //时间差的毫秒数        
						//计算出相差天数  
						//  								var days=Math.floor(begSeconds/(24*3600*1000));  
						//计算出小时数  
						var leave1 = begSeconds % (24 * 3600 * 1000); //计算天数后剩余的毫秒数  
						var hours = Math.floor(begSeconds / (3600 * 1000));
						//计算相差分钟数  
						var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数  
						var minutes = Math.floor(leave2 / (60 * 1000));
						//计算相差秒数  
						var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数  
						var seconds = Math.round(leave3 / 1000);
						goodsList[j].hour = hours;
						goodsList[j].minute = minutes;
						goodsList[j].second = seconds;
					} else {
						goodsList[j].saleStatus = "on_sale";

						var begSeconds = saleEndDate.getTime() - new Date().getTime(); //时间差的毫秒数        
						//计算出相差天数  
						//  								var days=Math.floor(begSeconds/(24*3600*1000));  
						//计算出小时数  
						var leave1 = begSeconds % (24 * 3600 * 1000); //计算天数后剩余的毫秒数  
						var hours = Math.floor(begSeconds / (3600 * 1000));
						//计算相差分钟数  
						var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数  
						var minutes = Math.floor(leave2 / (60 * 1000));
						//计算相差秒数  
						var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数  
						var seconds = Math.round(leave3 / 1000);
						goodsList[j].hour = hours;
						goodsList[j].minute = minutes;
						goodsList[j].second = seconds;
					}
				}
			}
			that.goodsList = goodsList;
			if (!that.isInit) {
				that.isInit = true;
				that.initPageArray();
			}
		},
		shopCartShow: function shopCartShow() {
			this.isShow = true;
		},
		shopCartHide: function shopCartHide() {
			this.isShow = false;
		}
	},
	ready: function ready() {},
	beforeDestroy: function beforeDestroy() {
		var that = this;
		if (that.firstCatCode == 'spike') {
			window.clearInterval(this.computeFlag);
		}
	},
	mounted: function mounted() {
		window.scrollTo(0, 0);
		this.$refs.navComp.getCat();
		var account = localStorage.getItem("account");
		if (account != undefined && account != "") {
			this.isLogin = true;
			this.account = account;
		}
		this.userCenterUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/index/default.htm';
		this.loginUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/login.htm';
		//			this.registerUrl = getUcUrl() + '/custm/user/user_reg_add.htm';
		this.registerUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/custm/user/user_reg_add.htm?formCode=MCHT_USER_FORM';
		this.logoutUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/logout.htm';
		this.aboutUsUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__["l" /* getAboutUsUrl */])();
		this.indexUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__["o" /* getIndexUrl */])();
		this.orderUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__["b" /* getEmallUrl */])() + '/orderManage/myOrderList.htm';

		var sortParam = this.$route.query.sortParam;
		var firstCatCode = this.$route.query.firstCatCode;
		var shopCode = this.$route.query.shopCode;
		var catCode = this.$route.query.catCode;
		var catNameCn = this.$route.query.catNameCn;
		var brandId = this.$route.query.brandId;
		var brandName = this.$route.query.brandName;

		if (sortParam != undefined) {
			this.sortParam = sortParam;
		}
		if (firstCatCode != undefined) {
			this.firstCatCode = firstCatCode;
		}
		if (shopCode != undefined) {
			this.shopCode = shopCode;
		}

		var that = this;
		if (firstCatCode != undefined && firstCatCode == 'spike') {
			this.computeFlag = window.setInterval(function () {
				that.computeTime(); //计算倒计时
			}, 1000);
		}
		if (catCode != undefined) {
			this.catCode = catCode;
			this.getCatGoods(this.catCode);
		}
		if (catNameCn != undefined) {
			this.catNameCn = decodeURI(catNameCn);;
		}
		if (brandId != undefined) {
			this.brandId = brandId;;
		}
		if (brandName != undefined) {
			this.brandName = brandName;;
		}
		this.getGoods();
		this.getShoppingCartNum();
		this.getShoppingCartList();
		this.getOrderCount();
		this.contactUrl = __WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__["p" /* sysContactUrl */];
	}
});

/***/ }),

/***/ "/z/Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_api_api_js__ = __webpack_require__("fXcb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_js_emallUtils_js__ = __webpack_require__("spYF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_js_alertConfirm_js__ = __webpack_require__("bCJ+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TopBar__ = __webpack_require__("5PWk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Header__ = __webpack_require__("teIl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_FooterMenu__ = __webpack_require__("gTlp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_FooterCopyright__ = __webpack_require__("3LwO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_HearderNav__ = __webpack_require__("7JIe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_clipboard2__ = __webpack_require__("wvfG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_clipboard2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_v_distpicker__ = __webpack_require__("95YI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_v_distpicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_v_distpicker__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//import jQuery from "../../../static/js/jquery.min.js"











__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_clipboard2___default.a);


__WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('v-distpicker', __WEBPACK_IMPORTED_MODULE_11_v_distpicker___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'addressManager',
  data: function data() {
    return {
      goodsCode: '',
      goodsCodes: '',
      payNum: '',
      select: { province: '', city: '', district: '' },
      address: '',
      mobile: '',
      zipcode: '',
      contextName: '',
      user_area: '',
      isEdit: '',
      id: '',
      addressTitle: '新增地址',
      sourceUrl: '',
      cityInfo: '',
      backUrl: 'address_list',
      orderSource: '',
      boList: [],
      distributeAccount: '',
      distributeName: '',
      shopCode: ''
    };
  },

  components: {
    'topbar': __WEBPACK_IMPORTED_MODULE_5__components_TopBar__["a" /* default */],
    'sortHeader': __WEBPACK_IMPORTED_MODULE_6__components_Header__["a" /* default */],
    'footermenu': __WEBPACK_IMPORTED_MODULE_7__components_FooterMenu__["a" /* default */],
    'footercopyright': __WEBPACK_IMPORTED_MODULE_8__components_FooterCopyright__["a" /* default */],
    'heardernav': __WEBPACK_IMPORTED_MODULE_9__components_HearderNav__["a" /* default */]
  },
  methods: {
    // 城市选择
    onSelected: function onSelected(data) {
      this.select.province = data.province.value;
      this.select.city = data.city.value;
      this.select.district = data.area.value;
    },
    jump_to: function jump_to(url) {
      if (this.goodsCode != '' && this.payNum != '') {
        this.$router.push({ name: url, params: {
            goodsCode: this.goodsCode,
            payNum: this.payNum,
            sourceUrl: this.sourceUrl
          } });
      } else if (this.goodsCodes != '') {
        this.$router.push({ name: url, params: {
            goodsCodes: this.goodsCodes
          } });
      } else {
        this.$router.push({ name: url });
      }
    },
    getOneAddress: function getOneAddress(addressId) {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_1__static_api_api_js__["a" /* default */].getOneAddress(addressId, function (ret) {
        var addressBo = ret.data;
        if (addressBo != undefined) {
          that.contextName = addressBo.contextName;
          that.mobile = addressBo.mobile;
          that.address = addressBo.address;

          that.select.province = addressBo.province;
          that.select.city = addressBo.city;
          that.select.district = addressBo.district;
          that.user_area = addressBo.province + "," + addressBo.city + "," + addressBo.district;
          that.id = addressBo.id;
          that.zipcode = addressBo.zipcode;
          that.isEdit = "update";
          that.addressTitle = "修改地址";
        }
      });
    },
    saveAddress: function saveAddress() {
      var that = this;
      var province = that.select.province;
      var city = that.select.city;
      var district = that.select.district;
      var address = that.address;
      var mobile = that.mobile;
      var contextName = that.contextName;
      var isEdit = that.isEdit;
      var zipcode = that.zipcode;
      var id = that.id;
      var isMobile = /^(((13[0-9]{1})|(14[0-9]{1})|(17[0-9]{1})|(15[0-9]{1})|(18[0-9]{1}))+\d{8})$/; //手机
      var isPhone = /^((0\d{2,3})-)?(\d{7,8})(-(\d{3,}))?$/; //座机
      var isZip = /^[0-9][0-9]{5}$/;

      if (this.isBlank(province) || this.isBlank(city) || this.isBlank(district) || this.isBlank(address) || this.isBlank(mobile) || this.isBlank(contextName)) {
        __WEBPACK_IMPORTED_MODULE_3__static_js_alertConfirm_js__["a" /* default */].singleConfirm("信息填写不完整!");
      } else if (address.length <= 5 || address.length > 100) {
        __WEBPACK_IMPORTED_MODULE_3__static_js_alertConfirm_js__["a" /* default */].singleConfirm("地址长度过长或过短!");
      } else if (!isMobile.test(mobile) && !isPhone.test(mobile)) {
        __WEBPACK_IMPORTED_MODULE_3__static_js_alertConfirm_js__["a" /* default */].singleConfirm("请填写正确的联系电话!");
      } else if (!isZip.test(zipcode)) {
        __WEBPACK_IMPORTED_MODULE_3__static_js_alertConfirm_js__["a" /* default */].singleConfirm("请填写正确的邮编!");
      } else {
        province = encodeURI(province);
        city = encodeURI(city);
        district = encodeURI(district);
        address = encodeURI(address);
        contextName = encodeURI(contextName);

        __WEBPACK_IMPORTED_MODULE_1__static_api_api_js__["a" /* default */].saveAddress(province, city, district, address, mobile, contextName, isEdit, id, zipcode, function (ret) {
          if (ret.code == 'success') {
            if (that.backUrl == 'address_list') {
              that.$router.push({
                path: that.backUrl,
                query: {} });
            } else {
              if (that.orderSource == 'cart') {
                that.$router.push({
                  path: that.backUrl,
                  query: {
                    orderSource: that.orderSource,
                    bos: that.boList
                  } });
              } else {
                that.$router.push({
                  path: that.backUrl,
                  query: {
                    goodsCode: that.goodsCode,
                    shopCode: that.shopCode,
                    payNum: that.payNum,
                    orderSource: that.orderSource,
                    distributeAccount: that.distributeAccount,
                    distributeName: that.distributeName,
                    bos: that.boList
                  } });
              }
            }
          } else {
            __WEBPACK_IMPORTED_MODULE_3__static_js_alertConfirm_js__["a" /* default */].singleConfirm(ret.msg);
          }
        });
      }
    },

    isBlank: function isBlank(obj) {
      return typeof obj == 'undefined' || obj == '' || obj == null;
    }
  },
  beforeMount: function beforeMount() {
    var backUrl = this.$route.query.backUrl;
    if (backUrl != undefined) {
      this.backUrl = backUrl;
    }
    var boList = this.$route.query.boList;
    if (boList != undefined) {
      this.boList = boList;
    }
    if (this.$route.query.orderSource != undefined) {
      this.orderSource = this.$route.query.orderSource;
    }
    if (this.$route.query.goodsCode != undefined) {
      this.goodsCode = this.$route.query.goodsCode;
    }
    if (this.$route.query.shopCode != undefined) {
      this.shopCode = this.$route.query.shopCode;
    }
    if (this.$route.query.payNum != undefined) {
      this.payNum = this.$route.query.payNum;
    }
    //if(this.$route.query.distributeAccount != undefined){
    //	this.distributeAccount = this.$route.query.distributeAccount;
    //}
    //if(this.$route.query.distributeName != undefined){
    //	this.distributeName = this.$route.query.distributeName;
    //}
    var addressId = this.$route.query.addressId;
    if (addressId != undefined) {
      this.id = addressId;
    }
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
    this.getOneAddress(this.id);
  }
});

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0t5L":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "16u8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TopBar__ = __webpack_require__("5PWk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_api_api_js__ = __webpack_require__("fXcb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__ = __webpack_require__("spYF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_js_db_main_js__ = __webpack_require__("gkCg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_js_db_main_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__static_js_db_main_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Header__ = __webpack_require__("teIl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_FooterMenu__ = __webpack_require__("gTlp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_FooterCopyright__ = __webpack_require__("3LwO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_HearderNav__ = __webpack_require__("7JIe");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//import {jQuery} from "../../../static/js/jquery.min.js"









/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'goodsList',
	components: {
		'topbar': __WEBPACK_IMPORTED_MODULE_2__components_TopBar__["a" /* default */],
		'sortHeader': __WEBPACK_IMPORTED_MODULE_6__components_Header__["a" /* default */],
		'footermenu': __WEBPACK_IMPORTED_MODULE_7__components_FooterMenu__["a" /* default */],
		'footercopyright': __WEBPACK_IMPORTED_MODULE_8__components_FooterCopyright__["a" /* default */],
		'heardernav': __WEBPACK_IMPORTED_MODULE_9__components_HearderNav__["a" /* default */]
	},
	data: function data() {
		var _ref;

		return _ref = {
			isRefresh: true,
			goodsList: [],
			recommendGoodsList: [],
			sortCondition: 'defaultSort',
			sortSaleAmount: '',
			sortPublishTime: '',
			sortPrice: '',
			choosedCondItem: [],
			catCode: 'categoryAll',
			interval: 'intervalAll',
			sortTime: 'timeAll',
			currentPage: 1,
			totalPage: 1,
			orderBy: '',
			orderAsc: '',
			shopCode: '',
			pageList: [1],
			totalItem: 0,
			sortParam: '',
			shoppingCartNum: 0,
			boList: [],
			count: 0,
			goodsImgs: [],
			sumMoney: 0,
			goodsName: '',
			firstCatCode: ''
		}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'shopCode', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'mobile', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'isLogin', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'isShow', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'account', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'userCenterUrl', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'loginUrl', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'registerUrl', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'logoutUrl', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'aboutUsUrl', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'indexUrl', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'orderUrl', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'catNameCn', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'brandId', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'brandName', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'allCount', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'payCount', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'putCount', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'receiveCount', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'sendCount', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'closeCount', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'computeFlag', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'contactUrl', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'showItem', 7), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'isInit', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'lower', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'upper', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'productType', 'meterial'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'orderType', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'activeLi', 'meterial'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'twoCategoryList', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'brandList', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'firstCatList', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'catMap', []), _ref;
	},

	watch: {
		sortParam: function sortParam(newValue, oldValue) {
			//      		alert(this.sortParam);
			//				alert(newValue+" to "+oldValue);
			if (oldValue != undefined && oldValue != '') {
				this.getRecommendGoods();
				this.getGoods();
			}
		}

	},
	methods: {
		orderShow: function orderShow() {
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".orders-list").show();
		},
		orderHide: function orderHide() {
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".orders-list").hide();
		},
		shopCarShow: function shopCarShow() {
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".goods-list").show();
		},
		shopCarHide: function shopCarHide() {
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".goods-list").hide();
		},
		getOrderCount: function getOrderCount(shopCode) {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_3__static_api_api_js__["a" /* default */].getOrderCount(function (ret) {
				if (ret.code == "success") {
					that.allCount = ret.data.allCount;
					that.payCount = ret.data.payCount;
					that.putCount = ret.data.putCount;
					that.receiveCount = ret.data.receiveCount;
					that.sendCount = ret.data.sendCount;
					that.closeCount = ret.data.closeCount;
				}
			});
		},
		logout: function logout() {
			localStorage.clear();
			__WEBPACK_IMPORTED_MODULE_3__static_api_api_js__["a" /* default */].loginOut(function (ret) {});
			window.location.href = this.logoutUrl;
		},
		clearCookie: function clearCookie() {
			var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
			if (keys) {
				for (var i = keys.length; i--;) {
					document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString();
				}
			}
		},
		goOrder: function goOrder(tradeStatus) {
			var account = localStorage.getItem("account");
			if (account != undefined && account != "") {
				window.location.href = this.orderUrl + "?tradeStatus=" + tradeStatus;
			} else {
				window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/login.htm';
			}
		},
		mobileAppShow: function mobileAppShow() {
			this.isShow = true;
		},
		mobileAppHidden: function mobileAppHidden() {
			this.isShow = false;
		},
		jumpTo: function jumpTo(name) {
			this.$router.push({ name: name });
		},
		toGoodsDetail: function toGoodsDetail(goodsCode, productType) {
			//this.$router.push({ name: 'goodsdetail', query:{goodsCode:goodsCode}});
			/*if(productType!=undefined&&productType=='sample'){//样品
   	let routeData = this.$router.resolve({ path: '/sampleDetail', query: {goodsCode: goodsCode } });
   	window.open(routeData.href, '_blank');
   }else{*/
			var routeData = this.$router.resolve({ path: '/goodsDetails', query: { goodsCode: goodsCode, orderType: this.orderType, productType: this.productType } });
			window.open(routeData.href, '_blank');
			/*}*/
		},
		prePage: function prePage() {
			if (this.currentPage > 1) {
				this.currentPage = this.currentPage - 1;
				this.adjustPageArray(this.currentPage);
				this.getGoods();
			}
		},
		nextPage: function nextPage() {
			if (this.currentPage < this.totalPage) {
				this.currentPage = this.currentPage + 1;
				this.adjustPageArray(this.currentPage);
				this.getGoods();
			}
		},
		queryByPage: function queryByPage(page) {
			this.currentPage = page;
			this.adjustPageArray(this.currentPage);
			this.getGoods();
		},
		adjustPageArray: function adjustPageArray(page) {
			if (page == this.pageList[6] && page + 2 <= this.totalPage) {
				this.pageList.push(page + 1);
				this.pageList.push(page + 2);
				this.pageList.shift();
				this.pageList.shift();
			} else if (page == this.pageList[6] && page + 1 == this.totalPage) {
				this.pageList.push(page + 1);
				this.pageList.shift();
			} else if (page == this.pageList[0] && page >= 3) {
				this.pageList.unshift(page - 1);
				this.pageList.unshift(page - 2);
				this.pageList.pop();
				this.pageList.pop();
			} else if (page == this.pageList[0] && page == 2) {
				this.pageList.unshift(page - 1);
				this.pageList.pop();
			}
		},
		initPageArray: function initPageArray() {
			var pageList = new Array();
			var totalPage = this.totalPage;
			for (var i = 1; i <= totalPage; i++) {
				if (i <= this.showItem) {
					pageList.push(i);
				}
			}
			this.pageList = pageList;
		},
		clearUserDefined: function clearUserDefined() {
			this.lower = '';
			this.upper = '';
		},
		userDefinedCondition: function userDefinedCondition() {
			this.lower = this.lower.trim();
			this.upper = this.upper.trim();
			var sortParams = '';
			if (this.lower != '' && this.upper != '') {
				sortParams = this.lower + ',' + this.upper;
			} else if (this.lower == '' && this.upper != '') {
				sortParams = '0,' + this.upper;
			} else if (this.lower != '' && this.upper == '') {
				sortParams = this.lower + ',';
			}
			this.chooseCondition('', 'amount', sortParams);
		},
		//选择一级类目时
		chooseFirstCat: function chooseFirstCat(firstCatCode) {
			this.firstCatCode = firstCatCode;
			if (this.catMap != undefined && this.catMap[firstCatCode] != undefined && this.catMap[firstCatCode] != null) {
				this.twoCategoryList = JSON.parse(this.catMap[firstCatCode]);
			}
		},
		chooseCondition: function chooseCondition(event, type, sortParams) {
			if (event != '') {
				var condText = event.target.innerText;
				if (condText != "不限") {
					var condText = event.target.innerText;
					if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#choosedCond").find("span[condType='" + type + "']").length != 0) {
						__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#choosedCond").find("span[condType='" + type + "']").remove();
					}
					this.choosedCondItem.push({ condName: condText, condType: type });
				} else {
					__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#choosedCond").find("span[condType='" + type + "']").remove();
				}

				if (type == 'amount') {
					this.clearUserDefined();
				}
			} else {
				if (type == 'amount') {
					if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#choosedCond").find("span[condType='" + type + "']").length != 0) {
						__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#choosedCond").find("span[condType='" + type + "']").remove();
					}
				}
			}

			if (type == 'amount') {
				this.interval = sortParams;
			} else if (type == 'cat') {
				this.catCode = sortParams;
			} else if (type == 'time') {
				this.sortTime = sortParams;
			} else if (type == 'catNameCn') {
				this.catCode = sortParams;
			} else if (type == 'brand') {
				this.brandId = sortParams;
			} else if (type == 'firstCat') {
				//选择了一级类目
				if (this.firstCatCode != sortParams) {
					this.firstCatCode = sortParams;
					this.catCode = "categoryAll"; //换一级类目后二级类目初始化为全部
					if (this.catMap[sortParams] != undefined && this.catMap[sortParams] != null) {
						this.twoCategoryList = JSON.parse(this.catMap[sortParams]);
					} else {
						this.twoCategoryList = [];
					}

					if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#choosedCond").find("span[condType='catNameCn']").length != 0) {
						__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#choosedCond").find("span[condType='catNameCn']").remove();
					}
				}
			}
			this.currentPage = 1; //页码初始化为1
			this.getRecommendGoods();
			this.getGoods();
		},
		removeCondition: function removeCondition(index, type) {
			if (type == 'amount') {
				this.interval = "intervalAll";
			} else if (type == 'cat') {
				this.catCode = "categoryAll";
			} else if (type == 'time') {
				this.sortTime = "timeAll";
			} else if (type == 'catNameCn') {
				this.catCode = "categoryAll";
			} else if (type == 'brand') {
				this.brandId = 0;
			} else if (type == 'firstCat') {
				this.firstCatCode = '';
			}
			//		  			this.choosedCondItem.splice(index,1);
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#choosedCond").find("span[condType='" + type + "']").remove();
			this.getRecommendGoods();
			this.getGoods();
		},
		findGoods: function findGoods() {
			this.resetCond();
			this.getRecommendGoods();
			this.getGoods();
		},
		findShops: function findShops() {
			this.$router.push({ name: 'shopsList', query: { sortParam: this.sortParam } });
		},
		sortGoods: function sortGoods(sortCondition) {
			this.currentPage = 1;
			this.sortCondition = sortCondition;
			if (sortCondition == "saleAmount") {
				this.orderBy = "sale_number";
				if (this.sortSaleAmount == '') {
					this.sortSaleAmount = "desc";
				} else if (this.sortSaleAmount == 'desc') {
					this.sortSaleAmount = "asc";
				} else if (this.sortSaleAmount == 'asc') {
					this.sortSaleAmount = "desc";
				}
				this.orderAsc = this.sortSaleAmount;
			}
			if (sortCondition == "publishTime") {
				this.orderBy = "gmt_create";
				if (this.sortPublishTime == '') {
					this.sortPublishTime = "desc";
				} else if (this.sortPublishTime == 'desc') {
					this.sortPublishTime = "asc";
				} else if (this.sortPublishTime == 'asc') {
					this.sortPublishTime = "desc";
				}
				this.orderAsc = this.sortPublishTime;
			}
			if (sortCondition == "price") {
				this.orderBy = "unit_price";
				if (this.sortPrice == '') {
					this.sortPrice = "desc";
				} else if (this.sortPrice == 'desc') {
					this.sortPrice = "asc";
				} else if (this.sortPrice == 'asc') {
					this.sortPrice = "desc";
				}
				this.orderAsc = this.sortPrice;
			}
			if (sortCondition == "defaultSort") {
				this.orderBy = "";
				this.orderAsc = "";
			}
			this.getGoods();
			this.getRecommendGoods();
		},
		getRecommendGoods: function getRecommendGoods() {
			var that = this;
			var interval = that.interval;
			var catCode = that.catCode;
			var cabinetId = "";
			var pageSize = 5;
			var isQueryAll = "n";
			var currentPage = 1;
			var orderBy = "sale_number";
			var orderAsc = "desc";
			var shopCode = that.shopCode;
			var sortTime = "";
			var goodsName = encodeURI(that.sortParam);
			var firstCatCode = that.firstCatCode;
			var brandId = that.brandId;
			var productType = that.productType;
			var orderType = that.orderType;

			__WEBPACK_IMPORTED_MODULE_3__static_api_api_js__["a" /* default */].getGoodsList(cabinetId, catCode, interval, currentPage, orderBy, orderAsc, shopCode, sortTime, pageSize, isQueryAll, goodsName, firstCatCode, brandId, productType, orderType, function (ret) {
				if (ret.code == "success") {
					var goods = ret.data.goods;
					if (goods != undefined) {
						for (var i = 0; i < goods.length; i++) {
							//商品图片
							var imgMiddle = goods[i].imgMiddle;
							if (imgMiddle.indexOf(";") != -1) {
								imgMiddle = imgMiddle.split(";")[0];
							}
							imgMiddle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + imgMiddle;
							goods[i].imgMiddle = imgMiddle;
						}
					}
					that.recommendGoodsList = goods;
				}
			});
		},
		getGoods: function getGoods() {
			var that = this;
			var interval = that.interval;
			var catCode = that.catCode;
			var isQueryAll = "n";
			var shopCode = that.shopCode;
			var cabinetId = "";
			var pageSize = 9;
			var currentPage = that.currentPage;
			var orderBy = that.orderBy;
			var orderAsc = that.orderAsc;
			var sortTime = that.sortTime;
			var goodsName = encodeURI(that.sortParam);
			var firstCatCode = that.firstCatCode;
			var brandId = that.brandId;
			var productType = that.productType;
			var orderType = that.orderType;
			__WEBPACK_IMPORTED_MODULE_3__static_api_api_js__["a" /* default */].getGoodsList(cabinetId, catCode, interval, currentPage, orderBy, orderAsc, shopCode, sortTime, pageSize, isQueryAll, goodsName, firstCatCode, brandId, productType, orderType, function (ret) {
				if (ret.code == "success") {
					var goods = ret.data.goods;
					that.totalItem = ret.data.totalItem;
					var totalPage = ret.data.totalPage;
					if (totalPage != undefined && totalPage != 0 && totalPage != that.totalPage) {
						that.totalPage = ret.data.totalPage;
						that.initPageArray();
					} else if (totalPage != undefined && totalPage == 0) {
						that.totalPage = 1;
						that.initPageArray();
					}
					if (goods != undefined) {
						for (var i = 0; i < goods.length; i++) {
							//商品图片
							var imgMiddle = goods[i].imgMiddle;
							if (imgMiddle.indexOf(";") != -1) {
								imgMiddle = imgMiddle.split(";")[0];
							}
							imgMiddle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + imgMiddle;
							goods[i].imgMiddle = imgMiddle;

							if (firstCatCode == 'spike') {

								var marketPrice = JSON.parse(goods[i].attrValue).marketPrice;
								var saleTimeStr = JSON.parse(goods[i].attrValue).saleTimeShow;
								var saleEndTimeStr = JSON.parse(goods[i].attrValue).saleEndTimeShow;
								if (marketPrice != undefined && marketPrice != "") {
									goods[i].marketPrice = marketPrice;
								} else {
									goods[i].marketPrice = goods[i].unitPrice;
								}
								if (saleEndTimeStr != undefined && saleEndTimeStr != '') {
									saleEndTimeStr = saleEndTimeStr.replace(/-/g, "/");
									var saleEndDate = new Date(saleEndTimeStr);

									saleTimeStr = saleTimeStr.replace(/-/g, "/");
									var saleDate = new Date(saleTimeStr);

									//如果当期日期大于销售结束日期 xxx
									if (new Date() > saleEndDate) {
										goods[i].saleStatus = "end";
									} else if (new Date() < saleDate) {
										//如果当期时间小于上架时间，展示距离开始 时间
										goods[i].saleStatus = "wait_start";
										var begSeconds = saleDate.getTime() - new Date().getTime(); //时间差的毫秒数        
										//计算出相差天数  
										//  								var days=Math.floor(begSeconds/(24*3600*1000));  
										//计算出小时数  
										var leave1 = begSeconds % (24 * 3600 * 1000); //计算天数后剩余的毫秒数  
										var hours = Math.floor(begSeconds / (3600 * 1000));
										//计算相差分钟数  
										var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数  
										var minutes = Math.floor(leave2 / (60 * 1000));
										//计算相差秒数  
										var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数  
										var seconds = Math.round(leave3 / 1000);
										// 									goods[i].day=days;
										goods[i].hour = hours;
										goods[i].minute = minutes;
										goods[i].second = seconds;
									} else {
										goods[i].saleStatus = "on_sale";

										var begSeconds = saleEndDate.getTime() - new Date().getTime(); //时间差的毫秒数        
										//计算出相差天数  
										//  								var days=Math.floor(begSeconds/(24*3600*1000));  
										//计算出小时数  
										var leave1 = begSeconds % (24 * 3600 * 1000); //计算天数后剩余的毫秒数  
										var hours = Math.floor(begSeconds / (3600 * 1000));
										//计算相差分钟数  
										var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数  
										var minutes = Math.floor(leave2 / (60 * 1000));
										//计算相差秒数  
										var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数  
										var seconds = Math.round(leave3 / 1000);
										// 									goods[i].day=days;
										goods[i].hour = hours;
										goods[i].minute = minutes;
										goods[i].second = seconds;
									}
								}
							}
						}
					}
					that.goodsList = goods;
					if (!that.isInit) {
						that.isInit = true;
						that.initPageArray();
					}
				}
			});
		},
		getShoppingCartNum: function getShoppingCartNum(shopCode) {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_3__static_api_api_js__["a" /* default */].getShoppingCartNum(function (ret) {
				if (ret.code == "success") {
					that.shoppingCartNum = ret.data.shoppingCartNum;
				}
			});
		},
		getShoppingCartList: function getShoppingCartList() {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_3__static_api_api_js__["a" /* default */].getShoppingCartList(function (ret) {
				if (ret.code == "success") {
					that.boList = ret.data.boList;
					var totalCount = 0;
					var bos = new Array();
					bos = ret.data.boList;
					var money = 0;
					for (var i = 0; i < bos.length; i++) {
						var imgSmall = bos[i].imgSmall;
						if (imgSmall.indexOf(";") != -1) {
							imgSmall = imgSmall.split(";")[0];
						}
						bos[i].imgSmall = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + imgSmall;
						money = money + bos[i].goodsPrice * bos[i].goodsNumber;
						totalCount = totalCount + bos[i].goodsNumber;
					}
					that.sumMoney = money;
					that.count = totalCount;
				}
			});
		},
		deleteGoods: function deleteGoods(goodsCode) {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_3__static_api_api_js__["a" /* default */].deleteGoods(goodsCode, function (ret) {
				if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["n" /* parseResult */])(ret, null, false)) {
					__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#" + goodsCode + "_cart_pro").remove();
				}
			});
		},
		goIndex: function goIndex() {
			this.$router.push({ name: 'index' });
		},
		getMoreCatGoods: function getMoreCatGoods(catCode, catNameCn) {
			this.catNameCn = catNameCn;
			this.resetCond();
			this.sortParam = "";
			this.firstCatCode = catCode;
			this.sortParam = "";
			this.getRecommendGoods();
			this.getGoods();
		},
		getCatGoods: function getCatGoods(catCode, catNameCn) {
			this.catNameCn = catNameCn;
			this.resetCond();
			this.sortParam = "";
			this.catCode = catCode;
			this.firstCatCode = "";
			this.sortParam = "";
			this.getRecommendGoods();
			this.getGoods();
		},
		resetCond: function resetCond() {
			this.interval = "intervalAll";
			this.catCode = "categoryAll";
			this.sortTime = "timeAll";
			this.firstCatCode = "";
			this.orderBy = "";
			this.orderAsc = "";
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#choosedCond").html("");
		},
		computeTime: function computeTime() {
			var that = this;
			var goodsList = that.goodsList;
			for (var j = 0; j < goodsList.length; j++) {
				var saleTimeStr = JSON.parse(goodsList[j].attrValue).saleTimeShow;
				var saleEndTimeStr = JSON.parse(goodsList[j].attrValue).saleEndTimeShow;

				if (saleEndTimeStr != undefined && saleEndTimeStr != '') {
					saleEndTimeStr = saleEndTimeStr.replace(/-/g, "/");
					var saleEndDate = new Date(saleEndTimeStr);

					saleTimeStr = saleTimeStr.replace(/-/g, "/");
					var saleDate = new Date(saleTimeStr);

					//如果当期日期大于销售结束日期 xxx
					if (new Date() > saleEndDate) {
						goodsList[j].saleStatus = "end";
					} else if (new Date() < saleDate) {
						//如果当期时间小于上架时间，展示距离开始 时间
						goodsList[j].saleStatus = "wait_start";
						var begSeconds = saleDate.getTime() - new Date().getTime(); //时间差的毫秒数        
						//计算出相差天数  
						//  								var days=Math.floor(begSeconds/(24*3600*1000));  
						//计算出小时数  
						var leave1 = begSeconds % (24 * 3600 * 1000); //计算天数后剩余的毫秒数  
						var hours = Math.floor(begSeconds / (3600 * 1000));
						//计算相差分钟数  
						var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数  
						var minutes = Math.floor(leave2 / (60 * 1000));
						//计算相差秒数  
						var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数  
						var seconds = Math.round(leave3 / 1000);
						goodsList[j].hour = hours;
						goodsList[j].minute = minutes;
						goodsList[j].second = seconds;
					} else {
						goodsList[j].saleStatus = "on_sale";

						var begSeconds = saleEndDate.getTime() - new Date().getTime(); //时间差的毫秒数        
						//计算出相差天数  
						//  								var days=Math.floor(begSeconds/(24*3600*1000));  
						//计算出小时数  
						var leave1 = begSeconds % (24 * 3600 * 1000); //计算天数后剩余的毫秒数  
						var hours = Math.floor(begSeconds / (3600 * 1000));
						//计算相差分钟数  
						var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数  
						var minutes = Math.floor(leave2 / (60 * 1000));
						//计算相差秒数  
						var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数  
						var seconds = Math.round(leave3 / 1000);
						goodsList[j].hour = hours;
						goodsList[j].minute = minutes;
						goodsList[j].second = seconds;
					}
				}
			}
			that.goodsList = goodsList;
			if (!that.isInit) {
				that.isInit = true;
				that.initPageArray();
			}
		},
		getCategoryListByCode: function getCategoryListByCode(parentCode) {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_3__static_api_api_js__["a" /* default */].getCategoryListByCode(parentCode, function (ret) {
				if (ret.data.catList != null || ret.data.catList != "") {
					that.twoCategoryList = ret.data.catList;
				}
			});
		},
		getAllCategoryMap: function getAllCategoryMap() {
			var that = this;
			var productType = '';
			if (that.productType != undefined) {
				if (that.productType == 'sample') {
					productType = 'product'; //样品和现货公用一套类目，按product来查询
				} else {
					productType = that.productType;
				}
			}
			__WEBPACK_IMPORTED_MODULE_3__static_api_api_js__["a" /* default */].getAllCategoryMap(productType, function (ret) {
				if (ret.data.firstCatList != null || ret.data.firstCatList != "") {
					that.firstCatList = ret.data.firstCatList;
				}
				if (ret.data.catMap != null || ret.data.catMap != "") {
					that.catMap = ret.data.catMap;
				}
			});
		},
		getBrandList: function getBrandList() {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_3__static_api_api_js__["a" /* default */].getBrandList(function (ret) {
				if (ret.data.brandBoList != null || ret.data.brandBoList != "") {
					that.brandList = ret.data.brandBoList;
				}
			});
		},
		showMoreCategory: function showMoreCategory() {
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.td_div').toggleClass('td_h');
		},
		showMoreBrand: function showMoreBrand() {
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.td_brand_div').toggleClass('td_brand_h');
		}
	},
	ready: function ready() {},
	beforeDestroy: function beforeDestroy() {
		var that = this;
		if (that.firstCatCode == 'spike') {
			window.clearInterval(this.computeFlag);
		}
	},
	mounted: function mounted() {
		window.scrollTo(0, 0);
		//			this.$refs.navComp.getCat();//不用获取首页的类目
		var account = localStorage.getItem("account");
		if (account != undefined && account != "") {
			this.isLogin = true;
			this.account = account;
		}
		this.userCenterUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/index/default.htm';
		this.loginUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/login.htm';
		//			this.registerUrl = getUcUrl() + '/custm/user/user_reg_add.htm';
		this.registerUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/custm/user/user_reg_add.htm?formCode=MCHT_USER_FORM';
		this.logoutUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/logout.htm';
		this.aboutUsUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["l" /* getAboutUsUrl */])();
		this.indexUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["o" /* getIndexUrl */])();
		this.orderUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["b" /* getEmallUrl */])() + '/orderManage/myOrderList.htm';

		var sortParam = this.$route.query.sortParam;
		var firstCatCode = this.$route.query.firstCatCode;
		var shopCode = this.$route.query.shopCode;
		var catCode = this.$route.query.catCode;
		var catNameCn = this.$route.query.catNameCn;
		var brandId = this.$route.query.brandId;
		var brandName = this.$route.query.brandName;
		//产品类型
		if (this.$route.query.productType != undefined && this.$route.query.productType != "") {
			this.productType = this.$route.query.productType;
		}
		if (this.$route.params.productType != undefined && this.$route.params.productType != "") {
			this.productType = this.$route.params.productType;
		}
		if (this.productType == 'sample' || this.productType == 'meterial') {
			this.activeLi = this.$route.query.productType;
		}
		//下单类型
		if (this.$route.query.orderType != undefined && this.$route.query.orderType != "") {
			this.orderType = this.$route.query.orderType;
		}
		if (this.$route.params.orderType != undefined && this.$route.params.orderType != "") {
			this.orderType = this.$route.params.orderType;
		}
		if (sortParam != undefined) {
			this.sortParam = sortParam;
		}
		if (firstCatCode != undefined) {
			this.firstCatCode = firstCatCode;
		}
		if (shopCode != undefined) {
			this.shopCode = shopCode;
		}
		var that = this;
		if (firstCatCode != undefined && firstCatCode == 'spike') {
			this.computeFlag = window.setInterval(function () {
				that.computeTime(); //计算倒计时
			}, 1000);
		}
		if (catCode != undefined) {
			this.catCode = catCode;
			this.getCatGoods(this.catCode);
		} else {
			this.getRecommendGoods();
			this.getGoods();
		}
		if (catNameCn != undefined) {
			this.catNameCn = decodeURI(catNameCn);;
		}
		if (brandId != undefined) {
			this.brandId = brandId;;
		}
		if (brandName != undefined) {
			this.brandName = brandName;;
		}
		//this.getRecommendGoods();
		//this.getGoods();
		this.getShoppingCartNum();
		this.getShoppingCartList();
		this.getOrderCount();
		this.contactUrl = __WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["p" /* sysContactUrl */];
		if (firstCatCode != undefined && firstCatCode != "") {
			this.getCategoryListByCode(firstCatCode);
		} else {
			this.getAllCategoryMap();
		}
		//获取品牌信息
		this.getBrandList();
	}
});

/***/ }),

/***/ "1RbL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_api_api_js__ = __webpack_require__("fXcb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__ = __webpack_require__("spYF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_js_db_main_js__ = __webpack_require__("gkCg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_js_db_main_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__static_js_db_main_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TopBar__ = __webpack_require__("5PWk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Header__ = __webpack_require__("teIl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_FooterMenu__ = __webpack_require__("gTlp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_FooterCopyright__ = __webpack_require__("3LwO");


var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//import {jQuery} from "../../../static/js/jquery.min.js"








/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'shopsList',
	components: {
		'topbar': __WEBPACK_IMPORTED_MODULE_5__components_TopBar__["a" /* default */],
		'sortHeader': __WEBPACK_IMPORTED_MODULE_6__components_Header__["a" /* default */],
		'footermenu': __WEBPACK_IMPORTED_MODULE_7__components_FooterMenu__["a" /* default */],
		'footercopyright': __WEBPACK_IMPORTED_MODULE_8__components_FooterCopyright__["a" /* default */]
	},
	data: function data() {
		return {
			goodsList: [],
			recommendGoodsList: [],
			sortCondition: 'defaultSort',
			sortSaleAmount: '',
			sortPublishTime: '',
			sortPrice: '',
			choosedCondItem: [],
			catCode: 'categoryAll',
			interval: 'intervalAll',
			sortTime: 'timeAll',
			currentPage: 1,
			totalPage: 1,
			orderBy: '',
			orderAsc: '',
			shopCode: '',
			pageList: [1],
			totalItem: 0,
			sortParam: '',
			shoppingCartNum: 0,
			boList: [],
			count: 0,
			goodsImgs: [],
			sumMoney: 0,
			goodsName: '',
			firstCatCode: '',
			catList: [],
			isLogin: false,
			mobile: '',
			isShow: false,
			account: '',
			shopList: [],
			relativeShopList: [],
			indexUrl: '',
			allCount: 0,
			payCount: 0,
			putCount: 0,
			receiveCount: 0,
			sendCount: 0,
			closeCount: 0
		};
	},

	methods: (_methods = {
		orderShow: function orderShow() {
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".orders-list").show();
		},
		orderHide: function orderHide() {
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".orders-list").hide();
		},
		shopCarShow: function shopCarShow() {
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".goods-list").show();
		},
		shopCarHide: function shopCarHide() {
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".goods-list").hide();
		},
		getOrderCount: function getOrderCount(shopCode) {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_2__static_api_api_js__["a" /* default */].getOrderCount(function (ret) {
				if (ret.code == "success") {
					that.allCount = ret.data.allCount;
					that.payCount = ret.data.payCount;
					that.putCount = ret.data.putCount;
					that.receiveCount = ret.data.receiveCount;
					that.sendCount = ret.data.sendCount;
					that.closeCount = ret.data.closeCount;
				}
			});
		},
		goOrder: function goOrder(tradeStatus) {
			var account = localStorage.getItem("account");
			if (account != undefined && account != "") {
				window.location.href = this.orderUrl + "?tradeStatus=" + tradeStatus;
			} else {
				window.location.href = getUcUrl() + '/login.htm';
			}
		},
		mobileAppShow: function mobileAppShow() {
			this.isShow = true;
		},
		mobileAppHidden: function mobileAppHidden() {
			this.isShow = false;
		},
		jumpTo: function jumpTo(name) {
			this.$router.push({ name: name });
		},
		toGoodsDetail: function toGoodsDetail(goodsCode) {
			this.$router.push({ name: 'goodsdetail', params: { goodsCode: goodsCode } });
		},
		prePage: function prePage() {
			if (this.currentPage > 1) {
				this.currentPage = this.currentPage - 1;
				this.getShopList();
			}
		},
		nextPage: function nextPage() {
			if (this.currentPage < this.totalPage) {
				this.currentPage = this.currentPage + 1;
				this.getShopList();
			}
		},
		queryByPage: function queryByPage(page) {
			this.currentPage = page;
			this.getShopList();
		},
		findGoods: function findGoods() {
			this.$router.push({ name: 'goodsList', query: { sortParam: this.sortParam } });
		},
		findShops: function findShops() {
			this.getRelativeShopList();
			this.getShopList();
		},
		goodsCateShow: function goodsCateShow() {
			$(".categorys-dropdown").show();
		},
		goodsCateHidden: function goodsCateHidden() {
			$(".categorys-dropdown").hide();
		},
		goShop: function goShop(shopCode) {
			this.$router.push({ name: 'shop_index', query: { shopCode: shopCode } });
		},
		getRelativeShopList: function getRelativeShopList() {
			var that = this;
			var shopType = "";
			var shopName = encodeURI(that.sortParam);
			var currentPage = 1;
			var pageSize = 6;
			__WEBPACK_IMPORTED_MODULE_2__static_api_api_js__["a" /* default */].getShopList(shopName, currentPage, shopType, pageSize, function (ret) {
				if (ret.code == "success") {
					var shopList = ret.data.shopList;
					if (shopList != undefined) {
						for (var i = 0; i < shopList.length; i++) {
							var shopStandarLogo = shopList[i].shopStandarLogo;
							shopStandarLogo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + shopStandarLogo;
							shopList[i].shopStandarLogo = shopStandarLogo;
						}
						that.relativeShopList = shopList;
					}
				}
			});
		},
		getShopList: function getShopList() {
			var that = this;
			var shopType = "";
			var shopName = encodeURI(that.sortParam);
			var currentPage = that.currentPage;
			var pageSize = 9;
			__WEBPACK_IMPORTED_MODULE_2__static_api_api_js__["a" /* default */].getShopList(shopName, currentPage, shopType, pageSize, function (ret) {
				if (ret.code == "success") {
					var shopList = ret.data.shopList;
					if (shopList != undefined) {
						for (var i = 0; i < shopList.length; i++) {
							var shopStandarLogo = shopList[i].shopStandarLogo;
							shopStandarLogo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + shopStandarLogo;
							shopList[i].shopStandarLogo = shopStandarLogo;
						}
						that.shopList = shopList;
					}
					that.totalItem = ret.data.totalItem;
					var totalPage = ret.data.totalPage;
					var pageList = new Array();
					if (totalPage != undefined && totalPage != 0) {
						for (var i = 1; i <= totalPage; i++) {
							pageList.push(i);
						}
						that.totalPage = totalPage;
					} else {
						pageList.push(1);
					}
					that.pageList = pageList;
				}
			});
		},
		getShoppingCartNum: function getShoppingCartNum(shopCode) {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_2__static_api_api_js__["a" /* default */].getShoppingCartNum(function (ret) {
				if (ret.code == "success") {
					that.shoppingCartNum = ret.data.shoppingCartNum;
				}
			});
		},
		getShoppingCartList: function getShoppingCartList() {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_2__static_api_api_js__["a" /* default */].getShoppingCartList(function (ret) {
				if (ret.code == "success") {
					that.boList = ret.data.boList;
					var totalCount = 0;
					var bos = new Array();
					bos = ret.data.boList;
					var money = 0;
					for (var i = 0; i < bos.length; i++) {
						var imgSmall = bos[i].imgSmall;
						if (imgSmall.indexOf(";") != -1) {
							imgSmall = imgSmall.split(";")[0];
						}
						bos[i].imgSmall = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + imgSmall;
						money = money + bos[i].goodsPrice * bos[i].goodsNumber;
						totalCount = totalCount + bos[i].goodsNumber;
					}
					that.sumMoney = money;
					that.count = totalCount;
				}
			});
		},
		deleteGoods: function deleteGoods(goodsCode) {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_2__static_api_api_js__["a" /* default */].deleteGoods(goodsCode, function (ret) {
				if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__["n" /* parseResult */])(ret, null, false)) {
					__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#" + goodsCode + "_cart_pro").remove();
				}
			});
		},
		goIndex: function goIndex() {
			this.$router.push({ name: 'index' });
		},
		getMoreCatGoods: function getMoreCatGoods(catCode, catNameCn) {
			this.$router.push({ name: 'goodsList', query: { firstCatCode: catCode, catNameCn: catNameCn } });
		},
		getCatGoods: function getCatGoods(catCode, catNameCn) {
			this.$router.push({ name: 'goodsList', query: { catCode: catCode, catNameCn: catNameCn } });
		}
	}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "goodsCateShow", function goodsCateShow() {
		__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".sc-submenu").show();
	}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "goodsCateHidden", function goodsCateHidden() {
		__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".sc-submenu").hide();
	}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "childCateShow", function childCateShow(catCode) {
		__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#" + catCode + "_child").show();
	}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "childCateHide", function childCateHide(catCode) {
		__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#" + catCode + "_child").hide();
	}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "getCat", function getCat() {
		var that = this;
		__WEBPACK_IMPORTED_MODULE_2__static_api_api_js__["a" /* default */].getAllCat('', function (ret) {
			if (ret.code == "success") {
				that.catList = ret.data.firstCatList;
			}
		});
	}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "resetCond", function resetCond() {
		this.interval = "intervalAll";
		this.catCode = "categoryAll";
		this.sortTime = "timeAll";
		this.firstCatCode = "";
		this.orderBy = "";
		this.orderAsc = "";
		__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#choosedCond").html("");
	}), _methods),
	ready: function ready() {},
	mounted: function mounted() {
		window.scrollTo(0, 0);
		var account = localStorage.getItem("account");
		if (account != undefined && account != "") {
			this.isLogin = true;
			this.account = account;
		}
		var sortParam = this.$route.query.sortParam;
		var firstCatCode = this.$route.query.firstCatCode;
		var catCode = this.$route.query.catCode;
		if (sortParam != undefined) {
			this.sortParam = sortParam;
		}
		if (firstCatCode != undefined) {
			this.firstCatCode = firstCatCode;
		}
		if (catCode != undefined) {
			this.catCode = catCode;
		}
		this.indexUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__["o" /* getIndexUrl */])();
		this.getCat();
		this.getRelativeShopList();
		this.getShopList();
		this.getShoppingCartNum();
		this.getShoppingCartList();
		this.getOrderCount();
	}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "1VKG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head-nav clear-l"
  }, [_c('div', {
    staticClass: "div"
  }, [_c('div', {
    staticClass: "w1200 bc"
  }, [_c('ul', {
    staticClass: "nav fl"
  }, [_c('li', [_c('a', {
    class: {
      "active": _vm.activeLi === "purchaser"
    },
    attrs: {
      "href": _vm.purchaserUrl
    }
  }, [_vm._v("采购商服务")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      "active": _vm.activeLi === "mallIndex"
    },
    on: {
      "click": function($event) {
        _vm.goIndex()
      }
    }
  }, [_vm._v("商城首页")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      "active": _vm.activeLi === "brand"
    },
    attrs: {
      "href": _vm.brandUrl
    }
  }, [_vm._v("品牌导航")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      "active": _vm.activeLi === "sample"
    },
    on: {
      "click": function($event) {
        _vm.goSample()
      }
    }
  }, [_vm._v("样品中心")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      "active": _vm.activeLi === "requirement"
    },
    attrs: {
      "href": _vm.requirementUrl
    }
  }, [_vm._v("需求中心")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      "active": _vm.activeLi === "tradingHall"
    },
    attrs: {
      "href": _vm.tradingHallUrl
    }
  }, [_vm._v("交易大厅")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      "active": _vm.activeLi === "meterial"
    },
    on: {
      "click": function($event) {
        _vm.goMeterial()
      }
    }
  }, [_vm._v("原材料")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      "active": _vm.activeLi === "news"
    },
    attrs: {
      "href": _vm.newsUrl
    }
  }, [_vm._v("新闻百科")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      "active": _vm.activeLi === "exhibition"
    },
    attrs: {
      "href": _vm.exhibitionUrl
    }
  }, [_vm._v("展会")])])]), _vm._v(" "), (_vm.firstCatShow) ? _c('div', {
    staticClass: "mall-categorys"
  }, [_c('div', {
    staticClass: "sc-submenu"
  }, [_c('ul', [_vm._m(0), _vm._v(" "), _vm._l((_vm.catList), function(cat, index) {
    return _c('li', {
      class: 'li-' + (index + 1),
      on: {
        "mouseleave": function($event) {
          _vm.childCateHide()
        },
        "mouseenter": function($event) {
          _vm.childCateShow(index)
        }
      }
    }, [_c('div', {
      staticClass: "yj"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.getMore(cat.catCode, cat.catNameCn)
        }
      }
    }, [_vm._v(_vm._s(cat.catNameCn))])]), _vm._v(" "), _c('div', {
      staticClass: "sc-submenu-all",
      class: {
        "none": _vm.currIndex != index
      },
      style: ('top:' + index * (-45) + 'px'),
      on: {
        "mouseleave": function($event) {
          _vm.childCateHide()
        }
      }
    }, [_c('dl', [_c('dt', [_vm._v(_vm._s(cat.catNameCn))]), _vm._v(" "), _c('dd', [_vm._l((cat.catBoList), function(childCat) {
      return _c('a', {
        on: {
          "click": function($event) {
            _vm.getCatGoods(childCat.catCode, childCat.catNameCn)
          }
        }
      }, [_vm._v(_vm._s(childCat.catNameCn))])
    }), _vm._v(" "), _c('a', {
      on: {
        "click": function($event) {
          _vm.getMore(cat.catCode, cat.catNameCn)
        }
      }
    }, [_vm._v("更多")])], 2)])])])
  })], 2)])]) : _vm._e()])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "category-head"
  }, [_vm._v("箱包分类\n            \t\t\t"), _c('div', {
    staticClass: "category-head-border"
  })])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1pAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__("ORbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_api_api_js__ = __webpack_require__("fXcb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_md5__ = __webpack_require__("NC6I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_js_md5__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*引入Vue框架*/

/*引入资源请求插件*/

/*使用VueResource插件*/
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);
//import jQuery from "../../../static/js/jquery.min.js"



//	import md5 from "../../../static/js/md5.min.js";
/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'login',
	data: function data() {
		return {
			changeTag: "tagPwdContent",
			isPwdActive: true,
			isMobileActive: false,
			backUrl: 'index'
		};
	},

	components: {},
	methods: {
		changeTagFun: function changeTagFun(id) {
			var flag = "tagPwdContent";
			if (id == "tagMobile") {
				flag = "tagMobileContent";
				this.isPwdActive = false;
				this.isMobileActive = true;
			} else {
				this.isPwdActive = true;
				this.isMobileActive = false;
			}
			this.changeTag = flag;
		},
		login: function login() {
			var that = this;
			var account = __WEBPACK_IMPORTED_MODULE_2_jquery___default()("#account").val();
			var password = __WEBPACK_IMPORTED_MODULE_2_jquery___default()("#password").val();
			if (account == "") {
				alert('请输入账号');
				return false;
			}
			if (password == "") {
				alert('请输入密码');
				return false;
			}
			var pwd_md5 = __WEBPACK_IMPORTED_MODULE_4_js_md5___default()(password);
			__WEBPACK_IMPORTED_MODULE_3__static_api_api_js__["a" /* default */].login(account, pwd_md5, function (ret) {
				if (ret.optStatus != undefined && ret.optStatus) {
					localStorage.setItem('mobile', ret.mobile);
					that.$router.push({ name: 'index' });
				}
			});
		},

		mobileLogin: function mobileLogin() {
			var that = this;
			var mobile = __WEBPACK_IMPORTED_MODULE_2_jquery___default()("#mobile").val();
			var checkCode = __WEBPACK_IMPORTED_MODULE_2_jquery___default()("#checkCode").val();
			if (mobile == "") {
				alert('请输入手机号');
				return false;
			}
			if (checkCode == "") {
				alert('请输入验证码');
				return false;
			}
			__WEBPACK_IMPORTED_MODULE_3__static_api_api_js__["a" /* default */].mobileLogin(mobile, checkCode, function (ret) {
				if (ret.code == 'success') {
					localStorage.setItem('mobile', mobile);
					that.$router.push({ name: 'index' });
				} else {
					alert(ret.msg);
				}
			});
		},

		sendCode: function sendCode() {
			var that = this;
			var buttonView = __WEBPACK_IMPORTED_MODULE_2_jquery___default()("#buttonView");
			if (that.leftTime > 0) {
				alert('请在' + that.leftTime + '秒后再次获取');
				return false;
			}
			var mobile = __WEBPACK_IMPORTED_MODULE_2_jquery___default()("#mobile").val();
			if (mobile == "") {
				alert('请输入手机号');
				return false;
			}
			buttonView.attr("disabled", true);
			that.leftTime = 60;
			var result_id = setInterval(this.countDown, 1000, buttonView);
			__WEBPACK_IMPORTED_MODULE_3__static_api_api_js__["a" /* default */].sendCode(mobile, function (ret) {
				if (ret.code == "success") {
					//confirm('短信发送成功', '提示', ['确定'], function(e) {});
				} else {
					alert(ret.msg);
					clearInterval(result_id);
					that.leftTime = '0';
					buttonView.attr("disabled", false);
				}
			});
		},

		countDown: function countDown(obj) {
			if (this.leftTime > 0) {
				this.leftTime = this.leftTime - 1;
				obj.text("剩余" + this.leftTime + "秒");
			} else {
				obj.attr("disabled", false);
				obj.text("获取验证码");
			}
		}
	},
	mounted: function mounted() {}
});

/***/ }),

/***/ "24m4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sampleDetail_vue__ = __webpack_require__("AENg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f68eb258_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_sampleDetail_vue__ = __webpack_require__("3ciW");
function injectStyle (ssrContext) {
  __webpack_require__("5+tB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sampleDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f68eb258_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_sampleDetail_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3LwO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterCopyright_vue__ = __webpack_require__("Ecbd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0307353a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_FooterCopyright_vue__ = __webpack_require__("lo3H");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterCopyright_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0307353a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_FooterCopyright_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3ciW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "indexbg"
  }, [_c('topbar'), _vm._v(" "), _c('emallheader', {
    ref: "c1"
  }), _vm._v(" "), _c('headernav', {
    ref: "navComp",
    attrs: {
      "activeLi": "mallIndex"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clear mt15"
  }), _vm._v(" "), _c('div', {
    staticClass: "w1200 bc"
  }, [_c('div', {
    staticClass: "hq-crumb-wrap"
  }, [_c('ul', [_vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "item sep"
  }, [_vm._v(">")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.getGoodList(_vm.catCode, _vm.goodsCatNameCn)
      }
    }
  }, [_vm._v(_vm._s(_vm.goodsCatNameCn))])]), _vm._v(" "), _c('li', {
    staticClass: "item sep"
  }, [_vm._v(">")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.getGoodDetails(_vm.goodsCode)
      }
    }
  }, [_vm._v(_vm._s(_vm.goodsDetail.goodsName))])])])]), _vm._v(" "), _c('div', {
    staticClass: "db-goods-show"
  }, [_c('div', {
    staticClass: "goodspic"
  }, [_c('div', {
    staticClass: "spec-preview",
    attrs: {
      "id": "preview"
    }
  }, [_c('span', {
    staticClass: "jqzoom"
  }, [_c('img', {
    attrs: {
      "jqimg": _vm.goodsImgLarge,
      "src": _vm.goodsImgLarge,
      "width": "430px",
      "height": "430px"
    }
  })]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "spec-scroll"
  }, [_c('a', {
    staticClass: "prev",
    attrs: {
      "title": "上一张"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "next",
    attrs: {
      "title": "下一张"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "items"
  }, [_c('ul', _vm._l((_vm.goodsImgs), function(gI, index) {
    return _c('li', [_c('img', {
      attrs: {
        "alt": "",
        "bimg": gI,
        "src": gI
      },
      on: {
        "click": function($event) {
          _vm.choosePic(index)
        }
      }
    })])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "dt-m"
  }, [_c('div', {
    staticClass: "sp-title"
  }, [_c('h3', [_vm._v(" " + _vm._s(_vm.goodsName))])]), _vm._v(" "), (_vm.seckillPrice != '' && _vm.seckillPrice > 0) ? _c('div', {
    staticClass: "shop-miaosha"
  }, [_c('img', {
    staticClass: "miaosha-img",
    attrs: {
      "src": __webpack_require__("Ec7t"),
      "alt": ""
    }
  }), _vm._v(" 秒杀\n\t\t\t\t\t\t"), _vm._v(" "), (_vm.activityEndTime > 0) ? _c('span', {
    staticClass: "miaosha-time"
  }, [_vm._v("\n                \t\t\t\t距离结束"), _c('i', [_vm._v(_vm._s(_vm.hour))]), _vm._v(":"), _c('i', [_vm._v(_vm._s(_vm.minute))]), _vm._v(":"), _c('i', [_vm._v(_vm._s(_vm.second))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.seckillPrice == '' && _vm.nextBeginTime != '') ? _c('div', {
    staticClass: "shop-miaosha"
  }, [_c('img', {
    staticClass: "miaosha-img",
    attrs: {
      "src": __webpack_require__("Ec7t"),
      "alt": ""
    }
  }), _vm._v(" 秒杀预告\n\t\t\t\t\t\t"), _vm._v(" "), (_vm.nextBeginTime != '') ? _c('span', {
    staticClass: "miaosha-time"
  }, [_vm._v("\n                \t\t\t\t预计" + _vm._s(_vm.nextBeginTime.substr(0, 4)) + "年" + _vm._s(_vm.nextBeginTime.substr(4, 2)) + "月" + _vm._s(_vm.nextBeginTime.substr(6, 2)) + "日" + _vm._s(_vm.nextBeginTime.substr(8, 2)) + ":" + _vm._s(_vm.nextBeginTime.substr(10, 2)) + "开始\n                \t\t\t")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "goods_b active"
  }, [_vm._v("加工订购")]), _vm._v(" "), _c('dl', {
    staticClass: "sp-meta",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [(_vm.goodsDetail.orderQuantity != undefined && _vm.goodsDetail.orderQuantity > 0) ? _c('div', [_c('dt', [_vm._v("起订：")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.goodsDetail.orderQuantity) + "件")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.skuList), function(skuAttr, index_n) {
    return _c('div', [(skuAttr.skuName != null && skuAttr.skuName != '') ? _c('dt', [_vm._v(_vm._s(skuAttr.skuName) + "：")]) : _vm._e(), _vm._v(" "), (skuAttr.skuValue != null && skuAttr.skuValue != '') ? _c('dd', _vm._l((skuAttr.skuValue.split(',')), function(specItem, index) {
      return (specItem != null && specItem != '' && _vm.existsSku(specItem, index_n)) ? _c('a', {
        staticClass: "td-txt",
        class: {
          selected: specItem == _vm.skuList[index_n].skuChoosed
        },
        on: {
          "click": function($event) {
            specItem != _vm.skuList[index_n].skuChoosed && _vm.chooseSpec(specItem, index_n)
          }
        }
      }, [_vm._v(_vm._s(specItem))]) : _vm._e()
    })) : _vm._e()])
  }), _vm._v(" "), _c('div', [_c('dt', [_vm._v("原始价格：")]), _vm._v(" "), (_vm.chooseGoodsPrice != '') ? _c('dd', {
    staticStyle: {
      "color": "#EF920D"
    }
  }, [_vm._v(_vm._s(_vm.goodsPrice) + "元")]) : _vm._e(), _vm._v(" "), (_vm.minPrice > 0 && _vm.chooseGoodsPrice == '') ? _c('dd', {
    staticStyle: {
      "color": "#EF920D"
    }
  }, [_vm._v(_vm._s(_vm.minPrice) + "元"), (_vm.maxPrice > _vm.minPrice) ? _c('span', [_vm._v("  - " + _vm._s(_vm.maxPrice) + "元")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', [_c('dt', [_vm._v("生产数量：")]), _vm._v(" "), _c('dd', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.produceNum),
      expression: "produceNum"
    }],
    staticClass: "inpt",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.produceNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.produceNum = $event.target.value
      }
    }
  }), _vm._v("  个")])]), _vm._v(" "), _c('div', [_c('dt', [_vm._v("品质服务")]), _vm._v(" "), _c('dd', _vm._l((_vm.qualitys), function(qua, index) {
    return (qua.dictValue != '') ? _c('a', {
      staticClass: "td-txt",
      class: {
        selected: _vm.quality == qua.dictValue
      },
      on: {
        "click": function($event) {
          _vm.chooseQuality(qua.dictValue)
        }
      }
    }, [_vm._v(_vm._s(qua.dictText))]) : _vm._e()
  }))]), _vm._v(" "), _c('div', [_c('dt', [_vm._v("验货方式")]), _vm._v(" "), _c('dd', _vm._l((_vm.inspectionTypes), function(ins, index) {
    return (ins.dictValue != '') ? _c('a', {
      staticClass: "td-txt",
      class: {
        selected: _vm.inspectionType == ins.dictValue
      },
      on: {
        "click": function($event) {
          _vm.chooseInspection(ins.dictValue)
        }
      }
    }, [_vm._v(_vm._s(ins.dictText))]) : _vm._e()
  }))]), _vm._v(" "), (_vm.isLogin && (_vm.expressMode == 'weight' || _vm.expressMode == 'counter')) ? _c('dt', [_vm._v("配送至：")]) : _vm._e(), _vm._v(" "), (_vm.isLogin && (_vm.expressMode == 'weight' || _vm.expressMode == 'counter')) ? _c('dd', [_c('span', [_vm._v("配送至：")]), _vm._v(" "), _c('select', {
    staticClass: "city_select_css",
    attrs: {
      "id": "expressChage"
    },
    on: {
      "input": function($event) {
        _vm.expressChage()
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "北京市"
    }
  }, [_vm._v("北京")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "天津市"
    }
  }, [_vm._v("天津")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "河北省"
    }
  }, [_vm._v("河北")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "山西省"
    }
  }, [_vm._v("山西")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "内蒙古自治区"
    }
  }, [_vm._v("内蒙古")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "辽宁省"
    }
  }, [_vm._v("辽宁")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "吉林省"
    }
  }, [_vm._v("吉林")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "黑龙江省"
    }
  }, [_vm._v("黑龙江")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "上海市"
    }
  }, [_vm._v("上海")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "江苏省"
    }
  }, [_vm._v("江苏")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "浙江省"
    }
  }, [_vm._v("浙江")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "安徽省"
    }
  }, [_vm._v("安徽")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "福建省"
    }
  }, [_vm._v("福建")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "江西省"
    }
  }, [_vm._v("江西")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "山东省"
    }
  }, [_vm._v("山东")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "河南省"
    }
  }, [_vm._v("河南")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "湖北省"
    }
  }, [_vm._v("湖北")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "湖南省"
    }
  }, [_vm._v("湖南")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "广东省"
    }
  }, [_vm._v("广东")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "广西壮族自治区"
    }
  }, [_vm._v("广西")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "海南省"
    }
  }, [_vm._v("海南")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "重庆省"
    }
  }, [_vm._v("重庆")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "四川省"
    }
  }, [_vm._v("四川")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "贵州省"
    }
  }, [_vm._v("贵州")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "云南省"
    }
  }, [_vm._v("云南")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "西藏自治区"
    }
  }, [_vm._v("西藏")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "陕西省"
    }
  }, [_vm._v("陕西")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "甘肃省"
    }
  }, [_vm._v("甘肃")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "青海省"
    }
  }, [_vm._v("青海")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "宁夏回族自治区"
    }
  }, [_vm._v("宁夏")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "新疆维吾尔族自治区"
    }
  }, [_vm._v("新疆")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "香港特别行政区"
    }
  }, [_vm._v("香港")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "澳门特别行政区"
    }
  }, [_vm._v("澳门")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "台湾省"
    }
  }, [_vm._v("台湾")])])]) : _vm._e(), _vm._v(" "), _c('table', [_c('tr', [_c('td', [(_vm.goodsDetail.laserService > 0) ? _c('dt', [_vm._v("激光服务:")]) : _vm._e()]), _vm._v(" "), (_vm.goodsDetail.laserService > 0) ? _c('td', [_c('a', {
    staticClass: "td-txt",
    class: {
      selected: _vm.laserService != ''
    },
    on: {
      "click": function($event) {
        _vm.chooseLaster(_vm.goodsDetail.laserService)
      }
    }
  }, [_vm._v("激光")]), _vm._v(_vm._s(_vm.goodsDetail.laserService / 100) + "元/件\n\t\t\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', [(_vm.goodsDetail.printingService > 0) ? _c('dt', [_vm._v("印花服务:")]) : _vm._e()]), _vm._v(" "), (_vm.goodsDetail.printingService > 0) ? _c('td', [_c('a', {
    staticClass: "td-txt",
    class: {
      selected: _vm.printingService != ''
    },
    on: {
      "click": function($event) {
        _vm.choosePrinting(_vm.goodsDetail.printingService)
      }
    }
  }, [_vm._v("印花")]), _vm._v(_vm._s(_vm.goodsDetail.printingService / 100) + "元/件\n\t\t\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', [(_vm.goodsDetail.rebrandingService > 0) ? _c('dt', [_vm._v("换标服务:")]) : _vm._e()]), _vm._v(" "), (_vm.goodsDetail.rebrandingService > 0) ? _c('td', [_c('a', {
    staticClass: "td-txt",
    class: {
      selected: _vm.rebrandingService != ''
    },
    on: {
      "click": function($event) {
        _vm.chooseRebranding(_vm.goodsDetail.rebrandingService)
      }
    }
  }, [_vm._v("换标")]), _vm._v(_vm._s(_vm.goodsDetail.rebrandingService / 100) + "元/件\n\t\t\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('tr', [_vm._m(2), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "td-txt",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.change_input()
      }
    }
  }, [_vm._v("选择")]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "addTextForm"
    },
    on: {
      "change": function($event) {
        _vm.setImg($event)
      }
    }
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "0",
      "type": "file",
      "name": "style_picture"
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "1",
      "type": "file",
      "name": "style_picture"
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "2",
      "type": "file",
      "name": "style_picture"
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "3",
      "type": "file",
      "name": "style_picture"
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "4",
      "type": "file",
      "name": "style_picture"
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "img-wrapper"
    },
    on: {
      "click": function($event) {
        _vm.deleteImg($event)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "48%",
      "display": "none",
      "max-height": "200px"
    },
    attrs: {
      "src": "",
      "id": "img_0"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-width": "48%",
      "display": "none",
      "max-height": "200px"
    },
    attrs: {
      "src": "",
      "id": "img_1"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-width": "48%",
      "display": "none",
      "max-height": "200px"
    },
    attrs: {
      "src": "",
      "id": "img_2"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-width": "48%",
      "display": "none",
      "max-height": "200px"
    },
    attrs: {
      "src": "",
      "id": "img_3"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-width": "48%",
      "display": "none",
      "max-height": "200px"
    },
    attrs: {
      "src": "",
      "id": "img_4"
    }
  })])])]), _vm._v(" "), _c('tr', [_vm._m(3), _vm._v(" "), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remark),
      expression: "remark"
    }],
    attrs: {
      "rows": "5",
      "cols": "70"
    },
    domProps: {
      "value": (_vm.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.remark = $event.target.value
      }
    }
  })])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "sp-action"
  }, [_c('a', {
    class: {
      'delisting-bccolor': _vm.goodsBo.shopGoodsStatus === 'delisting', 'sp-link-buy': _vm.goodsBo.shopGoodsStatus === 'listing'
    },
    on: {
      "click": function($event) {
        _vm.goodsBo.shopGoodsStatus == 'listing' && _vm.payOrder()
      }
    }
  }, [_vm._v(_vm._s(_vm.goodsBo.shopGoodsStatus == 'delisting' ? '已下架' : '采购下单'))])]), _vm._v(" "), _c('div', {
    staticClass: "sp-other"
  }, [_c('span', {
    staticClass: "mr40"
  }, [_c('i', {
    staticClass: "ico-sp-sc"
  }), _c('a', {
    staticClass: "co1",
    on: {
      "click": function($event) {
        !_vm.isPreview && _vm.addOrDeleteFavoriteGoods()
      }
    }
  }, [_vm._v(_vm._s(_vm.isExistFavoriteGoods == 0 ? '收藏' : '已收藏'))])]), _vm._v(" "), (_vm.goodsBo.seven_day_return == 'Y') ? _c('span', {
    staticClass: "co1"
  }, [_c('i', {
    staticClass: "ico-sp-tk"
  }), _vm._v("支持7天无理由退货服务")]) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "post_btmshare"
  }, [_c('span', {
    staticClass: "post_topshare_title"
  }, [_vm._v("分享到：")]), _vm._v(" "), _c('ul', {
    staticClass: "post_share"
  }, [_c('li', {
    staticClass: "share_weixin js_weixin",
    attrs: {
      "data-type": "btm"
    },
    on: {
      "click": function($event) {
        _vm.easyShare('weixin')
      }
    }
  }, [_vm._m(4)]), _vm._v(" "), _c('li', {
    staticClass: "share_qzone js_share",
    attrs: {
      "data-type": "qzone"
    },
    on: {
      "click": function($event) {
        _vm.easyShare('qzone')
      }
    }
  }, [_vm._m(5)]), _vm._v(" "), _c('li', {
    staticClass: "share_weibo js_share",
    attrs: {
      "data-type": "weibo"
    },
    on: {
      "click": function($event) {
        _vm.easyShare('weibo')
      }
    }
  }, [_vm._m(6)])]), _vm._v(" "), _c('div', {
    staticClass: "js_qrcode_wrap",
    attrs: {
      "id": "js_qrcode_top"
    }
  }, [_c('div', {
    staticClass: "js_qrcode_arr"
  }), _vm._v(" "), _c('a', {
    staticClass: "js_qrcode_close",
    attrs: {
      "target": "_self",
      "data-type": "top",
      "title": "关闭"
    },
    on: {
      "click": _vm.closeqrcode
    }
  }), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('p', [_vm._v("用微信扫码二维码")]), _vm._v(" "), _c('p', [_vm._v("分享至好友和朋友圈")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    staticClass: "sp-side-wrap mt20"
  }, [_c('div', {
    staticClass: "hd"
  }, [_c('a', {
    staticClass: "refresh fr",
    on: {
      "click": function($event) {
        !_vm.isPreview && _vm.refreshGoods()
      }
    }
  }), _vm._v(" "), _c('h3', [_vm._v("猜你喜欢")])]), _vm._v(" "), _c('ul', _vm._l((_vm.recommendGoodsList), function(goodBo) {
    return _c('li', [_c('a', {
      staticClass: "fl pic",
      on: {
        "click": function($event) {
          _vm.goDetail(goodBo.goodsCode)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": goodBo.imgMiddle,
        "width": "106",
        "height": "106"
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "title"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.goDetail(goodBo.goodsCode)
        }
      }
    }, [_vm._v(_vm._s(goodBo.goodsName))])]), _vm._v(" "), _c('p', {
      staticClass: "price co2"
    }, [_vm._v("￥" + _vm._s((goodBo.unitPrice / 100).toFixed(2)))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "sp-dt-tab"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "bd"
  }, [_c('ul', {
    staticClass: "details-sp-cs"
  }, [_c('li', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("商品名称：" + _vm._s(_vm.goodsName))]), _vm._v(" "), (_vm.goodsDetail.brandName != null && _vm.goodsDetail.brandName != '') ? _c('li', [_vm._v("品牌： " + _vm._s(_vm.goodsDetail.brandName))]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v("商品编码：" + _vm._s(_vm.goodsCode))])]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.goodsDetail.goodsVideo) ? _c('div', {
    staticStyle: {
      "height": "20rem"
    }
  }, [_c('video', {
    staticStyle: {
      "height": "20rem",
      "margin-left": "5.5rem"
    },
    attrs: {
      "controls": "controls",
      "width": "80%"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.imgPath + _vm.goodsDetail.goodsVideo
    }
  }), _vm._v(" Your browser does not support the video tag.\n\t\t\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "img-list",
    domProps: {
      "innerHTML": _vm._s(_vm.goodsDesc)
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.goodsDesc) + "\n\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "bd none"
  }, [_c('h4', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "ico-l"
  }), _vm._v("商品评价\n       \t  \t"), (_vm.goodRate != null) ? _c('div', {
    staticClass: "haopin"
  }, [_vm._v("好评率"), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.goodRate))]), _vm._v("%")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, _vm._l((_vm.creditList), function(credit, creditIdx) {
    return _c('div', {
      staticClass: "details-sp-pinjia"
    }, [_c('div', {
      staticClass: "details-sp-pinjia-col-1"
    }, [_c('p', {
      staticClass: "pinjia-ms"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t描述相符度："), _c('span', {
      class: 'sp-pj-star star' + credit.creditPoint
    }), _vm._v(" 发货速度：\n\t\t\t\t\t\t\t\t\t"), _c('span', {
      class: 'sp-pj-star star' + credit.speedPoint
    }), _vm._v(" 服务态度：\n\t\t\t\t\t\t\t\t\t"), _c('span', {
      class: 'sp-pj-star star' + credit.attitudePoint
    })]), _vm._v(" "), _c('p', {
      staticClass: "pinjia-con"
    }, [_vm._v(_vm._s(credit.content))]), _vm._v(" "), (credit.creditImgs != undefined && credit.creditImgs.length > 0) ? _c('div', {
      staticClass: "pinjia-img"
    }, _vm._l((credit.creditImgs), function(gI, imgIdx) {
      return _c('img', {
        attrs: {
          "alt": "",
          "bimg": gI,
          "src": gI,
          "width": "48",
          "height": "48"
        },
        on: {
          "click": function($event) {
            _vm.showImg(creditIdx, gI)
          }
        }
      })
    })) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "pinjia_scale_img",
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": creditIdx + '_div'
      }
    }, [_c('img', {
      attrs: {
        "id": creditIdx
      },
      on: {
        "click": function($event) {
          _vm.hideImg(creditIdx)
        }
      }
    })])]), _vm._v(" "), (credit.ext2 != undefined && credit.ext2 != '') ? _c('div', {
      staticClass: "details-sp-pinjia-col-1"
    }, [_c('p', {
      staticClass: "pinjia-con"
    }, [_c('span', {
      staticStyle: {
        "color": "#999"
      }
    }, [_vm._v("[追加评论]")]), _c('br'), _vm._v(_vm._s(credit.ext2))]), _vm._v(" "), (credit.appendImgs != undefined && credit.appendImgs.length > 0) ? _c('div', {
      staticClass: "pinjia-img"
    }, _vm._l((credit.appendImgs), function(gI_append, imgIdx) {
      return _c('img', {
        attrs: {
          "alt": "",
          "bimg": gI_append,
          "src": gI_append,
          "width": "48",
          "height": "48"
        },
        on: {
          "click": function($event) {
            _vm.showAppendImg(creditIdx, gI_append)
          }
        }
      })
    })) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "pinjia_scale_img",
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": creditIdx + '_append_div'
      }
    }, [_c('img', {
      attrs: {
        "id": creditIdx + '_append'
      },
      on: {
        "click": function($event) {
          _vm.hideAppendImg(creditIdx)
        }
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "details-sp-pinjia-col-2"
    }, [_c('p', {
      staticClass: "pj-user"
    }, [_c('span', [_vm._v("评价人：")]), _vm._v(" " + _vm._s(credit.buyerName) + "（匿名）")]), _vm._v(" "), _c('p', {
      staticClass: "pj-time"
    }, [_vm._v(_vm._s(credit.dataStr) + " ")])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "top",
    on: {
      "click": function($event) {
        _vm.scrollToTop()
      }
    }
  }, [_vm._m(10)])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('footermenu'), _vm._v(" "), _c('footercopyright')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "item"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("首页")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jqzoom-ico"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": __webpack_require__("9adc"),
      "width": "26",
      "height": "26"
    }
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('dt', [_vm._v("上传图片")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('dt', [_vm._v("加工说明")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "target": "_self"
    }
  }, [_c('i', {
    attrs: {
      "title": "分享到微信"
    }
  }), _c('span'), _vm._v("微信")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "target": "_self"
    }
  }, [_c('i', {
    attrs: {
      "title": "分享到QQ空间"
    }
  }), _c('span'), _vm._v("QQ空间")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "target": "_self"
    }
  }, [_c('i', {
    attrs: {
      "title": "分享到新浪微博"
    }
  }), _c('span'), _vm._v("微博")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "js_qrcode_img js_share_qrcode",
    attrs: {
      "title": ""
    }
  }, [_c('canvas', {
    attrs: {
      "id": "canvas",
      "width": "120",
      "height": "120"
    }
  }), _c('img', {
    attrs: {
      "src": ""
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hd"
  }, [_c('ul', [_c('li', {
    staticClass: "hover"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("商品描述")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("商品评价")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "ico-l"
  }), _vm._v("产品详情")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('span', [_vm._v("TOP")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3w6z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmallHeader_vue__ = __webpack_require__("6flv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a5ac146_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EmallHeader_vue__ = __webpack_require__("Gias");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmallHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a5ac146_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EmallHeader_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4RNh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__("C4MV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);





!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(exports)) && "object" == ( false ? "undefined" : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(module)) ? module.exports = e() : "function" == typeof define && __webpack_require__("nErl") ? define("vue-easy-slider", [], e) : "object" == (typeof exports === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(exports)) ? exports["vue-easy-slider"] = e() : t["vue-easy-slider"] = e();
}(this, function () {
  return function (t) {
    function e(i) {
      if (n[i]) return n[i].exports;var o = n[i] = { exports: {}, id: i, loaded: !1 };return t[i].call(o.exports, o, o.exports, e), o.loaded = !0, o.exports;
    }var n = {};return e.m = t, e.c = n, e.p = "", e(0);
  }([function (t, e, n) {
    "use strict";
    function i(t) {
      return t && t.__esModule ? t : { "default": t };
    }Object.defineProperty(e, "__esModule", { value: !0 }), e.SliderItem = e.Slider = void 0;var o = n(37),
        r = i(o),
        s = n(43),
        a = i(s);e.Slider = r["default"], e.SliderItem = a["default"];
  },,,, function (t, e) {
    t.exports = function () {
      var t = [];return t.toString = function () {
        for (var t = [], e = 0; e < this.length; e++) {
          var n = this[e];n[2] ? t.push("@media " + n[2] + "{" + n[1] + "}") : t.push(n[1]);
        }return t.join("");
      }, t.i = function (e, n) {
        "string" == typeof e && (e = [[null, e, ""]]);for (var i = {}, o = 0; o < this.length; o++) {
          var r = this[o][0];"number" == typeof r && (i[r] = !0);
        }for (o = 0; o < e.length; o++) {
          var s = e[o];"number" == typeof s[0] && i[s[0]] || (n && !s[2] ? s[2] = n : n && (s[2] = "(" + s[2] + ") and (" + n + ")"), t.push(s));
        }
      }, t;
    };
  }, function (t, e, n) {
    function i(t) {
      for (var e = 0; e < t.length; e++) {
        var n = t[e],
            i = h[n.id];if (i) {
          i.refs++;for (var o = 0; o < i.parts.length; o++) {
            i.parts[o](n.parts[o]);
          }for (; o < n.parts.length; o++) {
            i.parts.push(r(n.parts[o]));
          }i.parts.length > n.parts.length && (i.parts.length = n.parts.length);
        } else {
          for (var s = [], o = 0; o < n.parts.length; o++) {
            s.push(r(n.parts[o]));
          }h[n.id] = { id: n.id, refs: 1, parts: s };
        }
      }
    }function o() {
      var t = document.createElement("style");return t.type = "text/css", l.appendChild(t), t;
    }function r(t) {
      var e,
          n,
          i = document.querySelector('style[data-vue-ssr-id~="' + t.id + '"]');if (i) {
        if (p) return m;i.parentNode.removeChild(i);
      }if (v) {
        var r = f++;i = d || (d = o()), e = s.bind(null, i, r, !1), n = s.bind(null, i, r, !0);
      } else i = o(), e = a.bind(null, i), n = function n() {
        i.parentNode.removeChild(i);
      };return e(t), function (i) {
        if (i) {
          if (i.css === t.css && i.media === t.media && i.sourceMap === t.sourceMap) return;e(t = i);
        } else n();
      };
    }function s(t, e, n, i) {
      var o = n ? "" : i.css;if (t.styleSheet) t.styleSheet.cssText = y(e, o);else {
        var r = document.createTextNode(o),
            s = t.childNodes;s[e] && t.removeChild(s[e]), s.length ? t.insertBefore(r, s[e]) : t.appendChild(r);
      }
    }function a(t, e) {
      var n = e.css,
          i = e.media,
          o = e.sourceMap;if (i && t.setAttribute("media", i), o && (n += "\n/*# sourceURL=" + o.sources[0] + " */", n += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(o)))) + " */"), t.styleSheet) t.styleSheet.cssText = n;else {
        for (; t.firstChild;) {
          t.removeChild(t.firstChild);
        }t.appendChild(document.createTextNode(n));
      }
    }var u = "undefined" != typeof document,
        c = n(6),
        h = {},
        l = u && (document.head || document.getElementsByTagName("head")[0]),
        d = null,
        f = 0,
        p = !1,
        m = function m() {},
        v = "undefined" != typeof navigator && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase());t.exports = function (t, e, n) {
      p = n;var o = c(t, e);return i(o), function (e) {
        for (var n = [], r = 0; r < o.length; r++) {
          var s = o[r],
              a = h[s.id];a.refs--, n.push(a);
        }e ? (o = c(t, e), i(o)) : o = [];for (var r = 0; r < n.length; r++) {
          var a = n[r];if (0 === a.refs) {
            for (var u = 0; u < a.parts.length; u++) {
              a.parts[u]();
            }delete h[a.id];
          }
        }
      };
    };var y = function () {
      var t = [];return function (e, n) {
        return t[e] = n, t.filter(Boolean).join("\n");
      };
    }();
  }, function (t, e) {
    t.exports = function (t, e) {
      for (var n = [], i = {}, o = 0; o < e.length; o++) {
        var r = e[o],
            s = r[0],
            a = r[1],
            u = r[2],
            c = r[3],
            h = { id: t + ":" + o, css: a, media: u, sourceMap: c };i[s] ? i[s].parts.push(h) : n.push(i[s] = { id: s, parts: [h] });
      }return n;
    };
  }, function (t, e) {
    t.exports = function (t, e, n, i) {
      var o,
          r = t = t || {},
          s = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(t["default"]);"object" !== s && "function" !== s || (o = t, r = t["default"]);var a = "function" == typeof r ? r.options : r;if (e && (a.render = e.render, a.staticRenderFns = e.staticRenderFns), n && (a._scopeId = n), i) {
        var u = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(a.computed || null);__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(i).forEach(function (t) {
          var e = i[t];u[t] = function () {
            return e;
          };
        }), a.computed = u;
      }return { esModule: o, exports: r, options: a };
    };
  },, function (t, e) {
    "use strict";
    function n(t, e, n) {
      var i,
          o = null;return function () {
        var r = this,
            s = arguments,
            a = +new Date();clearTimeout(o), i || (i = a), a - i >= n ? (t.apply(r, s), i = a) : o = setTimeout(function () {
          t.apply(r, s);
        }, e);
      };
    }function i(t, e) {
      var n = !1;return function () {
        n || (n = !0, t.apply(this, arguments), setTimeout(function () {
          return n = !1;
        }, e));
      };
    }Object.defineProperty(e, "__esModule", { value: !0 }), e.throttle = n, e.debounce = i;
  },,,,,, function (t, e, n) {
    "use strict";
    function i(t) {
      return t && t.__esModule ? t : { "default": t };
    }function o() {
      return !performance && performance.now ? performance.now() : Date.now ? Date.now() : new Date().getTime();
    }Object.defineProperty(e, "__esModule", { value: !0 });var r = n(16),
        s = i(r),
        a = n(17),
        u = i(a);"undefined" == typeof window.requestAnimationFrame && (window.requestAnimationFrame = function (t) {
      return setTimeout(function () {
        t(o());
      }, 1e3 / 60);
    }, window.cancelAnimationFrame = function (t) {
      return clearTimeout(t);
    });var c = function () {
      function t(e, n, i) {
        (0, s["default"])(this, t), this.duration = e, this.update = n, this.easing = i;
      }return (0, u["default"])(t, [{ key: "animate", value: function value(t) {
          function e(u) {
            n = n || u;var c = Math.min(1, (u - n) / i);o.call(s, r ? r(c) : c, c), c < 1 ? a = requestAnimationFrame(e) : t(s);
          }var n = 0,
              i = this.duration,
              o = this.update,
              r = this.easing,
              s = this,
              a = 0;s.cancel = function () {
            cancelAnimationFrame(a), o.call(s, 0, 0), t(new Error("User canceled!"));
          }, a = requestAnimationFrame(e);
        } }, { key: "ease", value: function value(e) {
          return new t(this.duration, this.update, e);
        } }]), t;
    }();e["default"] = c;
  }, function (t, e) {
    "use strict";
    e.__esModule = !0, e["default"] = function (t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    };
  }, function (t, e, n) {
    "use strict";
    function i(t) {
      return t && t.__esModule ? t : { "default": t };
    }e.__esModule = !0;var o = n(18),
        r = i(o);e["default"] = function () {
      function t(t, e) {
        for (var n = 0; n < e.length; n++) {
          var i = e[n];i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), (0, r["default"])(t, i.key, i);
        }
      }return function (e, n, i) {
        return n && t(e.prototype, n), i && t(e, i), e;
      };
    }();
  }, function (t, e, n) {
    t.exports = { "default": n(19), __esModule: !0 };
  }, function (t, e, n) {
    n(20);var i = n(23).Object;t.exports = function (t, e, n) {
      return i.defineProperty(t, e, n);
    };
  }, function (t, e, n) {
    var i = n(21);i(i.S + i.F * !n(31), "Object", { defineProperty: n(27).f });
  }, function (t, e, n) {
    var i = n(22),
        o = n(23),
        r = n(24),
        s = n(26),
        a = "prototype",
        u = function u(t, e, n) {
      var c,
          h,
          l,
          d = t & u.F,
          f = t & u.G,
          p = t & u.S,
          m = t & u.P,
          v = t & u.B,
          y = t & u.W,
          g = f ? o : o[e] || (o[e] = {}),
          T = g[a],
          x = f ? i : p ? i[e] : (i[e] || {})[a];f && (n = e);for (c in n) {
        h = !d && x && void 0 !== x[c], h && c in g || (l = h ? x[c] : n[c], g[c] = f && "function" != typeof x[c] ? n[c] : v && h ? r(l, i) : y && x[c] == l ? function (t) {
          var e = function e(_e, n, i) {
            if (this instanceof t) {
              switch (arguments.length) {case 0:
                  return new t();case 1:
                  return new t(_e);case 2:
                  return new t(_e, n);}return new t(_e, n, i);
            }return t.apply(this, arguments);
          };return e[a] = t[a], e;
        }(l) : m && "function" == typeof l ? r(Function.call, l) : l, m && ((g.virtual || (g.virtual = {}))[c] = l, t & u.R && T && !T[c] && s(T, c, l)));
      }
    };u.F = 1, u.G = 2, u.S = 4, u.P = 8, u.B = 16, u.W = 32, u.U = 64, u.R = 128, t.exports = u;
  }, function (t, e) {
    var n = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();"number" == typeof __g && (__g = n);
  }, function (t, e) {
    var n = t.exports = { version: "2.4.0" };"number" == typeof __e && (__e = n);
  }, function (t, e, n) {
    var i = n(25);t.exports = function (t, e, n) {
      if (i(t), void 0 === e) return t;switch (n) {case 1:
          return function (n) {
            return t.call(e, n);
          };case 2:
          return function (n, i) {
            return t.call(e, n, i);
          };case 3:
          return function (n, i, o) {
            return t.call(e, n, i, o);
          };}return function () {
        return t.apply(e, arguments);
      };
    };
  }, function (t, e) {
    t.exports = function (t) {
      if ("function" != typeof t) throw TypeError(t + " is not a function!");return t;
    };
  }, function (t, e, n) {
    var i = n(27),
        o = n(35);t.exports = n(31) ? function (t, e, n) {
      return i.f(t, e, o(1, n));
    } : function (t, e, n) {
      return t[e] = n, t;
    };
  }, function (t, e, n) {
    var i = n(28),
        o = n(30),
        r = n(34),
        s = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default.a;e.f = n(31) ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default.a : function (t, e, n) {
      if (i(t), e = r(e, !0), i(n), o) try {
        return s(t, e, n);
      } catch (a) {}if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");return "value" in n && (t[e] = n.value), t;
    };
  }, function (t, e, n) {
    var i = n(29);t.exports = function (t) {
      if (!i(t)) throw TypeError(t + " is not an object!");return t;
    };
  }, function (t, e) {
    t.exports = function (t) {
      return "object" == (typeof t === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(t)) ? null !== t : "function" == typeof t;
    };
  }, function (t, e, n) {
    t.exports = !n(31) && !n(32)(function () {
      return 7 != Object.defineProperty(n(33)("div"), "a", { get: function get() {
          return 7;
        } }).a;
    });
  }, function (t, e, n) {
    t.exports = !n(32)(function () {
      return 7 != Object.defineProperty({}, "a", { get: function get() {
          return 7;
        } }).a;
    });
  }, function (t, e) {
    t.exports = function (t) {
      try {
        return !!t();
      } catch (e) {
        return !0;
      }
    };
  }, function (t, e, n) {
    var i = n(29),
        o = n(22).document,
        r = i(o) && i(o.createElement);t.exports = function (t) {
      return r ? o.createElement(t) : {};
    };
  }, function (t, e, n) {
    var i = n(29);t.exports = function (t, e) {
      if (!i(t)) return t;var n, o;if (e && "function" == typeof (n = t.toString) && !i(o = n.call(t))) return o;if ("function" == typeof (n = t.valueOf) && !i(o = n.call(t))) return o;if (!e && "function" == typeof (n = t.toString) && !i(o = n.call(t))) return o;throw TypeError("Can't convert object to primitive value");
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      return { enumerable: !(1 & t), configurable: !(2 & t), writable: !(4 & t), value: e };
    };
  },, function (t, e, n) {
    n(38);var i = n(7)(n(40), n(42), "data-v-cbdfe4ca", null);t.exports = i.exports;
  }, function (t, e, n) {
    var i = n(39);"string" == typeof i && (i = [[t.id, i, ""]]), i.locals && (t.exports = i.locals);n(5)("d181ded2", i, !0);
  }, function (t, e, n) {
    e = t.exports = n(4)(), e.push([t.id, ".slider[data-v-cbdfe4ca]{position:relative;overflow:hidden}.items[data-v-cbdfe4ca]{position:relative;height:100%;width:100%}.indicators[data-v-cbdfe4ca]{position:absolute;bottom:20px;z-index:999}.indi-center[data-v-cbdfe4ca]{left:50%;transform:translateX(-50%)}.indi-left[data-v-cbdfe4ca]{left:3%}.indi-right[data-v-cbdfe4ca]{right:3%}.slider-indicator-icon[data-v-cbdfe4ca]{display:inline-block;width:10px;height:10px;margin:0 .1rem;cursor:pointer;border-radius:50%;background-color:rgba(0,0,0,.2)}.slider-indicator-active[data-v-cbdfe4ca]{background-color:hsla(0,0%,100%,.2)}", ""]);
  }, function (t, e, n) {
    "use strict";
    function i(t) {
      return t && t.__esModule ? t : { "default": t };
    }Object.defineProperty(e, "__esModule", { value: !0 });var o = n(41),
        r = i(o),
        s = n(9);e["default"] = { data: function data() {
        return { children: [], nowItemIndex: 0, timer: 0, af: null };
      }, props: { width: { type: String, "default": "auto" }, height: { type: String, "default": "300px" }, interval: { type: Number, "default": 3e3 }, speed: { type: Number, "default": 500 }, auto: { type: Boolean, "default": !0 }, indicators: { "default": "center" }, animation: { type: String, "default": "normal" }, initIndex: { type: Number, "default": 0 } }, computed: { childrenLength: function childrenLength() {
          return this.children.length;
        } }, methods: { updateItems: function updateItems() {
          var t = this;this.children = this.$children.filter(function (t) {
            return "easy-slider-item" === t.$options.name;
          });this.nowItemIndex = this.initIndex;var e = this.children[this.nowItemIndex];e && e.initItem(), this.$nextTick(function () {
            e && (t.handleSetTopItem(e), t.autoplay());
          });
        }, handleSetTopItem: function handleSetTopItem(t, e) {
          t && (t.$el.style.zIndex = 99), e && (e.$el.style.zIndex = 98);
        }, autoplay: function autoplay() {
          function t() {
            return setInterval(function () {
              var t = (e.nowItemIndex + 1) % e.childrenLength;e.jump(t);
            }, e.interval);
          }if (this.auto && !(this.childrenLength < 2)) {
            var e = this;this.timer && clearInterval(this.timer), this.timer = t();
          }
        }, jump: function jump(t) {
          var e = this.children[this.nowItemIndex],
              n = this.children[t],
              i = t - this.nowItemIndex,
              o = i > 0;i === -(this.childrenLength - 1) && (o = !0), i === this.childrenLength - 1 && (o = !1), e && n && (e.hideHandle(o), n.showHandle(o), this.nowItemIndex = t);
        }, prev: function prev() {
          if (!(this.childrenLength < 2)) {
            var t = this.nowItemIndex - 1 === -1 ? this.childrenLength - 1 : this.nowItemIndex - 1;this.jump(t), this.autoplay();
          }
        }, next: function next() {
          if (!(this.childrenLength < 2)) {
            var t = (this.nowItemIndex + 1) % this.childrenLength;this.jump(t), this.autoplay();
          }
        }, indicatorHandle: function indicatorHandle(t) {
          this.childrenLength < 2 || (this.jump(t), this.autoplay());
        } }, created: function created() {
        this.handleItemChange = (0, s.throttle)(this.updateItems, 100), this.jump = (0, s.debounce)(this.jump, this.speed + 100);
      }, beforeMount: function beforeMount() {
        this.handleItemChange();
      }, mounted: function mounted() {
        var t = this,
            e = this.$refs.container;this.af = new r["default"](e, { swipe: function swipe(e) {
            "Left" === e.direction ? t.next() : t.prev();
          } });
      }, activated: function activated() {
        var t = this,
            e = this.$refs.container;this.af = new r["default"](e, { swipe: function swipe(e) {
            "Left" === e.direction ? t.next() : t.prev();
          } });this.handleItemChange();
      }, beforeDestroy: function beforeDestroy() {
        this.timer && clearTimeout(this.timer), this.af.destroy();
      }, deactivated: function deactivated() {
        this.timer && clearTimeout(this.timer), this.af.destroy();
      } };
  }, function (t, e, n) {
    !function () {
      function e(t) {
        return Math.sqrt(t.x * t.x + t.y * t.y);
      }function n(t, e) {
        return t.x * e.x + t.y * e.y;
      }function i(t, i) {
        var o = e(t) * e(i);if (0 === o) return 0;var r = n(t, i) / o;return r > 1 && (r = 1), Math.acos(r);
      }function o(t, e) {
        return t.x * e.y - e.x * t.y;
      }function r(t, e) {
        var n = i(t, e);return o(t, e) > 0 && (n *= -1), 180 * n / Math.PI;
      }function s(t, e) {
        var n = new a(t);return n.add(e), n;
      }var a = function a(t) {
        this.handlers = [], this.el = t;
      };a.prototype.add = function (t) {
        this.handlers.push(t);
      }, a.prototype.del = function (t) {
        t || (this.handlers = []);for (var e = this.handlers.length; e >= 0; e--) {
          this.handlers[e] === t && this.handlers.splice(e, 1);
        }
      }, a.prototype.dispatch = function () {
        for (var t = 0, e = this.handlers.length; t < e; t++) {
          var n = this.handlers[t];"function" == typeof n && n.apply(this.el, arguments);
        }
      };var u = function u(t, e) {
        this.element = "string" == typeof t ? document.querySelector(t) : t, this.start = this.start.bind(this), this.move = this.move.bind(this), this.end = this.end.bind(this), this.cancel = this.cancel.bind(this), this.element.addEventListener("touchstart", this.start, !1), this.element.addEventListener("touchmove", this.move, !1), this.element.addEventListener("touchend", this.end, !1), this.element.addEventListener("touchcancel", this.cancel, !1), this.preV = { x: null, y: null }, this.pinchStartLen = null, this.zoom = 1, this.isDoubleTap = !1;var n = function n() {};this.rotate = s(this.element, e.rotate || n), this.touchStart = s(this.element, e.touchStart || n), this.multipointStart = s(this.element, e.multipointStart || n), this.multipointEnd = s(this.element, e.multipointEnd || n), this.pinch = s(this.element, e.pinch || n), this.swipe = s(this.element, e.swipe || n), this.tap = s(this.element, e.tap || n), this.doubleTap = s(this.element, e.doubleTap || n), this.longTap = s(this.element, e.longTap || n), this.singleTap = s(this.element, e.singleTap || n), this.pressMove = s(this.element, e.pressMove || n), this.touchMove = s(this.element, e.touchMove || n), this.touchEnd = s(this.element, e.touchEnd || n), this.touchCancel = s(this.element, e.touchCancel || n), this.delta = null, this.last = null, this.now = null, this.tapTimeout = null, this.singleTapTimeout = null, this.longTapTimeout = null, this.swipeTimeout = null, this.x1 = this.x2 = this.y1 = this.y2 = null, this.preTapPosition = { x: null, y: null };
      };u.prototype = { start: function start(t) {
          if (t.touches) {
            this.now = Date.now(), this.x1 = t.touches[0].pageX, this.y1 = t.touches[0].pageY, this.delta = this.now - (this.last || this.now), this.touchStart.dispatch(t), null !== this.preTapPosition.x && (this.isDoubleTap = this.delta > 0 && this.delta <= 250 && Math.abs(this.preTapPosition.x - this.x1) < 30 && Math.abs(this.preTapPosition.y - this.y1) < 30), this.preTapPosition.x = this.x1, this.preTapPosition.y = this.y1, this.last = this.now;var n = this.preV,
                i = t.touches.length;if (i > 1) {
              this._cancelLongTap(), this._cancelSingleTap();var o = { x: t.touches[1].pageX - this.x1, y: t.touches[1].pageY - this.y1 };n.x = o.x, n.y = o.y, this.pinchStartLen = e(n), this.multipointStart.dispatch(t);
            }this.longTapTimeout = setTimeout(function () {
              this.longTap.dispatch(t);
            }.bind(this), 750);
          }
        }, move: function move(t) {
          if (t.touches) {
            var n = this.preV,
                i = t.touches.length,
                o = t.touches[0].pageX,
                s = t.touches[0].pageY;if (this.isDoubleTap = !1, i > 1) {
              var a = { x: t.touches[1].pageX - o, y: t.touches[1].pageY - s };null !== n.x && (this.pinchStartLen > 0 && (t.zoom = e(a) / this.pinchStartLen, this.pinch.dispatch(t)), t.angle = r(a, n), this.rotate.dispatch(t)), n.x = a.x, n.y = a.y;
            } else null !== this.x2 ? (t.deltaX = o - this.x2, t.deltaY = s - this.y2) : (t.deltaX = 0, t.deltaY = 0), this.pressMove.dispatch(t);this.touchMove.dispatch(t), this._cancelLongTap(), this.x2 = o, this.y2 = s, i > 1 && t.preventDefault();
          }
        }, end: function end(t) {
          if (t.changedTouches) {
            this._cancelLongTap();var e = this;t.touches.length < 2 && this.multipointEnd.dispatch(t), this.x2 && Math.abs(this.x1 - this.x2) > 30 || this.y2 && Math.abs(this.y1 - this.y2) > 30 ? (t.direction = this._swipeDirection(this.x1, this.x2, this.y1, this.y2), this.swipeTimeout = setTimeout(function () {
              e.swipe.dispatch(t);
            }, 0)) : (this.tapTimeout = setTimeout(function () {
              e.tap.dispatch(t), e.isDoubleTap && (e.doubleTap.dispatch(t), clearTimeout(e.singleTapTimeout), e.isDoubleTap = !1);
            }, 0), e.isDoubleTap || (e.singleTapTimeout = setTimeout(function () {
              e.singleTap.dispatch(t);
            }, 250))), this.touchEnd.dispatch(t), this.preV.x = 0, this.preV.y = 0, this.zoom = 1, this.pinchStartLen = null, this.x1 = this.x2 = this.y1 = this.y2 = null;
          }
        }, cancel: function cancel(t) {
          clearTimeout(this.singleTapTimeout), clearTimeout(this.tapTimeout), clearTimeout(this.longTapTimeout), clearTimeout(this.swipeTimeout), this.touchCancel.dispatch(t);
        }, _cancelLongTap: function _cancelLongTap() {
          clearTimeout(this.longTapTimeout);
        }, _cancelSingleTap: function _cancelSingleTap() {
          clearTimeout(this.singleTapTimeout);
        }, _swipeDirection: function _swipeDirection(t, e, n, i) {
          return Math.abs(t - e) >= Math.abs(n - i) ? t - e > 0 ? "Left" : "Right" : n - i > 0 ? "Up" : "Down";
        }, on: function on(t, e) {
          this[t] && this[t].add(e);
        }, off: function off(t, e) {
          this[t] && this[t].del(e);
        }, destroy: function destroy() {
          return this.singleTapTimeout && clearTimeout(this.singleTapTimeout), this.tapTimeout && clearTimeout(this.tapTimeout), this.longTapTimeout && clearTimeout(this.longTapTimeout), this.swipeTimeout && clearTimeout(this.swipeTimeout), this.element.removeEventListener("touchstart", this.start), this.element.removeEventListener("touchmove", this.move), this.element.removeEventListener("touchend", this.end), this.element.removeEventListener("touchcancel", this.cancel), this.rotate.del(), this.touchStart.del(), this.multipointStart.del(), this.multipointEnd.del(), this.pinch.del(), this.swipe.del(), this.tap.del(), this.doubleTap.del(), this.longTap.del(), this.singleTap.del(), this.pressMove.del(), this.touchMove.del(), this.touchEnd.del(), this.touchCancel.del(), this.preV = this.pinchStartLen = this.zoom = this.isDoubleTap = this.delta = this.last = this.now = this.tapTimeout = this.singleTapTimeout = this.longTapTimeout = this.swipeTimeout = this.x1 = this.x2 = this.y1 = this.y2 = this.preTapPosition = this.rotate = this.touchStart = this.multipointStart = this.multipointEnd = this.pinch = this.swipe = this.tap = this.doubleTap = this.longTap = this.singleTap = this.pressMove = this.touchMove = this.touchEnd = this.touchCancel = null, null;
        } }, t.exports = u;
    }();
  }, function (t, e) {
    t.exports = { render: function render() {
        var t = this,
            e = t.$createElement,
            n = t._self._c || e;return n("div", { staticClass: "slider", style: { width: t.width, height: t.height } }, [n("div", { ref: "container", staticClass: "items" }, [t._t("default")], 2), t._v(" "), t.indicators ? n("div", { "class": "indicators indi-" + t.indicators, on: { click: function click(t) {
              t.stopPropagation();
            } } }, t._l(t.childrenLength, function (e) {
          return n("span", { key: e, staticClass: "slider-indicator-icon", "class": { "slider-indicator-active": t.nowItemIndex === e - 1 }, on: { click: function click(n) {
                t.indicatorHandle(e - 1);
              } } });
        })) : t._e()]);
      }, staticRenderFns: [] };
  }, function (t, e, n) {
    n(44);var i = n(7)(n(46), n(47), "data-v-5debfe35", null);t.exports = i.exports;
  }, function (t, e, n) {
    var i = n(45);"string" == typeof i && (i = [[t.id, i, ""]]), i.locals && (t.exports = i.locals);n(5)("790851cd", i, !0);
  }, function (t, e, n) {
    e = t.exports = n(4)(), e.push([t.id, ".slider-item[data-v-5debfe35],.wrap[data-v-5debfe35]{position:absolute;top:0;left:0;width:100%;height:100%}", ""]);
  }, function (t, e, n) {
    "use strict";
    function i(t) {
      return t && t.__esModule ? t : { "default": t };
    }Object.defineProperty(e, "__esModule", { value: !0 });var o = n(15),
        r = i(o),
        s = { normal: { beforeEnter: function beforeEnter(t, e) {
          var n = getComputedStyle(e),
              i = n.width;parseFloat(i);e.style.transform = "translateX(" + (t.direction ? i : "-" + i) + ")";
        }, enter: function enter(t, e, n) {
          var i = getComputedStyle(e),
              o = i.width,
              s = t.direction ? parseFloat(o) : -parseFloat(o),
              a = new r["default"](t.speed, function (t) {
            e.style.transform = "translateX(" + (s - s * t) + "px)";
          });a.animate(function () {
            return n();
          });
        }, leave: function leave(t, e, n) {
          var i = getComputedStyle(e),
              o = i.width,
              s = t.direction ? -parseFloat(o) : parseFloat(o),
              a = new r["default"](t.speed, function (t) {
            e.style.transform = "translateX(" + s * t + "px)";
          });a.animate(function () {
            return n();
          });
        } }, fade: { beforeEnter: function beforeEnter(t, e) {
          e.style.opacity = 0, e.style.transform = t.direction ? "translateX(10px)" : "translateX(-10px)";
        }, enter: function enter(t, e, n) {
          var i = t.direction ? 10 : -10,
              o = new r["default"](t.speed, function (t) {
            e.style.opacity = t, e.style.transform = "translateX(" + (i - i * t) + "px)";
          });o.animate(function () {
            return n();
          });
        }, leave: function leave(t, e, n) {
          var i = t.direction ? -10 : 10,
              o = new r["default"](t.speed, function (t) {
            e.style.opacity = 1 - t, e.style.transform = "translateX(" + i * t + "px)";
          });o.animate(function () {
            return n();
          });
        } } };e["default"] = { name: "easy-slider-item", data: function data() {
        return { animate: !1, direction: 0, speed: 0, show: !1, animation: "" };
      }, props: { onClick: { type: Function, "default": function _default() {} } }, methods: { beforeEnter: function beforeEnter(t) {
          s[this.animation].beforeEnter(this, t);
        }, enter: function enter(t, e) {
          s[this.animation].enter(this, t, function () {
            return e();
          });
        }, leave: function leave(t, e) {
          var n = this;s[this.animation].leave(this, t, function () {
            e(), n.show = !1;
          });
        }, showHandle: function showHandle(t) {
          var e = this;this.direction = t, this.show = !0, this.$nextTick(function () {
            return e.animate = !0;
          });
        }, hideHandle: function hideHandle(t) {
          this.direction = t, this.animate = !1;
        }, initItem: function initItem() {
          this.animate = !0, this.show = !0;
        } }, created: function created() {
        this.$parent.handleItemChange(), this.speed = this.$parent.speed, this.animation = this.$parent.animation;
      } };
  }, function (t, e) {
    t.exports = { render: function render() {
        var t = this,
            e = t.$createElement,
            n = t._self._c || e;return t.show ? n("div", { staticClass: "slider-item", on: { click: t.onClick } }, [n("transition", { attrs: { css: !1 }, on: { beforeEnter: t.beforeEnter, enter: t.enter, leave: t.leave } }, [t.animate ? n("div", { staticClass: "wrap" }, [t._t("default")], 2) : t._e()])], 1) : t._e();
      }, staticRenderFns: [] };
  }]);
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("f1Eh")(module)))

/***/ }),

/***/ "4s7B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "hq-shop-header"
  }, [_c('div', {
    staticClass: "w1200 bc bd"
  }, [_c('ul', {
    staticClass: "hq-shop-nav"
  }, [_vm._m(1), _vm._v(" "), _c('li', {
    staticClass: "all-goods pr",
    on: {
      "mouseenter": function($event) {
        _vm.goodsCateShow()
      },
      "mouseleave": function($event) {
        _vm.goodsCateHidden()
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/shop_goods_list'
      }
    }
  }, [_vm._v("全部商品"), _c('i', {
    staticClass: "dp-ico-a-1"
  })]), _vm._v(" "), _vm._m(2)], 1), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _vm._m(6)])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hq-shop-banner"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("TK06"),
      "width": "1400",
      "height": "120"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "hover"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("首页")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "categorys-dropdown none"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("专利")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("能源动力")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("通信电子")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("机械加工")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("电池")])]), _vm._v(" "), _c('li', {
    staticClass: "last"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("家电")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("企业介绍")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("店铺留言")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("店铺评价")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hq-shop-zx fr"
  }, [_c('a', {
    staticClass: "a-btn-zx",
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("咨询／收藏"), _c('i', {
    staticClass: "dp-ico-a-1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "zx-drop-box"
  }, [_c('div', {
    staticClass: "item-1"
  }, [_c('i', {
    staticClass: "dp-ico-arrw"
  }), _vm._v(" "), _c('p', [_vm._v("店铺等级："), _c('span', {
    staticClass: "dp-ico-dpdj"
  }), _c('span', {
    staticClass: "dp-ico-dpdj"
  }), _c('span', {
    staticClass: "dp-ico-dpdj"
  })]), _vm._v(" "), _c('p', [_vm._v("信用等级： v6 "), _c('span', {
    staticClass: "dp-ico-xydj"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item-2"
  }, [_c('a', {
    staticClass: "a-btn-zxzx",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "dp-ico-zxzx"
  }), _vm._v("在线咨询")]), _vm._v(" "), _c('a', {
    staticClass: "a-btn-scbd ml10",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "dp-ico-scbd"
  }), _vm._v("收藏本店")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5+tB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "586K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shop_introduction"
  }, [_c('topbar'), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "hq-shop-banner"
  }, [_c('a', {
    attrs: {
      "href": _vm.bannerItem.link
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.bannerItem.mediaCode,
      "width": "1400",
      "height": "120"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hq-shop-header"
  }, [_c('div', {
    staticClass: "w1200 bc bd"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "hq-shop-zx fr"
  }, [_c('a', {
    staticClass: "a-btn-zx",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "mouseenter": function($event) {
        _vm.shopAskAndFavoriteShow()
      }
    }
  }, [_vm._v("咨询／收藏"), _c('i', {
    staticClass: "dp-ico-a-1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "zx-drop-box none",
    on: {
      "mouseleave": function($event) {
        _vm.shopAskAndFavoriteHidden()
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "item-2"
  }, [_vm._m(2), _vm._v(" "), _c('a', {
    staticClass: "a-btn-scbd ml10",
    on: {
      "click": function($event) {
        _vm.addOrDeleteFavoriteShop()
      }
    }
  }, [_c('i', {
    staticClass: "dp-ico-scbd"
  }), _vm._v(_vm._s(_vm.isExistFavoriteShop == 0 ? '收藏本店' : '已经收藏'))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "w1200 bc"
  }, [_c('div', {
    staticClass: "shop-tabbox-1 shop-jp-tj"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "bd bd-2"
  }, [_c('div', {
    staticClass: "shop-qyjs-box"
  }, [_c('dl', [_c('dt', [_vm._v("店铺信息")]), _vm._v(" "), _c('dd', [_vm._v("所在地区： " + _vm._s(_vm.shopBo.province) + _vm._s(_vm.shopBo.city) + _vm._s(_vm.shopBo.district))]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("联系我们")]), _vm._v(" "), _c('dd', [_vm._v("联系客服："), _c('a', {
    staticClass: "a-btn-zxzx",
    attrs: {
      "href": _vm.shopBo.qq
    }
  }, [_c('i', {
    staticClass: "dp-ico-zxzx"
  }), _vm._v("在线咨询")])]), _vm._v(" "), _c('dd', [_vm._v("收藏店铺："), _c('a', {
    staticClass: "a-btn-scbd",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.addOrDeleteFavoriteShop()
      }
    }
  }, [_c('i', {
    staticClass: "dp-ico-scbd"
  }), _vm._v(_vm._s(_vm.isExistFavoriteShop == 0 ? '收藏本店' : '已经收藏'))])])]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "shopDesc",
    domProps: {
      "innerHTML": _vm._s(_vm.shopBo.shopDesc)
    }
  }, [_vm._v("\n\t         \t\t" + _vm._s(_vm.shopBo.shopDesc) + "\n\t         \t")])])])])]), _vm._v(" "), _c('footermenu'), _vm._v(" "), _c('footercopyright')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "hq-shop-nav"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("企业介绍")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-1"
  }, [_c('i', {
    staticClass: "dp-ico-arrw"
  }), _vm._v(" "), _c('p', [_vm._v("店铺等级："), _c('span', {
    staticClass: "dp-ico-dpdj"
  }), _c('span', {
    staticClass: "dp-ico-dpdj"
  }), _c('span', {
    staticClass: "dp-ico-dpdj"
  })]), _vm._v(" "), _c('p', [_vm._v("信用等级： v6 "), _c('span', {
    staticClass: "dp-ico-xydj"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "a-btn-zxzx",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "dp-ico-zxzx"
  }), _vm._v("在线咨询")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hd hd-2"
  }, [_c('ul', [_c('li', {
    staticClass: "hover mb20"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("企业介绍")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dd', [_vm._v("工商执照："), _c('img', {
    staticClass: "v_mid",
    attrs: {
      "src": __webpack_require__("mSkG"),
      "width": "18",
      "height": "20"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', [_c('dt', [_vm._v("店铺服务")]), _vm._v(" "), _c('dd', [_c('img', {
    staticClass: "mr8",
    attrs: {
      "src": __webpack_require__("lm+Y"),
      "width": "68",
      "height": "68"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "mr8",
    attrs: {
      "src": __webpack_require__("CzyT"),
      "width": "68",
      "height": "68"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "mr8",
    attrs: {
      "src": __webpack_require__("gWNQ"),
      "width": "68",
      "height": "68"
    }
  })])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "595I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_payComplete_vue__ = __webpack_require__("lu7E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08468c2a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_payComplete_vue__ = __webpack_require__("FoZp");
function injectStyle (ssrContext) {
  __webpack_require__("qR+W")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-08468c2a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_payComplete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08468c2a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_payComplete_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5PWk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopBar_vue__ = __webpack_require__("kGbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1ecf252_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_TopBar_vue__ = __webpack_require__("tFka");
function injectStyle (ssrContext) {
  __webpack_require__("K6AW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1ecf252_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_TopBar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5aJO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5if9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6RZS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

/*! flipclock 2015-08-31 */
var Base = function Base() {};Base.extend = function (a, b) {
  "use strict";
  var c = Base.prototype.extend;Base._prototyping = !0;var d = new this();c.call(d, a), d.base = function () {}, delete Base._prototyping;var e = d.constructor,
      f = d.constructor = function () {
    if (!Base._prototyping) if (this._constructing || this.constructor == f) this._constructing = !0, e.apply(this, arguments), delete this._constructing;else if (null !== arguments[0]) return (arguments[0].extend || c).call(arguments[0], d);
  };return f.ancestor = this, f.extend = this.extend, f.forEach = this.forEach, f.implement = this.implement, f.prototype = d, f.toString = this.toString, f.valueOf = function (a) {
    return "object" == a ? f : e.valueOf();
  }, c.call(f, b), "function" == typeof f.init && f.init(), f;
}, Base.prototype = { extend: function extend(a, b) {
    if (arguments.length > 1) {
      var c = this[a];if (c && "function" == typeof b && (!c.valueOf || c.valueOf() != b.valueOf()) && /\bbase\b/.test(b)) {
        var d = b.valueOf();b = function b() {
          var a = this.base || Base.prototype.base;this.base = c;var b = d.apply(this, arguments);return this.base = a, b;
        }, b.valueOf = function (a) {
          return "object" == a ? b : d;
        }, b.toString = Base.toString;
      }this[a] = b;
    } else if (a) {
      var e = Base.prototype.extend;Base._prototyping || "function" == typeof this || (e = this.extend || e);for (var f = { toSource: null }, g = ["constructor", "toString", "valueOf"], h = Base._prototyping ? 0 : 1; i = g[h++];) {
        a[i] != f[i] && e.call(this, i, a[i]);
      }for (var i in a) {
        f[i] || e.call(this, i, a[i]);
      }
    }return this;
  } }, Base = Base.extend({ constructor: function constructor() {
    this.extend(arguments[0]);
  } }, { ancestor: Object, version: "1.1", forEach: function forEach(a, b, c) {
    for (var d in a) {
      void 0 === this.prototype[d] && b.call(c, a[d], d, a);
    }
  }, implement: function implement() {
    for (var a = 0; a < arguments.length; a++) {
      "function" == typeof arguments[a] ? arguments[a](this.prototype) : this.prototype.extend(arguments[a]);
    }return this;
  }, toString: function toString() {
    return String(this.valueOf());
  } });var _FlipClock;!function (a) {
  "use strict";
  _FlipClock = function FlipClock(a, b, c) {
    return b instanceof Object && b instanceof Date == !1 && (c = b, b = 0), new _FlipClock.Factory(a, b, c);
  }, _FlipClock.Lang = {}, _FlipClock.Base = Base.extend({ buildDate: "2014-12-12", version: "0.7.7", constructor: function constructor(b, c) {
      "object" != (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(b)) && (b = {}), "object" != (typeof c === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(c)) && (c = {}), this.setOptions(a.extend(!0, {}, b, c));
    }, callback: function callback(a) {
      if ("function" == typeof a) {
        for (var b = [], c = 1; c <= arguments.length; c++) {
          arguments[c] && b.push(arguments[c]);
        }a.apply(this, b);
      }
    }, log: function log(a) {
      window.console && console.log && console.log(a);
    }, getOption: function getOption(a) {
      return this[a] ? this[a] : !1;
    }, getOptions: function getOptions() {
      return this;
    }, setOption: function setOption(a, b) {
      this[a] = b;
    }, setOptions: function setOptions(a) {
      for (var b in a) {
        "undefined" != typeof a[b] && this.setOption(b, a[b]);
      }
    } });
}(jQuery), function (a) {
  "use strict";
  _FlipClock.Face = _FlipClock.Base.extend({ autoStart: !0, dividers: [], factory: !1, lists: [], constructor: function constructor(a, b) {
      this.dividers = [], this.lists = [], this.base(b), this.factory = a;
    }, build: function build() {
      this.autoStart && this.start();
    }, createDivider: function createDivider(b, c, d) {
      "boolean" != typeof c && c || (d = c, c = b);var e = ['<span class="' + this.factory.classes.dot + ' top"></span>', '<span class="' + this.factory.classes.dot + ' bottom"></span>'].join("");d && (e = ""), b = this.factory.localize(b);var f = ['<span class="' + this.factory.classes.divider + " " + (c ? c : "").toLowerCase() + '">', '<span class="' + this.factory.classes.label + '">' + (b ? b : "") + "</span>", e, "</span>"],
          g = a(f.join(""));return this.dividers.push(g), g;
    }, createList: function createList(a, b) {
      "object" == (typeof a === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(a)) && (b = a, a = 0);var c = new _FlipClock.List(this.factory, a, b);return this.lists.push(c), c;
    }, reset: function reset() {
      this.factory.time = new _FlipClock.Time(this.factory, this.factory.original ? Math.round(this.factory.original) : 0, { minimumDigits: this.factory.minimumDigits }), this.flip(this.factory.original, !1);
    }, appendDigitToClock: function appendDigitToClock(a) {
      a.$el.append(!1);
    }, addDigit: function addDigit(a) {
      var b = this.createList(a, { classes: { active: this.factory.classes.active, before: this.factory.classes.before, flip: this.factory.classes.flip } });this.appendDigitToClock(b);
    }, start: function start() {}, stop: function stop() {}, autoIncrement: function autoIncrement() {
      this.factory.countdown ? this.decrement() : this.increment();
    }, increment: function increment() {
      this.factory.time.addSecond();
    }, decrement: function decrement() {
      0 == this.factory.time.getTimeSeconds() ? this.factory.stop() : this.factory.time.subSecond();
    }, flip: function flip(b, c) {
      var d = this;a.each(b, function (a, b) {
        var e = d.lists[a];e ? (c || b == e.digit || e.play(), e.select(b)) : d.addDigit(b);
      });
    } });
}(jQuery), function (a) {
  "use strict";
  _FlipClock.Factory = _FlipClock.Base.extend({ animationRate: 1e3, autoStart: !0, callbacks: { destroy: !1, create: !1, init: !1, interval: !1, start: !1, stop: !1, reset: !1 }, classes: { active: "flip-clock-active", before: "flip-clock-before", divider: "flip-clock-divider", dot: "flip-clock-dot", label: "flip-clock-label", flip: "flip", play: "play", wrapper: "flip-clock-wrapper" }, clockFace: "HourlyCounter", countdown: !1, defaultClockFace: "HourlyCounter", defaultLanguage: "english", $el: !1, face: !0, lang: !1, language: "english", minimumDigits: 0, original: !1, running: !1, time: !1, timer: !1, $wrapper: !1, constructor: function constructor(b, c, d) {
      d || (d = {}), this.lists = [], this.running = !1, this.base(d), this.$el = a(b).addClass(this.classes.wrapper), this.$wrapper = this.$el, this.original = c instanceof Date ? c : c ? Math.round(c) : 0, this.time = new _FlipClock.Time(this, this.original, { minimumDigits: this.minimumDigits, animationRate: this.animationRate }), this.timer = new _FlipClock.Timer(this, d), this.loadLanguage(this.language), this.loadClockFace(this.clockFace, d), this.autoStart && this.start();
    }, loadClockFace: function loadClockFace(a, b) {
      var c,
          d = "Face",
          e = !1;return a = a.ucfirst() + d, this.face.stop && (this.stop(), e = !0), this.$el.html(""), this.time.minimumDigits = this.minimumDigits, c = _FlipClock[a] ? new _FlipClock[a](this, b) : new _FlipClock[this.defaultClockFace + d](this, b), c.build(), this.face = c, e && this.start(), this.face;
    }, loadLanguage: function loadLanguage(a) {
      var b;return b = _FlipClock.Lang[a.ucfirst()] ? _FlipClock.Lang[a.ucfirst()] : _FlipClock.Lang[a] ? _FlipClock.Lang[a] : _FlipClock.Lang[this.defaultLanguage], this.lang = b;
    }, localize: function localize(a, b) {
      var c = this.lang;if (!a) return null;var d = a.toLowerCase();return "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(b)) && (c = b), c && c[d] ? c[d] : a;
    }, start: function start(a) {
      var b = this;b.running || b.countdown && !(b.countdown && b.time.time > 0) ? b.log("Trying to start timer when countdown already at 0") : (b.face.start(b.time), b.timer.start(function () {
        b.flip(), "function" == typeof a && a();
      }));
    }, stop: function stop(a) {
      this.face.stop(), this.timer.stop(a);for (var b in this.lists) {
        this.lists.hasOwnProperty(b) && this.lists[b].stop();
      }
    }, reset: function reset(a) {
      this.timer.reset(a), this.face.reset();
    }, setTime: function setTime(a) {
      this.time.time = a, this.flip(!0);
    }, getTime: function getTime(a) {
      return this.time;
    }, setCountdown: function setCountdown(a) {
      var b = this.running;this.countdown = a ? !0 : !1, b && (this.stop(), this.start());
    }, flip: function flip(a) {
      this.face.flip(!1, a);
    } });
}(jQuery), function (a) {
  "use strict";
  _FlipClock.List = _FlipClock.Base.extend({ digit: 0, classes: { active: "flip-clock-active", before: "flip-clock-before", flip: "flip" }, factory: !1, $el: !1, $obj: !1, items: [], lastDigit: 0, constructor: function constructor(a, b, c) {
      this.factory = a, this.digit = b, this.lastDigit = b, this.$el = this.createList(), this.$obj = this.$el, b > 0 && this.select(b), this.factory.$el.append(this.$el);
    }, select: function select(a) {
      if ("undefined" == typeof a ? a = this.digit : this.digit = a, this.digit != this.lastDigit) {
        var b = this.$el.find("." + this.classes.before).removeClass(this.classes.before);this.$el.find("." + this.classes.active).removeClass(this.classes.active).addClass(this.classes.before), this.appendListItem(this.classes.active, this.digit), b.remove(), this.lastDigit = this.digit;
      }
    }, play: function play() {
      this.$el.addClass(this.factory.classes.play);
    }, stop: function stop() {
      var a = this;setTimeout(function () {
        a.$el.removeClass(a.factory.classes.play);
      }, this.factory.timer.interval);
    }, createListItem: function createListItem(a, b) {
      return ['<li class="' + (a ? a : "") + '">', '<a href="#">', '<div class="up">', '<div class="shadow"></div>', '<div class="inn">' + (b ? b : "") + "</div>", "</div>", '<div class="down">', '<div class="shadow"></div>', '<div class="inn">' + (b ? b : "") + "</div>", "</div>", "</a>", "</li>"].join("");
    }, appendListItem: function appendListItem(a, b) {
      var c = this.createListItem(a, b);this.$el.append(c);
    }, createList: function createList() {
      var b = this.getPrevDigit() ? this.getPrevDigit() : this.digit,
          c = a(['<ul class="' + this.classes.flip + " " + (this.factory.running ? this.factory.classes.play : "") + '">', this.createListItem(this.classes.before, b), this.createListItem(this.classes.active, this.digit), "</ul>"].join(""));return c;
    }, getNextDigit: function getNextDigit() {
      return 9 == this.digit ? 0 : this.digit + 1;
    }, getPrevDigit: function getPrevDigit() {
      return 0 == this.digit ? 9 : this.digit - 1;
    } });
}(jQuery), function (a) {
  "use strict";
  String.prototype.ucfirst = function () {
    return this.substr(0, 1).toUpperCase() + this.substr(1);
  }, a.fn.FlipClock = function (b, c) {
    return new _FlipClock(a(this), b, c);
  }, a.fn.flipClock = function (b, c) {
    return a.fn.FlipClock(b, c);
  };
}(jQuery), function (a) {
  "use strict";
  _FlipClock.Time = _FlipClock.Base.extend({ time: 0, factory: !1, minimumDigits: 0, constructor: function constructor(a, b, c) {
      "object" != (typeof c === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(c)) && (c = {}), c.minimumDigits || (c.minimumDigits = a.minimumDigits), this.base(c), this.factory = a, b && (this.time = b);
    }, convertDigitsToArray: function convertDigitsToArray(a) {
      var b = [];a = a.toString();for (var c = 0; c < a.length; c++) {
        a[c].match(/^\d*$/g) && b.push(a[c]);
      }return b;
    }, digit: function digit(a) {
      var b = this.toString(),
          c = b.length;return b[c - a] ? b[c - a] : !1;
    }, digitize: function digitize(b) {
      var c = [];if (a.each(b, function (a, b) {
        b = b.toString(), 1 == b.length && (b = "0" + b);for (var d = 0; d < b.length; d++) {
          c.push(b.charAt(d));
        }
      }), c.length > this.minimumDigits && (this.minimumDigits = c.length), this.minimumDigits > c.length) for (var d = c.length; d < this.minimumDigits; d++) {
        c.unshift("0");
      }return c;
    }, getDateObject: function getDateObject() {
      return this.time instanceof Date ? this.time : new Date(new Date().getTime() + 1e3 * this.getTimeSeconds());
    }, getDayCounter: function getDayCounter(a) {
      var b = [this.getDays(), this.getHours(!0), this.getMinutes(!0)];return a && b.push(this.getSeconds(!0)), this.digitize(b);
    }, getDays: function getDays(a) {
      var b = this.getTimeSeconds() / 60 / 60 / 24;return a && (b %= 7), Math.floor(b);
    }, getHourCounter: function getHourCounter() {
      var a = this.digitize([this.getHours(), this.getMinutes(!0), this.getSeconds(!0)]);return a;
    }, getHourly: function getHourly() {
      return this.getHourCounter();
    }, getHours: function getHours(a) {
      var b = this.getTimeSeconds() / 60 / 60;return a && (b %= 24), Math.floor(b);
    }, getMilitaryTime: function getMilitaryTime(a, b) {
      "undefined" == typeof b && (b = !0), a || (a = this.getDateObject());var c = [a.getHours(), a.getMinutes()];return b === !0 && c.push(a.getSeconds()), this.digitize(c);
    }, getMinutes: function getMinutes(a) {
      var b = this.getTimeSeconds() / 60;return a && (b %= 60), Math.floor(b);
    }, getMinuteCounter: function getMinuteCounter() {
      var a = this.digitize([this.getMinutes(), this.getSeconds(!0)]);return a;
    }, getTimeSeconds: function getTimeSeconds(a) {
      return a || (a = new Date()), this.time instanceof Date ? this.factory.countdown ? Math.max(this.time.getTime() / 1e3 - a.getTime() / 1e3, 0) : a.getTime() / 1e3 - this.time.getTime() / 1e3 : this.time;
    }, getTime: function getTime(a, b) {
      "undefined" == typeof b && (b = !0), a || (a = this.getDateObject()), console.log(a);var c = a.getHours(),
          d = [c > 12 ? c - 12 : 0 === c ? 12 : c, a.getMinutes()];return b === !0 && d.push(a.getSeconds()), this.digitize(d);
    }, getSeconds: function getSeconds(a) {
      var b = this.getTimeSeconds();return a && (60 == b ? b = 0 : b %= 60), Math.ceil(b);
    }, getWeeks: function getWeeks(a) {
      var b = this.getTimeSeconds() / 60 / 60 / 24 / 7;return a && (b %= 52), Math.floor(b);
    }, removeLeadingZeros: function removeLeadingZeros(b, c) {
      var d = 0,
          e = [];return a.each(c, function (a, f) {
        b > a ? d += parseInt(c[a], 10) : e.push(c[a]);
      }), 0 === d ? e : c;
    }, addSeconds: function addSeconds(a) {
      this.time instanceof Date ? this.time.setSeconds(this.time.getSeconds() + a) : this.time += a;
    }, addSecond: function addSecond() {
      this.addSeconds(1);
    }, subSeconds: function subSeconds(a) {
      this.time instanceof Date ? this.time.setSeconds(this.time.getSeconds() - a) : this.time -= a;
    }, subSecond: function subSecond() {
      this.subSeconds(1);
    }, toString: function toString() {
      return this.getTimeSeconds().toString();
    } });
}(jQuery), function (a) {
  "use strict";
  _FlipClock.Timer = _FlipClock.Base.extend({ callbacks: { destroy: !1, create: !1, init: !1, interval: !1, start: !1, stop: !1, reset: !1 }, count: 0, factory: !1, interval: 1e3, animationRate: 1e3, constructor: function constructor(a, b) {
      this.base(b), this.factory = a, this.callback(this.callbacks.init), this.callback(this.callbacks.create);
    }, getElapsed: function getElapsed() {
      return this.count * this.interval;
    }, getElapsedTime: function getElapsedTime() {
      return new Date(this.time + this.getElapsed());
    }, reset: function reset(a) {
      clearInterval(this.timer), this.count = 0, this._setInterval(a), this.callback(this.callbacks.reset);
    }, start: function start(a) {
      this.factory.running = !0, this._createTimer(a), this.callback(this.callbacks.start);
    }, stop: function stop(a) {
      this.factory.running = !1, this._clearInterval(a), this.callback(this.callbacks.stop), this.callback(a);
    }, _clearInterval: function _clearInterval() {
      clearInterval(this.timer);
    }, _createTimer: function _createTimer(a) {
      this._setInterval(a);
    }, _destroyTimer: function _destroyTimer(a) {
      this._clearInterval(), this.timer = !1, this.callback(a), this.callback(this.callbacks.destroy);
    }, _interval: function _interval(a) {
      this.callback(this.callbacks.interval), this.callback(a), this.count++;
    }, _setInterval: function _setInterval(a) {
      var b = this;b._interval(a), b.timer = setInterval(function () {
        b._interval(a);
      }, this.interval);
    } });
}(jQuery), function (a) {
  _FlipClock.TwentyFourHourClockFace = _FlipClock.Face.extend({ constructor: function constructor(a, b) {
      this.base(a, b);
    }, build: function build(b) {
      var c = this,
          d = this.factory.$el.find("ul");this.factory.time.time || (this.factory.original = new Date(), this.factory.time = new _FlipClock.Time(this.factory, this.factory.original));var b = b ? b : this.factory.time.getMilitaryTime(!1, this.showSeconds);b.length > d.length && a.each(b, function (a, b) {
        c.createList(b);
      }), this.createDivider(), this.createDivider(), a(this.dividers[0]).insertBefore(this.lists[this.lists.length - 2].$el), a(this.dividers[1]).insertBefore(this.lists[this.lists.length - 4].$el), this.base();
    }, flip: function flip(a, b) {
      this.autoIncrement(), a = a ? a : this.factory.time.getMilitaryTime(!1, this.showSeconds), this.base(a, b);
    } });
}(jQuery), function (a) {
  _FlipClock.CounterFace = _FlipClock.Face.extend({ shouldAutoIncrement: !1, constructor: function constructor(a, b) {
      "object" != (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(b)) && (b = {}), a.autoStart = b.autoStart ? !0 : !1, b.autoStart && (this.shouldAutoIncrement = !0), a.increment = function () {
        a.countdown = !1, a.setTime(a.getTime().getTimeSeconds() + 1);
      }, a.decrement = function () {
        a.countdown = !0;var b = a.getTime().getTimeSeconds();b > 0 && a.setTime(b - 1);
      }, a.setValue = function (b) {
        a.setTime(b);
      }, a.setCounter = function (b) {
        a.setTime(b);
      }, this.base(a, b);
    }, build: function build() {
      var b = this,
          c = this.factory.$el.find("ul"),
          d = this.factory.getTime().digitize([this.factory.getTime().time]);d.length > c.length && a.each(d, function (a, c) {
        var d = b.createList(c);d.select(c);
      }), a.each(this.lists, function (a, b) {
        b.play();
      }), this.base();
    }, flip: function flip(a, b) {
      this.shouldAutoIncrement && this.autoIncrement(), a || (a = this.factory.getTime().digitize([this.factory.getTime().time])), this.base(a, b);
    }, reset: function reset() {
      this.factory.time = new _FlipClock.Time(this.factory, this.factory.original ? Math.round(this.factory.original) : 0), this.flip();
    } });
}(jQuery), function (a) {
  _FlipClock.DailyCounterFace = _FlipClock.Face.extend({ showSeconds: !0, constructor: function constructor(a, b) {
      this.base(a, b);
    }, build: function build(b) {
      var c = this,
          d = this.factory.$el.find("ul"),
          e = 0;b = b ? b : this.factory.time.getDayCounter(this.showSeconds), b.length > d.length && a.each(b, function (a, b) {
        c.createList(b);
      }), this.showSeconds ? a(this.createDivider("Seconds")).insertBefore(this.lists[this.lists.length - 2].$el) : e = 2, a(this.createDivider("Minutes")).insertBefore(this.lists[this.lists.length - 4 + e].$el), a(this.createDivider("Hours")).insertBefore(this.lists[this.lists.length - 6 + e].$el), a(this.createDivider("Days", !0)).insertBefore(this.lists[0].$el), this.base();
    }, flip: function flip(a, b) {
      a || (a = this.factory.time.getDayCounter(this.showSeconds)), this.autoIncrement(), this.base(a, b);
    } });
}(jQuery), function (a) {
  _FlipClock.HourlyCounterFace = _FlipClock.Face.extend({ constructor: function constructor(a, b) {
      this.base(a, b);
    }, build: function build(b, c) {
      var d = this,
          e = this.factory.$el.find("ul");c = c ? c : this.factory.time.getHourCounter(), c.length > e.length && a.each(c, function (a, b) {
        d.createList(b);
      }), a(this.createDivider("Seconds")).insertBefore(this.lists[this.lists.length - 2].$el), a(this.createDivider("Minutes")).insertBefore(this.lists[this.lists.length - 4].$el), b || a(this.createDivider("Hours", !0)).insertBefore(this.lists[0].$el), this.base();
    }, flip: function flip(a, b) {
      a || (a = this.factory.time.getHourCounter()), this.autoIncrement(), this.base(a, b);
    }, appendDigitToClock: function appendDigitToClock(a) {
      this.base(a), this.dividers[0].insertAfter(this.dividers[0].next());
    } });
}(jQuery), function (a) {
  _FlipClock.MinuteCounterFace = _FlipClock.HourlyCounterFace.extend({ clearExcessDigits: !1, constructor: function constructor(a, b) {
      this.base(a, b);
    }, build: function build() {
      this.base(!0, this.factory.time.getMinuteCounter());
    }, flip: function flip(a, b) {
      a || (a = this.factory.time.getMinuteCounter()), this.base(a, b);
    } });
}(jQuery), function (a) {
  _FlipClock.TwelveHourClockFace = _FlipClock.TwentyFourHourClockFace.extend({ meridium: !1, meridiumText: "AM", build: function build() {
      var b = this.factory.time.getTime(!1, this.showSeconds);this.base(b), this.meridiumText = this.getMeridium(), this.meridium = a(['<ul class="flip-clock-meridium">', "<li>", '<a href="#">' + this.meridiumText + "</a>", "</li>", "</ul>"].join("")), this.meridium.insertAfter(this.lists[this.lists.length - 1].$el);
    }, flip: function flip(a, b) {
      this.meridiumText != this.getMeridium() && (this.meridiumText = this.getMeridium(), this.meridium.find("a").html(this.meridiumText)), this.base(this.factory.time.getTime(!1, this.showSeconds), b);
    }, getMeridium: function getMeridium() {
      return new Date().getHours() >= 12 ? "PM" : "AM";
    }, isPM: function isPM() {
      return "PM" == this.getMeridium() ? !0 : !1;
    }, isAM: function isAM() {
      return "AM" == this.getMeridium() ? !0 : !1;
    } });
}(jQuery), function (a) {
  _FlipClock.Lang.Arabic = { years: "سنوات", months: "شهور", days: "أيام", hours: "ساعات", minutes: "دقائق", seconds: "ثواني" }, _FlipClock.Lang.ar = _FlipClock.Lang.Arabic, _FlipClock.Lang["ar-ar"] = _FlipClock.Lang.Arabic, _FlipClock.Lang.arabic = _FlipClock.Lang.Arabic;
}(jQuery), function (a) {
  _FlipClock.Lang.Danish = { years: "År", months: "Måneder", days: "Dage", hours: "Timer", minutes: "Minutter", seconds: "Sekunder" }, _FlipClock.Lang.da = _FlipClock.Lang.Danish, _FlipClock.Lang["da-dk"] = _FlipClock.Lang.Danish, _FlipClock.Lang.danish = _FlipClock.Lang.Danish;
}(jQuery), function (a) {
  _FlipClock.Lang.German = { years: "Jahre", months: "Monate", days: "Tage", hours: "Stunden", minutes: "Minuten", seconds: "Sekunden" }, _FlipClock.Lang.de = _FlipClock.Lang.German, _FlipClock.Lang["de-de"] = _FlipClock.Lang.German, _FlipClock.Lang.german = _FlipClock.Lang.German;
}(jQuery), function (a) {
  _FlipClock.Lang.English = { years: "Years", months: "Months", days: "Days", hours: "Hours", minutes: "Minutes", seconds: "Seconds" }, _FlipClock.Lang.en = _FlipClock.Lang.English, _FlipClock.Lang["en-us"] = _FlipClock.Lang.English, _FlipClock.Lang.english = _FlipClock.Lang.English;
}(jQuery), function (a) {
  _FlipClock.Lang.Spanish = { years: "Años", months: "Meses", days: "Días", hours: "Horas", minutes: "Minutos", seconds: "Segundos" }, _FlipClock.Lang.es = _FlipClock.Lang.Spanish, _FlipClock.Lang["es-es"] = _FlipClock.Lang.Spanish, _FlipClock.Lang.spanish = _FlipClock.Lang.Spanish;
}(jQuery), function (a) {
  _FlipClock.Lang.Finnish = { years: "Vuotta", months: "Kuukautta", days: "Päivää", hours: "Tuntia", minutes: "Minuuttia", seconds: "Sekuntia" }, _FlipClock.Lang.fi = _FlipClock.Lang.Finnish, _FlipClock.Lang["fi-fi"] = _FlipClock.Lang.Finnish, _FlipClock.Lang.finnish = _FlipClock.Lang.Finnish;
}(jQuery), function (a) {
  _FlipClock.Lang.French = { years: "Ans", months: "Mois", days: "Jours", hours: "Heures", minutes: "Minutes", seconds: "Secondes" }, _FlipClock.Lang.fr = _FlipClock.Lang.French, _FlipClock.Lang["fr-ca"] = _FlipClock.Lang.French, _FlipClock.Lang.french = _FlipClock.Lang.French;
}(jQuery), function (a) {
  _FlipClock.Lang.Italian = { years: "Anni", months: "Mesi", days: "Giorni", hours: "Ore", minutes: "Minuti", seconds: "Secondi" }, _FlipClock.Lang.it = _FlipClock.Lang.Italian, _FlipClock.Lang["it-it"] = _FlipClock.Lang.Italian, _FlipClock.Lang.italian = _FlipClock.Lang.Italian;
}(jQuery), function (a) {
  _FlipClock.Lang.Latvian = { years: "Gadi", months: "Mēneši", days: "Dienas", hours: "Stundas", minutes: "Minūtes", seconds: "Sekundes" }, _FlipClock.Lang.lv = _FlipClock.Lang.Latvian, _FlipClock.Lang["lv-lv"] = _FlipClock.Lang.Latvian, _FlipClock.Lang.latvian = _FlipClock.Lang.Latvian;
}(jQuery), function (a) {
  _FlipClock.Lang.Dutch = { years: "Jaren", months: "Maanden", days: "Dagen", hours: "Uren", minutes: "Minuten", seconds: "Seconden" }, _FlipClock.Lang.nl = _FlipClock.Lang.Dutch, _FlipClock.Lang["nl-be"] = _FlipClock.Lang.Dutch, _FlipClock.Lang.dutch = _FlipClock.Lang.Dutch;
}(jQuery), function (a) {
  _FlipClock.Lang.Norwegian = { years: "År", months: "Måneder", days: "Dager", hours: "Timer", minutes: "Minutter", seconds: "Sekunder" }, _FlipClock.Lang.no = _FlipClock.Lang.Norwegian, _FlipClock.Lang.nb = _FlipClock.Lang.Norwegian, _FlipClock.Lang["no-nb"] = _FlipClock.Lang.Norwegian, _FlipClock.Lang.norwegian = _FlipClock.Lang.Norwegian;
}(jQuery), function (a) {
  _FlipClock.Lang.Portuguese = { years: "Anos", months: "Meses", days: "Dias", hours: "Horas", minutes: "Minutos", seconds: "Segundos" }, _FlipClock.Lang.pt = _FlipClock.Lang.Portuguese, _FlipClock.Lang["pt-br"] = _FlipClock.Lang.Portuguese, _FlipClock.Lang.portuguese = _FlipClock.Lang.Portuguese;
}(jQuery), function (a) {
  _FlipClock.Lang.Russian = { years: "лет", months: "месяцев", days: "дней", hours: "часов", minutes: "минут", seconds: "секунд" }, _FlipClock.Lang.ru = _FlipClock.Lang.Russian, _FlipClock.Lang["ru-ru"] = _FlipClock.Lang.Russian, _FlipClock.Lang.russian = _FlipClock.Lang.Russian;
}(jQuery), function (a) {
  _FlipClock.Lang.Swedish = { years: "År", months: "Månader", days: "Dagar", hours: "Timmar", minutes: "Minuter", seconds: "Sekunder" }, _FlipClock.Lang.sv = _FlipClock.Lang.Swedish, _FlipClock.Lang["sv-se"] = _FlipClock.Lang.Swedish, _FlipClock.Lang.swedish = _FlipClock.Lang.Swedish;
}(jQuery), function (a) {
  _FlipClock.Lang.Chinese = { years: "年", months: "月", days: "日", hours: "时", minutes: "分", seconds: "秒" }, _FlipClock.Lang.zh = _FlipClock.Lang.Chinese, _FlipClock.Lang["zh-cn"] = _FlipClock.Lang.Chinese, _FlipClock.Lang.chinese = _FlipClock.Lang.Chinese;
}(jQuery);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "6VjR":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "6Y+c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "shop-focus-img"
  }, [_c('slider', {
    style: ({
      height: _vm.sliderHeight
    }),
    attrs: {
      "animation": "normal"
    }
  }, _vm._l((_vm.adsItems), function(i, index) {
    return _c('slider-item', {
      key: index
    }, [_c('div', [_c('a', {
      attrs: {
        "href": i.linkUrl
      }
    }, [_c('img', {
      attrs: {
        "src": i.imgUrl,
        "width": "1400",
        "height": "370"
      }
    })])])])
  }))], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6flv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'emallheader',
	data: function data() {
		return {
			msg: 'Welcome to Your Vue.js App123'
		};
	}
});

/***/ }),

/***/ "7JIe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HearderNav_vue__ = __webpack_require__("lGIb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ec01199_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_HearderNav_vue__ = __webpack_require__("1VKG");
function injectStyle (ssrContext) {
  __webpack_require__("UfZE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HearderNav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ec01199_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_HearderNav_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7KI2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_api_api_js__ = __webpack_require__("fXcb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_js_emallUtils_js__ = __webpack_require__("spYF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_js_alertConfirm_js__ = __webpack_require__("bCJ+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TopBar__ = __webpack_require__("5PWk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Header__ = __webpack_require__("teIl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_FooterMenu__ = __webpack_require__("gTlp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_FooterCopyright__ = __webpack_require__("3LwO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_HearderNav__ = __webpack_require__("7JIe");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//import jQuery from "../../../static/js/jquery.min.js"










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'address_list',
  data: function data() {
    return {
      goodsCode: '',
      goodsCodes: '',
      payNum: '',
      boList: [],
      addressTitle: '收货地址管理',
      sourceUrl: '',
      cityInfo: '',
      backUrl: 'address_list',
      orderSource: '',
      canCreateAddress: true,
      addressIndex: ''
    };
  },

  components: {
    'topbar': __WEBPACK_IMPORTED_MODULE_5__components_TopBar__["a" /* default */],
    'sortHeader': __WEBPACK_IMPORTED_MODULE_6__components_Header__["a" /* default */],
    'footermenu': __WEBPACK_IMPORTED_MODULE_7__components_FooterMenu__["a" /* default */],
    'footercopyright': __WEBPACK_IMPORTED_MODULE_8__components_FooterCopyright__["a" /* default */],
    'heardernav': __WEBPACK_IMPORTED_MODULE_9__components_HearderNav__["a" /* default */]
  },
  methods: {
    addressShow: function addressShow(index) {
      this.addressIndex = index;
    },
    addressHide: function addressHide() {
      this.addressIndex = -1;
    },
    queryUserAddress: function queryUserAddress() {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_1__static_api_api_js__["a" /* default */].queryUserAddress(function (ret) {
        if (ret.code == "success") {
          that.boList = ret.data;
          if (that.boList != null && that.boList.length > 4) {
            that.canCreateAddress = false;
          }
        }
      });
    },
    setDefaultAddress: function setDefaultAddress(addressId, index) {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_1__static_api_api_js__["a" /* default */].setDefaultAddress(addressId, function (ret) {
        if (ret.code == "success") {
          that.addressIndex = index;
          if (that.boList != null) {
            for (var i = 0; i < that.boList.length; i++) {
              that.boList[i].isDefault = 'n';
            }
          }
          that.boList[index].isDefault = 'y';
          //alertConfirm.singleConfirm('设置默认地址成功');
        }
      });
    },
    deleteAddress: function deleteAddress(addressId, index) {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_1__static_api_api_js__["a" /* default */].deleteAddress(addressId, function (ret) {
        if (ret.code == "success") {
          that.boList.splice(index, 1);
          if (that.boList != null && that.boList.length < 5) {
            that.canCreateAddress = true;
          }
          __WEBPACK_IMPORTED_MODULE_3__static_js_alertConfirm_js__["a" /* default */].singleConfirm('删除地址成功');
        } else if (ret.code == "addressNotExists") {
          __WEBPACK_IMPORTED_MODULE_3__static_js_alertConfirm_js__["a" /* default */].singleConfirm('地址信息不存在');
        } else if (ret.code == "addressUserError") {
          __WEBPACK_IMPORTED_MODULE_3__static_js_alertConfirm_js__["a" /* default */].singleConfirm('无权删除此地址信息');
        }
      });
    },
    toAddressDetail: function toAddressDetail(addressId) {
      this.$router.push({ name: 'address',
        query: {
          backUrl: 'address_list',
          addressId: addressId
        } });
    }

  },
  beforeMount: function beforeMount() {},
  mounted: function mounted() {
    window.scrollTo(0, 0);
    this.queryUserAddress();
  }
});

/***/ }),

/***/ "7N4N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "indexbg"
  }, [_c('topbar'), _vm._v(" "), _c('header'), _vm._v(" "), _c('emallheader'), _vm._v(" "), _c('div', {
    staticClass: "clear mt15"
  }), _vm._v(" "), _c('div', {
    staticClass: "w1200 bc"
  }, [_c('div', {
    staticClass: "hq-shopping-cart"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tipsbox success"
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v(" "), _c('h3', [_vm._v("恭喜您，下单成功！")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("备注：此处为备注信息，此处为备注信息此处为备注信息")]), _vm._v(" "), _c('div', {
    staticClass: "ft"
  }, [_c('a', {
    staticClass: "btn",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.jumpToOrderList()
      }
    }
  }, [_vm._v("查看全部订单")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("返回首页")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('footermenu'), _vm._v(" "), _c('footercopyright')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hq-reg-step"
  }, [_c('ul', {
    staticClass: "ico"
  }, [_c('li', [_c('p', {
    staticClass: "item"
  }, [_vm._v("购物车")]), _vm._v(" "), _c('i', {
    staticClass: "step-count"
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "line"
  })]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "item"
  }, [_vm._v("提交订单")]), _vm._v(" "), _c('i', {
    staticClass: "step-count"
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "line"
  })]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "item"
  }, [_vm._v("确认付款")]), _vm._v(" "), _c('i', {
    staticClass: "step-count"
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "line"
  })]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('p', {
    staticClass: "item"
  }, [_vm._v("下单成功")]), _vm._v(" "), _c('i', {
    staticClass: "step-count"
  })])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb20 ad-4 mt20"
  }, [_c('img', {
    attrs: {
      "src": "images/footer-ad-1.png",
      "width": "1200",
      "height": "60"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7Ohe":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "8iXI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterSlogan_vue__ = __webpack_require__("L+8x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_195ff51c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_FooterSlogan_vue__ = __webpack_require__("RSxB");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterSlogan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_195ff51c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_FooterSlogan_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9XVc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_seckillList_vue__ = __webpack_require__("cDO+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0a6fd78_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_seckillList_vue__ = __webpack_require__("aq0g");
function injectStyle (ssrContext) {
  __webpack_require__("H1Ye")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f0a6fd78"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_seckillList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0a6fd78_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_seckillList_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9adc":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "AA4W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TopBar__ = __webpack_require__("5PWk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FooterMenu__ = __webpack_require__("gTlp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ShopNav__ = __webpack_require__("hV6H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FooterCopyright__ = __webpack_require__("3LwO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_HearderNav__ = __webpack_require__("7JIe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Header__ = __webpack_require__("teIl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__static_api_api_js__ = __webpack_require__("fXcb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__ = __webpack_require__("bCJ+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__static_js_emallUtils_js__ = __webpack_require__("spYF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_resource__ = __webpack_require__("ORbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__static_js_jquery_jqzoom_js__ = __webpack_require__("V693");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__static_js_jquery_jqzoom_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__static_js_jquery_jqzoom_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__static_js_jqzoom_base_js__ = __webpack_require__("SP3i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__static_js_jqzoom_base_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__static_js_jqzoom_base_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_date_picker__ = __webpack_require__("M94k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_qrcode__ = __webpack_require__("71e1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_qrcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_qrcode__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







//import jQuery from "../../../static/js/jqzoom.base.js"







//引入滚动和放大插件



__WEBPACK_IMPORTED_MODULE_12_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_12_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_resource__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_12_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18_qrcode___default.a);
/** 
	 * 从 file 域获取 本地图片 url 
	 */
function getFileUrl(obj) {
	var url = void 0;
	url = window.URL.createObjectURL(obj.files.item(0));
	return url;
}
/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'goodsdetail',
	components: {
		'topbar': __WEBPACK_IMPORTED_MODULE_2__components_TopBar__["a" /* default */],
		'shopnav': __WEBPACK_IMPORTED_MODULE_4__components_ShopNav__["a" /* default */],
		'footermenu': __WEBPACK_IMPORTED_MODULE_3__components_FooterMenu__["a" /* default */],
		'footercopyright': __WEBPACK_IMPORTED_MODULE_5__components_FooterCopyright__["a" /* default */],
		'emallheader': __WEBPACK_IMPORTED_MODULE_7__components_Header__["a" /* default */],
		'headernav': __WEBPACK_IMPORTED_MODULE_6__components_HearderNav__["a" /* default */],
		'datepicker': __WEBPACK_IMPORTED_MODULE_17_vue_date_picker___default.a
	},
	data: function data() {
		var _ref;

		return _ref = {
			goodsDetail: {},
			goodsDesc: '',
			goodsName: '',
			goodsPrice: '',
			goodsPrice1: '', //不知道谁占了名字
			goodsCode: '',
			goodsCatNameCn: '',
			goodsNumber: 0,
			shoppingCartNum: '',
			payNum: 1,
			currentNum: '',
			buyGoodsNumber: '',
			isLimitGoodsFlag: '',
			goodsQuota: '',
			priceText: '',
			greenshoeUser: '',
			backUrl: '',
			goodsImgs: [],
			goodsImgLarge: '',
			goodsImgMid: '',
			goodsImgSml: '',
			slider: [{ imgUrl: "" }],
			sliderHeight: '17.8rem',
			goodsLimitMax: '',
			shopCode: '',
			saleNumber: 0,
			inpSaleNumber: 0,
			shopInfo: {},
			//          	shopLogo:'../../static/images/temp/sp-dp-logo.jpg',
			shopLogo: '',
			qqUrl: '',
			breaks: 0,
			creditList: [],
			discount: 0,
			marketPrice: 0,
			catCode: '',
			recommendGoodsList: [],
			distributeName: '',
			distributeAccount: '',
			catList: [],
			isExistFavoriteGoods: 0,
			isExistFavoriteShop: 0,
			goodsBo: {},
			currentPage: 1,
			totalPage: 1,
			isPreview: false,
			brokerDiscountPersent: 0,
			brokerPrice: 0,
			spec: '',
			specName: '',
			specNameEn: '',
			goodRate: null,
			isSpike: 'n',
			computeFlag: '',
			hour: 0,
			minute: 0,
			second: 0,
			isLogin: false,
			shopName: '',
			expressBo: {},
			expressFeeBoList: [],
			expressFeeDesc: '', //运费
			expressMode: '', //运费类别
			expressArea: '', //运费地区
			skuList: [], //类目关联的SKU
			goodsSkuList: [], //商品关联的SKU
			usedSkuArry: [], //商品使用的SKU，二维数组
			goodsSkuMap: new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a() }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'hour', '0'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'minute', '0'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'second', '0'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'activityEndTime', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'seckillPrice', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'pointType', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'unselectSKU', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'chooseGoodsPrice', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'maxPrice', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'minPrice', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'nextSecckill', {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'nextBeginTime', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'canAddToShoppingCart', true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'attachName', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'attachPath', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'orderType', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'printService', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'rebrandingService', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'printingService', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'laserService', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'customize_desc', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'customize_desc', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'remark', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'begin_delivery_time', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'partTypes', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'partChangeList', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'imgNum', 5), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'priceAreaJson', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'produceNum', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'qualitys', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'inspectionTypes', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'quality', 'C'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'inspectionType', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'currDate', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'activeLi', "mallIndex"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'maxBuyNum', 9), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'userIsLogin', true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'vailUserFlag', false), _ref;
	},

	methods: {
		//交期的最小时间为今天
		disabledDate: function disabledDate(date) {
			return date.getTime() < new Date(this.currDate).getTime();
		},

		//获取当前日期
		getCurrDate: function getCurrDate() {
			var currDate = new Date();
			var currMonth = currDate.getMonth() + 1;
			if ((currMonth + "").length < 2) {
				currMonth = "0" + currMonth;
			}
			var currStr = currDate.getFullYear() + "-" + currMonth + "-" + currDate.getDate();
			return currStr;
		},
		chooseQuality: function chooseQuality(quality) {
			this.quality = quality;
		},
		chooseInspection: function chooseInspection(inspectionType) {
			this.inspectionType = inspectionType;
		},
		//控制是否展示部件
		isPartShow: function isPartShow(k, index) {
			var that = this;
			for (var i = 0; i < that.partChangeList.length; i++) {
				if (that.partChangeList[i].name == that.partTypes[index].dictText && i != k) {
					return false;
				}
			}
			return true;
		},
		//删除部件
		delPart: function delPart(index) {
			this.partChangeList.splice(index, 1);
		},
		//添加部件
		addPart: function addPart() {
			var that = this;
			for (var i = 0; i < that.partTypes.length; i++) {
				var flag = true;
				for (var j = 0; j < that.partChangeList.length; j++) {
					if (that.partTypes[i].dictText == that.partChangeList[j].name) {
						flag = false;
						break;
					}
				}
				if (flag) {
					that.partChangeList.push({ name: that.partTypes[i].dictText, value: '' });
					break;
				}
			}
		},
		choosePrint: function choosePrint(printService) {
			var that = this;
			if (that.printService == '') {
				this.printService = printService;
			} else {
				this.printService = '';
			}
		},
		chooseLaster: function chooseLaster(laserService) {
			var that = this;
			if (that.laserService == '') {
				this.laserService = laserService;
			} else {
				this.laserService = '';
			}
		},
		choosePrinting: function choosePrinting(printingService) {
			var that = this;
			if (that.printingService == '') {
				this.printingService = printingService;
			} else {
				this.printingService = '';
			}
		},
		chooseRebranding: function chooseRebranding(rebrandingService) {
			var that = this;
			if (that.rebrandingService == '') {
				this.rebrandingService = rebrandingService;
			} else {
				this.rebrandingService = '';
			}
		},
		changeTab: function changeTab(orderType) {
			//console.log("orderType:"+orderType);
			this.orderType = orderType;
			if (orderType == 'spot') {
				if (this.goodsNumber > this.maxBuyNum) {
					this.payNum = this.maxBuyNum;
				} else {
					this.payNum = this.goodsNumber;
				}
			}
		},
		generateQrcode: function generateQrcode() {
			var that = this;
			var url = __WEBPACK_IMPORTED_MODULE_11__static_js_emallUtils_js__["v" /* mobileGoodsDetailUrl */] + that.goodsCode;
			var canvas = document.getElementById("canvas");
			__WEBPACK_IMPORTED_MODULE_18_qrcode___default.a.toCanvas(canvas, url, { errorCorrectionLevel: "H", width: 120 }, function (error) {
				if (error) console.error(error);
				console.log('success!');
			});
			__WEBPACK_IMPORTED_MODULE_18_qrcode___default.a.toCanvas(canvas, url, { errorCorrectionLevel: "H", width: 120 }, function (error) {
				if (error) console.error(error);
				console.log('success!');
			});
		},
		generatePicQrcode: function generatePicQrcode() {
			var that = this;
			var url = __WEBPACK_IMPORTED_MODULE_11__static_js_emallUtils_js__["w" /* pcGoodsDetailUrl */] + that.goodsCode;
			var canvas = document.getElementById("picCanvas");
			__WEBPACK_IMPORTED_MODULE_18_qrcode___default.a.toCanvas(canvas, url, { errorCorrectionLevel: "H", width: 220 }, function (error) {
				if (error) console.error(error);
				console.log('success!');
			});
			__WEBPACK_IMPORTED_MODULE_18_qrcode___default.a.toCanvas(canvas, url, { errorCorrectionLevel: "H", width: 220 }, function (error) {
				if (error) console.error(error);
				console.log('success!');
			});
		},
		closeqrcode: function closeqrcode() {
			__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#js_qrcode_top").css("z-index", -1);
		},
		closepicqrcode: function closepicqrcode() {
			__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#js_picqrcode_top").css("z-index", -1);
		},
		easyShare: function easyShare(type) {
			var that = this;
			var str = window.location.href;
			var url = encodeURIComponent(str);
			that.closeqrcode();
			that.closepicqrcode();
			if (type == "weibo") {
				window.open("http://service.weibo.com/share/share.php?appkey=&title=" + that.goodsName + "&url=" + url + "&pic=" + that.goodsImgs[0]);
			} else if (type == "qzone") {
				var title = encodeURI(that.goodsName);
				var pics = that.goodsImgs[0];
				window.open("https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=" + url + "&title=" + title + "&pics=" + pics + "&desc=&summary=&site=");
			} else if (type == "weixin") {
				__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#js_qrcode_top").css("z-index", 999);
				that.generateQrcode();
			} else if (type == "picqrcode") {
				__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#js_picqrcode_top").css("z-index", 999);
				that.generatePicQrcode();
			}
		},
		existsSku: function existsSku(specName, index) {
			var tmpArry = this.usedSkuArry[index];
			if (this.usedSkuArry[index] != undefined && this.usedSkuArry[index] != null) {
				for (var i = 0; i < this.usedSkuArry[index].length; i++) {
					if (this.usedSkuArry[index][i] == specName) {
						return true;
					}
				}
			}
			return false;
		},
		//选择规则
		chooseSpec: function chooseSpec(specName, index) {
			var that = this;
			//this.specName = specName;
			var chooseFlag = true; //是否所有的规格都选择了
			that.skuList[index].skuChoosed = specName;
			var skuStr = '';
			var skuEnStr = '';
			var unselectSKU = true;
			for (var i = 0; i < that.skuList.length; i++) {
				if (that.skuList[i].skuChoosed == "") {
					//如果有的规格没选
					chooseFlag = false;
				}
				if (i == 0) {
					skuStr = that.skuList[i].skuChoosed;
					skuEnStr = that.skuList[i].skuValueEn;
				} else {
					skuStr += "_" + that.skuList[i].skuChoosed;
					skuEnStr += "_" + that.skuList[i].skuValueEn;
				}
				if (that.skuList[i].skuChoosed == null || that.skuList[i].skuChoosed == "") {
					unselectSKU = false;
				}
			}
			that.unselectSKU = unselectSKU;
			that.specName = skuStr;
			that.specNameEn = skuEnStr;
			var goodsSku = that.goodsSkuMap.get(skuStr);
			if (goodsSku != undefined) {
				that.goodsNumber = parseInt(goodsSku.goodsNumber);
				//that.saleNumber=parseInt(goodsSku.saleNumber);
				that.goodsPrice = (goodsSku.unitPrice / 100).toFixed(2);
				that.chooseGoodsPrice = goodsSku.unitPrice / 100;
				that.brokerPrice = (goodsSku.unitPrice * that.brokerDiscountPersent / 100 / 100).toFixed(2);
			} /*else{
     if(chooseFlag){
     	that.goodsNumber=0;
     	that.saleNumber=0;
     	that.goodsPrice = 0;
     }
     }*/
			//that.skuList[index].skuChoosed
			var goodsSkuStr = '';
			for (var j = 0; j < that.skuList.length; j++) {
				if (j == 0) {
					goodsSkuStr += that.skuList[j].skuChoosed;
				} else {
					goodsSkuStr += "_" + that.skuList[j].skuChoosed;
				}
			}
			for (var k = 0; k < that.goodsSkuList.length; k++) {
				if (that.goodsSkuList[k].goodsSkuStr == goodsSkuStr) {
					that.priceAreaJson = that.goodsSkuList[k].priceAreaJson;
					if (that.goodsSkuList[k].imgLarge != undefined && that.goodsSkuList[k].imgLarge != "") {
						if (that.goodsSkuList[k].imgLarge.indexOf(";") != -1) {
							var imgLarge = that.goodsSkuList[k].imgLarge.substring(0, that.goodsSkuList[k].imgLarge.length - 1);
							that.goodsImgs = imgLarge.split(";");
							//展示第一张图
							that.goodsImgLarge = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + that.goodsImgs[0];
							for (var m = 0; m < that.goodsImgs.length; m++) {
								that.goodsImgs[m] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + that.goodsImgs[m];
							}
						}
					}
				}
			}
		},
		choosePic: function choosePic(index) {
			this.goodsImgLarge = this.goodsImgs[index];
		},
		showImg: function showImg(creditIdx, gI) {
			__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#" + creditIdx).attr("src", gI);
			__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#" + creditIdx + "_div").show();
		},
		hideImg: function hideImg(creditIdx) {
			__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#" + creditIdx + "_div").hide();
		},
		showAppendImg: function showAppendImg(creditIdx, gI_append) {
			__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#" + creditIdx + '_append').attr("src", gI_append);
			__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#" + creditIdx + "_append_div").show();
		},
		hideAppendImg: function hideAppendImg(creditIdx) {
			__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#" + creditIdx + "_append_div").hide();
		},
		getMore: function getMore(catCode) {
			var that = this;
			that.$router.push({ name: 'goodsList', query: { firstCatCode: catCode } });
		},
		goShop: function goShop(shopCode) {
			this.$router.push({ name: 'shop_index', query: { shopCode: shopCode } });
			//		  	 	this.$router.push({path:'shop_index',params:{shopCode:shopCode}});
		},
		goDetail: function goDetail(goodsCode) {
			this.$router.push({ name: 'goodsdetail', query: { goodsCode: goodsCode } });
			window.location.reload();
		},
		/**
   * 运费情况
   */
		expressChage: function expressChage() {
			var that = this;
			that.expressArea = '';
			var regionArea = __WEBPACK_IMPORTED_MODULE_8_jquery___default()("#expressChage").val();
			if (regionArea == undefined) {
				regionArea = '北京市';
			}
			var expressFeeBoList = that.expressFeeBoList;
			var defaultExpress = "";
			var unit = "kg";
			if (that.expressMode == "counter") {
				var unit = "件";
			}
			if (that.expressMode == "counter" || that.expressMode == "weight") {
				//按件或重量
				for (var i = 0; i < expressFeeBoList.length; i++) {
					var express = expressFeeBoList[i];
					if (express.regionArea == '默认运费') {
						defaultExpress = express.firstNumber + unit + "以下" + express.firstAmount / 100 + "元，超出部分每" + express.addNumber + unit + express.addAmount / 100 + "元";
					}
					if (regionArea == express.regionArea) {
						that.expressArea = express.firstNumber + unit + "以下" + express.firstAmount / 100 + "元，超出部分每" + express.addNumber + unit + express.addAmount / 100 + "元";
					}
				}
			} else if (that.expressMode == "constant") {
				//固定运费
				for (var i = 0; i < expressFeeBoList.length; i++) {
					var expressFee = expressFeeBoList[i];
					if (expressFee.constantFee > 0) {
						that.expressArea = expressFee.constantFee / 100 + "元";
						break;
					}
				}
			}
			//默认运费
			if (that.expressArea == "") {
				that.expressArea = defaultExpress;
			}
			//满XX包邮
			var freePostageMode = that.expressBo.freePostageMode;
			if (freePostageMode != "" && freePostageMode != undefined && freePostageMode != null) {
				for (var i = 0; i < expressFeeBoList.length; i++) {
					var expressFee = expressFeeBoList[i];
					if (expressFee.freePostageAmount > 0) {
						that.expressArea = that.expressArea + "，满" + expressFee.freePostageAmount / 100 + "元包邮";
						break;
					}
				}
			}
		},
		getGoodDetail: function getGoodDetail(goodsCode) {
			var that = this;
			this.$http.jsonp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__static_js_emallUtils_js__["q" /* getAjaxUrl */])() + '/goods/ajax_goods_physical_detail.htm', {
				params: { goodsCode: goodsCode }
			}).then(function (ret) {
				//--------------------取运费-----------------------
				that.expressBo = ret.body.data.expressBo;
				that.qualitys = ret.body.data.qualitys; //品质
				that.inspectionTypes = ret.body.data.inspectionTypes; //验收
				that.partTypes = ret.body.data.partTypes; //产品部件
				that.partChangeList.push({ name: that.partTypes[0].dictText, value: '' });
				that.currDate = ret.body.data.currDate; //系统当前日期
				var expressBo = ret.body.data.expressBo;

				if (expressBo != undefined && expressBo != null) {
					that.expressFeeBoList = expressBo.expressFeeBoList;
					console.log(expressBo);

					if (expressBo.feeMode == "free_postage") {
						//包邮
						that.expressFeeDesc = "包邮";
						that.expressMode = "";
					} else if (expressBo.feeMode == "constant") {
						//固定邮费
						that.expressFeeDesc = "固定邮费";
						that.expressMode = "constant";
						that.expressChage();
					} else if (expressBo.feeMode == "weight") {
						that.expressFeeDesc = "按重量计算";
						that.expressMode = "weight";
						that.expressChage();
					} else if (expressBo.feeMode == "counter") {
						that.expressFeeDesc = "按件计算";
						that.expressMode = "counter";
						that.expressChage();
					} else {
						that.expressFeeDesc = "包邮";
					}
				} else {
					that.expressFeeDesc = "包邮";
				}
				//------------------取商品其它信息--------------------
				var good = ret.body.data.goods;
				if (good != undefined) {
					that.goodsBo = good;
				}

				if (that.orderType == undefined || that.orderType == '') {
					if (good.productType == "meterial") {
						that.orderType = "purchase";
					} else if (good.productType == "sample") {
						that.orderType = "custom";
					} else if (good.productType == "product") {
						that.orderType = "spot";
					} else {
						that.orderType = "custom";
					}
				}
				if (that.orderType == 'spot') {
					if (good.goodsNumber <= 10) {
						//库存小于或等于10时为无现货，默认为订购
						that.orderType = "custom";
					}
				}
				that.nextSecckill = ret.body.data.nextSecckill; //最新的秒杀活动信息
				//设置下场秒杀活动开始时间
				if (that.nextSecckill != undefined) {
					if (that.nextSecckill.activityBeginTime != undefined && that.nextSecckill.activityBeginTime > 0) {
						that.nextBeginTime = that.nextSecckill.activityBeginTime;
					}
				}
				//			 			if(good.attrValue!=undefined && good.attrValue!=""){
				that.goodsDetail = JSON.parse(good.attrValue);
				that.marketPrice = JSON.parse(good.attrValue).marketPrice / 100;
				var isSpike = JSON.parse(good.attrValue).isSpike;
				if (isSpike != undefined && isSpike != '') {
					that.isSpike = isSpike;
				}
				var saleTimeStr = JSON.parse(good.attrValue).saleTimeShow;
				var saleEndTimeStr = JSON.parse(good.attrValue).saleEndTimeShow;

				if (saleEndTimeStr != undefined && saleEndTimeStr != '') {
					saleEndTimeStr = saleEndTimeStr.replace(/-/g, "/");
					var saleEndDate = new Date(saleEndTimeStr);

					saleTimeStr = saleTimeStr.replace(/-/g, "/");
					var saleDate = new Date(saleTimeStr);

					//如果当期日期大于销售结束日期
					if (new Date() > saleEndDate) {
						good.saleStatus = "end";
					} else if (new Date() < saleDate) {
						//如果当期时间小于上架时间，展示距离开始 时间
						good.saleStatus = "wait_start";
						var begSeconds = saleDate.getTime() - new Date().getTime(); //时间差的毫秒数
						//计算出相差天数
						//  								var days=Math.floor(begSeconds/(24*3600*1000));
						//计算出小时数
						var leave1 = begSeconds % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
						var hours = Math.floor(begSeconds / (3600 * 1000));
						//计算相差分钟数
						var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
						var minutes = Math.floor(leave2 / (60 * 1000));
						//计算相差秒数
						var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
						var seconds = Math.round(leave3 / 1000);
						// 									good.day=days;
						that.hour = hours;
						that.minute = minutes;
						that.second = seconds;
					} else {
						good.saleStatus = "on_sale";

						var begSeconds = saleEndDate.getTime() - new Date().getTime(); //时间差的毫秒数
						//计算出相差天数
						//  								var days=Math.floor(begSeconds/(24*3600*1000));
						//计算出小时数
						var leave1 = begSeconds % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
						var hours = Math.floor(begSeconds / (3600 * 1000));
						//计算相差分钟数
						var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
						var minutes = Math.floor(leave2 / (60 * 1000));
						//计算相差秒数
						var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
						var seconds = Math.round(leave3 / 1000);
						// 									good.day=days;
						that.hour = hours;
						that.minute = minutes;
						that.second = seconds;
					}
				}
				//			 			}
				that.attrValue = JSON.parse(good.attrValue);
				//产品详情图片路径添加绝对路径
				that.goodsDesc = good.goodsDesc.replace(/\/upload\//g, __WEBPACK_IMPORTED_MODULE_9__static_api_api_js__["a" /* default */].getImgPath() + "/upload/");
				that.goodsName = good.goodsName;
				that.catCode = good.catCode;
				that.firstCatCode = that.attrValue.firstCatCode;
				that.getRecommendGoods();
				that.seckillPrice = good.seckillPrice;
				if (that.seckillPrice > 0) {
					that.activityEndTime = good.activityEndTime;
				}
				that.spec = JSON.parse(good.attrValue).spec;
				if (that.spec != undefined && that.spec != '') {
					that.specName = that.spec.split(',')[0];
				}
				/*if(ret.body.data.brokerDiscountPersent != undefined){
    that.brokerDiscountPersent=ret.body.data.brokerDiscountPersent;
    that.brokerPrice = (good.unitPrice*that.brokerDiscountPersent/100/100).toFixed(2) ;
    }*/
				//unitPrice 是产品单价
				that.goodsPrice1 = good.goodsPrice;
				that.pointType = good.pointType;
				that.goodsPrice = (good.unitPrice / 100).toFixed(2);
				that.goodsCode = good.goodsCode;
				that.goodsCatNameCn = good.ext3;
				//这个地方估计有坑~
				var imgArray = [];
				if (good.imgLarge.indexOf(";") != -1) {
					good.imgLarge = good.imgLarge.substring(0, good.imgLarge.length - 1);
					that.goodsImgs = good.imgLarge.split(";");
					good.imgLarge = that.goodsImgs[0];
				}
				that.goodsImgLarge = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + good.imgLarge;
				for (var j = 0; j < that.goodsImgs.length; j++) {
					that.goodsImgs[j] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + that.goodsImgs[j];
				}

				//			 			that.goodsImgs.push(that.goodsImgLarge);
				//			 			that.goodsImgs.push(that.goodsImgMid);
				//			 			that.goodsImgs.push(that.goodsImgSml);

				that.goodsNumber = good.goodsNumber;
				that.discount = (that.goodsPrice / that.marketPrice * 10).toFixed(2);
				that.breaks = parseFloat(that.marketPrice - that.goodsPrice).toFixed(2);
				that.saleNumber = good.saleNumber;
				that.inpSaleNumber = good.inpSaleNumber;
				that.shopCode = good.shopCode;
				that.shopName = good.shopName;

				var goodsSkuMap = that.goodsSkuMap;
				var goodsSkuList = ret.body.data.goodsSkuList;

				if (goodsSkuList == null || goodsSkuList.length <= 1) {
					that.unselectSKU = true; //代表规格已经全部选择
				}
				if (goodsSkuList == null) {
					//如果商品未关联SKU
					if (good.priceAreaJson != undefined && good.priceAreaJson != null) {
						that.priceAreaJson = good.priceAreaJson;
					}
				} else {
					//初始化多级报价为第一条SKU里面的值
					that.priceAreaJson = goodsSkuList[0].priceAreaJson;
					if (goodsSkuList[0].priceAreaJson != undefined && goodsSkuList[0].priceAreaJson != null) {
						that.priceAreaJson = goodsSkuList[0].priceAreaJson;
					}
				}
				var defaultSkuArry = ''; //默认选择的SKU
				var usedSkuArry = that.usedSkuArry; //商品使用的SKU，二维数组
				var skuList = ret.body.data.skuList;
				if (skuList != undefined) {
					that.skuList = skuList;
				}
				if (goodsSkuList != undefined) {
					that.goodsSkuList = goodsSkuList;
					var goodsNum = 0;
					var minPrice = 0;
					var maxPrice = 0;
					for (var i = 0; i < goodsSkuList.length; i++) {
						goodsNum += goodsSkuList[i].goodsNumber;
						var tmpArry = goodsSkuList[i].goodsSkuStr.split("_");
						for (var o = 0; o < tmpArry.length; o++) {
							if (i == 0) {
								usedSkuArry.push(new Array(tmpArry[o]));
							} else {
								usedSkuArry[o].push(tmpArry[o]);
							}
							for (var m = 0; m < skuList.length; m++) {
								if (skuList[m].skuValue.indexOf(tmpArry[o]) == -1) {
									skuList[m].skuValue += "," + tmpArry[o];
								}
							}
						}
						goodsSkuMap.set(goodsSkuList[i].goodsSkuStr, goodsSkuList[i]);
						if (goodsSkuList[i].isDefault == 'y') {

							//if(goodsSkuList.length<=1){
							that.unselectSKU = true; //选择了默认的SKU
							that.specName = goodsSkuList[i].goodsSkuStr;
							that.specNameEn = goodsSkuList[i].goodsSkuStrEn;
							that.goodsNumber = parseInt(goodsSkuList[i].goodsNumber);
							//that.saleNumber=parseInt(goodsSkuList[i].saleNumber);
							defaultSkuArry = goodsSkuList[i].goodsSkuStr.split("_");
							//}
						}
						if (i == 0 || minPrice > goodsSkuList[i].unitPrice / 100) {
							minPrice = goodsSkuList[i].unitPrice / 100;
						}
						if (goodsSkuList[i].unitPrice / 100 > maxPrice) {
							maxPrice = goodsSkuList[i].unitPrice / 100;
						}
					}
					that.goodsPrice = minPrice.toFixed(2);
					that.brokerPrice = (minPrice * that.brokerDiscountPersent / 100).toFixed(2);
					//							that.goodsNumber = goodsNum;
					that.maxPrice = maxPrice;
					that.minPrice = minPrice;
				} else {
					that.chooseGoodsPrice = good.unitPrice;
				}
				//库存小于或等于10的现货商品，默认展示订购页面
				if ((that.goodsBo.goodsNumber == undefined || that.goodsBo.goodsNumber <= 10) && that.orderType == 'spot') {
					that.orderType = "custom";
				}

				if (skuList != undefined && skuList != '') {
					//没看仔细看逻辑  这里可能为空
					for (var m = 0; m < skuList.length; m++) {
						if (defaultSkuArry.length >= m) {

							skuList[m].skuChoosed = defaultSkuArry[m];
						}
					}
				}
				console.log(usedSkuArry);
				that.getShopInfo(good.shopCode);
				//店铺是否收藏
				that.existFavoriteShop();
				that.computeFlag = window.setInterval(function () {
					that.computeTime(); //计算倒计时
				}, 1000);
				//判断商品是否虚拟商品firstCatCode"virtual_commodity"
				if (that.goodsDetail.firstCatCode != undefined && that.goodsDetail.firstCatCode == "virtual_commodity") {
					that.canAddToShoppingCart = false;
				}
			}, function (err) {
				//			 			alertConfirm.singleConfirm("异步请求操作失败")
			});
		},
		getGoodCredits: function getGoodCredits(goodsCode, currentPage, pageSize) {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_9__static_api_api_js__["a" /* default */].getGoodCredits(goodsCode, currentPage, pageSize, function (ret) {
				if (ret.code == "success") {
					var goodRate = ret.data.goodRate;
					if (goodRate != undefined) {
						that.goodRate = goodRate;
					}
					var creditList = ret.data.creditBos;
					for (var i = 0; i < creditList.length; i++) {
						var gmtCreate = creditList[i].gmtCreate + "";
						var yy = gmtCreate.substring(0, 4);
						var mm = gmtCreate.substring(4, 6);
						var dd = gmtCreate.substring(6, 8);
						var hh = gmtCreate.substring(8, 10);
						var MM = gmtCreate.substring(10, 12);
						var ss = gmtCreate.substring(12, 14);
						var dataStr = yy + "." + mm + "." + dd + " " + hh + ":" + MM + ":" + ss;
						creditList[i].dataStr = dataStr;

						var buyerName = creditList[i].buyerAccount;
						if (buyerName != undefined && buyerName.length > 1) {
							buyerName = buyerName.substr(0, 1) + "****" + buyerName.substr(-1);
						}
						creditList[i].buyerName = buyerName;
						var imgs = creditList[i].ext1;
						if (imgs != undefined && imgs != "") {
							creditList[i].creditImgs = imgs.split(";");
							//alertConfirm.singleConfirm(creditList[i].creditImgs);
							for (var j = 0; j < creditList[i].creditImgs.length; j++) {
								if (creditList[i].creditImgs[j] != undefined && creditList[i].creditImgs[j] != "") {
									creditList[i].creditImgs[j] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + creditList[i].creditImgs[j];
								} else {
									creditList[i].creditImgs.splice(j, 1);
								}
							}
						}

						var appendimgs = creditList[i].ext3;
						if (appendimgs != undefined && appendimgs != "") {
							creditList[i].appendImgs = appendimgs.split(";");
							//alertConfirm.singleConfirm(creditList[i].creditImgs);
							for (var j = 0; j < creditList[i].appendImgs.length; j++) {
								if (creditList[i].appendImgs[j] != undefined && creditList[i].appendImgs[j] != "") {
									creditList[i].appendImgs[j] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + creditList[i].appendImgs[j];
								} else {
									creditList[i].appendImgs.splice(j, 1);
								}
							}
						}
					}
					that.creditList = creditList;
				}
			});
		},
		getGoodDetails: function getGoodDetails(goodsCode) {
			this.$router.push({ path: 'goodsDetails', query: { goodsCode: goodsCode } });
		},
		getGoodList: function getGoodList(catCode, catNameCn) {
			this.$router.push({ path: 'goodsList', query: { catCode: catCode, catNameCn: catNameCn } });
		},
		getShoppingCartNum: function getShoppingCartNum(shopCode) {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_9__static_api_api_js__["a" /* default */].getShoppingCartNum(function (ret) {
				that.shoppingCartNum = ret.data.shoppingCartNum;
			});
		},
		getShopInfo: function getShopInfo(shopCode) {
			var that = this;
			this.$http.jsonp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__static_js_emallUtils_js__["q" /* getAjaxUrl */])() + '/shop/ajax_shop_index.htm', {
				params: { shopCode: shopCode }
			}).then(function (ret) {
				if (ret.body.code == "success") {
					var info = ret.body.data.shopBo;
					that.shopInfo = info;
					if (info.shopLogo != undefined && info.shopLogo != "") {
						that.shopLogo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + info.shopLogo;
					}
					if (info.qq == undefined || info.qq == '') {
						that.qqUrl = "javascript:volid(0);";
					} else {
						that.qqUrl = "http://wpa.qq.com/msgrd?v=3&site=qq&menu=yes&uin=" + info.qq;
					}
				}
			}, function (err) {
				//			 			alertConfirm.singleConfirm("异步查询店铺信息失败")
			});
		},
		addPayNum: function addPayNum() {
			this.payNum = parseInt(this.payNum) + 1;
			if (this.orderType == 'spot' && (this.payNum > this.goodsNumber || this.payNum > this.maxBuyNum)) {
				__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm("请选择订购业务", function () {});
				if (this.goodsNumber > this.maxBuyNum) {
					this.payNum = this.maxBuyNum;
				} else {
					this.payNum = this.goodsNumber;
				}
				return false;
			}
		},
		subPayNum: function subPayNum() {
			if (this.payNum > 1) {
				this.payNum = parseInt(this.payNum) - 1;
			}
		},
		setPayNum: function setPayNum() {
			var _payNum = parseInt(__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#payNum").val());
			//只是现货商品才需要控制订单的购买数量
			if (this.orderType == 'spot' && (_payNum > this.goodsNumber || _payNum > this.maxBuyNum)) {
				__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm("请选择订购业务", function () {});
				if (this.goodsNumber > this.maxBuyNum) {
					this.payNum = this.maxBuyNum;
				} else {
					this.payNum = this.goodsNumber;
				}
				return false;
			} else if (_payNum <= 0) {
				this.payNum = 1;
				return false;
			}
			this.payNum = _payNum;
		},
		setProduceNum: function setProduceNum() {
			var _produceNum = parseInt(__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#produceNum").val());
			//只是现货商品才需要控制订单的购买数量
			if (_produceNum <= 0) {
				this.produceNum = 1;
				return false;
			}
			this.produceNum = _produceNum;
		},
		//订购申请
		customizeApply: function customizeApply(applyType) {
			var that = this;
			var customize_desc = that.customize_desc;
			if (applyType == 'subscribe') {
				if (customize_desc == undefined || customize_desc == '') {
					/*alertConfirm.singleConfirm("请录入订购说明！");
     return;*/
				} else {
					customize_desc = encodeURI(customize_desc);
				}
			}
			var remark = '';
			if (that.remark == '') {
				/*alertConfirm.singleConfirm("请录入备注！");
    return;*/
			} else {
				remark = encodeURI(that.remark);
			}
			var deleveryTime = '';
			var begin_delivery_time = __WEBPACK_IMPORTED_MODULE_8_jquery___default()("input[name='begin_delivery_time']").val();
			if (begin_delivery_time == '') {
				__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm("请录入交期！");
				return;
			} else {
				deleveryTime = begin_delivery_time.replace('-', '').replace('-', '');
			}
			var specName = '';
			if (that.specName != '') {
				specName = encodeURI(that.specName);
			}
			var specNameEn = '';
			if (that.specNameEn != '') {
				specNameEn = encodeURI(that.specNameEn);
			}
			var accessory_change_json = '';
			//var changeList = [];
			//打样要求
			var changeJsonStr = '';
			if (that.partChangeList != undefined && that.partChangeList.length > 0 && that.partChangeList[0].value != "") {
				changeJsonStr = '{';
				for (var i = 0; i < that.partChangeList.length; i++) {
					/*changeList.push({
     	name: encodeURI(that.partChangeList[i].name),
     	value: encodeURI(that.partChangeList[i].value)
     });*/
					if (that.partChangeList[i].value != "") {
						changeJsonStr += '"' + encodeURI(that.partChangeList[i].name) + '":"' + encodeURI(that.partChangeList[i].value) + '"';
						if (that.partChangeList.length > 1 && i < that.partChangeList.length - 1) {
							changeJsonStr += ',';
						}
					}
				}
				changeJsonStr += '}';
				/*accessory_change_json = JSON.stringify(changeList);*/
			}
			var formData = new FormData(__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#addFileForm")[0]);
			__WEBPACK_IMPORTED_MODULE_8_jquery___default.a.ajax({
				url: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__static_js_emallUtils_js__["q" /* getAjaxUrl */])() + '/demand/attachment_upload.htm',
				type: 'POST',
				data: formData,
				async: false,
				cache: false,
				contentType: false, // 告诉jQuery不要去设置Content-Type请求头  
				processData: false, // 告诉jQuery不要去处理发送的数据  
				success: function success(result) {
					result = eval('(' + result + ')');
					if (result.code == "success") {
						var fileName = "";
						if (result.data.fileName != undefined && result.data.fileName != "") {
							fileName = encodeURI(result.data.fileName);
						}
						var filePath = result.data.filePath;
						if (applyType == 'subscribe') {
							//订购申请,applyType:subscribe
							__WEBPACK_IMPORTED_MODULE_9__static_api_api_js__["a" /* default */].customizeApply("goods", applyType, customize_desc, remark, deleveryTime, that.goodsDetail.qualityService, 'wait', that.payNum, changeJsonStr, that.goodsCode, specName, '', '', fileName, filePath, function (ret) {
								if (ret.code != null && ret.code == "success") {
									__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm("订购申请提交成功");
									//window.location.reload();
								} else if (ret.code != null && ret.code == "9999") {
									__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm("请先登陆！");
									window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/login.htm';
									return false;
								} else if (ret) {
									var errorCode = ret.code;
									var errorMsg = '系统繁忙，请稍后再试';
									__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm(errorMsg);
								}
							});
						} else {
							//打样申请，需要传图片
							var formData2 = new FormData(__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#addTextForm")[0]);
							__WEBPACK_IMPORTED_MODULE_8_jquery___default.a.ajax({
								url: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__static_js_emallUtils_js__["q" /* getAjaxUrl */])() + '/demand/multi_img_upload.htm',
								type: 'POST',
								data: formData2,
								async: false,
								cache: false,
								contentType: false, // 告诉jQuery不要去设置Content-Type请求头  
								processData: false, // 告诉jQuery不要去处理发送的数据  
								success: function success(result2) {
									result2 = eval('(' + result2 + ')');
									if (result2.code == "success") {

										var imageName = "";
										if (result2.data.imgName != undefined && result2.data.imgName != "") {
											imageName = encodeURI(result2.data.imgName);
										}
										var imagePath = result2.data.imgPath;
										customize_desc = ""; //打样申请,不需要传 订购说明 这个参数
										//打样申请,applyType:proof
										__WEBPACK_IMPORTED_MODULE_9__static_api_api_js__["a" /* default */].customizeApply("goods", applyType, customize_desc, remark, deleveryTime, that.quality, 'wait', that.payNum, changeJsonStr, that.goodsCode, specName, imageName, imagePath, fileName, filePath, function (ret) {
											if (ret.code != null && ret.code == "success") {
												__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm("打样申请提交成功");
												//window.location.reload();
											} else if (ret.code != null && ret.code == "9999") {
												__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm("请先登陆！");
												window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/login.htm';
												return false;
											} else if (ret) {
												var errorCode = ret.code;
												var errorMsg = '系统繁忙，请稍后再试';
												__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm(errorMsg);
											}
										});
									} else {
										__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm(result.msg);
									}
								},
								error: function error(ret) {
									__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm("图片上传失败！");
								}
							});
						}
					} else {
						__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm(result.msg);
					}
				},
				error: function error(ret) {
					__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm("附件上传失败！");
				}
			});
		},
		payOrder: function payOrder() {
			if (!this.unselectSKU) {
				__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm("请选择商品属性！");
				return;
			}
			var that = this;
			var priceNum = that.goodsPrice;
			if (priceNum === undefined || priceNum === "0") {
				__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm("商品暂无报价，请联系客服");
				return false;
			}
			var goodsCode = this.goodsCode;
			if (that.orderType == "spot") {
				//现货下单，表单验证
				if (this.goodsNumber === 0) {
					return;
				}
				var that = this;
				var num = __WEBPACK_IMPORTED_MODULE_8_jquery___default()("#payNum").val();
				if (num < 1) {
					__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm("购买数量不能为 0");
					return false;
				}
				var payNum = parseInt(that.payNum);
				if (this.orderType == 'spot' && parseInt(this.payNum) > this.goodsNumber) {
					__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm("请选择订购业务");
					this.payNum = this.goodsNumber;
					return false;
				}
			}
			if (that.orderType == "purchase") {
				//采购订单，表单验证
				var produceNum = that.produceNum;
				if (produceNum == null || produceNum < 1) {
					__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm("请录入正整数的生产数量");
					return false;
				}
				if (that.quality == '') {
					__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm("请选择品质服务");
					return false;
				}
				if (that.inspectionType == '') {
					__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm("请选择验货方式");
					return false;
				}
				var remark = '';
				if (that.remark == '') {
					__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm("请录入加工说明");
					return false;
				} else {
					remark = encodeURI(that.remark);
				}
			}

			__WEBPACK_IMPORTED_MODULE_9__static_api_api_js__["a" /* default */].checkUnpaidOrder(goodsCode, function (ret) {
				if (ret.code == "9999" && ret.msg == "auth vaild fail!") {
					__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm("请登陆", function () {
						window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/login.htm';
					});
					return false;
				}

				var payNum = parseInt(that.payNum);
				var surplusNumberVal = that.goodsBo.goodsNumber;

				var currentNum = that.currentNum;
				var buyGoodsNumber = that.buyGoodsNumber;
				var goodsLimitMax = that.goodsDetail.goodsLimitMax;
				var goodsLimit = that.goodsDetail.goodsLimit;
				var saleTime = that.goodsDetail.saleTime;
				var goodsQuota = that.goodsQuota;
				var isLimitGoodsFlag = that.isLimitGoodsFlag;

				var supplerAccount = that.goodsDetail.supplerAccount;
				var shopAccount = that.goodsDetail.shopAccount;
				var goodsAttrValue = that.goodsDetail.attrValue;
				if (that.orderType == "spot") {
					//现货下单
					var formData = new FormData(__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#addFileForm")[0]);
					__WEBPACK_IMPORTED_MODULE_8_jquery___default.a.ajax({
						url: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__static_js_emallUtils_js__["q" /* getAjaxUrl */])() + '/demand/attachment_upload.htm',
						type: 'POST',
						data: formData,
						async: false,
						cache: false,
						contentType: false, // 告诉jQuery不要去设置Content-Type请求头  
						processData: false, // 告诉jQuery不要去处理发送的数据  
						success: function success(result) {
							result = eval('(' + result + ')');
							if (result.code == "success") {
								var fileName = "";
								if (result.data.fileName != undefined && result.data.fileName != "") {
									fileName = encodeURI(result.data.fileName);
								}
								var filePath = result.data.filePath;
								that.$router.push({
									name: 'ordercommit',
									query: {
										goodsCode: goodsCode,
										shopCode: that.shopCode,
										shopName: that.shopName,
										payNum: payNum,
										orderSource: "noCart",
										distributeAccount: that.distributeAccount,
										distributeName: that.distributeName,
										specName: that.specName,
										printServicePara: that.printService,
										fileNamePara: fileName,
										filePathPara: filePath,
										orderType: that.orderType
									}
								});
							} else {
								__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm(result.msg);
							}
						},
						error: function error(ret) {
							__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm("附件上传失败！");
						}
					});
				} else if (that.orderType == "purchase") {
					//采购订单
					var formData = new FormData(__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#addTextForm")[0]);
					__WEBPACK_IMPORTED_MODULE_8_jquery___default.a.ajax({
						url: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__static_js_emallUtils_js__["q" /* getAjaxUrl */])() + '/demand/multi_img_upload.htm',
						type: 'POST',
						data: formData,
						async: false,
						cache: false,
						contentType: false, // 告诉jQuery不要去设置Content-Type请求头  
						processData: false, // 告诉jQuery不要去处理发送的数据  
						success: function success(result) {
							result = eval('(' + result + ')');
							if (result.code == "success") {
								var imageName = "";
								if (result.data.imgName != undefined && result.data.imgName != "") {
									imageName = encodeURI(result.data.imgName);
								}
								var imagePath = result.data.imgPath;
								that.$router.push({
									name: 'ordercommit',
									query: {
										goodsCode: goodsCode,
										shopCode: that.shopCode,
										shopName: that.shopName,
										payNum: that.produceNum,
										orderSource: "noCart",
										distributeAccount: that.distributeAccount,
										distributeName: that.distributeName,
										specName: that.specName,
										rebrandingServicePara: that.rebrandingService, //换标服务
										printingServicePara: that.printingService, //印花服务
										laserServicePara: that.laserService, //激光服务
										imageNamePara: imageName,
										imagePathPara: imagePath,
										orderType: that.orderType
									}
								});
							} else {
								__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm(result.msg);
							}
						},
						error: function error(ret) {
							__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm("图片上传失败！");
						}
					});
				}
			});
		},
		refreshGoods: function refreshGoods() {
			if (this.currentPage < this.totalPage) {
				this.currentPage += 1;
			} else if (this.currentPage == this.totalPage) {
				this.currentPage = 1;
			}
			this.getRecommendGoods();
		},
		getRecommendGoods: function getRecommendGoods() {
			var that = this;
			var interval = "intervalAll";
			var catCode = that.catCode;
			var cabinetId = "";
			var pageSize = 5;
			var isQueryAll = "n";
			var currentPage = that.currentPage;
			var orderBy = "sale_number";
			var orderAsc = "desc";
			var shopCode = "";
			var sortTime = "";
			var goodsName = "";
			var firstCatCode = "";
			var brandId = 0;
			var productType = "";
			var orderType = "";
			__WEBPACK_IMPORTED_MODULE_9__static_api_api_js__["a" /* default */].getGoodsList(cabinetId, catCode, interval, currentPage, orderBy, orderAsc, shopCode, sortTime, pageSize, isQueryAll, goodsName, firstCatCode, brandId, productType, orderType, function (ret) {
				if (ret.code == "success") {
					that.totalPage = ret.data.totalPage;
					var goods = ret.data.goods;
					if (goods != undefined) {
						for (var i = 0; i < goods.length; i++) {
							//商品图片
							var imgMiddle = goods[i].imgMiddle;
							if (imgMiddle.indexOf(";") != -1) {
								imgMiddle = imgMiddle.split(";")[0];
							}
							imgMiddle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + imgMiddle;
							goods[i].imgMiddle = imgMiddle;
						}
					}
					that.recommendGoodsList = goods;
				}
			});
		},
		addToShoppingCart: function addToShoppingCart() {
			if (!this.unselectSKU) {
				__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm("请选择商品属性！");
				return;
			}
			if (this.goodsNumber === 0) {
				return;
			}
			var that = this;
			var priceNum = that.goodsPrice;
			if (priceNum === undefined || priceNum === "0") {
				__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm("商品暂无报价，请联系客服");
				return false;
			}
			var specName = that.specName;
			if (specName != undefined && specName != '') {
				specName = encodeURI(specName);
			}
			var specNameEn = that.specNameEn;
			if (specNameEn != undefined && specNameEn != '') {
				specNameEn = encodeURI(specNameEn);
			}
			var goodsCode = that.goodsCode;
			var operationDesc = "加入购物车";
			var num = __WEBPACK_IMPORTED_MODULE_8_jquery___default()("#payNum").val();
			if (num < 1) {
				__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm("购买数量不能为 0");
				return false;
			}
			__WEBPACK_IMPORTED_MODULE_9__static_api_api_js__["a" /* default */].checkUnpaidOrder(goodsCode, function (ret) {
				if (ret.code != undefined && ret.code == '9999') {
					window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/login.htm';
					return false;
				}
				var payNum = parseInt(that.payNum);
				var surplusNumberVal = that.goodsDetail.goodsNumber;
				var currentNum = that.currentNum;
				var buyGoodsNumber = that.buyGoodsNumber;
				var goodsLimitMax = that.goodsDetail.goodsLimitMax;
				var goodsLimit = that.goodsDetail.goodsLimit;
				var saleTime = that.goodsDetail.saleTime;
				var goodsQuota = that.goodsQuota;
				var isLimitGoodsFlag = that.isLimitGoodsFlag;

				var supplerAccount = that.goodsDetail.supplerAccount;
				var shopAccount = that.goodsDetail.shopAccount;
				var goodsAttrValue = that.goodsDetail.attrValue;
				if (supplerAccount == undefined) {
					supplerAccount = '';
				}
				if (shopAccount == undefined) {
					shopAccount = '';
				}
				if (goodsAttrValue == undefined) {
					goodsAttrValue = '';
				}
				if (Date.parse(saleTime) > new Date()) {
					__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm('商品尚未起售');
				} else if (isLimitGoodsFlag && parseInt(goodsQuota) < parseInt(payNum)) {
					__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm('数量超过限购数量');
				} else if (parseInt(payNum) > parseInt(surplusNumberVal)) {
					__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm(operationDesc + '数量超过可购买数量');
				} else if (goodsLimitMax != '0' && parseInt(payNum) > parseInt(goodsLimitMax) - parseInt(buyGoodsNumber)) {
					__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm(operationDesc + '数量超过限购数量');
				} else if (parseInt(payNum) < goodsLimit) {
					__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm(operationDesc + '数量小于起够数量');
				} else if (parseInt(payNum) * parseInt(priceNum) > parseInt(currentNum)) {
					__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm(operationDesc + '总积分超过可用积分');
				} else if (parseInt(payNum) > 99) {
					__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm(operationDesc + '数量不得超过99');
				} else {
					__WEBPACK_IMPORTED_MODULE_9__static_api_api_js__["a" /* default */].addShoppingCart(goodsCode, payNum, supplerAccount, goodsAttrValue, shopAccount, specName, specNameEn, function (ret) {
						if (ret.code == "success") {
							__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm("商品加入购物车成功");
							that.$refs.c1.getShoppingCartNum();
							that.$refs.c1.getShoppingCartList();
						} else {
							__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm(ret.msg);
						}
					});
				}
			});
		},
		goIndex: function goIndex() {
			this.$router.push({ name: 'index' });
		},
		getCatGoods: function getCatGoods(catCode) {
			this.$router.push({ name: 'goodsList', params: { catCode: catCode } });
		},
		getCat: function getCat() {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_9__static_api_api_js__["a" /* default */].getAllCat('', function (ret) {
				if (ret.code == "success") {
					that.catList = ret.data.firstCatList;
				}
			});
		},
		getVailUserFlag: function getVailUserFlag() {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_9__static_api_api_js__["a" /* default */].vailUserInfo(function (ret) {
				//
				if (ret.code != null && ret.code == "success") {
					if (ret.data.vailUserFlag == true) {
						//alertConfirm.singleConfirm("打样申请提交成功，请进行信息完善.",function(){
						//	window.location.href = getUcUrl() + "/user/edit_userinfo.htm";
						//});
						//设置状态
						that.vailUserFlag = true;
					} else {
						//alertConfirm.singleConfirm("打样申请提交成功");
						//window.location.reload();
						//设置状态
						that.vailUserFlag = false;
					}
					that.userIsLogin = true;
				} else if (ret.code != null && ret.code == "9999") {
					//alertConfirm.singleConfirm("请先登陆！");
					//window.location.href = getUcUrl() + '/login.htm';
					that.userIsLogin = false;
					return false;
				} else if (ret) {
					var errorCode = ret.code;
					var errorMsg = '系统繁忙，请稍后再试';
					__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm(errorMsg);
				}
			});
		},
		toEditUserInfo: function toEditUserInfo() {
			window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__static_js_emallUtils_js__["a" /* getUcUrl */])() + "/user/edit_userinfo.htm";
		},
		toUserLogin: function toUserLogin() {
			window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__static_js_emallUtils_js__["a" /* getUcUrl */])() + "/login.htm";
		},
		//      	sharePage:function(){
		//      		LightSDK.native.share({
		//				    title:"分享的标题",
		//				    content:"分享的内容简介",
		//				    url:"https://www.baidu.com/", //分享出去的链接打开后显示的地址
		//				    image:"https://passport.hscloud.cn/iuccasserver/statics/images/lght.jpg" //分享出去的图片
		//				},function(data){
		//				    if(data.error_no!="0"){
		//				        alertConfirm.singleConfirm(data.error_info);
		//				        return false;
		//				    }else{
		//				        console.log(data);//your code
		//				    }
		//				});
		//      	}

		addOrDeleteFavoriteGoods: function addOrDeleteFavoriteGoods() {
			var that = this;
			var goodsCode = that.goodsCode;
			if (0 == that.isExistFavoriteGoods) {
				__WEBPACK_IMPORTED_MODULE_9__static_api_api_js__["a" /* default */].addUserFavorite("goods", goodsCode, null, function (ret) {
					if (ret.code == "9999" && ret.msg == "auth vaild fail!") {
						__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm("对不起,先登陆！");
						window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/login.htm';
						return false;
					}
					if (ret.code != null && ret.code == "success") {
						that.isExistFavoriteGoods = 1;
					} else {
						__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm(ret.msg);
					}
				});
			} else if (1 == that.isExistFavoriteGoods) {
				__WEBPACK_IMPORTED_MODULE_9__static_api_api_js__["a" /* default */].deleteFavoriteBycode("goods", goodsCode, null, function (ret) {
					if (ret.code == "9999" && ret.msg == "auth vaild fail!") {
						__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm("对不起,先登陆！");
						window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/login.htm';
						return false;
					}
					if (ret.code != null && ret.code == "success") {
						that.isExistFavoriteGoods = 0;
					} else {
						__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm(ret.msg);
					}
				});
			}
		},
		addOrDeleteFavoriteShop: function addOrDeleteFavoriteShop() {
			var that = this;
			var shopCode = that.shopCode;
			if (0 == that.isExistFavoriteShop) {
				__WEBPACK_IMPORTED_MODULE_9__static_api_api_js__["a" /* default */].addUserFavorite("shop", null, shopCode, function (ret) {
					if (ret.code == "9999" && ret.msg == "auth vaild fail!") {
						__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm("对不起,先登陆！");
						window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/login.htm';
						return false;
					}
					if (ret.code != null && ret.code == "success") {
						that.isExistFavoriteShop = 1;
					} else {
						__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm(ret.msg);
					}
				});
			} else if (1 == that.isExistFavoriteShop) {
				__WEBPACK_IMPORTED_MODULE_9__static_api_api_js__["a" /* default */].deleteFavoriteBycode("shop", null, shopCode, function (ret) {
					if (ret.code == "9999" && ret.msg == "auth vaild fail!") {
						__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm("对不起,先登陆！");
						window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/login.htm';
						return false;
					}
					if (ret.code != null && ret.code == "success") {
						that.isExistFavoriteShop = 0;
					} else {
						__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm(ret.msg);
					}
				});
			}
		},
		existFavoriteGoods: function existFavoriteGoods() {
			var that = this;
			var goodsCode = that.goodsCode;
			__WEBPACK_IMPORTED_MODULE_9__static_api_api_js__["a" /* default */].isExistFavorite("goods", goodsCode, null, function (ret) {
				if (ret.code != null && ret.code == "success") {
					that.isExistFavoriteGoods = ret.data.isExist;
				} else {
					console.log("existFavorite：" + ret.msg);
				}
			});
		},
		existFavoriteShop: function existFavoriteShop() {
			var that = this;
			var shopCode = that.shopCode;
			__WEBPACK_IMPORTED_MODULE_9__static_api_api_js__["a" /* default */].isExistFavorite("shop", null, shopCode, function (ret) {
				if (ret.code != null && ret.code == "success") {
					that.isExistFavoriteShop = ret.data.isExist;
				} else {
					console.log("existFavorite：" + ret.msg);
				}
			});
		},
		previewGoods: function previewGoods(goodsCode) {
			console.log(1);
			var that = this;
			__WEBPACK_IMPORTED_MODULE_9__static_api_api_js__["a" /* default */].viewGoodsDetail(goodsCode, function (ret) {
				if (ret.code == "success") {
					var good = ret.data.goods;
					if (good != undefined) {
						that.goodsBo = good;
					}
					that.goodsDetail = JSON.parse(good.attrValue);
					that.marketPrice = JSON.parse(good.attrValue).marketPrice / 100;
					//			 			}
					//产品详情图片路径添加绝对路径
					that.goodsDesc = good.goodsDesc.replace(/\/upload\//g, __WEBPACK_IMPORTED_MODULE_9__static_api_api_js__["a" /* default */].getImgPath() + "/upload/");
					that.goodsName = good.goodsName;
					that.catCode = good.catCode;
					//unitPrice 是产品单价
					that.goodsPrice = (good.unitPrice / 100).toFixed(2);
					that.goodsCode = good.goodsCode;
					that.goodsCatNameCn = good.ext3;
					//这个地方估计有坑~
					var imgArray = [];
					if (good.imgLarge.indexOf(";") != -1) {
						good.imgLarge = good.imgLarge.substring(0, good.imgLarge.length - 1);
						that.goodsImgs = good.imgLarge.split(";");
						good.imgLarge = that.goodsImgs[0];
					}

					that.goodsImgLarge = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + good.imgLarge;
					for (var j = 0; j < that.goodsImgs.length; j++) {
						that.goodsImgs[j] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + that.goodsImgs[j];
					}

					that.goodsNumber = good.goodsNumber;
					that.discount = (that.goodsPrice / that.marketPrice * 10).toFixed(2);
					that.breaks = parseFloat(that.marketPrice - that.goodsPrice).toFixed(2);
					that.saleNumber = good.saleNumber;
					that.inpSaleNumber = good.inpSaleNumber;
				}
			});
		},
		viewExpressFees: function viewExpressFees() {
			var that = this;
			window.open(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__static_js_emallUtils_js__["b" /* getEmallUrl */])() + '/expresspManage/express_set_view.htm?shopCode=' + that.shopCode);
		},
		computeTime: function computeTime() {
			var that = this;
			var activityEndTime = new Date(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__static_js_emallUtils_js__["r" /* dateFormat */])(that.activityEndTime).replace(/-/g, "/"));
			var begSeconds = activityEndTime.getTime() - new Date().getTime(); //时间差的毫秒数
			//计算出小时数
			var leave1 = begSeconds % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
			var hours = Math.floor(begSeconds / (3600 * 1000));
			//计算相差分钟数
			var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
			var minutes = Math.floor(leave2 / (60 * 1000));
			//计算相差秒数
			var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
			var seconds = Math.round(leave3 / 1000);
			that.hour = hours + "";
			that.minute = minutes + "";
			that.second = seconds + "";
		},
		handleScroll: function handleScroll(e) {
			if (Math.abs(e.currentTarget.scrollY) > 300) {
				__WEBPACK_IMPORTED_MODULE_8_jquery___default()(".top").show();
			} else {
				__WEBPACK_IMPORTED_MODULE_8_jquery___default()(".top").hide();
			}
		},
		scrollToTop: function scrollToTop() {
			__WEBPACK_IMPORTED_MODULE_8_jquery___default()("html,body").animate({
				scrollTop: 0
			}, 500);
		},
		//根据点击上传按钮触发input
		change_input: function change_input() {
			var inputArr = __WEBPACK_IMPORTED_MODULE_8_jquery___default()('#addTextForm input');
			var add_inputId = ''; //需要被触发的input
			for (var i = 0; i < inputArr.length; i++) {
				// 根据input的value值判断是否已经选择文件
				if (!inputArr[i].value) {
					//如果没有选择,获得这个input的ID      
					add_inputId = inputArr[i].id;
					break;
				}
			}
			if (add_inputId) {
				//如果需要被触发的input ID存在,将对应的input触发
				return __WEBPACK_IMPORTED_MODULE_8_jquery___default()("#" + add_inputId).click();
			} else {
				__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm("最多选择" + this.imgNum + "张图片");
			}
		},

		//当input选择了图片的时候触发,将获得的src赋值到相对应的img
		setImg: function setImg(e) {
			var target = e.target;
			__WEBPACK_IMPORTED_MODULE_8_jquery___default()('#img_' + target.id).attr('src', getFileUrl(e.srcElement));
			__WEBPACK_IMPORTED_MODULE_8_jquery___default()('#img_' + target.id).show();
		},

		//点击图片删除该图片并清除相对的input
		deleteImg: function deleteImg(e) {
			var target = e.target;
			var inputID = ''; //需要清除value的input
			if (target.nodeName == 'IMG') {
				target.src = '';
				inputID = target.id.replace('img_', ''); //获得需要清除value的input
				__WEBPACK_IMPORTED_MODULE_8_jquery___default()('input#' + inputID).val("");
			}
		},
		setFileName: function setFileName(e) {
			/*let target = e.target;
   var file=jQuery('#' + target.id).files;
   var fileName=jQuery('#' + target.id).files[0].name;
   jQuery('#file_' + target.id).show();*/
		},

		//根据点击上传按钮触发input
		change_File: function change_File() {
			var inputArr = __WEBPACK_IMPORTED_MODULE_8_jquery___default()('#addFileForm input');
			var add_inputId = ''; //需要被触发的input
			for (var i = 0; i < inputArr.length; i++) {
				// 根据input的value值判断是否已经选择文件
				if (!inputArr[i].value) {
					//如果没有选择,获得这个input的ID      
					add_inputId = inputArr[i].id;
					break;
				}
			}
			if (add_inputId) {
				//如果需要被触发的input ID存在,将对应的input触发
				return __WEBPACK_IMPORTED_MODULE_8_jquery___default()("#" + add_inputId).click();
			} else {
				__WEBPACK_IMPORTED_MODULE_10__static_js_alertConfirm_js__["a" /* default */].singleConfirm("最多选择" + this.imgNum + "个附件");
			}
		},

		//当input选择了图片的时候触发,将获得的src赋值到相对应的img
		setFile: function setFile(e) {
			var target = e.target;
			//jQuery('#file_' + target.id).val(getFileUrl(e.srcElement).name);
			//				let fileName=jQuery('#' + target.id).files[0].name;
			//				jQuery('#' + target.id).text("附件"+target.id);
			__WEBPACK_IMPORTED_MODULE_8_jquery___default()('#' + target.id).show();
			__WEBPACK_IMPORTED_MODULE_8_jquery___default()('#a_' + target.id).show();
		},

		//点击图片删除该图片并清除相对的input
		deleteFile: function deleteFile(e) {
			var target = e.target;
			var inputID = ''; //需要清除value的input
			__WEBPACK_IMPORTED_MODULE_8_jquery___default()('#a_' + inputID).hide();
			inputID = target.id.replace('a_', ''); //获得需要清除value的input
			__WEBPACK_IMPORTED_MODULE_8_jquery___default()('input#' + inputID).val("");
			__WEBPACK_IMPORTED_MODULE_8_jquery___default()('input#' + inputID).hide();
			target.remove();
		}
	},
	beforeMount: function beforeMount() {
		var that = this;
		window.scrollTo(0, 0);
		that.imgPath = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=";

		if (localStorage.getItem("account")) {
			that.isLogin = true;
		}
		var goodsCode = "";
		if (that.$route.params.goodsCode != undefined) {
			goodsCode = that.$route.params.goodsCode;
		}
		if (that.$route.query.goodsCode != undefined) {
			goodsCode = that.$route.query.goodsCode;
		}
		//下单类型
		if (this.$route.query.orderType != undefined && this.$route.query.orderType != "") {
			this.orderType = this.$route.query.orderType;
		}
		//由列表页面传递过来的productType用于控制详情页面的页头点亮
		if (this.$route.query.productType != undefined && this.$route.query.productType != "") {
			if (that.$route.query.productType == 'sample' || that.$route.query.productType == 'meterial') {
				that.activeLi = that.$route.query.productType;
			}
		}
		that.goodsCode = goodsCode;
		var distributeAccount = that.$route.query.distributeAccount;
		if (distributeAccount != undefined) {
			that.distributeAccount = distributeAccount;
			if (distributeAccount == "") {
				that.canAddToShoppingCart = true;
			}
		}
		var distributeName = that.$route.query.distributeName;
		if (distributeName != undefined) {
			that.distributeName = distributeName;
		}
		var isPreview = that.$route.query.isPreview;
		if (isPreview != undefined && isPreview == "true") {
			that.isPreview = isPreview;
			this.previewGoods(goodsCode);
		} else {
			this.getGoodDetail(goodsCode);
		}
		this.getGoodCredits(goodsCode, 1, 20);
		this.existFavoriteGoods();

		this.getCat();
		//			this.existFavoriteShop();
		//			debugger;
		this.getVailUserFlag();
	},
	beforeDestroy: function beforeDestroy() {
		window.clearInterval(this.computeFlag);
	},
	mounted: function mounted() {
		__WEBPACK_IMPORTED_MODULE_8_jquery___default()(".jqzoom").jqueryzoom();
		//jQuery(".beforeDestroy").val();
		__WEBPACK_IMPORTED_MODULE_8_jquery___default()('.city_select_css').each(function (i, j) {
			var options = __WEBPACK_IMPORTED_MODULE_8_jquery___default()(j).find("option");
			options.attr("selected", false);
			options.first().attr("selected", true);
		});

		$(".sp-dt-tab .hd ul li").click(function () {
			var index = $(this).index();
			$(this).addClass("hover").siblings().removeClass();
			$(".sp-dt-tab .bd").eq(index).show().siblings(".sp-dt-tab .bd").hide();
		});

		this.$nextTick(function () {
			window.addEventListener('scroll', this.handleScroll); //滚动事件监听
		});
	}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "AENg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TopBar__ = __webpack_require__("5PWk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FooterMenu__ = __webpack_require__("gTlp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ShopNav__ = __webpack_require__("hV6H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_FooterCopyright__ = __webpack_require__("3LwO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_HearderNav__ = __webpack_require__("7JIe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Header__ = __webpack_require__("teIl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__static_api_api_js__ = __webpack_require__("fXcb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__ = __webpack_require__("bCJ+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__static_js_emallUtils_js__ = __webpack_require__("spYF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_resource__ = __webpack_require__("ORbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__static_js_jquery_jqzoom_js__ = __webpack_require__("V693");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__static_js_jquery_jqzoom_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__static_js_jquery_jqzoom_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__static_js_jqzoom_base_js__ = __webpack_require__("SP3i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__static_js_jqzoom_base_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__static_js_jqzoom_base_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_qrcode__ = __webpack_require__("71e1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_qrcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_qrcode__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







//import jQuery from "../../../static/js/jqzoom.base.js"







//引入滚动和放大插件


__WEBPACK_IMPORTED_MODULE_13_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_13_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vue_resource__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_13_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18_qrcode___default.a);
/** 
 * 从 file 域获取 本地图片 url 
 */
function getFileUrl(obj) {
	var url = void 0;
	url = window.URL.createObjectURL(obj.files.item(0));
	return url;
}
/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'goodsdetail',
	components: {
		'topbar': __WEBPACK_IMPORTED_MODULE_3__components_TopBar__["a" /* default */],
		'shopnav': __WEBPACK_IMPORTED_MODULE_5__components_ShopNav__["a" /* default */],
		'footermenu': __WEBPACK_IMPORTED_MODULE_4__components_FooterMenu__["a" /* default */],
		'footercopyright': __WEBPACK_IMPORTED_MODULE_6__components_FooterCopyright__["a" /* default */],
		'emallheader': __WEBPACK_IMPORTED_MODULE_8__components_Header__["a" /* default */],
		'headernav': __WEBPACK_IMPORTED_MODULE_7__components_HearderNav__["a" /* default */]
	},
	data: function data() {
		var _ref;

		return _ref = {
			goodsDetail: {},
			goodsDesc: '',
			goodsName: '',
			goodsPrice: '',
			goodsPrice1: '', //不知道谁占了名字
			goodsCode: '',
			goodsCatNameCn: '',
			goodsNumber: 0,
			shoppingCartNum: '',
			payNum: 1,
			currentNum: '',
			buyGoodsNumber: '',
			isLimitGoodsFlag: '',
			goodsQuota: '',
			priceText: '',
			greenshoeUser: '',
			backUrl: '',
			goodsImgs: [],
			goodsImgLarge: '',
			goodsImgMid: '',
			goodsImgSml: '',
			slider: [{
				imgUrl: ""
			}],
			sliderHeight: '17.8rem',
			goodsLimitMax: '',
			shopCode: '',
			saleNumber: 0,
			inpSaleNumber: 0,
			shopInfo: {},
			//          	shopLogo:'../../static/images/temp/sp-dp-logo.jpg',
			shopLogo: '',
			qqUrl: '',
			breaks: 0,
			creditList: [],
			discount: 0,
			marketPrice: 0,
			catCode: '',
			recommendGoodsList: [],
			distributeName: '',
			distributeAccount: '',
			catList: [],
			isExistFavoriteGoods: 0,
			isExistFavoriteShop: 0,
			goodsBo: {},
			currentPage: 1,
			totalPage: 1,
			isPreview: false,
			brokerDiscountPersent: 0,
			brokerPrice: 0,
			spec: '',
			specName: '',
			goodRate: null,
			isSpike: 'n',
			computeFlag: '',
			hour: 0,
			minute: 0,
			second: 0,
			isLogin: false,
			shopName: '',
			expressBo: {},
			expressFeeBoList: [],
			expressFeeDesc: '', //运费
			expressMode: '', //运费类别
			expressArea: '', //运费地区
			skuList: [], //类目关联的SKU
			goodsSkuList: [], //商品关联的SKU
			usedSkuArry: [], //商品使用的SKU，二维数组
			goodsSkuMap: new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a() }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'hour', '0'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'minute', '0'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'second', '0'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'activityEndTime', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'seckillPrice', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'pointType', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'unselectSKU', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'chooseGoodsPrice', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'maxPrice', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'minPrice', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'nextSecckill', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'nextBeginTime', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'canAddToShoppingCart', true), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'attachName', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'attachPath', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'orderType', 'purchase'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'printService', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'rebrandingService', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'printingService', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'laserService', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'customize_desc', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'customize_desc', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'remark', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'begin_delivery_time', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'partTypes', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'partChangeList', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'imgNum', 5), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'produceNum', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'qualitys', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'inspectionTypes', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'quality', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'inspectionType', ''), _ref;
	},

	methods: {
		chooseQuality: function chooseQuality(quality) {
			this.quality = quality;
		},
		chooseInspection: function chooseInspection(inspectionType) {
			this.inspectionType = inspectionType;
		},
		//控制是否展示部件
		isPartShow: function isPartShow(k, index) {
			var that = this;
			for (var i = 0; i < that.partChangeList.length; i++) {
				if (that.partChangeList[i].name == that.partTypes[index].dictText && i != k) {
					return false;
				}
			}
			return true;
		},
		//删除部件
		delPart: function delPart(index) {
			this.partChangeList.splice(index, 1);
		},
		//添加部件
		addPart: function addPart() {
			var that = this;
			for (var i = 0; i < that.partTypes.length; i++) {
				var flag = true;
				for (var j = 0; j < that.partChangeList.length; j++) {
					if (that.partTypes[i].dictText == that.partChangeList[j].name) {
						flag = false;
						break;
					}
				}
				if (flag) {
					that.partChangeList.push({
						name: that.partTypes[i].dictText,
						value: ''
					});
					break;
				}
			}
		},
		choosePrint: function choosePrint(printService) {
			var that = this;
			if (that.printService == '') {
				this.printService = printService;
			} else {
				this.printService = '';
			}
		},
		chooseLaster: function chooseLaster(laserService) {
			var that = this;
			if (that.laserService == '') {
				this.laserService = laserService;
			} else {
				this.laserService = '';
			}
		},
		choosePrinting: function choosePrinting(printingService) {
			var that = this;
			if (that.printingService == '') {
				this.printingService = printingService;
			} else {
				this.printingService = '';
			}
		},
		chooseRebranding: function chooseRebranding(rebrandingService) {
			var that = this;
			if (that.rebrandingService == '') {
				this.rebrandingService = rebrandingService;
			} else {
				this.rebrandingService = '';
			}
		},
		changeTab: function changeTab(orderType) {
			this.orderType = orderType;
		},
		generateQrcode: function generateQrcode() {
			var that = this;
			var url = __WEBPACK_IMPORTED_MODULE_12__static_js_emallUtils_js__["v" /* mobileGoodsDetailUrl */] + that.goodsCode;
			var canvas = document.getElementById("canvas");
			__WEBPACK_IMPORTED_MODULE_18_qrcode___default.a.toCanvas(canvas, url, {
				errorCorrectionLevel: "H",
				width: 120
			}, function (error) {
				if (error) console.error(error);
				console.log('success!');
			});
			__WEBPACK_IMPORTED_MODULE_18_qrcode___default.a.toCanvas(canvas, url, {
				errorCorrectionLevel: "H",
				width: 120
			}, function (error) {
				if (error) console.error(error);
				console.log('success!');
			});
		},
		closeqrcode: function closeqrcode() {
			__WEBPACK_IMPORTED_MODULE_9_jquery___default()("#js_qrcode_top").css("z-index", -1);
		},
		easyShare: function easyShare(type) {
			var that = this;
			var str = window.location.href;
			var url = encodeURIComponent(str);
			if (type == "weibo") {
				window.open("http://service.weibo.com/share/share.php?appkey=&title=" + that.goodsName + "&url=" + url + "&pic=" + that.goodsImgs[0]);
			} else if (type == "qzone") {
				var title = encodeURI(that.goodsName);
				var pics = that.goodsImgs[0];
				window.open("https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=" + url + "&title=" + title + "&pics=" + pics + "&desc=&summary=&site=");
			} else if (type == "weixin") {
				__WEBPACK_IMPORTED_MODULE_9_jquery___default()("#js_qrcode_top").css("z-index", 999);
				that.generateQrcode();
			}
		},
		existsSku: function existsSku(specName, index) {
			var tmpArry = this.usedSkuArry[index];
			if (this.usedSkuArry[index] != undefined && this.usedSkuArry[index] != null) {
				for (var i = 0; i < this.usedSkuArry[index].length; i++) {
					if (this.usedSkuArry[index][i] == specName) {
						return true;
					}
				}
			}
			return false;
		},
		//选择规则
		chooseSpec: function chooseSpec(specName, index) {
			var that = this;
			//this.specName = specName;
			var chooseFlag = true; //是否所有的规格都选择了
			that.skuList[index].skuChoosed = specName;
			var skuStr = '';
			var unselectSKU = true;
			for (var i = 0; i < that.skuList.length; i++) {
				if (that.skuList[i].skuChoosed == "") {
					//如果有的规格没选
					chooseFlag = false;
				}
				if (i == 0) {
					skuStr = that.skuList[i].skuChoosed;
				} else {
					skuStr += "_" + that.skuList[i].skuChoosed;
				}
				if (that.skuList[i].skuChoosed == null || that.skuList[i].skuChoosed == "") {
					unselectSKU = false;
				}
			}
			that.unselectSKU = unselectSKU;
			that.specName = skuStr;
			var goodsSku = that.goodsSkuMap.get(skuStr);
			if (goodsSku != undefined) {
				that.goodsNumber = parseInt(goodsSku.goodsNumber);
				//that.saleNumber=parseInt(goodsSku.saleNumber);
				that.goodsPrice = (goodsSku.unitPrice / 100).toFixed(2);
				that.chooseGoodsPrice = goodsSku.unitPrice / 100;
				that.brokerPrice = (goodsSku.unitPrice * that.brokerDiscountPersent / 100 / 100).toFixed(2);
			}
			/*else{
           			if(chooseFlag){
           				that.goodsNumber=0;
           				that.saleNumber=0;
           				that.goodsPrice = 0;
           			}
           		}*/
			//that.skuList[index].skuChoosed
			var goodsSkuStr = '';
			for (var j = 0; j < that.skuList.length; j++) {
				if (j == 0) {
					goodsSkuStr += that.skuList[j].skuChoosed;
				} else {
					goodsSkuStr += "_" + that.skuList[j].skuChoosed;
				}
			}
			for (var k = 0; k < that.goodsSkuList.length; k++) {
				if (that.goodsSkuList[k].goodsSkuStr == goodsSkuStr) {
					if (that.goodsSkuList[k].imgLarge != undefined && that.goodsSkuList[k].imgLarge != "") {
						if (that.goodsSkuList[k].imgLarge.indexOf(";") != -1) {
							var imgLarge = that.goodsSkuList[k].imgLarge.substring(0, that.goodsSkuList[k].imgLarge.length - 1);
							that.goodsImgs = imgLarge.split(";");
							//展示第一张图
							that.goodsImgLarge = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + that.goodsImgs[0];
							for (var m = 0; m < that.goodsImgs.length; m++) {
								that.goodsImgs[m] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + that.goodsImgs[m];
							}
						}
					}
				}
			}
		},
		choosePic: function choosePic(index) {
			this.goodsImgLarge = this.goodsImgs[index];
		},
		showImg: function showImg(creditIdx, gI) {
			__WEBPACK_IMPORTED_MODULE_9_jquery___default()("#" + creditIdx).attr("src", gI);
			__WEBPACK_IMPORTED_MODULE_9_jquery___default()("#" + creditIdx + "_div").show();
		},
		hideImg: function hideImg(creditIdx) {
			__WEBPACK_IMPORTED_MODULE_9_jquery___default()("#" + creditIdx + "_div").hide();
		},
		showAppendImg: function showAppendImg(creditIdx, gI_append) {
			__WEBPACK_IMPORTED_MODULE_9_jquery___default()("#" + creditIdx + '_append').attr("src", gI_append);
			__WEBPACK_IMPORTED_MODULE_9_jquery___default()("#" + creditIdx + "_append_div").show();
		},
		hideAppendImg: function hideAppendImg(creditIdx) {
			__WEBPACK_IMPORTED_MODULE_9_jquery___default()("#" + creditIdx + "_append_div").hide();
		},
		getMore: function getMore(catCode) {
			var that = this;
			that.$router.push({
				name: 'goodsList',
				query: {
					firstCatCode: catCode
				}
			});
		},
		goShop: function goShop(shopCode) {
			this.$router.push({
				name: 'shop_index',
				query: {
					shopCode: shopCode
				}
			});
			//		  	 	this.$router.push({path:'shop_index',params:{shopCode:shopCode}});
		},
		goDetail: function goDetail(goodsCode) {
			this.$router.push({
				name: 'goodsdetail',
				query: {
					goodsCode: goodsCode
				}
			});
			window.location.reload();
		},
		/**
   * 运费情况
   */
		expressChage: function expressChage() {
			var that = this;
			that.expressArea = '';
			var regionArea = __WEBPACK_IMPORTED_MODULE_9_jquery___default()("#expressChage").val();
			if (regionArea == undefined) {
				regionArea = '北京市';
			}
			var expressFeeBoList = that.expressFeeBoList;
			var defaultExpress = "";
			var unit = "kg";
			if (that.expressMode == "counter") {
				var unit = "件";
			}
			if (that.expressMode == "counter" || that.expressMode == "weight") {
				//按件或重量
				for (var i = 0; i < expressFeeBoList.length; i++) {
					var express = expressFeeBoList[i];
					if (express.regionArea == '默认运费') {
						defaultExpress = express.firstNumber + unit + "以下" + express.firstAmount / 100 + "元，超出部分每" + express.addNumber + unit + express.addAmount / 100 + "元";
					}
					if (regionArea == express.regionArea) {
						that.expressArea = express.firstNumber + unit + "以下" + express.firstAmount / 100 + "元，超出部分每" + express.addNumber + unit + express.addAmount / 100 + "元";
					}
				}
			} else if (that.expressMode == "constant") {
				//固定运费
				for (var i = 0; i < expressFeeBoList.length; i++) {
					var expressFee = expressFeeBoList[i];
					if (expressFee.constantFee > 0) {
						that.expressArea = expressFee.constantFee / 100 + "元";
						break;
					}
				}
			}
			//默认运费
			if (that.expressArea == "") {
				that.expressArea = defaultExpress;
			}
			//满XX包邮
			var freePostageMode = that.expressBo.freePostageMode;
			if (freePostageMode != "" && freePostageMode != undefined && freePostageMode != null) {
				for (var i = 0; i < expressFeeBoList.length; i++) {
					var expressFee = expressFeeBoList[i];
					if (expressFee.freePostageAmount > 0) {
						that.expressArea = that.expressArea + "，满" + expressFee.freePostageAmount / 100 + "元包邮";
						break;
					}
				}
			}
		},
		getGoodDetail: function getGoodDetail(goodsCode) {
			var that = this;
			this.$http.jsonp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__static_js_emallUtils_js__["q" /* getAjaxUrl */])() + '/goods/ajax_goods_physical_detail.htm', {
				params: {
					goodsCode: goodsCode
				}
			}).then(function (ret) {
				//--------------------取运费-----------------------
				that.expressBo = ret.body.data.expressBo;
				that.partTypes = ret.body.data.partTypes; //产品部件
				that.qualitys = ret.body.data.qualitys; //品质
				that.inspectionTypes = ret.body.data.inspectionTypes; //验收
				that.partChangeList.push({
					name: that.partTypes[0].dictText,
					value: ''
				});
				var expressBo = ret.body.data.expressBo;

				if (expressBo != undefined && expressBo != null) {
					that.expressFeeBoList = expressBo.expressFeeBoList;
					console.log(expressBo);

					if (expressBo.feeMode == "free_postage") {
						//包邮
						that.expressFeeDesc = "包邮";
						that.expressMode = "";
					} else if (expressBo.feeMode == "constant") {
						//固定邮费
						that.expressFeeDesc = "固定邮费";
						that.expressMode = "constant";
						that.expressChage();
					} else if (expressBo.feeMode == "weight") {
						that.expressFeeDesc = "按重量计算";
						that.expressMode = "weight";
						that.expressChage();
					} else if (expressBo.feeMode == "counter") {
						that.expressFeeDesc = "按件计算";
						that.expressMode = "counter";
						that.expressChage();
					} else {
						that.expressFeeDesc = "包邮";
					}
				} else {
					that.expressFeeDesc = "包邮";
				}

				//------------------取商品其它信息--------------------
				var good = ret.body.data.goods;
				if (good != undefined) {
					that.goodsBo = good;
				}
				that.nextSecckill = ret.body.data.nextSecckill; //最新的秒杀活动信息
				//设置下场秒杀活动开始时间
				if (that.nextSecckill != undefined) {
					if (that.nextSecckill.activityBeginTime != undefined && that.nextSecckill.activityBeginTime > 0) {
						that.nextBeginTime = that.nextSecckill.activityBeginTime;
					}
				}
				//			 			if(good.attrValue!=undefined && good.attrValue!=""){
				that.goodsDetail = JSON.parse(good.attrValue);
				that.marketPrice = JSON.parse(good.attrValue).marketPrice / 100;
				var isSpike = JSON.parse(good.attrValue).isSpike;
				if (isSpike != undefined && isSpike != '') {
					that.isSpike = isSpike;
				}
				var saleTimeStr = JSON.parse(good.attrValue).saleTimeShow;
				var saleEndTimeStr = JSON.parse(good.attrValue).saleEndTimeShow;

				if (saleEndTimeStr != undefined && saleEndTimeStr != '') {
					saleEndTimeStr = saleEndTimeStr.replace(/-/g, "/");
					var saleEndDate = new Date(saleEndTimeStr);

					saleTimeStr = saleTimeStr.replace(/-/g, "/");
					var saleDate = new Date(saleTimeStr);

					//如果当期日期大于销售结束日期
					if (new Date() > saleEndDate) {
						good.saleStatus = "end";
					} else if (new Date() < saleDate) {
						//如果当期时间小于上架时间，展示距离开始 时间
						good.saleStatus = "wait_start";
						var begSeconds = saleDate.getTime() - new Date().getTime(); //时间差的毫秒数
						//计算出相差天数
						//  								var days=Math.floor(begSeconds/(24*3600*1000));
						//计算出小时数
						var leave1 = begSeconds % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
						var hours = Math.floor(begSeconds / (3600 * 1000));
						//计算相差分钟数
						var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
						var minutes = Math.floor(leave2 / (60 * 1000));
						//计算相差秒数
						var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
						var seconds = Math.round(leave3 / 1000);
						// 									good.day=days;
						that.hour = hours;
						that.minute = minutes;
						that.second = seconds;
					} else {
						good.saleStatus = "on_sale";

						var begSeconds = saleEndDate.getTime() - new Date().getTime(); //时间差的毫秒数
						//计算出相差天数
						//  								var days=Math.floor(begSeconds/(24*3600*1000));
						//计算出小时数
						var leave1 = begSeconds % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
						var hours = Math.floor(begSeconds / (3600 * 1000));
						//计算相差分钟数
						var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
						var minutes = Math.floor(leave2 / (60 * 1000));
						//计算相差秒数
						var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
						var seconds = Math.round(leave3 / 1000);
						// 									good.day=days;
						that.hour = hours;
						that.minute = minutes;
						that.second = seconds;
					}
				}
				//			 			}
				that.attrValue = JSON.parse(good.attrValue);
				//产品详情图片路径添加绝对路径
				that.goodsDesc = good.goodsDesc.replace(/\/upload\//g, __WEBPACK_IMPORTED_MODULE_10__static_api_api_js__["a" /* default */].getImgPath() + "/upload/");
				that.goodsName = good.goodsName;
				that.catCode = good.catCode;
				that.firstCatCode = that.attrValue.firstCatCode;
				that.getRecommendGoods();
				that.seckillPrice = good.seckillPrice;
				if (that.seckillPrice > 0) {
					that.activityEndTime = good.activityEndTime;
				}
				that.spec = JSON.parse(good.attrValue).spec;
				if (that.spec != undefined && that.spec != '') {
					that.specName = that.spec.split(',')[0];
				}
				if (ret.body.data.brokerDiscountPersent != undefined) {
					that.brokerDiscountPersent = ret.body.data.brokerDiscountPersent;
					that.brokerPrice = (good.unitPrice * that.brokerDiscountPersent / 100 / 100).toFixed(2);
				}
				//unitPrice 是产品单价
				that.goodsPrice1 = good.goodsPrice;
				that.pointType = good.pointType;
				that.goodsPrice = (good.unitPrice / 100).toFixed(2);
				that.goodsCode = good.goodsCode;
				that.goodsCatNameCn = good.ext3;
				//这个地方估计有坑~
				var imgArray = [];
				if (good.imgLarge.indexOf(";") != -1) {
					good.imgLarge = good.imgLarge.substring(0, good.imgLarge.length - 1);
					that.goodsImgs = good.imgLarge.split(";");
					good.imgLarge = that.goodsImgs[0];
				}
				that.goodsImgLarge = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + good.imgLarge;
				for (var j = 0; j < that.goodsImgs.length; j++) {
					that.goodsImgs[j] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + that.goodsImgs[j];
				}

				//			 			that.goodsImgs.push(that.goodsImgLarge);
				//			 			that.goodsImgs.push(that.goodsImgMid);
				//			 			that.goodsImgs.push(that.goodsImgSml);

				that.goodsNumber = good.goodsNumber;
				that.discount = (that.goodsPrice / that.marketPrice * 10).toFixed(2);
				that.breaks = parseFloat(that.marketPrice - that.goodsPrice).toFixed(2);
				that.saleNumber = good.saleNumber;
				that.inpSaleNumber = good.inpSaleNumber;
				that.shopCode = good.shopCode;
				that.shopName = good.shopName;

				var goodsSkuMap = that.goodsSkuMap;
				var goodsSkuList = ret.body.data.goodsSkuList;
				if (goodsSkuList == null || goodsSkuList.length <= 1) {
					that.unselectSKU = true;
				}
				var defaultSkuArry = ''; //默认选择的SKU
				var usedSkuArry = that.usedSkuArry; //商品使用的SKU，二维数组
				var skuList = ret.body.data.skuList;
				if (skuList != undefined) {
					that.skuList = skuList;
				}
				if (goodsSkuList != undefined) {
					that.goodsSkuList = goodsSkuList;
					var goodsNum = 0;
					var minPrice = 0;
					var maxPrice = 0;
					for (var i = 0; i < goodsSkuList.length; i++) {
						goodsNum += goodsSkuList[i].goodsNumber;
						var tmpArry = goodsSkuList[i].goodsSkuStr.split("_");
						for (var o = 0; o < tmpArry.length; o++) {
							if (i == 0) {
								usedSkuArry.push(new Array(tmpArry[o]));
							} else {
								usedSkuArry[o].push(tmpArry[o]);
							}
							for (var m = 0; m < skuList.length; m++) {
								if (skuList[m].skuValue.indexOf(tmpArry[o]) == -1) {
									skuList[m].skuValue += "," + tmpArry[o];
								}
							}
						}
						goodsSkuMap.set(goodsSkuList[i].goodsSkuStr, goodsSkuList[i]);
						if (goodsSkuList[i].isDefault == 'y') {

							if (goodsSkuList.length <= 1) {
								that.specName = goodsSkuList[i].goodsSkuStr;
								that.goodsNumber = parseInt(goodsSkuList[i].goodsNumber);
								//that.saleNumber=parseInt(goodsSkuList[i].saleNumber);
								defaultSkuArry = goodsSkuList[i].goodsSkuStr.split("_");
							}
						}
						if (i == 0 || minPrice > goodsSkuList[i].unitPrice / 100) {
							minPrice = goodsSkuList[i].unitPrice / 100;
						}
						if (goodsSkuList[i].unitPrice / 100 > maxPrice) {
							maxPrice = goodsSkuList[i].unitPrice / 100;
						}
					}
					that.goodsPrice = minPrice.toFixed(2);
					that.brokerPrice = (minPrice * that.brokerDiscountPersent / 100).toFixed(2);
					that.goodsNumber = goodsNum;
					that.maxPrice = maxPrice;
					that.minPrice = minPrice;
				} else {
					that.chooseGoodsPrice = good.unitPrice;
				}

				if (skuList != undefined && skuList != '') {
					//没看仔细看逻辑  这里可能为空
					for (var m = 0; m < skuList.length; m++) {
						if (defaultSkuArry.length >= m) {

							skuList[m].skuChoosed = defaultSkuArry[m];
						}
					}
				}
				console.log(usedSkuArry);
				that.getShopInfo(good.shopCode);
				//店铺是否收藏
				that.existFavoriteShop();
				that.computeFlag = window.setInterval(function () {
					that.computeTime(); //计算倒计时
				}, 1000);
				//判断商品是否虚拟商品firstCatCode"virtual_commodity"
				if (that.goodsDetail.firstCatCode != undefined && that.goodsDetail.firstCatCode == "virtual_commodity") {
					that.canAddToShoppingCart = false;
				}
			}, function (err) {
				//			 			alertConfirm.singleConfirm("异步请求操作失败")
			});
		},
		getGoodCredits: function getGoodCredits(goodsCode, currentPage, pageSize) {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_10__static_api_api_js__["a" /* default */].getGoodCredits(goodsCode, currentPage, pageSize, function (ret) {
				if (ret.code == "success") {
					var goodRate = ret.data.goodRate;
					if (goodRate != undefined) {
						that.goodRate = goodRate;
					}
					var creditList = ret.data.creditBos;
					for (var i = 0; i < creditList.length; i++) {
						var gmtCreate = creditList[i].gmtCreate + "";
						var yy = gmtCreate.substring(0, 4);
						var mm = gmtCreate.substring(4, 6);
						var dd = gmtCreate.substring(6, 8);
						var hh = gmtCreate.substring(8, 10);
						var MM = gmtCreate.substring(10, 12);
						var ss = gmtCreate.substring(12, 14);
						var dataStr = yy + "." + mm + "." + dd + " " + hh + ":" + MM + ":" + ss;
						creditList[i].dataStr = dataStr;

						var buyerName = creditList[i].buyerAccount;
						if (buyerName != undefined && buyerName.length > 1) {
							buyerName = buyerName.substr(0, 1) + "****" + buyerName.substr(-1);
						}
						creditList[i].buyerName = buyerName;
						var imgs = creditList[i].ext1;
						if (imgs != undefined && imgs != "") {
							creditList[i].creditImgs = imgs.split(";");
							//alertConfirm.singleConfirm(creditList[i].creditImgs);
							for (var j = 0; j < creditList[i].creditImgs.length; j++) {
								if (creditList[i].creditImgs[j] != undefined && creditList[i].creditImgs[j] != "") {
									creditList[i].creditImgs[j] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + creditList[i].creditImgs[j];
								} else {
									creditList[i].creditImgs.splice(j, 1);
								}
							}
						}

						var appendimgs = creditList[i].ext3;
						if (appendimgs != undefined && appendimgs != "") {
							creditList[i].appendImgs = appendimgs.split(";");
							//alertConfirm.singleConfirm(creditList[i].creditImgs);
							for (var j = 0; j < creditList[i].appendImgs.length; j++) {
								if (creditList[i].appendImgs[j] != undefined && creditList[i].appendImgs[j] != "") {
									creditList[i].appendImgs[j] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + creditList[i].appendImgs[j];
								} else {
									creditList[i].appendImgs.splice(j, 1);
								}
							}
						}
					}
					that.creditList = creditList;
				}
			});
		},
		getGoodDetails: function getGoodDetails(goodsCode) {
			this.$router.push({
				path: 'goodsDetails',
				query: {
					goodsCode: goodsCode
				}
			});
		},
		getGoodList: function getGoodList(catCode, catNameCn) {
			this.$router.push({
				path: 'goodsList',
				query: {
					catCode: catCode,
					catNameCn: catNameCn
				}
			});
		},
		getShoppingCartNum: function getShoppingCartNum(shopCode) {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_10__static_api_api_js__["a" /* default */].getShoppingCartNum(function (ret) {
				that.shoppingCartNum = ret.data.shoppingCartNum;
			});
		},
		getShopInfo: function getShopInfo(shopCode) {
			var that = this;
			this.$http.jsonp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__static_js_emallUtils_js__["q" /* getAjaxUrl */])() + '/shop/ajax_shop_index.htm', {
				params: {
					shopCode: shopCode
				}
			}).then(function (ret) {
				if (ret.body.code == "success") {
					var info = ret.body.data.shopBo;
					that.shopInfo = info;
					if (info.shopLogo != undefined && info.shopLogo != "") {
						that.shopLogo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + info.shopLogo;
					}
					if (info.qq == undefined || info.qq == '') {
						that.qqUrl = "javascript:volid(0);";
					} else {
						that.qqUrl = "http://wpa.qq.com/msgrd?v=3&site=qq&menu=yes&uin=" + info.qq;
					}
				}
			}, function (err) {
				//			 			alertConfirm.singleConfirm("异步查询店铺信息失败")
			});
		},
		addPayNum: function addPayNum() {
			this.payNum = parseInt(this.payNum) + 1;
			if (this.payNum > this.goodsNumber) {
				__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm("购买数量超过库存数量");
				this.payNum = this.goodsNumber;
				return false;
			}
		},
		subPayNum: function subPayNum() {
			if (this.payNum > 1) {
				this.payNum = parseInt(this.payNum) - 1;
			}
		},
		setPayNum: function setPayNum() {
			var _payNum = __WEBPACK_IMPORTED_MODULE_9_jquery___default()("#payNum").val();
			if (_payNum > this.goodsNumber) {
				__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm("购买数量超过库存数量");
				this.payNum = this.goodsNumber;
				return false;
			} else if (_payNum <= 0) {
				this.payNum = 1;
				return false;
			}
			this.payNum = _payNum;
		},
		//订购申请
		customizeApply: function customizeApply(applyType) {
			var that = this;
			var customize_desc = '';
			if (that.orderType == 'custom') {
				if (that.customize_desc == '') {
					__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm("请录入订购说明！");
					return;
				} else {
					customize_desc = encodeURI(that.customize_desc);
				}
			}
			var remark = '';
			if (that.remark == '') {
				__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm("请录入备注！");
				return;
			} else {
				remark = encodeURI(that.remark);
			}
			var deleveryTime = '';
			if (that.begin_delivery_time == '') {
				__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm("请录入交期！");
				return;
			} else {
				deleveryTime = that.begin_delivery_time.replace('-', '').replace('-', '');
			}
			var specName = '';
			if (that.specName != '') {
				specName = encodeURI(that.specName);
			}
			var accessory_change_json = '';
			var changeList = [];
			if (that.partChangeList != undefined && that.partChangeList.length > 0) {
				for (var i = 0; i < that.partChangeList.length; i++) {
					changeList.push({
						name: encodeURI(that.partChangeList[i].name),
						value: encodeURI(that.partChangeList[i].value)
					});
				}
				accessory_change_json = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(changeList);
			}
			var formData = new FormData(__WEBPACK_IMPORTED_MODULE_9_jquery___default()("#addFileForm")[0]);
			__WEBPACK_IMPORTED_MODULE_9_jquery___default.a.ajax({
				url: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__static_js_emallUtils_js__["q" /* getAjaxUrl */])() + '/demand/attachment_upload.htm',
				type: 'POST',
				data: formData,
				async: false,
				cache: false,
				contentType: false, // 告诉jQuery不要去设置Content-Type请求头  
				processData: false, // 告诉jQuery不要去处理发送的数据  
				success: function success(result) {
					result = eval('(' + result + ')');
					if (result.code == "success") {
						var fileName = "";
						if (result.data.fileName != undefined && result.data.fileName != "") {
							fileName = encodeURI(result.data.fileName);
						}
						var filePath = result.data.filePath;
						if (applyType == 'goods') {
							//订购申请
							__WEBPACK_IMPORTED_MODULE_10__static_api_api_js__["a" /* default */].customizeApply(applyType, applyType, customize_desc, remark, 0, that.goodsPrice * 100, that.goodsPrice * 100 * that.payNum, deleveryTime, '', 'wait', that.payNum, accessory_change_json, that.goodsCode, specName, '', '', fileName, filePath, function (ret) {
								if (ret.code != null && ret.code == "success") {
									__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm("订购申请提交成功");
								} else if (ret.code != null && ret.code == "9999") {
									__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm("请先登陆！");
									window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/login.htm';
									return false;
								} else if (ret) {
									var errorCode = ret.code;
									var errorMsg = '系统繁忙，请稍后再试';
									__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm(errorMsg);
								}
							});
						} else {
							//打样申请，需要传图片
							var formData2 = new FormData(__WEBPACK_IMPORTED_MODULE_9_jquery___default()("#addTextForm")[0]);
							__WEBPACK_IMPORTED_MODULE_9_jquery___default.a.ajax({
								url: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__static_js_emallUtils_js__["q" /* getAjaxUrl */])() + '/demand/multi_img_upload.htm',
								type: 'POST',
								data: formData2,
								async: false,
								cache: false,
								contentType: false, // 告诉jQuery不要去设置Content-Type请求头  
								processData: false, // 告诉jQuery不要去处理发送的数据  
								success: function success(result2) {
									result2 = eval('(' + result2 + ')');
									if (result2.code == "success") {

										var imageName = "";
										if (result2.data.imgName != undefined && result2.data.imgName != "") {
											imageName = encodeURI(result2.data.imgName);
										}
										var imagePath = result2.data.imgPath;

										__WEBPACK_IMPORTED_MODULE_10__static_api_api_js__["a" /* default */].customizeApply(applyType, applyType, customize_desc, remark, 0, that.goodsPrice * 100, that.goodsPrice * 100 * that.payNum, deleveryTime, '', 'wait', that.payNum, accessory_change_json, that.goodsCode, specName, imageName, imagePath, fileName, filePath, function (ret) {
											if (ret.code != null && ret.code == "success") {
												__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm("订购申请提交成功");
											} else if (ret.code != null && ret.code == "9999") {
												__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm("请先登陆！");
												window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/login.htm';
												return false;
											} else if (ret) {
												var errorCode = ret.code;
												var errorMsg = '系统繁忙，请稍后再试';
												__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm(errorMsg);
											}
										});
									} else {
										__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm(result.msg);
									}
								},
								error: function error(ret) {
									__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm("图片上传失败！");
								}
							});
						}
					} else {
						__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm(result.msg);
					}
				},
				error: function error(ret) {
					__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm("附件上传失败！");
				}
			});
		},
		payOrder: function payOrder() {
			if (!this.unselectSKU) {
				__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm("请选择商品属性！");
				return;
			}
			var that = this;
			var goodsCode = this.goodsCode;
			if (that.orderType == "spot") {
				//现货下单，表单验证
				if (this.goodsNumber === 0) {
					return;
				}
				var that = this;
				var num = __WEBPACK_IMPORTED_MODULE_9_jquery___default()("#payNum").val();
				if (num < 1) {
					__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm("购买数量不能为 0");
					return false;
				}
				var payNum = parseInt(that.payNum);
				if (this.orderType == 'spot' && parseInt(this.payNum) > this.goodsNumber) {
					__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm("购买数量超过库存数量");
					this.payNum = this.goodsNumber;
					return false;
				}
			}
			if (that.orderType == "purchase") {
				//采购订单，表单验证
				var produceNum = that.produceNum;
				if (produceNum == null || produceNum < 1) {
					__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm("请录入正整数的生产数量");
					return false;
				}
				if (that.quality == '') {
					__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm("请选择品质服务");
					return false;
				}
				if (that.inspectionType == '') {
					__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm("请选择验货方式");
					return false;
				}
				var remark = '';
				if (that.remark == '') {
					__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm("请录入加工说明");
					return false;
				} else {
					remark = encodeURI(that.remark);
				}
			}

			__WEBPACK_IMPORTED_MODULE_10__static_api_api_js__["a" /* default */].checkUnpaidOrder(goodsCode, function (ret) {
				if (ret.code == "9999" && ret.msg == "auth vaild fail!") {
					__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm("请登陆");
					window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/login.htm';
					return false;
				}

				var payNum = parseInt(that.payNum);
				var surplusNumberVal = that.goodsBo.goodsNumber;
				var priceNum = that.goodsDetail.goodsPrice;
				var currentNum = that.currentNum;
				var buyGoodsNumber = that.buyGoodsNumber;
				var goodsLimitMax = that.goodsDetail.goodsLimitMax;
				var goodsLimit = that.goodsDetail.goodsLimit;
				var saleTime = that.goodsDetail.saleTime;
				var goodsQuota = that.goodsQuota;
				var isLimitGoodsFlag = that.isLimitGoodsFlag;

				var supplerAccount = that.goodsDetail.supplerAccount;
				var shopAccount = that.goodsDetail.shopAccount;
				var goodsAttrValue = that.goodsDetail.attrValue;
				if (that.orderType == "spot") {
					//现货下单
					var formData = new FormData(__WEBPACK_IMPORTED_MODULE_9_jquery___default()("#addFileForm")[0]);
					__WEBPACK_IMPORTED_MODULE_9_jquery___default.a.ajax({
						url: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__static_js_emallUtils_js__["q" /* getAjaxUrl */])() + '/demand/attachment_upload.htm',
						type: 'POST',
						data: formData,
						async: false,
						cache: false,
						contentType: false, // 告诉jQuery不要去设置Content-Type请求头  
						processData: false, // 告诉jQuery不要去处理发送的数据  
						success: function success(result) {
							result = eval('(' + result + ')');
							if (result.code == "success") {
								var fileName = "";
								if (result.data.fileName != undefined && result.data.fileName != "") {
									fileName = encodeURI(result.data.fileName);
								}
								var filePath = result.data.filePath;
								that.$router.push({
									name: 'ordercommit',
									query: {
										goodsCode: goodsCode,
										shopCode: that.shopCode,
										shopName: that.shopName,
										payNum: payNum,
										orderSource: "noCart",
										distributeAccount: that.distributeAccount,
										distributeName: that.distributeName,
										specName: that.specName,
										printServicePara: that.printService,
										fileNamePara: fileName,
										filePathPara: filePath
									}
								});
							} else {
								__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm(result.msg);
							}
						},
						error: function error(ret) {
							__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm("附件上传失败！");
						}
					});
				} else if (that.orderType == "purchase") {
					//采购订单
					var formData = new FormData(__WEBPACK_IMPORTED_MODULE_9_jquery___default()("#addTextForm")[0]);
					__WEBPACK_IMPORTED_MODULE_9_jquery___default.a.ajax({
						url: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__static_js_emallUtils_js__["q" /* getAjaxUrl */])() + '/demand/multi_img_upload.htm',
						type: 'POST',
						data: formData,
						async: false,
						cache: false,
						contentType: false, // 告诉jQuery不要去设置Content-Type请求头  
						processData: false, // 告诉jQuery不要去处理发送的数据  
						success: function success(result) {
							result = eval('(' + result + ')');
							if (result.code == "success") {
								var imageName = "";
								if (result.data.imgName != undefined && result.data.imgName != "") {
									imageName = encodeURI(result.data.imgName);
								}
								var imagePath = result.data.imgPath;
								that.$router.push({
									name: 'ordercommit',
									query: {
										goodsCode: goodsCode,
										shopCode: that.shopCode,
										shopName: that.shopName,
										payNum: that.produceNum,
										orderSource: "noCart",
										distributeAccount: that.distributeAccount,
										distributeName: that.distributeName,
										specName: that.specName,
										printServicePara: that.printService,
										imageNamePara: imageName,
										imagePathPara: imagePath
									}
								});
							} else {
								__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm(result.msg);
							}
						},
						error: function error(ret) {
							__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm("图片上传失败！");
						}
					});
				}
			});
		},
		//采购下单
		submitOrderExt: function submitOrderExt() {
			var that = this;

			var produceNum = that.produceNum;
			if (produceNum == null || produceNum < 1) {
				__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm("请录入正整数的生产数量");
				return false;
			}
			if (that.quality == '') {
				__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm("请选择品质服务");
				return false;
			}
			if (that.inspectionType == '') {
				__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm("请选择验货方式");
				return false;
			}
			var remark = '';
			if (that.remark == '') {
				__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm("请录入加工说明");
				return false;
			} else {
				remark = encodeURI(that.remark);
			}
			var buyerNote = "";
			var goodOrder = "";
			var orderSource = "noCart";

			var bos = that.boList;

			var specName = null;
			var deliveryType = null;
			if (that.specName != undefined && that.specName != '') {
				specName = encodeURI(that.specName);
			}

			var isChoosePrint = "N"; //是否选择了打印服务
			if (that.printService != undefined && that.printService != "") {
				isChoosePrint = "Y";
			}
			var isChooseLaser = "N"; //是否选择了激光服务
			if (that.laserService != undefined && that.laserService != "") {
				isChooseLaser = "Y";
			}
			var isChoosePrinting = "N"; //是否选择了印花服务
			if (that.printingService != undefined && that.printingService != "") {
				isChoosePrinting = "Y";
			}
			var isChooseRebranding = "N"; //是否选择了换标服务
			if (that.rebrandingService != undefined && that.rebrandingService != "") {
				isChooseRebranding = "Y";
			}

			//				buyerNote = encodeURI(buyerNote);
			var isOnline = false;
			var addressId = null;
			var discountInfo = "";
			var distributeName = that.distributeName;
			var distributeAccount = that.distributeAccount;
			var discountType = "";
			//
			var receiptTurn = 0;
			if (that.isReceiptTrue != 0) {
				if (that.receiptType == 1) {
					receiptTurn = -1;
				} else if (that.receiptType == 2) {
					receiptTurn = that.receiptId;
				} else if (that.receiptType == 3) {
					receiptTurn = that.receiptId1;
				}
			}

			var formData2 = new FormData(__WEBPACK_IMPORTED_MODULE_9_jquery___default()("#addTextForm")[0]);
			__WEBPACK_IMPORTED_MODULE_9_jquery___default.a.ajax({
				url: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__static_js_emallUtils_js__["q" /* getAjaxUrl */])() + '/demand/multi_img_upload.htm',
				type: 'POST',
				data: formData2,
				async: false,
				cache: false,
				contentType: false, // 告诉jQuery不要去设置Content-Type请求头  
				processData: false, // 告诉jQuery不要去处理发送的数据  
				success: function success(result2) {
					result2 = eval('(' + result2 + ')');
					if (result2.code == "success") {
						var imageName = "";
						if (result2.data.imgName != undefined && result2.data.imgName != "") {
							imageName = encodeURI(result2.data.imgName);
						}
						var imagePath = result2.data.imgPath;
						goodOrder = that.goodsCode + ":" + produceNum + ":" + that.shopCode + ":" + specName + ":" + deliveryType + ":" + "N" + ":" + isChoosePrint + ":" + isChooseLaser + ":" + isChoosePrinting + ":" + isChooseRebranding + ":" + null + ":" + null + ":" + imageName + ":" + imagePath;
						//采购订单
						__WEBPACK_IMPORTED_MODULE_10__static_api_api_js__["a" /* default */].confirmPhysicalOrder("purchase", goodOrder, discountInfo, buyerNote, addressId, isOnline, '', '', '', '', orderSource, that.distributeName, that.distributeAccount, that.discountType, null, produceNum, that.quality, that.inspectionType, remark, function (ret) {
							var operation = '兑换';
							if (ret.code != null && ret.code == "success") {
								__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm('订购成功');
							} else if (ret.code == undefined || ret.code == null || ret.code == 'null') {
								__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm('系统繁忙，请稍后再试');
							} else if (ret.code != null && ret.code == "9999") {
								__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm("请先登陆！");
								window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/login.htm';
								return false;
							} else {
								__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm(ret.msg);
							}
						});
					} else if (ret.code != null && ret.code == "9999") {
						__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm("请先登陆！");
						window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/login.htm';
						return false;
					} else {
						__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm(result.msg);
					}
				},
				error: function error(ret) {
					__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm("图片上传失败！");
				}
			});
		},
		refreshGoods: function refreshGoods() {
			if (this.currentPage < this.totalPage) {
				this.currentPage += 1;
			} else if (this.currentPage == this.totalPage) {
				this.currentPage = 1;
			}
			this.getRecommendGoods();
		},
		getRecommendGoods: function getRecommendGoods() {
			var that = this;
			var interval = "intervalAll";
			var catCode = that.catCode;
			var cabinetId = "";
			var pageSize = 5;
			var isQueryAll = "n";
			var currentPage = that.currentPage;
			var orderBy = "sale_number";
			var orderAsc = "desc";
			var shopCode = "";
			var sortTime = "";
			var goodsName = "";
			var firstCatCode = "";
			var brandId = 0;
			var product_type = "";
			var order_type = "";
			__WEBPACK_IMPORTED_MODULE_10__static_api_api_js__["a" /* default */].getGoodsList(cabinetId, catCode, interval, currentPage, orderBy, orderAsc, shopCode, sortTime, pageSize, isQueryAll, goodsName, firstCatCode, brandId, product_type, order_type, function (ret) {
				if (ret.code == "success") {
					that.totalPage = ret.data.totalPage;
					var goods = ret.data.goods;
					if (goods != undefined) {
						for (var i = 0; i < goods.length; i++) {
							//商品图片
							var imgMiddle = goods[i].imgMiddle;
							if (imgMiddle.indexOf(";") != -1) {
								imgMiddle = imgMiddle.split(";")[0];
							}
							imgMiddle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + imgMiddle;
							goods[i].imgMiddle = imgMiddle;
						}
					}
					that.recommendGoodsList = goods;
				}
			});
		},
		addToShoppingCart: function addToShoppingCart() {
			if (!this.unselectSKU) {
				__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm("请选择商品属性！");
				return;
			}
			if (this.goodsNumber === 0) {
				return;
			}
			var that = this;
			var specName = that.specName;
			if (specName != undefined && specName != '') {
				specName = encodeURI(specName);
			}
			var goodsCode = that.goodsCode;
			var operationDesc = "加入购物车";
			var num = __WEBPACK_IMPORTED_MODULE_9_jquery___default()("#payNum").val();
			if (num < 1) {
				__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm("购买数量不能为 0");
				return false;
			}
			__WEBPACK_IMPORTED_MODULE_10__static_api_api_js__["a" /* default */].checkUnpaidOrder(goodsCode, function (ret) {
				if (ret.code != undefined && ret.code == '9999') {
					window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/login.htm';
					return false;
				}
				var payNum = that.payNum;
				var surplusNumberVal = that.goodsDetail.goodsNumber;
				var priceNum = that.goodsDetail.goodsPrice;
				var currentNum = that.currentNum;
				var buyGoodsNumber = that.buyGoodsNumber;
				var goodsLimitMax = that.goodsDetail.goodsLimitMax;
				var goodsLimit = that.goodsDetail.goodsLimit;
				var saleTime = that.goodsDetail.saleTime;
				var goodsQuota = that.goodsQuota;
				var isLimitGoodsFlag = that.isLimitGoodsFlag;

				var supplerAccount = that.goodsDetail.supplerAccount;
				var shopAccount = that.goodsDetail.shopAccount;
				var goodsAttrValue = that.goodsDetail.attrValue;
				if (supplerAccount == undefined) {
					supplerAccount = '';
				}
				if (shopAccount == undefined) {
					shopAccount = '';
				}
				if (goodsAttrValue == undefined) {
					goodsAttrValue = '';
				}
				if (Date.parse(saleTime) > new Date()) {
					__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm('商品尚未起售');
				} else if (isLimitGoodsFlag && parseInt(goodsQuota) < parseInt(payNum)) {
					__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm('数量超过限购数量');
				} else if (parseInt(payNum) > parseInt(surplusNumberVal)) {
					__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm(operationDesc + '数量超过可购买数量');
				} else if (goodsLimitMax != '0' && parseInt(payNum) > parseInt(goodsLimitMax) - parseInt(buyGoodsNumber)) {
					__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm(operationDesc + '数量超过限购数量');
				} else if (payNum < goodsLimit) {
					__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm(operationDesc + '数量小于起够数量');
				} else if (parseInt(payNum) * parseInt(priceNum) > parseInt(currentNum)) {
					__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm(operationDesc + '总积分超过可用积分');
				} else if (parseInt(payNum) > 99) {
					__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm(operationDesc + '数量不得超过99');
				} else {
					__WEBPACK_IMPORTED_MODULE_10__static_api_api_js__["a" /* default */].addShoppingCart(goodsCode, payNum, supplerAccount, goodsAttrValue, shopAccount, specName, function (ret) {
						if (ret.code == "success") {
							__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm("商品加入购物车成功");
							that.$refs.c1.getShoppingCartNum();
							that.$refs.c1.getShoppingCartList();
						} else {
							__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm(ret.msg);
						}
					});
				}
			});
		},
		goIndex: function goIndex() {
			this.$router.push({
				name: 'index'
			});
		},
		getCatGoods: function getCatGoods(catCode) {
			this.$router.push({
				name: 'goodsList',
				params: {
					catCode: catCode
				}
			});
		},
		getCat: function getCat() {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_10__static_api_api_js__["a" /* default */].getAllCat('', function (ret) {
				if (ret.code == "success") {
					that.catList = ret.data.firstCatList;
				}
			});
		},
		//      	sharePage:function(){
		//      		LightSDK.native.share({
		//				    title:"分享的标题",
		//				    content:"分享的内容简介",
		//				    url:"https://www.baidu.com/", //分享出去的链接打开后显示的地址
		//				    image:"https://passport.hscloud.cn/iuccasserver/statics/images/lght.jpg" //分享出去的图片
		//				},function(data){
		//				    if(data.error_no!="0"){
		//				        alertConfirm.singleConfirm(data.error_info);
		//				        return false;
		//				    }else{
		//				        console.log(data);//your code
		//				    }
		//				});
		//      	}

		addOrDeleteFavoriteGoods: function addOrDeleteFavoriteGoods() {
			var that = this;
			var goodsCode = that.goodsCode;
			if (0 == that.isExistFavoriteGoods) {
				__WEBPACK_IMPORTED_MODULE_10__static_api_api_js__["a" /* default */].addUserFavorite("goods", goodsCode, null, function (ret) {
					if (ret.code == "9999" && ret.msg == "auth vaild fail!") {
						__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm("对不起,先登陆！");
						window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/login.htm';
						return false;
					}
					if (ret.code != null && ret.code == "success") {
						that.isExistFavoriteGoods = 1;
					} else {
						__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm(ret.msg);
					}
				});
			} else if (1 == that.isExistFavoriteGoods) {
				__WEBPACK_IMPORTED_MODULE_10__static_api_api_js__["a" /* default */].deleteFavoriteBycode("goods", goodsCode, null, function (ret) {
					if (ret.code == "9999" && ret.msg == "auth vaild fail!") {
						__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm("对不起,先登陆！");
						window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/login.htm';
						return false;
					}
					if (ret.code != null && ret.code == "success") {
						that.isExistFavoriteGoods = 0;
					} else {
						__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm(ret.msg);
					}
				});
			}
		},
		addOrDeleteFavoriteShop: function addOrDeleteFavoriteShop() {
			var that = this;
			var shopCode = that.shopCode;
			if (0 == that.isExistFavoriteShop) {
				__WEBPACK_IMPORTED_MODULE_10__static_api_api_js__["a" /* default */].addUserFavorite("shop", null, shopCode, function (ret) {
					if (ret.code == "9999" && ret.msg == "auth vaild fail!") {
						__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm("对不起,先登陆！");
						window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/login.htm';
						return false;
					}
					if (ret.code != null && ret.code == "success") {
						that.isExistFavoriteShop = 1;
					} else {
						__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm(ret.msg);
					}
				});
			} else if (1 == that.isExistFavoriteShop) {
				__WEBPACK_IMPORTED_MODULE_10__static_api_api_js__["a" /* default */].deleteFavoriteBycode("shop", null, shopCode, function (ret) {
					if (ret.code == "9999" && ret.msg == "auth vaild fail!") {
						__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm("对不起,先登陆！");
						window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/login.htm';
						return false;
					}
					if (ret.code != null && ret.code == "success") {
						that.isExistFavoriteShop = 0;
					} else {
						__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm(ret.msg);
					}
				});
			}
		},
		existFavoriteGoods: function existFavoriteGoods() {
			var that = this;
			var goodsCode = that.goodsCode;
			__WEBPACK_IMPORTED_MODULE_10__static_api_api_js__["a" /* default */].isExistFavorite("goods", goodsCode, null, function (ret) {
				if (ret.code != null && ret.code == "success") {
					that.isExistFavoriteGoods = ret.data.isExist;
				} else {
					console.log("existFavorite：" + ret.msg);
				}
			});
		},
		existFavoriteShop: function existFavoriteShop() {
			var that = this;
			var shopCode = that.shopCode;
			__WEBPACK_IMPORTED_MODULE_10__static_api_api_js__["a" /* default */].isExistFavorite("shop", null, shopCode, function (ret) {
				if (ret.code != null && ret.code == "success") {
					that.isExistFavoriteShop = ret.data.isExist;
				} else {
					console.log("existFavorite：" + ret.msg);
				}
			});
		},
		previewGoods: function previewGoods(goodsCode) {
			console.log(1);
			var that = this;
			__WEBPACK_IMPORTED_MODULE_10__static_api_api_js__["a" /* default */].viewGoodsDetail(goodsCode, function (ret) {
				if (ret.code == "success") {
					var good = ret.data.goods;
					if (good != undefined) {
						that.goodsBo = good;
					}
					that.goodsDetail = JSON.parse(good.attrValue);
					that.marketPrice = JSON.parse(good.attrValue).marketPrice / 100;
					//			 			}
					//产品详情图片路径添加绝对路径
					that.goodsDesc = good.goodsDesc.replace(/\/upload\//g, __WEBPACK_IMPORTED_MODULE_10__static_api_api_js__["a" /* default */].getImgPath() + "/upload/");
					that.goodsName = good.goodsName;
					that.catCode = good.catCode;
					//unitPrice 是产品单价
					that.goodsPrice = (good.unitPrice / 100).toFixed(2);
					that.goodsCode = good.goodsCode;
					that.goodsCatNameCn = good.ext3;
					//这个地方估计有坑~
					var imgArray = [];
					if (good.imgLarge.indexOf(";") != -1) {
						good.imgLarge = good.imgLarge.substring(0, good.imgLarge.length - 1);
						that.goodsImgs = good.imgLarge.split(";");
						good.imgLarge = that.goodsImgs[0];
					}

					that.goodsImgLarge = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + good.imgLarge;
					for (var j = 0; j < that.goodsImgs.length; j++) {
						that.goodsImgs[j] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + that.goodsImgs[j];
					}

					that.goodsNumber = good.goodsNumber;
					that.discount = (that.goodsPrice / that.marketPrice * 10).toFixed(2);
					that.breaks = parseFloat(that.marketPrice - that.goodsPrice).toFixed(2);
					that.saleNumber = good.saleNumber;
					that.inpSaleNumber = good.inpSaleNumber;
				}
			});
		},
		viewExpressFees: function viewExpressFees() {
			var that = this;
			window.open(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__static_js_emallUtils_js__["b" /* getEmallUrl */])() + '/expresspManage/express_set_view.htm?shopCode=' + that.shopCode);
		},
		computeTime: function computeTime() {
			var that = this;
			var activityEndTime = new Date(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__static_js_emallUtils_js__["r" /* dateFormat */])(that.activityEndTime).replace(/-/g, "/"));
			var begSeconds = activityEndTime.getTime() - new Date().getTime(); //时间差的毫秒数
			//计算出小时数
			var leave1 = begSeconds % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
			var hours = Math.floor(begSeconds / (3600 * 1000));
			//计算相差分钟数
			var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
			var minutes = Math.floor(leave2 / (60 * 1000));
			//计算相差秒数
			var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
			var seconds = Math.round(leave3 / 1000);
			that.hour = hours + "";
			that.minute = minutes + "";
			that.second = seconds + "";
		},
		handleScroll: function handleScroll(e) {
			if (Math.abs(e.currentTarget.scrollY) > 300) {
				__WEBPACK_IMPORTED_MODULE_9_jquery___default()(".top").show();
			} else {
				__WEBPACK_IMPORTED_MODULE_9_jquery___default()(".top").hide();
			}
		},
		scrollToTop: function scrollToTop() {
			__WEBPACK_IMPORTED_MODULE_9_jquery___default()("html,body").animate({
				scrollTop: 0
			}, 500);
		},
		//根据点击上传按钮触发input
		change_input: function change_input() {
			var inputArr = __WEBPACK_IMPORTED_MODULE_9_jquery___default()('#addTextForm input');
			var add_inputId = ''; //需要被触发的input
			for (var i = 0; i < inputArr.length; i++) {
				// 根据input的value值判断是否已经选择文件
				if (!inputArr[i].value) {
					//如果没有选择,获得这个input的ID      
					add_inputId = inputArr[i].id;
					break;
				}
			}
			if (add_inputId) {
				//如果需要被触发的input ID存在,将对应的input触发
				return __WEBPACK_IMPORTED_MODULE_9_jquery___default()("#" + add_inputId).click();
			} else {
				__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm("最多选择" + this.imgNum + "张图片");
			}
		},

		//当input选择了图片的时候触发,将获得的src赋值到相对应的img
		setImg: function setImg(e) {
			var target = e.target;
			__WEBPACK_IMPORTED_MODULE_9_jquery___default()('#img_' + target.id).attr('src', getFileUrl(e.srcElement));
			__WEBPACK_IMPORTED_MODULE_9_jquery___default()('#img_' + target.id).show();
		},

		//点击图片删除该图片并清除相对的input
		deleteImg: function deleteImg(e) {
			var target = e.target;
			var inputID = ''; //需要清除value的input
			if (target.nodeName == 'IMG') {
				target.src = '';
				inputID = target.id.replace('img_', ''); //获得需要清除value的input
				__WEBPACK_IMPORTED_MODULE_9_jquery___default()('input#' + inputID).val("");
			}
		},
		setFileName: function setFileName(e) {
			/*let target = e.target;
   var file=jQuery('#' + target.id).files;
   var fileName=jQuery('#' + target.id).files[0].name;
   jQuery('#file_' + target.id).show();*/
		},

		//根据点击上传按钮触发input
		change_File: function change_File() {
			var inputArr = __WEBPACK_IMPORTED_MODULE_9_jquery___default()('#addFileForm input');
			var add_inputId = ''; //需要被触发的input
			for (var i = 0; i < inputArr.length; i++) {
				// 根据input的value值判断是否已经选择文件
				if (!inputArr[i].value) {
					//如果没有选择,获得这个input的ID      
					add_inputId = inputArr[i].id;
					break;
				}
			}
			if (add_inputId) {
				//如果需要被触发的input ID存在,将对应的input触发
				return __WEBPACK_IMPORTED_MODULE_9_jquery___default()("#" + add_inputId).click();
			} else {
				__WEBPACK_IMPORTED_MODULE_11__static_js_alertConfirm_js__["a" /* default */].singleConfirm("最多选择" + this.imgNum + "个附件");
			}
		},

		//当input选择了图片的时候触发,将获得的src赋值到相对应的img
		setFile: function setFile(e) {
			var target = e.target;
			//jQuery('#file_' + target.id).val(getFileUrl(e.srcElement).name);
			//				let fileName=jQuery('#' + target.id).files[0].name;
			//				jQuery('#' + target.id).text("附件"+target.id);
			__WEBPACK_IMPORTED_MODULE_9_jquery___default()('#' + target.id).show();
			__WEBPACK_IMPORTED_MODULE_9_jquery___default()('#a_' + target.id).show();
		},

		//点击图片删除该图片并清除相对的input
		deleteFile: function deleteFile(e) {
			var target = e.target;
			var inputID = ''; //需要清除value的input
			__WEBPACK_IMPORTED_MODULE_9_jquery___default()('#a_' + inputID).hide();
			inputID = target.id.replace('a_', ''); //获得需要清除value的input
			__WEBPACK_IMPORTED_MODULE_9_jquery___default()('input#' + inputID).val("");
			__WEBPACK_IMPORTED_MODULE_9_jquery___default()('input#' + inputID).hide();
			target.remove();
		}
	},
	beforeMount: function beforeMount() {
		var that = this;
		window.scrollTo(0, 0);
		that.imgPath = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=";

		if (localStorage.getItem("account")) {
			that.isLogin = true;
		}
		var goodsCode = "";
		if (that.$route.params.goodsCode != undefined) {
			goodsCode = that.$route.params.goodsCode;
		}
		if (that.$route.query.goodsCode != undefined) {
			goodsCode = that.$route.query.goodsCode;
		}
		that.goodsCode = goodsCode;
		var distributeAccount = that.$route.query.distributeAccount;
		if (distributeAccount != undefined) {
			that.distributeAccount = distributeAccount;
			if (distributeAccount == "") {
				that.canAddToShoppingCart = true;
			}
		}
		var distributeName = that.$route.query.distributeName;
		if (distributeName != undefined) {
			that.distributeName = distributeName;
		}
		var isPreview = that.$route.query.isPreview;
		if (isPreview != undefined && isPreview == "true") {
			that.isPreview = isPreview;
			this.previewGoods(goodsCode);
		} else {
			this.getGoodDetail(goodsCode);
		}
		this.getGoodCredits(goodsCode, 1, 20);
		this.existFavoriteGoods();

		this.getCat();
		//			this.existFavoriteShop();
	},
	beforeDestroy: function beforeDestroy() {
		window.clearInterval(this.computeFlag);
	},
	mounted: function mounted() {
		__WEBPACK_IMPORTED_MODULE_9_jquery___default()(".jqzoom").jqueryzoom();
		//jQuery(".beforeDestroy").val();
		__WEBPACK_IMPORTED_MODULE_9_jquery___default()('.city_select_css').each(function (i, j) {
			var options = __WEBPACK_IMPORTED_MODULE_9_jquery___default()(j).find("option");
			options.attr("selected", false);
			options.first().attr("selected", true);
		});

		$(".sp-dt-tab .hd ul li").click(function () {
			var index = $(this).index();
			$(this).addClass("hover").siblings().removeClass();
			$(".sp-dt-tab .bd").eq(index).show().siblings(".sp-dt-tab .bd").hide();
		});

		this.$nextTick(function () {
			window.addEventListener('scroll', this.handleScroll); //滚动事件监听
		});
	}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "AH8N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B9hn":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "BLUo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_goodsDetail_vue__ = __webpack_require__("AA4W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36686b1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_goodsDetail_vue__ = __webpack_require__("Tgkl");
function injectStyle (ssrContext) {
  __webpack_require__("yp1l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_goodsDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36686b1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_goodsDetail_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CyML":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CzyT":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "DVZZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_paySuccess_vue__ = __webpack_require__("uRVv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b63e65bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_paySuccess_vue__ = __webpack_require__("gwPj");
function injectStyle (ssrContext) {
  __webpack_require__("lDv9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b63e65bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_paySuccess_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b63e65bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_paySuccess_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ec7t":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Ecbd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_js_emallUtils_js__ = __webpack_require__("spYF");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'footercopyright',
	data: function data() {
		return {
			aboutUsUrl: '',
			aboutusList: []
		};
	},

	methods: {
		requestCms: function requestCms(req_param) {
			var that = this;
			var params = {
				c: req_param
			};
			jQuery.ajax({
				type: "get",
				url: __WEBPACK_IMPORTED_MODULE_0__static_js_emallUtils_js__["k" /* cmsApiUrl */],
				async: false,
				dataType: "jsonp", // 返回的数据类型，设置为JSONP方式
				cache: true,
				data: params,
				success: function success(ret) {
					if (ret.code == 'success') {
						var list = ret.values.list;
						if (list != undefined && list.length > 0) {
							that.aboutusList = list;
						}
					}
				},
				error: function error(err) {}
			});
		}
	},
	mounted: function mounted() {
		this.aboutUsUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__static_js_emallUtils_js__["l" /* getAboutUsUrl */])();
		this.requestCms("aboutus");
		/**
   * 站长统计
   */
		var cnzz_protocol = "https:" == document.location.protocol ? "https://" : "http://";
		jQuery("#site_stat").html(unescape("%3Cspan id='cnzz_stat_icon_1276729368'%3E%3C/span%3E%3Cscript src='" + cnzz_protocol + "s23.cnzz.com/z_stat.php%3Fid%3D1276729368%26show%3Dpic' type='text/javascript'%3E%3C/script%3E"));
	}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "Eh5F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FoZp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "indexbg"
  }, [_c('topbar'), _vm._v(" "), _c('sortHeader'), _vm._v(" "), _c('div', {
    staticClass: "clear mt15"
  }), _vm._v(" "), _c('div', {
    staticClass: "w1200 bc"
  }, [_c('div', {
    staticClass: "hq-shopping-cart"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tipsbox success"
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v(" "), _c('h3', [_vm._v("支付申请成功！")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("说明：您的支付申请已受理，请查看是否扣费。")]), _vm._v(" "), _c('div', {
    staticClass: "ft"
  }, [_c('a', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.viewAllOrders()
      }
    }
  }, [_vm._v("查看全部订单")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("返回首页")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('footermenu'), _vm._v(" "), _c('footercopyright')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hq-reg-step"
  }, [_c('ul', {
    staticClass: "ico"
  }, [_c('li', [_c('p', {
    staticClass: "item"
  }, [_vm._v("购物车")]), _vm._v(" "), _c('i', {
    staticClass: "step-count"
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "line"
  })]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "item"
  }, [_vm._v("提交订单")]), _vm._v(" "), _c('i', {
    staticClass: "step-count"
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "line"
  })]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "item"
  }, [_vm._v("确认付款")]), _vm._v(" "), _c('i', {
    staticClass: "step-count"
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "line"
  })]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('p', {
    staticClass: "item"
  }, [_vm._v("下单成功")]), _vm._v(" "), _c('i', {
    staticClass: "step-count"
  })])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb20 ad-4 mt20"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("dlf8"),
      "width": "1200",
      "height": "60"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FruX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_goodsClassList_vue__ = __webpack_require__("/ZyE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39b5de0e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_goodsClassList_vue__ = __webpack_require__("SHpc");
function injectStyle (ssrContext) {
  __webpack_require__("Ktix")
  __webpack_require__("Eh5F")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-39b5de0e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_goodsClassList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39b5de0e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_goodsClassList_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Fw7Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("lRO8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71629636_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("nFGY");
function injectStyle (ssrContext) {
  __webpack_require__("Gsi9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71629636_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "G5fF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G5tM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_goodsList_vue__ = __webpack_require__("+Z1y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d79e83aa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_goodsList_vue__ = __webpack_require__("P5WD");
function injectStyle (ssrContext) {
  __webpack_require__("k+ur")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d79e83aa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_goodsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d79e83aa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_goodsList_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Gias":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "w1200 bc"
  }, [_c('a', {
    staticClass: "logo fl",
    attrs: {
      "href": "#",
      "title": "云永云商城"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "r-box fr"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "mycart ml25"
  }, [_c('i', {
    staticClass: "ico-orders"
  }), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.goOrder('')
      }
    }
  }, [_vm._v("我的订单 "), _c('span', {
    staticClass: "ico-shopping-amount"
  }, [_vm._v(_vm._s(_vm.allCount))])]), _vm._v(" "), _c('i', {
    staticClass: "ico-r"
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-list orders"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('wait_buyer_pay')
      }
    }
  }, [_vm._v("等待买家付款 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.payCount))])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('wait_send_goods')
      }
    }
  }, [_vm._v("等待卖家发货 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.sendCount))])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('wait_buyer_confirm_goods')
      }
    }
  }, [_vm._v("等待确认收货 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.putCount))])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('trade_finish')
      }
    }
  }, [_vm._v("订单完成 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.receiveCount))])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('trade_close')
      }
    }
  }, [_vm._v("订单关闭 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.closeCount))])])])])])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search"
  }, [_c('span', {
    staticClass: "ico"
  }), _vm._v(" "), _c('input', {
    staticClass: "text",
    attrs: {
      "type": "text",
      "placeholder": "请输入关键字"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn"
  }, [_vm._v("搜索")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mycart"
  }, [_c('i', {
    staticClass: "ico-cart"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("我的购物车")]), _vm._v(" "), _c('span', {
    staticClass: "ico-shopping-amount"
  }, [_vm._v("0")]), _vm._v(" "), _c('i', {
    staticClass: "ico-r"
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-list none",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('div', {
    staticClass: "no-goods"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("HdMn"),
      "width": "57",
      "height": "49"
    }
  }), _vm._v("购物车中还没有商品，赶紧选购吧！\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "mylist"
  }, [_c('h4', [_vm._v("最新加入的商品")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "li-1"
  }, [_c('span', {
    staticClass: "fr"
  }, [_vm._v("小计：￥599.00")])]), _vm._v(" "), _c('li', {
    staticClass: "li-2"
  }, [_c('a', {
    staticClass: "fl spic",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("nnXf"),
      "width": "50",
      "height": "50"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("一种超硬物料自动破碎装置物料自动破碎装置")])]), _vm._v(" "), _c('p', {
    staticClass: "other"
  }, [_c('span', [_vm._v("￥599.00×1")]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "del",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("删除")])])])]), _vm._v(" "), _c('div', {
    staticClass: "fbar"
  }, [_c('span', {
    staticClass: "fl ml10"
  }, [_vm._v("共2件商品　共计"), _c('b', [_vm._v("￥ 738.00")])]), _vm._v(" "), _c('a', {
    staticClass: "fr gobuy",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("去购物车")])])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Gsi9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Gvnd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H1Ye":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H6cY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "grid-940-1 mt20"
  }, [_c('div', {
    staticClass: "loginpage-left",
    attrs: {
      "id": "div_left"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "loginpage-right"
  }, [_c('form', [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "backUrl",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "qualifyType",
      "value": "002001"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "clientType",
      "value": "uc"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "exchangeId",
      "value": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "loginpage-title"
  }, [_c('span', {
    staticClass: "Login_Span_1",
    class: {
      'Cur': _vm.isPwdActive
    },
    attrs: {
      "id": "tagPwd"
    },
    on: {
      "click": function($event) {
        _vm.changeTagFun('tagPwd')
      }
    }
  }, [_vm._v("密码登录")]), _vm._v(" "), _c('span', {
    staticClass: "Login_Span_2",
    class: {
      'Cur': _vm.isMobileActive
    },
    attrs: {
      "id": "tagMobile"
    },
    on: {
      "click": function($event) {
        _vm.changeTagFun('tagMobile')
      }
    }
  }, [_vm._v("手机验证码登录")])]), _vm._v(" "), (_vm.changeTag === 'tagPwdContent') ? _c('table', {
    staticClass: "loginpage-table Cur",
    attrs: {
      "width": "100%",
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "login_th"
  }, [_c('font', {
    staticClass: "loginpage-star",
    attrs: {
      "id": "account_font"
    }
  }, [_vm._v("*")]), _vm._v("登录账号 ：")], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "login_th"
  }, [_c('font', {
    staticClass: "loginpage-star",
    attrs: {
      "id": "p_font"
    }
  }, [_vm._v("*")]), _vm._v("登录密码：")], 1), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(" ")]), _vm._v(" "), _c('td', [_c('input', {
    staticClass: "btn-loginpage cur",
    attrs: {
      "type": "button",
      "value": "登 录"
    },
    on: {
      "click": function($event) {
        _vm.login()
      }
    }
  }), _vm._v("    \n\t\t\t\t          ")])])])]) : _vm._e(), _vm._v(" "), (_vm.changeTag === 'tagMobileContent') ? _c('table', {
    staticClass: "loginpage-table Cur",
    attrs: {
      "width": "100%",
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "login_th_1"
  }, [_c('font', {
    staticClass: "loginpage-star",
    attrs: {
      "id": "account_font"
    }
  }, [_vm._v("*")]), _vm._v("手机号 ：")], 1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "login_th_1"
  }, [_c('font', {
    staticClass: "loginpage-star",
    attrs: {
      "id": "p_font"
    }
  }, [_vm._v("*")]), _vm._v("验证码：")], 1), _vm._v(" "), _c('td', {
    staticClass: "login_td_1"
  }, [_c('input', {
    staticClass: "input-txt",
    attrs: {
      "id": "checkCode",
      "name": "checkCode",
      "value": "",
      "type": "password",
      "maxlength": "20"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "mui-btn mr10 f12 login_button",
    attrs: {
      "type": "button",
      "id": "buttonView"
    },
    on: {
      "click": function($event) {
        _vm.sendCode()
      }
    }
  }, [_vm._v("获取验证码")])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(" ")]), _vm._v(" "), _c('td', [_c('input', {
    staticClass: "btn-loginpage cur",
    attrs: {
      "type": "button",
      "value": "登 录"
    },
    on: {
      "click": function($event) {
        _vm.mobileLogin()
      }
    }
  }), _vm._v("    \n\t\t\t\t          ")])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clr"
  })])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "login_td"
  }, [_c('input', {
    staticClass: "input-txt",
    staticStyle: {
      "color": "#000000"
    },
    attrs: {
      "type": "text",
      "id": "account",
      "name": "account",
      "value": "",
      "maxlength": "256"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "login_td"
  }, [_c('input', {
    staticClass: "input-txt",
    attrs: {
      "id": "password",
      "name": "password",
      "value": "",
      "type": "password",
      "maxlength": "20"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "login_td_1"
  }, [_c('input', {
    staticClass: "input-txt",
    staticStyle: {
      "color": "#000000"
    },
    attrs: {
      "type": "text",
      "id": "mobile",
      "name": "mobile",
      "value": "",
      "maxlength": "256"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HCTz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_api_api_js__ = __webpack_require__("fXcb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_js_emallUtils_js__ = __webpack_require__("spYF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__("ORbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_router__ = __webpack_require__("/ocq");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'emallheader',
	data: function data() {
		return {
			isLogin: false,
			shoppingCartNum: 0,
			boList: [],
			count: 0,
			goodsImgs: [],
			sumMoney: 0,
			sortParam: '',
			carIsShow: '',
			indexUrl: '',
			orderUrl: '',
			allCount: 0,
			payCount: 0,
			putCount: 0,
			receiveCount: 0,
			sendCount: 0,
			closeCount: 0,
			isShow: false
		};
	},

	methods: {
		changeParam: function changeParam(para) {
			this.sortParam = para;
		},
		orderShow: function orderShow() {
			jQuery(".orders-list").show();
		},
		orderHide: function orderHide() {
			jQuery(".orders-list").hide();
		},
		goOrder: function goOrder(tradeStatus) {
			var account = localStorage.getItem("account");
			if (account != undefined && account != "") {
				window.location.href = this.orderUrl + "?tradeStatus=" + tradeStatus;
			} else {
				window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/login.htm';
			}
		},
		shopCarShow: function shopCarShow() {
			jQuery(".goods-list").show();
		},
		shopCarHide: function shopCarHide() {
			jQuery(".goods-list").hide();
		},
		sortGoods: function sortGoods() {
			this.$router.push({ name: 'goodsList', query: { sortParam: this.sortParam } });
			this.$emit('input', this.sortParam);
		},
		sortShops: function sortShops() {
			this.$router.push({ name: 'shopsList', query: { sortParam: this.sortParam } });
		},
		getOrderCount: function getOrderCount(shopCode) {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_0__static_api_api_js__["a" /* default */].getOrderCount(function (ret) {
				if (ret.code == "success") {
					that.allCount = ret.data.allCount;
					that.payCount = ret.data.payCount;
					that.putCount = ret.data.putCount;
					that.receiveCount = ret.data.receiveCount;
					that.sendCount = ret.data.sendCount;
					that.closeCount = ret.data.closeCount;
				}
			});
		},

		getShoppingCartNum: function getShoppingCartNum(shopCode) {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_0__static_api_api_js__["a" /* default */].getShoppingCartNum(function (ret) {
				if (ret.code == "success") {
					that.shoppingCartNum = ret.data.shoppingCartNum;
				}
			});
		},
		getShoppingCartList: function getShoppingCartList() {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_0__static_api_api_js__["a" /* default */].getShoppingCartList(function (ret) {
				if (ret.code == "success") {
					that.boList = ret.data.boList;
					var totalCount = 0;
					var bos = new Array();
					bos = ret.data.boList;
					var money = 0;
					for (var i = 0; i < bos.length; i++) {
						var imgSmall = bos[i].imgSmall;
						if (imgSmall.indexOf(";") != -1) {
							imgSmall = imgSmall.split(";")[0];
						}
						bos[i].imgSmall = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + imgSmall;
						bos[i].unitPrice = bos[i].unitPrice / 100;
						money = money + bos[i].unitPrice * bos[i].goodsNumber;
						totalCount = totalCount + bos[i].goodsNumber;
					}
					that.sumMoney = money;
					that.count = totalCount;
				}
			});
		},
		deleteGoods: function deleteGoods(id, goodsCode, index) {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_0__static_api_api_js__["a" /* default */].deleteGoods(id, goodsCode, function (ret) {
				if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__static_js_emallUtils_js__["n" /* parseResult */])(ret, null, false)) {
					//jQuery("#" + goodsCode + "_cart_pro").remove();
					that.boList.splice(index, 1);
					that.getShoppingCartNum();
				}
			});
		},
		toDetail: function toDetail(goodsCode) {
			this.$router.push({ path: '/goodsDetails', query: { goodsCode: goodsCode } });
			window.location.reload();
		},
		toShopCart: function toShopCart() {
			this.$router.push({ path: '/shopCart' });
		},
		shopCartShow: function shopCartShow() {
			this.isShow = true;
		},
		shopCartHide: function shopCartHide() {
			this.isShow = false;
		}
	}, mounted: function mounted() {
		this.indexUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__static_js_emallUtils_js__["o" /* getIndexUrl */])();
		this.orderUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__static_js_emallUtils_js__["b" /* getEmallUrl */])() + '/orderManage/myOrderList.htm';
		this.getShoppingCartNum();
		this.getShoppingCartList();
		this.getOrderCount();
		var account = localStorage.getItem("account");
		if (account != undefined && account != "") {
			this.isLogin = true;
		}
	}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "HdMn":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADkAAAAxBAMAAACSZRzbAAAABGdBTUEAALGPC/xhBQAAABVQTFRF9/f33t7e7+/v5ubm1tbWzMzM////aV8NPAAAAMlJREFUOMvtlFEOgyAMhn3aDfQAy8IJHM+Lo14AyvOm6P2PMEDUidBsicle1jf65W9/irYYiXgUh9MebfAcHRzVOdoJQWhdbUm4ulppggJiG6QJWnrqpanKRvkbCcFSFFriRkadiGlMrnKTtK6qNIVVFmgHrodi7nQGHlFvL/Tq5Zim2o+vYXHlN7rvG95Tr7lLQ1FQFEX80x/RTXxFzQbG7zt9mHPcDt059X1ZGXxHn4ghaVDu6LD8ecNq+UNKVx7LOddBdcyOfQE/YB6bHupS8QAAAABJRU5ErkJggg=="

/***/ }),

/***/ "HoL6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('topbar'), _vm._v(" "), _c('sortHeader'), _vm._v(" "), _c('heardernav'), _vm._v(" "), _c('div', {
    staticClass: "border p20 container_outer"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "clr"
  }), _vm._v(" "), _c('div', {
    staticClass: "mt20"
  }, [(_vm.canCreateAddress) ? _c('input', {
    staticClass: "hq-btn-6 mr15",
    attrs: {
      "type": "button",
      "value": "新增收货地址"
    },
    on: {
      "click": function($event) {
        _vm.toAddressDetail()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('form', [_c('table', {
    staticClass: "table-c-5",
    attrs: {
      "width": "100%",
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [_vm._m(1), _vm._v(" "), _vm._l((_vm.boList), function(bo, index) {
    return _c('tr', {
      on: {
        "mouseenter": function($event) {
          _vm.addressShow(index)
        },
        "mouseleave": function($event) {
          _vm.addressHide()
        }
      }
    }, [_c('td', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(bo.contextName) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(bo.province) + _vm._s(bo.city) + _vm._s(bo.district) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(bo.address) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(bo.zipcode) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(bo.mobile) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "change_a",
      on: {
        "click": function($event) {
          _vm.toAddressDetail(bo.id)
        }
      }
    }, [_vm._v("修改")]), _vm._v("  |  "), _c('a', {
      staticClass: "delete_a",
      on: {
        "click": function($event) {
          _vm.deleteAddress(bo.id, index)
        }
      }
    }, [_vm._v("删除")])]), _vm._v(" "), _c('td', [(bo.isDefault == 'y') ? _c('span', {
      staticClass: "note"
    }, [_vm._v("默认地址")]) : _vm._e(), _vm._v(" "), (_vm.addressIndex == index && bo.isDefault == 'n') ? _c('input', {
      staticClass: "tbl-deliver-address",
      attrs: {
        "type": "button",
        "value": "设为默认"
      },
      on: {
        "click": function($event) {
          _vm.setDefaultAddress(bo.id, index)
        }
      }
    }) : _vm._e()])])
  })], 2)])])])]), _vm._v(" "), _c('footermenu'), _vm._v(" "), _c('footercopyright')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-h4"
  }, [_c('h4', {
    staticClass: "left"
  }, [_vm._v("收货地址管理")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticStyle: {
      "width": "60px",
      "padding-right": "15px",
      "text-align": "left"
    }
  }, [_vm._v("收货人")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "80px",
      "padding-right": "15px",
      "text-align": "left"
    }
  }, [_vm._v("所在地区")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "100px",
      "padding-right": "15px",
      "text-align": "left"
    }
  }, [_vm._v("详细地址")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "60px",
      "padding-right": "15px",
      "text-align": "left"
    }
  }, [_vm._v("邮政编码")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "70px",
      "padding-right": "15px",
      "text-align": "left"
    }
  }, [_vm._v("联系电话")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "70px",
      "padding-right": "15px",
      "text-align": "left"
    }
  }, [_vm._v("操作")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "70px",
      "padding-right": "15px",
      "text-align": "left"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IJlu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('topbar'), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('sortHeader'), _vm._v(" "), _c('heardernav', {
    ref: "navComp",
    attrs: {
      "activeLi": _vm.activeLi,
      "isRefresh": _vm.isRefresh
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clear mt15"
  }), _vm._v(" "), _c('div', {
    staticClass: "w1200 bc"
  }, [_c('div', {
    staticClass: "hq-crumb-wrap"
  }, [_c('ul', [_vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "item sep"
  }, [_vm._v(">")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.sortParam) + _vm._s(_vm.catNameCn) + _vm._s(_vm.brandName))])])]), _vm._v(" "), _c('div', {
    staticClass: "sp-side-wrap"
  }, [_vm._m(1), _vm._v(" "), _c('ul', _vm._l((_vm.recommendGoodsList), function(recommendGood) {
    return _c('li', [_c('a', {
      staticClass: "fl pic",
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(recommendGood.goodsCode, recommendGood.productType)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": recommendGood.imgMiddle,
        "width": "106",
        "height": "106"
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "title"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(recommendGood.goodsCode, recommendGood.productType)
        }
      }
    }, [_vm._v(_vm._s(recommendGood.goodsName))])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "sp-search-list"
  }, [_c('div', {
    staticClass: "l-hd"
  }, [_c('div', {
    staticClass: "top-num fr"
  }, [_vm._v("共" + _vm._s(_vm.totalItem) + "条 "), _c('span', {
    staticClass: "co2"
  }, [_vm._v(_vm._s(_vm.sortParam) + _vm._s(_vm.catNameCn))])]), _vm._v(" "), _c('h3', [_vm._v("搜索结果")])]), _vm._v(" "), _c('div', {
    staticClass: "hq-selector"
  }, [_c('div', {
    staticClass: "hd"
  }, [_c('dl', [_c('dt', [_vm._v("已选条件：")]), _vm._v(" "), _c('dd', {
    attrs: {
      "id": "choosedCond"
    }
  }, _vm._l((_vm.choosedCondItem), function(condItem, index) {
    return _c('span', {
      staticClass: "checked-item",
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "condType": condItem.condType
      }
    }, [_vm._v(_vm._s(condItem.condName)), _c('a', {
      staticClass: "del",
      on: {
        "click": function($event) {
          _vm.removeCondition(index, condItem.condType)
        }
      }
    })])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "bd"
  }, [_c('dl', [_c('dt', [_vm._v("价格：")]), _vm._v(" "), _c('dd', [_c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', 'intervalAll')
      }
    }
  }, [_vm._v("不限")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '0,100')
      }
    }
  }, [_vm._v("0-100")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '101,200')
      }
    }
  }, [_vm._v("101-200")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '201,300')
      }
    }
  }, [_vm._v("201-300")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '301,500')
      }
    }
  }, [_vm._v("301-500")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '501,1000')
      }
    }
  }, [_vm._v("501-1000")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '1001,5000')
      }
    }
  }, [_vm._v("1001-5000")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '5000,')
      }
    }
  }, [_vm._v("5000以上")])])]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("发布时间：")]), _vm._v(" "), _c('dd', [_c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'timeAll')
      }
    }
  }, [_vm._v("不限")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'oneDay')
      }
    }
  }, [_vm._v("一天内")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'twoDay')
      }
    }
  }, [_vm._v("两天内")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'oneWeek')
      }
    }
  }, [_vm._v("一周内")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'oneMonth')
      }
    }
  }, [_vm._v("一月内")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "pro-tool mt20"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('ul', [_c('li', {
    class: {
      "hover": _vm.sortCondition === "defaultSort"
    },
    on: {
      "click": function($event) {
        _vm.sortGoods('defaultSort')
      }
    }
  }, [_vm._v("默认")]), _vm._v(" "), _c('li', {
    class: {
      "hover": _vm.sortCondition === "saleAmount"
    },
    on: {
      "click": function($event) {
        _vm.sortGoods('saleAmount')
      }
    }
  }, [_vm._v("销量"), _c('i', {
    class: {
      "up": _vm.sortSaleAmount == "asc"
    }
  })]), _vm._v(" "), _c('li', {
    class: {
      "hover": _vm.sortCondition === "publishTime"
    },
    on: {
      "click": function($event) {
        _vm.sortGoods('publishTime')
      }
    }
  }, [_vm._v("发布时间"), _c('i', {
    class: {
      "up": _vm.sortPublishTime == "asc"
    }
  })]), _vm._v(" "), _c('li', {
    class: {
      "hover": _vm.sortCondition === "price"
    },
    on: {
      "click": function($event) {
        _vm.sortGoods('price')
      }
    }
  }, [_vm._v("价格"), _c('i', {
    class: {
      "up": _vm.sortPrice == "asc"
    }
  })]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "price-wrap"
  }, [_c('div', {
    staticClass: "input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lower),
      expression: "lower"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.lower)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lower = $event.target.value
      }
    }
  }), _vm._v(" - "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.upper),
      expression: "upper"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.upper)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.upper = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "price-tool"
  }, [_c('div', {
    staticClass: "price-tool-btn"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.clearUserDefined()
      }
    }
  }, [_vm._v("清空")])]), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.userDefinedCondition()
      }
    }
  }, [_vm._v("确定")])])])])])])])])]), _vm._v(" "), (_vm.firstCatCode != 'spike') ? _c('div', {
    staticClass: "pro-list"
  }, [_c('ul', _vm._l((_vm.goodsList), function(goodsBo) {
    return _c('li', [_c('p', {
      staticClass: "img"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(goodsBo.goodsCode, goodsBo.productType)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": goodsBo.imgMiddle,
        "width": "265",
        "height": "265"
      }
    })])]), _vm._v(" "), _c('p', {
      staticClass: "title"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(goodsBo.goodsCode, goodsBo.productType)
        }
      }
    }, [_vm._v(_vm._s(goodsBo.goodsName))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "20%",
        "float": "right",
        "text-align": "right"
      },
      attrs: {
        "id": "alert_btn"
      }
    }, [(goodsBo.seven_day_return == 'Y') ? _c('img', {
      staticStyle: {
        "width": "17px",
        "height": "17px"
      },
      attrs: {
        "src": __webpack_require__("Lw0y")
      }
    }) : _vm._e()])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.firstCatCode == 'spike') ? _c('div', {
    staticClass: "bd"
  }, [_c('ul', {
    staticClass: "miaosha-ul"
  }, _vm._l((_vm.goodsList), function(goodsBo) {
    return _c('li', [_c('p', {
      staticClass: "pic tc"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(goodsBo.goodsCode, goodsBo.productType)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": goodsBo.imgMiddle,
        "width": "265",
        "height": "265"
      }
    })])]), _vm._v(" "), _c('p', {
      staticClass: "title"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(goodsBo.goodsCode, goodsBo.productType)
        }
      }
    }, [_vm._v(_vm._s(goodsBo.goodsName))])]), _vm._v(" "), _c('div', {
      staticClass: "line-price"
    }, [_c('span', {
      staticClass: "co3"
    }, [_vm._v("￥" + _vm._s((goodsBo.unitPrice / 100).toFixed(2)))]), _c('span', {
      staticClass: "old"
    }, [_vm._v("￥" + _vm._s((goodsBo.marketPrice / 100).toFixed(2)))])]), _vm._v(" "), _c('div', {
      staticClass: "pinpainow_item_time"
    }, [(goodsBo.saleStatus === 'end') ? _c('span', {
      staticClass: "brandsknow_time_txt"
    }, [_vm._v("                         \n                \t\t\t\t已结束                       \n                \t\t\t")]) : _vm._e(), _vm._v(" "), (goodsBo.saleStatus === 'wait_start') ? _c('span', {
      staticClass: "brandsknow_time_txt"
    }, [_vm._v("                         \n                \t\t\t\t距开始 "), _c('i', {
      staticClass: "brandsknow_time_txt_time"
    }, [_vm._v(_vm._s(goodsBo.hour))]), _vm._v("时"), _c('i', {
      staticClass: "brandsknow_time_txt_time"
    }, [_vm._v(_vm._s(goodsBo.minute))]), _vm._v("分"), _c('i', {
      staticClass: "brandsknow_time_txt_time"
    }, [_vm._v(_vm._s(goodsBo.second))]), _vm._v("秒                        \n                \t\t\t")]) : _vm._e(), _vm._v(" "), (goodsBo.saleStatus === 'on_sale') ? _c('span', {
      staticClass: "brandsknow_time_txt"
    }, [_vm._v("                         \n                \t\t\t\t距结束 "), _c('i', {
      staticClass: "brandsknow_time_txt_time"
    }, [_vm._v(_vm._s(goodsBo.hour))]), _vm._v("时"), _c('i', {
      staticClass: "brandsknow_time_txt_time"
    }, [_vm._v(_vm._s(goodsBo.minute))]), _vm._v("分"), _c('i', {
      staticClass: "brandsknow_time_txt_time"
    }, [_vm._v(_vm._s(goodsBo.second))]), _vm._v("秒                        \n                \t\t\t")]) : _vm._e()])])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dp-pages tc"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.prePage()
      }
    }
  }, [_vm._v(" < ")]), _vm._v(" "), _vm._l((_vm.pageList), function(page) {
    return _c('a', {
      class: {
        "current_page": _vm.currentPage === page
      },
      on: {
        "click": function($event) {
          _vm.queryByPage(page)
        }
      }
    }, [_vm._v(_vm._s(page))])
  }), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.nextPage()
      }
    }
  }, [_vm._v(" > ")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('footermenu'), _vm._v(" "), _c('footercopyright')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "item"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("首页")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hd"
  }, [_c('h3', [_vm._v("精品推荐")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb20 ad-4 mt20"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("dlf8"),
      "width": "1200",
      "height": "60"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "INmO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__("ORbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TopBar__ = __webpack_require__("5PWk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_EmallHeader__ = __webpack_require__("3w6z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FooterMenu__ = __webpack_require__("gTlp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FooterCopyright__ = __webpack_require__("3LwO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_js_emallUtils_js__ = __webpack_require__("spYF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_js_alertConfirm_js__ = __webpack_require__("bCJ+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__static_api_api_js__ = __webpack_require__("fXcb");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*引入Vue框架*/

/*引入资源请求插件*/

/*使用VueResource插件*/
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);




//import jQuery from "../../../static/js/jquery.min.js"





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_9_mint_ui__["Swipe"].name, __WEBPACK_IMPORTED_MODULE_9_mint_ui__["Swipe"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_9_mint_ui__["SwipeItem"].name, __WEBPACK_IMPORTED_MODULE_9_mint_ui__["SwipeItem"]);
/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'shop_introduction',
	data: function data() {
		return {
			shopBo: {},
			sliderItems: [],
			bannerItem: {},
			adsItem: {},
			bottomAdsItem: {},
			sliderHeight: '370px',
			shopCatList: '',
			shopCode: '',
			catCode: 'categoryAll',
			interval: 'intervalAll',
			sortTime: 'timeAll',
			currentPage: 1,
			totalPage: 1,
			orderBy: '',
			orderAsc: '',
			isExistFavoriteShop: 0
		};
	},

	components: {
		'topbar': __WEBPACK_IMPORTED_MODULE_2__components_TopBar__["a" /* default */],
		'emallheader': __WEBPACK_IMPORTED_MODULE_3__components_EmallHeader__["a" /* default */],
		'footermenu': __WEBPACK_IMPORTED_MODULE_4__components_FooterMenu__["a" /* default */],
		'footercopyright': __WEBPACK_IMPORTED_MODULE_5__components_FooterCopyright__["a" /* default */]
	},
	methods: {
		goodsCateShow: function goodsCateShow() {
			$(".categorys-dropdown").show();
		},
		goodsCateHidden: function goodsCateHidden() {
			$(".categorys-dropdown").hide();
		},
		shopAskAndFavoriteShow: function shopAskAndFavoriteShow() {
			$(".zx-drop-box").show();
		},
		shopAskAndFavoriteHidden: function shopAskAndFavoriteHidden() {
			$(".zx-drop-box").hide();
		},
		getShopInfo: function getShopInfo() {
			var that = this;
			var shopCode = that.shopCode;
			this.$http.jsonp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__static_js_emallUtils_js__["q" /* getAjaxUrl */])() + "/shop/ajax_shop.json", {
				params: {
					shopCode: shopCode
				},
				jsonp: 'callback'
			}).then(function (res) {
				if (res.body.code == "success") {

					var adsList = res.body.data.adsList;
					var shopBo = res.body.data.shopBo;
					if (shopBo != undefined) {
						var qq = shopBo.qq;
						if (qq != undefined && qq != '') {
							shopBo.qq = 'http://wpa.qq.com/msgrd?v=3&site=qq&menu=yes&uin=' + qq;
						}
						var shopDesc = shopBo.shopDesc;
						if (shopDesc != undefined && shopDesc != '') {
							shopBo.shopDesc = shopDesc.replace(/\/upload\//g, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/");
						}
						that.shopBo = shopBo;
					}
					if (adsList != undefined) {
						var sliderItems = new Array();
						for (var i = 0; i < adsList.length; i++) {
							adsList[i].mediaCode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + adsList[i].mediaCode;
							if (adsList[i].adsType == "slider") {
								sliderItems.push(adsList[i]);
							} else if (adsList[i].adsType == "banner") {
								that.bannerItem = adsList[i];
							} else if (adsList[i].adsType == "inner_ads") {
								that.adsItem = adsList[i];
							} else if (adsList[i].adsType == "bottom_slogen") {
								that.bottomAdsItem = adsList[i];
							}
						}
						that.sliderItems = sliderItems;
					}
				}
			}, function () {});
		},

		getShopCat: function getShopCat() {
			var that = this;
			var shopCode = that.shopCode;
			var isShow = "y";
			var isLeaf = "y";
			this.$http.jsonp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__static_js_emallUtils_js__["q" /* getAjaxUrl */])() + "/shop/ajax_shop_cat.json", {
				params: {
					shopCode: shopCode,
					isShow: isShow,
					isLeaf: isLeaf
				},
				jsonp: 'callback'
			}).then(function (res) {
				if (res.body.code == "success") {
					var shopCatList = res.body.data.shopCatList;
					that.shopCatList = shopCatList;
				} else {}
			}, function () {});
		},
		addOrDeleteFavoriteShop: function addOrDeleteFavoriteShop() {
			var that = this;
			var shopCode = that.shopCode;
			if (0 == that.isExistFavoriteShop) {
				__WEBPACK_IMPORTED_MODULE_10__static_api_api_js__["a" /* default */].addUserFavorite("shop", null, shopCode, function (ret) {
					if (ret.code != null && ret.code == "success") {
						that.isExistFavoriteShop = 1;
					} else {
						__WEBPACK_IMPORTED_MODULE_8__static_js_alertConfirm_js__["a" /* default */].singleConfirm(ret.msg);
					}
				});
			} else if (1 == that.isExistFavoriteShop) {
				__WEBPACK_IMPORTED_MODULE_10__static_api_api_js__["a" /* default */].deleteFavoriteBycode("shop", null, shopCode, function (ret) {
					if (ret.code != null && ret.code == "success") {
						that.isExistFavoriteShop = 0;
					} else {
						__WEBPACK_IMPORTED_MODULE_8__static_js_alertConfirm_js__["a" /* default */].singleConfirm(ret.msg);
					}
				});
			}
		},
		existFavoriteShop: function existFavoriteShop() {
			var that = this;
			var shopCode = that.shopCode;
			__WEBPACK_IMPORTED_MODULE_10__static_api_api_js__["a" /* default */].isExistFavorite("shop", null, shopCode, function (ret) {
				if (ret.code != null && ret.code == "success") {
					that.isExistFavoriteShop = ret.data.isExist;
				} else {
					console.error("existFavorite请求失败：" + ret.msg);
				}
			});
		}
	},
	beforeMount: function beforeMount() {
		var shopCode = this.$route.query.shopCode;
		if (shopCode != undefined) {
			this.shopCode = shopCode;
		}
		this.existFavoriteShop();
	},
	mounted: function mounted() {
		window.scrollTo(0, 0);
		var shopCode = this.$route.query.shopCode;
		if (shopCode != undefined) {
			this.shopCode = shopCode;
		}
		this.getShopInfo();
		this.getShopCat();
	}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "JXLR":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "JXyc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "footer-menu"
  }, [_c('div', {
    staticClass: "w1200 bc clearfix",
    staticStyle: {
      "min-height": "100px"
    }
  }, [_c('ul', {
    staticClass: "cols-1"
  }, [_c('li', [_c('a', {
    staticStyle: {
      "font-weight": "900",
      "color": "#666"
    },
    attrs: {
      "href": "javasctipt:;"
    }
  }, [_vm._v(_vm._s(_vm.frendlinkList.name))])]), _vm._v(" "), _vm._l((_vm.frendlinkList.list), function(frendlink) {
    return _c('li', [_c('a', {
      attrs: {
        "href": frendlink.url
      }
    }, [_vm._v(_vm._s(frendlink.title))])])
  })], 2), _vm._v(" "), _c('ul', {
    staticClass: "cols-2"
  }, [_c('li', [_c('a', {
    staticStyle: {
      "font-weight": "900",
      "color": "#666"
    },
    attrs: {
      "href": "javasctipt:;"
    }
  }, [_vm._v(_vm._s(_vm.paymentList.name))])]), _vm._v(" "), _vm._l((_vm.paymentList.list), function(payment) {
    return _c('li', [_c('a', {
      attrs: {
        "href": payment.url
      }
    }, [_vm._v(_vm._s(payment.title))])])
  })], 2), _vm._v(" "), _c('ul', {
    staticClass: "cols-3"
  }, [_c('li', [_c('a', {
    staticStyle: {
      "font-weight": "900",
      "color": "#666"
    },
    attrs: {
      "href": "javasctipt:;"
    }
  }, [_vm._v(_vm._s(_vm.serviceList.name))])]), _vm._v(" "), _vm._l((_vm.serviceList.list), function(service) {
    return _c('li', [_c('a', {
      attrs: {
        "href": service.url
      }
    }, [_vm._v(_vm._s(service.title))])])
  })], 2)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JfXx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_address_list_vue__ = __webpack_require__("7KI2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d109c738_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_address_list_vue__ = __webpack_require__("HoL6");
function injectStyle (ssrContext) {
  __webpack_require__("CyML")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d109c738"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_address_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d109c738_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_address_list_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "K6AW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ktix":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "L+8x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'footerslogan',
	data: function data() {
		return {
			msg: 'Welcome to Your Vue.js App123'
		};
	}
});

/***/ }),

/***/ "LV99":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LoU4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Lw0y":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e207621_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("ppu4");
function injectStyle (ssrContext) {
  __webpack_require__("5if9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e207621_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "NowL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'shopnav',
	data: function data() {
		return {
			msg: 'Welcome to Your Vue.js App123'
		};
	},

	methods: {
		goodsCateShow: function goodsCateShow() {
			$(".categorys-dropdown").show();
		},
		goodsCateHidden: function goodsCateHidden() {
			$(".categorys-dropdown").hide();
		}
	}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "O+2g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P5WD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('topbar'), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('sortHeader', {
    ref: "sortHeader",
    model: {
      value: (_vm.sortParam),
      callback: function($$v) {
        _vm.sortParam = $$v
      },
      expression: "sortParam"
    }
  }), _vm._v(" "), _c('heardernav', {
    ref: "navComp",
    attrs: {
      "activeLi": _vm.activeLi,
      "isRefresh": _vm.isRefresh
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clear mt15"
  }), _vm._v(" "), _c('div', {
    staticClass: "w1200 bc"
  }, [_c('div', {
    staticClass: "hq-crumb-wrap"
  }, [_c('ul', [_vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "item sep"
  }, [_vm._v(">")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.sortParam) + _vm._s(_vm.catNameCn) + _vm._s(_vm.brandName))])])]), _vm._v(" "), _c('div', {
    staticClass: "sp-side-wrap"
  }, [_vm._m(1), _vm._v(" "), _c('ul', _vm._l((_vm.recommendGoodsList), function(recommendGood) {
    return _c('li', [_c('a', {
      staticClass: "fl pic",
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(recommendGood.goodsCode, recommendGood.productType)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": recommendGood.imgMiddle,
        "width": "106",
        "height": "106"
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "title"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(recommendGood.goodsCode, recommendGood.productType)
        }
      }
    }, [_vm._v(_vm._s(recommendGood.goodsName))])]), _vm._v(" "), (recommendGood.productType != 'sample' && recommendGood.goodsPrice > 0) ? _c('p', {
      staticClass: "price co2"
    }, [_vm._v(_vm._s(recommendGood.goodsPrice) + "积分")]) : _vm._e(), _vm._v(" "), (recommendGood.productType != 'sample' && recommendGood.goodsPrice == 0) ? _c('p', {
      staticClass: "price co2"
    }, [_vm._v(_vm._s(recommendGood.unitPrice == 0 ? "" : "￥" + (recommendGood.unitPrice / 100).toFixed(2)))]) : _vm._e()])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "sp-search-list"
  }, [_c('div', {
    staticClass: "l-hd"
  }, [_c('div', {
    staticClass: "top-num fr"
  }, [_vm._v("共" + _vm._s(_vm.totalItem) + "条 "), _c('span', {
    staticClass: "co2"
  }, [_vm._v(_vm._s(_vm.sortParam) + _vm._s(_vm.catNameCn))])]), _vm._v(" "), _c('h3', [_vm._v("搜索结果")])]), _vm._v(" "), _c('div', {
    staticClass: "hq-selector"
  }, [_c('div', {
    staticClass: "hd"
  }, [_c('dl', [_c('dt', [_vm._v("已选条件：")]), _vm._v(" "), _c('dd', {
    attrs: {
      "id": "choosedCond"
    }
  }, _vm._l((_vm.choosedCondItem), function(condItem, index) {
    return _c('span', {
      staticClass: "checked-item",
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "condType": condItem.condType
      }
    }, [_vm._v(_vm._s(condItem.condName)), _c('a', {
      staticClass: "del",
      on: {
        "click": function($event) {
          _vm.removeCondition(index, condItem.condType)
        }
      }
    })])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "bd"
  }, [(_vm.firstCatList != undefined && _vm.firstCatList.length > 0) ? _c('dl', [_c('dt', [_vm._v("主类")]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "td_h"
  }, _vm._l((_vm.firstCatList), function(firstCat, index) {
    return _c('a', {
      staticStyle: {
        "display": "inline-block"
      },
      on: {
        "click": function($event) {
          _vm.chooseCondition($event, 'firstCat', firstCat.catCode)
        }
      }
    }, [_vm._v(_vm._s(firstCat.catNameCn))])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.twoCategoryList != undefined && _vm.twoCategoryList.length > 0) ? _c('dl', [_c('dt', [_vm._v("分类")]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "td_h"
  }, _vm._l((_vm.twoCategoryList), function(twoCategory, index) {
    return _c('a', {
      staticStyle: {
        "display": "inline-block"
      },
      on: {
        "click": function($event) {
          _vm.chooseCondition($event, 'catNameCn', twoCategory.catCode)
        }
      }
    }, [_vm._v(_vm._s(twoCategory.catNameCn))])
  }))])]) : _vm._e(), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("品牌")]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "td_brand_h"
  }, _vm._l((_vm.brandList), function(brand, index) {
    return _c('a', {
      staticStyle: {
        "display": "inline-block"
      },
      on: {
        "click": function($event) {
          _vm.chooseCondition($event, 'brand', brand.id)
        }
      }
    }, [_vm._v(_vm._s(brand.brandNameCn))])
  }))])]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("价格：")]), _vm._v(" "), _c('dd', [_c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', 'intervalAll')
      }
    }
  }, [_vm._v("不限")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '0,100')
      }
    }
  }, [_vm._v("0-100")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '101,200')
      }
    }
  }, [_vm._v("101-200")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '201,300')
      }
    }
  }, [_vm._v("201-300")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '301,500')
      }
    }
  }, [_vm._v("301-500")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '501,1000')
      }
    }
  }, [_vm._v("501-1000")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '1001,5000')
      }
    }
  }, [_vm._v("1001-5000")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '5000,')
      }
    }
  }, [_vm._v("5000以上")])])]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("发布时间：")]), _vm._v(" "), _c('dd', [_c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'timeAll')
      }
    }
  }, [_vm._v("不限")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'oneDay')
      }
    }
  }, [_vm._v("一天内")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'twoDay')
      }
    }
  }, [_vm._v("两天内")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'oneWeek')
      }
    }
  }, [_vm._v("一周内")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'oneMonth')
      }
    }
  }, [_vm._v("一月内")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "pro-tool mt20"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('ul', [_c('li', {
    class: {
      "hover": _vm.sortCondition === "defaultSort"
    },
    on: {
      "click": function($event) {
        _vm.sortGoods('defaultSort')
      }
    }
  }, [_vm._v("默认")]), _vm._v(" "), _c('li', {
    class: {
      "hover": _vm.sortCondition === "saleAmount"
    },
    on: {
      "click": function($event) {
        _vm.sortGoods('saleAmount')
      }
    }
  }, [_vm._v("销量"), _c('i', {
    class: {
      "up": _vm.sortSaleAmount == "asc"
    }
  })]), _vm._v(" "), _c('li', {
    class: {
      "hover": _vm.sortCondition === "publishTime"
    },
    on: {
      "click": function($event) {
        _vm.sortGoods('publishTime')
      }
    }
  }, [_vm._v("发布时间"), _c('i', {
    class: {
      "up": _vm.sortPublishTime == "asc"
    }
  })]), _vm._v(" "), _c('li', {
    class: {
      "hover": _vm.sortCondition === "price"
    },
    on: {
      "click": function($event) {
        _vm.sortGoods('price')
      }
    }
  }, [_vm._v("价格"), _c('i', {
    class: {
      "up": _vm.sortPrice == "asc"
    }
  })]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "price-wrap"
  }, [_c('div', {
    staticClass: "input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lower),
      expression: "lower"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.lower)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lower = $event.target.value
      }
    }
  }), _vm._v(" - "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.upper),
      expression: "upper"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.upper)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.upper = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "price-tool"
  }, [_c('div', {
    staticClass: "price-tool-btn"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.clearUserDefined()
      }
    }
  }, [_vm._v("清空")])]), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.userDefinedCondition()
      }
    }
  }, [_vm._v("确定")])])])])])])])])]), _vm._v(" "), (_vm.firstCatCode != 'spike') ? _c('div', {
    staticClass: "pro-list"
  }, [_c('ul', _vm._l((_vm.goodsList), function(goodsBo) {
    return _c('li', [_c('p', {
      staticClass: "img"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(goodsBo.goodsCode, goodsBo.productType)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": goodsBo.imgMiddle,
        "width": "265",
        "height": "265"
      }
    })])]), _vm._v(" "), _c('p', {
      staticClass: "title"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(goodsBo.goodsCode, goodsBo.productType)
        }
      }
    }, [_vm._v(_vm._s(goodsBo.goodsName))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "20%",
        "float": "right",
        "text-align": "right"
      },
      attrs: {
        "id": "alert_btn"
      }
    }, [(goodsBo.seven_day_return == 'Y') ? _c('img', {
      staticStyle: {
        "width": "17px",
        "height": "17px"
      },
      attrs: {
        "src": __webpack_require__("Lw0y")
      }
    }) : _vm._e()]), _vm._v(" "), (goodsBo.goodsPrice > 0 && goodsBo.productType != 'sample') ? _c('p', {
      staticClass: "price"
    }, [_vm._v(" " + _vm._s(goodsBo.goodsPrice) + "积分")]) : _vm._e(), _vm._v(" "), (goodsBo.goodsPrice == 0 && goodsBo.productType != 'sample') ? _c('p', {
      staticClass: "price"
    }, [_vm._v(" " + _vm._s(goodsBo.unitPrice == 0 ? '' : '￥' + (goodsBo.unitPrice / 100).toFixed(2)))]) : _vm._e()])
  }))]) : _vm._e(), _vm._v(" "), (_vm.firstCatCode == 'spike') ? _c('div', {
    staticClass: "bd"
  }, [_c('ul', {
    staticClass: "miaosha-ul"
  }, _vm._l((_vm.goodsList), function(goodsBo) {
    return _c('li', [_c('p', {
      staticClass: "pic tc"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(goodsBo.goodsCode, goodsBo.productType)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": goodsBo.imgMiddle,
        "width": "265",
        "height": "265"
      }
    })])]), _vm._v(" "), _c('p', {
      staticClass: "title"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(goodsBo.goodsCode, goodsBo.productType)
        }
      }
    }, [_vm._v(_vm._s(goodsBo.goodsName))])]), _vm._v(" "), _c('div', {
      staticClass: "line-price"
    }, [_c('span', {
      staticClass: "co3"
    }, [_vm._v("￥" + _vm._s((goodsBo.unitPrice / 100).toFixed(2)))]), _c('span', {
      staticClass: "old"
    }, [_vm._v("￥" + _vm._s((goodsBo.marketPrice / 100).toFixed(2)))])]), _vm._v(" "), _c('div', {
      staticClass: "pinpainow_item_time"
    }, [(goodsBo.saleStatus === 'end') ? _c('span', {
      staticClass: "brandsknow_time_txt"
    }, [_vm._v("                         \n                \t\t\t\t已结束                       \n                \t\t\t")]) : _vm._e(), _vm._v(" "), (goodsBo.saleStatus === 'wait_start') ? _c('span', {
      staticClass: "brandsknow_time_txt"
    }, [_vm._v("                         \n                \t\t\t\t距开始 "), _c('i', {
      staticClass: "brandsknow_time_txt_time"
    }, [_vm._v(_vm._s(goodsBo.hour))]), _vm._v("时"), _c('i', {
      staticClass: "brandsknow_time_txt_time"
    }, [_vm._v(_vm._s(goodsBo.minute))]), _vm._v("分"), _c('i', {
      staticClass: "brandsknow_time_txt_time"
    }, [_vm._v(_vm._s(goodsBo.second))]), _vm._v("秒                        \n                \t\t\t")]) : _vm._e(), _vm._v(" "), (goodsBo.saleStatus === 'on_sale') ? _c('span', {
      staticClass: "brandsknow_time_txt"
    }, [_vm._v("                         \n                \t\t\t\t距结束 "), _c('i', {
      staticClass: "brandsknow_time_txt_time"
    }, [_vm._v(_vm._s(goodsBo.hour))]), _vm._v("时"), _c('i', {
      staticClass: "brandsknow_time_txt_time"
    }, [_vm._v(_vm._s(goodsBo.minute))]), _vm._v("分"), _c('i', {
      staticClass: "brandsknow_time_txt_time"
    }, [_vm._v(_vm._s(goodsBo.second))]), _vm._v("秒                        \n                \t\t\t")]) : _vm._e()])])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dp-pages tc"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.prePage()
      }
    }
  }, [_vm._v(" < ")]), _vm._v(" "), _vm._l((_vm.pageList), function(page) {
    return _c('a', {
      class: {
        "current_page": _vm.currentPage === page
      },
      on: {
        "click": function($event) {
          _vm.queryByPage(page)
        }
      }
    }, [_vm._v(_vm._s(page))])
  }), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.nextPage()
      }
    }
  }, [_vm._v(" > ")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('footermenu'), _vm._v(" "), _c('footercopyright')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "item"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("首页")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hd"
  }, [_c('h3', [_vm._v("精品推荐")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb20 ad-4 mt20"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("dlf8"),
      "width": "1200",
      "height": "60"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PDX5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shopCart_vue__ = __webpack_require__("+48i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43763a82_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_shopCart_vue__ = __webpack_require__("YWuJ");
function injectStyle (ssrContext) {
  __webpack_require__("Vmyv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shopCart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43763a82_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_shopCart_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Q1ZF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('topbar'), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('sortHeader', {
    model: {
      value: (_vm.sortParam),
      callback: function($$v) {
        _vm.sortParam = $$v
      },
      expression: "sortParam"
    }
  }), _vm._v(" "), _c('heardernav', {
    ref: "navComp",
    attrs: {
      "activeLi": _vm.activeLi,
      "isRefresh": _vm.isRefresh
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clear mt15"
  }), _vm._v(" "), _c('div', {
    staticClass: "w1200 bc"
  }, [_c('div', {
    staticClass: "hq-crumb-wrap"
  }, [_c('ul', [_vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "item sep"
  }, [_vm._v(">")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.sortParam) + _vm._s(_vm.catNameCn) + _vm._s(_vm.brandName))])])]), _vm._v(" "), _c('div', {
    staticClass: "sp-side-wrap"
  }, [_vm._m(1), _vm._v(" "), _c('ul', _vm._l((_vm.recommendGoodsList), function(recommendGood) {
    return _c('li', [_c('a', {
      staticClass: "fl pic",
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(recommendGood.goodsCode, recommendGood.productType)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": recommendGood.imgMiddle,
        "width": "106",
        "height": "106"
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "title"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(recommendGood.goodsCode, recommendGood.productType)
        }
      }
    }, [_vm._v(_vm._s(recommendGood.goodsName))])]), _vm._v(" "), (recommendGood.productType != 'sample' && recommendGood.goodsPrice > 0) ? _c('p', {
      staticClass: "price co2"
    }, [_vm._v(_vm._s(recommendGood.goodsPrice) + "积分")]) : _vm._e(), _vm._v(" "), (recommendGood.productType != 'sample' && recommendGood.goodsPrice == 0) ? _c('p', {
      staticClass: "price co2"
    }, [_vm._v(_vm._s(recommendGood.unitPrice == 0 ? "" : "￥" + (recommendGood.unitPrice / 100).toFixed(2)))]) : _vm._e()])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "sp-search-list"
  }, [_c('div', {
    staticClass: "l-hd"
  }, [_c('div', {
    staticClass: "top-num fr"
  }, [_vm._v("共" + _vm._s(_vm.totalItem) + "条 "), _c('span', {
    staticClass: "co2"
  }, [_vm._v(_vm._s(_vm.sortParam) + _vm._s(_vm.catNameCn))])]), _vm._v(" "), _c('h3', [_vm._v("搜索结果")])]), _vm._v(" "), _c('div', {
    staticClass: "hq-selector"
  }, [_c('div', {
    staticClass: "hd"
  }, [_c('dl', [_c('dt', [_vm._v("已选条件：")]), _vm._v(" "), _c('dd', {
    attrs: {
      "id": "choosedCond"
    }
  }, _vm._l((_vm.choosedCondItem), function(condItem, index) {
    return _c('span', {
      staticClass: "checked-item",
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "condType": condItem.condType
      }
    }, [_vm._v(_vm._s(condItem.condName)), _c('a', {
      staticClass: "del",
      on: {
        "click": function($event) {
          _vm.removeCondition(index, condItem.condType)
        }
      }
    })])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "bd"
  }, [(_vm.firstCatList != undefined && _vm.firstCatList.length > 0) ? _c('dl', [_c('dt', [_vm._v("主类")]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "td_h"
  }, _vm._l((_vm.firstCatList), function(firstCat, index) {
    return _c('a', {
      staticStyle: {
        "display": "inline-block"
      },
      on: {
        "click": function($event) {
          _vm.chooseCondition($event, 'firstCat', firstCat.catCode)
        }
      }
    }, [_vm._v(_vm._s(firstCat.catNameCn))])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.twoCategoryList != undefined && _vm.twoCategoryList.length > 0) ? _c('dl', [_c('dt', [_vm._v("分类")]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "td_h"
  }, _vm._l((_vm.twoCategoryList), function(twoCategory, index) {
    return _c('a', {
      staticStyle: {
        "display": "inline-block"
      },
      on: {
        "click": function($event) {
          _vm.chooseCondition($event, 'catNameCn', twoCategory.catCode)
        }
      }
    }, [_vm._v(_vm._s(twoCategory.catNameCn))])
  }))])]) : _vm._e(), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("价格：")]), _vm._v(" "), _c('dd', [_c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', 'intervalAll')
      }
    }
  }, [_vm._v("不限")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '0,100')
      }
    }
  }, [_vm._v("0-100")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '101,200')
      }
    }
  }, [_vm._v("101-200")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '201,300')
      }
    }
  }, [_vm._v("201-300")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '301,500')
      }
    }
  }, [_vm._v("301-500")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '501,1000')
      }
    }
  }, [_vm._v("501-1000")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '1001,5000')
      }
    }
  }, [_vm._v("1001-5000")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '5000,')
      }
    }
  }, [_vm._v("5000以上")])])]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("发布时间：")]), _vm._v(" "), _c('dd', [_c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'timeAll')
      }
    }
  }, [_vm._v("不限")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'oneDay')
      }
    }
  }, [_vm._v("一天内")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'twoDay')
      }
    }
  }, [_vm._v("两天内")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'oneWeek')
      }
    }
  }, [_vm._v("一周内")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'oneMonth')
      }
    }
  }, [_vm._v("一月内")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "pro-tool mt20"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('ul', [_c('li', {
    class: {
      "hover": _vm.sortCondition === "defaultSort"
    },
    on: {
      "click": function($event) {
        _vm.sortGoods('defaultSort')
      }
    }
  }, [_vm._v("默认")]), _vm._v(" "), _c('li', {
    class: {
      "hover": _vm.sortCondition === "saleAmount"
    },
    on: {
      "click": function($event) {
        _vm.sortGoods('saleAmount')
      }
    }
  }, [_vm._v("销量"), _c('i', {
    class: {
      "up": _vm.sortSaleAmount == "asc"
    }
  })]), _vm._v(" "), _c('li', {
    class: {
      "hover": _vm.sortCondition === "publishTime"
    },
    on: {
      "click": function($event) {
        _vm.sortGoods('publishTime')
      }
    }
  }, [_vm._v("发布时间"), _c('i', {
    class: {
      "up": _vm.sortPublishTime == "asc"
    }
  })]), _vm._v(" "), _c('li', {
    class: {
      "hover": _vm.sortCondition === "price"
    },
    on: {
      "click": function($event) {
        _vm.sortGoods('price')
      }
    }
  }, [_vm._v("价格"), _c('i', {
    class: {
      "up": _vm.sortPrice == "asc"
    }
  })]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "price-wrap"
  }, [_c('div', {
    staticClass: "input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lower),
      expression: "lower"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.lower)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lower = $event.target.value
      }
    }
  }), _vm._v(" - "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.upper),
      expression: "upper"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.upper)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.upper = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "price-tool"
  }, [_c('div', {
    staticClass: "price-tool-btn"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.clearUserDefined()
      }
    }
  }, [_vm._v("清空")])]), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.userDefinedCondition()
      }
    }
  }, [_vm._v("确定")])])])])])])])])]), _vm._v(" "), (_vm.firstCatCode != 'spike') ? _c('div', {
    staticClass: "pro-list"
  }, [_c('ul', _vm._l((_vm.goodsList), function(goodsBo) {
    return _c('li', [_c('p', {
      staticClass: "img"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(goodsBo.goodsCode, goodsBo.productType)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": goodsBo.imgMiddle,
        "width": "265",
        "height": "265"
      }
    })])]), _vm._v(" "), _c('p', {
      staticClass: "title"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(goodsBo.goodsCode, goodsBo.productType)
        }
      }
    }, [_vm._v(_vm._s(goodsBo.goodsName))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "20%",
        "float": "right",
        "text-align": "right"
      },
      attrs: {
        "id": "alert_btn"
      }
    }, [(goodsBo.seven_day_return == 'Y') ? _c('img', {
      staticStyle: {
        "width": "17px",
        "height": "17px"
      },
      attrs: {
        "src": __webpack_require__("Lw0y")
      }
    }) : _vm._e()]), _vm._v(" "), (goodsBo.goodsPrice > 0 && goodsBo.productType != 'sample') ? _c('p', {
      staticClass: "price"
    }, [_vm._v(" " + _vm._s(goodsBo.goodsPrice) + "积分")]) : _vm._e(), _vm._v(" "), (goodsBo.goodsPrice == 0 && goodsBo.productType != 'sample') ? _c('p', {
      staticClass: "price"
    }, [_vm._v(" " + _vm._s(goodsBo.unitPrice == 0 ? '' : '￥' + (goodsBo.unitPrice / 100).toFixed(2)))]) : _vm._e()])
  }))]) : _vm._e(), _vm._v(" "), (_vm.firstCatCode == 'spike') ? _c('div', {
    staticClass: "bd"
  }, [_c('ul', {
    staticClass: "miaosha-ul"
  }, _vm._l((_vm.goodsList), function(goodsBo) {
    return _c('li', [_c('p', {
      staticClass: "pic tc"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(goodsBo.goodsCode, goodsBo.productType)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": goodsBo.imgMiddle,
        "width": "265",
        "height": "265"
      }
    })])]), _vm._v(" "), _c('p', {
      staticClass: "title"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(goodsBo.goodsCode, goodsBo.productType)
        }
      }
    }, [_vm._v(_vm._s(goodsBo.goodsName))])]), _vm._v(" "), _c('div', {
      staticClass: "line-price"
    }, [_c('span', {
      staticClass: "co3"
    }, [_vm._v("￥" + _vm._s((goodsBo.unitPrice / 100).toFixed(2)))]), _c('span', {
      staticClass: "old"
    }, [_vm._v("￥" + _vm._s((goodsBo.marketPrice / 100).toFixed(2)))])]), _vm._v(" "), _c('div', {
      staticClass: "pinpainow_item_time"
    }, [(goodsBo.saleStatus === 'end') ? _c('span', {
      staticClass: "brandsknow_time_txt"
    }, [_vm._v("                         \n                \t\t\t\t已结束                       \n                \t\t\t")]) : _vm._e(), _vm._v(" "), (goodsBo.saleStatus === 'wait_start') ? _c('span', {
      staticClass: "brandsknow_time_txt"
    }, [_vm._v("                         \n                \t\t\t\t距开始 "), _c('i', {
      staticClass: "brandsknow_time_txt_time"
    }, [_vm._v(_vm._s(goodsBo.hour))]), _vm._v("时"), _c('i', {
      staticClass: "brandsknow_time_txt_time"
    }, [_vm._v(_vm._s(goodsBo.minute))]), _vm._v("分"), _c('i', {
      staticClass: "brandsknow_time_txt_time"
    }, [_vm._v(_vm._s(goodsBo.second))]), _vm._v("秒                        \n                \t\t\t")]) : _vm._e(), _vm._v(" "), (goodsBo.saleStatus === 'on_sale') ? _c('span', {
      staticClass: "brandsknow_time_txt"
    }, [_vm._v("                         \n                \t\t\t\t距结束 "), _c('i', {
      staticClass: "brandsknow_time_txt_time"
    }, [_vm._v(_vm._s(goodsBo.hour))]), _vm._v("时"), _c('i', {
      staticClass: "brandsknow_time_txt_time"
    }, [_vm._v(_vm._s(goodsBo.minute))]), _vm._v("分"), _c('i', {
      staticClass: "brandsknow_time_txt_time"
    }, [_vm._v(_vm._s(goodsBo.second))]), _vm._v("秒                        \n                \t\t\t")]) : _vm._e()])])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dp-pages tc"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.prePage()
      }
    }
  }, [_vm._v(" < ")]), _vm._v(" "), _vm._l((_vm.pageList), function(page) {
    return _c('a', {
      class: {
        "current_page": _vm.currentPage === page
      },
      on: {
        "click": function($event) {
          _vm.queryByPage(page)
        }
      }
    }, [_vm._v(_vm._s(page))])
  }), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.nextPage()
      }
    }
  }, [_vm._v(" > ")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('footermenu'), _vm._v(" "), _c('footercopyright')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "item"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("首页")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hd"
  }, [_c('h3', [_vm._v("精品推荐")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb20 ad-4 mt20"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("dlf8"),
      "width": "1200",
      "height": "60"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Q4AZ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAACu0lEQVR4Xu2aT4hOURjGn0fkT40dZTYjpUQWYmF2o6TYKJaDLKZkobCjWFDYjWIxkYWa7FAWlBQ2KDUWGinT+JMoykb5kz+PTt3FNI1v7rnfe+ee77zfu37Pue/z+55zz3vu+QjnQef60QXQdUAiBCRtI3l3rstJYglI2gegl+Q5dwAkLQQwCeCCVwAnAJwCcMwdAEnLALwBsMQrgMsAhop178sBktYCeA5gnlcA9wEMTHnr+3GApO0Abk/b8nwAkBQs/xLAaq8ADgAYmaHhyd8BkhYX295yrwDOhP3+P+1u3g6QtKJoeRd5BTAKYLDFYSdfB0jaAGBslpNe1gAeAeh3CUDSLgDXS5zz83OApPkAXgFY6RXAYQDDJcSHlLwcIKkHwHsAS70CCL98cEDZyMcBkvqKtb+grPqsloCk8NYPb/+YyMMBkjYDeByjPKsvQpKeAthUAcBrAO8ixl0ieS0if8ZU04sRSaHXDz1/3fEl9BYkv7b7IDMAUy44etstqsT4QyQvlsibNcUSQDjnh/N+3RE6yzUk/1o8yATAtAsOi7pazbGT5C2rh1gBCJcbeyKKCmeD0CvExgOSW2IHtco3ARBbkKRwFxjuBGNjHckXsYNyAXCV5H5L8WGuTnHADwCrSH70CuA0yZPW4jvFAZ+Kpue7VwBDJK/UIb4THDAOYD1JeQUwQPJhXeJTd8AdkjvqFJ8ygD9Fvz/hFcAIyYN1i0/VAd+Kbe+zVwDHSZ6dC/EpOuBD0fL+9Apg0OI7Xwy8lA5DYyQ3xhRvkZsSgH6STyxExcyRCoAbJHfHFG6VmwKAX+E/gyTfWomKmScFAMMkj8YUbZnbNACzC46qUJoGcITk+arFW4xrEsDeYu3/thBSdY4mATwjebNq4VbjmgKwleQ9KxHtzNMIgHYKth7bBWBNtNPmc++AfxVAIVBC6MsVAAAAAElFTkSuQmCC"

/***/ }),

/***/ "Qo9D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shop_index"
  }, [_c('topbar'), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), (_vm.bannerItem != '') ? _c('div', {
    staticClass: "hq-shop-banner"
  }, [_c('img', {
    staticStyle: {
      "width": "1400",
      "height": "120px",
      "cursor": "pointer"
    },
    attrs: {
      "src": _vm.bannerItem.mediaCode
    },
    on: {
      "click": function($event) {
        _vm.goUrl(_vm.bannerItem.link)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hq-shop-header"
  }, [_c('div', {
    staticClass: "w1200 bc bd"
  }, [_c('ul', {
    staticClass: "hq-shop-nav"
  }, [_vm._m(0), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goShopIntroduction()
      }
    }
  }, [_vm._v("企业介绍")])])]), _vm._v(" "), _c('div', {
    staticClass: "hq-shop-zx fr"
  }, [_c('a', {
    staticClass: "a-btn-zx",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "mouseenter": function($event) {
        _vm.shopAskAndFavoriteShow()
      }
    }
  }, [_vm._v("咨询／收藏"), _c('i', {
    staticClass: "dp-ico-a-1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "zx-drop-box none",
    on: {
      "mouseleave": function($event) {
        _vm.shopAskAndFavoriteHidden()
      }
    }
  }, [_c('div', {
    staticClass: "item-1"
  }, [_c('i', {
    staticClass: "dp-ico-arrw"
  }), _vm._v(" "), _c('p', [_vm._v("店铺好评率：" + _vm._s(_vm.goodRate) + "%")]), _vm._v(" "), (_vm.shopBo.creditPoint >= 4) ? _c('p', [_c('span', {
    staticClass: "vm"
  }, [_vm._v("信用等级： ")]), _vm._v(" "), (_vm.shopBo.creditPoint >= 4 && _vm.shopBo.creditPoint <= 10) ? _c('span', {
    staticClass: "vip_rank_1 vm"
  }) : _vm._e(), _vm._v(" "), (_vm.shopBo.creditPoint >= 11 && _vm.shopBo.creditPoint <= 40) ? _c('span', {
    staticClass: "vip_rank_2 vm"
  }) : _vm._e(), _vm._v(" "), (_vm.shopBo.creditPoint >= 41 && _vm.shopBo.creditPoint <= 90) ? _c('span', {
    staticClass: "vip_rank_3 vm"
  }) : _vm._e(), _vm._v(" "), (_vm.shopBo.creditPoint >= 91 && _vm.shopBo.creditPoint <= 150) ? _c('span', {
    staticClass: "vip_rank_4 vm"
  }) : _vm._e(), _vm._v(" "), (_vm.shopBo.creditPoint >= 151 && _vm.shopBo.creditPoint <= 250) ? _c('span', {
    staticClass: "vip_rank_5 vm"
  }) : _vm._e(), _vm._v(" "), (_vm.shopBo.creditPoint >= 251 && _vm.shopBo.creditPoint <= 500) ? _c('span', {
    staticClass: "vip_rank_6 vm"
  }) : _vm._e(), _vm._v(" "), (_vm.shopBo.creditPoint >= 501 && _vm.shopBo.creditPoint <= 1000) ? _c('span', {
    staticClass: "vip_rank_7 vm"
  }) : _vm._e(), _vm._v(" "), (_vm.shopBo.creditPoint >= 1001 && _vm.shopBo.creditPoint <= 2000) ? _c('span', {
    staticClass: "vip_rank_8 vm"
  }) : _vm._e(), _vm._v(" "), (_vm.shopBo.creditPoint >= 2001 && _vm.shopBo.creditPoint <= 5000) ? _c('span', {
    staticClass: "vip_rank_9 vm"
  }) : _vm._e(), _vm._v(" "), (_vm.shopBo.creditPoint >= 5001 && _vm.shopBo.creditPoint <= 10000) ? _c('span', {
    staticClass: "vip_rank_10 vm"
  }) : _vm._e(), _vm._v(" "), (_vm.shopBo.creditPoint >= 10001 && _vm.shopBo.creditPoint <= 20000) ? _c('span', {
    staticClass: "vip_rank_11 vm"
  }) : _vm._e(), _vm._v(" "), (_vm.shopBo.creditPoint >= 20001 && _vm.shopBo.creditPoint <= 50000) ? _c('span', {
    staticClass: "vip_rank_12 vm"
  }) : _vm._e(), _vm._v(" "), (_vm.shopBo.creditPoint >= 50001 && _vm.shopBo.creditPoint <= 100000) ? _c('span', {
    staticClass: "vip_rank_13 vm"
  }) : _vm._e(), _vm._v(" "), (_vm.shopBo.creditPoint >= 100001 && _vm.shopBo.creditPoint <= 200000) ? _c('span', {
    staticClass: "vip_rank_14 vm"
  }) : _vm._e(), _vm._v(" "), (_vm.shopBo.creditPoint >= 200001) ? _c('span', {
    staticClass: "vip_rank_15"
  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "item-2"
  }, [_c('a', {
    staticClass: "a-btn-zxzx",
    attrs: {
      "href": _vm.shopBo.qq
    }
  }, [_c('i', {
    staticClass: "dp-ico-zxzx"
  }), _vm._v("在线咨询")]), _vm._v(" "), _c('a', {
    staticClass: "a-btn-scbd ml10",
    on: {
      "click": function($event) {
        _vm.addOrDeleteFavoriteShop()
      }
    }
  }, [_c('i', {
    staticClass: "dp-ico-scbd"
  }), _vm._v(_vm._s(_vm.isExistFavoriteShop == 0 ? '收藏本店' : '已经收藏'))])])])])])]), _vm._v(" "), (_vm.sliderItems != '') ? _c('div', {
    staticClass: "shop-focus-img"
  }, [_c('mt-swipe', {
    staticStyle: {
      "height": "370px",
      "cursor": "pointer"
    },
    attrs: {
      "auto": 3000,
      "speed": 1000
    }
  }, _vm._l((_vm.sliderItems), function(i, index) {
    return _c('mt-swipe-item', {
      key: index,
      style: ({
        background: 'url(' + i.mediaCode + ')' + 'no-repeat center top'
      }),
      attrs: {
        "link": i.link,
        "onclick": "jumpUrl(this)"
      },
      on: {
        "click": function($event) {
          _vm.goUrl(i.link)
        }
      }
    }, [_c('a', {
      staticStyle: {
        "display": "none"
      }
    }, [_vm._v(_vm._s(i.link))])])
  }))], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "w1200 bc",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [(_vm.noGoods) ? _c('div', {
    staticClass: "qidai"
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.firstCatList), function(shopCatBo, index) {
    return (shopCatBo.goodsList.length != 0) ? _c('div', {
      staticClass: "shop-tabbox-1 shop-jp-tj"
    }, [_c('div', {
      staticClass: "hd"
    }, [_c('ul', [_c('li', {
      staticClass: "hover"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.getCatGoods('', shopCatBo.catCode)
        }
      }
    }, [_vm._v(_vm._s(shopCatBo.catNameCn))])]), _vm._v(" "), _c('ul', {
      staticClass: "tags"
    }, [_c('a', {
      staticClass: "more",
      on: {
        "click": function($event) {
          _vm.getMore(shopCatBo.catCode, shopCatBo.catNameCn)
        }
      }
    }, [_vm._v("更多 >")]), _vm._v(" "), _vm._l((shopCatBo.childCatList), function(childCatBo) {
      return _c('li', [_c('a', {
        attrs: {
          "href": "javascript:void(0);"
        },
        on: {
          "click": function($event) {
            _vm.getCatGoods(childCatBo.catCode, shopCatBo.catCode)
          }
        }
      }, [_vm._v(_vm._s(childCatBo.catNameCn))])])
    })], 2)])]), _vm._v(" "), (shopCatBo.catCode != 'spike') ? _c('div', {
      staticClass: "bd"
    }, [_c('ul', {
      attrs: {
        "id": shopCatBo.catCode
      }
    }, _vm._l((shopCatBo.goodsList), function(goodsBo, index) {
      return (index < 8) ? _c('li', [_c('p', {
        staticClass: "pic tc"
      }, [_c('a', {
        on: {
          "click": function($event) {
            _vm.goDetail(goodsBo.goodsCode)
          }
        }
      }, [_c('img', {
        attrs: {
          "src": _vm.profixPath + (goodsBo.imgMiddle != null ? (goodsBo.imgMiddle.split(';'))[0] : ''),
          "width": "265",
          "height": "265"
        }
      })])]), _vm._v(" "), _c('p', {
        staticClass: "title"
      }, [_c('a', {
        on: {
          "click": function($event) {
            _vm.goDetail(goodsBo.goodsCode)
          }
        }
      }, [_vm._v(_vm._s(goodsBo.goodsName))])]), _vm._v(" "), (goodsBo.goodsPrice == 0) ? _c('p', {
        staticClass: "other"
      }, [_c('span', {
        staticClass: "price"
      }, [_vm._v("¥" + _vm._s(goodsBo.unitPrice / 100))])]) : _c('p', {
        staticClass: "other"
      }, [_c('span', {
        staticClass: "price"
      }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(goodsBo.goodsPrice) + "\n\t\t\t\t\t\t\t\t\t"), (goodsBo.pointType == 'point') ? _c('span', [_vm._v("积分")]) : (goodsBo.pointType == 'special') ? _c('span', [_vm._v("专用积分")]) : (goodsBo.pointType == 'red') ? _c('span', [_vm._v("红积分")]) : (goodsBo.pointType == 'blue') ? _c('span', [_vm._v("蓝积分")]) : _vm._e()])])]) : _vm._e()
    }))]) : _vm._e(), _vm._v(" "), (shopCatBo.catCode == 'spike') ? _c('div', {
      staticClass: "bd"
    }, [_c('ul', {
      staticClass: "miaosha-ul",
      attrs: {
        "id": shopCatBo.catCode
      }
    }, _vm._l((shopCatBo.goodsList), function(goodsBo) {
      return _c('li', [_c('p', {
        staticClass: "pic tc"
      }, [_c('a', {
        on: {
          "click": function($event) {
            _vm.goDetail(goodsBo.goodsCode)
          }
        }
      }, [_c('img', {
        attrs: {
          "src": _vm.profixPath + goodsBo.imgMiddle,
          "width": "265",
          "height": "265"
        }
      })])]), _vm._v(" "), _c('p', {
        staticClass: "title"
      }, [_c('a', {
        on: {
          "click": function($event) {
            _vm.goDetail(goodsBo.goodsCode)
          }
        }
      }, [_vm._v(_vm._s(goodsBo.goodsName))])]), _vm._v(" "), _c('div', {
        staticClass: "line-price"
      }, [_c('span', {
        staticClass: "co3"
      }, [_vm._v("¥" + _vm._s(goodsBo.unitPrice / 100))]), _c('span', {
        staticClass: "old"
      }, [_vm._v("¥" + _vm._s(goodsBo.marketPrice / 100))])]), _vm._v(" "), _c('div', {
        staticClass: "pinpainow_item_time"
      }, [(goodsBo.saleStatus === 'end') ? _c('span', {
        staticClass: "brandsknow_time_txt"
      }, [_vm._v("                         \n                \t\t\t\t已结束                       \n                \t\t\t")]) : _vm._e(), _vm._v(" "), (goodsBo.saleStatus === 'wait_start') ? _c('span', {
        staticClass: "brandsknow_time_txt"
      }, [_vm._v("                         \n                \t\t\t\t距开始 "), _c('i', {
        staticClass: "brandsknow_time_txt_time"
      }, [_vm._v(_vm._s(goodsBo.hour))]), _vm._v("时"), _c('i', {
        staticClass: "brandsknow_time_txt_time"
      }, [_vm._v(_vm._s(goodsBo.minute))]), _vm._v("分"), _c('i', {
        staticClass: "brandsknow_time_txt_time"
      }, [_vm._v(_vm._s(goodsBo.second))]), _vm._v("秒                        \n                \t\t\t")]) : _vm._e(), _vm._v(" "), (goodsBo.saleStatus === 'on_sale') ? _c('span', {
        staticClass: "brandsknow_time_txt"
      }, [_vm._v("                         \n                \t\t\t\t距结束 "), _c('i', {
        staticClass: "brandsknow_time_txt_time"
      }, [_vm._v(_vm._s(goodsBo.hour))]), _vm._v("时"), _c('i', {
        staticClass: "brandsknow_time_txt_time"
      }, [_vm._v(_vm._s(goodsBo.minute))]), _vm._v("分"), _c('i', {
        staticClass: "brandsknow_time_txt_time"
      }, [_vm._v(_vm._s(goodsBo.second))]), _vm._v("秒                        \n                \t\t\t")]) : _vm._e()])])
    }))]) : _vm._e(), _vm._v(" "), (index == 0 && _vm.adsItem != '') ? _c('div', {
      staticClass: "mt20"
    }, [_c('a', {
      attrs: {
        "href": _vm.adsItem.link
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.adsItem.mediaCode,
        "width": "1200",
        "height": "390"
      }
    })])]) : _vm._e()]) : _vm._e()
  })], 2), _vm._v(" "), (_vm.bottomAdsItem != '') ? _c('div', {
    staticStyle: {
      "padding-bottom": "0.8rem",
      "width": "1200px",
      "margin": "auto"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.bottomAdsItem.link
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.bottomAdsItem.mediaCode,
      "width": "1200",
      "height": "60"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('footermenu'), _vm._v(" "), _c('footercopyright')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "hover"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("首页")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QrVH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__ = __webpack_require__("1pAy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc71e45a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__ = __webpack_require__("H6cY");
function injectStyle (ssrContext) {
  __webpack_require__("G5fF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cc71e45a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc71e45a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RSxB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "mb20 ad-4 mt20"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("dlf8"),
      "width": "1200",
      "height": "60"
    }
  })])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Rd1n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TopBar__ = __webpack_require__("5PWk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_api_api_js__ = __webpack_require__("fXcb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__ = __webpack_require__("spYF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_js_db_main_js__ = __webpack_require__("gkCg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_js_db_main_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__static_js_db_main_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Header__ = __webpack_require__("teIl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_FooterMenu__ = __webpack_require__("gTlp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_FooterCopyright__ = __webpack_require__("3LwO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_HearderNav__ = __webpack_require__("7JIe");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//import {jQuery} from "../../../static/js/jquery.min.js"









/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'goodsList',
	components: {
		'topbar': __WEBPACK_IMPORTED_MODULE_2__components_TopBar__["a" /* default */],
		'sortHeader': __WEBPACK_IMPORTED_MODULE_6__components_Header__["a" /* default */],
		'footermenu': __WEBPACK_IMPORTED_MODULE_7__components_FooterMenu__["a" /* default */],
		'footercopyright': __WEBPACK_IMPORTED_MODULE_8__components_FooterCopyright__["a" /* default */],
		'heardernav': __WEBPACK_IMPORTED_MODULE_9__components_HearderNav__["a" /* default */]
	},
	data: function data() {
		var _ref;

		return _ref = {
			isRefresh: true,
			goodsList: [],
			recommendGoodsList: [],
			sortCondition: 'defaultSort',
			sortSaleAmount: '',
			sortPublishTime: '',
			sortPrice: '',
			choosedCondItem: [],
			catCode: 'categoryAll',
			interval: 'intervalAll',
			sortTime: 'timeAll',
			currentPage: 1,
			totalPage: 1,
			orderBy: '',
			orderAsc: '',
			shopCode: '',
			pageList: [1],
			totalItem: 0,
			sortParam: '',
			shoppingCartNum: 0,
			boList: [],
			count: 0,
			goodsImgs: [],
			sumMoney: 0,
			goodsName: '',
			firstCatCode: ''
		}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'shopCode', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'mobile', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'isLogin', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'isShow', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'account', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'userCenterUrl', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'loginUrl', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'registerUrl', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'logoutUrl', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'aboutUsUrl', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'indexUrl', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'orderUrl', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'catNameCn', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'brandId', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'brandName', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'allCount', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'payCount', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'putCount', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'receiveCount', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'sendCount', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'closeCount', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'computeFlag', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'contactUrl', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'showItem', 7), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'isInit', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'lower', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'upper', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'product_type', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'activeLi', 'sample'), _ref;
	},

	methods: {
		orderShow: function orderShow() {
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".orders-list").show();
		},
		orderHide: function orderHide() {
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".orders-list").hide();
		},
		shopCarShow: function shopCarShow() {
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".goods-list").show();
		},
		shopCarHide: function shopCarHide() {
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".goods-list").hide();
		},
		getOrderCount: function getOrderCount(shopCode) {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_3__static_api_api_js__["a" /* default */].getOrderCount(function (ret) {
				if (ret.code == "success") {
					that.allCount = ret.data.allCount;
					that.payCount = ret.data.payCount;
					that.putCount = ret.data.putCount;
					that.receiveCount = ret.data.receiveCount;
					that.sendCount = ret.data.sendCount;
					that.closeCount = ret.data.closeCount;
				}
			});
		},
		logout: function logout() {
			localStorage.clear();
			__WEBPACK_IMPORTED_MODULE_3__static_api_api_js__["a" /* default */].loginOut(function (ret) {});
			window.location.href = this.logoutUrl;
		},
		clearCookie: function clearCookie() {
			var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
			if (keys) {
				for (var i = keys.length; i--;) {
					document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString();
				}
			}
		},
		goOrder: function goOrder(tradeStatus) {
			var account = localStorage.getItem("account");
			if (account != undefined && account != "") {
				window.location.href = this.orderUrl + "?tradeStatus=" + tradeStatus;
			} else {
				window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/login.htm';
			}
		},
		mobileAppShow: function mobileAppShow() {
			this.isShow = true;
		},
		mobileAppHidden: function mobileAppHidden() {
			this.isShow = false;
		},
		jumpTo: function jumpTo(name) {
			this.$router.push({ name: name });
		},
		toGoodsDetail: function toGoodsDetail(goodsCode, productType) {
			//this.$router.push({ name: 'goodsdetail', query:{goodsCode:goodsCode}});
			if (productType != undefined && productType == 'sample') {
				//样品
				var routeData = this.$router.resolve({ path: '/sampleDetail', query: { goodsCode: goodsCode } });
				window.open(routeData.href, '_blank');
			} else {
				var _routeData = this.$router.resolve({ path: '/goodsDetails', query: { goodsCode: goodsCode } });
				window.open(_routeData.href, '_blank');
			}
		},
		prePage: function prePage() {
			if (this.currentPage > 1) {
				this.currentPage = this.currentPage - 1;
				this.adjustPageArray(this.currentPage);
				this.getGoods();
			}
		},
		nextPage: function nextPage() {
			if (this.currentPage < this.totalPage) {
				this.currentPage = this.currentPage + 1;
				this.adjustPageArray(this.currentPage);
				this.getGoods();
			}
		},
		queryByPage: function queryByPage(page) {
			this.currentPage = page;
			this.adjustPageArray(this.currentPage);
			this.getGoods();
		},
		adjustPageArray: function adjustPageArray(page) {
			if (page == this.pageList[6] && page + 2 <= this.totalPage) {
				this.pageList.push(page + 1);
				this.pageList.push(page + 2);
				this.pageList.shift();
				this.pageList.shift();
			} else if (page == this.pageList[6] && page + 1 == this.totalPage) {
				this.pageList.push(page + 1);
				this.pageList.shift();
			} else if (page == this.pageList[0] && page >= 3) {
				this.pageList.unshift(page - 1);
				this.pageList.unshift(page - 2);
				this.pageList.pop();
				this.pageList.pop();
			} else if (page == this.pageList[0] && page == 2) {
				this.pageList.unshift(page - 1);
				this.pageList.pop();
			}
		},
		initPageArray: function initPageArray() {
			var pageList = new Array();
			var totalPage = this.totalPage;
			for (var i = 1; i <= totalPage; i++) {
				if (i <= this.showItem) {
					pageList.push(i);
				}
			}
			this.pageList = pageList;
		},
		clearUserDefined: function clearUserDefined() {
			this.lower = '';
			this.upper = '';
		},
		userDefinedCondition: function userDefinedCondition() {
			this.lower = this.lower.trim();
			this.upper = this.upper.trim();
			var sortParams = '';
			if (this.lower != '' && this.upper != '') {
				sortParams = this.lower + ',' + this.upper;
			} else if (this.lower == '' && this.upper != '') {
				sortParams = '0,' + this.upper;
			} else if (this.lower != '' && this.upper == '') {
				sortParams = this.lower + ',';
			}
			this.chooseCondition('', 'amount', sortParams);
		},
		chooseCondition: function chooseCondition(event, type, sortParams) {
			if (event != '') {
				var condText = event.target.innerText;
				if (condText != "不限") {
					var condText = event.target.innerText;
					if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#choosedCond").find("span[condType='" + type + "']").length != 0) {
						__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#choosedCond").find("span[condType='" + type + "']").remove();
					}
					this.choosedCondItem.push({ condName: condText, condType: type });
				} else {
					__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#choosedCond").find("span[condType='" + type + "']").remove();
				}

				if (type == 'amount') {
					this.clearUserDefined();
				}
			} else {
				if (type == 'amount') {
					if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#choosedCond").find("span[condType='" + type + "']").length != 0) {
						__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#choosedCond").find("span[condType='" + type + "']").remove();
					}
				}
			}

			if (type == 'amount') {
				this.interval = sortParams;
			} else if (type == 'cat') {
				this.catCode = sortParams;
			} else if (type == 'time') {
				this.sortTime = sortParams;
			}
			this.getRecommendGoods();
			this.getGoods();
		},
		removeCondition: function removeCondition(index, type) {
			if (type == 'amount') {
				this.interval = "intervalAll";
			} else if (type == 'cat') {
				this.catCode = "categoryAll";
			} else if (type == 'time') {
				this.sortTime = "timeAll";
			}
			this.choosedCondItem.splice(index, 1);
			this.getRecommendGoods();
			this.getGoods();
		},
		findGoods: function findGoods() {
			this.resetCond();
			this.getRecommendGoods();
			this.getGoods();
		},
		findShops: function findShops() {
			this.$router.push({ name: 'shopsList', query: { sortParam: this.sortParam } });
		},
		sortGoods: function sortGoods(sortCondition) {
			this.currentPage = 1;
			this.sortCondition = sortCondition;
			if (sortCondition == "saleAmount") {
				this.orderBy = "sale_number";
				if (this.sortSaleAmount == '') {
					this.sortSaleAmount = "desc";
				} else if (this.sortSaleAmount == 'desc') {
					this.sortSaleAmount = "asc";
				} else if (this.sortSaleAmount == 'asc') {
					this.sortSaleAmount = "desc";
				}
				this.orderAsc = this.sortSaleAmount;
			}
			if (sortCondition == "publishTime") {
				this.orderBy = "gmt_create";
				if (this.sortPublishTime == '') {
					this.sortPublishTime = "desc";
				} else if (this.sortPublishTime == 'desc') {
					this.sortPublishTime = "asc";
				} else if (this.sortPublishTime == 'asc') {
					this.sortPublishTime = "desc";
				}
				this.orderAsc = this.sortPublishTime;
			}
			if (sortCondition == "price") {
				this.orderBy = "unit_price";
				if (this.sortPrice == '') {
					this.sortPrice = "desc";
				} else if (this.sortPrice == 'desc') {
					this.sortPrice = "asc";
				} else if (this.sortPrice == 'asc') {
					this.sortPrice = "desc";
				}
				this.orderAsc = this.sortPrice;
			}
			if (sortCondition == "defaultSort") {
				this.orderBy = "";
				this.orderAsc = "";
			}
			this.getGoods();
			this.getRecommendGoods();
		},
		getRecommendGoods: function getRecommendGoods() {
			var that = this;
			var interval = that.interval;
			var catCode = that.catCode;
			var cabinetId = "";
			var pageSize = 5;
			var isQueryAll = "n";
			var currentPage = 1;
			var orderBy = "sale_number";
			var orderAsc = "desc";
			var shopCode = that.shopCode;
			var sortTime = "";
			var goodsName = encodeURI(that.sortParam);
			var firstCatCode = that.firstCatCode;
			var brandId = that.brandId;
			var product_type = that.product_type;
			var order_type = "";
			__WEBPACK_IMPORTED_MODULE_3__static_api_api_js__["a" /* default */].getGoodsList(cabinetId, catCode, interval, currentPage, orderBy, orderAsc, shopCode, sortTime, pageSize, isQueryAll, goodsName, firstCatCode, brandId, product_type, order_type, function (ret) {
				if (ret.code == "success") {
					var goods = ret.data.goods;
					if (goods != undefined) {
						for (var i = 0; i < goods.length; i++) {
							//商品图片
							var imgMiddle = goods[i].imgMiddle;
							if (imgMiddle.indexOf(";") != -1) {
								imgMiddle = imgMiddle.split(";")[0];
							}
							imgMiddle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + imgMiddle;
							goods[i].imgMiddle = imgMiddle;
						}
					}
					that.recommendGoodsList = goods;
				}
			});
		},
		getGoods: function getGoods() {
			var that = this;
			var interval = that.interval;
			var catCode = that.catCode;
			var isQueryAll = "n";
			var shopCode = that.shopCode;
			var cabinetId = "";
			var pageSize = 9;
			var currentPage = that.currentPage;
			var orderBy = that.orderBy;
			var orderAsc = that.orderAsc;
			var sortTime = that.sortTime;
			var goodsName = encodeURI(that.sortParam);
			var firstCatCode = that.firstCatCode;
			var brandId = that.brandId;
			var product_type = that.product_type;
			__WEBPACK_IMPORTED_MODULE_3__static_api_api_js__["a" /* default */].getGoodsList(cabinetId, catCode, interval, currentPage, orderBy, orderAsc, shopCode, sortTime, pageSize, isQueryAll, goodsName, firstCatCode, brandId, product_type, function (ret) {
				if (ret.code == "success") {
					var goods = ret.data.goods;
					that.totalItem = ret.data.totalItem;
					var totalPage = ret.data.totalPage;
					if (totalPage != undefined && totalPage != 0 && totalPage != that.totalPage) {
						that.totalPage = ret.data.totalPage;
						that.initPageArray();
					} else if (totalPage != undefined && totalPage == 0) {
						that.totalPage = 1;
						that.initPageArray();
					}
					if (goods != undefined) {
						for (var i = 0; i < goods.length; i++) {
							//商品图片
							var imgMiddle = goods[i].imgMiddle;
							if (imgMiddle.indexOf(";") != -1) {
								imgMiddle = imgMiddle.split(";")[0];
							}
							imgMiddle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + imgMiddle;
							goods[i].imgMiddle = imgMiddle;

							if (firstCatCode == 'spike') {

								var marketPrice = JSON.parse(goods[i].attrValue).marketPrice;
								var saleTimeStr = JSON.parse(goods[i].attrValue).saleTimeShow;
								var saleEndTimeStr = JSON.parse(goods[i].attrValue).saleEndTimeShow;
								if (marketPrice != undefined && marketPrice != "") {
									goods[i].marketPrice = marketPrice;
								} else {
									goods[i].marketPrice = goods[i].unitPrice;
								}
								if (saleEndTimeStr != undefined && saleEndTimeStr != '') {
									saleEndTimeStr = saleEndTimeStr.replace(/-/g, "/");
									var saleEndDate = new Date(saleEndTimeStr);

									saleTimeStr = saleTimeStr.replace(/-/g, "/");
									var saleDate = new Date(saleTimeStr);

									//如果当期日期大于销售结束日期 xxx
									if (new Date() > saleEndDate) {
										goods[i].saleStatus = "end";
									} else if (new Date() < saleDate) {
										//如果当期时间小于上架时间，展示距离开始 时间
										goods[i].saleStatus = "wait_start";
										var begSeconds = saleDate.getTime() - new Date().getTime(); //时间差的毫秒数        
										//计算出相差天数  
										//  								var days=Math.floor(begSeconds/(24*3600*1000));  
										//计算出小时数  
										var leave1 = begSeconds % (24 * 3600 * 1000); //计算天数后剩余的毫秒数  
										var hours = Math.floor(begSeconds / (3600 * 1000));
										//计算相差分钟数  
										var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数  
										var minutes = Math.floor(leave2 / (60 * 1000));
										//计算相差秒数  
										var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数  
										var seconds = Math.round(leave3 / 1000);
										// 									goods[i].day=days;
										goods[i].hour = hours;
										goods[i].minute = minutes;
										goods[i].second = seconds;
									} else {
										goods[i].saleStatus = "on_sale";

										var begSeconds = saleEndDate.getTime() - new Date().getTime(); //时间差的毫秒数        
										//计算出相差天数  
										//  								var days=Math.floor(begSeconds/(24*3600*1000));  
										//计算出小时数  
										var leave1 = begSeconds % (24 * 3600 * 1000); //计算天数后剩余的毫秒数  
										var hours = Math.floor(begSeconds / (3600 * 1000));
										//计算相差分钟数  
										var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数  
										var minutes = Math.floor(leave2 / (60 * 1000));
										//计算相差秒数  
										var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数  
										var seconds = Math.round(leave3 / 1000);
										// 									goods[i].day=days;
										goods[i].hour = hours;
										goods[i].minute = minutes;
										goods[i].second = seconds;
									}
								}
							}
						}
					}
					that.goodsList = goods;
					if (!that.isInit) {
						that.isInit = true;
						that.initPageArray();
					}
				}
			});
		},
		getShoppingCartNum: function getShoppingCartNum(shopCode) {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_3__static_api_api_js__["a" /* default */].getShoppingCartNum(function (ret) {
				if (ret.code == "success") {
					that.shoppingCartNum = ret.data.shoppingCartNum;
				}
			});
		},
		getShoppingCartList: function getShoppingCartList() {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_3__static_api_api_js__["a" /* default */].getShoppingCartList(function (ret) {
				if (ret.code == "success") {
					that.boList = ret.data.boList;
					var totalCount = 0;
					var bos = new Array();
					bos = ret.data.boList;
					var money = 0;
					for (var i = 0; i < bos.length; i++) {
						var imgSmall = bos[i].imgSmall;
						if (imgSmall.indexOf(";") != -1) {
							imgSmall = imgSmall.split(";")[0];
						}
						bos[i].imgSmall = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + imgSmall;
						money = money + bos[i].goodsPrice * bos[i].goodsNumber;
						totalCount = totalCount + bos[i].goodsNumber;
					}
					that.sumMoney = money;
					that.count = totalCount;
				}
			});
		},
		deleteGoods: function deleteGoods(goodsCode) {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_3__static_api_api_js__["a" /* default */].deleteGoods(goodsCode, function (ret) {
				if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["n" /* parseResult */])(ret, null, false)) {
					__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#" + goodsCode + "_cart_pro").remove();
				}
			});
		},
		goIndex: function goIndex() {
			this.$router.push({ name: 'index' });
		},
		getMoreCatGoods: function getMoreCatGoods(catCode, catNameCn) {
			this.catNameCn = catNameCn;
			this.resetCond();
			this.sortParam = "";
			this.firstCatCode = catCode;
			this.sortParam = "";
			this.getRecommendGoods();
			this.getGoods();
		},
		getCatGoods: function getCatGoods(catCode, catNameCn) {
			this.catNameCn = catNameCn;
			this.resetCond();
			this.sortParam = "";
			this.catCode = catCode;
			this.firstCatCode = "";
			this.sortParam = "";
			this.getRecommendGoods();
			this.getGoods();
		},
		resetCond: function resetCond() {
			this.interval = "intervalAll";
			this.catCode = "categoryAll";
			this.sortTime = "timeAll";
			this.firstCatCode = "";
			this.orderBy = "";
			this.orderAsc = "";
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#choosedCond").html("");
		},
		computeTime: function computeTime() {
			var that = this;
			var goodsList = that.goodsList;
			for (var j = 0; j < goodsList.length; j++) {
				var saleTimeStr = JSON.parse(goodsList[j].attrValue).saleTimeShow;
				var saleEndTimeStr = JSON.parse(goodsList[j].attrValue).saleEndTimeShow;

				if (saleEndTimeStr != undefined && saleEndTimeStr != '') {
					saleEndTimeStr = saleEndTimeStr.replace(/-/g, "/");
					var saleEndDate = new Date(saleEndTimeStr);

					saleTimeStr = saleTimeStr.replace(/-/g, "/");
					var saleDate = new Date(saleTimeStr);

					//如果当期日期大于销售结束日期 xxx
					if (new Date() > saleEndDate) {
						goodsList[j].saleStatus = "end";
					} else if (new Date() < saleDate) {
						//如果当期时间小于上架时间，展示距离开始 时间
						goodsList[j].saleStatus = "wait_start";
						var begSeconds = saleDate.getTime() - new Date().getTime(); //时间差的毫秒数        
						//计算出相差天数  
						//  								var days=Math.floor(begSeconds/(24*3600*1000));  
						//计算出小时数  
						var leave1 = begSeconds % (24 * 3600 * 1000); //计算天数后剩余的毫秒数  
						var hours = Math.floor(begSeconds / (3600 * 1000));
						//计算相差分钟数  
						var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数  
						var minutes = Math.floor(leave2 / (60 * 1000));
						//计算相差秒数  
						var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数  
						var seconds = Math.round(leave3 / 1000);
						goodsList[j].hour = hours;
						goodsList[j].minute = minutes;
						goodsList[j].second = seconds;
					} else {
						goodsList[j].saleStatus = "on_sale";

						var begSeconds = saleEndDate.getTime() - new Date().getTime(); //时间差的毫秒数        
						//计算出相差天数  
						//  								var days=Math.floor(begSeconds/(24*3600*1000));  
						//计算出小时数  
						var leave1 = begSeconds % (24 * 3600 * 1000); //计算天数后剩余的毫秒数  
						var hours = Math.floor(begSeconds / (3600 * 1000));
						//计算相差分钟数  
						var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数  
						var minutes = Math.floor(leave2 / (60 * 1000));
						//计算相差秒数  
						var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数  
						var seconds = Math.round(leave3 / 1000);
						goodsList[j].hour = hours;
						goodsList[j].minute = minutes;
						goodsList[j].second = seconds;
					}
				}
			}
			that.goodsList = goodsList;
			if (!that.isInit) {
				that.isInit = true;
				that.initPageArray();
			}
		}
	},
	ready: function ready() {},
	beforeDestroy: function beforeDestroy() {
		var that = this;
		if (that.firstCatCode == 'spike') {
			window.clearInterval(this.computeFlag);
		}
	},
	mounted: function mounted() {
		window.scrollTo(0, 0);
		this.$refs.navComp.getCat();
		var account = localStorage.getItem("account");
		if (account != undefined && account != "") {
			this.isLogin = true;
			this.account = account;
		}
		this.userCenterUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/index/default.htm';
		this.loginUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/login.htm';
		//			this.registerUrl = getUcUrl() + '/custm/user/user_reg_add.htm';
		this.registerUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/custm/user/user_reg_add.htm?formCode=MCHT_USER_FORM';
		this.logoutUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/logout.htm';
		this.aboutUsUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["l" /* getAboutUsUrl */])();
		this.indexUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["o" /* getIndexUrl */])();
		this.orderUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["b" /* getEmallUrl */])() + '/orderManage/myOrderList.htm';

		var sortParam = this.$route.query.sortParam;
		var firstCatCode = this.$route.query.firstCatCode;
		var shopCode = this.$route.query.shopCode;
		var catCode = this.$route.query.catCode;
		var catNameCn = this.$route.query.catNameCn;
		var brandId = this.$route.query.brandId;
		var brandName = this.$route.query.brandName;
		//产品类型
		if (this.$route.query.product_type != undefined && this.$route.query.product_type != "") {
			this.product_type = this.$route.query.product_type;
		}
		if (sortParam != undefined) {
			this.sortParam = sortParam;
		}
		if (firstCatCode != undefined) {
			this.firstCatCode = firstCatCode;
		}
		if (shopCode != undefined) {
			this.shopCode = shopCode;
		}
		var that = this;
		if (firstCatCode != undefined && firstCatCode == 'spike') {
			this.computeFlag = window.setInterval(function () {
				that.computeTime(); //计算倒计时
			}, 1000);
		}
		if (catCode != undefined) {
			this.catCode = catCode;
			this.getCatGoods(this.catCode);
		} else {
			this.getRecommendGoods();
			this.getGoods();
		}
		if (catNameCn != undefined) {
			this.catNameCn = decodeURI(catNameCn);;
		}
		if (brandId != undefined) {
			this.brandId = brandId;;
		}
		if (brandName != undefined) {
			this.brandName = brandName;;
		}
		//this.getRecommendGoods();
		//this.getGoods();
		this.getShoppingCartNum();
		this.getShoppingCartList();
		this.getOrderCount();
		this.contactUrl = __WEBPACK_IMPORTED_MODULE_4__static_js_emallUtils_js__["p" /* sysContactUrl */];
	}
});

/***/ }),

/***/ "SHpc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "topbar"
  }, [_c('div', {
    staticClass: "w1200 bc"
  }, [_c('ul', {
    staticClass: "topbar-right fr"
  }, [(_vm.isLogin == false) ? _c('li', [_c('a', {
    staticClass: "co2",
    attrs: {
      "href": _vm.loginUrl
    }
  }, [_vm._v("[登录]")])]) : _vm._e(), _vm._v(" "), (_vm.isLogin == false) ? _c('li', [_c('a', {
    staticClass: "co2",
    attrs: {
      "href": _vm.registerUrl
    }
  }, [_vm._v("[注册]")])]) : _vm._e(), _vm._v(" "), (_vm.isLogin == true) ? _c('li', [_c('span', [_vm._v("您好")])]) : _vm._e(), _vm._v(" "), (_vm.isLogin == true) ? _c('li', [_c('a', {
    staticClass: "co2",
    attrs: {
      "href": _vm.userCenterUrl
    }
  }, [_vm._v(_vm._s(_vm.account))])]) : _vm._e(), _vm._v(" "), (_vm.isLogin == true) ? _c('li', [_c('a', {
    staticClass: "co2",
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("[退出]")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.aboutUsUrl
    }
  }, [_vm._v("关于我们")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.contactUrl,
      "target": "_blank"
    }
  }, [_vm._v("联系客服")])])]), _vm._v(" "), _c('ul', {
    staticClass: "topbar-left fl"
  }, [_c('li', [_vm._v("\n\t\t\t\t\t\t您好！欢迎来到相伴宝！\n\t\t\t\t\t")]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "co1",
    attrs: {
      "href": _vm.indexUrl
    }
  }, [_vm._v("返回相伴宝")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header line"
  }, [_c('div', {
    staticClass: "w1200 bc"
  }, [_c('a', {
    staticClass: "logo fl",
    attrs: {
      "href": _vm.indexUrl,
      "title": "云永云商城"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('span', {
    staticClass: "ico"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sortParam),
      expression: "sortParam"
    }],
    staticClass: "text",
    attrs: {
      "type": "text",
      "placeholder": "请输入关键字"
    },
    domProps: {
      "value": (_vm.sortParam)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sortParam = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.findGoods()
      }
    }
  }, [_vm._v("搜商品")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "margin-left": "3px"
    },
    on: {
      "click": function($event) {
        _vm.findShops()
      }
    }
  }, [_vm._v("搜店铺")])]), _vm._v(" "), _c('div', {
    staticClass: "r-box fr",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "mycart",
    on: {
      "mouseenter": function($event) {
        _vm.shopCarShow()
      },
      "mouseleave": function($event) {
        _vm.shopCarHide()
      }
    }
  }, [_c('i', {
    staticClass: "ico-cart"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("我的购物车")]), _vm._v(" "), _c('span', {
    staticClass: "ico-shopping-amount"
  }, [_vm._v(_vm._s(_vm.shoppingCartNum))]), _vm._v(" "), _c('i', {
    staticClass: "ico-r"
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-list none",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), (_vm.shoppingCartNum == 0) ? _c('div', {
    staticClass: "no-goods"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("HdMn"),
      "width": "57",
      "height": "49"
    }
  }), _vm._v("购物车中还没有商品，赶紧选购吧！\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.shoppingCartNum > 0) ? _c('div', {
    staticClass: "mylist"
  }, [_c('h4', [_vm._v("最新加入的商品")]), _vm._v(" "), _c('ul', _vm._l((_vm.boList), function(bo) {
    return _c('li', {
      staticClass: "li-2",
      attrs: {
        "id": bo.goodsCode + '_cart_pro'
      }
    }, [_c('a', {
      staticClass: "fl spic",
      attrs: {
        "href": "#"
      }
    }, [_c('img', {
      attrs: {
        "src": bo.imgSmall,
        "width": "50",
        "height": "50"
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "name"
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(bo.goodsName))]), _vm._v("    "), _c('span', [_vm._v("数量：" + _vm._s(bo.goodsNumber))])]), _vm._v(" "), _c('p', {
      staticClass: "other"
    }, [_c('span', [_vm._v("￥" + _vm._s(bo.goodsPrice))]), _c('br'), _vm._v(" "), _c('a', {
      staticClass: "del",
      on: {
        "click": function($event) {
          _vm.deleteGoods(bo.goodsCode)
        }
      }
    }, [_vm._v("删除")])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "fbar"
  }, [_c('span', {
    staticClass: "fl ml10"
  }, [_vm._v("共" + _vm._s(_vm.count) + "件商品　共计"), _c('b', [_vm._v("￥ " + _vm._s(_vm.sumMoney))])]), _vm._v(" "), _c('a', {
    staticClass: "fr gobuy",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("去购物车")])])]) : _vm._e()])]), _vm._v(" "), (_vm.isLogin == true) ? _c('div', {
    staticClass: "myorder ml25",
    on: {
      "mouseenter": function($event) {
        _vm.orderShow()
      },
      "mouseleave": function($event) {
        _vm.orderHide()
      }
    }
  }, [_c('i', {
    staticClass: "ico-orders"
  }), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.goOrder('')
      }
    }
  }, [_vm._v("我的订单 "), _c('span', {
    staticClass: "ico-shopping-amount"
  }, [_vm._v(_vm._s(_vm.allCount))])]), _vm._v(" "), _c('i', {
    staticClass: "ico-r"
  }), _vm._v(" "), _c('div', {
    staticClass: "orders-list orders"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('wait_buyer_pay')
      }
    }
  }, [_vm._v("等待买家付款 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.payCount))])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('wait_send_goods')
      }
    }
  }, [_vm._v("等待卖家发货 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.sendCount))])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('wait_buyer_confirm_goods')
      }
    }
  }, [_vm._v("等待确认收货 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.putCount))])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('trade_finish')
      }
    }
  }, [_vm._v("订单完成 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.receiveCount))])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('trade_close')
      }
    }
  }, [_vm._v("订单关闭 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.closeCount))])])])])])]) : _vm._e()])])])]), _vm._v(" "), _c('heardernav', {
    ref: "navComp",
    attrs: {
      "isRefresh": _vm.isRefresh
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clear mt15"
  }), _vm._v(" "), _c('div', {
    staticClass: "w1200 bc"
  }, [_c('div', {
    staticClass: "hq-crumb-wrap"
  }, [_c('ul', [_vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "item sep"
  }, [_vm._v(">")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.sortParam) + _vm._s(_vm.catNameCn) + _vm._s(_vm.brandName))])])]), _vm._v(" "), _c('div', {
    staticClass: "sp-search-list"
  }, [_c('div', {
    staticClass: "l-hd"
  }, [_c('div', {
    staticClass: "top-num fr"
  }, [_vm._v("共" + _vm._s(_vm.totalItem) + "条 "), _c('span', {
    staticClass: "co2"
  }, [_vm._v(_vm._s(_vm.sortParam) + _vm._s(_vm.catNameCn))])]), _vm._v(" "), _c('h3', [_vm._v("搜索结果")])]), _vm._v(" "), _c('div', {
    staticClass: "hq-selector"
  }, [_c('div', {
    staticClass: "hd"
  }, [_c('dl', [_c('dt', [_vm._v("已选条件：")]), _vm._v(" "), _c('dd', {
    attrs: {
      "id": "choosedCond"
    }
  }, _vm._l((_vm.choosedCondItem), function(condItem, index) {
    return _c('span', {
      staticClass: "checked-item",
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "condType": condItem.condType
      }
    }, [_vm._v(_vm._s(condItem.condName)), _c('a', {
      staticClass: "del",
      on: {
        "click": function($event) {
          _vm.removeCondition(index, condItem.condType)
        }
      }
    })])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "bd"
  }, [_c('dl', [_c('dt', [_vm._v("价格：")]), _vm._v(" "), _c('dd', [_c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', 'intervalAll')
      }
    }
  }, [_vm._v("不限")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '0,100')
      }
    }
  }, [_vm._v("0-100")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '101,200')
      }
    }
  }, [_vm._v("101-200")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '201,300')
      }
    }
  }, [_vm._v("201-300")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '301,500')
      }
    }
  }, [_vm._v("301-500")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '501,1000')
      }
    }
  }, [_vm._v("501-1000")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '1001,5000')
      }
    }
  }, [_vm._v("1001-5000")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '5000,')
      }
    }
  }, [_vm._v("5000以上")])])]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("发布时间：")]), _vm._v(" "), _c('dd', [_c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'timeAll')
      }
    }
  }, [_vm._v("不限")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'oneDay')
      }
    }
  }, [_vm._v("一天内")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'twoDay')
      }
    }
  }, [_vm._v("两天内")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'oneWeek')
      }
    }
  }, [_vm._v("一周内")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'oneMonth')
      }
    }
  }, [_vm._v("一月内")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "pro-tool mt20"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('ul', [_c('li', {
    class: {
      "hover": _vm.sortCondition === "defaultSort"
    },
    on: {
      "click": function($event) {
        _vm.sortGoods('defaultSort')
      }
    }
  }, [_vm._v("默认")]), _vm._v(" "), _c('li', {
    class: {
      "hover": _vm.sortCondition === "saleAmount"
    },
    on: {
      "click": function($event) {
        _vm.sortGoods('saleAmount')
      }
    }
  }, [_vm._v("销量"), _c('i', {
    class: {
      "up": _vm.sortSaleAmount == "asc"
    }
  })]), _vm._v(" "), _c('li', {
    class: {
      "hover": _vm.sortCondition === "publishTime"
    },
    on: {
      "click": function($event) {
        _vm.sortGoods('publishTime')
      }
    }
  }, [_vm._v("发布时间"), _c('i', {
    class: {
      "up": _vm.sortPublishTime == "asc"
    }
  })]), _vm._v(" "), _c('li', {
    class: {
      "hover": _vm.sortCondition === "price"
    },
    on: {
      "click": function($event) {
        _vm.sortGoods('price')
      }
    }
  }, [_vm._v("价格"), _c('i', {
    class: {
      "up": _vm.sortPrice == "asc"
    }
  })]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "price-wrap"
  }, [_c('div', {
    staticClass: "input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lower),
      expression: "lower"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.lower)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lower = $event.target.value
      }
    }
  }), _vm._v(" - "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.upper),
      expression: "upper"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.upper)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.upper = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "price-tool"
  }, [_c('div', {
    staticClass: "price-tool-btn"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.clearUserDefined()
      }
    }
  }, [_vm._v("清空")])]), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.userDefinedCondition()
      }
    }
  }, [_vm._v("确定")])])])])])])])])]), _vm._v(" "), (_vm.firstCatCode != 'spike') ? _c('div', {
    staticClass: "pro-list"
  }, [_c('ul', _vm._l((_vm.goodsList), function(goodsBo) {
    return _c('li', [_c('p', {
      staticClass: "img"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(goodsBo.goodsCode)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": goodsBo.imgMiddle,
        "width": "265",
        "height": "265"
      }
    })])]), _vm._v(" "), _c('p', {
      staticClass: "title"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(goodsBo.goodsCode)
        }
      }
    }, [_vm._v(_vm._s(goodsBo.goodsName))])]), _vm._v(" "), _c('p', {
      staticClass: "price"
    }, [_vm._v(" ￥" + _vm._s((goodsBo.unitPrice / 100).toFixed(2)))]), _vm._v(" "), _c('p', {
      staticClass: "shop"
    }, [_c('i', {
      staticClass: "ico-shop-l"
    }), _c('a', {
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(goodsBo.goodsCode)
        }
      }
    }, [_vm._v(_vm._s(goodsBo.shopName))])])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.firstCatCode == 'spike') ? _c('div', {
    staticClass: "bd"
  }, [_c('ul', {
    staticClass: "miaosha-ul"
  }, _vm._l((_vm.goodsList), function(goodsBo) {
    return _c('li', [_c('p', {
      staticClass: "pic tc"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(goodsBo.goodsCode)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": goodsBo.imgMiddle,
        "width": "265",
        "height": "265"
      }
    })])]), _vm._v(" "), _c('p', {
      staticClass: "title"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(goodsBo.goodsCode)
        }
      }
    }, [_vm._v(_vm._s(goodsBo.goodsName))])]), _vm._v(" "), _c('div', {
      staticClass: "line-price"
    }, [_c('span', {
      staticClass: "co3"
    }, [_vm._v("￥" + _vm._s((goodsBo.unitPrice / 100).toFixed(2)))]), _c('span', {
      staticClass: "old"
    }, [_vm._v("￥" + _vm._s((goodsBo.marketPrice / 100).toFixed(2)))])]), _vm._v(" "), _c('div', {
      staticClass: "pinpainow_item_time"
    }, [(goodsBo.saleStatus === 'end') ? _c('span', {
      staticClass: "brandsknow_time_txt"
    }, [_vm._v("                         \n                \t\t\t\t已结束                       \n                \t\t\t")]) : _vm._e(), _vm._v(" "), (goodsBo.saleStatus === 'wait_start') ? _c('span', {
      staticClass: "brandsknow_time_txt"
    }, [_vm._v("                         \n                \t\t\t\t距开始 "), _c('i', {
      staticClass: "brandsknow_time_txt_time"
    }, [_vm._v(_vm._s(goodsBo.hour))]), _vm._v("时"), _c('i', {
      staticClass: "brandsknow_time_txt_time"
    }, [_vm._v(_vm._s(goodsBo.minute))]), _vm._v("分"), _c('i', {
      staticClass: "brandsknow_time_txt_time"
    }, [_vm._v(_vm._s(goodsBo.second))]), _vm._v("秒                        \n                \t\t\t")]) : _vm._e(), _vm._v(" "), (goodsBo.saleStatus === 'on_sale') ? _c('span', {
      staticClass: "brandsknow_time_txt"
    }, [_vm._v("                         \n                \t\t\t\t距结束 "), _c('i', {
      staticClass: "brandsknow_time_txt_time"
    }, [_vm._v(_vm._s(goodsBo.hour))]), _vm._v("时"), _c('i', {
      staticClass: "brandsknow_time_txt_time"
    }, [_vm._v(_vm._s(goodsBo.minute))]), _vm._v("分"), _c('i', {
      staticClass: "brandsknow_time_txt_time"
    }, [_vm._v(_vm._s(goodsBo.second))]), _vm._v("秒                        \n                \t\t\t")]) : _vm._e()])])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dp-pages tc"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.prePage()
      }
    }
  }, [_vm._v(" < ")]), _vm._v(" "), _vm._l((_vm.pageList), function(page) {
    return _c('a', {
      class: {
        "current_page": _vm.currentPage === page
      },
      on: {
        "click": function($event) {
          _vm.queryByPage(page)
        }
      }
    }, [_vm._v(_vm._s(page))])
  }), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.nextPage()
      }
    }
  }, [_vm._v(" > ")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('footermenu'), _vm._v(" "), _c('footercopyright')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "item"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("首页")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb20 ad-4 mt20"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("dlf8"),
      "width": "1200",
      "height": "60"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SP3i":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {
//鼠标经过预览图片函数
function preview(img) {
	jQuery("#preview .jqzoom img").attr("src", jQuery(img).attr("src"));
	jQuery("#preview .jqzoom img").attr("jqimg", jQuery(img).attr("bimg"));
}
//图片放大镜效果
jQuery(function () {
	jQuery(".jqzoom").jqueryzoom({ xzoom: 400, yzoom: 400 });
});

//图片预览小图移动效果,页面加载时触发
jQuery(function () {
	var tempLength = 0; //临时变量,当前移动的长度
	var viewNum = 5; //设置每次显示图片的个数量
	var moveNum = 2; //每次移动的数量
	var moveTime = 300; //移动速度,毫秒

	//下一张
	jQuery(".spec-scroll .next").bind("click", function () {
		var scrollDiv = jQuery(".spec-scroll .items ul"); //进行移动动画的容器
		var scrollItems = jQuery(".spec-scroll .items ul li"); //移动容器里的集合
		var moveLength = scrollItems.eq(0).width() * moveNum; //计算每次移动的长度
		var countLength = (scrollItems.length - viewNum) * scrollItems.eq(0).width(); //计算总长度,总个数*单个长度		
		if (tempLength < countLength) {
			if (countLength - tempLength > moveLength) {
				scrollDiv.animate({ left: "-=" + moveLength + "px" }, moveTime);
				tempLength += moveLength;
			} else {
				scrollDiv.animate({ left: "-=" + (countLength - tempLength) + "px" }, moveTime);
				tempLength += countLength - tempLength;
			}
		}
	});
	//上一张
	jQuery(".spec-scroll .prev").bind("click", function () {
		var scrollDiv = jQuery(".spec-scroll .items ul"); //进行移动动画的容器
		var scrollItems = jQuery(".spec-scroll .items ul li"); //移动容器里的集合
		var moveLength = scrollItems.eq(0).width() * moveNum; //计算每次移动的长度
		var countLength = (scrollItems.length - viewNum) * scrollItems.eq(0).width(); //计算总长度,总个数*单个长度				
		if (tempLength > 0) {
			if (tempLength > moveLength) {
				scrollDiv.animate({ left: "+=" + moveLength + "px" }, moveTime);
				tempLength -= moveLength;
			} else {
				scrollDiv.animate({ left: "+=" + tempLength + "px" }, moveTime);
				tempLength = 0;
			}
		}
	});
});
jQuery(function () {
	//tab
	jQuery(".sp-dt-tab .hd ul li").click(function () {
		var index = jQuery(this).index();
		jQuery(this).addClass("hover").siblings().removeClass();
		jQuery(".sp-dt-tab .bd").eq(index).show().siblings(".sp-dt-tab .bd").hide();
	});
	//省市选择
	jQuery(".sw-ui-area-box").hide();
	jQuery('.sw-ui-area-box-item a').click(function () {
		if (jQuery(this).attr("c").length > 1) {
			var citys = jQuery(this).attr("p") + " " + jQuery(this).attr("c");
			//alert(citys);
			jQuery("#citys").text(citys);
			jQuery(".sw-ui-area-box").hide();
		}
	});
	//全部商品
	//	 jQuery(".mall-categorys .hd").click(function(){
	//		 jQuery(".sc-submenu").show();
	//		 });
	//	 jQuery(".sc-submenu").mouseleave(function(){
	//		 jQuery(this).hide();
	//		 });
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "TDFL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TopBar__ = __webpack_require__("5PWk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Header__ = __webpack_require__("teIl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FooterMenu__ = __webpack_require__("gTlp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ShopNav__ = __webpack_require__("hV6H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_FooterCopyright__ = __webpack_require__("3LwO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_api_api_js__ = __webpack_require__("fXcb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_js_emallUtils_js__ = __webpack_require__("spYF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__static_js_alertConfirm_js__ = __webpack_require__("bCJ+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__static_js_map_js__ = __webpack_require__("oICd");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












__WEBPACK_IMPORTED_MODULE_10_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'ordercommit',
	data: function data() {
		var _ref;

		return _ref = {
			couponCode: '', //优惠券编码
			couponSubCode: '', //用户优惠券编码
			discountType: '', //抵扣类型：优惠券、会员折扣、积分
			discountAmount: 0,
			brokerDiscountAmount: 0, //代理商折扣金额
			couponDiscountAmount: 0, //优惠券折扣金额
			boList: [],
			shopBoList: [],
			addressBoList: [],
			address: '',
			addressId: 0,
			canCreateAddress: true,
			sumCount: 0,
			sumAmount: 0,
			sumOrderAmount: 0,
			totalExpressAmount: 0,
			isOnline: true,
			goodsBo: '',
			orderSource: '',
			distributeAccount: '',
			distributeName: '',
			brokerDiscountPersent: 0
		}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'brokerDiscountAmount', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'goodsCode', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'shopCode', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'shopName', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'payNum', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'specName', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'usableCouponList', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'goodsTotalPrice', {
			allAmount: 0,
			totalPoint: 0,
			totalRed: 0,
			totalBlue: 0,
			totalSpecial: 0,
			totalMoney: 0,
			totalExpressAmount: 0,
			brokerDiscountPersent: 0
		}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'map', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'pointStr', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'deliveryTypeFag', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'indexFag', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'seckillPrice', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'pointNum', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'pointDiscount', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'points', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'receiptType', 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'isReceipt', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'enterpriseList', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'specialList', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'taxpayerNum', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'receiptTitle', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'receiptId', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'receiptSmall1', '不开发票'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'receiptSmall2', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'receiptSmall3', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'isReceipt1', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'receiptId1', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'receiptflag', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'isReceiptTrue', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'serviceAmount', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'printServicePara', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'rebrandingServicePara', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'printingServicePara', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'laserServicePara', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'fileNamePara', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'filePathPara', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'imageNamePara', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'imagePathPara', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'orderType', 'spot'), _ref;
	},

	components: {
		'topbar': __WEBPACK_IMPORTED_MODULE_2__components_TopBar__["a" /* default */],
		'emallheader': __WEBPACK_IMPORTED_MODULE_3__components_Header__["a" /* default */],
		'footermenu': __WEBPACK_IMPORTED_MODULE_4__components_FooterMenu__["a" /* default */],
		'footercopyright': __WEBPACK_IMPORTED_MODULE_6__components_FooterCopyright__["a" /* default */]
	},
	methods: {
		//选择规则
		chooseDeliveryType: function chooseDeliveryType(typeItem, goodsBo) {
			var that = this;
			goodsBo.deliveryType = typeItem;
			if (typeItem == "self_take" && that.addressId == 0) {
				__WEBPACK_IMPORTED_MODULE_9__static_js_alertConfirm_js__["a" /* default */].singleConfirm("请先设置收货地址");
				return false;
			} else {
				this.showMap();
			}
			//计算运费
			that.computeExpressFee();
		},
		addAddress: function addAddress() {
			this.$router.push({
				name: 'address',
				query: {
					backUrl: 'orderCommit?specName=' + this.specName,
					orderSource: this.orderSource,
					boList: this.boList,
					goodsCode: this.goodsCode,
					shopCode: this.shopCode,
					payNum: this.payNum,
					distributeAccount: this.distributeAccount,
					distributeName: this.distributeName
				}
			});
		},
		editAddress: function editAddress(addressId) {
			this.$router.push({
				name: 'address',
				query: {
					backUrl: 'orderCommit',
					orderSource: this.orderSource,
					boList: this.boList,
					goodsCode: this.goodsCode,
					shopCode: this.shopCode,
					payNum: this.payNum,
					distributeAccount: this.distributeAccount,
					distributeName: this.distributeName,
					addressId: addressId,
					goodsCodes: ""
				}
			});
		},
		chooseAddress: function chooseAddress(addressId, index) {
			$("dl[id^='dl_']").css("color", "#666");
			//$("dl[id='dl_" +addressId+ "']").css("color","#fa660f");
			//alert(addressId);
			this.addressId = addressId;
			this.indexFag = index;
			var that = this;
			this.selectAddressPoint();
			//计算运费
			that.computeExpressFee();
		},

		getSumCount: function getSumCount() {
			var that = this;
			var count = 0;
			jQuery("[name='number']").each(function () {
				var num = jQuery(this).text();
				count = count + parseInt(num);
			});
			that.sumCount = count;
		},
		getSumAmount: function getSumAmount() {
			var that = this;
			var amount = 0;
			jQuery("[name='unitPrice']").each(function () {
				var price = jQuery(this).text().replace("￥", "");
				amount = amount + parseFloat(price);
			});
			that.sumOrderAmount = amount;
			if (that.brokerDiscountPersent != 0 && (that.seckillPrice == undefined || that.seckillPrice == '')) {
				that.brokerDiscountAmount = that.sumOrderAmount * (100 - that.brokerDiscountPersent);
				that.sumAmount = amount * that.brokerDiscountPersent / 100 + that.totalExpressAmount / 100;
			} else {
				that.sumAmount = amount + that.totalExpressAmount / 100;
			}
		},
		toDetail: function toDetail(goodsCode) {
			this.$router.push({ name: 'goodsdetail', query: { goodsCode: goodsCode } });
		},
		getUserAddresses: function getUserAddresses() {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_7__static_api_api_js__["a" /* default */].queryUserAddress(function (ret) {
				if (ret.data != undefined) {
					that.addressBoList = ret.data;
					if (that.addressBoList != null && that.addressBoList.length > 0) {
						that.addressBoList[0].isDefault = 'y';
						that.address = that.addressBoList[0];
						that.addressId = that.addressBoList[0].id;
					}
					if (that.addressBoList != null && that.addressBoList.length > 4) {
						that.canCreateAddress = false;
					}
					that.getCart(that.addressId);
				}
				//计算运费
				that.computeExpressFee();
			});
		},
		getCart: function getCart() {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_7__static_api_api_js__["a" /* default */].getCartListByCode(that.goodsCodes, "", that.addressId, function (ret) {
				if (ret.data != null) {
					that.points = ret.data.points;
					that.pointNum = that.points.point.usableNum;
					that.pointDiscount = that.points.point.discountMoney;
				}
			});
		},
		//选择抵扣信息
		chkDiscount: function chkDiscount() {
			var that = this;
			setTimeout(function () {
				if (that.points.point.is_choosed) {
					that.discountAmount = that.points.point.discountMoney;
					that.discountType = "point";
				} else {
					if (that.brokerDiscountAmount > 0) {
						that.discountType = "broker_level";
						that.discountAmount = that.brokerDiscountAmount / 100;
					} else {
						that.discountType = "";
						that.discountAmount = 0;
					}
				}
			}, 0);
		},
		submitOrderExt: function submitOrderExt() {
			var that = this;
			if (that.addressId == 0) {
				__WEBPACK_IMPORTED_MODULE_9__static_js_alertConfirm_js__["a" /* default */].singleConfirm("请先设置收货地址");
				return false;
			}
			var payNum = that.payNum;
			var buyerNote = "";
			var goodOrder = "";
			var orderSource = that.orderSource;
			if (orderSource != "noCart") {
				orderSource = "cart";
			}
			var bos = that.boList;
			for (var i = 0; i < bos.length; i++) {
				if (i > 0) {
					goodOrder += ",";
				}
				var specName = null;
				var deliveryType = null;
				if (bos[i].specName != undefined && bos[i].specName != '') {
					specName = encodeURI(bos[i].specName);
				}
				if (bos[i].deliveryType != undefined && bos[i].deliveryType != '') {
					deliveryType = bos[i].deliveryType;
				} else {
					deliveryType = null;
				}
				var isChoosePrint = "N"; //是否选择了打印服务
				if (that.printServicePara != undefined && that.printServicePara != null && that.printServicePara > 0) {
					isChoosePrint = "Y";
				}
				var isChooseLaser = "N"; //是否选择了打印服务
				var isChoosePrinting = "N"; //是否选择了打印服务
				var isChooseRebranding = "N"; //是否选择了打印服务
				if (that.rebrandingServicePara != undefined && that.rebrandingServicePara != null && that.rebrandingServicePara > 0) {
					isChooseRebranding = "Y";
				}
				if (that.printingServicePara != undefined && that.printingServicePara != null && that.printingServicePara > 0) {
					isChoosePrinting = "Y";
				}
				if (that.laserServicePara != undefined && that.laserServicePara != null && that.laserServicePara > 0) {
					isChooseLaser = "Y";
				}

				if (bos[i].ext2 == "noCart") {
					//
					bos[i].shopCode = bos[i].ext3;
					goodOrder = bos[i].goodsCode + ":" + bos[i].goodsNumber + ":" + bos[i].shopCode + ":" + specName + ":" + deliveryType + ":" + bos[i].sevenDayReturn + ":" + isChoosePrint + ":" + isChooseLaser + ":" + isChoosePrinting + ":" + isChooseRebranding + ":" + that.fileNamePara + ":" + that.filePathPara + ":" + that.imageNamePara + ":" + that.imagePathPara;
				} else {
					goodOrder += bos[i].goodsCode + ":" + bos[i].goodsNumber + ":" + bos[i].id + ":" + bos[i].shopCode + ":" + specName + ":" + deliveryType + ":" + bos[i].seven_day_return;
				}
			}
			buyerNote = encodeURI(buyerNote);
			var isOnline = false;
			if (that.sumAmount > 0) {
				isOnline = true;
			}
			var addressId = that.addressId;
			var discountInfo = "";
			var distributeName = that.distributeName;
			var distributeAccount = that.distributeAccount;
			var discountType = "";
			var totalPoint = 0;
			if (that.discountType == "point") {
				discountInfo = "point:" + that.pointNum + ":" + that.pointDiscount;
				totalPoint = that.goodsTotalPrice.totalPoint + that.pointNum;
			} else {
				totalPoint = that.goodsTotalPrice.totalPoint + that.pointNum;
			}
			//
			var receiptTurn = 0;
			if (that.isReceiptTrue != 0) {
				if (that.receiptType == 1) {
					receiptTurn = -1;
				} else if (that.receiptType == 2) {
					receiptTurn = that.receiptId;
				} else if (that.receiptType == 3) {
					receiptTurn = that.receiptId1;
				}
			}
			//				API.confirmOrder(goodOrder, null, buyerNote, isOnline, orderSource, function(ret) {
			//				API.confirmPhysicalOrder(goodOrder,discountInfo,buyerNote,addressId,isOnline,couponCode,userAccount,profit,couponSubCode,orderSrc,function(ret){
			//alert(goodOrder);return false;
			//现货订单
			__WEBPACK_IMPORTED_MODULE_7__static_api_api_js__["a" /* default */].confirmPhysicalOrder(that.orderType, goodOrder, discountInfo, buyerNote, addressId, isOnline, '', '', '', '', orderSource, that.distributeName, that.distributeAccount, that.discountType, null, null, null, null, null, function (ret) {
				var operation = '兑换';
				if (ret.code != null && ret.code == "success") {
					if (!isOnline) {
						that.$router.push({ name: 'paySuccess', params: {} });
					}
					var tradeCode = ret.data.tradeCode;
					var packageCode = ret.data.packageCode;
					var totalAmount = that.sumOrderAmount - that.discountAmount;
					if (that.goodsBo.deliveryType != 'self_take') {
						totalAmount += that.totalExpressAmount / 100;
					}
					that.$router.push({ name: 'orderconfirm', params: {
							bos: that.boList,
							sumAmount: totalAmount,
							totalPoint: totalPoint,
							tradeCode: tradeCode,
							packageCode: packageCode
						} });
				} else if (ret.code != null && ret.code == "online_success") {
					var tradeCode = ret.data.tradeCode;
					var packageCode = ret.data.packageCode;
					var totalAmount = that.sumOrderAmount - that.discountAmount;
					if (that.goodsBo.deliveryType != 'self_take') {
						totalAmount += that.totalExpressAmount / 100;
					}
					that.$router.push({ name: 'orderconfirm', params: {
							bos: that.boList,
							sumAmount: totalAmount,
							totalPoint: totalPoint,
							tradeCode: tradeCode,
							orderList: ret.data.orderList,
							packageCode: packageCode
						} });
				} else if (ret.code != null && ret.code == "send_redirect") {
					window.location.href = ret.msg;
				} else if (ret.code == undefined || ret.code == null || ret.code == 'null') {
					__WEBPACK_IMPORTED_MODULE_9__static_js_alertConfirm_js__["a" /* default */].singleConfirm('系统繁忙，请稍后再试');
				} else if (ret.code != null && ret.code == 'fail') {
					__WEBPACK_IMPORTED_MODULE_9__static_js_alertConfirm_js__["a" /* default */].singleConfirm(ret.msg);
				} else if (ret) {
					var errorCode = ret.code;
					var errorMsg = '系统繁忙，请稍后再试';
					if (errorCode == 'O_00001' || errorCode == 'O_00002' || errorCode == 'O_00011') {
						errorMsg = '商品尚未起售';
					} else if (errorCode == 'O_00003') {
						errorMsg = '商品已售罄';
					} else if (errorCode == 'O_00004') {
						errorMsg = '商品不足起卖数量';
					} else if (errorCode == 'O_00005' || errorCode == 'O_00012') {
						errorMsg = operation + '额度已用完';
					} else if (errorCode == 'O_00010') {
						errorMsg = '积分余额不足';
					} else if (errorCode == 'O_00019') {
						errorMsg = '您的账号不在' + operation + '该商品的号段范围内';
					} else if (errorCode == 'U_00032') {
						errorMsg = '非产权用户不能购买此商品';
					}
					__WEBPACK_IMPORTED_MODULE_9__static_js_alertConfirm_js__["a" /* default */].singleConfirm(errorMsg);
				}
			});
		},
		getOrderConfirm: function getOrderConfirm(goodsCode, payNum, shopCode, shopName, specName) {
			var that = this;
			specName = encodeURI(specName);
			__WEBPACK_IMPORTED_MODULE_7__static_api_api_js__["a" /* default */].getPhysicalOrderConfirm(goodsCode, payNum, specName, null, shopCode, function (ret) {
				if (ret.code == "success") {
					that.address = ret.data.address;

					/*if(ret.data.brokerDiscountPersent != undefined){
     that.brokerDiscountPersent=ret.data.brokerDiscountPersent;
     }*/
					that.goodsBo = ret.data.goods;

					that.goodsBo.attrValue = JSON.parse(ret.data.goods.attrValue);
					if (that.goodsBo.attrValue.deliveryType != undefined && that.goodsBo.attrValue.deliveryType != '') {
						var typeArray = new Array();
						if (that.goodsBo.attrValue.deliveryType.indexOf(",") == -1 && that.goodsBo.attrValue.deliveryType.indexOf("[") == -1) {
							var deliveryObj = { "typeCode": that.goodsBo.attrValue.deliveryType, "typeName": __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__static_js_emallUtils_js__["t" /* getValueFromMap */])(ret.data.enumDeliveryType, that.goodsBo.attrValue.deliveryType) };
							typeArray.push(deliveryObj);
							that.$set(that.goodsBo, 'deliveryType', that.goodsBo.attrValue.deliveryType);
						} else {
							var tempArray = JSON.parse(that.goodsBo.attrValue.deliveryType);
							if (tempArray != undefined && tempArray != null && tempArray.length > 0) {
								that.$set(that.goodsBo, 'deliveryType', tempArray[0]);
								for (var i = 0; i < tempArray.length; i++) {
									var deliveryObj = { "typeCode": tempArray[i], "typeName": __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__static_js_emallUtils_js__["t" /* getValueFromMap */])(ret.data.enumDeliveryType, tempArray[i]) };
									typeArray.push(deliveryObj);
								}
							}
						}
						that.$set(that.goodsBo, 'deliveryTypeArray', typeArray);
					}
					var imgSmall = ret.data.goods.imgSmall; // 图片
					if (imgSmall.indexOf(";") != -1) {
						imgSmall = imgSmall.split(";")[0];
					}
					that.goodsBo.imgSmall = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + imgSmall;
					if (that.goodsBo.seckillPrice > 0) {
						that.goodsBo.unitPrice = that.goodsBo.seckillPrice / 100;
						that.seckillPrice = that.goodsBo.seckillPrice;
					} else {
						that.goodsBo.unitPrice = that.goodsBo.unitPrice / 100;
					}
					if (that.goodsBo.attrValue.printService == null) {
						that.goodsBo.attrValue.printService = 0;
					} else {
						that.goodsBo.attrValue.printService = that.goodsBo.attrValue.printService / 100;
					}

					that.goodsBo.goodsNumber = payNum;
					that.goodsBo.ext1 = that.goodsBo.unitPrice * payNum;
					that.goodsBo.ext2 = "noCart";
					that.goodsBo.ext3 = shopCode;
					that.goodsBo.shopCode = shopCode;
					that.goodsBo.shopName = shopName;

					if (that.specName != undefined && that.specName != '') {
						that.goodsBo.goodsName = that.goodsBo.goodsName + "【" + that.specName + "】";
						that.goodsBo.specName = that.specName;
					}
					that.boList.push(that.goodsBo);

					that.points = ret.data.points;
					if (typeof that.points != 'undefined' && that.points != 'undefined' && that.points != null && that.points != '') {
						that.pointNum = that.points.point.usableNum;
						that.pointDiscount = that.points.point.discountMoney;
					}

					that.sortByShop();
					//计算运费
					that.computeExpressFee();
				}
			});
		},
		//按照店铺分类
		sortByShop: function sortByShop() {
			var that = this;
			var bos = that.boList;
			var shopBoMap = {};
			for (var i = 0; i < bos.length; i++) {
				//按照店铺分类
				var shopBo = shopBoMap[bos[i].shopName];
				if (shopBo == undefined) {
					var arrayTemp = new Array();
					arrayTemp.push(bos[i]);
					shopBo = {
						shopName: bos[i].shopName,
						shopCode: bos[i].shopCode,
						expressFee: 0,
						boListIn: arrayTemp
					};
					shopBoMap[bos[i].shopName] = shopBo;
				} else {
					shopBo.boListIn.push(bos[i]);
				}
				if (bos[i].goodsPrice > 0 && bos[i].pointType == 'point') {
					that.goodsTotalPrice.totalPoint = bos[i].goodsPrice * bos[i].goodsNumber + that.goodsTotalPrice.totalPoint;
					//jQuery("#totalPoint").html(that.goodsTotalPrice.totalPoint+"通用积分");
				}
				if (bos[i].goodsPrice > 0 && bos[i].pointType == 'red') {
					that.goodsTotalPrice.totalRed = bos[i].goodsPrice * bos[i].goodsNumber + that.goodsTotalPrice.totalRed;
					//alert(1);
					//jQuery("#totalRed").html(that.goodsTotalPrice.totalRed+"红积分+");
					//console.log(jQuery("#totalRed").html());
				}
				if (bos[i].goodsPrice > 0 && bos[i].pointType == 'blue') {
					that.goodsTotalPrice.totalBlue = bos[i].goodsPrice * bos[i].goodsNumber + that.goodsTotalPrice.totalBlue;
					//jQuery("#totalBlue").html(that.goodsTotalPrice.totalBlue+"蓝积分+");
				}
				if (bos[i].goodsPrice > 0 && bos[i].pointType == 'special') {
					that.goodsTotalPrice.totalSpecial = bos[i].goodsPrice * bos[i].goodsNumber + that.goodsTotalPrice.totalSpecial;
					//jQuery("#totalSpecial").html(that.goodsTotalPrice.totalSpecial+"专用积分+");
				}
				//
			}

			for (var j in shopBoMap) {
				that.shopBoList.push(shopBoMap[j]);
			}
		},
		//计算运费
		computeExpressFee: function computeExpressFee() {
			var that = this;
			var bos = that.boList;
			var goodOrder = "";
			var orderSource = that.orderSource;
			if (orderSource != "noCart") {
				orderSource = "cart";
			}
			var bos = that.boList;
			if (0 == bos) {
				return;
			}
			for (var i = 0; i < bos.length; i++) {
				if (i > 0) {
					goodOrder += ",";
				}
				if (bos[i].ext2 == "noCart") {
					//
					bos[i].shopCode = bos[i].ext3;
					goodOrder = bos[i].goodsCode + ":" + bos[i].goodsNumber + ":" + bos[i].shopCode + ":" + bos[i].specName + ":" + bos[i].deliveryType;
				} else {
					goodOrder += bos[i].goodsCode + ":" + bos[i].goodsNumber + ":" + bos[i].id + ":" + bos[i].shopCode + ":" + bos[i].specName + ":" + bos[i].deliveryType;
				}
			}
			if (that.specName != undefined && that.specName != '') {
				var specName = encodeURI(that.specName);
				goodOrder = goodOrder + ":" + specName;
			} else {
				goodOrder = goodOrder + ":" + null;
			}
			var addressId = that.addressId;
			__WEBPACK_IMPORTED_MODULE_7__static_api_api_js__["a" /* default */].computeExpressFee(addressId, goodOrder, orderSource, function (ret) {
				if (ret.code == "success") {
					that.totalExpressAmount = 0;
					for (var i = 0; i < that.shopBoList.length; i++) {
						var shopCode = that.shopBoList[i].shopCode;
						var expressFee = ret.data[shopCode];
						if (undefined == expressFee || null == expressFee) {
							expressFee = 0;
						}
						that.shopBoList[i].expressFee = expressFee;
						that.totalExpressAmount = that.totalExpressAmount + expressFee;
						/*that.brokerDiscountPersent = ret.data["brokerDiscountPersent"];
      if(that.seckillPrice==undefined||that.seckillPrice==''){
      	that.brokerDiscountAmount=that.sumOrderAmount*(100-that.brokerDiscountPersent);
      	if(that.brokerDiscountAmount>0){
      		that.discountType = "broker_level";
      that.discountAmount = that.brokerDiscountAmount/100;
      	}
      }*/
					}
				}
			});
		},
		getPointAddress: function getPointAddress() {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_7__static_api_api_js__["a" /* default */].getUserAddress(function (ret) {
				if (ret.data != null) {
					that.addressBo = ret.data.addressBo;
					var addr = that.addressBo.province + that.addressBo.city + that.addressBo.district + that.addressBo.address;
					var ci = encodeURI(that.addressBo.city);
					that.initMap(addr, ci);
				}
			});
		},
		getStoreList: function getStoreList(BMap, map, pointStr, ci) {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_7__static_api_api_js__["a" /* default */].getStoreList(pointStr, ci, function (ret) {
				var storeInfoBoList = ret.data;
				console.log(storeInfoBoList);
				var data_info = new Array();
				if (storeInfoBoList != undefined && storeInfoBoList.length > 0) {
					for (var i = 0; i < storeInfoBoList.length; i++) {
						var addr = storeInfoBoList[i].province + storeInfoBoList[i].city + storeInfoBoList[i].district + storeInfoBoList[i].address;
						var arr = new Array(storeInfoBoList[i].longitude, storeInfoBoList[i].latitude, storeInfoBoList[i].storeName + "<br>地址： " + addr + "<br>电话： " + storeInfoBoList[i].phone);
						data_info.push(arr);
					}
				}
				var opts = {
					width: 250, // 信息窗口宽度
					height: 120, // 信息窗口高度
					title: "门店详情", // 信息窗口标题
					enableMessage: true //设置允许信息窗发送短息
				};
				for (var i = 0; i < data_info.length; i++) {
					var point = new BMap.Point(data_info[i][0], data_info[i][1]);
					var markers = new BMap.Marker(point, {
						icon: new BMap.Symbol(BMap_Symbol_SHAPE_POINT, {
							scale: 1,
							fillColor: "red",
							fillOpacity: 0.9
						})
					});
					map.addOverlay(markers);
					var content = data_info[i][2];
					addClickHandler(content, markers);
				}
				function addClickHandler(content, marker) {
					marker.addEventListener("click", function (e) {
						showInfo(content, e);
					});
				}
				function showInfo(content, e) {
					var p = e.target;
					var point = new BMap.Point(p.getPosition().lng, p.getPosition().lat);
					var infoWindow = new BMap.InfoWindow(content, opts);
					map.openInfoWindow(infoWindow, point);
				}
			});
		},
		initMap: function initMap(addr, ci) {
			var that = this;
			var script = document.getElementById("mapScriptId");
			if (script == null) {
				that.$nextTick(function () {
					__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__static_js_map_js__["a" /* MP */])(__WEBPACK_IMPORTED_MODULE_8__static_js_emallUtils_js__["u" /* ak */]).then(function (BMap) {
						that.init_map(addr, ci);
					});
				});
			} else {
				that.init_map(addr, ci);
			}
		},

		init: function init() {
			var that = this;
			var script = document.getElementById("mapScriptId");
			if (script == null) {
				that.$nextTick(function () {
					__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__static_js_map_js__["a" /* MP */])(__WEBPACK_IMPORTED_MODULE_8__static_js_emallUtils_js__["u" /* ak */]).then(function (BMap) {});
				});
			}
		},
		init_map: function init_map(addr, ci) {
			var that = this;
			var map = new BMap.Map("mapPage", { minZoom: 7, maxZoom: 17 });
			map.centerAndZoom(new BMap.Point(116.4035, 39.915), 15);
			//map.enableScrollWheelZoom();
			map.addControl(new BMap.ScaleControl({ anchor: BMAP_ANCHOR_BOTTOM_LEFT }));
			map.addControl(new BMap.NavigationControl({ type: BMAP_NAVIGATION_CONTROL_LARGE, anchor: BMAP_ANCHOR_BOTTOM_LEFT }));
			map.addEventListener("dragend", function () {
				var bounds = map.getBounds();
				var sw = bounds.getSouthWest();
				var ne = bounds.getNorthEast();
				var pointStr = sw.lng + "," + sw.lat + "," + ne.lng + "," + ne.lat;
				that.getStoreList(BMap, map, pointStr, '');
			}); //停止拖拽地图时触发
			map.addEventListener("zoomend", function () {
				var bounds = map.getBounds();
				var sw = bounds.getSouthWest();
				var ne = bounds.getNorthEast();
				var pointStr = sw.lng + "," + sw.lat + "," + ne.lng + "," + ne.lat;
				that.getStoreList(BMap, map, pointStr, '');
			}); //停止拖拽地图时触发
			var myGeo = new BMap.Geocoder();
			myGeo.getPoint(addr, function (point) {
				if (point) {
					var map = that.map;
					map.centerAndZoom(point, 15);
					var marker = new BMap.Marker(point, {
						icon: new BMap.Symbol(BMap_Symbol_SHAPE_POINT, {
							scale: 1,
							fillColor: "blue",
							fillOpacity: 0.9,
							strokeColor: "blue",
							strokeOpacity: 0.3,
							strokeWeight: 20
						})
					});
					map.addOverlay(marker);
				}
			}, "全国");
			that.getStoreList(BMap, map, '', ci);
			this.map = map;
		},
		showMap: function showMap() {
			//alert(this.deliveryTypeFag);
			this.deliveryTypeFag = 0;
			var bos = this.boList;
			if (bos.length > 0) {
				for (var i = 0; i < bos.length; i++) {
					//alert("dielivery:"+bos[i].deliveryType);
					if (bos[i].deliveryType == 'self_take') {
						this.deliveryTypeFag = 1;
					}
				}
			}
			if (this.deliveryTypeFag == 1) {
				jQuery("#nearbyCompanyMap").show();
				//根据收货地址描点
				this.selectAddressPoint();
			} else {
				jQuery("#nearbyCompanyMap").hide();
			}
		},
		selectAddressPoint: function selectAddressPoint() {
			if (this.addressBoList.length > 0 && this.deliveryTypeFag > 0) {
				var addressBo = this.addressBoList[this.indexFag];
				var addr = addressBo.province + addressBo.city + addressBo.district + addressBo.address;
				var ci = encodeURI(addressBo.city);
				this.initMap(addr, ci);
			}
		},
		//发票弹窗
		showmodal: function showmodal() {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_7__static_api_api_js__["a" /* default */].getReceiptList(function (ret) {
				if (ret.code == "success") {
					that.enterpriseList = ret.data.enterpriseList;
					that.specialList = ret.data.specialList;
				} else {
					MessageBox.alert("获取个人发票信息失败!", "提示");
				}
			});
			jQuery("#mainId").show();
			jQuery(".ui-mask").show();
		},
		//关闭发票弹窗
		closemodal: function closemodal() {
			jQuery("#mainId").hide();
			jQuery(".ui-mask").hide();
		},
		//企业发票
		change2: function change2() {
			jQuery("#click_2").addClass("tab-item-selected");
			jQuery("#click_3").removeClass("tab-item-selected");
			jQuery("#vat-inv").hide();
			jQuery("#ele-inv").show();
			this.receiptType = "2";
		},
		//增值税发票
		change3: function change3() {
			jQuery("#click_2").removeClass("tab-item-selected");
			jQuery("#click_3").addClass("tab-item-selected");
			jQuery("#ele-inv").hide();
			jQuery("#vat-inv").show();
			this.receiptType = "3";
		},
		//企业发票是否开票
		contentTab1: function contentTab1() {
			jQuery("#electro-invoice-content-2").removeClass("invoice-item-selected");
			jQuery("#electro-invoice-content-1").addClass("invoice-item-selected");
			jQuery("#receiptContent").hide();
			this.isReceipt = 0;
		},
		//企业发票是否开票
		contentTab2: function contentTab2() {
			jQuery("#electro-invoice-content-1").removeClass("invoice-item-selected");
			jQuery("#electro-invoice-content-2").addClass("invoice-item-selected");
			jQuery("#receiptContent").show();
			this.isReceipt = 1;
		},
		//企业发票选择
		selectTitle: function selectTitle(event, titlenum, taxpayerNum) {
			if (titlenum < 0) {
				jQuery("#ele_code_div").hide();
				this.receiptType = '1';
			} else if (titlenum > 0) {
				jQuery("#ele_code_div").show();
				jQuery("#addEnterpriseRecipes").show();
				jQuery("#newReceiptTitle").hide();
				this.receiptType = '2';
			} else {
				jQuery("#addEnterpriseRecipes").hide();
				this.receiptType = '2';
			}
			jQuery("#ele_code").val(taxpayerNum);
			jQuery(".rise").removeClass("invoice-item-selected");
			jQuery(event.currentTarget).addClass("invoice-item-selected");
			this.receiptId = titlenum;
		},
		//增值税发票选择
		selectTitle1: function selectTitle1(event, titlenum, taxpayerNum, address, phone, openBank, openBankAccount) {
			if (titlenum < 0) {
				jQuery("#vat-inv-type1").hide();
				this.isReceipt1 = 0;
			} else if (titlenum > 0) {
				jQuery("#vat-inv-type1").show();
				jQuery("#addEnterpriseRecipes1").show();
				jQuery("#newReceiptTitle1").hide();
				this.receiptType = '3';
				this.isReceipt1 = 1;
			} else {
				jQuery("#addEnterpriseRecipes1").hide();
				this.receiptType = '3';
				this.isReceipt1 = 1;
			}
			if (titlenum > 0) {
				jQuery("#vat_code").val(taxpayerNum);
				jQuery("#vat_address").val(address);
				jQuery("#vat_phone").val(phone);
				jQuery("#vat_bankName").val(openBank);
				jQuery("#vat_bankAccount").val(openBankAccount);
			}
			jQuery(".rise1").removeClass("invoice-item-selected");
			jQuery(event.currentTarget).addClass("invoice-item-selected");
			this.receiptId1 = titlenum;
		},
		//保存企业发票
		saveReceipt: function saveReceipt() {
			var that = this;
			var receiptTitle = jQuery('#invoice-tit-list_lest').children('.invoice-item-selected').children('#invoice-2').children('input').val();
			var taxpayerNum = jQuery("#ele_code").val();
			var id = that.receiptId;
			var isReceipt = that.isReceipt;
			var receiptType = that.receiptType;
			if (receiptType == 2) {
				var reg_number = /^([a-zA-Z0-9]){15,20}$/;
				if (!reg_number.test(taxpayerNum)) {
					alert('请填写准确的纳税人识别号或统一社会信用代码!');
					jQuery("#ele_code").val('').focus();
					return false;
				}
				if (receiptTitle == null || receiptTitle == '') {
					alert("请填写准确发票抬头!", "提示");
					return false;
				}
				__WEBPACK_IMPORTED_MODULE_7__static_api_api_js__["a" /* default */].saveReceipt(id, receiptType, receiptTitle, taxpayerNum, null, null, null, null, function (ret) {
					if (ret.code == "success") {
						if (isReceipt == 1) {
							that.receiptSmall1 = '企业发票';
							that.receiptSmall2 = receiptTitle;
							that.receiptSmall3 = '商品明细';
							jQuery("#receiptSmall2").show();
							jQuery("#receiptSmall3").show();
							that.isReceiptTrue = 1;
						} else {
							that.receiptSmall1 = '不开发票';
							jQuery("#receiptSmall2").hide();
							jQuery("#receiptSmall3").hide();
							that.isReceiptTrue = 0;
						}
						that.receiptId = ret.data;
					} else {
						alert(ret.msg, "提示");
					}
				});
			} else if (receiptType == 1) {
				if (isReceipt == 1) {
					that.receiptSmall1 = '普通发票';
					that.receiptSmall2 = '个人';
					that.receiptSmall3 = '商品明细';
					jQuery("#receiptSmall2").show();
					jQuery("#receiptSmall3").show();
					that.isReceiptTrue = -1;
					that.receiptId = -1;
				} else {
					that.receiptSmall1 = '不开发票';
					jQuery("#receiptSmall2").hide();
					jQuery("#receiptSmall3").hide();
					that.isReceiptTrue = 0;
				}
			}
			this.closemodal();
		},
		//新增企业发票
		addEnterprise: function addEnterprise() {
			jQuery(".rise").removeClass("invoice-item-selected");
			jQuery("#newReceiptTitle").addClass('invoice-item-selected').show().find('input').val('').focus();
			document.getElementById('invoice-tit-list_lest').scrollTop = document.getElementById('invoice-tit-list_lest').scrollHeight;
			jQuery("#ele_code_div").show();
			jQuery("#ele_code").val('');
			jQuery("#addEnterpriseRecipes").hide();
		},
		//新增增值税发票
		addEnterprise1: function addEnterprise1() {
			jQuery(".rise1").removeClass("invoice-item-selected");
			jQuery("#newReceiptTitle1").addClass('invoice-item-selected').show().find('input').val('').focus();
			document.getElementById('invoice-tit-list_lest1').scrollTop = document.getElementById('invoice-tit-list_lest1').scrollHeight;
			jQuery("#vat_code").val("");
			jQuery("#vat_address").val("");
			jQuery("#vat_phone").val("");
			jQuery("#vat_bankName").val("");
			jQuery("#vat_bankAccount").val("");
			jQuery("#vat-inv-type1").show();
			jQuery("#addEnterpriseRecipes1").hide();
		},
		//保存增值税发票
		saveReceipt1: function saveReceipt1() {
			var that = this;
			var receiptTitle = jQuery('#invoice-tit-list_lest1').children('.invoice-item-selected').children('#invoice-2').children('input').val();
			var taxpayerNum = jQuery("#vat_code").val();
			var address = jQuery("#vat_address").val();
			var phone = jQuery("#vat_phone").val();
			var openBank = jQuery("#vat_bankName").val();
			var openBankAccount = jQuery("#vat_bankAccount").val();
			var id = that.receiptId1;
			var receiptType = that.receiptType;

			if (that.isReceipt1 == 1) {
				var checkAddValed = true;
				// 增值税单位名称验证
				if (!that.check_Invoice1("vat_companyName", receiptTitle)) {
					checkAddValed = false;
				}
				// 增值税纳税人识别号验证
				if (!that.check_Invoice1("vat_code", taxpayerNum)) {
					checkAddValed = false;
				}
				// 增值税注册注册地址验证
				if (!that.check_Invoice1("vat_address", address)) {
					checkAddValed = false;
				}
				// 增值税注册电话验证
				if (!that.check_Invoice1("vat_phone", phone)) {
					checkAddValed = false;
				}
				// 增值税开户银行验证
				if (!that.check_Invoice1("vat_bankName", openBank)) {
					checkAddValed = false;
				}
				// 增值税开户银行账户验证
				if (!that.check_Invoice1("vat_bankAccount", openBankAccount)) {
					checkAddValed = false;
				}
				if (!checkAddValed) {
					return false;
				}
				__WEBPACK_IMPORTED_MODULE_7__static_api_api_js__["a" /* default */].saveReceipt(id, receiptType, receiptTitle, taxpayerNum, address, phone, openBank, openBankAccount, function (ret) {
					if (ret.code == "success") {
						that.receiptSmall1 = '增值税专用发票';
						that.receiptSmall2 = receiptTitle;
						that.receiptSmall3 = '商品明细';
						jQuery("#receiptSmall2").show();
						jQuery("#receiptSmall3").show();
						that.receiptId1 = ret.data;
						that.isReceiptTrue = 1;
					} else {
						alert(ret.msg, "提示");
					}
				});
			} else {
				that.receiptSmall1 = '不开发票';
				jQuery("#receiptSmall2").hide();
				jQuery("#receiptSmall3").hide();
				that.isReceiptTrue = 0;
			}
			this.closemodal();
		},
		check_Invoice: function check_Invoice(type, event) {
			var that = this;
			var errorFlag = false;
			var errorMessage = null;
			var value = event.target.value;
			// 验证发票单位名称
			if (type == "vat_companyName") {
				if (this.isEmpty(value)) {
					errorFlag = true;
					errorMessage = "单位名称不能为空！";
				}
				//					else {
				//						if(this.checkLength(value) < 2) {
				//							errorFlag = true;
				//							errorMessage = "请填写完整单位名称！";
				//						}
				//						if(this.checkLength(value) > 50) {
				//							errorFlag = true;
				//							errorMessage = "单位名称过长,请重新输入！";
				//						}
				//						if(!this.is_forbidForInvoice(value)) {
				//							errorFlag = true;
				//							errorMessage = "单位名称含有非法字符！";
				//						}
				//					}
			} else if (type == "vat_code") {
				// 验证纳税人识别号
				if (this.isEmpty(value)) {
					errorFlag = true;
					errorMessage = "纳税人识别号不能为空！";
				} else {
					var reg_number = /^([a-zA-Z0-9]){15,20}$/;
					if (!reg_number.test(value)) {
						errorFlag = true;
						errorMessage = "纳税人识别号错误，请检查！";
					}
				}
			} else if (type == "vat_address") {
				// 验证发票注册地址
				if (this.isEmpty(value)) {
					errorFlag = true;
					errorMessage = "注册地址不能为空！";
				} else {
					if (this.checkLength(value) > 50) {
						errorFlag = true;
						errorMessage = "注册地址过长，请重新输入！";
					}
					if (!this.is_forbidForInvoice(value)) {
						errorFlag = true;
						errorMessage = "注册地址含有非法字符！";
					}
				}
			} else if (type == "vat_phone") {
				// 验证增值税发票电话
				if (this.isEmpty(value)) {
					errorFlag = true;
					errorMessage = "注册电话不能为空！";
				} else {
					if (this.checkLength(value) > 50) {
						errorFlag = true;
						errorMessage = "注册电话过长，请重新输入！";
					}
					if (!this.is_forbidForInvoice(value)) {
						errorFlag = true;
						errorMessage = "注册电话含有非法字符！";
					}
				}
			} else if (type == "vat_bankName") {
				// 验证增值税发票开户银行
				if (this.isEmpty(value)) {
					errorFlag = true;
					errorMessage = "开户银行不能为空！";
				} else {
					if (this.checkLength(value) > 50) {
						errorFlag = true;
						errorMessage = "开户银行过长，请重新输入！";
					}
					if (!this.is_forbidForInvoice(value)) {
						errorFlag = true;
						errorMessage = "开户银行含有非法字符！";
					}
				}
			} else if (type == "vat_bankAccount") {
				// 验证增值税发票银行账户
				if (this.isEmpty(value)) {
					errorFlag = true;
					errorMessage = "银行帐户不能为空！";
				} else {
					if (!this.is_forbidForInvoice(value)) {
						errorFlag = true;
						errorMessage = "银行帐户含有非法字符！";
					}
				}
			}
			if (errorFlag) {
				jQuery("#" + type + "_error").html(errorMessage);
				jQuery("#" + type + "_error").removeClass("succ-msg");
				jQuery("#" + type + "_error").addClass("error-msg");
				return false;
			} else {
				jQuery("#" + type + "_error").removeClass("error-msg");
				jQuery("#" + type + "_error").addClass("succ-msg");
				jQuery("#" + type + "_error").html("");
			}
			return true;
		},
		//我是真的不知道vue怎么能兼容,只能复制一个了
		check_Invoice1: function check_Invoice1(type, value) {
			var that = this;
			var errorFlag = false;
			var errorMessage = null;
			// 验证发票单位名称
			if (type == "vat_companyName") {
				if (this.isEmpty(value)) {
					errorFlag = true;
					errorMessage = "单位名称不能为空！";
				} else {
					if (this.checkLength(value) < 2) {
						errorFlag = true;
						errorMessage = "请填写完整单位名称！";
					}
					if (this.checkLength(value) > 50) {
						errorFlag = true;
						errorMessage = "单位名称过长,请重新输入！";
					}
					if (!this.is_forbidForInvoice(value)) {
						errorFlag = true;
						errorMessage = "单位名称含有非法字符！";
					}
				}
			} else if (type == "vat_code") {
				// 验证纳税人识别号
				if (this.isEmpty(value)) {
					errorFlag = true;
					errorMessage = "纳税人识别号不能为空！";
				} else {
					var reg_number = /^([a-zA-Z0-9]){15,20}$/;
					if (!reg_number.test(value)) {
						errorFlag = true;
						errorMessage = "纳税人识别号错误，请检查！";
					}
				}
			} else if (type == "vat_address") {
				// 验证发票注册地址
				if (this.isEmpty(value)) {
					errorFlag = true;
					errorMessage = "注册地址不能为空！";
				} else {
					if (this.checkLength(value) > 50) {
						errorFlag = true;
						errorMessage = "注册地址过长，请重新输入！";
					}
					if (!this.is_forbidForInvoice(value)) {
						errorFlag = true;
						errorMessage = "注册地址含有非法字符！";
					}
				}
			} else if (type == "vat_phone") {
				// 验证增值税发票电话
				if (this.isEmpty(value)) {
					errorFlag = true;
					errorMessage = "注册电话不能为空！";
				} else {
					if (this.checkLength(value) > 50) {
						errorFlag = true;
						errorMessage = "注册电话过长，请重新输入！";
					}
					if (!this.is_forbidForInvoice(value)) {
						errorFlag = true;
						errorMessage = "注册电话含有非法字符！";
					}
				}
			} else if (type == "vat_bankName") {
				// 验证增值税发票开户银行
				if (this.isEmpty(value)) {
					errorFlag = true;
					errorMessage = "开户银行不能为空！";
				} else {
					if (this.checkLength(value) > 50) {
						errorFlag = true;
						errorMessage = "开户银行过长，请重新输入！";
					}
					if (!this.is_forbidForInvoice(value)) {
						errorFlag = true;
						errorMessage = "开户银行含有非法字符！";
					}
				}
			} else if (type == "vat_bankAccount") {
				// 验证增值税发票银行账户
				if (this.isEmpty(value)) {
					errorFlag = true;
					errorMessage = "银行帐户不能为空！";
				} else {
					if (!this.is_forbidForInvoice(value)) {
						errorFlag = true;
						errorMessage = "银行帐户含有非法字符！";
					}
				}
			}
			if (errorFlag) {
				jQuery("#" + type + "_error").html(errorMessage);
				jQuery("#" + type + "_error").removeClass("succ-msg");
				jQuery("#" + type + "_error").addClass("error-msg");
				return false;
			} else {
				jQuery("#" + type + "_error").removeClass("error-msg");
				jQuery("#" + type + "_error").addClass("succ-msg");
				jQuery("#" + type + "_error").html("");
			}
			return true;
		},
		isEmpty: function isEmpty(value) {
			if (value == null || value == "" || value == "undefined" || value == undefined || value == "null") {
				return true;
			} else {
				if ($.trim(value) == "") {
					return true;
				}
				return false;
			}
		},
		checkLength: function checkLength(txtObj) {
			var val = txtObj;
			var valLength = 0;
			for (var ii = 0; ii < val.length; ii++) {
				var word = val.substring(ii, 1);
				if (/[^\x00-\xff]/g.test(word)) {
					valLength += 2;
				} else {
					valLength++;
				}
			}
			return valLength;
		},
		is_forbidForInvoice: function is_forbidForInvoice(temp_str) {
			temp_str = temp_str.replace(/(^\s*)|(\s*$)/g, "");
			var forbid_str = new String('>,<,&');
			var forbid_array = new Array();
			forbid_array = forbid_str.split(',');
			for (var i = 0; i < forbid_array.length; i++) {
				if (temp_str.search(new RegExp(forbid_array[i])) != -1) return false;
			}
			return true;
		}

	},
	beforeMount: function beforeMount() {
		var that = this;
		var deliveryMap = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();
		deliveryMap.set("express", "快递收货");
		deliveryMap.set("self_take", "上门自提");
		var goodsCode = this.$route.query.goodsCode;
		var payNum = this.$route.query.payNum;
		var shopCode = this.$route.query.shopCode;
		var shopName = this.$route.query.shopName;
		if (this.$route.query.orderType != undefined && this.$route.query.orderType != null) {
			that.orderType = this.$route.query.orderType;
		}
		if (this.$route.query.printServicePara != undefined && this.$route.query.printServicePara != "") {
			that.printServicePara = parseInt(that.$route.query.printServicePara); //附件
		}
		if (this.$route.query.rebrandingServicePara != undefined && this.$route.query.rebrandingServicePara != "") {
			that.rebrandingServicePara = parseInt(that.$route.query.rebrandingServicePara); //附件
		}
		if (this.$route.query.printingServicePara != undefined && this.$route.query.printingServicePara != "") {
			that.printingServicePara = parseInt(that.$route.query.printingServicePara); //附件
		}
		if (this.$route.query.laserServicePara != undefined && this.$route.query.laserServicePara != "") {
			that.laserServicePara = parseInt(that.$route.query.laserServicePara); //附件
		}

		if (this.$route.query.fileNamePara != undefined && this.$route.query.fileNamePara != null) {
			that.fileNamePara = that.$route.query.fileNamePara; //附件
		}
		if (this.$route.query.filePathPara != undefined && this.$route.query.filePathPara != null) {
			that.filePathPara = that.$route.query.filePathPara; //附件
		}
		if (this.$route.query.imageNamePara != undefined && this.$route.query.imageNamePara != null) {
			that.imageNamePara = that.$route.query.imageNamePara; //附件
		}
		if (this.$route.query.imagePathPara != undefined && this.$route.query.imagePathPara != null) {
			that.imagePathPara = that.$route.query.imagePathPara; //附件
		}
		that.payNum = payNum;
		that.goodsCode = goodsCode;
		that.shopCode = shopCode;
		if (typeof this.$route.query.distributeAccount != "undefined" && typeof this.$route.query.distributeName != "undefined") {
			that.distributeAccount = this.$route.query.distributeAccount;
			that.distributeName = this.$route.query.distributeName;
		}
		if (typeof this.$route.query.specName != "undefined") {
			that.specName = this.$route.query.specName;
		}

		that.orderSource = this.$route.query.orderSource;
		if (typeof goodsCode == "undefined" || goodsCode == null || typeof payNum == "undefined" || payNum == null) {
			//that.boList = this.$route.query.bos;
			that.goodsCodes = this.$route.query.goodsCodes;
			var boList = JSON.parse(localStorage.getItem('bos'));
			if (boList != undefined && boList.length > 0) {
				for (var i = 0; i < boList.length; i++) {
					boList[i].attrValue = JSON.parse(boList[i].attrValue);
					if (boList[i].attrValue.deliveryType != undefined && boList[i].attrValue.deliveryType != '') {
						var typeArray = new Array();
						if (boList[i].attrValue.deliveryType.indexOf(",") == -1 && boList[i].attrValue.deliveryType.indexOf("[") == -1) {
							var deliveryObj = { "typeCode": boList[i].attrValue.deliveryType, "typeName": deliveryMap.get(boList[i].attrValue.deliveryType) };
							//      					deliveryObj.typeCode=boList[i].attrValue.deliveryType;
							//		 					deliveryObj.typeName=deliveryMap.get(boList[i].attrValue.deliveryType);
							that.$set(boList[i], 'deliveryTypeArray', new Array());
							typeArray.push(deliveryObj);
							//      					boList[i].deliveryType=boList[i].attrValue.deliveryType;
							//      					Vue.set(boList[i],"deliveryType",boList[i].attrValue.deliveryType);
							that.$set(boList[i], 'deliveryType', boList[i].attrValue.deliveryType);
						} else {
							var tempArray = JSON.parse(boList[i].attrValue.deliveryType);
							//var tempArray=that.attrValue.deliveryType;
							if (tempArray != undefined && tempArray != null && tempArray.length > 0) {
								//		 						boList[i].deliveryType=tempArray[0];
								//Vue.set(boList[i],"deliveryType",tempArray[0]);
								that.$set(boList[i], 'deliveryType', tempArray[0]);

								for (var j = 0; j < tempArray.length; j++) {
									var deliveryObj = { "typeCode": tempArray[j], "typeName": deliveryMap.get(tempArray[j]) };
									//		 							deliveryObj.typeCode=tempArray[i];
									//		 							deliveryObj.typeName=deliveryMap.get(tempArray[i]);
									//		 							Vue.set(boList[i],"deliveryTypeArray",[]);
									typeArray.push(deliveryObj);
								}
							}
						}
						that.$set(boList[i], 'deliveryTypeArray', typeArray);
					}
				}
				that.boList = boList;
			}
			that.sortByShop();
		} else {
			this.getOrderConfirm(goodsCode, payNum, shopCode, shopName, that.specName);
		}
	},
	mounted: function mounted() {
		window.scrollTo(0, 0);
		this.getUserAddresses();
		this.showMap();
		this.init();

		this.getSumCount();
		this.getSumAmount();
	},
	updated: function updated() {
		this.getSumCount();
		this.getSumAmount();
		$("input[name='addressChk']:checked").parent().parent().css("color", "#fa660f");
	}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N"), __webpack_require__("7t+N")))

/***/ }),

/***/ "TK06":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dp-banner.37ba213.jpg";

/***/ }),

/***/ "Tgkl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "indexbg"
  }, [_c('topbar'), _vm._v(" "), _c('emallheader', {
    ref: "c1"
  }), _vm._v(" "), _c('headernav', {
    ref: "navComp",
    attrs: {
      "activeLi": _vm.activeLi
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clear mt15"
  }), _vm._v(" "), _c('div', {
    staticClass: "w1200 bc"
  }, [_c('div', {
    staticClass: "hq-crumb-wrap"
  }, [_c('ul', [_vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "item sep"
  }, [_vm._v(">")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.getGoodList(_vm.catCode, _vm.goodsCatNameCn)
      }
    }
  }, [_vm._v(_vm._s(_vm.goodsCatNameCn))])]), _vm._v(" "), _c('li', {
    staticClass: "item sep"
  }, [_vm._v(">")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.getGoodDetails(_vm.goodsCode)
      }
    }
  }, [_vm._v(_vm._s(_vm.goodsDetail.goodsName))])])])]), _vm._v(" "), _c('div', {
    staticClass: "db-goods-show"
  }, [_c('div', {
    staticClass: "goodspic"
  }, [_c('div', {
    staticClass: "spec-preview",
    attrs: {
      "id": "preview"
    }
  }, [_c('span', {
    staticClass: "jqzoom"
  }, [_c('img', {
    attrs: {
      "jqimg": _vm.goodsImgLarge,
      "src": _vm.goodsImgLarge,
      "width": "430px",
      "height": "430px"
    }
  })]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "spec-scroll"
  }, [_c('a', {
    staticClass: "prev",
    attrs: {
      "title": "上一张"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "next",
    attrs: {
      "title": "下一张"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "items"
  }, [_c('ul', _vm._l((_vm.goodsImgs), function(gI, index) {
    return _c('li', [_c('img', {
      attrs: {
        "alt": "",
        "bimg": gI,
        "src": gI
      },
      on: {
        "click": function($event) {
          _vm.choosePic(index)
        }
      }
    })])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "dt-m"
  }, [_c('div', {
    staticClass: "sp-title"
  }, [_c('h3', [_vm._v(" " + _vm._s(_vm.goodsName))])]), _vm._v(" "), (_vm.seckillPrice != '' && _vm.seckillPrice > 0) ? _c('div', {
    staticClass: "shop-miaosha"
  }, [_c('img', {
    staticClass: "miaosha-img",
    attrs: {
      "src": __webpack_require__("Ec7t"),
      "alt": ""
    }
  }), _vm._v("\n            \t\t\t\t秒杀\n            \t\t\t\t"), _vm._v(" "), (_vm.activityEndTime > 0) ? _c('span', {
    staticClass: "miaosha-time"
  }, [_vm._v("\n                \t\t\t\t距离结束"), _c('i', [_vm._v(_vm._s(_vm.hour))]), _vm._v(":"), _c('i', [_vm._v(_vm._s(_vm.minute))]), _vm._v(":"), _c('i', [_vm._v(_vm._s(_vm.second))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.seckillPrice == '' && _vm.nextBeginTime != '') ? _c('div', {
    staticClass: "shop-miaosha"
  }, [_c('img', {
    staticClass: "miaosha-img",
    attrs: {
      "src": __webpack_require__("Ec7t"),
      "alt": ""
    }
  }), _vm._v("\n            \t\t\t\t秒杀预告\n            \t\t\t\t"), _vm._v(" "), (_vm.nextBeginTime != '') ? _c('span', {
    staticClass: "miaosha-time"
  }, [_vm._v("\n                \t\t\t\t预计" + _vm._s(_vm.nextBeginTime.substr(0, 4)) + "年" + _vm._s(_vm.nextBeginTime.substr(4, 2)) + "月" + _vm._s(_vm.nextBeginTime.substr(6, 2)) + "日" + _vm._s(_vm.nextBeginTime.substr(8, 2)) + ":" + _vm._s(_vm.nextBeginTime.substr(10, 2)) + "开始\n                \t\t\t")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.goodsBo.productType == 'product' || _vm.goodsBo.productType == 'meterial') ? _c('h4', {
    staticClass: "goods_b",
    class: {
      "active": _vm.orderType === "spot", "disableColor": _vm.goodsBo.goodsNumber <= 10
    },
    on: {
      "click": function($event) {
        (_vm.goodsBo.goodsNumber > 10) ? _vm.changeTab('spot'): ''
      }
    }
  }, [_vm._v("现货")]) : _vm._e(), _vm._v(" "), (_vm.goodsBo.productType == 'product' || _vm.goodsBo.productType == 'sample') ? _c('h4', {
    staticClass: "goods_b",
    class: {
      "active": _vm.orderType === "custom"
    },
    on: {
      "click": function($event) {
        _vm.changeTab('custom')
      }
    }
  }, [_vm._v("订购")]) : _vm._e(), _vm._v(" "), (_vm.goodsBo.productType == 'product' || _vm.goodsBo.productType == 'sample') ? _c('h4', {
    staticClass: "goods_b",
    class: {
      "active": _vm.orderType === "proof"
    },
    on: {
      "click": function($event) {
        _vm.changeTab('proof')
      }
    }
  }, [_vm._v("打样")]) : _vm._e(), _vm._v(" "), (_vm.goodsBo.productType == 'meterial') ? _c('h4', {
    staticClass: "goods_b",
    class: {
      "active": _vm.orderType === "purchase"
    },
    on: {
      "click": function($event) {
        _vm.changeTab('purchase')
      }
    }
  }, [_vm._v("加工订购")]) : _vm._e(), _vm._v(" "), (_vm.orderType != 'purchase') ? _c('div', {
    staticClass: "sp-price"
  }, [(_vm.priceAreaJson != '') ? _c('div', {
    staticStyle: {
      "float": "left",
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [(_vm.orderType == 'spot') ? _c('dt', {
    staticClass: "item-3",
    staticStyle: {
      "width": "70px"
    }
  }, [_vm._v("价格 ")]) : _vm._e(), _vm._v(" "), (_vm.orderType != 'spot') ? _c('dt', {
    staticClass: "item-3",
    staticStyle: {
      "width": "70px"
    }
  }, [_vm._v("参考价格 ")]) : _vm._e(), _vm._v(" "), _c('dt', {
    staticClass: "item-3",
    staticStyle: {
      "width": "70px"
    }
  }, [_vm._v("数量 ")])]), _vm._v(" "), _vm._l((JSON.parse(_vm.priceAreaJson).orderPrice), function(orderPrice, index) {
    return (Array.isArray(JSON.parse(_vm.priceAreaJson).orderPrice)) ? _c('li', {
      staticStyle: {
        "float": "left"
      }
    }, [(index < (JSON.parse(_vm.priceAreaJson).orderPrice.length - 1)) ? _c('span', {
      staticClass: "co2"
    }, [_vm._v("￥"), _c('span', {
      staticClass: "f30 co2",
      class: {
        fb: (_vm.payNum >= parseInt(JSON.parse(_vm.priceAreaJson).orderNum[index]) && _vm.payNum < parseInt(JSON.parse(_vm.priceAreaJson).orderNum[index + 1]))
      }
    }, [_vm._v(_vm._s(orderPrice == 0 ? '暂无价格' : orderPrice))])]) : _vm._e(), _vm._v(" "), (index == (JSON.parse(_vm.priceAreaJson).orderPrice.length - 1)) ? _c('span', {
      staticClass: "co2"
    }, [_vm._v("￥"), _c('span', {
      staticClass: "f30 co2",
      class: {
        fb: _vm.payNum >= parseInt(JSON.parse(_vm.priceAreaJson).orderNum[index])
      }
    }, [_vm._v(_vm._s(orderPrice == 0 ? '暂无价格' : orderPrice))])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (index < (JSON.parse(_vm.priceAreaJson).orderPrice.length - 1)) ? _c('div', [_vm._v(_vm._s(JSON.parse(_vm.priceAreaJson).orderNum[index]) + "-" + _vm._s(JSON.parse(_vm.priceAreaJson).orderNum[index + 1] - 1) + "件")]) : _vm._e(), _vm._v(" "), (index == (JSON.parse(_vm.priceAreaJson).orderPrice.length - 1)) ? _c('div', [_vm._v("≥" + _vm._s(JSON.parse(_vm.priceAreaJson).orderNum[index]) + "件")]) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), (!Array.isArray(JSON.parse(_vm.priceAreaJson).orderPrice)) ? _c('li', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('span', {
    staticClass: "co2"
  }, [_vm._v("￥"), _c('span', {
    staticClass: "f30 co2 fb"
  }, [_vm._v(_vm._s(JSON.parse(_vm.priceAreaJson).orderPrice == 'null' || JSON.parse(_vm.priceAreaJson).orderPrice == 0 ? '暂无价格' : JSON.parse(_vm.priceAreaJson).orderPrice))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_vm._v("≥" + _vm._s(JSON.parse(_vm.priceAreaJson).orderNum) + "件")])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.orderType != 'spot' && _vm.priceAreaJson != '') ? _c('div', {
    staticClass: "co3"
  }, [_vm._v("需要后台业务员联系报价，才可正式下单.")]) : _vm._e(), _vm._v(" "), (_vm.priceAreaJson == '' && _vm.goodsPrice1 == 0) ? _c('div', {
    staticClass: "item-2 co2"
  }, [(_vm.isSpike == 'y') ? _c('span', {
    staticStyle: {
      "color": "#938a8c"
    }
  }, [_vm._v("秒杀价:")]) : _vm._e(), _vm._v(" "), ((_vm.brokerDiscountPersent == 0 || _vm.brokerDiscountPersent == 100) && _vm.seckillPrice == 0) ? _c('span', [_c('span', {
    staticClass: "co2"
  }, [(_vm.orderType != 'spot') ? _c('span', [_vm._v("参考价格：")]) : _vm._e()]), _vm._v("￥"), _c('span', {
    staticClass: "f30 fb co2"
  }, [_vm._v(_vm._s(_vm.goodsPrice == 0 ? '暂无价格' : _vm.goodsPrice))])]) : _vm._e(), _vm._v(" "), ((_vm.brokerDiscountPersent != 0 && _vm.brokerDiscountPersent != 100) || _vm.seckillPrice > 0) ? _c('span') : _vm._e(), _vm._v(" "), (_vm.brokerDiscountPersent != 0 && _vm.brokerDiscountPersent != 100 && _vm.seckillPrice == 0) ? _c('span', [_c('span', {
    staticClass: "co2"
  }, [_vm._v("￥"), _c('span', {
    staticClass: "f30 fb co2"
  }, [_vm._v(_vm._s(_vm.brokerPrice))])])]) : _vm._e(), _vm._v(" "), (_vm.seckillPrice > 0) ? _c('span', {
    staticClass: "f30 fb"
  }, [_vm._v("秒杀价：￥" + _vm._s((_vm.seckillPrice / 100).toFixed(2)))]) : _vm._e(), _vm._v(" "), (_vm.marketPrice > 0) ? _c('span', {
    staticClass: "zhe"
  }, [_vm._v(_vm._s(_vm.discount) + "折")]) : _vm._e(), _vm._v(" "), (_vm.goodsBo.rewardPointRate > 0 && (Math.floor(_vm.maxPrice * _vm.goodsBo.rewardPointRate / 100) > 0 || _vm.chooseGoodsPrice > 0) && (_vm.chooseGoodsPrice != '' ? Math.floor(_vm.chooseGoodsPrice * _vm.goodsBo.rewardPointRate / 100) : (Math.floor(_vm.minPrice * _vm.goodsBo.rewardPointRate / 100) + '-' + Math.floor(_vm.maxPrice * _vm.goodsBo.rewardPointRate / 100))) != 0) ? _c('span', {
    staticClass: "co_r mr10 f15",
    staticStyle: {
      "font-size": "0.6rem !important",
      "border": "1px red solid",
      "border-radius": "3px",
      "padding": "0 0.2rem 0 0.2rem"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t赠" + _vm._s(_vm.chooseGoodsPrice != '' ? Math.floor(_vm.chooseGoodsPrice * _vm.goodsBo.rewardPointRate / 100 / 100) : (Math.floor(_vm.minPrice * _vm.goodsBo.rewardPointRate / 100) + "-" + Math.floor(_vm.maxPrice * _vm.goodsBo.rewardPointRate / 100))) + "积分\n\t\t\t\t\t\t\t\t")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.priceAreaJson == '' && _vm.goodsPrice1 != 0) ? _c('div', {
    staticClass: "item-2 co2"
  }, [_c('span', {
    staticClass: "f14"
  }), _vm._v(" "), _c('span', {
    staticClass: "f30 fb"
  }, [_vm._v(_vm._s(_vm.goodsPrice1) + "\n\t\t\t\t\t\t\t\t\t"), (_vm.pointType == 'point') ? _c('span', [_vm._v("积分")]) : (_vm.pointType == 'special') ? _c('span', [_vm._v("专用积分")]) : (_vm.pointType == 'red') ? _c('span', [_vm._v("红积分")]) : (_vm.pointType == 'blue') ? _c('span', [_vm._v("蓝积分")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.orderType != 'spot' && _vm.priceAreaJson == '') ? _c('div', {
    staticClass: "co3"
  }, [_vm._v("需要后台业务员联系报价，才可正式下单")]) : _vm._e(), _vm._v(" "), (_vm.marketPrice > 0) ? _c('div', {
    staticClass: "item-3"
  }, [_vm._v("市场价："), _c('span', {
    staticClass: "cost-price"
  }, [_vm._v("￥" + _vm._s(_vm.marketPrice.toFixed(2)))]), _vm._v("（为您节省￥" + _vm._s(_vm.breaks) + " ）")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('dl', {
    staticClass: "sp-meta",
    class: {
      "top40": _vm.orderType === "purchase", "top140": _vm.orderType != "purchase"
    }
  }, [_vm._l((_vm.skuList), function(skuAttr, index_n) {
    return _c('div', [(skuAttr.skuName != null && skuAttr.skuName != '') ? _c('dt', [_vm._v(_vm._s(skuAttr.skuName) + "：")]) : _vm._e(), _vm._v(" "), (skuAttr.skuValue != null && skuAttr.skuValue != '') ? _c('dd', _vm._l((skuAttr.skuValue.split(',')), function(specItem, index) {
      return (specItem != null && specItem != '' && _vm.existsSku(specItem, index_n)) ? _c('a', {
        staticClass: "td-txt",
        class: {
          selected: specItem == _vm.skuList[index_n].skuChoosed
        },
        on: {
          "click": function($event) {
            specItem != _vm.skuList[index_n].skuChoosed && _vm.chooseSpec(specItem, index_n)
          }
        }
      }, [_vm._v(_vm._s(specItem))]) : _vm._e()
    })) : _vm._e()])
  }), _vm._v(" "), (_vm.orderType == 'purchase') ? _c('div', [(_vm.goodsDetail.orderQuantity != undefined && _vm.goodsDetail.orderQuantity > 0) ? _c('div', [_c('dt', [_vm._v("起订：")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.goodsDetail.orderQuantity) + "件")])]) : _vm._e(), _vm._v(" "), _c('div', [_c('dt', [_vm._v("原始价格：")]), _vm._v(" "), (_vm.chooseGoodsPrice != '') ? _c('dd', {
    staticStyle: {
      "color": "#EF920D"
    }
  }, [_vm._v(_vm._s(_vm.goodsPrice) + "元")]) : _vm._e(), _vm._v(" "), (_vm.minPrice > 0 && _vm.chooseGoodsPrice == '') ? _c('dd', {
    staticStyle: {
      "color": "#EF920D"
    }
  }, [_vm._v(_vm._s(_vm.minPrice) + "元"), (_vm.maxPrice > _vm.minPrice) ? _c('span', [_vm._v("  - " + _vm._s(_vm.maxPrice) + "元")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', [_c('dt', [_vm._v("生产数量：")]), _vm._v(" "), _c('dd', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.produceNum),
      expression: "produceNum"
    }],
    staticClass: "inpt",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "id": "produceNum",
      "type": "number",
      "onkeypress": "return(/[\\d]/.test(String.fromCharCode(event.keyCode)))",
      "min": "1"
    },
    domProps: {
      "value": (_vm.produceNum)
    },
    on: {
      "keyup": function($event) {
        _vm.setProduceNum()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.produceNum = $event.target.value
      }
    }
  }), _vm._v("  个")])]), _vm._v(" "), _c('div', [_c('dt', [_vm._v("验货方式")]), _vm._v(" "), _c('dd', _vm._l((_vm.inspectionTypes), function(ins, index) {
    return (ins.dictValue != '') ? _c('a', {
      staticClass: "td-txt",
      class: {
        selected: _vm.inspectionType == ins.dictValue
      },
      on: {
        "click": function($event) {
          _vm.chooseInspection(ins.dictValue)
        }
      }
    }, [_vm._v(_vm._s(ins.dictText))]) : _vm._e()
  }))])]) : _vm._e(), _vm._v(" "), (_vm.isLogin && (_vm.expressMode == 'weight' || _vm.expressMode == 'counter')) ? _c('dt', [_vm._v("配送至：")]) : _vm._e(), _vm._v(" "), (_vm.isLogin && (_vm.expressMode == 'weight' || _vm.expressMode == 'counter')) ? _c('dd', [_c('span', [_vm._v("配送至：")]), _vm._v(" "), _c('select', {
    staticClass: "city_select_css",
    attrs: {
      "id": "expressChage"
    },
    on: {
      "input": function($event) {
        _vm.expressChage()
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "北京市"
    }
  }, [_vm._v("北京")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "天津市"
    }
  }, [_vm._v("天津")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "河北省"
    }
  }, [_vm._v("河北")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "山西省"
    }
  }, [_vm._v("山西")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "内蒙古自治区"
    }
  }, [_vm._v("内蒙古")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "辽宁省"
    }
  }, [_vm._v("辽宁")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "吉林省"
    }
  }, [_vm._v("吉林")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "黑龙江省"
    }
  }, [_vm._v("黑龙江")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "上海市"
    }
  }, [_vm._v("上海")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "江苏省"
    }
  }, [_vm._v("江苏")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "浙江省"
    }
  }, [_vm._v("浙江")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "安徽省"
    }
  }, [_vm._v("安徽")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "福建省"
    }
  }, [_vm._v("福建")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "江西省"
    }
  }, [_vm._v("江西")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "山东省"
    }
  }, [_vm._v("山东")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "河南省"
    }
  }, [_vm._v("河南")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "湖北省"
    }
  }, [_vm._v("湖北")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "湖南省"
    }
  }, [_vm._v("湖南")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "广东省"
    }
  }, [_vm._v("广东")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "广西壮族自治区"
    }
  }, [_vm._v("广西")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "海南省"
    }
  }, [_vm._v("海南")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "重庆省"
    }
  }, [_vm._v("重庆")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "四川省"
    }
  }, [_vm._v("四川")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "贵州省"
    }
  }, [_vm._v("贵州")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "云南省"
    }
  }, [_vm._v("云南")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "西藏自治区"
    }
  }, [_vm._v("西藏")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "陕西省"
    }
  }, [_vm._v("陕西")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "甘肃省"
    }
  }, [_vm._v("甘肃")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "青海省"
    }
  }, [_vm._v("青海")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "宁夏回族自治区"
    }
  }, [_vm._v("宁夏")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "新疆维吾尔族自治区"
    }
  }, [_vm._v("新疆")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "香港特别行政区"
    }
  }, [_vm._v("香港")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "澳门特别行政区"
    }
  }, [_vm._v("澳门")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "台湾省"
    }
  }, [_vm._v("台湾")])])]) : _vm._e(), _vm._v(" "), _c('table', [(_vm.orderType == 'custom') ? _c('tr', [_vm._m(2), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customize_desc),
      expression: "customize_desc"
    }],
    attrs: {
      "rows": "5",
      "cols": "70"
    },
    domProps: {
      "value": (_vm.customize_desc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customize_desc = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.orderType == 'proof') ? _c('tr', [_vm._m(3), _c('td', [_c('table', {
    attrs: {
      "width": "80%"
    }
  }, [_vm._m(4), _vm._v(" "), _vm._l((_vm.partChangeList), function(partChange, k) {
    return _c('tr', [_c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (partChange.name),
        expression: "partChange.name"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          partChange.name = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, _vm._l((_vm.partTypes), function(ptType, index) {
      return (_vm.isPartShow(k, index)) ? _c('option', [_vm._v(_vm._s(ptType.dictValue))]) : _vm._e()
    }))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (partChange.value),
        expression: "partChange.value"
      }],
      staticClass: "inpt",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (partChange.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          partChange.value = $event.target.value
        }
      }
    }), _vm._v(" "), (k == 0) ? _c('a', {
      staticClass: "plus",
      on: {
        "click": function($event) {
          _vm.addPart()
        }
      }
    }, [_vm._v("+")]) : _vm._e(), _vm._v(" "), (k != 0) ? _c('a', {
      staticClass: "minus",
      on: {
        "click": function($event) {
          _vm.delPart(k)
        }
      }
    }, [_vm._v("-")]) : _vm._e()])])
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.orderType == 'proof' || _vm.orderType == 'purchase') ? _c('tr', [_c('td', [(_vm.orderType == 'proof') ? _c('dt', [_vm._v("打样备注")]) : _vm._e(), (_vm.orderType == 'purchase') ? _c('dt', [_vm._v("加工说明")]) : _vm._e()]), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remark),
      expression: "remark"
    }],
    attrs: {
      "rows": "5",
      "cols": "70"
    },
    domProps: {
      "value": (_vm.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.remark = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.orderType == 'proof' || _vm.orderType == 'purchase') ? _c('tr', [_vm._m(5), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "td-txt",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.change_input()
      }
    }
  }, [_vm._v("选择")]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "addTextForm"
    },
    on: {
      "change": function($event) {
        _vm.setImg($event)
      }
    }
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "0",
      "type": "file",
      "name": "style_picture"
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "1",
      "type": "file",
      "name": "style_picture"
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "2",
      "type": "file",
      "name": "style_picture"
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "3",
      "type": "file",
      "name": "style_picture"
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "4",
      "type": "file",
      "name": "style_picture"
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "img-wrapper"
    },
    on: {
      "click": function($event) {
        _vm.deleteImg($event)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "48%",
      "display": "none",
      "max-height": "200px"
    },
    attrs: {
      "src": "",
      "id": "img_0"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-width": "48%",
      "display": "none",
      "max-height": "200px"
    },
    attrs: {
      "src": "",
      "id": "img_1"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-width": "48%",
      "display": "none",
      "max-height": "200px"
    },
    attrs: {
      "src": "",
      "id": "img_2"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-width": "48%",
      "display": "none",
      "max-height": "200px"
    },
    attrs: {
      "src": "",
      "id": "img_3"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-width": "48%",
      "display": "none",
      "max-height": "200px"
    },
    attrs: {
      "src": "",
      "id": "img_4"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [((_vm.orderType == 'spot') && _vm.goodsDetail.printService > 0) ? _c('dt', [_vm._v("印刷服务:")]) : _vm._e()]), _vm._v(" "), ((_vm.orderType == 'spot') && _vm.goodsDetail.printService > 0) ? _c('td', [_c('a', {
    staticClass: "td-txt",
    class: {
      selected: _vm.printService != ''
    },
    on: {
      "click": function($event) {
        _vm.choosePrint(_vm.goodsDetail.printService)
      }
    }
  }, [_vm._v("印刷")]), _vm._v(_vm._s(_vm.goodsDetail.printService / 100) + "元/件\n                 \t\t\t\n                 \t\t")]) : _vm._e()]), _vm._v(" "), (_vm.orderType == 'purchase' || _vm.orderType == 'custom') ? _c('tr', [_c('td', [(_vm.goodsDetail.laserService > 0) ? _c('dt', [_vm._v("激光服务:")]) : _vm._e()]), _vm._v(" "), (_vm.goodsDetail.laserService > 0) ? _c('td', [_c('a', {
    staticClass: "td-txt",
    class: {
      selected: _vm.laserService != ''
    },
    on: {
      "click": function($event) {
        _vm.chooseLaster(_vm.goodsDetail.laserService)
      }
    }
  }, [_vm._v("激光")]), _vm._v(_vm._s(_vm.goodsDetail.laserService / 100) + "元/件\n\t\t\t\t\t\t")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.orderType == 'purchase' || _vm.orderType == 'custom') ? _c('tr', [_c('td', [(_vm.goodsDetail.printingService > 0) ? _c('dt', [_vm._v("印花服务:")]) : _vm._e()]), _vm._v(" "), (_vm.goodsDetail.printingService > 0) ? _c('td', [_c('a', {
    staticClass: "td-txt",
    class: {
      selected: _vm.printingService != ''
    },
    on: {
      "click": function($event) {
        _vm.choosePrinting(_vm.goodsDetail.printingService)
      }
    }
  }, [_vm._v("印花")]), _vm._v(_vm._s(_vm.goodsDetail.printingService / 100) + "元/件\n\t\t\t\t\t\t")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.orderType == 'purchase' || _vm.orderType == 'custom') ? _c('tr', [_c('td', [(_vm.goodsDetail.rebrandingService > 0) ? _c('dt', [_vm._v("换标服务:")]) : _vm._e()]), _vm._v(" "), (_vm.goodsDetail.rebrandingService > 0) ? _c('td', [_c('a', {
    staticClass: "td-txt",
    class: {
      selected: _vm.rebrandingService != ''
    },
    on: {
      "click": function($event) {
        _vm.chooseRebranding(_vm.goodsDetail.rebrandingService)
      }
    }
  }, [_vm._v("换标")]), _vm._v(_vm._s(_vm.goodsDetail.rebrandingService / 100) + "元/件\n\t\t\t\t\t\t")]) : _vm._e()]) : _vm._e(), _vm._v(" "), ((_vm.orderType == 'spot' || _vm.orderType == 'custom') && _vm.goodsDetail.qualityService != undefined && _vm.goodsDetail.qualityService != '') ? _c('tr', [_vm._m(6), _vm._v(" "), _c('td', _vm._l((_vm.qualitys), function(qua, index) {
    return (qua.dictValue == _vm.goodsDetail.qualityService) ? _c('span', [_vm._v(_vm._s(qua.dictText))]) : _vm._e()
  }))]) : _vm._e(), _vm._v(" "), ((_vm.orderType == 'spot' && _vm.goodsDetail.printService > 0) || _vm.orderType == 'custom' || _vm.orderType == 'proof') ? _c('tr', [_vm._m(7), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "td-txt",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.change_File()
      }
    }
  }, [_vm._v("选择")]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "addFileForm"
    },
    on: {
      "change": function($event) {
        _vm.setFile($event)
      }
    }
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "10",
      "type": "file",
      "name": "attachment"
    },
    on: {
      "change": function($event) {
        _vm.setFileName($event)
      }
    }
  }), _c('a', {
    staticClass: "minus",
    staticStyle: {
      "font-size": "20px",
      "display": "none"
    },
    attrs: {
      "id": "a_10"
    },
    on: {
      "click": function($event) {
        _vm.deleteFile($event)
      }
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "11",
      "type": "file",
      "name": "attachment"
    },
    on: {
      "change": function($event) {
        _vm.setFileName($event)
      }
    }
  }), _c('a', {
    staticClass: "minus",
    staticStyle: {
      "font-size": "20px",
      "display": "none"
    },
    attrs: {
      "id": "a_11"
    },
    on: {
      "click": function($event) {
        _vm.deleteFile($event)
      }
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "12",
      "type": "file",
      "name": "attachment"
    },
    on: {
      "change": function($event) {
        _vm.setFileName($event)
      }
    }
  }), _c('a', {
    staticClass: "minus",
    staticStyle: {
      "font-size": "20px",
      "display": "none"
    },
    attrs: {
      "id": "a_12"
    },
    on: {
      "click": function($event) {
        _vm.deleteFile($event)
      }
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "13",
      "type": "file",
      "name": "attachment"
    },
    on: {
      "change": function($event) {
        _vm.setFileName($event)
      }
    }
  }), _c('a', {
    staticClass: "minus",
    staticStyle: {
      "font-size": "20px",
      "display": "none"
    },
    attrs: {
      "id": "a_13"
    },
    on: {
      "click": function($event) {
        _vm.deleteFile($event)
      }
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "14",
      "type": "file",
      "name": "attachment"
    },
    on: {
      "change": function($event) {
        _vm.setFileName($event)
      }
    }
  }), _c('a', {
    staticClass: "minus",
    staticStyle: {
      "font-size": "20px",
      "display": "none"
    },
    attrs: {
      "id": "a_14"
    },
    on: {
      "click": function($event) {
        _vm.deleteFile($event)
      }
    }
  }, [_vm._v("-")])])])]) : _vm._e()]), _vm._v(" "), (_vm.orderType == 'purchase' || _vm.orderType == 'proof') ? _c('div', [_c('dt', [_vm._v("品质等级")]), _vm._v(" "), _c('dd', [_vm._l((_vm.qualitys), function(qua, index) {
    return (qua.dictValue != '') ? _c('a', {
      staticClass: "td-txt",
      class: {
        selected: _vm.quality == qua.dictValue
      },
      on: {
        "click": function($event) {
          _vm.chooseQuality(qua.dictValue)
        }
      }
    }, [_vm._v(_vm._s(qua.dictText))]) : _vm._e()
  }), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "href": "http://www.baomate.com/Baike/492.htm",
      "target": "_blank"
    }
  }, [_vm._v("质量标准及工艺要求")])], 2)]) : _vm._e(), _vm._v(" "), (_vm.orderType == 'spot' || _vm.orderType == 'custom' || _vm.orderType == 'proof') ? _c('dt', [_vm._v("数量：")]) : _vm._e(), _vm._v(" "), (_vm.orderType == 'spot' || _vm.orderType == 'custom' || _vm.orderType == 'proof') ? _c('dd', [_c('div', {
    staticClass: "hq-amount"
  }, [_c('span', {
    staticClass: "fl"
  }, [_c('a', {
    staticClass: "hq-amount-increase",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.subPayNum()
      }
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payNum),
      expression: "payNum"
    }],
    staticClass: "hq-amount-input",
    attrs: {
      "id": "payNum",
      "onkeypress": "return(/[\\d]/.test(String.fromCharCode(event.keyCode)))",
      "type": "number",
      "min": "1",
      "max": _vm.goodsNumber
    },
    domProps: {
      "value": (_vm.payNum)
    },
    on: {
      "keyup": function($event) {
        _vm.setPayNum()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payNum = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "hq-amount-decrease",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.addPayNum()
      }
    }
  }, [_vm._v("+")])]), _vm._v(" "), (_vm.orderType === 'spot') ? _c('span', {
    staticClass: "fl ml10"
  }, [_vm._v("库存" + _vm._s(_vm.goodsNumber) + "件 ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.goodsDetail.weight) ? _c('dt', [_vm._v("重量：")]) : _vm._e(), _vm._v(" "), (_vm.goodsDetail.weight) ? _c('dd', [_c('div', {
    staticClass: "hq-amount"
  }, [_c('span', {
    staticClass: "fl "
  }, [_vm._v(_vm._s(_vm.goodsDetail.weight))])])]) : _vm._e(), _vm._v(" "), _c('table', [(_vm.orderType == 'custom' || _vm.orderType == 'proof') ? _c('tr', [_vm._m(8), _vm._v(" "), _c('td', [_c('datepicker', {
    attrs: {
      "name": "begin_delivery_time",
      "type": "date",
      "readonly": true,
      "disabled-date": _vm.disabledDate
    },
    model: {
      value: (_vm.begin_delivery_time),
      callback: function($$v) {
        _vm.begin_delivery_time = $$v
      },
      expression: "begin_delivery_time"
    }
  })], 1)]) : _vm._e()])], 2), _vm._v(" "), (_vm.goodsBo.isDelete == 'Y') ? _c('div', {
    staticClass: "sp-action"
  }, [(_vm.orderType == 'proof') ? _c('a', {
    staticClass: "delisting-bccolor"
  }, [_vm._v("商品已过期")]) : _vm._e(), _vm._v(" "), (_vm.orderType == 'custom') ? _c('a', {
    staticClass: "delisting-bccolor"
  }, [_vm._v("商品已过期")]) : _vm._e(), _vm._v(" "), (_vm.orderType == 'spot') ? _c('a', {
    staticClass: "delisting-bccolor"
  }, [_vm._v("商品已过期")]) : _vm._e(), _vm._v(" "), (_vm.orderType == 'purchase') ? _c('a', {
    staticClass: "delisting-bccolor"
  }, [_vm._v("商品已过期")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.goodsBo.isDelete != 'Y') ? _c('div', {
    staticClass: "sp-action"
  }, [(_vm.orderType == 'proof') ? _c('span', [(_vm.vailUserFlag == true && _vm.userIsLogin == true) ? _c('a', {
    staticClass: "sp-link-buy",
    on: {
      "click": function($event) {
        _vm.customizeApply('proof')
      }
    }
  }, [_vm._v("打样申请")]) : _vm._e(), _vm._v(" "), (_vm.vailUserFlag == false && _vm.userIsLogin == true) ? _c('a', {
    staticClass: "sp-link-buy",
    on: {
      "click": function($event) {
        _vm.toEditUserInfo()
      }
    }
  }, [_vm._v("请完善信息")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.orderType == 'custom') ? _c('span', [(_vm.vailUserFlag == true && _vm.userIsLogin == true) ? _c('a', {
    staticClass: "sp-link-buy",
    on: {
      "click": function($event) {
        _vm.customizeApply('subscribe')
      }
    }
  }, [_vm._v("订购申请")]) : _vm._e(), _vm._v(" "), (_vm.vailUserFlag == false && _vm.userIsLogin == true) ? _c('a', {
    staticClass: "sp-link-buy",
    on: {
      "click": function($event) {
        _vm.toEditUserInfo()
      }
    }
  }, [_vm._v("请完善信息")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.userIsLogin == true && _vm.orderType == 'spot') ? _c('a', {
    class: {
      dactive: _vm.goodsNumber === 0, 'delisting-bccolor': _vm.goodsBo.shopGoodsStatus === 'delisting', 'sp-link-buy': _vm.goodsBo.shopGoodsStatus === 'listing'
    },
    on: {
      "click": function($event) {
        !_vm.isPreview && (_vm.goodsNumber > 0) && _vm.goodsBo.shopGoodsStatus == 'listing' && _vm.payOrder()
      }
    }
  }, [_vm._v(_vm._s(_vm.goodsBo.shopGoodsStatus == 'delisting' ? '已下架' : '立即下单'))]) : _vm._e(), _vm._v(" "), (_vm.userIsLogin == true && _vm.orderType == 'purchase') ? _c('a', {
    class: {
      'delisting-bccolor': _vm.goodsBo.shopGoodsStatus === 'delisting', 'sp-link-buy': _vm.goodsBo.shopGoodsStatus === 'listing'
    },
    on: {
      "click": function($event) {
        _vm.goodsBo.shopGoodsStatus == 'listing' && _vm.payOrder()
      }
    }
  }, [_vm._v(_vm._s(_vm.goodsBo.shopGoodsStatus == 'delisting' ? '已下架' : '采购下单'))]) : _vm._e(), _vm._v(" "), (_vm.userIsLogin == true && _vm.orderType == 'spot' && _vm.canAddToShoppingCart && _vm.distributeAccount == '' && _vm.goodsBo.shopGoodsStatus === 'listing' && _vm.seckillPrice == 0) ? _c('a', {
    staticClass: "sp-link-add",
    class: {
      dactive: _vm.goodsNumber === 0
    },
    on: {
      "click": function($event) {
        !_vm.isPreview && (_vm.goodsNumber > 0) && _vm.addToShoppingCart()
      }
    }
  }, [_c('i', {
    staticClass: "ico-cart-w"
  }), _vm._v("加入购物车")]) : _vm._e(), _vm._v(" "), (_vm.userIsLogin == false) ? _c('a', {
    staticClass: "sp-link-add",
    on: {
      "click": function($event) {
        _vm.toUserLogin()
      }
    }
  }, [_vm._v("请登录")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sp-other"
  }, [(_vm.goodsBo.isDelete != 'Y') ? _c('span', {
    staticClass: "mr40"
  }, [_c('i', {
    staticClass: "ico-sp-sc"
  }), _c('a', {
    staticClass: "co1",
    on: {
      "click": function($event) {
        !_vm.isPreview && _vm.addOrDeleteFavoriteGoods()
      }
    }
  }, [_vm._v(_vm._s(_vm.isExistFavoriteGoods == 0 ? '收藏' : '已收藏'))])]) : _vm._e(), _vm._v(" "), (_vm.goodsBo.seven_day_return == 'Y') ? _c('span', {
    staticClass: "co1"
  }, [_c('i', {
    staticClass: "ico-sp-tk"
  }), _vm._v("支持7天无理由退货服务")]) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "post_btmshare"
  }, [_c('span', {
    staticClass: "post_topshare_title"
  }, [_vm._v("分享到：")]), _vm._v(" "), _c('ul', {
    staticClass: "post_share"
  }, [_c('li', {
    staticClass: "share_weixin js_weixin",
    attrs: {
      "data-type": "btm"
    },
    on: {
      "click": function($event) {
        _vm.easyShare('weixin')
      }
    }
  }, [_vm._m(9)]), _vm._v(" "), _c('li', {
    staticClass: "share_qzone js_share",
    attrs: {
      "data-type": "qzone"
    },
    on: {
      "click": function($event) {
        _vm.easyShare('qzone')
      }
    }
  }, [_vm._m(10)]), _vm._v(" "), _c('li', {
    staticClass: "share_weibo js_share",
    attrs: {
      "data-type": "weibo"
    },
    on: {
      "click": function($event) {
        _vm.easyShare('weibo')
      }
    }
  }, [_vm._m(11)]), _vm._v(" "), _c('li', {
    staticClass: "share_pic js_share",
    attrs: {
      "data-type": "btm"
    },
    on: {
      "click": function($event) {
        _vm.easyShare('picqrcode')
      }
    }
  }, [_vm._m(12)])]), _vm._v(" "), _c('div', {
    staticClass: "js_qrcode_wrap",
    attrs: {
      "id": "js_qrcode_top"
    }
  }, [_c('div', {
    staticClass: "js_qrcode_arr"
  }), _vm._v(" "), _c('a', {
    staticClass: "js_qrcode_close",
    attrs: {
      "target": "_self",
      "data-type": "top",
      "title": "关闭"
    },
    on: {
      "click": _vm.closeqrcode
    }
  }), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('p', [_vm._v("用微信扫码二维码")]), _vm._v(" "), _c('p', [_vm._v("分享至好友和朋友圈")])]), _vm._v(" "), _c('div', {
    staticClass: "js_pic_qrcode_wrap",
    attrs: {
      "id": "js_picqrcode_top"
    }
  }, [_c('div', {
    staticClass: "js_qrcode_arr"
  }), _vm._v(" "), _c('a', {
    staticClass: "js_qrcode_close",
    attrs: {
      "target": "_self",
      "data-type": "top",
      "title": "关闭"
    },
    on: {
      "click": _vm.closepicqrcode
    }
  }), _vm._v(" "), _vm._m(14)])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    staticClass: "sp-side-wrap mt20"
  }, [_c('div', {
    staticClass: "hd"
  }, [_c('a', {
    staticClass: "refresh fr",
    on: {
      "click": function($event) {
        !_vm.isPreview && _vm.refreshGoods()
      }
    }
  }), _vm._v(" "), _c('h3', [_vm._v("猜你喜欢")])]), _vm._v(" "), _c('ul', _vm._l((_vm.recommendGoodsList), function(goodBo) {
    return _c('li', [_c('a', {
      staticClass: "fl pic",
      on: {
        "click": function($event) {
          _vm.goDetail(goodBo.goodsCode)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": goodBo.imgMiddle,
        "width": "106",
        "height": "106"
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "title"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.goDetail(goodBo.goodsCode)
        }
      }
    }, [_vm._v(_vm._s(goodBo.goodsName))])]), _vm._v(" "), _c('p', {
      staticClass: "price co2"
    }, [_vm._v("￥" + _vm._s((goodBo.unitPrice / 100).toFixed(2)))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "sp-dt-tab"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "bd"
  }, [_c('ul', {
    staticClass: "details-sp-cs"
  }, [_c('li', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("商品名称：" + _vm._s(_vm.goodsName))]), _vm._v(" "), (_vm.goodsDetail.brandName != null && _vm.goodsDetail.brandName != '') ? _c('li', [_vm._v("品牌： " + _vm._s(_vm.goodsDetail.brandName))]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v("商品编码：" + _vm._s(_vm.goodsCode))])]), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.goodsDetail.goodsVideo) ? _c('div', {
    staticStyle: {
      "height": "20rem"
    }
  }, [_c('video', {
    staticStyle: {
      "height": "20rem",
      "margin-left": "5.5rem"
    },
    attrs: {
      "controls": "controls",
      "width": "80%"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.imgPath + _vm.goodsDetail.goodsVideo
    }
  }), _vm._v("\n\t\t\t\t\t  Your browser does not support the video tag.\n\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "img-list",
    domProps: {
      "innerHTML": _vm._s(_vm.goodsDesc)
    }
  }, [_vm._v("\n                \t\t" + _vm._s(_vm.goodsDesc) + "\n              \t")])])]), _vm._v(" "), _c('div', {
    staticClass: "bd none"
  }, [_c('h4', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "ico-l"
  }), _vm._v("商品评价\n       \t  \t"), (_vm.goodRate != null) ? _c('div', {
    staticClass: "haopin"
  }, [_vm._v("好评率"), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.goodRate))]), _vm._v("%")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, _vm._l((_vm.creditList), function(credit, creditIdx) {
    return _c('div', {
      staticClass: "details-sp-pinjia"
    }, [_c('div', {
      staticClass: "details-sp-pinjia-col-1"
    }, [_c('p', {
      staticClass: "pinjia-ms"
    }, [_vm._v("\n                     \t       描述相符度："), _c('span', {
      class: 'sp-pj-star star' + credit.creditPoint
    }), _vm._v("\n                        \t发货速度："), _c('span', {
      class: 'sp-pj-star star' + credit.speedPoint
    }), _vm._v("\n                        \t服务态度："), _c('span', {
      class: 'sp-pj-star star' + credit.attitudePoint
    })]), _vm._v(" "), _c('p', {
      staticClass: "pinjia-con"
    }, [_vm._v(_vm._s(credit.content))]), _vm._v(" "), (credit.creditImgs != undefined && credit.creditImgs.length > 0) ? _c('div', {
      staticClass: "pinjia-img"
    }, _vm._l((credit.creditImgs), function(gI, imgIdx) {
      return _c('img', {
        attrs: {
          "alt": "",
          "bimg": gI,
          "src": gI,
          "width": "48",
          "height": "48"
        },
        on: {
          "click": function($event) {
            _vm.showImg(creditIdx, gI)
          }
        }
      })
    })) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "pinjia_scale_img",
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": creditIdx + '_div'
      }
    }, [_c('img', {
      attrs: {
        "id": creditIdx
      },
      on: {
        "click": function($event) {
          _vm.hideImg(creditIdx)
        }
      }
    })])]), _vm._v(" "), (credit.ext2 != undefined && credit.ext2 != '') ? _c('div', {
      staticClass: "details-sp-pinjia-col-1"
    }, [_c('p', {
      staticClass: "pinjia-con"
    }, [_c('span', {
      staticStyle: {
        "color": "#999"
      }
    }, [_vm._v("[追加评论]")]), _c('br'), _vm._v(_vm._s(credit.ext2))]), _vm._v(" "), (credit.appendImgs != undefined && credit.appendImgs.length > 0) ? _c('div', {
      staticClass: "pinjia-img"
    }, _vm._l((credit.appendImgs), function(gI_append, imgIdx) {
      return _c('img', {
        attrs: {
          "alt": "",
          "bimg": gI_append,
          "src": gI_append,
          "width": "48",
          "height": "48"
        },
        on: {
          "click": function($event) {
            _vm.showAppendImg(creditIdx, gI_append)
          }
        }
      })
    })) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "pinjia_scale_img",
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": creditIdx + '_append_div'
      }
    }, [_c('img', {
      attrs: {
        "id": creditIdx + '_append'
      },
      on: {
        "click": function($event) {
          _vm.hideAppendImg(creditIdx)
        }
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "details-sp-pinjia-col-2"
    }, [_c('p', {
      staticClass: "pj-user"
    }, [_c('span', [_vm._v("评价人：")]), _vm._v(" " + _vm._s(credit.buyerName) + "（匿名）")]), _vm._v(" "), _c('p', {
      staticClass: "pj-time"
    }, [_vm._v(_vm._s(credit.dataStr) + " ")])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "top",
    on: {
      "click": function($event) {
        _vm.scrollToTop()
      }
    }
  }, [_vm._m(17)])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('footermenu'), _vm._v(" "), _c('footercopyright')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "item"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("首页")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jqzoom-ico"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": __webpack_require__("9adc"),
      "width": "26",
      "height": "26"
    }
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('dt', [_vm._v("订购说明")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('dt', [_vm._v("打样要求")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("配件名称")]), _c('td', [_vm._v("调整说明")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('dt', [_vm._v("上传图片")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('dt', [_vm._v("品质等级:")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('dt', [_vm._v("附件")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('dt', [_vm._v("期望交期")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "target": "_self"
    }
  }, [_c('i', {
    attrs: {
      "title": "分享到微信"
    }
  }), _c('span'), _vm._v("微信")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "target": "_self"
    }
  }, [_c('i', {
    attrs: {
      "title": "分享到QQ空间"
    }
  }), _c('span'), _vm._v("QQ空间")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "target": "_self"
    }
  }, [_c('i', {
    attrs: {
      "title": "分享到新浪微博"
    }
  }), _c('span'), _vm._v("微博")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "target": "_self"
    }
  }, [_c('i', {
    attrs: {
      "title": "商品二维码"
    }
  }), _c('span'), _vm._v("二维码")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "js_qrcode_img js_share_qrcode",
    attrs: {
      "title": ""
    }
  }, [_c('canvas', {
    attrs: {
      "id": "canvas",
      "width": "120",
      "height": "120"
    }
  }), _c('img', {
    attrs: {
      "src": ""
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "js_qrcode_img js_share_qrcode",
    attrs: {
      "title": ""
    }
  }, [_c('canvas', {
    attrs: {
      "id": "picCanvas",
      "width": "220",
      "height": "220"
    }
  }), _c('img', {
    attrs: {
      "src": ""
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hd"
  }, [_c('ul', [_c('li', {
    staticClass: "hover"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("商品描述")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("商品评价")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "ico-l"
  }), _vm._v("产品详情")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('span', [_vm._v("TOP")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UEhY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__("ORbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TopBar__ = __webpack_require__("5PWk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Header__ = __webpack_require__("teIl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FooterMenu__ = __webpack_require__("gTlp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_FooterCopyright__ = __webpack_require__("3LwO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_HearderNav__ = __webpack_require__("7JIe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_api_api_js__ = __webpack_require__("fXcb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__static_js_flipclock_min_js__ = __webpack_require__("6RZS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__ = __webpack_require__("spYF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_mint_ui__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*引入Vue框架*/

/*引入资源请求插件*/

/*使用VueResource插件*/
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_11_mint_ui__["Swipe"].name, __WEBPACK_IMPORTED_MODULE_11_mint_ui__["Swipe"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_11_mint_ui__["SwipeItem"].name, __WEBPACK_IMPORTED_MODULE_11_mint_ui__["SwipeItem"]);

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'index',
	data: function data() {
		return {
			goodsList: [],
			catCode: 'categoryAll',
			interval: 'intervalAll',
			sortTime: 'timeAll',
			currentPage: 1,
			totalPage: 1,
			orderBy: '',
			orderAsc: '',
			shopCode: '',
			pageList: [1],
			totalItem: 0,
			sortParam: '',
			isInit: false,
			isLogin: false,
			isShow: false,
			account: '',
			contactUrl: '',
			loginUrl: '',
			registerUrl: '',
			logoutUrl: '',
			aboutUsUrl: '',
			indexUrl: '',
			showItem: 7
		};
	},

	components: {
		'topbar': __WEBPACK_IMPORTED_MODULE_3__components_TopBar__["a" /* default */],
		'sortHeader': __WEBPACK_IMPORTED_MODULE_4__components_Header__["a" /* default */],
		'footermenu': __WEBPACK_IMPORTED_MODULE_5__components_FooterMenu__["a" /* default */],
		'footercopyright': __WEBPACK_IMPORTED_MODULE_6__components_FooterCopyright__["a" /* default */],
		'heardernav': __WEBPACK_IMPORTED_MODULE_7__components_HearderNav__["a" /* default */]
	},
	methods: {
		jumpTo: function jumpTo(name) {
			this.$router.push({ name: name });
		},
		toGoodsDetail: function toGoodsDetail(goodsCode) {
			//this.$router.push({ name: 'goodsdetail', query:{goodsCode:goodsCode}});
			var routeData = this.$router.resolve({ path: '/goodsDetails', query: { goodsCode: goodsCode } });
			window.open(routeData.href, '_blank');
		},
		prePage: function prePage() {
			if (this.currentPage > 1) {
				this.currentPage = this.currentPage - 1;
				this.adjustPageArray(this.currentPage);
				this.getGoods();
			}
		},
		nextPage: function nextPage() {
			if (this.currentPage < this.totalPage) {
				this.currentPage = this.currentPage + 1;
				this.adjustPageArray(this.currentPage);
				this.getGoods();
			}
		},
		queryByPage: function queryByPage(page) {
			this.currentPage = page;
			this.adjustPageArray(this.currentPage);
			this.getGoods();
		},
		adjustPageArray: function adjustPageArray(page) {
			if (page == this.pageList[6] && page + 2 <= this.totalPage) {
				this.pageList.push(page + 1);
				this.pageList.push(page + 2);
				this.pageList.shift();
				this.pageList.shift();
			} else if (page == this.pageList[6] && page + 1 == this.totalPage) {
				this.pageList.push(page + 1);
				this.pageList.shift();
			} else if (page == this.pageList[0] && page >= 3) {
				this.pageList.unshift(page - 1);
				this.pageList.unshift(page - 2);
				this.pageList.pop();
				this.pageList.pop();
			} else if (page == this.pageList[0] && page == 2) {
				this.pageList.unshift(page - 1);
				this.pageList.pop();
			}
		},
		initPageArray: function initPageArray() {
			var pageList = new Array();
			var totalPage = this.totalPage;
			for (var i = 1; i <= totalPage; i++) {
				if (i <= this.showItem) {
					pageList.push(i);
				}
			}
			this.pageList = pageList;
		},
		getGoods: function getGoods() {
			var that = this;
			var interval = that.interval;
			var catCode = that.catCode;
			var isQueryAll = "n";
			var shopCode = that.shopCode;
			var cabinetId = "";
			var pageSize = 9;
			var currentPage = that.currentPage;
			var orderBy = that.orderBy;
			var orderAsc = that.orderAsc;
			var sortTime = that.sortTime;
			var goodsName = encodeURI(that.sortParam);
			var firstCatCode = "point_use_area";
			var brandId = that.brandId;
			var product_type = "";
			var order_type = "";
			__WEBPACK_IMPORTED_MODULE_8__static_api_api_js__["a" /* default */].getGoodsList(cabinetId, catCode, interval, currentPage, orderBy, orderAsc, shopCode, sortTime, pageSize, isQueryAll, goodsName, firstCatCode, brandId, product_type, order_type, function (ret) {
				if (ret.code == "success") {
					var goods = ret.data.goods;
					that.totalItem = ret.data.totalItem;
					var totalPage = ret.data.totalPage;
					if (totalPage != undefined && totalPage != 0 && totalPage != that.totalPage) {
						that.totalPage = ret.data.totalPage;
						that.initPageArray();
					} else if (totalPage != undefined) {
						that.totalPage = 1;
						that.initPageArray();
					}
					if (goods != undefined) {
						for (var i = 0; i < goods.length; i++) {
							//商品图片
							var imgMiddle = goods[i].imgMiddle;
							if (imgMiddle.indexOf(";") != -1) {
								imgMiddle = imgMiddle.split(";")[0];
							}
							imgMiddle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + imgMiddle;
							goods[i].imgMiddle = imgMiddle;
							goods[i].discountMoney = JSON.parse(goods[i].attrValue).discountMoney;

							if (firstCatCode == 'spike') {

								var marketPrice = JSON.parse(goods[i].attrValue).marketPrice;
								var saleTimeStr = JSON.parse(goods[i].attrValue).saleTimeShow;
								var saleEndTimeStr = JSON.parse(goods[i].attrValue).saleEndTimeShow;

								if (marketPrice != undefined && marketPrice != "") {
									goods[i].marketPrice = marketPrice;
								} else {
									goods[i].marketPrice = goods[i].unitPrice;
								}
								if (saleEndTimeStr != undefined && saleEndTimeStr != '') {
									saleEndTimeStr = saleEndTimeStr.replace(/-/g, "/");
									var saleEndDate = new Date(saleEndTimeStr);

									saleTimeStr = saleTimeStr.replace(/-/g, "/");
									var saleDate = new Date(saleTimeStr);

									//如果当期日期大于销售结束日期 xxx
									if (new Date() > saleEndDate) {
										goods[i].saleStatus = "end";
									} else if (new Date() < saleDate) {
										//如果当期时间小于上架时间，展示距离开始 时间
										goods[i].saleStatus = "wait_start";
										var begSeconds = saleDate.getTime() - new Date().getTime(); //时间差的毫秒数        
										//计算出相差天数  
										//  								var days=Math.floor(begSeconds/(24*3600*1000));  
										//计算出小时数  
										var leave1 = begSeconds % (24 * 3600 * 1000); //计算天数后剩余的毫秒数  
										var hours = Math.floor(begSeconds / (3600 * 1000));
										//计算相差分钟数  
										var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数  
										var minutes = Math.floor(leave2 / (60 * 1000));
										//计算相差秒数  
										var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数  
										var seconds = Math.round(leave3 / 1000);
										// 									goods[i].day=days;
										goods[i].hour = hours;
										goods[i].minute = minutes;
										goods[i].second = seconds;
									} else {
										goods[i].saleStatus = "on_sale";

										var begSeconds = saleEndDate.getTime() - new Date().getTime(); //时间差的毫秒数        
										//计算出相差天数  
										//  								var days=Math.floor(begSeconds/(24*3600*1000));  
										//计算出小时数  
										var leave1 = begSeconds % (24 * 3600 * 1000); //计算天数后剩余的毫秒数  
										var hours = Math.floor(begSeconds / (3600 * 1000));
										//计算相差分钟数  
										var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数  
										var minutes = Math.floor(leave2 / (60 * 1000));
										//计算相差秒数  
										var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数  
										var seconds = Math.round(leave3 / 1000);
										// 									goods[i].day=days;
										goods[i].hour = hours;
										goods[i].minute = minutes;
										goods[i].second = seconds;
									}
								}
							}
						}
					}
					that.goodsList = goods;
					if (!that.isInit) {
						that.isInit = true;
						that.initPageArray();
					}
				}
			});
		},
		shopCartShow: function shopCartShow() {
			this.isShow = true;
		},
		shopCartHide: function shopCartHide() {
			this.isShow = false;
		}
	},
	beforeDestroy: function beforeDestroy() {},
	mounted: function mounted() {
		window.scrollTo(0, 0);
		var account = localStorage.getItem("account");
		if (account != undefined && account != "") {
			this.isLogin = true;
			this.account = account;
		}
		this.userCenterUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/index/default.htm';
		this.loginUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/login.htm';
		this.registerUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/custm/user/user_reg_add.htm?formCode=MCHT_USER_FORM';
		this.logoutUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/logout.htm';
		this.aboutUsUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__["l" /* getAboutUsUrl */])();
		this.indexUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__["o" /* getIndexUrl */])();
		this.orderUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__["b" /* getEmallUrl */])() + '/orderManage/myOrderList.htm';
		this.getGoods();
	}
});

/***/ }),

/***/ "UfZE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V693":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {(function ($) {

		$.fn.jqueryzoom = function (options) {
				var settings = {
						xzoom: 400, //zoomed width default width
						yzoom: 400, //zoomed div default width
						offset: 10, //zoomed div default offset
						position: "right", //zoomed div default position,offset position is to the right of the image
						lens: 1, //zooming lens over the image,by default is 1;
						preload: 1
				};

				if (options) {
						$.extend(settings, options);
				}

				var noalt = '';
				$(this).hover(function () {

						var imageLeft = this.offsetLeft;
						var imageRight = this.offsetRight;
						var imageTop = $(this).get(0).offsetTop;
						var imageWidth = $(this).children('img').get(0).offsetWidth;
						var imageHeight = $(this).children('img').get(0).offsetHeight;

						noalt = $(this).children("img").attr("alt");

						var bigimage = $(this).children("img").attr("jqimg");

						$(this).children("img").attr("alt", '');

						if ($("div.zoomdiv").get().length == 0) {

								$(this).after("<div class='zoomdiv'><img class='bigimg' src='" + bigimage + "'/></div>");

								$(this).append("<div class='jqZoomPup'>&nbsp;</div>");
						}

						if (settings.position == "right") {

								if (imageLeft + imageWidth + settings.offset + settings.xzoom > screen.width) {

										leftpos = imageLeft - settings.offset - settings.xzoom;
								} else {

										leftpos = imageLeft + imageWidth + settings.offset;
								}
						} else {
								leftpos = imageLeft - settings.xzoom - settings.offset;
								if (leftpos < 0) {

										leftpos = imageLeft + imageWidth + settings.offset;
								}
						}

						$("div.zoomdiv").css({ top: imageTop, left: leftpos });

						$("div.zoomdiv").width(settings.xzoom);

						$("div.zoomdiv").height(settings.yzoom);

						$("div.zoomdiv").show();

						if (!settings.lens) {
								$(this).css('cursor', 'crosshair');
						}

						$(document.body).mousemove(function (e) {

								mouse = new MouseEvent(e);

								/*$("div.jqZoomPup").hide();*/

								var bigwidth = $(".bigimg").get(0).offsetWidth;

								var bigheight = $(".bigimg").get(0).offsetHeight;

								var scaley = 'x';

								var scalex = 'y';

								if (isNaN(scalex) | isNaN(scaley)) {

										var scalex = bigwidth / imageWidth;

										var scaley = bigheight / imageHeight;

										$("div.jqZoomPup").width(settings.xzoom / scalex);

										$("div.jqZoomPup").height(settings.yzoom / scaley);

										if (settings.lens) {
												$("div.jqZoomPup").css('visibility', 'visible');
										}
								}

								xpos = mouse.x - $("div.jqZoomPup").width() / 2 - imageLeft;

								ypos = mouse.y - $("div.jqZoomPup").height() / 2 - imageTop;

								if (settings.lens) {

										xpos = mouse.x - $("div.jqZoomPup").width() / 2 < imageLeft ? 0 : mouse.x + $("div.jqZoomPup").width() / 2 > imageWidth + imageLeft ? imageWidth - $("div.jqZoomPup").width() - 2 : xpos;

										ypos = mouse.y - $("div.jqZoomPup").height() / 2 < imageTop ? 0 : mouse.y + $("div.jqZoomPup").height() / 2 > imageHeight + imageTop ? imageHeight - $("div.jqZoomPup").height() - 2 : ypos;
								}

								if (settings.lens) {

										$("div.jqZoomPup").css({ top: ypos, left: xpos });
								}

								scrolly = ypos;

								$("div.zoomdiv").get(0).scrollTop = scrolly * scaley;

								scrollx = xpos;

								$("div.zoomdiv").get(0).scrollLeft = scrollx * scalex;
						});
				}, function () {

						$(this).children("img").attr("alt", noalt);
						$(document.body).unbind("mousemove");
						if (settings.lens) {
								$("div.jqZoomPup").remove();
						}
						$("div.zoomdiv").remove();
				});

				count = 0;

				if (settings.preload) {

						$('body').append("<div style='display:none;' class='jqPreload" + count + "'>sdsdssdsd</div>");

						$(this).each(function () {

								var imagetopreload = $(this).children("img").attr("jqimg");

								var content = jQuery('div.jqPreload' + count + '').html();

								jQuery('div.jqPreload' + count + '').html(content + '<img src=\"' + imagetopreload + '\">');
						});
				}
		};
})(jQuery);

function MouseEvent(e) {
		this.x = e.pageX;
		this.y = e.pageY;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "VND7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_address_vue__ = __webpack_require__("/z/Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48816669_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_address_vue__ = __webpack_require__("pTNH");
function injectStyle (ssrContext) {
  __webpack_require__("rIE/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-48816669"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_address_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48816669_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_address_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VUSJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_api_api_js__ = __webpack_require__("fXcb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_js_emallUtils_js__ = __webpack_require__("spYF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TopBar__ = __webpack_require__("5PWk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Header__ = __webpack_require__("teIl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FooterMenu__ = __webpack_require__("gTlp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ShopNav__ = __webpack_require__("hV6H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_FooterCopyright__ = __webpack_require__("3LwO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_js_alertConfirm_js__ = __webpack_require__("bCJ+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mint_ui_lib_style_css__ = __webpack_require__("d8/S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mint_ui_lib_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_mint_ui_lib_style_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













__WEBPACK_IMPORTED_MODULE_8_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_8_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_mint_ui___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'orderconfirm',
	data: function data() {
		return {
			boList: [],
			tradeCode: '',
			packageCode: '',
			sumAmount: 0,
			createTime: '',
			tradeCodes: '',
			goodsTotalPrice: {
				allAmount: 0,
				totalPoint: 0,
				totalRed: 0,
				totalBlue: 0,
				totalSpecial: 0,
				totalMoney: 0,
				totalExpressAmount: 0,
				brokerDiscountPersent: 0
			},
			orderList: []
		};
	},

	components: {
		'topbar': __WEBPACK_IMPORTED_MODULE_2__components_TopBar__["a" /* default */],
		'emallheader': __WEBPACK_IMPORTED_MODULE_3__components_Header__["a" /* default */],
		'footermenu': __WEBPACK_IMPORTED_MODULE_4__components_FooterMenu__["a" /* default */],
		'footercopyright': __WEBPACK_IMPORTED_MODULE_6__components_FooterCopyright__["a" /* default */]
	},
	methods: {

		getEmallTradeInfo: function getEmallTradeInfo(tradeCode) {

			var that = this;
			__WEBPACK_IMPORTED_MODULE_0__static_api_api_js__["a" /* default */].getTradeInfo(tradeCode, function (ret) {
				var ct = ret.data.gmtCreate + "";
				that.createTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__static_js_emallUtils_js__["r" /* dateFormat */])(ct);
			});
		},
		getEmallTradeInfoFromHt: function getEmallTradeInfoFromHt(tradeCode) {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_0__static_api_api_js__["a" /* default */].getTradeInfo(tradeCode, function (ret) {
				that.sumAmount = ((ret.data.moneyAmount + ret.data.expressAmount) / 100).toFixed(2);
				that.tradeCode = ret.data.tradeCode;
				var ct = ret.data.gmtCreate + "";
				that.createTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__static_js_emallUtils_js__["r" /* dateFormat */])(ct);
				that.boList.push(ret.data.orderList[0]);
				var order = {};
				order.goods_name = ret.data.orderList[0].goodsName;
				order.goods_number = ret.data.orderList[0].goodsNumber;
				order.trade_code = ret.data.orderList[0].tradeCode;
				that.orderList.push(order);
				that.packageCode = ret.data.packageCode;
				if (ret.data.pointAmount > 0 && ret.data.pointType == 'point') {
					that.goodsTotalPrice.totalPoint = ret.data.pointAmount * ret.data.goodsNumber + that.goodsTotalPrice.totalPoint;
				}
				if (ret.data.pointAmount > 0 && ret.data.pointType == 'red') {
					that.goodsTotalPrice.totalRed = ret.data.pointAmount * ret.data.goodsNumber + that.goodsTotalPrice.totalRed;
				}
				if (ret.data.pointAmount > 0 && ret.data.pointType == 'blue') {
					that.goodsTotalPrice.totalBlue = ret.data.pointAmount * ret.data.goodsNumber + that.goodsTotalPrice.totalBlue;
				}
				if (ret.data.pointAmount > 0 && ret.data.pointType == 'special') {
					that.goodsTotalPrice.totalSpecial = ret.data.pointAmount * ret.data.goodsNumber + that.goodsTotalPrice.totalSpecial;
				}
			});
		},
		payCQ: function payCQ(prodCode) {
			var that = this;
			var packageCode = that.packageCode;
			var tradeCodes = that.tradeCodes;
			if (tradeCodes == undefined || tradeCodes == '') {
				tradeCodes = that.tradeCode;
			}
			__WEBPACK_IMPORTED_MODULE_7__static_js_alertConfirm_js__["a" /* default */].alertConfirm("是否确定支付？", function () {
				//API.payPhysicalOrderCQMultiShop(packageCode,tradeCodes,prodCode,function(ret){
				__WEBPACK_IMPORTED_MODULE_0__static_api_api_js__["a" /* default */].payPhysicalOrderMultiShop(packageCode, tradeCodes, '0', prodCode, null, null, function (ret) {
					if (ret.code != null && ret.code == "redirect_pay_page") {
						//
						console.log(ret.data);
						//返回信息在层中进行显示，内容包含新跳转到双乾的支付网关页面
						jQuery("#shadowLayer").html(ret.data);
					} else if (ret.code != null && ret.code == "sandpay") {
						var responseText = ret.data;
						console.log("杉德支付证书：" + responseText);
						paymentjs.createPayment(responseText, function (result, err) {
							console.log(result);
							console.log(err.msg);
							console.log(err.extra);
						});
					} else if (ret.code != null && ret.code == "success") {
						that.$router.push({ name: 'paySuccess', params: {} });
					} else {
						__WEBPACK_IMPORTED_MODULE_7__static_js_alertConfirm_js__["a" /* default */].singleConfirm(ret.msg);
					}
				});
			});
			//});
		},
		//商城自有资金支付
		payEmall: function payEmall(prodCode, bankCode) {
			var that = this;
			var packageCode = that.packageCode;
			var tradeCodes = that.tradeCodes;
			if (tradeCodes == undefined || tradeCodes == '') {
				tradeCodes = that.tradeCode;
			}
			var isWeiXin = "N"; //是否在微信内支付
			__WEBPACK_IMPORTED_MODULE_7__static_js_alertConfirm_js__["a" /* default */].alertConfirm("是否确定支付？", function () {
				__WEBPACK_IMPORTED_MODULE_0__static_api_api_js__["a" /* default */].payPhysicalOrderMultiShop(packageCode, tradeCodes, '0', prodCode, bankCode, isWeiXin, function (ret) {
					debugger;
					if (ret.code != null && ret.code == "redirect_pay_page") {
						jQuery("#shadowLayer").html(ret.data);
					} else if (ret.code != null && ret.code == "sandpay") {
						var responseText = ret.data;
						console.log("杉德支付证书：" + responseText);
						paymentjs.createPayment(responseText, function (result, err) {
							console.log(result);
							console.log(err.msg);
							console.log(err.extra);
						});
					} else if (ret.code != null && ret.code == "success") {
						if (prodCode == "yunpay") {
							that.$router.push({ name: 'paySuccess', params: {} });
						} else if (prodCode == "yunpay_wx") {
							that.$router.push({ name: 'payScanQrcode', params: { code_url: ret.data.code_url, total_fee: ret.data.total_fee, package_code: ret.data.package_code } });
						}
					} else if (ret.code != null && ret.code == 'error') {
						__WEBPACK_IMPORTED_MODULE_7__static_js_alertConfirm_js__["a" /* default */].singleConfirm("支付失败！" + ret.msg);
					} else {
						__WEBPACK_IMPORTED_MODULE_7__static_js_alertConfirm_js__["a" /* default */].singleConfirm(ret.msg);
					}
				});
			});
		}
	},
	beforeMount: function beforeMount() {
		var that = this;
		if (this.$route.params.bos != undefined) {
			that.boList = this.$route.params.bos;
		}
		if (this.$route.params.sumAmount != undefined) {
			that.sumAmount = this.$route.params.sumAmount.toFixed(2);
		}
		if (this.$route.params.totalPoint != undefined) {
			that.goodsTotalPrice.totalPoint = this.$route.params.totalPoint;
		}
		if (this.$route.params.tradeCode != undefined) {
			var tradeCode = this.$route.params.tradeCode;
			that.tradeCode = tradeCode;
			this.getEmallTradeInfo(tradeCode);
		}
		if (this.$route.query.tradeCode != undefined) {
			var tradeCode = this.$route.query.tradeCode;
			that.getEmallTradeInfoFromHt(tradeCode);
		}
		if (this.$route.params.packageCode != undefined) {
			var packageCode = this.$route.params.packageCode;
			that.packageCode = packageCode;
		}
		if (this.$route.params.orderList != undefined) {
			that.orderList = this.$route.params.orderList;
			var orderList = that.orderList;
			for (var i = 0; i < orderList.length; i++) {
				if (i > 0) {
					that.tradeCodes += ",";
				}
				that.tradeCodes += orderList[i].trade_code;
			}
		}
	},
	mounted: function mounted() {
		window.scrollTo(0, 0);
		//	this.getEmallTradeInfo(this.tradeCode);
	}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "Vmyv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vwfw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_points_area_vue__ = __webpack_require__("UEhY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbe69e46_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_points_area_vue__ = __webpack_require__("/C53");
function injectStyle (ssrContext) {
  __webpack_require__("LV99")
  __webpack_require__("AH8N")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dbe69e46"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_points_area_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbe69e46_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_points_area_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WYKp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WYj9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shop_index"
  }, [_c('topbar'), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "hq-shop-banner"
  }, [_c('img', {
    attrs: {
      "src": _vm.bannerItem.mediaCode,
      "width": "1400",
      "height": "120"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "hq-shop-header"
  }, [_c('div', {
    staticClass: "w1200 bc bd"
  }, [_c('ul', {
    staticClass: "hq-shop-nav"
  }, [_vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "all-goods pr",
    on: {
      "mouseenter": function($event) {
        _vm.goodsCateShow()
      },
      "mouseleave": function($event) {
        _vm.goodsCateHidden()
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/shop_goods_list'
      }
    }
  }, [_vm._v("全部商品"), _c('i', {
    staticClass: "dp-ico-a-1"
  })]), _vm._v(" "), _c('ol', {
    staticClass: "categorys-dropdown none"
  }, _vm._l((_vm.catList), function(carBo, index) {
    return (index < 6) ? _c('li', [_c('router-link', {
      attrs: {
        "to": {
          path: '/shop_goods_list',
          query: {
            catCode: _vm.catBo.catCode,
            shopCode: _vm.shopCode
          }
        }
      }
    }, [_vm._v(_vm._s(_vm.catBo.catNameCn))])], 1) : _vm._e()
  }))], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "w1200 bc"
  }, [_c('div', {
    staticClass: "hq-dp-selector mt20"
  }, [_c('div', {
    staticClass: "hd"
  }, [_c('dl', [_c('dt', [_vm._v("已选条件：")]), _vm._v(" "), _c('dd', {
    attrs: {
      "id": "choosedCond"
    }
  }, _vm._l((_vm.choosedCondItem), function(condItem, index) {
    return _c('span', {
      staticClass: "checked-item",
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "condType": condItem.condType
      }
    }, [_vm._v(_vm._s(condItem.condName)), _c('a', {
      staticClass: "del",
      on: {
        "click": function($event) {
          _vm.removeCondition(index)
        }
      }
    })])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "bd"
  }, [_c('dl', [_c('dt', [_vm._v("价格：")]), _vm._v(" "), _c('dd', [_c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', 'intervalAll')
      }
    }
  }, [_vm._v("不限")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '0,10000')
      }
    }
  }, [_vm._v("1万以下")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '10000,20000')
      }
    }
  }, [_vm._v("1-2万")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '20000,30000')
      }
    }
  }, [_vm._v("2-3万")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '30000,50000')
      }
    }
  }, [_vm._v("3-5万")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '50000,100000')
      }
    }
  }, [_vm._v("5-10万")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '100000,200000')
      }
    }
  }, [_vm._v("10-20万")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '200000,500000')
      }
    }
  }, [_vm._v("20-50万")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '500000,1000000')
      }
    }
  }, [_vm._v("50-100万")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '1000000')
      }
    }
  }, [_vm._v("100万以上")])])]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("分类：")]), _vm._v(" "), _c('dd', [_c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'cat', 'categoryAll')
      }
    }
  }, [_vm._v("不限")]), _vm._v(" "), _vm._l((_vm.shopCatList), function(shopCat) {
    return _c('a', {
      on: {
        "click": function($event) {
          _vm.chooseCondition($event, 'cat', 'shopCat.catCode')
        }
      }
    }, [_vm._v(_vm._s(shopCat.catNameCn))])
  })], 2)]), _vm._v(" "), _c('dl', {
    staticClass: "b-n"
  }, [_c('dt', [_vm._v("发布时间：")]), _vm._v(" "), _c('dd', [_c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'timeAll')
      }
    }
  }, [_vm._v("不限")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'oneDay')
      }
    }
  }, [_vm._v("一天内")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'twoDay')
      }
    }
  }, [_vm._v("两天内")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'oneWeek')
      }
    }
  }, [_vm._v("一周内")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'oneMonth')
      }
    }
  }, [_vm._v("一月内")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "shop-tabbox-1 shop-jp-tj"
  }, [_c('div', {
    staticClass: "hd hd-2"
  }, [_c('div', {
    staticClass: "pro-tool-2 fr"
  }, [_c('ul', [_c('li', {
    class: {
      "hover": _vm.sortCondition === "defaultSort"
    },
    on: {
      "click": function($event) {
        _vm.sortGoods('defaultSort')
      }
    }
  }, [_vm._v("默认")]), _vm._v(" "), _c('li', {
    class: {
      "hover": _vm.sortCondition === "saleAmount"
    },
    on: {
      "click": function($event) {
        _vm.sortGoods('saleAmount')
      }
    }
  }, [_vm._v("销量"), _c('i', {
    class: {
      "up": _vm.sortSaleAmount == "asc"
    }
  })]), _vm._v(" "), _c('li', {
    class: {
      "hover": _vm.sortCondition === "publishTime"
    },
    on: {
      "click": function($event) {
        _vm.sortGoods('publishTime')
      }
    }
  }, [_vm._v("发布时间"), _c('i', {
    class: {
      "up": _vm.sortPublishTime == "asc"
    }
  })]), _vm._v(" "), _c('li', {
    class: {
      "hover": _vm.sortCondition === "price"
    },
    on: {
      "click": function($event) {
        _vm.sortGoods('price')
      }
    }
  }, [_vm._v("价格"), _c('i', {
    class: {
      "up": _vm.sortPrice == "asc"
    }
  })])])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "bd"
  }, [_c('ul', _vm._l((_vm.shopGoodsItems), function(good) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(good.goodsCode)
        }
      }
    }, [_c('p', {
      staticClass: "pic tc"
    }, [_c('a', [_c('img', {
      attrs: {
        "src": good.imgMiddle,
        "width": "265",
        "height": "265"
      }
    })])]), _vm._v(" "), _c('p', {
      staticClass: "title"
    }, [_c('a', [_vm._v(_vm._s(good.goodsName))])]), _vm._v(" "), _c('p', {
      staticClass: "other"
    }, [_c('span', {
      staticClass: "price"
    }, [_vm._v("¥" + _vm._s(good.unitPrice))])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "dp-pages tc"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.prePage()
      }
    }
  }, [_vm._v(" < ")]), _vm._v(" "), _vm._l((_vm.pageList), function(page) {
    return _c('a', {
      class: {
        "current_page": _vm.currentPage === page
      },
      on: {
        "click": function($event) {
          _vm.queryByPage(page)
        }
      }
    }, [_vm._v(_vm._s(page))])
  }), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.nextPage()
      }
    }
  }, [_vm._v(" > ")])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('footermenu'), _vm._v(" "), _c('footercopyright')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "hover"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("首页")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', {
    staticClass: "hover"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("全部商品")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb20 ad-4 mt20"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("dlf8"),
      "width": "1200",
      "height": "60"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Wblp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShopSlider_vue__ = __webpack_require__("ZLEC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d92fa60_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ShopSlider_vue__ = __webpack_require__("6Y+c");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShopSlider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d92fa60_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ShopSlider_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WiJr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TopBar__ = __webpack_require__("5PWk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_EmallHeader__ = __webpack_require__("3w6z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterMenu__ = __webpack_require__("gTlp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FooterCopyright__ = __webpack_require__("3LwO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ShopNav__ = __webpack_require__("hV6H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ShopSlider__ = __webpack_require__("Wblp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_FooterSlogan__ = __webpack_require__("8iXI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_js_emallUtils_js__ = __webpack_require__("spYF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_router__ = __webpack_require__("/ocq");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









//import jQuery from "../../../static/js/jquery.min.js"



__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_router__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = ({
		name: 'shop_goods_list',
		data: function data() {
				return {
						shopGoodsItems: [],
						bannerItem: {},
						shopCatList: '',
						sortCondition: 'defaultSort',
						sortSaleAmount: '',
						sortPublishTime: '',
						sortPrice: '',
						choosedCondItem: [],
						catCode: 'categoryAll',
						interval: 'intervalAll',
						sortTime: 'timeAll',
						currentPage: 1,
						totalPage: 1,
						orderBy: '',
						orderAsc: '',
						shopCode: '',
						pageList: []
				};
		},

		components: {
				'topbar': __WEBPACK_IMPORTED_MODULE_0__components_TopBar__["a" /* default */],
				'emallheader': __WEBPACK_IMPORTED_MODULE_1__components_EmallHeader__["a" /* default */],
				'footermenu': __WEBPACK_IMPORTED_MODULE_2__components_FooterMenu__["a" /* default */],
				'footercopyright': __WEBPACK_IMPORTED_MODULE_3__components_FooterCopyright__["a" /* default */],
				'shopnav': __WEBPACK_IMPORTED_MODULE_4__components_ShopNav__["a" /* default */],
				'shopslider': __WEBPACK_IMPORTED_MODULE_5__components_ShopSlider__["a" /* default */],
				'footerslogan': __WEBPACK_IMPORTED_MODULE_6__components_FooterSlogan__["a" /* default */]

		},
		methods: {
				toGoodsDetail: function toGoodsDetail(goodsCode) {
						this.$router.push({ name: 'goodsdetail', query: { goodsCode: goodsCode } });
				},
				prePage: function prePage() {
						if (this.currentPage > 1) {
								this.currentPage = this.currentPage - 1;
								this.getShopGoods();
						}
				},
				nextPage: function nextPage() {
						if (this.currentPage < this.totalPage) {
								this.currentPage = this.currentPage + 1;
								this.getShopGoods();
						}
				},
				queryByPage: function queryByPage(page) {
						this.currentPage = page;
						this.getShopGoods();
				},
				chooseCondition: function chooseCondition(event, type, sortParams) {
						var condText = event.target.innerText;
						var choosedCondText = this.$refs.choosed_cond.innerText;

						var condText = event.target.innerText;
						if (condText != "不限") {
								var condText = event.target.innerText;
								if (__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#choosedCond").find("span[condType='" + type + "']").length != 0) {
										__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#choosedCond").find("span[condType='" + type + "']").remove();
								}
								this.choosedCondItem.push({ condName: condText, condType: type });
						} else {
								__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#choosedCond").find("span[condType='" + type + "']").remove();
						}
						if (type == 'amount') {
								this.interval = sortParams;
						} else if (type == 'cat') {
								this.catCode = sortParams;
						} else if (type == 'time') {
								this.sortTime = sortParams;
						}
						this.getShopGoods();
				},
				removeCondition: function removeCondition(index) {
						this.choosedCondItem.splice(index, 1);
				},
				sortGoods: function sortGoods(sortCondition) {
						this.sortCondition = sortCondition;
						if (sortCondition == "saleAmount") {
								this.orderBy = "sale_number";
								if (this.sortSaleAmount == '') {
										this.sortSaleAmount = "desc";
								} else if (this.sortSaleAmount == 'desc') {
										this.sortSaleAmount = "asc";
								} else if (this.sortSaleAmount == 'asc') {
										this.sortSaleAmount = "desc";
								}
								this.orderAsc = this.sortSaleAmount;
						}
						if (sortCondition == "publishTime") {
								this.orderBy = "gmt_create";
								if (this.sortPublishTime == '') {
										this.sortPublishTime = "desc";
								} else if (this.sortPublishTime == 'desc') {
										this.sortPublishTime = "asc";
								} else if (this.sortPublishTime == 'asc') {
										this.sortPublishTime = "desc";
								}
								this.orderAsc = this.sortPublishTime;
						}
						if (sortCondition == "price") {
								this.orderBy = "unit_price";
								if (this.sortPrice == '') {
										this.sortPrice = "desc";
								} else if (this.sortPrice == 'desc') {
										this.sortPrice = "asc";
								} else if (this.sortPrice == 'asc') {
										this.sortPrice = "desc";
								}
								this.orderAsc = this.sortPrice;
						}
						if (sortCondition == "defaultSort") {
								this.orderBy = "";
								this.orderAsc = "";
						}
						this.getShopGoods();
				},
				goodsCateShow: function goodsCateShow() {
						$(".categorys-dropdown").show();
				},
				goodsCateHidden: function goodsCateHidden() {
						$(".categorys-dropdown").hide();
				},
				getShopInfo: function getShopInfo() {
						var that = this;
						var shopCode = that.shopCode;
						this.$http.jsonp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__static_js_emallUtils_js__["q" /* getAjaxUrl */])() + "/shop/ajax_shop.json", {
								params: {
										shopCode: shopCode
								},
								jsonp: 'callback'
						}).then(function (res) {
								if (res.body.code == "success") {
										var adsList = res.body.data.adsList;

										if (adsList != undefined) {
												var sliderItems = new Array();
												for (var i = 0; i < adsList.length; i++) {
														adsList[i].mediaCode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + adsList[i].mediaCode;
														if (adsList[i].adsType == "slider") {
																sliderItems.push(adsList[i]);
														} else if (adsList[i].adsType == "banner") {
																that.bannerItem = adsList[i];
														} else if (adsList[i].adsType == "inner_ads") {
																that.adsItem = adsList[i];
														} else if (adsList[i].adsType == "bottom_slogen") {
																that.bottomAdsItem = adsList[i];
														}
												}
												that.sliderItems = sliderItems;
										}
								}
						}, function () {});
				},
				getShopGoods: function getShopGoods() {
						var that = this;
						var interval = that.interval;
						var catCode = that.catCode;
						var cabinetId = "";
						var pageSize = 8;
						var currentPage = that.currentPage;
						var orderBy = that.orderBy;
						var orderAsc = that.orderAsc;
						var shopCode = that.shopCode;
						var sortTime = that.sortTime;
						this.$http.jsonp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__static_js_emallUtils_js__["q" /* getAjaxUrl */])() + "/goods/ajax_goods_list.json", {
								params: {
										cabinetId: cabinetId,
										catCode: catCode,
										interval: interval,
										currentPage: currentPage,
										orderBy: orderBy,
										orderAsc: orderAsc,
										shopCode: shopCode,
										sortTime: sortTime,
										pageSize: pageSize
								},
								jsonp: 'callback'
						}).then(function (res) {
								if (res.body.code == "success") {
										var goods = res.body.data.goods;
										var totalPage = res.body.data.totalPage;
										that.totalPage = totalPage;
										var pageList = new Array();
										for (var i = 1; i <= totalPage; i++) {
												pageList.push(i);
										}
										that.pageList = pageList;
										for (var i = 0; i < goods.length; i++) {
												//商品图片
												var imgMiddle = goods[i].imgMiddle; // 图片
												if (imgMiddle.indexOf(";") != -1) {
														imgMiddle = imgMiddle.split(";")[0];
												}
												imgMiddle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + imgMiddle;
												goods[i].imgMiddle = imgMiddle;
												goods[i].unitPrice = goods[i].unitPrice / 100;
										}
										that.shopGoodsItems = goods;
								} else {}
						}, function () {});
				},
				getShopCat: function getShopCat() {
						var that = this;
						var shopCode = that.shopCode;
						var isShow = "y";
						var isLeaf = "y";
						this.$http.jsonp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__static_js_emallUtils_js__["q" /* getAjaxUrl */])() + "/shop/ajax_shop_cat.json", {
								params: {
										shopCode: shopCode,
										isShow: isShow,
										isLeaf: isLeaf
								},
								jsonp: 'callback'
						}).then(function (res) {
								if (res.body.code == "success") {
										var shopCatList = res.body.data.shopCatList;
										that.shopCatList = shopCatList;
								} else {}
						}, function () {});
				}
		},
		mounted: function mounted() {
				window.scrollTo(0, 0);
				var catCode = this.$route.query.catCode;
				var shopCode = this.$route.query.shopCode;
				if (catCode != undefined) {
						this.catCode = catCode;
				}
				if (shopCode != undefined) {
						this.shopCode = shopCode;
				}
				this.getShopInfo();
				this.getShopGoods();
				this.getShopCat();
		}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "XWWZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TopBar__ = __webpack_require__("5PWk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Header__ = __webpack_require__("teIl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterMenu__ = __webpack_require__("gTlp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ShopNav__ = __webpack_require__("hV6H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FooterCopyright__ = __webpack_require__("3LwO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_js_emallUtils_js__ = __webpack_require__("spYF");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'orderpaysuccess',
	components: {
		'topbar': __WEBPACK_IMPORTED_MODULE_0__components_TopBar__["a" /* default */],
		'emallheader': __WEBPACK_IMPORTED_MODULE_1__components_Header__["a" /* default */],
		'footermenu': __WEBPACK_IMPORTED_MODULE_2__components_FooterMenu__["a" /* default */],
		'footercopyright': __WEBPACK_IMPORTED_MODULE_4__components_FooterCopyright__["a" /* default */]
	},
	methods: {
		jumpToOrderList: function jumpToOrderList() {
			window.location.href = __WEBPACK_IMPORTED_MODULE_5__static_js_emallUtils_js__["d" /* ajaxUrl */] + "/orderManage/myOrderList.htm";
		}
	}
});

/***/ }),

/***/ "YWuJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "indexbg"
  }, [_c('topbar'), _vm._v(" "), _c('header'), _vm._v(" "), _c('emallheader', {
    ref: "eh"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear mt15"
  }), _vm._v(" "), _c('div', {
    staticClass: "w1200 bc"
  }, [_c('div', {
    staticClass: "hq-shopping-cart"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "bd-box buycart-list mt20"
  }, [_c('div', {
    staticClass: "hd"
  }, [_c('dl', [_c('dt', {
    staticClass: "col-1"
  }, [_c('input', {
    attrs: {
      "id": "allCheck",
      "name": "",
      "type": "checkbox",
      "value": ""
    },
    on: {
      "click": function($event) {
        _vm.checkAll()
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "allCheck"
    }
  }, [_vm._v("全选")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('dt', {
    staticClass: "col-3"
  }, [_vm._v("单价")]), _vm._v(" "), _c('dt', {
    staticClass: "col-4"
  }, [_vm._v("数量")]), _vm._v(" "), _c('dt', {
    staticClass: "col-5"
  }, [_vm._v("总价")]), _vm._v(" "), _c('dt', {
    staticClass: "col-6"
  }, [_vm._v("操作")])])]), _vm._v(" "), _c('div', {
    staticClass: "bd"
  }, [(_vm.shopBoList.length == 0) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "font-size": "20px"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t购物车空空如也，去"), _c('router-link', {
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("购物")]), _vm._v("吧！\n\t\t\t\t\t\t")], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.shopBoList), function(shop, index) {
    return _c('div', {
      staticClass: "items"
    }, _vm._l((shop.boListIn), function(bo, boIndex) {
      return (bo) ? _c('dl', {
        attrs: {
          "id": bo.goodsCode + '_cart_pro'
        }
      }, [(bo.isDelete == 'Y') ? _c('dd', {
        staticClass: "col-1"
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t已过期\n\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (bo.isDelete != 'Y') ? _c('dd', {
        staticClass: "col-1"
      }, [_c('input', {
        attrs: {
          "name": "goodsCheckBox",
          "id": bo.goodsCode + '_chbox',
          "type": "checkbox",
          "disabled": bo.goodsStatus != 'listing' || bo.isExpired == 'y',
          "goodsId": bo.id,
          "goodsCode": bo.goodsCode,
          "goodsName": bo.goodsName,
          "specName": bo.specName
        },
        on: {
          "click": function($event) {
            _vm.chooseGoods($event)
          }
        }
      })]) : _vm._e(), _vm._v(" "), _c('dd', {
        staticClass: "col-2",
        staticStyle: {
          "position": "relative"
        }
      }, [_c('a', {
        staticClass: "pic fl",
        attrs: {
          "href": "#"
        }
      }, [_c('img', {
        attrs: {
          "src": bo.imgSmall,
          "width": "118",
          "height": "100"
        },
        on: {
          "click": function($event) {
            _vm.toDetail(bo.goodsCode)
          }
        }
      })]), _vm._v(" "), _c('p', {
        staticClass: "title"
      }, [_c('a', {
        staticClass: "co-b-2 name",
        class: {
          'delisting-color': (bo.goodsStatus == 'delisting' || bo.isExpired == 'y')
        },
        on: {
          "click": function($event) {
            _vm.toDetail(bo.goodsCode)
          }
        }
      }, [_vm._v(_vm._s(bo.goodsName))])]), _vm._v(" "), (bo.goodsStatus == 'delisting') ? _c('div', {
        staticStyle: {
          "position": "absolute",
          "top": "50px",
          "left": "200px"
        }
      }, [_c('img', {
        attrs: {
          "src": __webpack_require__("B9hn"),
          "width": "80",
          "height": "80"
        }
      })]) : _vm._e(), _vm._v(" "), (bo.isExpired == 'y') ? _c('div', {
        staticStyle: {
          "position": "absolute",
          "top": "50px",
          "left": "200px"
        }
      }, [_c('img', {
        attrs: {
          "src": __webpack_require__("vpJu"),
          "width": "80",
          "height": "80"
        }
      })]) : _vm._e(), _vm._v(" "), _c('div', {
        staticStyle: {
          "position": "absolute",
          "top": "70px",
          "left": "142px"
        }
      }, [_c('span', {
        staticClass: "co1"
      }, [_vm._v(_vm._s(bo.specName))])]), _vm._v(" "), (bo.seven_day_return == 'Y') ? _c('div', {
        staticStyle: {
          "position": "absolute",
          "top": "90px",
          "left": "142px"
        }
      }, [_vm._m(2, true)]) : _vm._e()]), _vm._v(" "), (bo.goodsPrice > 0) ? _c('dd', {
        staticClass: "col-3 co-r-1 f14",
        class: {
          'delisting-color': (bo.goodsStatus == 'delisting' || bo.isExpired == 'y')
        },
        attrs: {
          "id": bo.id + '_price'
        }
      }, [_vm._v(_vm._s(bo.goodsPrice) + "积分")]) : _c('dd', {
        staticClass: "col-3 co-r-1 f14",
        class: {
          'delisting-color': (bo.goodsStatus == 'delisting' || bo.isExpired == 'y')
        },
        attrs: {
          "id": bo.id + '_price'
        }
      }, [_vm._v("￥" + _vm._s(bo.unitPrice))]), _vm._v(" "), _c('dd', {
        staticClass: "col-4"
      }, [_c('div', {
        staticClass: "item-amount"
      }, [_c('a', {
        staticClass: "minus",
        on: {
          "click": function($event) {
            _vm.subPayNum(bo.id, bo.goodsCode)
          }
        }
      }, [_vm._v("-")]), _vm._v(" "), _c('input', {
        staticClass: "text-amount",
        attrs: {
          "id": bo.id + '_goods_number',
          "onkeypress": "return(/[\\d]/.test(String.fromCharCode(event.keyCode)))",
          "min": "1",
          "max": bo.goodsStock,
          "type": "text"
        },
        domProps: {
          "value": bo.goodsNumber
        },
        on: {
          "keyup": function($event) {
            _vm.setPayNum(bo.id, bo.goodsCode, bo.goodsStock)
          }
        }
      }), _vm._v(" "), _c('a', {
        staticClass: "plus",
        on: {
          "click": function($event) {
            _vm.addPayNum(bo.id, bo.goodsCode)
          }
        }
      }, [_vm._v("+")])])]), _vm._v(" "), _c('dd', {
        staticClass: "col-5 co-r-1 f14",
        class: {
          'delisting-color': (bo.goodsStatus == 'delisting' || bo.isExpired == 'y')
        },
        attrs: {
          "id": bo.id + '_unitPrice',
          "name": "unitPrice"
        }
      }, [_vm._v(_vm._s(bo.ext1))]), _vm._v(" "), _c('dd', {
        staticClass: "col-6 co-r-1 f12"
      }, [_c('a', {
        on: {
          "click": function($event) {
            _vm.deleteGoods(bo.id, bo.goodsCode, index)
          }
        }
      }, [_vm._v("删除")])])]) : _vm._e()
    }))
  }), _vm._v(" "), _c('div', {
    staticClass: "total tr co5"
  }, [_c('ul', [_c('li', {
    staticClass: "fr"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t已选 "), _c('span', {
    staticClass: "co-o-1 f18",
    attrs: {
      "id": "selectedCount"
    }
  }, [_vm._v("0")]), _vm._v(" 件商品 合计（不含手续费）：\n\t\t\t\t\t\t\t\t\t"), _c('span', {
    staticClass: "co-o-1 f18",
    attrs: {
      "id": "sumPay"
    }
  }, [_vm._v("￥0.00")]), _vm._v(" "), (_vm.saveMoney > 0) ? _c('span', [_vm._v("已节省")]) : _vm._e(), (_vm.saveMoney > 0) ? _c('span', {
    staticClass: "co-o-1 f16"
  }, [_vm._v("￥" + _vm._s(_vm.saveMoney))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "ml20"
  }, [_c('input', {
    staticClass: "a-btn-c-2",
    attrs: {
      "name": "",
      "type": "button",
      "value": "去结算"
    },
    on: {
      "click": function($event) {
        _vm.doSettle()
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ml20"
  }, [_c('input', {
    staticClass: "a-btn-c-2",
    attrs: {
      "name": "",
      "type": "button",
      "value": "清空购物车"
    },
    on: {
      "click": function($event) {
        _vm.deleteCart()
      }
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "co-b-2 f14 fr ml20",
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("继续购物>>")])], 1)])])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('footermenu'), _vm._v(" "), _c('footercopyright')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hq-reg-step"
  }, [_c('ul', {
    staticClass: "ico"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('p', {
    staticClass: "item"
  }, [_vm._v("购物车")]), _vm._v(" "), _c('i', {
    staticClass: "step-count"
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "line"
  })]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "item"
  }, [_vm._v("提交订单")]), _vm._v(" "), _c('i', {
    staticClass: "step-count"
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "line"
  })]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "item"
  }, [_vm._v("确认付款")]), _vm._v(" "), _c('i', {
    staticClass: "step-count"
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "line"
  })]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "item"
  }, [_vm._v("下单成功")]), _vm._v(" "), _c('i', {
    staticClass: "step-count"
  })])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', {
    staticClass: "col-2"
  }, [_c('span', {
    staticClass: "ml120"
  }, [_vm._v("商品名称")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "co1"
  }, [_c('i', {
    staticClass: "ico-sp-tk"
  }), _vm._v("支持7天无理由退货服务")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb20 ad-4 mt20"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("dlf8"),
      "width": "1200",
      "height": "60"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YYay":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shop_introduction_vue__ = __webpack_require__("INmO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_391ff9ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_shop_introduction_vue__ = __webpack_require__("586K");
function injectStyle (ssrContext) {
  __webpack_require__("/37r")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shop_introduction_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_391ff9ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_shop_introduction_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__page_shop_shop_index__ = __webpack_require__("lYG6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__page_shop_shop_goods_list__ = __webpack_require__("vooN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__page_shop_shop_introduction__ = __webpack_require__("YYay");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__page_shop_shopCart__ = __webpack_require__("PDX5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__page_goods_goodsDetail__ = __webpack_require__("BLUo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__page_goods_sampleDetail__ = __webpack_require__("24m4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__page_order_orderCommit__ = __webpack_require__("ZLH9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__page_order_orderConfirm__ = __webpack_require__("zYA5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__page_order_orderPaySuccess__ = __webpack_require__("kja2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__page_index_index__ = __webpack_require__("Fw7Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__page_login_login__ = __webpack_require__("QrVH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__page_address_address__ = __webpack_require__("VND7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__page_address_address_list__ = __webpack_require__("JfXx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__page_goods_goodsList__ = __webpack_require__("G5tM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__page_goods_meterialList__ = __webpack_require__("o+fC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__page_goods_sampleList__ = __webpack_require__("b0eZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__page_goods_seckillList__ = __webpack_require__("9XVc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__page_goods_goodsClassList__ = __webpack_require__("FruX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__page_shop_shopsList__ = __webpack_require__("y0gP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__page_pay_paySuccess__ = __webpack_require__("DVZZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__page_pay_payComplete__ = __webpack_require__("595I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__page_points_points_area__ = __webpack_require__("Vwfw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__page_order_payScanQrcode__ = __webpack_require__("fKuF");


























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/shop_index',
    name: 'shop_index',
    component: __WEBPACK_IMPORTED_MODULE_2__page_shop_shop_index__["a" /* default */]
  }, {
    path: '/shop_goods_list',
    name: 'shop_goods_list',
    component: __WEBPACK_IMPORTED_MODULE_3__page_shop_shop_goods_list__["a" /* default */]
  }, {
    path: '/shopCart',
    name: 'shopcart',
    component: __WEBPACK_IMPORTED_MODULE_5__page_shop_shopCart__["a" /* default */]
  }, {
    path: '/goodsDetails',
    name: 'goodsdetail',
    component: __WEBPACK_IMPORTED_MODULE_6__page_goods_goodsDetail__["a" /* default */]
  }, {
    path: '/sampleDetail',
    name: 'sampledetail',
    component: __WEBPACK_IMPORTED_MODULE_7__page_goods_sampleDetail__["a" /* default */]
  }, {
    path: '/orderCommit',
    name: 'ordercommit',
    component: __WEBPACK_IMPORTED_MODULE_8__page_order_orderCommit__["a" /* default */]
  }, {
    path: '/orderConfirm',
    name: 'orderconfirm',
    component: __WEBPACK_IMPORTED_MODULE_9__page_order_orderConfirm__["a" /* default */]
  }, {
    path: '/orderPaySuccess',
    name: 'orderpaysuccess',
    component: __WEBPACK_IMPORTED_MODULE_10__page_order_orderPaySuccess__["a" /* default */]
  }, {
    path: '/',
    name: 'index',
    component: __WEBPACK_IMPORTED_MODULE_11__page_index_index__["a" /* default */]
  }, {
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_12__page_login_login__["a" /* default */]
  }, {
    path: '/address',
    name: 'address',
    component: __WEBPACK_IMPORTED_MODULE_13__page_address_address__["a" /* default */]
  }, {
    path: '/address_list',
    name: 'address_list',
    component: __WEBPACK_IMPORTED_MODULE_14__page_address_address_list__["a" /* default */]
  }, {
    path: '/goodsList',
    name: 'goodsList',
    component: __WEBPACK_IMPORTED_MODULE_15__page_goods_goodsList__["a" /* default */]
  }, {
    path: '/sampleList',
    name: 'sampleList',
    component: __WEBPACK_IMPORTED_MODULE_17__page_goods_sampleList__["a" /* default */]
  }, {
    path: '/meterialList',
    name: 'meterialList',
    component: __WEBPACK_IMPORTED_MODULE_16__page_goods_meterialList__["a" /* default */]
  }, {
    path: '/seckillList',
    name: 'seckillList',
    component: __WEBPACK_IMPORTED_MODULE_18__page_goods_seckillList__["a" /* default */]
  }, {
    path: '/goodsClassList',
    name: 'goodsClassList',
    component: __WEBPACK_IMPORTED_MODULE_19__page_goods_goodsClassList__["a" /* default */]
  }, {
    path: '/shopsList',
    name: 'shopsList',
    component: __WEBPACK_IMPORTED_MODULE_20__page_shop_shopsList__["a" /* default */]
  }, {
    path: '/shopIntroduction',
    name: 'shopIntroduction',
    component: __WEBPACK_IMPORTED_MODULE_4__page_shop_shop_introduction__["a" /* default */]
  }, {
    path: '/paySuccess',
    name: 'paySuccess',
    component: __WEBPACK_IMPORTED_MODULE_21__page_pay_paySuccess__["a" /* default */]
  }, {
    path: '/payComplete',
    name: 'payComplete',
    component: __WEBPACK_IMPORTED_MODULE_22__page_pay_payComplete__["a" /* default */]
  }, {
    path: '/points_area',
    name: 'points_area',
    component: __WEBPACK_IMPORTED_MODULE_23__page_points_points_area__["a" /* default */]
  }, {
    path: '/payScanQrcode',
    name: 'payScanQrcode',
    component: __WEBPACK_IMPORTED_MODULE_24__page_order_payScanQrcode__["a" /* default */]
  }]
}));

/***/ }),

/***/ "YnqX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZLEC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_js_vue_easy_slider_js__ = __webpack_require__("4RNh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'shopslider',
	data: function data() {
		return {
			msg: 'Welcome to Your Vue.js App123',
			adsItems: [{ linkUrl: 'https://www.baidu.com', imgUrl: '../../static/images/temp/shop/focus-1.jpg' }, { linkUrl: 'https://www.baidu.com', imgUrl: '../../static/images/temp/shop/focus-1.jpg' }, { linkUrl: 'https://www.baidu.com', imgUrl: '../../static/images/temp/shop/focus-1.jpg' }],
			sliderHeight: '370px'
		};
	},

	components: {
		Slider: __WEBPACK_IMPORTED_MODULE_0__static_js_vue_easy_slider_js__["Slider"],
		SliderItem: __WEBPACK_IMPORTED_MODULE_0__static_js_vue_easy_slider_js__["SliderItem"]
	}
});

/***/ }),

/***/ "ZLH9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orderCommit_vue__ = __webpack_require__("TDFL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11c1f2f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_orderCommit_vue__ = __webpack_require__("jCf5");
function injectStyle (ssrContext) {
  __webpack_require__("LoU4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orderCommit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11c1f2f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_orderCommit_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZjUR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aq0g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "topbar"
  }, [_c('div', {
    staticClass: "w1200 bc",
    staticStyle: {
      "margin": "auto"
    }
  }, [_c('ul', {
    staticClass: "topbar-right fr"
  }, [(_vm.isLogin == false) ? _c('li', [_c('a', {
    staticClass: "co2",
    attrs: {
      "href": _vm.loginUrl
    }
  }, [_vm._v("[登录]")])]) : _vm._e(), _vm._v(" "), (_vm.isLogin == false) ? _c('li', [_c('a', {
    staticClass: "co2",
    attrs: {
      "href": _vm.registerUrl
    }
  }, [_vm._v("[注册]")])]) : _vm._e(), _vm._v(" "), (_vm.isLogin == true) ? _c('li', [_c('span', [_vm._v("您好")])]) : _vm._e(), _vm._v(" "), (_vm.isLogin == true) ? _c('li', [_c('a', {
    staticClass: "co2",
    attrs: {
      "href": _vm.userCenterUrl
    }
  }, [_vm._v(_vm._s(_vm.account))])]) : _vm._e(), _vm._v(" "), (_vm.isLogin == true) ? _c('li', [_c('a', {
    staticClass: "co2",
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("[退出]")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.aboutUsUrl
    }
  }, [_vm._v("关于我们")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.contactUrl,
      "target": "_blank"
    }
  }, [_vm._v("联系客服")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "mouseenter": function($event) {
        _vm.mobileAppShow()
      },
      "mouseleave": function($event) {
        _vm.mobileAppHidden()
      }
    }
  }, [_vm._v("手机商城")]), _vm._v(" "), (_vm.isShow) ? _c('div', {
    staticClass: "demensional_code"
  }, [_c('img', {
    attrs: {
      "width": "100px",
      "src": __webpack_require__("nz2A")
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('ul', {
    staticClass: "topbar-left fl"
  }, [_c('li', [_vm._v("\n\t\t\t\t\t\t您好！欢迎来到相伴宝！\n\t\t\t\t\t")]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "co1",
    attrs: {
      "href": _vm.indexUrl
    }
  }, [_vm._v("返回相伴宝")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header line"
  }, [_c('div', {
    staticClass: "w1200 bc",
    staticStyle: {
      "margin": "auto"
    }
  }, [_c('a', {
    staticClass: "logo fl",
    attrs: {
      "href": _vm.indexUrl,
      "title": "云永云商城"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('span', {
    staticClass: "ico"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sortParam),
      expression: "sortParam"
    }],
    staticClass: "text",
    attrs: {
      "type": "text",
      "placeholder": "请输入关键字"
    },
    domProps: {
      "value": (_vm.sortParam)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sortParam = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.findGoods()
      }
    }
  }, [_vm._v("搜商品")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "margin-left": "3px"
    },
    on: {
      "click": function($event) {
        _vm.findShops()
      }
    }
  }, [_vm._v("搜店铺")])]), _vm._v(" "), _c('div', {
    staticClass: "r-box fr",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "mycart",
    on: {
      "mouseenter": function($event) {
        _vm.shopCarShow()
      },
      "mouseleave": function($event) {
        _vm.shopCarHide()
      }
    }
  }, [_c('i', {
    staticClass: "ico-cart"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("我的购物车")]), _vm._v(" "), _c('span', {
    staticClass: "ico-shopping-amount"
  }, [_vm._v(_vm._s(_vm.shoppingCartNum))]), _vm._v(" "), _c('i', {
    staticClass: "ico-r"
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-list none",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), (_vm.shoppingCartNum == 0) ? _c('div', {
    staticClass: "no-goods"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("HdMn"),
      "width": "57",
      "height": "49"
    }
  }), _vm._v("购物车中还没有商品，赶紧选购吧！\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.shoppingCartNum > 0) ? _c('div', {
    staticClass: "mylist"
  }, [_c('h4', [_vm._v("最新加入的商品")]), _vm._v(" "), _c('ul', _vm._l((_vm.boList), function(bo) {
    return _c('li', {
      staticClass: "li-2",
      attrs: {
        "id": bo.goodsCode + '_cart_pro'
      }
    }, [_c('a', {
      staticClass: "fl spic",
      attrs: {
        "href": "#"
      }
    }, [_c('img', {
      attrs: {
        "src": bo.imgSmall,
        "width": "50",
        "height": "50"
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "name"
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(bo.goodsName))]), _vm._v("    "), _c('span', [_vm._v("数量：" + _vm._s(bo.goodsNumber))])]), _vm._v(" "), _c('p', {
      staticClass: "other"
    }, [_c('span', [_vm._v("￥" + _vm._s(bo.goodsPrice))]), _c('br'), _vm._v(" "), _c('a', {
      staticClass: "del",
      on: {
        "click": function($event) {
          _vm.deleteGoods(bo.goodsCode)
        }
      }
    }, [_vm._v("删除")])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "fbar"
  }, [_c('span', {
    staticClass: "fl ml10"
  }, [_vm._v("共" + _vm._s(_vm.count) + "件商品　共计"), _c('b', [_vm._v("￥ " + _vm._s(_vm.sumMoney))])]), _vm._v(" "), _c('a', {
    staticClass: "fr gobuy",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("去购物车")])])]) : _vm._e()])]), _vm._v(" "), (_vm.isLogin == true) ? _c('div', {
    staticClass: "myorder ml25",
    on: {
      "mouseenter": function($event) {
        _vm.orderShow()
      },
      "mouseleave": function($event) {
        _vm.orderHide()
      }
    }
  }, [_c('i', {
    staticClass: "ico-orders"
  }), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.goOrder('')
      }
    }
  }, [_vm._v("我的订单 "), _c('span', {
    staticClass: "ico-shopping-amount"
  }, [_vm._v(_vm._s(_vm.allCount))])]), _vm._v(" "), _c('i', {
    staticClass: "ico-r"
  }), _vm._v(" "), _c('div', {
    staticClass: "orders-list orders"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('wait_buyer_pay')
      }
    }
  }, [_vm._v("等待买家付款 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.payCount))])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('wait_send_goods')
      }
    }
  }, [_vm._v("等待卖家发货 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.sendCount))])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('wait_buyer_confirm_goods')
      }
    }
  }, [_vm._v("等待确认收货 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.putCount))])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('trade_finish')
      }
    }
  }, [_vm._v("订单完成 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.receiveCount))])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('trade_close')
      }
    }
  }, [_vm._v("订单关闭 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.closeCount))])])])])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear mt15"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "focus_nav",
    staticStyle: {
      "background": "#2C3847"
    },
    on: {
      "mouseover": function($event) {
        _vm.hoverShow()
      },
      "mouseout": function($event) {
        _vm.hoverHide()
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "navTime"
    }
  }, [_c('div', {
    staticClass: "navTime"
  }, [_c('ul', [_c('li', {
    class: {
      cur: _vm.seckillCode == _vm.secKillBo.activityCode
    },
    on: {
      "click": function($event) {
        _vm.chooseActivity(_vm.secKillBo.activityCode, _vm.secKillBo.activityBeginTime, _vm.secKillBo.activityEndTime)
      }
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "17px"
    }
  }, [_vm._v(_vm._s(_vm.secKillBo.activityBeginTime))]), _vm._v(" "), _c('p', {
    staticClass: "nav_kq"
  }, [_vm._v("已开抢")])]), _vm._v(" "), _vm._l((_vm.secKillList), function(seckill, index) {
    return _c('li', {
      key: seckill.id,
      class: {
        cur: _vm.seckillCode == seckill.activityCode
      },
      on: {
        "click": function($event) {
          _vm.chooseActivity(seckill.activityCode, seckill.activityBeginTime, seckill.activityEndTime)
        }
      }
    }, [_c('p', {
      staticStyle: {
        "font-size": "17px"
      }
    }, [_vm._v(_vm._s(seckill.activityBeginTime))]), _vm._v(" "), _c('p', {
      staticClass: "nav_kq"
    }, [_vm._v("即将开场")])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "btn_nav"
  }, [_c('a', {
    staticClass: "change-bnt prev-bnt",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.prev_move()
      }
    }
  }, [_vm._v("<")]), _vm._v(" "), _c('a', {
    staticClass: "change-bnt next-bnt",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.next_move()
      }
    }
  }, [_vm._v(">")])])])]), _vm._v(" "), _c('div', {
    staticClass: "shopWarp"
  }, [_c('div', {
    staticClass: "shopBox"
  }, [_c('ul', _vm._l((_vm.goodsList), function(good) {
    return _c('li', [_c('a', {
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(good.goodsCode)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": good.imgMiddle,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('p', {
      staticClass: "rightTitle"
    }, [_vm._v(_vm._s(good.goodsName))]), _vm._v(" "), _c('p', {
      staticClass: "rightdetail"
    }, [_vm._v(_vm._s(good.goodsNameDesc))]), _vm._v(" "), _c('div', {
      staticClass: "priceleft"
    }, [_c('span', {
      staticClass: "originalPrice1"
    }, [_vm._v("￥" + _vm._s((good.unitPrice / 100).toFixed(2)))]), _vm._v(" "), _c('br'), _vm._v(" "), (good.seckillPrice.length < 6) ? _c('span', {
      staticClass: "currentPrice1"
    }, [_c('span', {
      staticStyle: {
        "font-size": "18px",
        "font-weight": "500"
      }
    }, [_vm._v("￥")]), _vm._v(_vm._s((good.seckillPrice / 100).toFixed(2)))]) : _c('span', {
      staticClass: "currentPrice1"
    }, [_c('span', {
      staticStyle: {
        "font-size": "18px",
        "font-weight": "500"
      }
    }, [_vm._v("￥")]), _vm._v(_vm._s((good.seckillPrice / 100).toFixed(0)))])]), _vm._v(" "), (_vm.compareActTime(_vm.activityBeginTime, _vm.activityEndTime)) ? _c('div', {
      staticClass: "priceright link-btn"
    }, [_vm._v("\n                            \t\t马上抢\n                        ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clear"
    }), _vm._v(" "), (_vm.compareActTime(_vm.activityBeginTime, _vm.activityEndTime)) ? _c('div', {
      staticClass: "progress"
    }, [_c('div', {
      staticClass: "num"
    }, [_c('span', [_vm._v("已抢购" + _vm._s((good.saleNumberTotal + good.inpSaleNumber + good.goodsNumber) == 0 ? 0 : (((good.saleNumberTotal + good.inpSaleNumber) / (good.saleNumberTotal + good.inpSaleNumber + good.goodsNumber) * 100).toFixed(0))) + "%")]), _vm._v(" "), _c('span', [_vm._v("已抢购" + _vm._s(good.saleNumberTotal + good.inpSaleNumber) + "件")])]), _vm._v(" "), _c('div', {
      staticClass: "down"
    }, [_c('div', {
      style: ({
        'width': (good.saleNumberTotal + good.inpSaleNumber + good.goodsNumber) == 0 ? '0%' : (((good.saleNumberTotal + good.inpSaleNumber) / (good.saleNumberTotal + good.inpSaleNumber + good.goodsNumber) * 100).toFixed(0) + '%')
      })
    })])]) : _vm._e()])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('footermenu'), _vm._v(" "), _c('footercopyright')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head"
  }, [_c('div', [_c('h2', {
    staticClass: "head_logo left"
  }, [_c('img', {
    staticStyle: {
      "margin-top": "6px"
    },
    attrs: {
      "src": __webpack_require__("0t5L"),
      "width": "95px",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "headRight headLeft left"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("首页")])])])]), _vm._v(" "), _c('div', {
    staticClass: "headRight right"
  }, [_c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": __webpack_require__("6VjR"),
      "alt": ""
    }
  }), _vm._v("\n                        \t限时限量抢\n                    ")]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": __webpack_require__("ytwD"),
      "alt": ""
    }
  }), _vm._v("\n                        30天低价\n                    ")]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": __webpack_require__("7Ohe"),
      "alt": ""
    }
  }), _vm._v("\n                        全场包邮\n                    ")])])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "b0eZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sampleList_vue__ = __webpack_require__("Rd1n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61a86f61_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_sampleList_vue__ = __webpack_require__("IJlu");
function injectStyle (ssrContext) {
  __webpack_require__("5aJO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61a86f61"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sampleList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61a86f61_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_sampleList_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bCJ+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {var alertConfirm = {
  //默认弹出框，包含确定和取消
  //@Params message 弹出框信息
  //@Params callback 弹出框回调函数
  alertConfirm: function alertConfirm(message, callback) {
    this.confirm("normal", message, callback);
  },
  //单击弹出框，只包含确定
  //@Params message 弹出框信息
  //@Params callback 弹出框回调函数
  singleConfirm: function singleConfirm(message, callback) {
    this.confirm("single", message, callback);
  },
  //弹出框本体函数
  //@Params type 弹出框类型
  //@Params message 弹出框信息
  //@Params callback 弹出框回调函数
  confirm: function confirm(type, message, callback) {
    var that = this;

    if (!window.document.getElementById("alertConfirm")) {
      this.init(type);
    }

    if (!callback) {
      callback = function callback() {};
    }

    $('#alertM').html(message);

    if (type == "normal") {
      $('#cancle').on('click', function () {
        $('.cd-popup').removeClass('is-visible');
      });
    }

    $('#close').on('click', function () {
      $('.cd-popup').removeClass('is-visible');
    });

    $('.cd-popup').addClass('is-visible');

    $('#confirm').on('click', function () {
      that.callBackFun(callback);
    });

    $(document).keypress(function (e) {
      if (e.which == 13) {
        that.callBackFun(callback);
      }
    });
  },
  //弹出框初始化函数
  //@Params type 弹出框类型
  init: function init(type) {
    if (!window.document.getElementById("alertConfirm")) {
      var link = document.createElement("link");
      link.href = "static/css/alertConfirm.css";
      link.rel = "stylesheet";
      link.type = "text/css";
      document.head.appendChild(link);
      var alertC = window.document.createDocumentFragment();
      var div = window.document.createElement("div");
      div.id = "alertConfirm";
      div.className = "cd-popup";
      if (type == "single") {
        div.innerHTML = "<div class='cd-popup-container'><p id='alertM'>确定要删除吗?</p><ul class='cd-buttons'><li class='single'><a id='confirm'>确定</a></li></ul><a class='cd-popup-close img-replace' id='close'>Close</a></div>";
      } else if (type == "normal") {
        div.innerHTML = "<div class='cd-popup-container'><p id='alertM'>确定要删除吗?</p><ul class='cd-buttons'><li><a id='confirm'>确定</a></li><li><a id='cancle'>取消</a></li></ul><a class='cd-popup-close img-replace' id='close'>Close</a></div>";
      }
      alertC.appendChild(div);
      window.document.getElementById("app").appendChild(alertC);
    }
  },
  //弹出框回调函数
  //@Params callback 弹出框回调函数
  callBackFun: function callBackFun(callback) {
    callback();
    $('#alertConfirm').remove();
  }
};

/* harmony default export */ __webpack_exports__["a"] = (alertConfirm);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "cDO+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_api_api_js__ = __webpack_require__("fXcb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__ = __webpack_require__("spYF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_js_db_main_js__ = __webpack_require__("gkCg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_js_db_main_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__static_js_db_main_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Header__ = __webpack_require__("teIl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_FooterMenu__ = __webpack_require__("gTlp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_FooterCopyright__ = __webpack_require__("3LwO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_HearderNav__ = __webpack_require__("7JIe");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//import {jQuery} from "../../../static/js/jquery.min.js"









var colorListLength = 0;
var listLength = 0;
/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'goodsList',
	components: {
		'sortHeader': __WEBPACK_IMPORTED_MODULE_5__components_Header__["a" /* default */],
		'footermenu': __WEBPACK_IMPORTED_MODULE_6__components_FooterMenu__["a" /* default */],
		'footercopyright': __WEBPACK_IMPORTED_MODULE_7__components_FooterCopyright__["a" /* default */],
		'heardernav': __WEBPACK_IMPORTED_MODULE_8__components_HearderNav__["a" /* default */]
	},
	data: function data() {
		var _ref;

		return _ref = {
			isRefresh: true,
			goodsList: [],
			recommendGoodsList: [],
			sortCondition: 'defaultSort',
			sortSaleAmount: '',
			sortPublishTime: '',
			sortPrice: '',
			choosedCondItem: [],
			catCode: 'categoryAll',
			interval: 'intervalAll',
			sortTime: 'timeAll',
			currentPage: 1,
			totalPage: 1,
			orderBy: '',
			orderAsc: '',
			shopCode: '',
			pageList: [1],
			totalItem: 0,
			sortParam: '',
			shoppingCartNum: 0,
			boList: [],
			count: 0,
			goodsImgs: [],
			sumMoney: 0,
			goodsName: '',
			firstCatCode: ''
		}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "shopCode", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "mobile", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "isLogin", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "isShow", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "account", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "userCenterUrl", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "loginUrl", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "registerUrl", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "logoutUrl", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "aboutUsUrl", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "indexUrl", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "orderUrl", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "catNameCn", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "brandId", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "brandName", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "allCount", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "payCount", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "putCount", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "receiveCount", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "sendCount", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "closeCount", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "computeFlag", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "contactUrl", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "showItem", 7), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "isInit", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "lower", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "upper", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "activityBeginTime", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "activityEndTime", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "secKillBo", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "secKillList", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "seckillCode", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "moveLetf", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "moveRight", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "currentDate", null), _ref;
	},

	methods: {
		prev_move: function prev_move() {
			if (listLength + this.secKillList.length > 4) {
				listLength--;
				colorListLength -= 100;
				__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.navTime ul').animate({ "margin-left": colorListLength + "px" }, 200);
			}
		},
		next_move: function next_move() {
			if (colorListLength < 400) {
				colorListLength += 100;
				listLength++;
				__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.navTime ul').animate({ "margin-left": colorListLength + "px" }, 200);
			}
		},
		hoverShow: function hoverShow() {
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.btn_nav').show();
		},
		hoverHide: function hoverHide() {
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.btn_nav').hide();
		},
		orderShow: function orderShow() {
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".orders-list").show();
		},
		orderHide: function orderHide() {
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".orders-list").hide();
		},
		shopCarShow: function shopCarShow() {
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".goods-list").show();
		},
		shopCarHide: function shopCarHide() {
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".goods-list").hide();
		},
		getOrderCount: function getOrderCount(shopCode) {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_2__static_api_api_js__["a" /* default */].getOrderCount(function (ret) {
				if (ret.code == "success") {
					that.allCount = ret.data.allCount;
					that.payCount = ret.data.payCount;
					that.putCount = ret.data.putCount;
					that.receiveCount = ret.data.receiveCount;
					that.sendCount = ret.data.sendCount;
					that.closeCount = ret.data.closeCount;
				}
			});
		},
		logout: function logout() {
			localStorage.clear();
			__WEBPACK_IMPORTED_MODULE_2__static_api_api_js__["a" /* default */].loginOut(function (ret) {});
			window.location.href = this.logoutUrl;
		},
		clearCookie: function clearCookie() {
			var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
			if (keys) {
				for (var i = keys.length; i--;) {
					document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString();
				}
			}
		},
		goOrder: function goOrder(tradeStatus) {
			var account = localStorage.getItem("account");
			if (account != undefined && account != "") {
				window.location.href = this.orderUrl + "?tradeStatus=" + tradeStatus;
			} else {
				window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/login.htm';
			}
		},
		mobileAppShow: function mobileAppShow() {
			this.isShow = true;
		},
		mobileAppHidden: function mobileAppHidden() {
			this.isShow = false;
		},
		jumpTo: function jumpTo(name) {
			this.$router.push({ name: name });
		},
		toGoodsDetail: function toGoodsDetail(goodsCode) {
			//this.$router.push({ name: 'goodsdetail', query:{goodsCode:goodsCode}});
			var routeData = this.$router.resolve({ path: '/goodsDetails', query: { goodsCode: goodsCode } });
			window.open(routeData.href, '_blank');
		},
		prePage: function prePage() {
			if (this.currentPage > 1) {
				this.currentPage = this.currentPage - 1;
				this.adjustPageArray(this.currentPage);
				this.getGoods();
			}
		},
		nextPage: function nextPage() {
			if (this.currentPage < this.totalPage) {
				this.currentPage = this.currentPage + 1;
				this.adjustPageArray(this.currentPage);
				this.getGoods();
			}
		},
		queryByPage: function queryByPage(page) {
			this.currentPage = page;
			this.adjustPageArray(this.currentPage);
			this.getGoods();
		},
		adjustPageArray: function adjustPageArray(page) {
			if (page == this.pageList[6] && page + 2 <= this.totalPage) {
				this.pageList.push(page + 1);
				this.pageList.push(page + 2);
				this.pageList.shift();
				this.pageList.shift();
			} else if (page == this.pageList[6] && page + 1 == this.totalPage) {
				this.pageList.push(page + 1);
				this.pageList.shift();
			} else if (page == this.pageList[0] && page >= 3) {
				this.pageList.unshift(page - 1);
				this.pageList.unshift(page - 2);
				this.pageList.pop();
				this.pageList.pop();
			} else if (page == this.pageList[0] && page == 2) {
				this.pageList.unshift(page - 1);
				this.pageList.pop();
			}
		},
		initPageArray: function initPageArray() {
			var pageList = new Array();
			var totalPage = this.totalPage;
			for (var i = 1; i <= totalPage; i++) {
				if (i <= this.showItem) {
					pageList.push(i);
				}
			}
			this.pageList = pageList;
		},
		clearUserDefined: function clearUserDefined() {
			this.lower = '';
			this.upper = '';
		},
		userDefinedCondition: function userDefinedCondition() {
			this.lower = this.lower.trim();
			this.upper = this.upper.trim();
			var sortParams = '';
			if (this.lower != '' && this.upper != '') {
				sortParams = this.lower + ',' + this.upper;
			} else if (this.lower == '' && this.upper != '') {
				sortParams = '0,' + this.upper;
			} else if (this.lower != '' && this.upper == '') {
				sortParams = this.lower + ',';
			}
			this.chooseCondition('', 'amount', sortParams);
		},
		chooseCondition: function chooseCondition(event, type, sortParams) {
			if (event != '') {
				var condText = event.target.innerText;
				if (condText != "不限") {
					var condText = event.target.innerText;
					if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#choosedCond").find("span[condType='" + type + "']").length != 0) {
						__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#choosedCond").find("span[condType='" + type + "']").remove();
					}
					this.choosedCondItem.push({ condName: condText, condType: type });
				} else {
					__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#choosedCond").find("span[condType='" + type + "']").remove();
				}

				if (type == 'amount') {
					this.clearUserDefined();
				}
			} else {
				if (type == 'amount') {
					if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#choosedCond").find("span[condType='" + type + "']").length != 0) {
						__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#choosedCond").find("span[condType='" + type + "']").remove();
					}
				}
			}

			if (type == 'amount') {
				this.interval = sortParams;
			} else if (type == 'cat') {
				this.catCode = sortParams;
			} else if (type == 'time') {
				this.sortTime = sortParams;
			}
			this.getRecommendGoods();
			this.getGoods();
		},
		removeCondition: function removeCondition(index, type) {
			if (type == 'amount') {
				this.interval = "intervalAll";
			} else if (type == 'cat') {
				this.catCode = "categoryAll";
			} else if (type == 'time') {
				this.sortTime = "timeAll";
			}
			this.choosedCondItem.splice(index, 1);
			this.getRecommendGoods();
			this.getGoods();
		},
		findGoods: function findGoods() {
			this.resetCond();
			this.getRecommendGoods();
			this.getGoods();
		},
		findShops: function findShops() {
			this.$router.push({ name: 'shopsList', query: { sortParam: this.sortParam } });
		},
		sortGoods: function sortGoods(sortCondition) {
			this.currentPage = 1;
			this.sortCondition = sortCondition;
			if (sortCondition == "saleAmount") {
				this.orderBy = "sale_number";
				if (this.sortSaleAmount == '') {
					this.sortSaleAmount = "desc";
				} else if (this.sortSaleAmount == 'desc') {
					this.sortSaleAmount = "asc";
				} else if (this.sortSaleAmount == 'asc') {
					this.sortSaleAmount = "desc";
				}
				this.orderAsc = this.sortSaleAmount;
			}
			if (sortCondition == "publishTime") {
				this.orderBy = "gmt_create";
				if (this.sortPublishTime == '') {
					this.sortPublishTime = "desc";
				} else if (this.sortPublishTime == 'desc') {
					this.sortPublishTime = "asc";
				} else if (this.sortPublishTime == 'asc') {
					this.sortPublishTime = "desc";
				}
				this.orderAsc = this.sortPublishTime;
			}
			if (sortCondition == "price") {
				this.orderBy = "unit_price";
				if (this.sortPrice == '') {
					this.sortPrice = "desc";
				} else if (this.sortPrice == 'desc') {
					this.sortPrice = "asc";
				} else if (this.sortPrice == 'asc') {
					this.sortPrice = "desc";
				}
				this.orderAsc = this.sortPrice;
			}
			if (sortCondition == "defaultSort") {
				this.orderBy = "";
				this.orderAsc = "";
			}
			this.getGoods();
			this.getRecommendGoods();
		},
		getRecommendGoods: function getRecommendGoods() {
			var that = this;
			var interval = that.interval;
			var catCode = that.catCode;
			var cabinetId = "";
			var pageSize = 5;
			var isQueryAll = "n";
			var currentPage = 1;
			var orderBy = "sale_number";
			var orderAsc = "desc";
			var shopCode = that.shopCode;
			var sortTime = "";
			var goodsName = encodeURI(that.sortParam);
			var firstCatCode = that.firstCatCode;
			var brandId = that.brandId;
			var product_type = "";
			var order_type = "";
			__WEBPACK_IMPORTED_MODULE_2__static_api_api_js__["a" /* default */].getGoodsList(cabinetId, catCode, interval, currentPage, orderBy, orderAsc, shopCode, sortTime, pageSize, isQueryAll, goodsName, firstCatCode, brandId, product_type, order_type, function (ret) {
				if (ret.code == "success") {
					var goods = ret.data.goods;
					if (goods != undefined) {
						for (var i = 0; i < goods.length; i++) {
							//商品图片
							var imgMiddle = goods[i].imgMiddle;
							if (imgMiddle.indexOf(";") != -1) {
								imgMiddle = imgMiddle.split(";")[0];
							}
							imgMiddle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + imgMiddle;
							goods[i].imgMiddle = imgMiddle;
						}
					}
					that.recommendGoodsList = goods;
				}
			});
		},
		getGoods: function getGoods() {
			var that = this;
			var interval = that.interval;
			var catCode = that.catCode;
			var isQueryAll = "n";
			var shopCode = that.shopCode;
			var cabinetId = "";
			var pageSize = 99999;
			var currentPage = that.currentPage;
			var orderBy = that.orderBy;
			var orderAsc = that.orderAsc;
			var sortTime = that.sortTime;
			var goodsName = encodeURI(that.sortParam);
			var firstCatCode = that.firstCatCode;
			var brandId = that.brandId;
			var seckillCode = that.seckillCode;
			__WEBPACK_IMPORTED_MODULE_2__static_api_api_js__["a" /* default */].getSeckillgoodsList(seckillCode, currentPage, pageSize, function (ret) {
				if (ret.code == "success") {
					var goods = ret.data.goods;
					that.totalItem = ret.data.totalItem;
					var totalPage = ret.data.totalPage;
					if (totalPage != undefined && totalPage != 0 && totalPage != that.totalPage) {
						that.totalPage = ret.data.totalPage;
						that.initPageArray();
					} else if (totalPage != undefined && totalPage == 0) {
						that.totalPage = 1;
						that.initPageArray();
					}
					if (goods != undefined) {
						for (var i = 0; i < goods.length; i++) {
							//商品图片
							var imgMiddle = goods[i].imgMiddle;
							if (imgMiddle.indexOf(";") != -1) {
								imgMiddle = imgMiddle.split(";")[0];
							}
							imgMiddle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + imgMiddle;
							goods[i].imgMiddle = imgMiddle;

							if (firstCatCode == 'spike') {

								var marketPrice = JSON.parse(goods[i].attrValue).marketPrice;
								var saleTimeStr = JSON.parse(goods[i].attrValue).saleTimeShow;
								var saleEndTimeStr = JSON.parse(goods[i].attrValue).saleEndTimeShow;
								if (marketPrice != undefined && marketPrice != "") {
									goods[i].marketPrice = marketPrice;
								} else {
									goods[i].marketPrice = goods[i].unitPrice;
								}
								if (saleEndTimeStr != undefined && saleEndTimeStr != '') {
									saleEndTimeStr = saleEndTimeStr.replace(/-/g, "/");
									var saleEndDate = new Date(saleEndTimeStr);

									saleTimeStr = saleTimeStr.replace(/-/g, "/");
									var saleDate = new Date(saleTimeStr);
								}
							}
						}
					}
					that.goodsList = goods;
					if (!that.isInit) {
						that.isInit = true;
						that.initPageArray();
					}
				}
			});
		},
		getShoppingCartNum: function getShoppingCartNum(shopCode) {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_2__static_api_api_js__["a" /* default */].getShoppingCartNum(function (ret) {
				if (ret.code == "success") {
					that.shoppingCartNum = ret.data.shoppingCartNum;
				}
			});
		},
		getShoppingCartList: function getShoppingCartList() {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_2__static_api_api_js__["a" /* default */].getShoppingCartList(function (ret) {
				if (ret.code == "success") {
					that.boList = ret.data.boList;
					var totalCount = 0;
					var bos = new Array();
					bos = ret.data.boList;
					var money = 0;
					for (var i = 0; i < bos.length; i++) {
						var imgSmall = bos[i].imgSmall;
						if (imgSmall.indexOf(";") != -1) {
							imgSmall = imgSmall.split(";")[0];
						}
						bos[i].imgSmall = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + imgSmall;
						money = money + bos[i].goodsPrice * bos[i].goodsNumber;
						totalCount = totalCount + bos[i].goodsNumber;
					}
					that.sumMoney = money;
					that.count = totalCount;
				}
			});
		},
		deleteGoods: function deleteGoods(goodsCode) {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_2__static_api_api_js__["a" /* default */].deleteGoods(goodsCode, function (ret) {
				if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__["n" /* parseResult */])(ret, null, false)) {
					__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#" + goodsCode + "_cart_pro").remove();
				}
			});
		},
		goIndex: function goIndex() {
			this.$router.push({ name: 'index' });
		},
		getMoreCatGoods: function getMoreCatGoods(catCode, catNameCn) {
			this.catNameCn = catNameCn;
			this.resetCond();
			this.sortParam = "";
			this.firstCatCode = catCode;
			this.sortParam = "";
			this.getRecommendGoods();
			this.getGoods();
		},
		getCatGoods: function getCatGoods(catCode, catNameCn) {
			this.catNameCn = catNameCn;
			this.resetCond();
			this.sortParam = "";
			this.catCode = catCode;
			this.firstCatCode = "";
			this.sortParam = "";
			this.getRecommendGoods();
			this.getGoods();
		},
		resetCond: function resetCond() {
			this.interval = "intervalAll";
			this.catCode = "categoryAll";
			this.sortTime = "timeAll";
			this.firstCatCode = "";
			this.orderBy = "";
			this.orderAsc = "";
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#choosedCond").html("");
		},
		getSeckillActivityList: function getSeckillActivityList() {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_2__static_api_api_js__["a" /* default */].getSeckillActivityList(function (ret) {
				if (ret.code == "success" && ret.data != undefined) {
					that.currentDate = new Date(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__["r" /* dateFormat */])(ret.data.currentTime + "").replace(/-/g, "/"));
					that.secKillBo = ret.data.secKillBo;
					that.secKillBo.activityBeginTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__["r" /* dateFormat */])(that.secKillBo.activityBeginTime + "");
					that.secKillBo.activityEndTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__["r" /* dateFormat */])(that.secKillBo.activityEndTime + "");
					that.activityBeginTime = that.secKillBo.activityBeginTime;
					that.activityEndTime = that.secKillBo.activityEndTime;
					that.seckillCode = ret.data.secKillBo.activityCode;
					var secKillList = ret.data.secKillList;
					for (var i = 0; i < secKillList.length; i++) {
						secKillList[i].activityBeginTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__["r" /* dateFormat */])(secKillList[i].activityBeginTime + "");
						secKillList[i].activityEndTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__["r" /* dateFormat */])(secKillList[i].activityEndTime + "");
					}
					that.secKillList = secKillList;
					that.seckillGoods = ret.data.seckillGoods;
					that.getGoods();
				}
			});
		},
		chooseActivity: function chooseActivity(seckillCode, activityBeginTime, activityEndTime) {
			//				this.getCategoryList(catCode);
			this.seckillCode = seckillCode;
			this.activityBeginTime = activityBeginTime;
			this.activityEndTime = activityEndTime;
			var page = {
				'items': [],
				'totalPage': 0,
				'currentPage': 1,
				'nextPage': 1 //重置分页数据
				//				 page = this.page; 
				//				page.nextPage = 1;
			};this.page = page;
			this.getGoods(page);
		},
		//判断是否在活动时间内
		compareActTime: function compareActTime(actBeginTime, actEndTime) {
			var that = this;
			if (that.currentDate == null || that.currentDate == undefined || actBeginTime == null || actBeginTime == undefined || actEndTime == null || actEndTime == undefined) {
				return false;
			} else {
				if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__["s" /* compareDate */])(actBeginTime, that.currentDate) <= 0 && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__["s" /* compareDate */])(actEndTime, that.currentDate) >= 0) {
					return true;
				} else {
					return false;
				}
			}
		}
	},
	ready: function ready() {},
	beforeDestroy: function beforeDestroy() {
		var that = this;
		if (that.firstCatCode == 'spike') {
			window.clearInterval(this.computeFlag);
		}
	},
	mounted: function mounted() {
		window.scrollTo(0, 0);
		//			this.$refs.navComp.getCat();
		var account = localStorage.getItem("account");
		if (account != undefined && account != "") {
			this.isLogin = true;
			this.account = account;
		}
		this.userCenterUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/index/default.htm';
		this.loginUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/login.htm';
		//			this.registerUrl = getUcUrl() + '/custm/user/user_reg_add.htm';
		this.registerUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/custm/user/user_reg_add.htm?formCode=MCHT_USER_FORM';
		this.logoutUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/logout.htm';
		this.aboutUsUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__["l" /* getAboutUsUrl */])();
		this.indexUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__["o" /* getIndexUrl */])();
		this.orderUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_emallUtils_js__["b" /* getEmallUrl */])() + '/orderManage/myOrderList.htm';

		var sortParam = this.$route.query.sortParam;
		var firstCatCode = this.$route.query.firstCatCode;
		var shopCode = this.$route.query.shopCode;
		var catCode = this.$route.query.catCode;
		var catNameCn = this.$route.query.catNameCn;
		var brandId = this.$route.query.brandId;
		var brandName = this.$route.query.brandName;

		if (sortParam != undefined) {
			this.sortParam = sortParam;
		}
		if (firstCatCode != undefined) {
			this.firstCatCode = firstCatCode;
		}
		if (shopCode != undefined) {
			this.shopCode = shopCode;
		}
		var that = this;

		//			if(catCode != undefined){
		//				this.catCode = catCode;
		//				this.getCatGoods(this.catCode);
		//			}else{
		//				this.getRecommendGoods();
		//				this.getGoods();
		//			}
		if (catNameCn != undefined) {
			this.catNameCn = decodeURI(catNameCn);;
		}
		if (brandId != undefined) {
			this.brandId = brandId;;
		}
		if (brandName != undefined) {
			this.brandName = brandName;;
		}
		this.getSeckillActivityList();
	}
});

/***/ }),

/***/ "d8/S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dcIM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_js_emallUtils_js__ = __webpack_require__("spYF");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'footermenu',
	data: function data() {
		return {
			cmsApiUrl: '',
			serviceList: { 'name': '', list: [] },
			paymentList: { 'name': '', list: [] },
			//				aboutusList:[],
			frendlinkList: { 'name': '', list: [] }
		};
	},

	methods: {
		requestCms: function requestCms(req_param) {
			var that = this;
			var params = {
				c: req_param
			};
			jQuery.ajax({
				type: "get",
				url: __WEBPACK_IMPORTED_MODULE_0__static_js_emallUtils_js__["k" /* cmsApiUrl */],
				async: false,
				dataType: "jsonp", // 返回的数据类型，设置为JSONP方式
				cache: true,
				data: params,
				success: function success(ret) {
					if (ret.code == 'success') {
						var list = ret.values.list;
						if (req_param == "Service") {
							that.serviceList.name = ret.name;
						} else if (req_param == "Payment") {
							that.paymentList.name = ret.name;
						} else if (req_param == "frendlink") {
							that.frendlinkList.name = ret.name;
						}
						if (list != undefined && list.length > 0) {
							if (req_param == "Service") {
								that.serviceList.list = list;
								that.serviceList.name = ret.name;
							} else if (req_param == "Payment") {
								that.paymentList.list = list;
								that.paymentList.name = ret.name;
								//							}else if(req_param == "aboutus"){
								//								that.aboutusList = list;
							} else if (req_param == "frendlink") {
								that.frendlinkList.list = list;
								that.frendlinkList.name = ret.name;
							}
						}
					}
				},
				error: function error(err) {}
			});
		}
	},
	mounted: function mounted() {
		this.cmsApiUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__static_js_emallUtils_js__["c" /* getCmsUrl */])();
		this.requestCms("Service");
		this.requestCms("Payment");
		//			this.requestCms("aboutus");
		this.requestCms("frendlink");
	}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "dlf8":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "e+cu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__("ORbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TopBar__ = __webpack_require__("5PWk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Header__ = __webpack_require__("teIl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FooterMenu__ = __webpack_require__("gTlp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FooterCopyright__ = __webpack_require__("3LwO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_js_alertConfirm_js__ = __webpack_require__("bCJ+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_js_emallUtils_js__ = __webpack_require__("spYF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__static_api_api_js__ = __webpack_require__("fXcb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_qrcode__ = __webpack_require__("71e1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_qrcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_qrcode__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*引入Vue框架*/

/*引入资源请求插件*/

/*使用VueResource插件*/
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);





//import jQuery from "../../../static/js/jquery.min.js"




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_qrcode___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'payScanQrcode',
	data: function data() {
		return {
			code_url: "",
			total_fee: "",
			package_code: "",
			interval: null,
			indexUrl: "",
			orderUrl: ""
		};
	},

	components: {
		'topbar': __WEBPACK_IMPORTED_MODULE_2__components_TopBar__["a" /* default */],
		'sortHeader': __WEBPACK_IMPORTED_MODULE_3__components_Header__["a" /* default */],
		'footermenu': __WEBPACK_IMPORTED_MODULE_4__components_FooterMenu__["a" /* default */],
		'footercopyright': __WEBPACK_IMPORTED_MODULE_5__components_FooterCopyright__["a" /* default */]
	},
	methods: {
		goOrder: function goOrder(tradeStatus) {
			var account = localStorage.getItem("account");
			if (account != undefined && account != "") {
				window.location.href = this.orderUrl + "?tradeStatus=" + tradeStatus;
			} else {
				window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/login.htm';
			}
		},
		viewAllOrders: function viewAllOrders() {
			window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__static_js_emallUtils_js__["b" /* getEmallUrl */])() + '/orderManage/myOrderList.htm';
		},
		generateQrCode: function generateQrCode() {
			var that = this;
			var canvas = document.getElementById('canvas');
			__WEBPACK_IMPORTED_MODULE_10_qrcode___default.a.toCanvas(canvas, that.code_url, {
				errorCorrectionLevel: "H",
				width: 300
			}, function (error) {
				if (error) console.error(error);
				console.log('success!');
			});
		},
		ListenPayStatus: function ListenPayStatus() {
			var that = this;
			debugger;
			that.interval = setInterval(function () {
				__WEBPACK_IMPORTED_MODULE_9__static_api_api_js__["a" /* default */].checkPayStatus(that.package_code, function (ret) {
					debugger;
					if (ret.code == "success") {
						clearInterval(that.interval);
						that.$router.push({ name: 'paySuccess', params: {} });
					} else if (ret.code == "fail") {
						__WEBPACK_IMPORTED_MODULE_6__static_js_alertConfirm_js__["a" /* default */].singleConfirm("查询支付订单异常！");
						clearInterval(that.interval);
					}
				});
			}, 2000);
		}
	},
	beforeMount: function beforeMount() {
		var that = this;
		if (this.$route.params.code_url != undefined) {
			that.code_url = this.$route.params.code_url;
		}
		if (this.$route.params.total_fee != undefined) {
			that.total_fee = this.$route.params.total_fee;
		}
		debugger;
		if (this.$route.params.package_code != undefined) {
			that.package_code = this.$route.params.package_code;
		}
	},
	beforeRouteLeave: function beforeRouteLeave(to, form, next) {
		clearInterval(this.interval);
		next();
	},
	mounted: function mounted() {
		window.scrollTo(0, 0);
		this.indexUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__static_js_emallUtils_js__["c" /* getCmsUrl */])();
		this.orderUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__static_js_emallUtils_js__["b" /* getEmallUrl */])() + '/orderManage/myOrderList.htm';
		this.generateQrCode();
		this.ListenPayStatus();
	}
});

/***/ }),

/***/ "fKuF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_payScanQrcode_vue__ = __webpack_require__("e+cu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3560817c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_payScanQrcode_vue__ = __webpack_require__("+LED");
function injectStyle (ssrContext) {
  __webpack_require__("/4jM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3560817c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_payScanQrcode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3560817c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_payScanQrcode_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fXcb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_emallUtils_js__ = __webpack_require__("spYF");

var API = {
  getImgPath: function getImgPath() {
    return __WEBPACK_IMPORTED_MODULE_1__js_emallUtils_js__["d" /* ajaxUrl */];
  },
  getPurchaserUrl: function getPurchaserUrl() {
    return __WEBPACK_IMPORTED_MODULE_1__js_emallUtils_js__["e" /* purchaserUrl */];
  },
  getBrandUrl: function getBrandUrl() {
    return __WEBPACK_IMPORTED_MODULE_1__js_emallUtils_js__["f" /* brandUrl */];
  },
  getRequirementUrl: function getRequirementUrl() {
    return __WEBPACK_IMPORTED_MODULE_1__js_emallUtils_js__["g" /* requirementUrl */];
  },
  getTradingHallUrl: function getTradingHallUrl() {
    return __WEBPACK_IMPORTED_MODULE_1__js_emallUtils_js__["h" /* tradingHallUrl */];
  },
  getNewsUrl: function getNewsUrl() {
    return __WEBPACK_IMPORTED_MODULE_1__js_emallUtils_js__["i" /* newsUrl */];
  },
  getExhibitionUrl: function getExhibitionUrl() {
    return __WEBPACK_IMPORTED_MODULE_1__js_emallUtils_js__["j" /* exhibitionUrl */];
  },
  //验证普通会员、国内采购商、国外采购商的信息是否完善
  vailUserInfo: function vailUserInfo(callback) {
    execute("/mobile/custom/vailUserInfo.htm", {}, callback);
  },
  //定制申请、打样申请
  customizeApply: function customizeApply(type, apply_type, customize_desc, remark, begin_delivery_time, quality_requirements, status, order_num, accessory_change_json, old_product_code, old_goods_sku_str, pic_name, pic_path, attachment_name, attachment_path, callback) {
    execute("/mobile/custom/customize_apply.htm", {
      type: type,
      apply_type: apply_type,
      customize_desc: customize_desc,
      remark: remark,
      begin_delivery_time: begin_delivery_time,
      quality_requirements: quality_requirements,
      status: status,
      order_num: order_num,
      accessory_change_json: accessory_change_json,
      old_product_code: old_product_code,
      old_goods_sku_str: old_goods_sku_str,
      pic_name: pic_name,
      pic_path: pic_path,
      attachment_name: attachment_name,
      attachment_path: attachment_path
    }, callback);
  },
  //查询商品列表
  getGoodsList: function getGoodsList(cabinetId, catCode, interval, currentPage, orderBy, orderAsc, shopCode, sortTime, pageSize, isQueryAll, goodsName, firstCatCode, brandId, productType, orderType, callback) {
    execute("/mobile/goods/ajax_goods_list.htm", {
      cabinetId: cabinetId,
      catCode: catCode,
      interval: interval,
      currentPage: currentPage,
      orderBy: orderBy,
      orderAsc: orderAsc,
      shopCode: shopCode,
      sortTime: sortTime,
      pageSize: pageSize,
      isQueryAll: isQueryAll,
      goodsName: goodsName,
      firstCatCode: firstCatCode,
      brandId: brandId,
      productType: productType,
      orderType: orderType
    }, callback);
  },
  //根据一级类目查询二级类目
  getCategoryListByCode: function getCategoryListByCode(parentCode, callback) {
    execute("/mobile/category/get_category_list.htm", {
      parentCode: parentCode
    }, callback);
  },
  //查询全部类目
  getAllCategoryMap: function getAllCategoryMap(productType, callback) {
    execute("/mobile/category/get_all_category_map.htm", {
      productType: productType
    }, callback);
  },
  //根据一级类目查询二级类目
  getBrandList: function getBrandList(callback) {
    execute("/mobile/brand/ajax_query_list.htm", {}, callback);
  },
  //查询实物商品详情
  getGoodPhysicalDetail: function getGoodPhysicalDetail(goodsCode, callback) {
    execute("/mobile/goods/ajax_goods_physical_detail.htm", {
      goodsCode: goodsCode
    }, callback);
  },

  //查询虚拟产品详情
  getGoodDetail: function getGoodDetail(goodsCode, callback) {
    execute("/mobile/goods/ajax_goods_detail.htm", {
      goodsCode: goodsCode
    }, callback);
  },

  //查询购物车总数
  getShoppingCartNum: function getShoppingCartNum(callback) {
    execute("/mobile/shoppingCart/ajax_total_num.htm", {}, callback);
  },
  getOrderCount: function getOrderCount(callback) {
    execute("/mobile/order/ajax_order_count.htm", {}, callback);
  },
  isExistCqPsd: function isExistCqPsd(callback) {
    execute("/mobile/user/cquc/exist_paypwd.htm", {}, callback);
  },
  checkCqPsd: function checkCqPsd(psd, callback) {
    execute("/mobile/user/cquc/check_paypwd.htm", {
      "pwdCode": psd
    }, callback);
  },
  //判断是否存在未支付订单
  checkUnpaidOrder: function checkUnpaidOrder(goodsCode, callback) {
    execute("/mobile/order/ajax_unpaid_is_exist.htm", {
      goodsCode: goodsCode
    }, callback);
  },

  //添加购物车
  addShoppingCart: function addShoppingCart(goodsCode, goodsNumber, supplerAccount, goodsAttrValue, sellerAccount, specName, specNameEn, callback) {
    execute("/mobile/shoppingCart/ajax_add.htm", {
      goodsCode: goodsCode,
      goodsNumber: goodsNumber,
      supplerAccount: supplerAccount,
      goodsAttrValue: goodsAttrValue,
      sellerAccount: sellerAccount,
      specName: specName,
      specNameEn: specNameEn
    }, callback);
  },
  //购物车列表
  getShoppingCartList: function getShoppingCartList(callback) {
    execute("/mobile/shoppingCart/ajax_shoppingCart_list.htm", {}, callback);
  },

  //登录
  login: function login(account, password, callback) {
    execute("/mobile/login/ajax_dologin.htm", {
      account: account,
      password: password
    }, callback);
  },

  loginOut: function loginOut(callback) {
    execute("/mobile/login/login_out.htm", {}, callback);
  },

  //获取验证码
  sendCode: function sendCode(mobile, callback) {
    execute("/mobile/sms/send_code.htm", {
      mobile: mobile
    }, callback);
  },

  //手机号登录
  mobileLogin: function mobileLogin(mobile, checkCode, callback) {
    execute("/mobile/login/mobile_login.htm", {
      mobile: mobile,
      checkCode: checkCode
    }, callback);
  },

  //获取用户地址信息列表
  queryUserAddress: function queryUserAddress(callback) {
    execute("/mobile/address/ajax_query_user_address.htm", {}, callback);
  },

  //获取指定ID的地址信息
  getOneAddress: function getOneAddress(addressId, callback) {
    execute("/mobile/address/ajax_get_one_address.htm", {
      addressId: addressId
    }, callback);
  },

  //获取地址信息
  setDefaultAddress: function setDefaultAddress(addressId, callback) {
    execute("/mobile/address/ajax_set_default_address.htm", {
      addressId: addressId
    }, callback);
  },
  //获取地址信息
  deleteAddress: function deleteAddress(addressId, callback) {
    execute("/mobile/address/ajax_delete_address.htm", {
      addressId: addressId
    }, callback);
  },

  //新增地址
  saveAddress: function saveAddress(province, city, district, address, mobile, contextName, isEdit, id, zipcode, callback) {
    execute("/mobile/address/ajax_save_address.htm", {
      province: province,
      city: city,
      district: district,
      address: address,
      mobile: mobile,
      contextName: contextName,
      isEdit: isEdit,
      id: id,
      zipcode: zipcode
    }, callback);
  },

  //订单列表
  getOrderList: function getOrderList(currentPage, orderStatus, statusList, orderTime, callback) {
    execute("/mobile/order/ajax_order_list.htm", {
      currentPage: currentPage,
      orderStatus: orderStatus,
      statusList: statusList,
      orderTime: orderTime
    }, callback);
  },

  //订单详情
  getOrderDetail: function getOrderDetail(id, tradeCode, callback) {
    execute("/mobile/order/ajax_order_detail.htm", {
      id: id,
      tradeCode: tradeCode
    }, callback);
  },

  //实物商品待确认订单
  getPhysicalOrderConfirm: function getPhysicalOrderConfirm(goodsCode, payNum, specName, couponSubCode, shopCode, callback) {
    execute("/mobile/order/ajax_order_physical_confirm.htm", {
      goodsCode: goodsCode,
      payNum: payNum,
      specName: specName,
      couponSubCode: couponSubCode,
      shopCode: shopCode
    }, callback);
  },

  //实物商品确认订单
  confirmPhysicalOrder: function confirmPhysicalOrder(tradeType, goodOrder, discountInfo, buyerNote, addressId, isOnline, couponCode, userAccount, profit, couponSubCode, orderSource, distributeName, distributeAccount, discountType, receiptId, produceNum, quality, inspectionType, remark, callback) {
    execute("/mobile/order/ajax_submit_order_physical_confirm.htm", {
      tradeType: tradeType,
      goodOrder: goodOrder,
      discountInfo: discountInfo,
      buyerNote: buyerNote,
      addressId: addressId,
      isOnline: isOnline,
      couponCode: couponCode,
      userAccount: userAccount,
      profit: profit,
      couponSubCode: couponSubCode,
      orderSource: orderSource,
      distributeName: distributeName,
      distributeAccount: distributeAccount,
      discountType: discountType,
      receiptId: receiptId,
      produceNum: produceNum,
      quality: quality,
      inspectionType: inspectionType,
      remark: remark
    }, callback);
  },
  //单店版本实物商品订单支付
  payPhysicalOrderCQSingleShop: function payPhysicalOrderCQSingleShop(packageCode, tradeCodes, callback) {
    execute("/mobile/fund/ajax_order_physical_pay_CQ_SingleShop.htm", {
      packageCode: packageCode,
      tradeCodes: tradeCodes
    }, callback);
  },
  //多店版本实物商品订单支付(产权资金)
  payPhysicalOrderCQMultiShop: function payPhysicalOrderCQMultiShop(packageCode, tradeCodes, callback) {
    execute("/mobile/fund/ajax_order_physical_pay_CQ_MultiShop.htm", {
      packageCode: packageCode,
      tradeCodes: tradeCodes
    }, callback);
  },
  //多店版本实物商品订单支付(自有资金)
  payPhysicalOrderMultiShop: function payPhysicalOrderMultiShop(packageCode, tradeCodes, terminalType, prodCode, bankCode, isWeiXin, callback) {
    execute("/mobile/fund/ajax_order_physical_pay_MultiShop.htm", {
      packageCode: packageCode,
      tradeCodes: tradeCodes,
      terminalType: terminalType,
      prodCode: prodCode,
      bankCode: bankCode,
      isWeiXin: isWeiXin
    }, callback);
  },
  //添加收藏
  addUserFavorite: function addUserFavorite(favoriteType, goodsCode, shopCode, callback) {
    execute("/mobile/favorite/ajax_add.htm", {
      favoriteType: favoriteType,
      goodsCode: goodsCode,
      shopCode: shopCode
    }, callback);
  },
  //取消收藏
  deleteUserFavorite: function deleteUserFavorite(goodsCode, shopCode, callback) {
    execute("/mobile/favorite/ajax_delete.htm", {
      goodsCode: goodsCode,
      shopCode: shopCode
    }, callback);
  },
  //删除收藏
  deleteFavoriteBycode: function deleteFavoriteBycode(favoriteType, goodsCode, shopCode, callback) {
    execute("/mobile/favorite/ajax_delete.htm", {
      favoriteType: favoriteType,
      goodsCode: goodsCode,
      shopCode: shopCode
    }, callback);
  },
  //收藏是否存在
  isExistFavorite: function isExistFavorite(favoriteType, goodsCode, shopCode, callback) {
    execute("/mobile/favorite/ajax_isExist.htm", {
      favoriteType: favoriteType,
      goodsCode: goodsCode,
      shopCode: shopCode
    }, callback);
  },
  //虚拟商品待确认订单
  getOrderConfirm: function getOrderConfirm(goodsCode, payNum, couponSubCode, callback) {
    execute("/mobile/order/ajax_order_confirm.htm", {
      goodsCode: goodsCode,
      payNum: payNum
    }, callback);
  },

  //虚拟商品确认订单
  confirmOrder: function confirmOrder(goodOrder, discountInfo, buyerNote, isOnline, orderSource, callback) {
    execute("/mobile/order/ajax_submit_order_confirm.htm", {
      goodOrder: goodOrder,
      discountInfo: discountInfo,
      buyerNote: buyerNote,
      isOnline: isOnline,
      orderSource: orderSource
    }, callback);
  },

  //修改密码
  changePwd: function changePwd(pwd, againPwd, mobile, checkCode, callback) {
    execute("/mobile/user/change_pwd.htm", {
      password: pwd,
      confirmPassword: againPwd,
      mobile: mobile,
      checkCode: checkCode
    }, callback);
  },
  //查询用户个人中心信息
  getUserInfo: function getUserInfo(callback) {
    execute("/mobile/user/ajax_user_info.htm", {}, callback);
  },

  cancelOrder: function cancelOrder(id, orderType, callback) {
    execute("/mobile/order/ajax_order_close.htm", {
      id: id,
      orderType: orderType
    }, callback);
  },
  //删除购物车的商品
  deleteGoods: function deleteGoods(ids, goodsCodes, callback) {
    execute("/mobile/shoppingCart/ajax_batch_delete.htm", {
      goodsCodes: goodsCodes,
      ids: ids
    }, callback);
  },
  //计算购物车商品金额
  sumGoodsPrice: function sumGoodsPrice(goodsCodes, addressId, specNames, goodsNumbers, deliveryTypes, callback) {
    execute("/mobile/shoppingCart/ajax_sumShoppingCartGoodsPrice.htm", {
      goodsCodes: goodsCodes,
      addressId: addressId,
      specNames: specNames,
      goodsNumbers: goodsNumbers,
      deliveryTypes: deliveryTypes
    }, callback);
  },
  //修改购物车的商品数量
  updateGoodsCount: function updateGoodsCount(goodsCode, goodsNumber, id, callback) {
    execute("/mobile/shoppingCart/ajax_update_shoppingCartCount.htm", {
      goodsCode: goodsCode,
      goodsNumber: goodsNumber,
      id: id
    }, callback);
  },
  //修改购物车的商品数量
  getUserAddress: function getUserAddress(callback) {
    execute("/mobile/shoppingCart/user_address.htm", {}, callback);
  },
  //获取购物车的商品
  getCartList: function getCartList(callback) {
    execute("/mobile/shoppingCart/ajax_list.htm", {}, callback);
  },
  getCartListByCode: function getCartListByCode(goodsCodes, specNames, addressId, callback) {
    execute("/mobile/shoppingCart/ajax_shoppingCart_list_by_code.htm", {
      goodsCodes: goodsCodes,
      specNames: specNames,
      addressId: addressId
    }, callback);
  },
  getWeixinPackage: function getWeixinPackage(tradeCode, id, orderSrc, callback) {
    execute("/mobile/pay/weixin/data_package.htm", {
      tradeCode: tradeCode,
      id: id,
      orderSrc: orderSrc
    }, callback);
  },
  //查询用户积分
  getPointsDetail: function getPointsDetail(allcurrentPage, registcurrentPage, usecurrentPage, transCode, queryType, isFirst, pointType, pageSize, callback) {
    execute("/mobile//points/ajax_points_detail.htm", {
      allcurrentPage: allcurrentPage,
      registcurrentPage: registcurrentPage,
      usecurrentPage: usecurrentPage,
      transCode: transCode,
      queryType: queryType,
      isFirst: isFirst,
      pointType: pointType,
      pageSize: pageSize
    }, callback);
  },
  //购物车确认订单
  confirmCartOrder: function confirmCartOrder(goodOrder, discountInfo, buyerNote, addressId, isOnline, couponCode, userAccount, profit, couponSubCode, orderSrc, orderSource, callback) {
    execute("/mobile/order/ajax_submit_order_physical_confirm.htm", {
      goodOrder: goodOrder,
      discountInfo: discountInfo,
      buyerNote: buyerNote,
      addressId: addressId,
      isOnline: isOnline,
      couponCode: couponCode,
      userAccount: userAccount,
      profit: profit,
      couponSubCode: couponSubCode,
      orderSrc: orderSrc,
      orderSource: orderSource
    }, callback);
  },
  //首页数据查询
  getIndexInfo: function getIndexInfo(token, exchangeId, code, state, callback) {
    execute("/mobile/home/ajax_index.htm", {
      token: token,
      exchangeId: exchangeId,
      code: code,
      state: state
    }, callback);
  },
  //确认收货
  confirmReceived: function confirmReceived(tradeCode, callback) {
    execute("/mobile/order/receive_goods.htm", {
      tradeCode: tradeCode
    }, callback);
  },

  getUserAddresses: function getUserAddresses(callback) {
    execute("/mobile/address/ajax_get_address.htm", {}, callback);
  },

  getTradeInfo: function getTradeInfo(tradeCode, callback) {
    execute("/mobile/order/order_tradeInfo.htm", {
      tradeCode: tradeCode
    }, callback);
  },

  getShopInfo: function getShopInfo(shopCode, callback) {
    execute("/mobile/shop/ajax_shop.htm", {
      shopCode: shopCode
    }, callback);
  },

  /*查询店铺首页广告*/
  getShopIndexAds: function getShopIndexAds(shopCode, callback) {
    execute("/mobile/shop/ajax_shop_index_ads.htm", {
      shopCode: shopCode
    }, callback);
  },

  /*查询店铺首页友情链接*/
  getShopIndexLinks: function getShopIndexLinks(shopCode, callback) {
    execute("/mobile/shop/ajax_shop_index_links.htm", {
      shopCode: shopCode
    }, callback);
  },

  /*查询店铺评分*/
  getShopRate: function getShopRate(shopCode, callback) {
    execute("/mobile/shop/ajax_shop_rate.htm", {
      shopCode: shopCode
    }, callback);
  },

  getGoodCredits: function getGoodCredits(goodsCode, currentPage, pageSize, callback) {
    execute("/mobile/credit/ajax_goods_credit.htm", {
      goodsCode: goodsCode,
      currentPage: currentPage,
      pageSize: pageSize
    }, callback);
  },
  //查询首页广告及类目
  getIndex: function getIndex(callback) {
    execute("/mobile/home/ajax_index_info.htm", {}, callback);
  },
  //查询店铺列表
  getShopList: function getShopList(shopName, currentPage, shopType, pageSize, callback) {
    execute("/mobile/shop/ajax_shop_list.htm", {
      shopName: shopName,
      currentPage: currentPage,
      shopType: shopType,
      pageSize: pageSize
    }, callback);
  },
  //查询所有类目
  getAllCat: function getAllCat(productType, callback) {
    execute("/mobile/home/ajax_query_cat.htm", {
      productType: productType
    }, callback);
  },
  //查询首页橱窗
  getIndexCabinet: function getIndexCabinet(callback) {
    execute("/mobile/home/ajax_query_cabinet.htm", {}, callback);
  },
  getNews: function getNews(callback) {
    execute("http://www.crtp.test:28020/sckb/index.htm?_=", {
      _: '999'
    }, callback);
  },
  getShopGoodsByCat: function getShopGoodsByCat(shopCode, catCode, parentCode, callback) {
    execute("/mobile/shop/ajax_cat_goods.htm", {
      shopCode: shopCode,
      catCode: catCode,
      parentCode: parentCode
    }, callback);
  },
  viewGoodsDetail: function viewGoodsDetail(goodsCode, callback) {
    execute("/mobile/goods/ajax_view_goods_detail.htm", {
      goodsCode: goodsCode
    }, callback);
  },
  //计算运费
  computeExpressFee: function computeExpressFee(addressId, goodOrder, orderSource, callback) {
    execute("/mobile/express/ajax_computeExpressFee.htm", {
      addressId: addressId,
      goodOrder: goodOrder,
      orderSource: orderSource
    }, callback);
  },

  //查询门店列表
  getStoreList: function getStoreList(pointStr, city, callback) {
    execute("/mobile/order/ajax_store_list.htm", {
      pointStr: pointStr,
      city: city
    }, callback);
  },
  //查询首页推荐商品
  getRecommendGoods: function getRecommendGoods(pageSize, src, callback) {
    execute("/mobile/home/ajax_recommend_goods.htm", {
      pageSize: pageSize,
      src: src
    }, callback);
  },
  //查询首页推荐店铺
  getRecommendShops: function getRecommendShops(pageSize, src, callback) {
    execute("/mobile/home/ajax_recommend_shops.htm", {
      pageSize: pageSize,
      src: src
    }, callback);
  },
  //查询首页广告
  getIndexAds: function getIndexAds(callback) {
    execute("/mobile/home/ajax_index_ads.htm", {}, callback);
  },
  //获取首页秒杀活动
  getSeckillActivityList: function getSeckillActivityList(callback) {
    execute("/mobile/activity/ajax_get_seckill_list.htm", {}, callback);
  },
  getSeckillgoodsList: function getSeckillgoodsList(activityCode, currentPage, pageSize, callback) {
    execute("/mobile/activity/ajax_get_seckill_goods.htm", {
      activityCode: activityCode,
      currentPage: currentPage,
      pageSize: pageSize
    }, callback);
  },
  //获取不同类型的发票类型
  getReceiptList: function getReceiptList(callback) {
    execute("/mobile/receipt/ajax_get_receipt_list.htm", {}, callback);
  },
  //保存企业发票
  saveReceipt: function saveReceipt(id, receiptType, receiptTitle, taxpayerNum, address, phone, openBank, openBankAccount, callback) {
    execute("/mobile/receipt/save_receipt.htm", {
      id: id,
      receiptType: receiptType,
      receiptTitle: receiptTitle,
      taxpayerNum: taxpayerNum,
      address: address,
      phone: phone,
      openBank: openBank,
      openBankAccount: openBankAccount
    }, callback);
  },
  checkPayStatus: function checkPayStatus(orderNo, callback) {
    execute("/mobile/order/pay_status.htm", {
      orderNo: orderNo
    }, callback);
  }
};



function execute(func, params, callback) {
  function _callback(ret) {
    callback(ret);
  }
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resove, reject) {
    jQuery.ajax({
      type: "get",
      url: __WEBPACK_IMPORTED_MODULE_1__js_emallUtils_js__["d" /* ajaxUrl */] + func,
      async: false,
      dataType: "jsonp", // 返回的数据类型，设置为JSONP方式
      data: params,
      success: _callback,
      error: function error(err) {
        reject(err);
      }
    });
  }).catch(function (err) {
    console.log("<<<<<<<<接口报错，func：" + func + " params：" + params + " err：" + err);
  });
}

//module.exports = API;
/* harmony default export */ __webpack_exports__["a"] = (API);
var jsonp_callback;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "gTlp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterMenu_vue__ = __webpack_require__("dcIM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ea9f91a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_FooterMenu_vue__ = __webpack_require__("JXyc");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ea9f91a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_FooterMenu_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gWNQ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "gkCg":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {// JavaScript Document
$(function () {
	//我的购物车
	$(".header .mycart").hover(function () {
		$(this).addClass("hover");
		$(this).find(".goods-list").show();
	}, function () {
		$(this).removeClass("hover");
		$(this).find(".goods-list").hide();
	});

	//分类
	//	$(".sc-submenu ul li").hover(function(){
	//		var index= $(this).index();
	//		$(this).addClass("hover");
	//		$(this).find(".sc-submenu-all").show();
	//	},function(){
	//		$(this).removeClass("hover");
	//		$(this).find(".sc-submenu-all").hide();
	//		});	
	//	
	//	$(".sc-submenu").mouseleave(function(){
	//		$(".sc-submenu").hide();
	//	});
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "gwPj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "indexbg"
  }, [_c('topbar'), _vm._v(" "), _c('sortHeader'), _vm._v(" "), _c('div', {
    staticClass: "clear mt15"
  }), _vm._v(" "), _c('div', {
    staticClass: "w1200 bc"
  }, [_c('div', {
    staticClass: "hq-shopping-cart"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tipsbox success"
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v(" "), _c('h3', [_vm._v("恭喜您，下单成功！")]), _vm._v(" "), _c('div', {
    staticClass: "ft"
  }, [_c('a', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.viewAllOrders()
      }
    }
  }, [_vm._v("查看全部订单")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("返回首页")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('footermenu'), _vm._v(" "), _c('footercopyright')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hq-reg-step"
  }, [_c('ul', {
    staticClass: "ico"
  }, [_c('li', [_c('p', {
    staticClass: "item"
  }, [_vm._v("购物车")]), _vm._v(" "), _c('i', {
    staticClass: "step-count"
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "line"
  })]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "item"
  }, [_vm._v("提交订单")]), _vm._v(" "), _c('i', {
    staticClass: "step-count"
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "line"
  })]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "item"
  }, [_vm._v("确认付款")]), _vm._v(" "), _c('i', {
    staticClass: "step-count"
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "line"
  })]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('p', {
    staticClass: "item"
  }, [_vm._v("下单成功")]), _vm._v(" "), _c('i', {
    staticClass: "step-count"
  })])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb20 ad-4 mt20"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("dlf8"),
      "width": "1200",
      "height": "60"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hV6H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShopNav_vue__ = __webpack_require__("NowL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_272f49c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ShopNav_vue__ = __webpack_require__("4s7B");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShopNav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_272f49c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ShopNav_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jCf5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "indexbg"
  }, [_c('topbar'), _vm._v(" "), _c('header'), _vm._v(" "), _c('emallheader'), _vm._v(" "), _c('div', {
    staticClass: "clear mt15"
  }), _vm._v(" "), _c('div', {
    staticClass: "w1200 bc"
  }, [_c('div', {
    staticClass: "hq-shopping-cart"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "bd-box fill-address"
  }, [_vm._m(1), _vm._v(" "), _c('dt', {
    staticClass: "dt-jsz"
  }, [_vm._v("寄送至")]), _vm._v(" "), _vm._l((_vm.addressBoList), function(addressBo, index) {
    return _c('div', [_c('dl', {
      staticClass: "active dl-active",
      staticStyle: {
        "color": "#666"
      },
      attrs: {
        "name": "addressNode",
        "id": 'dl_' + addressBo.id
      }
    }, [_c('dd', [_c('a', {
      staticClass: "co-b-2 edit-addr fr",
      on: {
        "click": function($event) {
          _vm.editAddress(addressBo.id)
        }
      }
    }, [_vm._v("修改本地址")]), _vm._v(" "), _c('input', {
      attrs: {
        "name": "addressChk",
        "type": "radio"
      },
      domProps: {
        "value": addressBo.id,
        "checked": addressBo.id == _vm.addressId
      },
      on: {
        "click": function($event) {
          _vm.chooseAddress(addressBo.id, index)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "addr"
    }, [_vm._v(_vm._s(addressBo.province) + " " + _vm._s(addressBo.city) + " " + _vm._s(addressBo.district) + " " + _vm._s(addressBo.address) + "（" + _vm._s(addressBo.contextName) + " 收）")]), _vm._v(" "), _c('span', {
      staticClass: "tel"
    }, [_vm._v(_vm._s(addressBo.mobile))]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "hidden",
        "id": "addressId"
      },
      domProps: {
        "value": addressBo.contextName
      }
    })])])])
  }), _vm._v(" "), (_vm.canCreateAddress) ? _c('div', {
    staticClass: "ft-add-addr"
  }, [_c('a', {
    staticClass: "co-b-2 add-addr",
    on: {
      "click": function($event) {
        _vm.addAddress()
      }
    }
  }, [_c('i', [_vm._v("+")]), _vm._v("使用新地址")])]) : _vm._e()], 2), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "bd-box fill-ordering mt20"
  }, [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "bd"
  }, [_vm._l((_vm.shopBoList), function(shop, index) {
    return _c('div', {
      staticClass: "items"
    }, [_vm._l((shop.boListIn), function(bo) {
      return _c('dl', [_c('dd', {
        staticClass: "col-1"
      }, [_c('img', {
        staticClass: "fl",
        attrs: {
          "src": bo.imgSmall,
          "width": "75",
          "height": "75"
        }
      }), _vm._v(" "), _c('a', {
        staticClass: "co-b-2 name",
        on: {
          "click": function($event) {
            _vm.toDetail(bo.goodsCode)
          }
        }
      }, [_vm._v(_vm._s(bo.goodsName))]), _vm._v(" "), (bo.seven_day_return == 'Y' || bo.sevenDayReturn == 'Y') ? _c('span', {
        staticClass: "co-b-2 name",
        staticStyle: {
          "padding-top": "10px"
        }
      }, [_c('i', {
        staticClass: "ico-sp-tk"
      }), _vm._v("支持7天无理由退货服务")]) : _vm._e()]), _vm._v(" "), _c('dd', {
        staticClass: "col-2 sp-meta"
      }, _vm._l((bo.deliveryTypeArray), function(typeItem) {
        return (typeItem != null && typeItem != '') ? _c('span', {
          staticClass: "td-txt",
          class: {
            selected: typeItem.typeCode == bo.deliveryType
          },
          on: {
            "click": function($event) {
              _vm.chooseDeliveryType(typeItem.typeCode, bo)
            }
          }
        }, [_vm._v(_vm._s(typeItem.typeName))]) : _vm._e()
      })), _vm._v(" "), (bo.unitPrice > 0 && bo.goodsPrice == 0) ? _c('dd', {
        staticClass: "col-3 co4"
      }, [_vm._v("￥" + _vm._s(bo.unitPrice))]) : (bo.unitPrice == 0 && bo.goodsPrice > 0) ? _c('dd', {
        staticClass: "col-3 co4"
      }, [_vm._v(_vm._s(bo.goodsPrice) + "\n\t\t\t\t\t\t\t\t"), (bo.pointType == 'point') ? _c('span', [_vm._v("积分")]) : (bo.pointType == 'special') ? _c('span', [_vm._v("专用积分")]) : (bo.pointType == 'red') ? _c('span', [_vm._v("红积分")]) : (bo.pointType == 'blue') ? _c('span', [_vm._v("蓝积分")]) : _vm._e()]) : (bo.unitPrice > 0 && bo.goodsPrice > 0) ? _c('dd', {
        staticClass: "col-3 co4"
      }, [_vm._v("\n\t\t\t\t\t\t\t\t￥" + _vm._s(bo.unitPrice) + " + " + _vm._s(bo.goodsPrice) + "\n\t\t\t\t\t\t\t\t"), (bo.pointType == 'point') ? _c('span', [_vm._v("积分")]) : (bo.pointType == 'special') ? _c('span', [_vm._v("专用积分")]) : (bo.pointType == 'red') ? _c('span', [_vm._v("红积分")]) : (bo.pointType == 'blue') ? _c('span', [_vm._v("蓝积分")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('dd', {
        staticClass: "col-4 co4"
      }, [_vm._v("￥" + _vm._s((_vm.printServicePara + _vm.rebrandingServicePara + _vm.printingServicePara + _vm.laserServicePara) / 100))]), _vm._v(" "), _c('dd', {
        staticClass: "col-5 co4",
        attrs: {
          "name": "number"
        }
      }, [_vm._v(_vm._s(bo.goodsNumber))]), _vm._v(" "), _c('dd', {
        staticClass: "col-6 co-r-1 f14"
      }, [(bo.unitPrice > 0) ? _c('span', {
        attrs: {
          "name": "unitPrice"
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t￥" + _vm._s(((bo.unitPrice + (_vm.printServicePara + _vm.rebrandingServicePara + _vm.printingServicePara + _vm.laserServicePara) / 100) * bo.goodsNumber).toFixed(2)) + "\n\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (bo.unitPrice > 0 && bo.goodsPrice > 0) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t+\n\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (bo.goodsPrice > 0) ? _c('span', {
        attrs: {
          "name": "goodsPrice"
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s((bo.goodsPrice * bo.goodsNumber)) + "\n\t\t\t\t\t\t\t\t\t"), (bo.pointType == 'point') ? _c('span', [_vm._v("积分")]) : (bo.pointType == 'special') ? _c('span', [_vm._v("专用积分")]) : (bo.pointType == 'red') ? _c('span', [_vm._v("红积分")]) : (bo.pointType == 'blue') ? _c('span', [_vm._v("蓝积分")]) : _vm._e()]) : _vm._e()])])
    }), _vm._v(" "), (shop.expressFee > 0 && _vm.goodsBo.deliveryType != 'self_take') ? _c('div', {
      staticClass: "hd",
      staticStyle: {
        "background": "#f9f8fa",
        "height": "30px",
        "line-height": "30px"
      }
    }, [_c('dl', [_vm._m(5, true), _vm._v(" "), _c('dt', {
      staticClass: "col-3",
      staticStyle: {
        "visibility": "hidden"
      }
    }, [_vm._v("单价")]), _vm._v(" "), _c('dt', {
      staticClass: "col-4",
      staticStyle: {
        "visibility": "hidden"
      }
    }, [_vm._v("数量")]), _vm._v(" "), _c('dt', {
      staticClass: "col-2",
      staticStyle: {
        "visibility": "hidden"
      }
    }, [_vm._v("服务费")]), _vm._v(" "), _c('dt', {
      staticClass: "col-5",
      staticStyle: {
        "color": "#e3101e"
      }
    }, [_vm._v("运费：￥" + _vm._s((shop.expressFee / 100).toFixed(2)))])])]) : _vm._e()], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "total tr co5"
  }, [_vm._v("\n\t\t\t\t\t\t已选"), _c('span', {
    staticClass: "m10"
  }, [_vm._v(_vm._s(_vm.sumCount))]), _vm._v("件商品 合计：\n\t\t\t\t\t\t"), (_vm.goodsTotalPrice.totalPoint > 0) ? _c('span', {
    staticClass: "co-o-1 f18"
  }, [_vm._v(_vm._s(_vm.goodsTotalPrice.totalPoint) + "积分"), (_vm.sumOrderAmount > 0) ? _c('span', [_vm._v("+")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.goodsTotalPrice.totalRed > 0) ? _c('span', {
    staticClass: "co-o-1 f18"
  }, [_vm._v(_vm._s(_vm.goodsTotalPrice.totalRed) + "红积分+")]) : _vm._e(), _vm._v(" "), (_vm.goodsTotalPrice.totalBlue > 0) ? _c('span', {
    staticClass: "co-o-1 f18"
  }, [_vm._v(_vm._s(_vm.goodsTotalPrice.totalBlue) + "蓝积分+")]) : _vm._e(), _vm._v(" "), (_vm.goodsTotalPrice.totalSpecial > 0) ? _c('span', {
    staticClass: "co-o-1 f18"
  }, [_vm._v(_vm._s(_vm.goodsTotalPrice.totalSpecial) + "专用积分+")]) : _vm._e(), _vm._v(" "), (_vm.usableCouponList != '') ? _c('span', {
    staticClass: "co-o-1 f18"
  }, [(_vm.sumOrderAmount > 0) ? _c('span', [_vm._v("￥" + _vm._s((_vm.sumOrderAmount).toFixed(2)))]) : _vm._e(), (_vm.totalExpressAmount > 0 && _vm.goodsBo.deliveryType != 'self_take') ? _c('span', [_vm._v("+￥" + _vm._s((_vm.totalExpressAmount / 100).toFixed(2)))]) : _vm._e(), (_vm.couponDiscountAmount > 0) ? _c('span', [_vm._v("-￥" + _vm._s((_vm.couponDiscountAmount / 100).toFixed(2)))]) : _vm._e()]) : _c('span', {
    staticClass: "co-o-1 f18"
  }, [(_vm.sumOrderAmount > 0) ? _c('span', [_vm._v("￥" + _vm._s((_vm.sumOrderAmount).toFixed(2)))]) : _vm._e(), (_vm.totalExpressAmount > 0 && _vm.goodsBo.deliveryType != 'self_take') ? _c('span', [_vm._v("+￥" + _vm._s((_vm.totalExpressAmount / 100).toFixed(2)))]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.brokerDiscountAmount > 0 && _vm.discountType == 'broker_level') ? _c('span', [_vm._v("会员折扣：")]) : _vm._e(), (_vm.brokerDiscountAmount > 0 && _vm.discountType == 'broker_level') ? _c('span', {
    staticClass: "co-o-1 f18"
  }, [_vm._v("-￥" + _vm._s((_vm.brokerDiscountAmount / 100).toFixed(2)))]) : _vm._e(), _vm._v(" "), (_vm.orderSource == 'cart') ? _c('p', {
    staticClass: "mt15"
  }, [_c('router-link', {
    staticClass: "co-b-1 f14",
    attrs: {
      "to": {
        path: '/shopCart'
      },
      "href": "#"
    }
  }, [_vm._v("返回购物车 >")])], 1) : _vm._e()]), _vm._v(" "), _vm._l((_vm.points), function(pointBo, index) {
    return (pointBo.discountMoney > 0 && _vm.seckillPrice == '') ? _c('div', {
      staticClass: "total tr co5"
    }, [_c('span', {
      staticStyle: {
        "line-height": "1.5rem"
      }
    }, [_vm._v("使用\n\t\t\t\t\t\t\t\t" + _vm._s(pointBo.usableNum) + "积分抵用\n\t\t\t\t\t\t\t\t" + _vm._s(pointBo.discountMoney) + "元")]), _vm._v(" "), _c('div', {
      staticClass: "mui-left mui-ellipsis",
      staticStyle: {
        "float": "right"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pointBo.is_choosed),
        expression: "pointBo.is_choosed"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(pointBo.is_choosed) ? _vm._i(pointBo.is_choosed, null) > -1 : (pointBo.is_choosed)
      },
      on: {
        "click": function($event) {
          _vm.chkDiscount()
        },
        "__c": function($event) {
          var $$a = pointBo.is_choosed,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (pointBo.is_choosed = $$a.concat([$$v]))
            } else {
              $$i > -1 && (pointBo.is_choosed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            pointBo.is_choosed = $$c
          }
        }
      }
    })])]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "fill-ordering-ft"
  }, [_vm._v("\n\t\t\t\t订单消费总计：\n\t\t\t\t"), (_vm.discountType == 'point' && (_vm.pointNum + _vm.goodsTotalPrice.totalPoint) > 0) ? _c('span', {
    staticClass: "f20 co2"
  }, [_vm._v(_vm._s(_vm.pointNum + _vm.goodsTotalPrice.totalPoint) + "积分"), (_vm.sumAmount > 0) ? _c('span', [_vm._v("+")]) : _vm._e()]) : (_vm.discountType != 'point' && _vm.goodsTotalPrice.totalPoint > 0) ? _c('span', {
    staticClass: "f20 co2"
  }, [_vm._v(_vm._s(_vm.goodsTotalPrice.totalPoint) + "积分"), (_vm.sumAmount > 0) ? _c('span', [_vm._v("+")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.goodsTotalPrice.totalRed > 0) ? _c('span', {
    staticClass: "f20 co2"
  }, [_vm._v(_vm._s(_vm.goodsTotalPrice.totalRed) + "红积分"), (_vm.sumAmount > 0) ? _c('span', [_vm._v("+")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.goodsTotalPrice.totalBlue > 0) ? _c('span', {
    staticClass: "f20 co2"
  }, [_vm._v(_vm._s(_vm.goodsTotalPrice.totalBlue) + "蓝积分"), (_vm.sumAmount > 0) ? _c('span', [_vm._v("+")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.goodsTotalPrice.totalSpecial > 0) ? _c('span', {
    staticClass: "f20 co2"
  }, [_vm._v(_vm._s(_vm.goodsTotalPrice.totalSpecial) + "专用积分"), (_vm.sumAmount > 0) ? _c('span', [_vm._v("+")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.goodsBo.deliveryType == 'self_take' && (_vm.sumOrderAmount - _vm.discountAmount) > 0) ? _c('span', {
    staticClass: "f20 co2"
  }, [_vm._v("¥" + _vm._s((_vm.sumOrderAmount - _vm.discountAmount).toFixed(2)))]) : (_vm.goodsBo.deliveryType != 'self_take' && (_vm.sumOrderAmount - _vm.discountAmount + _vm.totalExpressAmount / 100) > 0) ? _c('span', {
    staticClass: "f20 co2"
  }, [_vm._v("¥" + _vm._s((_vm.sumOrderAmount - _vm.discountAmount + _vm.totalExpressAmount / 100).toFixed(2)))]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "a-btn-submit ml20",
    on: {
      "click": function($event) {
        _vm.submitOrderExt()
      }
    }
  }, [_vm._v("提交订单")])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "ui-mask",
    staticStyle: {
      "display": "none"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui-dialog",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "mainId"
    }
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "ui-dialog-content"
  }, [_c('div', {
    staticClass: "invoice-dialog",
    attrs: {
      "id": "invoice-tab"
    }
  }, [_c('div', {
    staticClass: "tab-nav"
  }, [_c('ul', [_c('li', {
    staticClass: "tab-nav-item tab-item-selected",
    attrs: {
      "id": "click_2"
    },
    on: {
      "click": function($event) {
        _vm.change2()
      }
    }
  }, [_vm._v("企业发票"), _c('b')]), _vm._v(" "), _c('li', {
    staticClass: "tab-nav-item",
    attrs: {
      "id": "click_3"
    },
    on: {
      "click": function($event) {
        _vm.change3()
      }
    }
  }, [_vm._v("增值税专用发票"), _c('b')])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-con ui-switchable-panel-selected",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "id": "ele-inv"
    }
  }, [_c('div', {
    staticClass: "form"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "invoice_ceshi1",
      "name": "invoice_ceshi1",
      "value": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("发票抬头")]), _vm._v(" "), _c('div', {
    staticClass: "fl"
  }, [_c('div', {
    staticClass: "invoice-list invoice-tit-list",
    attrs: {
      "id": "invoice-tit-list_lest"
    }
  }, [_c('div', {
    staticClass: "invoice-item rise invoice-item-selected",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.selectTitle($event, '-1', '')
      }
    }
  }, [_vm._m(9)]), _vm._v(" "), _vm._l((_vm.enterpriseList), function(enterprise) {
    return _c('div', {
      staticClass: "invoice-item rise",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.selectTitle($event, enterprise.id, enterprise.taxpayerNum)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "id": "invoice-2"
      }
    }, [_c('input', {
      staticClass: "itxt",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "text",
        "id": "fff",
        "readonly": "true"
      },
      domProps: {
        "value": enterprise.receiptTitle
      }
    }), _c('b')])])
  }), _vm._v(" "), _c('div', {
    staticClass: "invoice-item rise",
    staticStyle: {
      "cursor": "pointer",
      "display": "none"
    },
    attrs: {
      "id": "newReceiptTitle"
    },
    on: {
      "click": function($event) {
        _vm.selectTitle($event, '0', '')
      }
    }
  }, [_vm._m(10)])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "item nor-inv-type0",
    attrs: {
      "id": "addEnterpriseRecipes"
    },
    on: {
      "click": function($event) {
        _vm.addEnterprise()
      }
    }
  }, [_c('span', {
    staticClass: "label"
  }), _vm._v(" "), _vm._m(11)]), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "item invoice_content"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("发票内容")]), _vm._v(" "), _c('div', {
    staticClass: "fl"
  }, [_c('div', {
    staticClass: "invoice-list"
  }, [_c('ul', {
    attrs: {
      "id": "electro_book_content_radio"
    }
  }, [_c('li', {
    staticClass: "invoice-item invoice-item-selected",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "electro-invoice-content-1"
    },
    on: {
      "click": _vm.contentTab1
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t不开发票"), _c('b')]), _vm._v(" "), _c('li', {
    staticClass: "invoice-item",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "electro-invoice-content-2",
      "name": "electro-normalContent",
      "value": "1",
      "data-desc": "发票内容将显示详细商品名称与价格信息"
    },
    on: {
      "click": _vm.contentTab2
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t商品明细"), _c('b')])]), _vm._v(" "), _vm._m(13)])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "fl"
  }, [_c('div', {
    staticClass: "op-btns"
  }, [_c('a', {
    staticClass: "btn-1",
    on: {
      "click": function($event) {
        _vm.saveReceipt()
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('a', {
    staticClass: "btn-9 ml10",
    on: {
      "click": function($event) {
        _vm.closemodal()
      }
    }
  }, [_vm._v("取消")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-con",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "vat-inv"
    }
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "form",
    attrs: {
      "id": "invoice-box-03"
    }
  }, [_c('div', {
    staticClass: "steps"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("单位名称")]), _vm._v(" "), _c('div', {
    staticClass: "fl"
  }, [_c('div', {
    staticClass: "invoice-list invoice-tit-list zy",
    attrs: {
      "id": "invoice-tit-list_lest1"
    }
  }, [_c('div', {
    staticClass: "invoice-item rise1 invoice-item-selected",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.selectTitle1($event, '-1', '')
      }
    }
  }, [_vm._m(15)]), _vm._v(" "), _vm._l((_vm.specialList), function(special) {
    return _c('div', {
      staticClass: "invoice-item rise1",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.selectTitle1($event, special.id, special.taxpayerNum, special.address, special.phone, special.openBank, special.openBankAccount)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "id": "invoice-2"
      }
    }, [_c('input', {
      staticClass: "itxt",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "text",
        "id": "fff",
        "readonly": "true"
      },
      domProps: {
        "value": special.receiptTitle
      }
    }), _c('b')])])
  }), _vm._v(" "), _c('div', {
    staticClass: "invoice-item rise1",
    staticStyle: {
      "cursor": "pointer",
      "display": "none"
    },
    attrs: {
      "id": "newReceiptTitle1"
    },
    on: {
      "click": function($event) {
        _vm.selectTitle1($event, '0', '')
      }
    }
  }, [_vm._m(16)])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "item nor-inv-type0",
    attrs: {
      "id": "addEnterpriseRecipes1"
    },
    on: {
      "click": function($event) {
        _vm.addEnterprise1()
      }
    }
  }, [_c('span', {
    staticClass: "label"
  }), _vm._v(" "), _vm._m(17)]), _vm._v(" "), _c('div', {
    staticClass: "step vat-inv-type0 vat-inv-type1",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "vat-inv-type1"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "id": "vatCanEdit",
      "value": "false"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "id": "vat_code_div"
    }
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "fl"
  }, [_c('input', {
    staticClass: "itxt itxt04 vat-step-1",
    attrs: {
      "type": "text",
      "name": "vat_code",
      "id": "vat_code",
      "value": ""
    },
    on: {
      "blur": function($event) {
        _vm.check_Invoice('vat_code', $event)
      },
      "change": function($event) {
        _vm.check_Invoice('vat_code', $event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "message ",
    attrs: {
      "id": "vat_code_error"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "id": "vat_address_div"
    }
  }, [_vm._m(19), _vm._v(" "), _c('div', {
    staticClass: "fl"
  }, [_c('input', {
    staticClass: "itxt itxt04 vat-step-1",
    attrs: {
      "type": "text",
      "name": "vat_address",
      "id": "vat_address",
      "value": ""
    },
    on: {
      "blur": function($event) {
        _vm.check_Invoice('vat_address', $event)
      },
      "change": function($event) {
        _vm.check_Invoice('vat_address', $event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "message ",
    attrs: {
      "id": "vat_address_error"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "id": "vat_phone_div"
    }
  }, [_vm._m(20), _vm._v(" "), _c('div', {
    staticClass: "fl"
  }, [_c('input', {
    staticClass: "itxt itxt04 vat-step-1",
    attrs: {
      "type": "text",
      "name": "vat_phone",
      "id": "vat_phone",
      "value": ""
    },
    on: {
      "blur": function($event) {
        _vm.check_Invoice('vat_phone', $event)
      },
      "change": function($event) {
        _vm.check_Invoice('vat_phone', $event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "message ",
    attrs: {
      "id": "vat_phone_error"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "id": "vat_bankName_div"
    }
  }, [_vm._m(21), _vm._v(" "), _c('div', {
    staticClass: "fl"
  }, [_c('input', {
    staticClass: "itxt itxt04 vat-step-1",
    attrs: {
      "type": "text",
      "name": "vat_bankName",
      "id": "vat_bankName",
      "value": ""
    },
    on: {
      "blur": function($event) {
        _vm.check_Invoice('vat_bankName', $event)
      },
      "change": function($event) {
        _vm.check_Invoice('vat_bankName', $event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "message ",
    attrs: {
      "id": "vat_bankName_error"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "id": "vat_bankAccount_div"
    }
  }, [_vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "fl"
  }, [_c('input', {
    staticClass: "itxt itxt04 vat-step-1",
    attrs: {
      "type": "text",
      "name": "vat_bankAccount",
      "id": "vat_bankAccount",
      "value": ""
    },
    on: {
      "blur": function($event) {
        _vm.check_Invoice('vat_bankAccount', $event)
      },
      "change": function($event) {
        _vm.check_Invoice('vat_bankAccount', $event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "message ",
    attrs: {
      "id": "vat_bankAccount_error"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "label"
  }), _vm._v(" "), _c('div', {
    staticClass: "fl"
  }, [_c('div', {
    staticClass: "op-btns"
  }, [_c('a', {
    staticClass: "btn-1",
    attrs: {
      "id": "vat-btn-save",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveReceipt1()
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('a', {
    staticClass: "btn-9 ml10",
    on: {
      "click": function($event) {
        _vm.closemodal()
      }
    }
  }, [_vm._v("取消")])])])])])])])])]), _vm._v(" "), _c('a', {
    staticClass: "ui-dialog-close",
    attrs: {
      "title": "关闭"
    },
    on: {
      "click": function($event) {
        _vm.closemodal()
      }
    }
  }, [_c('span', {
    staticClass: "ui-icon ui-icon-delete"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('footermenu'), _vm._v(" "), _c('footercopyright')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hq-reg-step"
  }, [_c('ul', {
    staticClass: "ico"
  }, [_c('li', [_c('p', {
    staticClass: "item"
  }, [_vm._v("购物车")]), _vm._v(" "), _c('i', {
    staticClass: "step-count"
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "line"
  })]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('p', {
    staticClass: "item"
  }, [_vm._v("提交订单")]), _vm._v(" "), _c('i', {
    staticClass: "step-count"
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "line"
  })]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "item"
  }, [_vm._v("确认付款")]), _vm._v(" "), _c('i', {
    staticClass: "step-count"
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "line"
  })]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "item"
  }, [_vm._v("下单成功")]), _vm._v(" "), _c('i', {
    staticClass: "step-count"
  })])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hd-title clear-l"
  }, [_c('h4', {}, [_vm._v("确认收货地址")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bd-box fill-ordering mt20",
    attrs: {
      "id": "nearbyCompanyMap"
    }
  }, [_c('div', {
    staticClass: "hd-title-2"
  }, [_c('h4', {}, [_vm._v("附近商家")])]), _vm._v(" "), _c('div', {
    staticClass: "mapPage",
    attrs: {
      "id": "mapPage"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hd-title-2"
  }, [_c('h4', {}, [_vm._v("确认订单信息")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hd"
  }, [_c('dl', [_c('dt', {
    staticClass: "col-1"
  }, [_c('span', {
    staticClass: "ml20"
  }, [_vm._v("商品名称")])]), _vm._v(" "), _c('dt', {
    staticClass: "col-2"
  }, [_vm._v("配送方式")]), _vm._v(" "), _c('dt', {
    staticClass: "col-3"
  }, [_vm._v("单价")]), _vm._v(" "), _c('dt', {
    staticClass: "col-4"
  }, [_vm._v("服务费")]), _vm._v(" "), _c('dt', {
    staticClass: "col-5"
  }, [_vm._v("数量")]), _vm._v(" "), _c('dt', {
    staticClass: "col-6"
  }, [_vm._v("总价")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', {
    staticClass: "col-1",
    staticStyle: {
      "visibility": "hidden"
    }
  }, [_c('span', {
    staticClass: "ml20"
  }, [_vm._v("商品名称")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb20 ad-4 mt20"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("dlf8"),
      "width": "1200",
      "height": "60"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui-dialog-title"
  }, [_c('span', [_vm._v("发票信息")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "invoice-tips ftx-03 mt10 mb10 ",
    attrs: {
      "id": "electro-invoice-tips"
    }
  }, [_c('i'), _vm._v(" "), _c('span', {
    staticClass: "tip-cont"
  }, [_vm._v("电子普通发票和纸质普通发票具备同等法律效力，可支持报销入账，京东自营全面启用电子普通发票，")]), _vm._v(" "), _c('span', {
    staticClass: "tip-cont ml30"
  }, [_vm._v("非京东自营发票由第三方商家实际开具。"), _c('a', {
    staticClass: "ftx-05",
    attrs: {
      "target": "_blank",
      "href": "//help.jd.com/user/issue/list-505-508.html"
    }
  }, [_vm._v("电子普通发票相关信息>>")])]), _vm._v(" "), _c('span', {
    staticClass: "tip-cont ml30"
  }, [_vm._v("如商品由第三方卖家销售，发票类型及内容将由该卖家决定。"), _c('a', {
    staticClass: "ftx-05",
    attrs: {
      "target": "_blank",
      "href": "//help.jd.com/user/issue/list-505-508.html"
    }
  }, [_vm._v("发票信息相关问题>>")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "invoice-2"
    }
  }, [_c('span', {
    staticClass: "hide"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "value": "4"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "fore2"
  }, [_c('input', {
    staticClass: "itxt",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "text",
      "id": "fff",
      "value": "个人",
      "readonly": "true"
    }
  }), _c('b')])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "invoice-2"
    }
  }, [_c('span', {
    staticClass: "hide"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "value": "5"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "itxt itxt04",
    attrs: {
      "type": "text",
      "placeholder": "请填写公司发票抬头"
    }
  }), _c('b')])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fl"
  }, [_c('a', {
    staticClass: "ftx-05"
  }, [_vm._v("新增企业发票")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item nor-inv-type0",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "ele_code_div"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("纳税人识别号")]), _vm._v(" "), _c('div', {
    staticClass: "fl"
  }, [_c('input', {
    staticClass: "itxt itxt05",
    attrs: {
      "type": "text",
      "placeholder": "纳税人识别号",
      "name": "ele_code",
      "id": "ele_code",
      "value": ""
    }
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ftx03",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "receiptContent"
    }
  }, [_c('i', {
    staticClass: "warn-icon"
  }), _vm._v("发票内容将显示详细商品名称与价格信息\n\t\t\t\t\t\t\t\t\t\t")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "invoice-tips ftx-03 mt10 mb10 ",
    attrs: {
      "id": "vat-invoice-tips"
    }
  }, [_c('i'), _vm._v(" "), _c('span', {
    staticClass: "tip-cont"
  }, [_vm._v("我司依法开具发票，请您按照税法规定使用发票。")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "invoice-2"
    }
  }, [_c('span', {
    staticClass: "hide"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "value": "4"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "fore2"
  }, [_c('input', {
    staticClass: "itxt",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "text",
      "id": "fff",
      "value": "不开发票",
      "readonly": "true"
    }
  }), _c('b')])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "invoice-2"
    }
  }, [_c('span', {
    staticClass: "hide"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "value": "5"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "itxt itxt04",
    attrs: {
      "type": "text",
      "placeholder": "请填写单位名称"
    }
  }), _c('b')])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fl"
  }, [_c('a', {
    staticClass: "ftx-05"
  }, [_vm._v("新增企业发票")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('em', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("纳税人识别码")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('em', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("注册地址")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('em', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("注册电话")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('em', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("开户银行")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('em', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("银行账户")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "k+ur":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kGbq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_js_emallUtils_js__ = __webpack_require__("spYF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_api_api_js__ = __webpack_require__("fXcb");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'topbar',
	data: function data() {
		return {
			isLogin: false,
			isShow: false,
			account: '',
			userCenterUrl: '',
			loginUrl: '',
			registerUrl: '',
			logoutUrl: '',
			aboutUsUrl: '',
			indexUrl: '',
			contactUrl: '',
			shoppingCartNum: 0,
			boList: [],
			count: 0,
			goodsImgs: [],
			sumMoney: 0,
			sortParam: '',
			carIsShow: ''
		};
	},

	methods: {
		logout: function logout() {
			localStorage.clear();
			__WEBPACK_IMPORTED_MODULE_1__static_api_api_js__["a" /* default */].loginOut(function (ret) {});
			window.location.href = this.logoutUrl;
		},
		clearCookie: function clearCookie() {
			var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
			if (keys) {
				for (var i = keys.length; i--;) {
					document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString();
				}
			}
		},
		jumpTo: function jumpTo(name) {
			this.$router.push({ name: name });
		},
		getCookie: function getCookie(name) {
			var bikky = document.cookie;
			//console.log("bikky=="+bikky);
			var toBikky = decodeURIComponent(bikky);
			bikky = toBikky;
			//console.log("toBikky=="+toBikky);
			name += "=";
			var i = 0;
			while (i < bikky.length) {
				var offset = i + name.length;
				if (bikky.substring(i, offset) == name) {
					var endstr = bikky.indexOf(";", offset);
					if (endstr == -1) endstr = bikky.length;
					return unescape(bikky.substring(offset, endstr));
				}
				i = bikky.indexOf(" ", i) + 1;
				if (i == 0) break;
			}
			return null;
		},
		shopCartShow: function shopCartShow() {
			this.isShow = true;
		},
		shopCartHide: function shopCartHide() {
			this.isShow = false;
		},
		getShoppingCartNum: function getShoppingCartNum(shopCode) {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_1__static_api_api_js__["a" /* default */].getShoppingCartNum(function (ret) {
				if (ret.code == "success") {
					that.shoppingCartNum = ret.data.shoppingCartNum;
				}
			});
		},
		getShoppingCartList: function getShoppingCartList() {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_1__static_api_api_js__["a" /* default */].getShoppingCartList(function (ret) {
				if (ret.code == "success") {
					that.boList = ret.data.boList;
					var totalCount = 0;
					var bos = new Array();
					bos = ret.data.boList;
					var money = 0;
					for (var i = 0; i < bos.length; i++) {
						var imgSmall = bos[i].imgSmall;
						if (imgSmall.indexOf(";") != -1) {
							imgSmall = imgSmall.split(";")[0];
						}
						bos[i].imgSmall = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + imgSmall;
						bos[i].unitPrice = bos[i].unitPrice / 100;
						money = money + bos[i].unitPrice * bos[i].goodsNumber;
						totalCount = totalCount + bos[i].goodsNumber;
					}
					that.sumMoney = money;
					that.count = totalCount;
				}
			});
		},
		deleteGoods: function deleteGoods(id, goodsCode, index) {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_1__static_api_api_js__["a" /* default */].deleteGoods(id, goodsCode, function (ret) {
				if (parseResult(ret, null, false)) {
					//jQuery("#" + goodsCode + "_cart_pro").remove();
					that.boList.splice(index, 1);
					that.getShoppingCartNum();
				}
			});
		},
		toDetail: function toDetail(goodsCode) {
			this.$router.push({ path: '/goodsDetails', query: { goodsCode: goodsCode } });
			window.location.reload();
		},
		toShopCart: function toShopCart() {
			this.$router.push({ path: '/shopCart' });
		}
	},
	mounted: function mounted() {
		var that = this;
		var account = this.getCookie("r_userAgent_account");
		//console.log("account=="+account);
		if (account != undefined && account != null && account != "") {
			that.isLogin = true;
			that.account = account;
		}

		that.userCenterUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/index/default.htm';
		that.loginUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/login.htm';
		//			that.registerUrl = getUcUrl() + '/custm/user/user_reg_add.htm';
		that.registerUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/custm/user/user_reg_add.htm?formCode=MCHT_USER_FORM';
		that.logoutUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/logout.htm';
		that.aboutUsUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__static_js_emallUtils_js__["l" /* getAboutUsUrl */])();
		that.indexUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__static_js_emallUtils_js__["o" /* getIndexUrl */])();
		that.contactUrl = __WEBPACK_IMPORTED_MODULE_0__static_js_emallUtils_js__["p" /* sysContactUrl */];
		this.getShoppingCartNum();
		this.getShoppingCartList();
	}
});

/***/ }),

/***/ "kja2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orderPaySuccess_vue__ = __webpack_require__("XWWZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c733110_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_orderPaySuccess_vue__ = __webpack_require__("7N4N");
function injectStyle (ssrContext) {
  __webpack_require__("YnqX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orderPaySuccess_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c733110_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_orderPaySuccess_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lDv9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lGIb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_api_api_js__ = __webpack_require__("fXcb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'hearderNav',
	data: function data() {
		return {
			navSelectCatList: [],
			showFlag: true,
			catList: [],
			catListNew: [],
			currIndex: -1,
			purchaserUrl: __WEBPACK_IMPORTED_MODULE_0__static_api_api_js__["a" /* default */].getPurchaserUrl(),
			brandUrl: __WEBPACK_IMPORTED_MODULE_0__static_api_api_js__["a" /* default */].getBrandUrl(),
			requirementUrl: __WEBPACK_IMPORTED_MODULE_0__static_api_api_js__["a" /* default */].getRequirementUrl(),
			tradingHallUrl: __WEBPACK_IMPORTED_MODULE_0__static_api_api_js__["a" /* default */].getTradingHallUrl(),
			newsUrl: __WEBPACK_IMPORTED_MODULE_0__static_api_api_js__["a" /* default */].getNewsUrl(),
			exhibitionUrl: __WEBPACK_IMPORTED_MODULE_0__static_api_api_js__["a" /* default */].getExhibitionUrl()
		};
	},

	props: ['isRefresh', 'activeLi', 'firstCatShow'],
	components: {},
	methods: {
		goIndex: function goIndex() {
			this.$router.push({ name: 'index' });
		},
		goSample: function goSample() {
			this.$router.push({ name: 'goodsList', query: { productType: "sample", orderType: "proof" } });
			window.location.reload();
		},
		goMeterial: function goMeterial() {
			this.$router.push({ name: 'meterialList', query: { productType: "meterial" } });
			window.location.reload();
		},
		childCateHide: function childCateHide() {
			this.currIndex = -1;
		},
		childCateShow: function childCateShow(index) {
			this.currIndex = index;
		},
		wholeCateHide: function wholeCateHide() {
			this.firstCatShow = false;
			this.showFlag = false;
		},
		wholeCateShow: function wholeCateShow() {
			this.firstCatShow = true;
		},
		getMore: function getMore(catCode, catNameCn) {
			this.$router.push({ name: 'goodsList', query: { firstCatCode: catCode, catNameCn: catNameCn } });
			window.location.reload();
		},
		getCatGoods: function getCatGoods(catCode, catNameCn) {
			this.$router.push({ name: 'goodsList', query: { catCode: catCode, catNameCn: catNameCn } });
			if (this.isRefresh) {
				window.location.reload();
			}
		},
		getCat: function getCat() {
			var that = this;
			//这里只查询现货类目
			__WEBPACK_IMPORTED_MODULE_0__static_api_api_js__["a" /* default */].getAllCat('product', function (ret) {
				if (ret.code == "success") {
					var firstCatList = ret.data.firstCatList;
					if (firstCatList != undefined && firstCatList.length > 0) {
						var a = Math.ceil(firstCatList.length / 8);
						var b = firstCatList.length % 8;
						var c = 0;
						var carArray = [];
						for (var i = 0; i < 8; i++) {
							var items = [];
							for (var j = 0; j < a; j++) {
								if (c >= firstCatList.length) break;
								items = items.concat(firstCatList[c]);
								c++;
								if (i == b - 1 && j == a - 1) a--;
							}
							if (items.length != 0) {
								carArray.push(items);
							}
						}
						that.catListNew = carArray;
						that.catList = firstCatList;
					}
				}
			});
		}
	},
	mounted: function mounted() {}
});

/***/ }),

/***/ "lRO8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__("ORbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TopBar__ = __webpack_require__("5PWk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Header__ = __webpack_require__("teIl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FooterMenu__ = __webpack_require__("gTlp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_FooterCopyright__ = __webpack_require__("3LwO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_HearderNav__ = __webpack_require__("7JIe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_api_api_js__ = __webpack_require__("fXcb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__static_js_flipclock_min_js__ = __webpack_require__("6RZS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__ = __webpack_require__("spYF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_mint_ui__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*引入Vue框架*/

/*引入资源请求插件*/

/*使用VueResource插件*/
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_11_mint_ui__["Swipe"].name, __WEBPACK_IMPORTED_MODULE_11_mint_ui__["Swipe"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_11_mint_ui__["SwipeItem"].name, __WEBPACK_IMPORTED_MODULE_11_mint_ui__["SwipeItem"]);

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'index',
	data: function data() {
		return {
			activeLi: "mallIndex",
			sliderItems: [],
			littleAdsItem: {},
			adsItem: [],
			innerAdsNum: 0,
			bottomAdsItem: {},
			sliderHeight: '405px',
			firstCatList: [],
			hotGoodsList: [],
			hotSecondList: [],
			hotShopList: [],
			secondPageShow: false,
			cabinetId: '', //首页橱窗ID
			profixPath: '',
			isLogin: false,
			isShow: false,
			account: '',
			userCenterUrl: '',
			loginUrl: '',
			registerUrl: '',
			logoutUrl: '',
			aboutUsUrl: '',
			indexUrl: '',
			newList: [],
			exchangeUrl: '',
			imgPath: '',
			contactUrl: '',
			computeFlag: '',
			secKillBo: '',
			nextActivityTime: '',
			seckillGoods: [],
			seckillHour: '0',
			seckillMinute: '0',
			seckillSecond: '0',
			activityName: '', //秒杀活动开始标识
			currentDate: null, //系统当前时间
			clock: '' //倒计时组件
		};
	},

	components: {
		'topbar': __WEBPACK_IMPORTED_MODULE_3__components_TopBar__["a" /* default */],
		'sortHeader': __WEBPACK_IMPORTED_MODULE_4__components_Header__["a" /* default */],
		'footermenu': __WEBPACK_IMPORTED_MODULE_5__components_FooterMenu__["a" /* default */],
		'footercopyright': __WEBPACK_IMPORTED_MODULE_6__components_FooterCopyright__["a" /* default */],
		'heardernav': __WEBPACK_IMPORTED_MODULE_7__components_HearderNav__["a" /* default */]
	},
	methods: {
		getIndexAds: function getIndexAds() {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_8__static_api_api_js__["a" /* default */].getIndexAds(function (ret) {
				if (ret.code == "success" && ret.data.adsList.length > 0) {
					var adsList = ret.data.adsList;
					if (adsList != undefined && adsList.length > 0) {
						var sliderItems = new Array();
						for (var i = 0; i < adsList.length; i++) {
							adsList[i].mediaCode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + adsList[i].mediaCode;
							if (adsList[i].adsType == "slider") {
								sliderItems.push(adsList[i]);
							} else if (adsList[i].adsType == "little_ads") {
								that.littleAdsItem = adsList[i];
							} else if (adsList[i].adsType == "inner_ads") {
								that.innerAdsNum++;
								that.adsItem.push(adsList[i]);
							} else if (adsList[i].adsType == "bottom_slogen") {
								that.bottomAdsItem = adsList[i];
							}
						}
						that.sliderItems = sliderItems;
					}
				}
			});
		},
		getRecommendGoods: function getRecommendGoods() {
			var that = this;
			var pageSize = 10;
			var src = "pc";
			__WEBPACK_IMPORTED_MODULE_8__static_api_api_js__["a" /* default */].getRecommendGoods(pageSize, src, function (ret) {
				var goodsList = ret.data.goodsList;
				that.cabinetId = ret.data.cabinetId;
				if (ret.code == "success" && goodsList != undefined && goodsList.length > 0) {
					for (var i = 0; i < goodsList.length; i++) {
						var imgMiddle = goodsList[i].imgMiddle;
						if (imgMiddle.indexOf(";") >= 0) {
							imgMiddle = imgMiddle.split(";")[0];
							goodsList[i].imgMiddle = imgMiddle;
						}
					}
					var listLength = goodsList.length;
					if (listLength <= 6) {
						that.hotGoodsList = goodsList;
					} else if (listLength > 6) {
						that.hotGoodsList = goodsList.slice(0, 6);
						that.hotSecondList = goodsList.slice(6, listLength.length);
						that.secondPageShow = true;
					}
				}
			});
		},
		getRecommendShops: function getRecommendShops() {
			var that = this;
			var pageSize = 8;
			var src = "pc";
			__WEBPACK_IMPORTED_MODULE_8__static_api_api_js__["a" /* default */].getRecommendShops(pageSize, src, function (ret) {
				if (ret.code == "success" && ret.data.shopList.length > 0) {
					that.hotShopList = ret.data.shopList;
				}
			});
		},
		logout: function logout() {
			localStorage.clear();
			__WEBPACK_IMPORTED_MODULE_8__static_api_api_js__["a" /* default */].loginOut(function (ret) {});
			window.location.href = this.logoutUrl;
		},
		mobileAppShow: function mobileAppShow() {
			this.isShow = true;
		},
		mobileAppHidden: function mobileAppHidden() {
			this.isShow = false;
		},
		jumpTo: function jumpTo(name) {
			this.$router.push({ name: name });
		},
		jumpToCabinet: function jumpToCabinet(name) {
			window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__["c" /* getCmsUrl */])() + "/custom.htm?tplName=More&c=" + this.cabinetId;
		},
		goDetail: function goDetail(goodsCode) {
			//this.$router.push({name:'goodsdetail',query:{goodsCode:goodsCode}});
			var routeData = this.$router.resolve({ path: '/goodsDetails', query: { goodsCode: goodsCode } });
			window.open(routeData.href, '_blank');
		},
		goShop: function goShop(shopCode) {
			this.$router.push({ name: 'shop_index', query: { shopCode: shopCode } });
		},
		getBrandGoods: function getBrandGoods(brandId, brandName) {
			this.$router.push({ name: 'goodsList', query: { brandId: brandId, brandName: brandName } });
		},
		getMore: function getMore(catCode, catNameCn) {
			if (catCode == "point_use_area") {
				//			this.$router.push({name:'points_area',query:{}});
				window.open("/#/points_area", '_blank');
			} else {
				this.$router.push({ name: 'goodsList', query: { firstCatCode: catCode, catNameCn: catNameCn } });
			}
		},
		getCatGoods: function getCatGoods(catCode, catNameCn) {
			this.$router.push({ name: 'goodsList', query: { catCode: catCode, catNameCn: catNameCn } });
		},
		getIndexInfo: function getIndexInfo() {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_8__static_api_api_js__["a" /* default */].getIndex(function (ret) {
				if (ret.code == "success" && ret.data != undefined) {
					var account = ret.data.account;

					if (account != undefined && account != "") {
						that.isLogin = true;
						that.account = account;
						localStorage.setItem("account", account);
					}

					var firstCatList = ret.data.firstCatList;

					if (firstCatList != undefined && firstCatList.length > 0) {
						for (var i = 0; i < firstCatList.length; i++) {
							var picPath = firstCatList[i].picPath;
							picPath = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + picPath;
							firstCatList[i].picPath = picPath;
							for (var j = 0; j < firstCatList[i].goodsList.length; j++) {
								var marketPrice = JSON.parse(firstCatList[i].goodsList[j].attrValue).marketPrice;
								var saleTimeStr = JSON.parse(firstCatList[i].goodsList[j].attrValue).saleTimeShow;
								var saleEndTimeStr = JSON.parse(firstCatList[i].goodsList[j].attrValue).saleEndTimeShow;
								if (marketPrice != undefined && marketPrice != "") {
									firstCatList[i].goodsList[j].marketPrice = marketPrice;
								} else {
									firstCatList[i].goodsList[j].marketPrice = firstCatList[i].goodsList[j].unitPrice;
								}
								if (saleEndTimeStr != undefined && saleEndTimeStr != '') {
									saleEndTimeStr = saleEndTimeStr.replace(/-/g, "/");
									var saleEndDate = new Date(saleEndTimeStr);

									saleTimeStr = saleTimeStr.replace(/-/g, "/");
									var saleDate = new Date(saleTimeStr);

									//如果当期日期大于销售结束日期 xxx
									if (new Date() > saleEndDate) {
										firstCatList[i].goodsList[j].saleStatus = "end";
									} else if (new Date() < saleDate) {
										//如果当期时间小于上架时间，展示距离开始 时间
										firstCatList[i].goodsList[j].saleStatus = "wait_start";
										var begSeconds = saleDate.getTime() - new Date().getTime(); //时间差的毫秒数
										//计算出相差天数
										//  								var days=Math.floor(begSeconds/(24*3600*1000));
										//计算出小时数
										var leave1 = begSeconds % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
										var hours = Math.floor(begSeconds / (3600 * 1000));
										//计算相差分钟数
										var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
										var minutes = Math.floor(leave2 / (60 * 1000));
										//计算相差秒数
										var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
										var seconds = Math.round(leave3 / 1000);
										// 									firstCatList[i].goodsList[j].day=days;
										firstCatList[i].goodsList[j].hour = hours;
										firstCatList[i].goodsList[j].minute = minutes;
										firstCatList[i].goodsList[j].second = seconds;
									} else {
										firstCatList[i].goodsList[j].saleStatus = "on_sale";

										var begSeconds = saleEndDate.getTime() - new Date().getTime(); //时间差的毫秒数
										//计算出相差天数
										//  								var days=Math.floor(begSeconds/(24*3600*1000));
										//计算出小时数
										var leave1 = begSeconds % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
										var hours = Math.floor(begSeconds / (3600 * 1000));
										//计算相差分钟数
										var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
										var minutes = Math.floor(leave2 / (60 * 1000));
										//计算相差秒数
										var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
										var seconds = Math.round(leave3 / 1000);
										// 									firstCatList[i].goodsList[j].day=days;
										firstCatList[i].goodsList[j].hour = hours;
										firstCatList[i].goodsList[j].minute = minutes;
										firstCatList[i].goodsList[j].second = seconds;
									}
								}
							}
						}
					}
					that.firstCatList = firstCatList;
					that.profixPath = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=";
				}
			});
		},
		getNews: function getNews() {
			var that = this;
			var params = '{}';
			__WEBPACK_IMPORTED_MODULE_2_jquery___default.a.ajax({
				type: "get",
				url: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__["o" /* getIndexUrl */])() + '/sckb/index.htm',
				async: false,
				dataType: "jsonp", // 返回的数据类型，设置为JSONP方式
				data: params,
				success: function success(ret) {
					if (ret.code == 'success') {
						var newList = ret.values.list;
						if (newList != undefined && newList.length > 0) {
							that.newList = newList;
						}
					}
				},
				error: function error(err) {}
			});
		},
		goIndex: function goIndex() {
			this.$router.push({ name: 'index' });
		},
		getCat: function getCat() {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_8__static_api_api_js__["a" /* default */].getAllCat('', function (ret) {
				if (ret.code == "success") {
					var firstCatList = ret.data.firstCatList;
				}
			});
		},
		computeTime: function computeTime() {
			var that = this;
			//系统当前时间
			if (that.currentDate != null && that.currentDate != undefined) {
				that.currentDate = new Date(that.currentDate.getTime() + 1000);
			}
			if (that.secKillBo != '' && that.secKillBo != undefined) {
				//默认展示距离活动结束时间
				var activityBeginTime = new Date(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__["r" /* dateFormat */])(that.secKillBo.activityBeginTime + "").replace(/-/g, "/"));
				var activityEndTime = new Date(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__["r" /* dateFormat */])(that.secKillBo.activityEndTime + "").replace(/-/g, "/"));
				var showTime = activityEndTime;
				//如果当前活动开始了
				if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__["s" /* compareDate */])(activityBeginTime, that.currentDate) <= 0 && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__["s" /* compareDate */])(activityEndTime, that.currentDate) >= 0) {
					//that.activityName=that.secKillBo.activityName;
					that.activityName = "本场距离结束还剩：";
				} else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__["s" /* compareDate */])(activityBeginTime, that.currentDate) > 0) {
					that.activityName = "本场距离开始还剩：";
					showTime = activityBeginTime;
				} else {
					window.clearInterval(that.computeFlag);
					that.secKillBo = null; //停止秒杀活动展示
					that.getSeckillActivityList(); //重新查询秒杀活动
				}
				//					var begSeconds = showTime.getTime() - new Date().getTime(); //时间差的毫秒数   
				//					//计算出小时数  
				//					var leave1 = begSeconds % (24 * 3600 * 1000); //计算天数后剩余的毫秒数  
				//					var hours = Math.floor(begSeconds / (3600 * 1000));
				//					//计算相差分钟数  
				//					var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数  
				//					var minutes = Math.floor(leave2 / (60 * 1000));
				//					//计算相差秒数  
				//					var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数  
				//					var seconds = Math.round(leave3 / 1000);
				//					if(hours < 10) {
				//						hours = "0" + hours
				//					}
				//					if(minutes < 10) {
				//						minutes = "0" + minutes
				//					}
				//					if(seconds < 10) {
				//						seconds = "0" + seconds
				//					}
				//					that.hour = hours + "";
				//					that.minute = minutes + "";
				//					that.second = seconds + "";
			}
		},
		handleScroll: function handleScroll(e) {
			if (Math.abs(e.currentTarget.scrollY) > 300) {
				__WEBPACK_IMPORTED_MODULE_2_jquery___default()(".top").show();
			} else {
				__WEBPACK_IMPORTED_MODULE_2_jquery___default()(".top").hide();
			}
		},
		scrollToTop: function scrollToTop() {
			__WEBPACK_IMPORTED_MODULE_2_jquery___default()("html,body").animate({
				scrollTop: 0
			}, 500);
		},
		//判断是否在活动时间内
		compareActTime: function compareActTime(actBeginTime, actEndTime) {
			var that = this;
			var beginTime = new Date(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__["r" /* dateFormat */])(actBeginTime + "").replace(/-/g, "/"));
			var endTime = new Date(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__["r" /* dateFormat */])(actEndTime + "").replace(/-/g, "/"));
			if (that.currentDate == null || that.currentDate == undefined || actBeginTime == null || actBeginTime == undefined || actEndTime == null || actEndTime == undefined) {
				return false;
			} else {
				if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__["s" /* compareDate */])(beginTime, that.currentDate) <= 0 && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__["s" /* compareDate */])(endTime, that.currentDate) >= 0) {
					return true;
				} else {
					return false;
				}
			}
		},
		initClock: function initClock() {
			var that = this;

			//判断根据开始时间还是结束时间计算
			var activityBeginTime = new Date(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__["r" /* dateFormat */])(this.secKillBo.activityBeginTime + "").replace(/-/g, "/"));
			var activityEndTime = new Date(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__["r" /* dateFormat */])(this.secKillBo.activityEndTime + "").replace(/-/g, "/"));
			var showTime = activityEndTime;
			//如果当前活动开始了
			if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__["s" /* compareDate */])(activityBeginTime, this.currentDate) <= 0 && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__["s" /* compareDate */])(activityEndTime, this.currentDate) >= 0) {
				//that.activityName='';
			} else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__["s" /* compareDate */])(activityBeginTime, that.currentDate) > 0) {
				//that.activityName="本场距离开始还剩：";
				showTime = activityBeginTime;
			} else {
				that.clock.stop();
			}
			//根据时间进行计算差距
			var begSeconds = showTime - new Date().getTime(); //时间差的毫秒数
			/*that.clock.setTime(begSeconds/1000);
   that.clock.setCountdown(true);
   that.clock.start();*/
			that.clock = $('.clock').FlipClock(begSeconds / 1000, {
				clockFace: 'HourlyCounter',
				countdown: true,
				//      autoStart: false,
				callbacks: { //回调函数
					stop: function stop() {
						alert("stoped!");
					}
				}
			});
		},
		getSeckillActivityList: function getSeckillActivityList() {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_8__static_api_api_js__["a" /* default */].getSeckillActivityList(function (ret) {
				if (ret.code == "success" && ret.data != undefined) {
					that.secKillBo = ret.data.secKillBo;
					that.currentDate = new Date(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__["r" /* dateFormat */])(ret.data.currentTime + "").replace(/-/g, "/"));
					//						that.nextActivityTime = ret.data.nextActivityTime;
					that.seckillGoods = ret.data.seckillGoods;
					//						that.computeFlag = window.setInterval(function() {
					//							that.computeTime1(); //计算倒计时
					//						}, 1000);
					if (that.secKillBo != null) {
						that.initClock();
						that.computeFlag = window.setInterval(function () {
							that.computeTime(); //计算倒计时
						}, 1000);
					}
				}
			});
		}
	},
	beforeDestroy: function beforeDestroy() {
		window.clearInterval(this.computeFlag);
	},
	mounted: function mounted() {
		this.$refs.navComp.getCat();
		this.userCenterUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/index/default.htm';
		this.loginUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/login.htm';
		//	this.registerUrl = 'http://uc.hcehce.com/custm/user/user_reg_add.htm';
		this.registerUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/custm/user/user_reg_add.htm?formCode=MCHT_USER_FORM';
		this.logoutUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__["a" /* getUcUrl */])() + '/logout.htm';
		this.aboutUsUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__["l" /* getAboutUsUrl */])();
		this.indexUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__["o" /* getIndexUrl */])();
		this.exchangeUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__["o" /* getIndexUrl */])();
		this.imgPath = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=";
		window.scrollTo(0, 0);
		this.getIndexInfo();
		this.getRecommendGoods();
		this.getRecommendShops();
		this.getIndexAds();
		this.getCat();
		//this.getNews();
		this.contactUrl = __WEBPACK_IMPORTED_MODULE_10__static_js_emallUtils_js__["p" /* sysContactUrl */];
		var that = this;
		/*this.computeFlag = window.setInterval(function(){
  	that.computeTime();//计算倒计时
  },1000);*/

		this.$nextTick(function () {
			window.addEventListener('scroll', this.handleScroll); //滚动事件监听
		});

		this.getSeckillActivityList();
	}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "lYG6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shop_index_vue__ = __webpack_require__("pqfS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ab16012_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_shop_index_vue__ = __webpack_require__("Qo9D");
function injectStyle (ssrContext) {
  __webpack_require__("Gvnd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ab16012"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shop_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ab16012_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_shop_index_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lm+Y":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "lo3H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "footer-copyright"
  }, [_c('div', {
    staticClass: "menu"
  }, [_vm._l((_vm.aboutusList), function(aboutus, index) {
    return [_c('a', {
      attrs: {
        "href": aboutus.url
      }
    }, [_vm._v(_vm._s(aboutus.title))]), _vm._v(" "), (index != (_vm.aboutusList.length - 1)) ? [_vm._v("|")] : _vm._e()]
  })], 2), _vm._v(" "), _vm._m(0)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n\t\t\tCopyright © 2017 All Rights Reserved baomate.com\n\t\t\t"), _c('span', {
    attrs: {
      "id": "site_stat"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lu7E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__("ORbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TopBar__ = __webpack_require__("5PWk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Header__ = __webpack_require__("teIl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FooterMenu__ = __webpack_require__("gTlp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FooterCopyright__ = __webpack_require__("3LwO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_js_emallUtils_js__ = __webpack_require__("spYF");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*引入Vue框架*/

/*引入资源请求插件*/

/*使用VueResource插件*/
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);




//import jQuery from "../../../static/js/jquery.min.js"


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'paySuccess',
  data: function data() {
    return {};
  },

  components: {
    'sortHeader': __WEBPACK_IMPORTED_MODULE_3__components_Header__["a" /* default */],
    'footermenu': __WEBPACK_IMPORTED_MODULE_4__components_FooterMenu__["a" /* default */],
    'footercopyright': __WEBPACK_IMPORTED_MODULE_5__components_FooterCopyright__["a" /* default */]
  },
  methods: {
    viewAllOrders: function viewAllOrders() {
      window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__static_js_emallUtils_js__["b" /* getEmallUrl */])() + '/orderManage/myOrderList.htm';
    }
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
  }
});

/***/ }),

/***/ "mSkG":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,/9j/4QAYRXhpZgAASUkqAAgAAAAAAAAAAAAAAP/sABFEdWNreQABAAQAAAA8AAD/4QMpaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLwA8P3hwYWNrZXQgYmVnaW49Iu+7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI/PiA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJBZG9iZSBYTVAgQ29yZSA1LjAtYzA2MCA2MS4xMzQ3NzcsIDIwMTAvMDIvMTItMTc6MzI6MDAgICAgICAgICI+IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCBDUzUgV2luZG93cyIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpENUFDRjM0MzkxNDIxMUU3Qjk1QjhCMzhDRkU4RkE0MCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpENUFDRjM0NDkxNDIxMUU3Qjk1QjhCMzhDRkU4RkE0MCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkQ1QUNGMzQxOTE0MjExRTdCOTVCOEIzOENGRThGQTQwIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkQ1QUNGMzQyOTE0MjExRTdCOTVCOEIzOENGRThGQTQwIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+/+4ADkFkb2JlAGTAAAAAAf/bAIQABgQEBAUEBgUFBgkGBQYJCwgGBggLDAoKCwoKDBAMDAwMDAwQDA4PEA8ODBMTFBQTExwbGxscHx8fHx8fHx8fHwEHBwcNDA0YEBAYGhURFRofHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8f/8AAEQgAFAASAwERAAIRAQMRAf/EAIkAAAMBAQAAAAAAAAAAAAAAAAUGBwMIAQADAAMAAAAAAAAAAAAAAAAEBQYBAwcQAAAEBQEGBgMAAAAAAAAAAAECAwQAERITBSExIkIUBgdBUWGhMhYjQyURAAEDAgMDCAsAAAAAAAAAAAEAEQIDBSExEkETBPBRYXGh0TIUgbHB4fEiQiNDFQb/2gAMAwEAAhEDEQA/AK/3E7mh0y4Tx7VC4+UTFY6qoDZTTCeu7qY3pCe43I0jogHl35J5aLP5oGRLRBAwzJPqHShfQXdpzlcg2xeVSKY7kDlReELaNcIICJVUxEQLumCQgOsBcDeZahCq2JAfryRl2sMaMDUgfCzh3wO0FVGKVS6iXdfEP3mfcumlKjxoKZ0kPlWlaADlEo6T8afGIe71RHipasiw7lVfz/FQpvCp4JjPmOz4pf6Mx+TVeBlnhQQE4AixTNNOYnMFamszS0lMdsLKlSAqRhDH5gT7OWxMbxWpQpbimXxeRd8sguifyenw8+KOj49ihkAz/wBO53+nRz9ISoruy4Z2/acKbn5L87avS/Yt1HefTkscT9GvF5S3c/Xcqlt4a93b5QPwX67efb06+n34LM962OSaYokMv//Z"

/***/ }),

/***/ "mtcC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header line"
  }, [_c('div', [_c('div', {
    staticClass: "w1200 bc"
  }, [_c('a', {
    staticClass: "logo fl",
    attrs: {
      "href": _vm.indexUrl,
      "title": "相伴宝"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('span', {
    staticClass: "ico"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sortParam),
      expression: "sortParam"
    }],
    staticClass: "text",
    attrs: {
      "type": "text",
      "placeholder": "请输入你要搜索的关键字"
    },
    domProps: {
      "value": (_vm.sortParam)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sortParam = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.sortGoods()
      }
    }
  }, [_vm._v("搜索")])]), _vm._v(" "), _c('div', {
    staticClass: "r-box fr",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "mycart",
    on: {
      "click": _vm.toShopCart,
      "mouseenter": function($event) {
        _vm.shopCarShow()
      },
      "mouseleave": function($event) {
        _vm.shopCarHide()
      }
    }
  }, [_c('i', {
    staticClass: "ico-cart"
  }), _vm._v("\n\t\t\t\t\t\t我的购物车\n\t\t\t\t\t\t"), _c('i', {
    staticClass: "ico-r"
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-list none"
  }, [_c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), (_vm.shoppingCartNum == 0) ? _c('div', {
    staticClass: "no-goods"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("HdMn"),
      "width": "57",
      "height": "49"
    }
  }), _vm._v("购物车中还没有商品，赶紧选购吧！\n\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.shoppingCartNum > 0) ? _c('div', {
    staticClass: "mylist"
  }, [_c('h4', [_vm._v("最新加入的商品 ")]), _vm._v(" "), _c('ul', _vm._l((_vm.boList), function(bo, index) {
    return _c('li', {
      staticClass: "li-2",
      attrs: {
        "id": bo.goodsCode + '_cart_pro'
      }
    }, [_c('a', {
      staticClass: "fl spic",
      on: {
        "click": function($event) {
          _vm.toDetail(bo.goodsCode)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": bo.imgSmall,
        "width": "50",
        "height": "50"
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "name"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.toDetail(bo.goodsCode)
        }
      }
    }, [_c('span', {
      attrs: {
        "name": "goodsName"
      }
    }, [_vm._v(_vm._s(bo.goodsName))]), (bo.specName != '') ? _c('span', [_vm._v("【" + _vm._s(bo.specName) + "】")]) : _vm._e()]), _vm._v("    "), _c('span', {
      staticStyle: {
        "color": "#f60"
      }
    }, [_vm._v("数量：" + _vm._s(bo.goodsNumber))])]), _vm._v(" "), _c('p', {
      staticClass: "other"
    }, [_c('span', [_vm._v("￥" + _vm._s(bo.unitPrice))]), _c('br'), _vm._v(" "), _c('a', {
      staticClass: "del",
      on: {
        "click": function($event) {
          _vm.deleteGoods(bo.id, bo.goodsCode, index)
        }
      }
    }, [_vm._v("删除")])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "fbar"
  }, [_c('span', {
    staticClass: "fl ml10"
  }, [_vm._v("共" + _vm._s(_vm.count) + "件商品　共计"), _c('b', [_vm._v("￥ " + _vm._s(_vm.sumMoney))])]), _vm._v(" "), _c('a', {
    staticClass: "fr gobuy",
    on: {
      "click": _vm.toShopCart
    }
  }, [_vm._v("去购物车")])])]) : _vm._e()])])])])])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nFGY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('topbar'), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('sortHeader'), _vm._v(" "), _c('heardernav', {
    ref: "navComp",
    attrs: {
      "activeLi": _vm.activeLi,
      "firstCatShow": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "shop-focus-img"
  }, [_c('mt-swipe', {
    staticStyle: {
      "height": "405px",
      "cursor": "pointer"
    },
    attrs: {
      "auto": 3000,
      "speed": 1000
    }
  }, _vm._l((_vm.sliderItems), function(i, index) {
    return _c('mt-swipe-item', {
      key: index,
      style: ({
        background: 'url(' + i.mediaCode + ')' + 'no-repeat center top'
      }),
      attrs: {
        "onclick": "jumpUrl(this)"
      }
    }, [_c('a', {
      staticStyle: {
        "display": "none"
      }
    }, [_vm._v(_vm._s(i.link))])])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "clear mt15"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "recommend",
    staticStyle: {
      "border": "solid 1px #ddd",
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "hd1"
  }, [_c('h3', {
    staticClass: "hd-tit1"
  }, [_vm._v("热门推荐")]), _vm._v(" "), (_vm.cabinetId != null && _vm.cabinetId != '' && _vm.hotGoodsList != null && _vm.hotGoodsList.length > 0) ? _c('a', {
    staticClass: "more",
    on: {
      "click": function($event) {
        _vm.jumpToCabinet()
      }
    }
  }, [_vm._v("更多 >")]) : _vm._e()]), _vm._v(" "), _c('mt-swipe', {
    staticStyle: {
      "height": "280px"
    },
    attrs: {
      "show-indicators": false
    }
  }, [_c('mt-swipe-item', [_c('div', {
    staticClass: "bd",
    staticStyle: {
      "line-height": "0px"
    }
  }, [_c('ul', {
    staticClass: "items li5"
  }, _vm._l((_vm.hotGoodsList), function(hotGood) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.goDetail(hotGood.goodsCode)
        }
      }
    }, [_c('a', [_c('img', {
      attrs: {
        "src": _vm.imgPath + hotGood.imgMiddle,
        "width": "210",
        "height": "210"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "line-tit"
    }, [_c('a', {
      staticClass: "co4"
    }, [_vm._v(_vm._s(hotGood.goodsName))])]), _vm._v(" "), (hotGood.goodsPrice == 0) ? _c('div', {
      staticClass: "line-price"
    }, [_c('span', {
      staticClass: "co2"
    }, [_vm._v(_vm._s(hotGood.unitPrice == 0 ? "" : "￥" + (hotGood.unitPrice / 100).toFixed(2)))])]) : _c('div', {
      staticClass: "line-price"
    }, [_c('span', {
      staticClass: "co2"
    }, [_vm._v("\n\t\t\t\t                    \t" + _vm._s(hotGood.goodsPrice) + "\n\t\t\t\t\t\t\t\t\t\t"), (hotGood.pointType == 'point') ? _c('span', [_vm._v("积分")]) : (hotGood.pointType == 'special') ? _c('span', [_vm._v("专用积分")]) : (hotGood.pointType == 'red') ? _c('span', [_vm._v("红积分")]) : (hotGood.pointType == 'blue') ? _c('span', [_vm._v("蓝积分")]) : _vm._e()])])])
  }))])]), _vm._v(" "), (_vm.secondPageShow) ? _c('mt-swipe-item', [_c('div', {
    staticClass: "bd",
    staticStyle: {
      "line-height": "0px"
    }
  }, [_c('ul', {
    staticClass: "items"
  }, _vm._l((_vm.hotSecondList), function(hotGood) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.goDetail(hotGood.goodsCode)
        }
      }
    }, [_c('a', [_c('img', {
      attrs: {
        "src": _vm.imgPath + hotGood.imgMiddle,
        "width": "210",
        "height": "210"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "line-tit"
    }, [_c('a', {
      staticClass: "co4"
    }, [_vm._v(_vm._s(hotGood.goodsName))])]), _vm._v(" "), (hotGood.goodsPrice == 0) ? _c('div', {
      staticClass: "line-price"
    }, [_c('span', {
      staticClass: "co2"
    }, [_vm._v(_vm._s(hotGood.unitPrice == 0 ? "" : "￥" + (hotGood.unitPrice / 100).toFixed(2)))])]) : _c('div', {
      staticClass: "line-price"
    }, [_c('span', {
      staticClass: "co2"
    }, [_vm._v("\n\t\t\t                \t\t\t" + _vm._s(hotGood.goodsPrice) + "\n\t\t\t\t\t\t\t\t\t\t"), (hotGood.pointType == 'point') ? _c('span', [_vm._v("积分")]) : (hotGood.pointType == 'special') ? _c('span', [_vm._v("专用积分")]) : (hotGood.pointType == 'red') ? _c('span', [_vm._v("红积分")]) : (hotGood.pointType == 'blue') ? _c('span', [_vm._v("蓝积分")]) : _vm._e()])])])
  }))])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.secKillBo != null && _vm.secKillBo != ''),
      expression: "secKillBo!=null&&secKillBo!=''"
    }]
  }, [_c('div', {
    staticClass: "recommend",
    staticStyle: {
      "margin-bottom": "20px",
      "height": "350px"
    }
  }, [_c('a', {
    staticClass: "more1",
    on: {
      "click": function($event) {
        _vm.jumpTo('seckillList')
      }
    }
  }, [_vm._v("更多 >")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "buying"
  }, [_c('ul', [_c('li', {
    staticClass: "shopTime"
  }, [_c('h1', {
    staticStyle: {
      "width": "231px"
    }
  }, [_vm._v("抢购")]), _vm._v(" "), _c('h2', {
    staticClass: "eg"
  }, [_vm._v("FLASH DEALS")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "64px",
      "height": "64px"
    },
    attrs: {
      "src": __webpack_require__("Q4AZ")
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "18px",
      "margin-bottom": "10px"
    }
  }, [_vm._v(_vm._s(_vm.activityName))]), _vm._v(" "), _c('div', {
    staticClass: "clock",
    staticStyle: {
      "margin": "2em"
    }
  })]), _vm._v(" "), _vm._l((_vm.seckillGoods), function(list, index) {
    return (index < 4) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          _vm.goDetail(list.goodsCode)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.imgPath + (list.imgMiddle != null ? (list.imgMiddle.split(';'))[0] : '')
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(list.goodsName))]), _vm._v(" "), _c('div', {
      staticClass: "priceBox"
    }, [_c('span', {
      staticClass: "currentPrice"
    }, [_vm._v("￥" + _vm._s(list.seckillPrice / 100))]), _vm._v(" "), _c('span', {
      staticClass: "originalPrice"
    }, [_vm._v(_vm._s(list.unitPrice == 0 ? "" : "￥" + list.unitPrice / 100))])])])]) : _vm._e()
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "clear mt15"
  }), _vm._v(" "), _vm._l((_vm.firstCatList), function(cat, index) {
    return _c('div', [(cat.catCode == 'spike' && cat.goodsList.length > 0) ? _c('div', {
      staticClass: "grid-c1 miaosha"
    }, [_c('div', {
      staticClass: "side-l"
    }, [_c('div', {
      staticClass: "hd"
    }, [_c('a', {
      staticClass: "more",
      on: {
        "click": function($event) {
          _vm.getMore(cat.catCode, cat.catNameCn)
        }
      }
    }, [_vm._v("更多 >")]), _vm._v(" "), _c('ul', {
      staticClass: "tags"
    }, _vm._l((cat.catBoList), function(childCat, idx) {
      return (idx < 8) ? _c('li', [_c('a', {
        on: {
          "click": function($event) {
            _vm.getCatGoods(childCat.catCode, childCat.catCode, childCat.catNameCn)
          }
        }
      }, [_vm._v(_vm._s(childCat.catNameCn))])]) : _vm._e()
    })), _vm._v(" "), _c('h3', [_c('i', {
      staticClass: "ico-3"
    }), _vm._v(_vm._s(cat.catNameCn) + "专区")])]), _vm._v(" "), _c('div', {
      staticClass: "bd"
    }, [_c('ul', {
      staticClass: "items"
    }, _vm._l((cat.goodsList), function(goodsBo) {
      return _c('li', [_c('a', {
        on: {
          "click": function($event) {
            _vm.goDetail(goodsBo.goodsCode)
          }
        }
      }, [_c('img', {
        attrs: {
          "src": _vm.profixPath + goodsBo.imgMiddle,
          "width": "197",
          "height": "197"
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "line-tit"
      }, [_c('a', {
        staticClass: "co4",
        attrs: {
          "href": "#"
        }
      }, [_vm._v(_vm._s(goodsBo.goodsName))])]), _vm._v(" "), _c('div', {
        staticClass: "line-price"
      }, [_c('span', {
        staticClass: "co3"
      }, [_vm._v(_vm._s(goodsBo.unitPrice == 0 ? "" : "￥" + (goodsBo.unitPrice / 100).toFixed(2)))]), _c('span', {
        staticClass: "old"
      }, [_vm._v("￥" + _vm._s((goodsBo.marketPrice / 100).toFixed(2)))])]), _vm._v(" "), _c('div', {
        staticClass: "pinpainow_item_time"
      }, [(goodsBo.saleStatus === 'end') ? _c('span', {
        staticClass: "brandsknow_time_txt"
      }, [_vm._v("\n                \t\t\t\t已结束\n                \t\t\t")]) : _vm._e(), _vm._v(" "), (goodsBo.saleStatus === 'wait_start') ? _c('span', {
        staticClass: "brandsknow_time_txt"
      }, [_vm._v("\n                \t\t\t\t距开始 "), _c('i', {
        staticClass: "brandsknow_time_txt_time"
      }, [_vm._v(_vm._s(goodsBo.hour))]), _vm._v("时"), _c('i', {
        staticClass: "brandsknow_time_txt_time"
      }, [_vm._v(_vm._s(goodsBo.minute))]), _vm._v("分"), _c('i', {
        staticClass: "brandsknow_time_txt_time"
      }, [_vm._v(_vm._s(goodsBo.second))]), _vm._v("秒\n                \t\t\t")]) : _vm._e(), _vm._v(" "), (goodsBo.saleStatus === 'on_sale') ? _c('span', {
        staticClass: "brandsknow_time_txt"
      }, [_vm._v("\n                \t\t\t\t距结束 "), _c('i', {
        staticClass: "brandsknow_time_txt_time"
      }, [_vm._v(_vm._s(goodsBo.hour))]), _vm._v("时"), _c('i', {
        staticClass: "brandsknow_time_txt_time"
      }, [_vm._v(_vm._s(goodsBo.minute))]), _vm._v("分"), _c('i', {
        staticClass: "brandsknow_time_txt_time"
      }, [_vm._v(_vm._s(goodsBo.second))]), _vm._v("秒\n                \t\t\t")]) : _vm._e()])])
    }))])])]) : _vm._e(), _vm._v(" "), (cat.catCode != 'spike' && cat.goodsList.length > 0) ? _c('div', {
      staticClass: "grid-c1 suit-dress"
    }, [_c('div', {
      staticClass: "side-l"
    }, [_c('div', {
      staticClass: "hd"
    }, [_c('a', {
      staticClass: "more",
      on: {
        "click": function($event) {
          _vm.getMore(cat.catCode, cat.catNameCn)
        }
      }
    }, [_vm._v("更多 >")]), _vm._v(" "), _c('ul', {
      staticClass: "tags"
    }, _vm._l((cat.catBoList), function(childCat, idx) {
      return (idx < 8) ? _c('li', [_c('a', {
        on: {
          "click": function($event) {
            _vm.getCatGoods(childCat.catCode, childCat.catNameCn)
          }
        }
      }, [_vm._v(_vm._s(childCat.catNameCn))])]) : _vm._e()
    })), _vm._v(" "), _c('h3', [_vm._v(_vm._s(cat.catNameCn) + "专区")])]), _vm._v(" "), _c('div', {
      staticClass: "bd"
    }, [_c('a', {
      staticClass: "showpic",
      on: {
        "click": function($event) {
          _vm.getMore(cat.catCode, cat.catNameCn)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": cat.picPath,
        "width": "300",
        "height": "550"
      }
    })]), _vm._v(" "), _c('ul', {
      staticClass: "items"
    }, _vm._l((cat.goodsList), function(goodsBo) {
      return _c('li', [_c('a', {
        on: {
          "click": function($event) {
            _vm.goDetail(goodsBo.goodsCode)
          }
        }
      }, [_c('img', {
        attrs: {
          "src": _vm.profixPath + goodsBo.imgMiddle,
          "width": "197",
          "height": "197"
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "line-tit"
      }, [_c('a', {
        staticClass: "co4",
        attrs: {
          "href": "#"
        }
      }, [_vm._v(_vm._s(goodsBo.goodsName))])]), _vm._v(" "), (goodsBo.goodsPrice == 0) ? _c('div', {
        staticClass: "line-price"
      }, [_c('span', {
        staticClass: "co3"
      }, [_vm._v(_vm._s(goodsBo.unitPrice == 0 ? "" : "￥" + (goodsBo.unitPrice / 100).toFixed(2)) + " ")])]) : _c('div', {
        staticClass: "line-price"
      }, [_c('span', {
        staticClass: "co3"
      }, [_vm._v("\n                        \t\t" + _vm._s(goodsBo.goodsPrice) + "\n\t\t\t\t\t\t\t\t"), (goodsBo.pointType == 'point') ? _c('span', [_vm._v("积分")]) : (goodsBo.pointType == 'special') ? _c('span', [_vm._v("专用积分")]) : (goodsBo.pointType == 'red') ? _c('span', [_vm._v("红积分")]) : (goodsBo.pointType == 'blue') ? _c('span', [_vm._v("蓝积分")]) : _vm._e(), _vm._v(" \n                        \t")])])])
    }))])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clear mt15"
    }), _vm._v(" "), _vm._l((_vm.adsItem), function(ads, ads_idx) {
      return (index == ads_idx) ? _c('div', {
        staticStyle: {
          "margin-top": "15px"
        }
      }, [_c('a', {
        attrs: {
          "href": ads.link
        }
      }, [_c('img', {
        attrs: {
          "src": ads.mediaCode,
          "width": "1200",
          "height": "130"
        }
      })])]) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticClass: "clear mt15"
    })], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "top",
    on: {
      "click": function($event) {
        _vm.scrollToTop()
      }
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "clear mt20"
  })], 2), _vm._v(" "), (_vm.bottomAdsItem.mediaCode != null) ? _c('div', {
    staticStyle: {
      "padding-bottom": "0.8rem",
      "width": "1200px",
      "margin": "auto"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.bottomAdsItem.mediaCode,
      "width": "1200",
      "height": "60"
    }
  })]) : _vm._e(), _vm._v(" "), _c('footermenu'), _vm._v(" "), _c('footercopyright')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hd"
  }, [_c('h3', {
    staticClass: "hd-tit"
  }, [_vm._v("抢购")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('span', [_vm._v("TOP")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nnXf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zcjy-1.dac7566.jpg";

/***/ }),

/***/ "nz2A":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "o+fC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_meterialList_vue__ = __webpack_require__("16u8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_499be6a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_meterialList_vue__ = __webpack_require__("Q1ZF");
function injectStyle (ssrContext) {
  __webpack_require__("ZjUR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-499be6a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_meterialList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_499be6a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_meterialList_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oICd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = MP;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

function MP(ak) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    window.onload = function () {
      resolve(BMap);
    };
    var script = document.createElement("script");
    script.id = "mapScriptId";
    script.type = "text/javascript";
    script.src = "http://api.map.baidu.com/api?v=3.0&ak=" + ak + "&callback=init";
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

/***/ }),

/***/ "pTNH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('topbar'), _vm._v(" "), _c('sortHeader'), _vm._v(" "), _c('heardernav'), _vm._v(" "), _c('div', {
    staticClass: "border p20 container_outer"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "clr"
  }), _vm._v(" "), _c('div', {
    staticClass: "mt20"
  }, [_c('form', [_c('table', {
    staticClass: "table-c-5",
    attrs: {
      "width": "100%",
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "150px",
      "height": "35px",
      "background": "#f60",
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#FFf"
    }
  }, [_vm._v(_vm._s(_vm.addressTitle))])]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "areaInfo"
    }
  }, [_vm._m(1), _vm._v(" "), _c('td', [_c('v-distpicker', {
    attrs: {
      "province": _vm.select.province,
      "city": _vm.select.city,
      "area": _vm.select.district
    },
    on: {
      "selected": _vm.onSelected
    }
  })], 1)]), _vm._v(" "), _c('tr', [_vm._m(2), _vm._v(" "), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    staticStyle: {
      "width": "450px",
      "padding": "5px",
      "background": "#fff",
      "border": "1px solid #c6c6c6",
      "max-width": "450px"
    },
    attrs: {
      "rows": "5",
      "cols": "55",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_vm._m(3), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contextName),
      expression: "contextName"
    }],
    staticStyle: {
      "padding": "5px",
      "background": "#fff",
      "border": "1px solid #c6c6c6",
      "width": "300px"
    },
    attrs: {
      "value": "",
      "type": "text",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.contextName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contextName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_vm._m(4), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    staticStyle: {
      "padding": "5px",
      "background": "#fff",
      "border": "1px solid #c6c6c6",
      "width": "185px"
    },
    attrs: {
      "type": "text",
      "value": "",
      "maxlength": "13"
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('tr', [_vm._m(5), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zipcode),
      expression: "zipcode"
    }],
    staticStyle: {
      "padding": "5px",
      "background": "#fff",
      "border": "1px solid #c6c6c6",
      "width": "185px"
    },
    attrs: {
      "type": "text",
      "value": "",
      "maxlength": "13"
    },
    domProps: {
      "value": (_vm.zipcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.zipcode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('tr', [_c('th', {
    staticStyle: {
      "width": "150px",
      "padding-right": "15px"
    }
  }), _vm._v(" "), _c('td', [_c('input', {
    staticClass: "submit_button",
    attrs: {
      "type": "button",
      "value": "保存"
    },
    on: {
      "click": function($event) {
        _vm.saveAddress()
      }
    }
  })])])])])])])]), _vm._v(" "), _c('footermenu'), _vm._v(" "), _c('footercopyright')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-h4"
  }, [_c('h4', {
    staticClass: "left"
  }, [_vm._v("收货地址")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticStyle: {
      "width": "150px",
      "padding-right": "15px"
    }
  }, [_vm._v("所在地区"), _c('span', {
    staticStyle: {
      "color": "#f00"
    }
  }, [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticStyle: {
      "width": "150px",
      "padding-right": "15px"
    }
  }, [_vm._v("详细地址"), _c('span', {
    staticStyle: {
      "color": "#f00"
    }
  }, [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticStyle: {
      "width": "150px",
      "padding-right": "15px"
    }
  }, [_vm._v("收件人姓名"), _c('span', {
    staticStyle: {
      "color": "#f00"
    }
  }, [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticStyle: {
      "width": "150px",
      "padding-right": "15px"
    }
  }, [_vm._v("联系电话"), _c('span', {
    staticStyle: {
      "color": "#f00"
    }
  }, [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticStyle: {
      "width": "150px",
      "padding-right": "15px"
    }
  }, [_vm._v("邮政编码"), _c('span', {
    staticStyle: {
      "color": "#f00"
    }
  }, [_vm._v("*")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pYz0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pmnU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('topbar'), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header line"
  }, [_c('div', {
    staticClass: "w1200 bc"
  }, [_c('a', {
    staticClass: "logo fl",
    attrs: {
      "href": _vm.indexUrl,
      "title": "云永云商城"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('span', {
    staticClass: "ico"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sortParam),
      expression: "sortParam"
    }],
    staticClass: "text",
    attrs: {
      "type": "text",
      "placeholder": "请输入关键字"
    },
    domProps: {
      "value": (_vm.sortParam)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sortParam = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.findGoods()
      }
    }
  }, [_vm._v("搜商品")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "margin-left": "3px"
    },
    on: {
      "click": function($event) {
        _vm.findShops()
      }
    }
  }, [_vm._v("搜店铺")])]), _vm._v(" "), _c('div', {
    staticClass: "r-box fr",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "mycart",
    on: {
      "mouseenter": function($event) {
        _vm.shopCarShow()
      },
      "mouseleave": function($event) {
        _vm.shopCarHide()
      }
    }
  }, [_c('i', {
    staticClass: "ico-cart"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("我的购物车")]), _vm._v(" "), _c('span', {
    staticClass: "ico-shopping-amount"
  }, [_vm._v(_vm._s(_vm.shoppingCartNum))]), _vm._v(" "), _c('i', {
    staticClass: "ico-r"
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-list none",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), (_vm.shoppingCartNum == 0) ? _c('div', {
    staticClass: "no-goods"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("HdMn"),
      "width": "57",
      "height": "49"
    }
  }), _vm._v("购物车中还没有商品，赶紧选购吧！\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.shoppingCartNum > 0) ? _c('div', {
    staticClass: "mylist"
  }, [_c('h4', [_vm._v("最新加入的商品")]), _vm._v(" "), _c('ul', _vm._l((_vm.boList), function(bo) {
    return _c('li', {
      staticClass: "li-2",
      attrs: {
        "id": bo.goodsCode + '_cart_pro'
      }
    }, [_c('a', {
      staticClass: "fl spic",
      attrs: {
        "href": "#"
      }
    }, [_c('img', {
      attrs: {
        "src": bo.imgSmall,
        "width": "50",
        "height": "50"
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "name"
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(bo.goodsName))]), _vm._v("    "), _c('span', [_vm._v("数量：" + _vm._s(bo.goodsNumber))])]), _vm._v(" "), _c('p', {
      staticClass: "other"
    }, [_c('span', [_vm._v("￥" + _vm._s(bo.goodsPrice))]), _c('br'), _vm._v(" "), _c('a', {
      staticClass: "del",
      on: {
        "click": function($event) {
          _vm.deleteGoods(bo.goodsCode)
        }
      }
    }, [_vm._v("删除")])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "fbar"
  }, [_c('span', {
    staticClass: "fl ml10"
  }, [_vm._v("共" + _vm._s(_vm.count) + "件商品　共计"), _c('b', [_vm._v("￥ " + _vm._s(_vm.sumMoney))])]), _vm._v(" "), _c('a', {
    staticClass: "fr gobuy",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("去购物车")])])]) : _vm._e()])]), _vm._v(" "), (_vm.isLogin == true) ? _c('div', {
    staticClass: "myorder ml25",
    on: {
      "mouseenter": function($event) {
        _vm.orderShow()
      },
      "mouseleave": function($event) {
        _vm.orderHide()
      }
    }
  }, [_c('i', {
    staticClass: "ico-orders"
  }), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.goOrder('')
      }
    }
  }, [_vm._v("我的订单 "), _c('span', {
    staticClass: "ico-shopping-amount"
  }, [_vm._v(_vm._s(_vm.allCount))])]), _vm._v(" "), _c('i', {
    staticClass: "ico-r"
  }), _vm._v(" "), _c('div', {
    staticClass: "orders-list orders"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('wait_buyer_pay')
      }
    }
  }, [_vm._v("等待买家付款 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.payCount))])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('wait_send_goods')
      }
    }
  }, [_vm._v("等待卖家发货 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.sendCount))])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('wait_buyer_confirm_goods')
      }
    }
  }, [_vm._v("等待确认收货 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.putCount))])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('trade_finish')
      }
    }
  }, [_vm._v("订单完成 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.receiveCount))])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('trade_close')
      }
    }
  }, [_vm._v("订单关闭 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.closeCount))])])])])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "head-nav clear-l"
  }, [_c('div', {
    staticClass: "w1200 bc"
  }, [_c('div', {
    staticClass: "mall-categorys fl"
  }, [_c('div', {
    staticClass: "hd",
    on: {
      "mouseenter": function($event) {
        _vm.goodsCateShow()
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("全部分类")])]), _vm._v(" "), _c('div', {
    staticClass: "sc-submenu none",
    staticStyle: {
      "opacity": "0.85",
      "background": "rgb(130, 122, 123)"
    },
    on: {
      "mouseleave": function($event) {
        _vm.goodsCateHidden()
      }
    }
  }, [_c('ul', _vm._l((_vm.catList), function(cat) {
    return _c('li', {
      staticClass: "li-1",
      on: {
        "mouseleave": function($event) {
          _vm.childCateHide(cat.catCode)
        }
      }
    }, [_c('div', {
      staticClass: "yj",
      staticStyle: {
        "background": "rgb(130, 122, 123)"
      },
      on: {
        "mouseenter": function($event) {
          _vm.childCateShow(cat.catCode)
        }
      }
    }, [_c('i', {
      staticClass: "sc-ico-nav sc-ico-01"
    }), _vm._v(" "), _c('a', {
      staticClass: "fb",
      staticStyle: {
        "color": "#fdfbfb"
      }
    }, [_vm._v(_vm._s(cat.catNameCn))]), _vm._v(" "), _c('i', {
      staticClass: "sc-ico-arrow"
    })]), _vm._v(" "), _c('div', {
      staticClass: "sc-submenu-all none",
      attrs: {
        "id": cat.catCode + '_child'
      },
      on: {
        "mouseenter": function($event) {
          _vm.childCateShow(cat.catCode)
        }
      }
    }, [_c('dl', [_c('dt', [_c('i'), _vm._v(_vm._s(cat.catNameCn))]), _vm._v(" "), _c('dd', [_vm._l((cat.catBoList), function(childCat) {
      return _c('a', {
        on: {
          "click": function($event) {
            _vm.getCatGoods(childCat.catCode, childCat.catNameCn)
          }
        }
      }, [_vm._v(_vm._s(childCat.catNameCn))])
    }), _vm._v(" "), _c('a', {
      on: {
        "click": function($event) {
          _vm.getMoreCatGoods(cat.catCode, cat.catNameCn)
        }
      }
    }, [_vm._v("更多")])], 2)])])])
  }))])]), _vm._v(" "), _c('ul', {
    staticClass: "nav fl"
  }, [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goIndex()
      }
    }
  }, [_vm._v("商城首页")])]), _vm._v(" "), _vm._l((_vm.catList), function(carBo, index) {
    return (index < 6) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          _vm.getMoreCatGoods(carBo.catCode, carBo.catNameCn)
        }
      }
    }, [_vm._v(_vm._s(carBo.catNameCn))])]) : _vm._e()
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "clear mt15"
  }), _vm._v(" "), _c('div', {
    staticClass: "w1200 bc"
  }, [_c('div', {
    staticClass: "hq-crumb-wrap"
  }, [_c('ul', [_c('li', {
    staticClass: "item"
  }, [_vm._v("首页")]), _vm._v(" "), _c('li', {
    staticClass: "item sep"
  }, [_vm._v(">")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.sortParam))])])]), _vm._v(" "), _c('div', {
    staticClass: "sp-side-wrap"
  }, [_vm._m(0), _vm._v(" "), _c('ul', _vm._l((_vm.relativeShopList), function(relativeShop) {
    return _c('li', [_c('a', {
      staticClass: "fl pic",
      on: {
        "click": function($event) {
          _vm.goShop(relativeShop.shopCode)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": relativeShop.shopStandarLogo,
        "width": "106",
        "height": "106"
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "title"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.goShop(relativeShop.shopCode)
        }
      }
    }, [_vm._v(_vm._s(relativeShop.shopName))])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "sp-search-list"
  }, [_c('div', {
    staticClass: "l-hd"
  }, [_c('div', {
    staticClass: "top-num fr"
  }, [_vm._v("共" + _vm._s(_vm.totalItem) + "条 "), _c('span', {
    staticClass: "co2"
  }, [_vm._v(_vm._s(_vm.sortParam))])]), _vm._v(" "), _c('h3', [_vm._v("搜索结果")])]), _vm._v(" "), _c('div', {
    staticClass: "pro-list"
  }, [_c('ul', _vm._l((_vm.shopList), function(shopBo) {
    return _c('li', [_c('p', {
      staticClass: "img"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.goShop(shopBo.shopCode)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": shopBo.shopStandarLogo,
        "width": "265",
        "height": "265"
      }
    })])]), _vm._v(" "), _c('p', {
      staticClass: "title"
    }, [_c('i', {
      staticClass: "ico-shop-l"
    }), _c('a', {
      on: {
        "click": function($event) {
          _vm.goShop(shopBo.shopCode)
        }
      }
    }, [_vm._v(_vm._s(shopBo.shopName))])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "dp-pages tc"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.prePage()
      }
    }
  }, [_vm._v(" < ")]), _vm._v(" "), _vm._l((_vm.pageList), function(page) {
    return _c('a', {
      class: {
        "current_page": _vm.currentPage === page
      },
      on: {
        "click": function($event) {
          _vm.queryByPage(page)
        }
      }
    }, [_vm._v(_vm._s(page))])
  }), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.nextPage()
      }
    }
  }, [_vm._v(" > ")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('footermenu'), _vm._v(" "), _c('footercopyright')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hd"
  }, [_c('h3', [_vm._v("相关店铺")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb20 ad-4 mt20"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("dlf8"),
      "width": "1200",
      "height": "60"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ppu4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pqfS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__("ORbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TopBar__ = __webpack_require__("5PWk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_EmallHeader__ = __webpack_require__("3w6z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FooterMenu__ = __webpack_require__("gTlp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FooterCopyright__ = __webpack_require__("3LwO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_js_emallUtils_js__ = __webpack_require__("spYF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_js_alertConfirm_js__ = __webpack_require__("bCJ+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__static_api_api_js__ = __webpack_require__("fXcb");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*引入Vue框架*/

/*引入资源请求插件*/

/*使用VueResource插件*/
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);




//import jQuery from "../../../static/js/jquery.min.js"





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_9_mint_ui__["Swipe"].name, __WEBPACK_IMPORTED_MODULE_9_mint_ui__["Swipe"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_9_mint_ui__["SwipeItem"].name, __WEBPACK_IMPORTED_MODULE_9_mint_ui__["SwipeItem"]);

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'shop_index',
	data: function data() {
		return {
			tea: [],
			wine: [],
			shopBo: {},
			sliderItems: [],
			bannerItem: '',
			adsItem: '',
			bottomAdsItem: '',
			sliderHeight: '370px',
			shopCatList: '',
			shopCode: '',
			catCode: 'categoryAll',
			interval: 'intervalAll',
			sortTime: 'timeAll',
			currentPage: 1,
			totalPage: 1,
			orderBy: '',
			orderAsc: '',
			firstCatList: [],
			profixPath: '',
			isExistFavoriteShop: 0,
			linkList: [],
			goodRate: '',
			computeFlag: '',
			noGoods: false
		};
	},

	components: {
		'topbar': __WEBPACK_IMPORTED_MODULE_2__components_TopBar__["a" /* default */],
		'emallheader': __WEBPACK_IMPORTED_MODULE_3__components_EmallHeader__["a" /* default */],
		'footermenu': __WEBPACK_IMPORTED_MODULE_4__components_FooterMenu__["a" /* default */],
		'footercopyright': __WEBPACK_IMPORTED_MODULE_5__components_FooterCopyright__["a" /* default */]
	},
	methods: {
		goUrl: function goUrl(url) {
			var currentUrl = window.location.href;
			if (currentUrl.split("?")[0] == url.split("?")[0]) {
				window.location.href = url;
				window.location.reload();
			} else {
				window.location.href = url;
			}
		},
		getCatGoods: function getCatGoods(childCatCode, firstCatCode) {
			var that = this;
			var parentCode = "";
			if (childCatCode == "") {
				parentCode = firstCatCode;
			}
			__WEBPACK_IMPORTED_MODULE_10__static_api_api_js__["a" /* default */].getShopGoodsByCat(that.shopCode, childCatCode, parentCode, function (ret) {
				var goodsShopBos = ret.data.goodsShopBos;
				var vhtml = "";
				if (goodsShopBos != undefined) {
					for (var i = 0; i < goodsShopBos.length; i++) {

						//商品图片
						var imgMiddle = goodsShopBos[i].imgMiddle; // 图片
						if (imgMiddle.indexOf(";") != -1) {
							imgMiddle = imgMiddle.split(";")[0];
						}
						imgMiddle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + imgMiddle;
						goodsShopBos[i].imgMiddle = imgMiddle;
						goodsShopBos[i].unitPrice = goodsShopBos[i].unitPrice / 100;

						vhtml += "<li>";
						vhtml += "<p class='pic tc'>";
						vhtml += "<a href='#goodsDetails?goodsCode=" + goodsShopBos[i].goodsCode + "'><img src='" + goodsShopBos[i].imgMiddle + "' width='265' height='265'></a>";
						vhtml += "</p>";
						vhtml += "<p class='title'>";
						vhtml += "<a href='#goodsDetails?goodsCode=" + goodsShopBos[i].goodsCode + "'>" + goodsShopBos[i].goodsName + "</a>";
						vhtml += "</p>";
						vhtml += "<p class='other'>";
						vhtml += "<span class='price'>¥" + goodsShopBos[i].unitPrice + "</span>";
						vhtml += "</p>";
						vhtml += "</li>";
					}
				}
				//						jQuery("#"+firstCatCode).html(vhtml);
				__WEBPACK_IMPORTED_MODULE_6_jquery___default()("#" + firstCatCode).html(vhtml);
			});
		},
		goDetail: function goDetail(goodsCode) {
			this.$router.push({
				name: 'goodsdetail',
				query: {
					goodsCode: goodsCode
				}
			});
		},
		goShopIntroduction: function goShopIntroduction() {
			this.$router.push({
				name: 'shopIntroduction',
				query: {
					shopCode: this.shopCode
				}
			});
		},
		goodsCateShow: function goodsCateShow() {
			$(".categorys-dropdown").show();
		},
		goodsCateHidden: function goodsCateHidden() {
			$(".categorys-dropdown").hide();
		},
		shopAskAndFavoriteShow: function shopAskAndFavoriteShow() {
			$(".zx-drop-box").show();
		},
		shopAskAndFavoriteHidden: function shopAskAndFavoriteHidden() {
			$(".zx-drop-box").hide();
		},
		getShopInfo: function getShopInfo() {
			var that = this;
			var shopCode = that.shopCode;
			this.$http.jsonp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__static_js_emallUtils_js__["q" /* getAjaxUrl */])() + "/shop/ajax_shop.json", {
				params: {
					shopCode: shopCode
				},
				jsonp: 'callback'
			}).then(function (res) {
				if (res.body.code == "success") {

					var shopBo = res.body.data.shopBo;
					var goodRate = res.body.data.goodRate;
					if (goodRate != undefined) {
						that.goodRate = goodRate;
					}
					//alert(shopBo.creditPoint);
					if (shopBo != undefined) {
						var qq = shopBo.qq;
						if (qq != undefined && qq != '') {
							shopBo.qq = 'http://wpa.qq.com/msgrd?v=3&site=qq&menu=yes&uin=' + qq;
						}
					}
					that.shopBo = shopBo;

					var linkList = res.body.data.linkList;
					if (linkList != undefined) {
						for (var i = 0; i < linkList.length; i++) {
							linkList[i].mediaCode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + linkList[i].mediaCode;
						}
						that.linkList = linkList;
					}

					var firstCatList = res.body.data.firstCatList;
					if (firstCatList != undefined) {
						that.firstCatList = firstCatList;
						if (firstCatList.length == 0) {
							that.noGoods = true;
						}
						for (var i = 0; i < firstCatList.length; i++) {
							if (firstCatList[i].catCode == 'spike') {
								for (var j = 0; j < firstCatList[i].goodsList.length; j++) {

									var marketPrice = JSON.parse(firstCatList[i].goodsList[j].attrValue).marketPrice;
									var saleTimeStr = JSON.parse(firstCatList[i].goodsList[j].attrValue).saleTimeShow;
									var saleEndTimeStr = JSON.parse(firstCatList[i].goodsList[j].attrValue).saleEndTimeShow;
									if (marketPrice != undefined && marketPrice != "") {
										firstCatList[i].goodsList[j].marketPrice = marketPrice;
									} else {
										firstCatList[i].goodsList[j].marketPrice = firstCatList[i].goodsList[j].unitPrice;
									}
									if (saleEndTimeStr != undefined && saleEndTimeStr != '') {
										saleEndTimeStr = saleEndTimeStr.replace(/-/g, "/");
										var saleEndDate = new Date(saleEndTimeStr);

										saleTimeStr = saleTimeStr.replace(/-/g, "/");
										var saleDate = new Date(saleTimeStr);

										//如果当期日期大于销售结束日期 xxx
										if (new Date() > saleEndDate) {
											firstCatList[i].goodsList[j].saleStatus = "end";
										} else if (new Date() < saleDate) {
											//如果当期时间小于上架时间，展示距离开始 时间
											firstCatList[i].goodsList[j].saleStatus = "wait_start";
											var begSeconds = saleDate.getTime() - new Date().getTime(); //时间差的毫秒数        
											//计算出相差天数  
											//  								var days=Math.floor(begSeconds/(24*3600*1000));  
											//计算出小时数  
											var leave1 = begSeconds % (24 * 3600 * 1000); //计算天数后剩余的毫秒数  
											var hours = Math.floor(begSeconds / (3600 * 1000));
											//计算相差分钟数  
											var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数  
											var minutes = Math.floor(leave2 / (60 * 1000));
											//计算相差秒数  
											var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数  
											var seconds = Math.round(leave3 / 1000);
											// 									firstCatList[i].goodsList[j].day=days;
											firstCatList[i].goodsList[j].hour = hours;
											firstCatList[i].goodsList[j].minute = minutes;
											firstCatList[i].goodsList[j].second = seconds;
										} else {
											firstCatList[i].goodsList[j].saleStatus = "on_sale";

											var begSeconds = saleEndDate.getTime() - new Date().getTime(); //时间差的毫秒数        
											//计算出相差天数  
											//  								var days=Math.floor(begSeconds/(24*3600*1000));  
											//计算出小时数  
											var leave1 = begSeconds % (24 * 3600 * 1000); //计算天数后剩余的毫秒数  
											var hours = Math.floor(begSeconds / (3600 * 1000));
											//计算相差分钟数  
											var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数  
											var minutes = Math.floor(leave2 / (60 * 1000));
											//计算相差秒数  
											var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数  
											var seconds = Math.round(leave3 / 1000);
											// 									firstCatList[i].goodsList[j].day=days;
											firstCatList[i].goodsList[j].hour = hours;
											firstCatList[i].goodsList[j].minute = minutes;
											firstCatList[i].goodsList[j].second = seconds;
										}
									}
								}
							}
						}
					}
					that.profixPath = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=";
				}
			}, function () {});
		},
		getShopIndexAds: function getShopIndexAds(shopCode) {
			var that = this;
			this.$http.jsonp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__static_js_emallUtils_js__["q" /* getAjaxUrl */])() + "/shop/ajax_shop_index_ads.htm", {
				params: {
					shopCode: shopCode
				},
				jsonp: 'callback'
			}).then(function (ret) {
				if (ret.body.code == "success") {
					var adsList = ret.body.data.adsList;
					if (adsList != undefined) {
						var sliderItems = new Array();
						for (var i = 0; i < adsList.length; i++) {
							adsList[i].mediaCode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + adsList[i].mediaCode;
							if (adsList[i].adsType == "slider") {
								sliderItems.push(adsList[i]);
							} else if (adsList[i].adsType == "banner") {
								that.bannerItem = adsList[i];
							} else if (adsList[i].adsType == "inner_ads") {
								that.adsItem = adsList[i];
							} else if (adsList[i].adsType == "bottom_slogen") {
								that.bottomAdsItem = adsList[i];
							}
						}
						that.sliderItems = sliderItems;
					}
				} else {}
			}, function () {});
		},
		getShopGoods: function getShopGoods() {
			var that = this;
			var interval = "intervalAll";
			var catCode = "categoryAll";
			var cabinetId = "";
			var pageSize = 8;
			var isQueryAll = "y";
			var currentPage = that.currentPage;
			var orderBy = that.orderBy;
			var orderAsc = that.orderAsc;
			var shopCode = that.shopCode;
			var sortTime = that.sortTime;
			this.$http.jsonp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__static_js_emallUtils_js__["q" /* getAjaxUrl */])() + "/goods/ajax_goods_list.json", {
				params: {
					cabinetId: cabinetId,
					catCode: catCode,
					interval: interval,
					currentPage: currentPage,
					orderBy: orderBy,
					orderAsc: orderAsc,
					shopCode: shopCode,
					sortTime: sortTime,
					pageSize: pageSize,
					isQueryAll: isQueryAll
				},
				jsonp: 'callback'
			}).then(function (res) {
				if (res.body.code == "success") {
					var goods = res.body.data.goods;
					var totalPage = res.body.data.totalPage;
					that.totalPage = totalPage;
					for (var i = 0; i < goods.length; i++) {
						//商品图片
						var imgMiddle = goods[i].imgMiddle; // 图片
						if (imgMiddle.indexOf(";") != -1) {
							imgMiddle = imgMiddle.split(";")[0];
						}
						imgMiddle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__static_js_emallUtils_js__["m" /* getImgUrl */])() + "/upload/show.htm?filePath=" + imgMiddle;
						goods[i].imgMiddle = imgMiddle;
						goods[i].unitPrice = goods[i].unitPrice / 100;
					}
					var shopCatList = that.shopCatList;
					for (var i = 0; i < shopCatList.length; i++) {
						var vhtml = "";
						for (var j = 0; j < goods.length; j++) {
							if (goods[j].catCode == shopCatList[i].catCode) {
								vhtml += "<li>";
								vhtml += "<p class='pic tc'>";
								vhtml += "<a href='#goodsDetails?goodsCode=" + goods[j].goodsCode + "'><img src='" + goods[j].imgMiddle + "' width='265' height='265'></a>";
								vhtml += "</p>";
								vhtml += "<p class='title'>";
								vhtml += "<a href='#goodsDetails?goodsCode=" + goods[j].goodsCode + "'>" + goods[j].goodsName + "</a>";
								vhtml += "</p>";
								vhtml += "<p class='other'>";
								vhtml += "<span class='price'>¥" + goods[j].unitPrice + "</span>";
								vhtml += "</p>";
								vhtml += "</li>";
							}
						}
						__WEBPACK_IMPORTED_MODULE_6_jquery___default()("#" + shopCatList[i].catCode).html(vhtml);
					}
				} else {}
			}, function () {});
		},
		getMore: function getMore(catCode, catNameCn) {
			this.$router.push({
				path: 'goodsClassList',
				query: {
					firstCatCode: catCode,
					catNameCn: catNameCn,
					shopCode: this.shopCode
				}
			});
		},
		getShopCat: function getShopCat() {
			var that = this;
			var shopCode = that.shopCode;
			var isShow = "y";
			var isLeaf = "y";
			this.$http.jsonp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__static_js_emallUtils_js__["q" /* getAjaxUrl */])() + "/shop/ajax_shop_cat.json", {
				params: {
					shopCode: shopCode,
					isShow: isShow,
					isLeaf: isLeaf
				},
				jsonp: 'callback'
			}).then(function (res) {
				if (res.body.code == "success") {
					var shopCatList = res.body.data.shopCatList;
					that.shopCatList = shopCatList;
				} else {}
			}, function () {});
		},
		addOrDeleteFavoriteShop: function addOrDeleteFavoriteShop() {
			var that = this;
			var shopCode = that.shopCode;
			if (0 == that.isExistFavoriteShop) {
				__WEBPACK_IMPORTED_MODULE_10__static_api_api_js__["a" /* default */].addUserFavorite("shop", null, shopCode, function (ret) {
					if (ret.code != null && ret.code == "success") {
						that.isExistFavoriteShop = 1;
					} else if (ret.code != null && ret.code == "9999") {
						__WEBPACK_IMPORTED_MODULE_8__static_js_alertConfirm_js__["a" /* default */].singleConfirm("请先登录");
					}
				});
			} else if (1 == that.isExistFavoriteShop) {
				__WEBPACK_IMPORTED_MODULE_10__static_api_api_js__["a" /* default */].deleteFavoriteBycode("shop", null, shopCode, function (ret) {
					if (ret.code != null && ret.code == "success") {
						that.isExistFavoriteShop = 0;
					} else {
						__WEBPACK_IMPORTED_MODULE_8__static_js_alertConfirm_js__["a" /* default */].singleConfirm("操作失败");
					}
				});
			}
		},
		existFavoriteShop: function existFavoriteShop() {
			var that = this;
			var shopCode = that.shopCode;
			__WEBPACK_IMPORTED_MODULE_10__static_api_api_js__["a" /* default */].isExistFavorite("shop", null, shopCode, function (ret) {
				if (ret.code != null && ret.code == "success") {
					that.isExistFavoriteShop = ret.data.isExist;
				} else {
					console.error("existFavorite请求失败：" + ret.msg);
				}
			});
		},
		computeTime: function computeTime() {
			var that = this;
			var firstCatList = that.firstCatList;
			for (var i = 0; i < firstCatList.length; i++) {
				if (firstCatList[i].catCode == 'spike') {
					for (var j = 0; j < firstCatList[i].goodsList.length; j++) {
						var saleTimeStr = JSON.parse(firstCatList[i].goodsList[j].attrValue).saleTimeShow;
						var saleEndTimeStr = JSON.parse(firstCatList[i].goodsList[j].attrValue).saleEndTimeShow;

						if (saleEndTimeStr != undefined && saleEndTimeStr != '') {
							saleEndTimeStr = saleEndTimeStr.replace(/-/g, "/");
							var saleEndDate = new Date(saleEndTimeStr);

							saleTimeStr = saleTimeStr.replace(/-/g, "/");
							var saleDate = new Date(saleTimeStr);

							//如果当期日期大于销售结束日期 xxx
							if (new Date() > saleEndDate) {
								firstCatList[i].goodsList[j].saleStatus = "end";
							} else if (new Date() < saleDate) {
								//如果当期时间小于上架时间，展示距离开始 时间
								firstCatList[i].goodsList[j].saleStatus = "wait_start";
								var begSeconds = saleDate.getTime() - new Date().getTime(); //时间差的毫秒数        
								//计算出相差天数  
								//  								var days=Math.floor(begSeconds/(24*3600*1000));  
								//计算出小时数  
								var leave1 = begSeconds % (24 * 3600 * 1000); //计算天数后剩余的毫秒数  
								var hours = Math.floor(begSeconds / (3600 * 1000));
								//计算相差分钟数  
								var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数  
								var minutes = Math.floor(leave2 / (60 * 1000));
								//计算相差秒数  
								var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数  
								var seconds = Math.round(leave3 / 1000);
								//firstCatList[i].goodsList[j].unitPrice=firstCatList[i].goodsList[j].unitPrice+"1";
								firstCatList[i].goodsList[j].hour = hours;
								firstCatList[i].goodsList[j].minute = minutes;
								firstCatList[i].goodsList[j].second = seconds;
							} else {
								firstCatList[i].goodsList[j].saleStatus = "on_sale";

								var begSeconds = saleEndDate.getTime() - new Date().getTime(); //时间差的毫秒数        
								//计算出相差天数  
								//  								var days=Math.floor(begSeconds/(24*3600*1000));  
								//计算出小时数  
								var leave1 = begSeconds % (24 * 3600 * 1000); //计算天数后剩余的毫秒数  
								var hours = Math.floor(begSeconds / (3600 * 1000));
								//计算相差分钟数  
								var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数  
								var minutes = Math.floor(leave2 / (60 * 1000));
								//计算相差秒数  
								var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数  
								var seconds = Math.round(leave3 / 1000);
								firstCatList[i].goodsList[j].hour = hours;
								firstCatList[i].goodsList[j].minute = minutes;
								firstCatList[i].goodsList[j].second = seconds;
							}
						}
					}
				}
			}
		}
	},
	beforeMount: function beforeMount() {
		var shopCode = this.$route.query.shopCode;
		if (shopCode != undefined) {
			this.shopCode = shopCode;
		}
		this.getShopIndexAds(shopCode);
		this.existFavoriteShop();
	},
	beforeDestroy: function beforeDestroy() {
		window.clearInterval(this.computeFlag);
	},
	mounted: function mounted() {
		window.scrollTo(0, 0);
		var shopCode = this.$route.query.shopCode;
		if (shopCode != undefined) {
			this.shopCode = shopCode;
		}
		this.getShopInfo();
		this.getShopCat();

		var that = this;
		this.computeFlag = window.setInterval(function () {
			that.computeTime(); //计算倒计时
		}, 1000);
	}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "qR+W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rIE/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "spYF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getEmallUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getAboutUsUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getUcUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getIndexUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getImgUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCmsUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getAjaxUrl; });
/* unused harmony export getAdsList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return dateFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getValueFromMap; });
/* unused harmony export showMoney */
/* unused harmony export getFooterUrl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return parseResult; });
/* unused harmony export EnumPointType */
/* unused harmony export defaultMiddleImg */
/* unused harmony export defaultSmallImg */
/* unused harmony export Map */
/* unused harmony export GetQueryString */
/* unused harmony export isWeiXin */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ajaxUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return compareDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return sysContactUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return ak; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return pcGoodsDetailUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return mobileGoodsDetailUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return cmsApiUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return purchaserUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return brandUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return requirementUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return tradingHallUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return newsUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return exhibitionUrl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);


//import Light from "light";
//import {jQuery} from "./jshead.js";
//var domain="typaimai.com";
//var domain="hshs.exp";
//var domain="typaimai.test";
//var domain="e.hsyunyong.com";
var domain = AppConfig.url.domainUrl;

//环境
var pcGoodsDetailUrl = AppConfig.url.indexUrl + "/#/goodsDetails?goodsCode=";
var mobileGoodsDetailUrl = AppConfig.url.mobileGoodsDetailUrl + "/#/goods/goods_physical_detail?goodsCode=";
//var mobileGoodsDetailUrl = "http://momall."+domain+"/#/goods/goods_physical_detail?goodsCode=";
//UAT环境
//var mobileGoodsDetailUrl = "http://m-mall-uat."+domain+"/#/goods/goods_physical_detail?goodsCode=";

function getAboutUsUrl() {
	//测试环境
	//return "http://www.yibaobuy.com:28020/abount/629.htm";
	//生产环境
	return "http://cms.typaimai.com/aboutus/index.htm";
}
function getIndexUrl() {
	//测试环境
	//return "http://mall."+domain;
	//生产环境
	//	return "http://cms.91yyzx.cn";
	//UAT环境
	//return "http://mall-uat."+domain;
	return AppConfig.url.indexUrl;
}
function getCmsUrl() {
	//测试环境
	//return "http://mall."+domain;
	//生产环境
	//	return "http://cms.91yyzx.cn";
	//UAT环境
	//return "http://mall-uat."+domain;
	return AppConfig.url.cmsUrl;
}
function getUcUrl() {
	//开发环境
	//return "http://uc."+domain;
	//测试环境
	//return "http://uc."+domain;
	//生产环境
	//return "http://euc."+domain;
	//UAT环境
	//return "http://euc-uat."+domain;
	return AppConfig.url.ucUrl;
}
//东北商品
//var ajaxUrl = "http://emall.91yyzx.cn";
//香港收藏品
//ajaxUrl = "http://emall.yibaobuy.com";
//测试环境
//var ajaxUrl = "http://emall."+domain;
//UAT环境
//var ajaxUrl = "http://emall-uat."+domain;
var ajaxUrl = AppConfig.url.ajaxUrl;
//采购商服务
var purchaserUrl = AppConfig.url.purchaserUrl;
//品牌导航
var brandUrl = AppConfig.url.brandUrl;
//需求中心
var requirementUrl = AppConfig.url.requirementUrl;
//交易大厅
var tradingHallUrl = AppConfig.url.tradingHallUrl;
//新闻百科
var newsUrl = AppConfig.url.newsUrl;
//展会
var exhibitionUrl = AppConfig.url.exhibitionUrl;
/**
 * 
 */
function getAjaxUrl() {
	//return "http://emall.hsnsfe.dev/mobile";
	//测试环境
	//return "http://emall."+domain+"/mobile";
	//生产环境
	//return "http://emall.91yyzx.cn/mobile";
	//UAT环境
	//return "http://emall-uat."+domain+"/mobile";
	return AppConfig.url.ajaxUrl + "/mobile";
}

function getImgUrl() {
	//return "http://emall.hsnsfe.dev";
	//测试环境
	//return "http://emall."+domain;
	//生产环境
	//return "http://emall.91yyzx.cn";
	//UAT环境
	//return "http://emall-uat."+domain;
	return AppConfig.url.imgUrl;
}

function getEmallUrl() {
	//测试环境
	//return "http://emall."+domain;
	//生产环境
	//return "http://emall.91yyzx.cn";
	//UAT环境
	//return "http://emall.yibaobuy.com";
	//return "http://emall-uat."+domain;
	return AppConfig.url.emallUrl;
}

//联系客服链接
var sysContactUrl = AppConfig.url.contactUrl; //"http://wpa.qq.com/msgrd?v=3&uin=1850908193&site=qq&menu=yes";

//默认产品小图
var defaultSmallImg = "images/goods/defaultSmallImg.jpg";
var defaultMiddleImg = "images/goods/defaultMiddleImg.jpg";
var cmsApiUrl = AppConfig.url.cmsUrl + "/api/index.htm";

/**
 * 返回页面地址
 * @param {Object} url
 */
function getUrl(url) {
	var domain = sessionStorage.getItem("domain");
	if (domain == undefined || domain == null || domain == 'null') {
		return url;
	} else {
		if (url != undefined && url != null) {
			if (url.indexOf("http") == 0) {
				return url;
			}
			if (domain.lastIndexOf("/") < domain.length - 1) {
				domain += "/";
			}
			if (url.indexOf("/") == 0) {
				url = url.substring(1, url.length);
			}
			return domain + url;
		} else {
			return domain;
		}
	}
}

function getAdsList() {
	var imgUrls = new Array();
	var imgUrl1 = { 'imgUrl': 'images/temp/lb1.jpg' };
	var imgUrl2 = { 'imgUrl': 'images/temp/lb2.jpg' };
	var imgUrl3 = { 'imgUrl': 'images/temp/lb3.jpg' };
	imgUrls[0] = imgUrl1;
	imgUrls[1] = imgUrl2;
	imgUrls[2] = imgUrl3;
	return imgUrls;
}

/**
 * 占位符替换
 * @returns
 */
function StringFormat() {
	if (arguments.length == 0) return this;
	var str = arguments[0];
	for (var i = 1; i < arguments.length; i++) {
		var re = new RegExp('\\{' + (i - 1) + '\\}', 'gm');
		str = str.replace(re, arguments[i]);
	}
	return str;
}

/**
 * 获取地址栏参数
 */
function GetQueryString(name) {
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
	var r = window.location.search.substr(1).match(reg);
	if (r != null) return unescape(r[2]);
	return null;
}

/**
 * 权限控制
 */
function isPermission() {}

/**
 * 是否使用微信内置浏览器
 */
function isWeiXin() {
	var ua = window.navigator.userAgent.toLowerCase();
	if (ua.match(/MicroMessenger/i) == 'micromessenger') {
		return true;
	} else {
		return false;
	}
}

function saveDomain() {
	var curUrl = window.location.href;
	if (curUrl != undefined && curUrl.length > 0) {
		var curDomain = curUrl.substring(0, curUrl.indexOf("/loading") + 1);
		if (curDomain == undefined || curDomain == '') {
			var curDomain = curUrl.substring(0, curUrl.indexOf("/index") + 1);
		}
		if (curDomain == undefined || curDomain == '') {
			var curDomain = curUrl.substring(0, curUrl.indexOf("/model") + 1);
		}
		sessionStorage.setItem("domain", curDomain);
	}
}

/**
 * &#123456;转中文
 * @param {Object} str 输入字符串
 */
function unicode2chs(str) {
	if (str == undefined || str.length == 0) {
		return "";
	}
	var reg = /\d{5}/gi;
	var result = "";
	var strArr = str.match(reg);
	if (strArr == undefined || strArr == null || strArr.length == 0) {
		return str;
	}
	for (i in strArr) {
		decStr = strArr[i];
		hexStr = parseInt(decStr).toString(16);
		result += '%u' + hexStr;
	}
	return unescape(result);
}

//jQuery(document).ready(function() {
//	saveDomain();
//})

/**
 * 获取cookie，解决cookie为空问题，IOS微信使用，经过跳转添加token=1参数
 */
function getWxCookie() {
	var backUrl = window.location.href;
	if (backUrl.indexOf("token=1") < 0) {
		backUrl = encodeURIComponent(backUrl);
		var serverUrl = getAjaxUrl() + "/home/get_token.htm";
		window.location.href = serverUrl + "?backurl=" + backUrl;
	}
}

function isNotBlank(str) {
	if (typeof str != 'string') {
		return false;
	}
	if (str == undefined || str == null || str.trim() == '') {
		return false;
	}
	return true;
}
function isBlank(str) {
	return !isNotBlank(str);
}

var EnumPointType = {
	'point': '通用积分',
	'special': '专用积分',
	'red': '红积分',
	'blue': '蓝积分'
	//获取积分名称
};function getPointTypeName(pointType) {
	if (pointType == "point") {
		return "积分";
	}
}

function stringUtilsSplit(str, length) {
	if (str.length > length) {
		return str.substring(0, length) + "...";
	} else {
		return str;
	}
}

/**
* 解析结果
* @param {Object} result 返回结果
* @param {Object} errMsg 错误提示信息
* @param {Object} redirect 错误返回地址
*/
function parseResult(result, errMsg, redirect) {
	if (result == undefined) {
		return false;
	}
	if (result.code != undefined && result.code == '9999') {
		//			Light.navigate("login/login",{
		//				backUrl:redirect
		//			});
		alert("您暂无权限！");
		return false;
	}
	if (result.code != undefined && result.code == 'fail') {
		if (errMsg == undefined || errMsg == null) {
			if (result.msg != undefined && result.msg != null) {
				errMsg = result.msg;
			} else {
				errMsg = "系统繁忙，请稍后再试";
			}
		}
		//		alert(errMsg);
		/*mui.confirm(errMsg,'提示',['确定'],function(e){
  	if (redirect != false) {
  		if (redirect != undefined && redirect != null) {
  			window.location.href = redirect;
  		} else {
  			window.history.go(-1);
  		}
  	}
  });*/
		return false;
	}
	if (result.code != undefined && result.code == 'goodsNumFail') {
		if (errMsg == undefined || errMsg == null) {
			if (result.msg != undefined && result.msg != null) {
				errMsg = result.msg;
			} else {
				errMsg = "系统繁忙，请稍后再试";
			}
		}
		/*mui.confirm(errMsg,'提示',['确定'],function(e){
  	
  });*/
		//		alert(errMsg);
		return false;
	}
	if (result.code != undefined && result.code != 'success') {
		if (result.msg == undefined || result.msg == null) {
			errMsg = "系统繁忙，请稍后再试";
		} else {
			errMsg = result.msg;
		}
		/*mui.confirm(errMsg,'提示',['确定'],function(e){
  	if (redirect != false) {
  		if (redirect != undefined && redirect != null) {
  			window.location.href = redirect;
  		} else {
  			window.history.go(-1);
  		}
  	}
  });*/
		//		alert(errMsg);
		return false;
	}
	return true;
}

var emallTitle = "积分商城"; //商城标题
var showCoupon = false; //是否显示 促销券
var showCabinet = true; //是否展示橱窗
var showNavicate = true; //是否展示分类导航
var showMoney = true; //是否显示金额

function dateFormat(dateStr) {
	var showTime = "";
	if (dateStr.length == 14) {
		showTime += dateStr.substring(0, 4) + "-";
		showTime += dateStr.substring(4, 6) + "-";
		showTime += dateStr.substring(6, 8) + " ";
		showTime += dateStr.substring(8, 10) + ":";
		showTime += dateStr.substring(10, 12) + ":";
		showTime += dateStr.substring(12, 14);
	}
	return showTime;
}

function getValueFromMap(enumMap, enumKey) {
	var jsonStr = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(enumMap);
	var jsonObject = JSON.parse(jsonStr);
	var enumValue = jsonObject[enumKey];
	return enumValue;
}

function Map() {
	this.elements = new Array();

	//获取MAP元素个数     
	this.size = function () {
		return this.elements.length;
	};

	//判断MAP是否为空     
	this.isEmpty = function () {
		return this.elements.length < 1;
	};

	//删除MAP所有元素     
	this.clear = function () {
		this.elements = new Array();
	};

	//向MAP中增加元素（key, value)      
	this.put = function (_key, _value) {
		this.elements.push({
			key: _key,
			value: _value
		});
	};

	//删除指定KEY的元素，成功返回True，失败返回False     
	this.remove = function (_key) {
		var bln = false;
		try {
			for (var i = 0; i < this.elements.length; i++) {
				if (this.elements[i].key == _key) {
					this.elements.splice(i, 1);
					return true;
				}
			}
		} catch (e) {
			bln = false;
		}
		return bln;
	};

	//获取指定KEY的元素值VALUE，失败返回NULL     
	this.get = function (_key) {
		try {
			for (var i = 0; i < this.elements.length; i++) {
				if (this.elements[i].key == _key) {
					return this.elements[i].value;
				}
			}
		} catch (e) {
			return null;
		}
	};

	//获取指定索引的元素（使用element.key，element.value获取KEY和VALUE），失败返回NULL     
	this.element = function (_index) {
		if (_index < 0 || _index >= this.elements.length) {
			return null;
		}
		return this.elements[_index];
	};

	//判断MAP中是否含有指定KEY的元素     
	this.containsKey = function (_key) {
		var bln = false;
		try {
			for (var i = 0; i < this.elements.length; i++) {
				if (this.elements[i].key == _key) {
					bln = true;
				}
			}
		} catch (e) {
			bln = false;
		}
		return bln;
	};

	//判断MAP中是否含有指定VALUE的元素     
	this.containsValue = function (_value) {
		var bln = false;
		try {
			for (var i = 0; i < this.elements.length; i++) {
				if (this.elements[i].value == _value) {
					bln = true;
				}
			}
		} catch (e) {
			bln = false;
		}
		return bln;
	};

	//获取MAP中所有VALUE的数组（ARRAY）     
	this.values = function () {
		var arr = new Array();
		for (var i = 0; i < this.elements.length; i++) {
			arr.push(this.elements[i].value);
		}
		return arr;
	};

	//获取MAP中所有KEY的数组（ARRAY）     
	this.keys = function () {
		var arr = new Array();
		for (var i = 0; i < this.elements.length; i++) {
			arr.push(this.elements[i].key);
		}
		return arr;
	};
}
// 说明：两个时间相减
// 参数：JS的Date类型，或者 string 类型，格式为：yyyy-MM-dd HH:mm:ss
// 返回: date1-date2的秒数
function compareDate(date1, date2) {
	var type1 = typeof date1 === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(date1);
	var type2 = typeof date2 === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(date2);
	if (type1 == 'string') {
		date1 = new Date(date1);
	}
	if (type2 == 'string') {
		date2 = new Date(date2);
	}
	return (date1 - date2) / 1000;
}

//百度地图Ak
var ak = "AHTQQIz1IKN3P0BfojMHzH4GHkHt1Wyx";


/***/ }),

/***/ "tFka":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topbar"
  }, [_c('div', {
    staticClass: "w1200 bc"
  }, [_c('ul', {
    staticClass: "topbar-right fr"
  }, [(_vm.isLogin == true) ? _c('li', [_c('span', [_vm._v("您好")])]) : _vm._e(), _vm._v(" "), (_vm.isLogin == true) ? _c('li', [_c('a', {
    staticClass: "co2",
    attrs: {
      "href": _vm.userCenterUrl
    }
  }, [_vm._v(_vm._s(_vm.account))])]) : _vm._e(), _vm._v(" "), (_vm.isLogin == true) ? _c('li', [_c('a', {
    staticClass: "co2",
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("[退出]")])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticStyle: {
      "height": "30px",
      "width": "77px"
    },
    on: {
      "mouseenter": function($event) {
        _vm.shopCartShow()
      },
      "mouseleave": function($event) {
        _vm.shopCartHide()
      }
    }
  }, [_c('a', {
    on: {
      "click": _vm.toShopCart
    }
  }, [_vm._v("购物车")]), _vm._v("("), _c('a', {
    staticStyle: {
      "color": "#f60"
    }
  }, [_vm._v(_vm._s(_vm.count))]), _vm._v(")\n\t\t\t\t\n\t\t\t\t"), (_vm.isShow) ? _c('div', {
    staticClass: "top_shopcart",
    attrs: {
      "id": "shopCartInfo"
    }
  }, [_c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), (_vm.shoppingCartNum == 0) ? _c('div', {
    staticClass: "no-goods"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("HdMn"),
      "width": "57",
      "height": "49"
    }
  }), _vm._v("购物车中还没有商品，赶紧选购吧！\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.shoppingCartNum > 0) ? _c('div', {
    staticClass: "mylist"
  }, [_c('h4', [_vm._v("最新加入的商品 ")]), _vm._v(" "), _c('ul', _vm._l((_vm.boList), function(bo, index) {
    return _c('li', {
      staticClass: "li-2",
      attrs: {
        "id": bo.goodsCode + '_cart_pro'
      }
    }, [_c('a', {
      staticClass: "fl spic",
      on: {
        "click": function($event) {
          _vm.toDetail(bo.goodsCode)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": bo.imgSmall,
        "width": "50",
        "height": "50"
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "name"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.toDetail(bo.goodsCode)
        }
      }
    }, [_c('span', {
      attrs: {
        "name": "goodsName"
      }
    }, [_vm._v(_vm._s(bo.goodsName))]), (bo.specName != '') ? _c('span', [_vm._v("【" + _vm._s(bo.specName) + "】")]) : _vm._e()]), _vm._v("    "), _c('span', {
      staticStyle: {
        "color": "#f60"
      }
    }, [_vm._v("数量：" + _vm._s(bo.goodsNumber))])]), _vm._v(" "), _c('p', {
      staticClass: "other"
    }, [_c('span', [_vm._v("￥" + _vm._s(bo.unitPrice))]), _c('br'), _vm._v(" "), _c('a', {
      staticClass: "del",
      on: {
        "click": function($event) {
          _vm.deleteGoods(bo.id, bo.goodsCode, index)
        }
      }
    }, [_vm._v("删除")])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "fbar"
  }, [_c('span', {
    staticClass: "fl ml10"
  }, [_vm._v("共" + _vm._s(_vm.count) + "件商品　共计"), _c('b', [_vm._v("￥ " + _vm._s(_vm.sumMoney))])]), _vm._v(" "), _c('a', {
    staticClass: "fr gobuy",
    on: {
      "click": _vm.toShopCart
    }
  }, [_vm._v("去购物车")])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.contactUrl,
      "target": "_blank"
    }
  }, [_vm._v("联系客服")])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('ul', {
    staticClass: "topbar-left fl"
  }, [_c('li', [_vm._v("\n\t\t\t\t您好！欢迎来到相伴宝！\n\t\t\t")]), _vm._v(" "), (_vm.isLogin == false) ? _c('li', [_c('a', {
    staticClass: "co2",
    attrs: {
      "href": _vm.loginUrl
    }
  }, [_vm._v("[登录]")])]) : _vm._e(), _vm._v(" "), (_vm.isLogin == false) ? _c('li', [_c('a', {
    staticClass: "co2",
    attrs: {
      "href": _vm.registerUrl
    }
  }, [_vm._v("[注册]")])]) : _vm._e()])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.baomate.com/aboutus/index.htm"
    }
  }, [_vm._v("关于我们")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "http://en.baomate.com",
      "target": "_blank"
    }
  }, [_vm._v("English")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "teIl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__("HCTz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40218366_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__("mtcC");
function injectStyle (ssrContext) {
  __webpack_require__("yy3O")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40218366_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tthr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "indexbg"
  }, [_c('topbar'), _vm._v(" "), _c('header'), _vm._v(" "), _c('emallheader'), _vm._v(" "), _c('div', {
    staticClass: "clear mt15"
  }), _vm._v(" "), _c('div', {
    staticClass: "w1200 bc"
  }, [_c('div', {
    staticClass: "hq-shopping-cart"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "contain"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "pv10 f14"
  }, [_vm._v("\n\t\t\t\t\t\t订单消费总计：\n\t\t\t\t\t\t"), (_vm.goodsTotalPrice.totalPoint > 0) ? _c('span', {
    staticClass: "f20 co2"
  }, [_vm._v(_vm._s(_vm.goodsTotalPrice.totalPoint) + "积分"), (_vm.sumAmount > 0) ? _c('span', [_vm._v("+")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.goodsTotalPrice.totalRed > 0) ? _c('span', {
    staticClass: "f20 co2"
  }, [_vm._v(_vm._s(_vm.goodsTotalPrice.totalRed) + "红积分"), (_vm.sumAmount > 0) ? _c('span', [_vm._v("+")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.goodsTotalPrice.totalBlue > 0) ? _c('span', {
    staticClass: "f20 co2"
  }, [_vm._v(_vm._s(_vm.goodsTotalPrice.totalBlue) + "蓝积分"), (_vm.sumAmount > 0) ? _c('span', [_vm._v("+")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.goodsTotalPrice.totalSpecial > 0) ? _c('span', {
    staticClass: "f20 co2"
  }, [_vm._v(_vm._s(_vm.goodsTotalPrice.totalSpecial) + "专用积分"), (_vm.sumAmount > 0) ? _c('span', [_vm._v("+")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.sumAmount > 0) ? _c('span', {
    staticClass: "f20 co2"
  }, [_vm._v("¥" + _vm._s(_vm.sumAmount))]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.orderList), function(order) {
    return _c('div', [_c('ul', [_c('ul', {
      staticClass: "fl w450 co5"
    }, [_c('li', {
      staticClass: "pv10"
    }, [_vm._v("订单编号：" + _vm._s(order.trade_code))]), _vm._v(" "), _c('li', {
      staticClass: "pv10"
    }, [_vm._v("交易日期：" + _vm._s(_vm.createTime))])]), _vm._v(" "), _c('ul', {
      staticClass: " fl co5"
    }, [_c('li', {
      staticClass: "pv10"
    }, [_vm._v("商品名称：" + _vm._s(order.goods_name))]), _vm._v(" "), _c('li', {
      staticClass: "pv10"
    }, [_vm._v("商品数量：" + _vm._s(order.goods_number))])])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "contain mt20"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "m30"
  }, [_c('a', {
    staticClass: " w200",
    staticStyle: {
      "margin-right": "30px"
    },
    on: {
      "click": function($event) {
        _vm.payEmall('yunpay_wx', null)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("JXLR")
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: " w200",
    on: {
      "click": function($event) {
        _vm.payCQ('yunpay_zfb')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("zg80")
    }
  })])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "shadowLayer"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('footermenu'), _vm._v(" "), _c('footercopyright')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hq-reg-step"
  }, [_c('ul', {
    staticClass: "ico"
  }, [_c('li', [_c('p', {
    staticClass: "item"
  }, [_vm._v("购物车")]), _vm._v(" "), _c('i', {
    staticClass: "step-count"
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "line"
  })]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "item"
  }, [_vm._v("提交订单")]), _vm._v(" "), _c('i', {
    staticClass: "step-count"
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "line"
  })]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('p', {
    staticClass: "item"
  }, [_vm._v("确认付款")]), _vm._v(" "), _c('i', {
    staticClass: "step-count"
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "line"
  })]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "item"
  }, [_vm._v("下单成功")]), _vm._v(" "), _c('i', {
    staticClass: "step-count"
  })])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-title"
  }, [_c('h5', {
    staticClass: "f18"
  }, [_vm._v("订单信息")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-title"
  }, [_c('h5', {
    staticClass: "f18"
  }, [_vm._v("支付选择")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb20 ad-4 mt20"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("dlf8"),
      "width": "1200",
      "height": "60"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uRVv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__("ORbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TopBar__ = __webpack_require__("5PWk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Header__ = __webpack_require__("teIl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FooterMenu__ = __webpack_require__("gTlp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FooterCopyright__ = __webpack_require__("3LwO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_js_emallUtils_js__ = __webpack_require__("spYF");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*引入Vue框架*/

/*引入资源请求插件*/

/*使用VueResource插件*/
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);




//import jQuery from "../../../static/js/jquery.min.js"


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'paySuccess',
  data: function data() {
    return {};
  },

  components: {
    'sortHeader': __WEBPACK_IMPORTED_MODULE_3__components_Header__["a" /* default */],
    'footermenu': __WEBPACK_IMPORTED_MODULE_4__components_FooterMenu__["a" /* default */],
    'footercopyright': __WEBPACK_IMPORTED_MODULE_5__components_FooterCopyright__["a" /* default */]
  },
  methods: {
    viewAllOrders: function viewAllOrders() {
      window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__static_js_emallUtils_js__["b" /* getEmallUrl */])() + '/orderManage/myOrderList.htm';
    }
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
  }
});

/***/ }),

/***/ "vooN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shop_goods_list_vue__ = __webpack_require__("WiJr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32512b52_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_shop_goods_list_vue__ = __webpack_require__("WYj9");
function injectStyle (ssrContext) {
  __webpack_require__("pYz0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-32512b52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shop_goods_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32512b52_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_shop_goods_list_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vpJu":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "y0gP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shopsList_vue__ = __webpack_require__("1RbL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57a061c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_shopsList_vue__ = __webpack_require__("pmnU");
function injectStyle (ssrContext) {
  __webpack_require__("WYKp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57a061c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shopsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57a061c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_shopsList_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yp1l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ytwD":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "yy3O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zYA5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orderConfirm_vue__ = __webpack_require__("VUSJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38f3f95a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_orderConfirm_vue__ = __webpack_require__("tthr");
function injectStyle (ssrContext) {
  __webpack_require__("O+2g")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orderConfirm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38f3f95a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_orderConfirm_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zg80":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.70faf212fc23be1bce66.js